
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire1e6c"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire1e6c"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1f5FT", function(module, exports) {

$parcel$export(module.exports, "getFormByFormId", () => $0e7b980ace74eb41$export$cb557289c617b5c8);

var $hvLQT = parcelRequire("hvLQT");
async function $0e7b980ace74eb41$export$cb557289c617b5c8(id, appointmentChannelId = null, path = null) {
    if (id == null || id === '') return Promise.reject(new Error('Form ID is required. Pass form_id (or form) in the URL, e.g. ?form_id=YOUR_FORM_ID'));
    const params = new URLSearchParams();
    if (appointmentChannelId) params.set('appointment_channel_id', appointmentChannelId);
    if (path) params.set('path', path);
    const qs = params.toString();
    return await (0, $hvLQT.apiClient).GET(`api/channels/widget/${id}${qs ? '?' + qs : ''}`);
}

});
parcelRegister("hvLQT", function(module, exports) {

$parcel$export(module.exports, "apiClient", () => $cbfa73536110cd9a$export$407ca81eb46778dd);

var $fmRoT = parcelRequire("fmRoT");

var $er9E0 = parcelRequire("er9E0");
parcelRequire("7rUQ4");

var $cEKee = parcelRequire("cEKee");
/* Api services */ const $cbfa73536110cd9a$var$apiUrl = (url)=>{
    return `${"https://app.pilotpractice.com"}/${url}`;
};
const $cbfa73536110cd9a$var$inIframe = ()=>{
    try {
        return window.self !== window.top;
    } catch (e) {
        return true;
    }
};
const $cbfa73536110cd9a$var$token = ()=>{
    if (0, $cEKee.access_token) return 0, $cEKee.access_token;
    else if ($cbfa73536110cd9a$var$inIframe()) return (0, $er9E0.params)('token');
};
function $cbfa73536110cd9a$var$getCsrfToken() {
    let cookieStr = document.cookie; // could be "XSRF-TOKEN=...; AnotherCookie=...; ..."
    let cookiesArray = cookieStr.split('; ');
    let xsrfToken;
    cookiesArray.forEach((cookie)=>{
        let [name, value] = cookie.split('=');
        if (name === 'XSRF-TOKEN') xsrfToken = value;
    });
    return xsrfToken;
}
const $cbfa73536110cd9a$var$config = ()=>({
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            Authorization: 'Bearer ' + $cbfa73536110cd9a$var$token()
        }
    });
const $cbfa73536110cd9a$var$GET = (url)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($fmRoT))).get($cbfa73536110cd9a$var$apiUrl(url), $cbfa73536110cd9a$var$config());
};
const $cbfa73536110cd9a$var$POST = (url, data)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($fmRoT))).post($cbfa73536110cd9a$var$apiUrl(url), data, $cbfa73536110cd9a$var$config());
};
const $cbfa73536110cd9a$var$PUT = (url, data)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($fmRoT))).put($cbfa73536110cd9a$var$apiUrl(url), data, $cbfa73536110cd9a$var$config());
};
const $cbfa73536110cd9a$export$407ca81eb46778dd = {
    GET: $cbfa73536110cd9a$var$GET,
    POST: $cbfa73536110cd9a$var$POST,
    PUT: $cbfa73536110cd9a$var$PUT,
    config: $cbfa73536110cd9a$var$config,
    apiUrl: $cbfa73536110cd9a$var$apiUrl,
    inIframe: $cbfa73536110cd9a$var$inIframe
};

});
parcelRegister("fmRoT", function(module, exports) {

module.exports = (parcelRequire("7we3r"));

});
parcelRegister("7we3r", function(module, exports) {
'use strict';

var $gKvUL = parcelRequire("gKvUL");

var $jJbMR = parcelRequire("jJbMR");

var $ewFRw = parcelRequire("ewFRw");

var $lk5EI = parcelRequire("lk5EI");

var $lJY4v = parcelRequire("lJY4v");
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */ function $57966c7e0affc4cb$var$createInstance(defaultConfig) {
    var context = new $ewFRw(defaultConfig);
    var instance = $jJbMR($ewFRw.prototype.request, context);
    // Copy axios.prototype to instance
    $gKvUL.extend(instance, $ewFRw.prototype, context);
    // Copy context to instance
    $gKvUL.extend(instance, context);
    return instance;
}
// Create the default instance to be exported
var $57966c7e0affc4cb$var$axios = $57966c7e0affc4cb$var$createInstance($lJY4v);
// Expose Axios class to allow class inheritance
$57966c7e0affc4cb$var$axios.Axios = $ewFRw;
// Factory for creating new instances
$57966c7e0affc4cb$var$axios.create = function create(instanceConfig) {
    return $57966c7e0affc4cb$var$createInstance($lk5EI($57966c7e0affc4cb$var$axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
$57966c7e0affc4cb$var$axios.Cancel = (parcelRequire("4Tkeq"));

$57966c7e0affc4cb$var$axios.CancelToken = (parcelRequire("lAKPy"));

$57966c7e0affc4cb$var$axios.isCancel = (parcelRequire("7L4QX"));
// Expose all/spread
$57966c7e0affc4cb$var$axios.all = function all(promises) {
    return Promise.all(promises);
};

$57966c7e0affc4cb$var$axios.spread = (parcelRequire("JEeti"));

// Expose isAxiosError
$57966c7e0affc4cb$var$axios.isAxiosError = (parcelRequire("dxy9O"));
module.exports = $57966c7e0affc4cb$var$axios;
// Allow use of default import syntax in TypeScript
module.exports.default = $57966c7e0affc4cb$var$axios;

});
parcelRegister("gKvUL", function(module, exports) {
'use strict';

var $jJbMR = parcelRequire("jJbMR");
/*global toString:true*/ // utils is a library of generic helper functions non-specific to axios
var $c319b2c832c2914a$var$toString = Object.prototype.toString;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */ function $c319b2c832c2914a$var$isArray(val) {
    return $c319b2c832c2914a$var$toString.call(val) === '[object Array]';
}
/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */ function $c319b2c832c2914a$var$isUndefined(val) {
    return typeof val === 'undefined';
}
/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $c319b2c832c2914a$var$isBuffer(val) {
    return val !== null && !$c319b2c832c2914a$var$isUndefined(val) && val.constructor !== null && !$c319b2c832c2914a$var$isUndefined(val.constructor) && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ function $c319b2c832c2914a$var$isArrayBuffer(val) {
    return $c319b2c832c2914a$var$toString.call(val) === '[object ArrayBuffer]';
}
/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $c319b2c832c2914a$var$isFormData(val) {
    return typeof FormData !== 'undefined' && val instanceof FormData;
}
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $c319b2c832c2914a$var$isArrayBufferView(val) {
    var result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && val.buffer instanceof ArrayBuffer;
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */ function $c319b2c832c2914a$var$isString(val) {
    return typeof val === 'string';
}
/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */ function $c319b2c832c2914a$var$isNumber(val) {
    return typeof val === 'number';
}
/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */ function $c319b2c832c2914a$var$isObject(val) {
    return val !== null && typeof val === 'object';
}
/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */ function $c319b2c832c2914a$var$isPlainObject(val) {
    if ($c319b2c832c2914a$var$toString.call(val) !== '[object Object]') return false;
    var prototype = Object.getPrototypeOf(val);
    return prototype === null || prototype === Object.prototype;
}
/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */ function $c319b2c832c2914a$var$isDate(val) {
    return $c319b2c832c2914a$var$toString.call(val) === '[object Date]';
}
/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */ function $c319b2c832c2914a$var$isFile(val) {
    return $c319b2c832c2914a$var$toString.call(val) === '[object File]';
}
/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */ function $c319b2c832c2914a$var$isBlob(val) {
    return $c319b2c832c2914a$var$toString.call(val) === '[object Blob]';
}
/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ function $c319b2c832c2914a$var$isFunction(val) {
    return $c319b2c832c2914a$var$toString.call(val) === '[object Function]';
}
/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */ function $c319b2c832c2914a$var$isStream(val) {
    return $c319b2c832c2914a$var$isObject(val) && $c319b2c832c2914a$var$isFunction(val.pipe);
}
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ function $c319b2c832c2914a$var$isURLSearchParams(val) {
    return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */ function $c319b2c832c2914a$var$trim(str) {
    return str.replace(/^\s*/, '').replace(/\s*$/, '');
}
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */ function $c319b2c832c2914a$var$isStandardBrowserEnv() {
    if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' || navigator.product === 'NativeScript' || navigator.product === 'NS')) return false;
    return typeof window !== 'undefined' && typeof document !== 'undefined';
}
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */ function $c319b2c832c2914a$var$forEach(obj, fn) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    // Force an array if not already something iterable
    if (typeof obj !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($c319b2c832c2914a$var$isArray(obj)) // Iterate over array values
    for(var i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) fn.call(null, obj[key], key, obj);
    }
}
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */ function $c319b2c832c2914a$var$merge() {
    var result = {};
    function assignValue(val, key) {
        if ($c319b2c832c2914a$var$isPlainObject(result[key]) && $c319b2c832c2914a$var$isPlainObject(val)) result[key] = $c319b2c832c2914a$var$merge(result[key], val);
        else if ($c319b2c832c2914a$var$isPlainObject(val)) result[key] = $c319b2c832c2914a$var$merge({}, val);
        else if ($c319b2c832c2914a$var$isArray(val)) result[key] = val.slice();
        else result[key] = val;
    }
    for(var i = 0, l = arguments.length; i < l; i++)$c319b2c832c2914a$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */ function $c319b2c832c2914a$var$extend(a, b, thisArg) {
    $c319b2c832c2914a$var$forEach(b, function assignValue(val, key) {
        if (thisArg && typeof val === 'function') a[key] = $jJbMR(val, thisArg);
        else a[key] = val;
    });
    return a;
}
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */ function $c319b2c832c2914a$var$stripBOM(content) {
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
}
module.exports = {
    isArray: $c319b2c832c2914a$var$isArray,
    isArrayBuffer: $c319b2c832c2914a$var$isArrayBuffer,
    isBuffer: $c319b2c832c2914a$var$isBuffer,
    isFormData: $c319b2c832c2914a$var$isFormData,
    isArrayBufferView: $c319b2c832c2914a$var$isArrayBufferView,
    isString: $c319b2c832c2914a$var$isString,
    isNumber: $c319b2c832c2914a$var$isNumber,
    isObject: $c319b2c832c2914a$var$isObject,
    isPlainObject: $c319b2c832c2914a$var$isPlainObject,
    isUndefined: $c319b2c832c2914a$var$isUndefined,
    isDate: $c319b2c832c2914a$var$isDate,
    isFile: $c319b2c832c2914a$var$isFile,
    isBlob: $c319b2c832c2914a$var$isBlob,
    isFunction: $c319b2c832c2914a$var$isFunction,
    isStream: $c319b2c832c2914a$var$isStream,
    isURLSearchParams: $c319b2c832c2914a$var$isURLSearchParams,
    isStandardBrowserEnv: $c319b2c832c2914a$var$isStandardBrowserEnv,
    forEach: $c319b2c832c2914a$var$forEach,
    merge: $c319b2c832c2914a$var$merge,
    extend: $c319b2c832c2914a$var$extend,
    trim: $c319b2c832c2914a$var$trim,
    stripBOM: $c319b2c832c2914a$var$stripBOM
};

});
parcelRegister("jJbMR", function(module, exports) {
'use strict';
module.exports = function bind(fn, thisArg) {
    return function wrap() {
        var args = new Array(arguments.length);
        for(var i = 0; i < args.length; i++)args[i] = arguments[i];
        return fn.apply(thisArg, args);
    };
};

});


parcelRegister("ewFRw", function(module, exports) {
'use strict';

var $gKvUL = parcelRequire("gKvUL");

var $cbIsf = parcelRequire("cbIsf");

var $83RYu = parcelRequire("83RYu");

var $dlZEJ = parcelRequire("dlZEJ");

var $lk5EI = parcelRequire("lk5EI");
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */ function $a93486d2307f31c3$var$Axios(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
        request: new $83RYu(),
        response: new $83RYu()
    };
}
/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */ $a93486d2307f31c3$var$Axios.prototype.request = function request(config) {
    /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof config === 'string') {
        config = arguments[1] || {};
        config.url = arguments[0];
    } else config = config || {};
    config = $lk5EI(this.defaults, config);
    // Set config.method
    if (config.method) config.method = config.method.toLowerCase();
    else if (this.defaults.method) config.method = this.defaults.method.toLowerCase();
    else config.method = 'get';
    // Hook up interceptors middleware
    var chain = [
        $dlZEJ,
        undefined
    ];
    var promise = Promise.resolve(config);
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
        chain.unshift(interceptor.fulfilled, interceptor.rejected);
    });
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
        chain.push(interceptor.fulfilled, interceptor.rejected);
    });
    while(chain.length)promise = promise.then(chain.shift(), chain.shift());
    return promise;
};
$a93486d2307f31c3$var$Axios.prototype.getUri = function getUri(config) {
    config = $lk5EI(this.defaults, config);
    return $cbIsf(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};
// Provide aliases for supported request methods
$gKvUL.forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $a93486d2307f31c3$var$Axios.prototype[method] = function(url, config) {
        return this.request($lk5EI(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
$gKvUL.forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ $a93486d2307f31c3$var$Axios.prototype[method] = function(url, data, config) {
        return this.request($lk5EI(config || {}, {
            method: method,
            url: url,
            data: data
        }));
    };
});
module.exports = $a93486d2307f31c3$var$Axios;

});
parcelRegister("cbIsf", function(module, exports) {
'use strict';

var $gKvUL = parcelRequire("gKvUL");
function $8df8fedf1c1e4428$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+').replace(/%5B/gi, '[').replace(/%5D/gi, ']');
}
/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */ module.exports = function buildURL(url, params, paramsSerializer) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    var serializedParams;
    if (paramsSerializer) serializedParams = paramsSerializer(params);
    else if ($gKvUL.isURLSearchParams(params)) serializedParams = params.toString();
    else {
        var parts = [];
        $gKvUL.forEach(params, function serialize(val, key) {
            if (val === null || typeof val === 'undefined') return;
            if ($gKvUL.isArray(val)) key = key + '[]';
            else val = [
                val
            ];
            $gKvUL.forEach(val, function parseValue(v) {
                if ($gKvUL.isDate(v)) v = v.toISOString();
                else if ($gKvUL.isObject(v)) v = JSON.stringify(v);
                parts.push($8df8fedf1c1e4428$var$encode(key) + '=' + $8df8fedf1c1e4428$var$encode(v));
            });
        });
        serializedParams = parts.join('&');
    }
    if (serializedParams) {
        var hashmarkIndex = url.indexOf('#');
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
};

});

parcelRegister("83RYu", function(module, exports) {
'use strict';

var $gKvUL = parcelRequire("gKvUL");
function $5de878cd737ef277$var$InterceptorManager() {
    this.handlers = [];
}
/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */ $5de878cd737ef277$var$InterceptorManager.prototype.use = function use(fulfilled, rejected) {
    this.handlers.push({
        fulfilled: fulfilled,
        rejected: rejected
    });
    return this.handlers.length - 1;
};
/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */ $5de878cd737ef277$var$InterceptorManager.prototype.eject = function eject(id) {
    if (this.handlers[id]) this.handlers[id] = null;
};
/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */ $5de878cd737ef277$var$InterceptorManager.prototype.forEach = function forEach(fn) {
    $gKvUL.forEach(this.handlers, function forEachHandler(h) {
        if (h !== null) fn(h);
    });
};
module.exports = $5de878cd737ef277$var$InterceptorManager;

});

parcelRegister("dlZEJ", function(module, exports) {
'use strict';

var $gKvUL = parcelRequire("gKvUL");

var $7YJ0v = parcelRequire("7YJ0v");

var $7L4QX = parcelRequire("7L4QX");

var $lJY4v = parcelRequire("lJY4v");
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ function $9b8d10189805ccc0$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
}
/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */ module.exports = function dispatchRequest(config) {
    $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
    // Ensure headers exist
    config.headers = config.headers || {};
    // Transform request data
    config.data = $7YJ0v(config.data, config.headers, config.transformRequest);
    // Flatten headers
    config.headers = $gKvUL.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers);
    $gKvUL.forEach([
        'delete',
        'get',
        'head',
        'post',
        'put',
        'patch',
        'common'
    ], function cleanHeaderConfig(method) {
        delete config.headers[method];
    });
    var adapter = config.adapter || $lJY4v.adapter;
    return adapter(config).then(function onAdapterResolution(response) {
        $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = $7YJ0v(response.data, response.headers, config.transformResponse);
        return response;
    }, function onAdapterRejection(reason) {
        if (!$7L4QX(reason)) {
            $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) reason.response.data = $7YJ0v(reason.response.data, reason.response.headers, config.transformResponse);
        }
        return Promise.reject(reason);
    });
};

});
parcelRegister("7YJ0v", function(module, exports) {
'use strict';

var $gKvUL = parcelRequire("gKvUL");
/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */ module.exports = function transformData(data, headers, fns) {
    /*eslint no-param-reassign:0*/ $gKvUL.forEach(fns, function transform(fn) {
        data = fn(data, headers);
    });
    return data;
};

});

parcelRegister("7L4QX", function(module, exports) {
'use strict';
module.exports = function isCancel(value) {
    return !!(value && value.__CANCEL__);
};

});

parcelRegister("lJY4v", function(module, exports) {
'use strict';

var $gKvUL = parcelRequire("gKvUL");

var $kiL6T = parcelRequire("kiL6T");
var $fd3c65eeb28abd71$var$DEFAULT_CONTENT_TYPE = {
    'Content-Type': 'application/x-www-form-urlencoded'
};
function $fd3c65eeb28abd71$var$setContentTypeIfUnset(headers, value) {
    if (!$gKvUL.isUndefined(headers) && $gKvUL.isUndefined(headers['Content-Type'])) headers['Content-Type'] = value;
}

function $fd3c65eeb28abd71$var$getDefaultAdapter() {
    var adapter;
    if (typeof XMLHttpRequest !== 'undefined') // For browsers use XHR adapter
    adapter = (parcelRequire("at5cb"));
    return adapter;
}
var $fd3c65eeb28abd71$var$defaults = {
    adapter: $fd3c65eeb28abd71$var$getDefaultAdapter(),
    transformRequest: [
        function transformRequest(data, headers) {
            $kiL6T(headers, 'Accept');
            $kiL6T(headers, 'Content-Type');
            if ($gKvUL.isFormData(data) || $gKvUL.isArrayBuffer(data) || $gKvUL.isBuffer(data) || $gKvUL.isStream(data) || $gKvUL.isFile(data) || $gKvUL.isBlob(data)) return data;
            if ($gKvUL.isArrayBufferView(data)) return data.buffer;
            if ($gKvUL.isURLSearchParams(data)) {
                $fd3c65eeb28abd71$var$setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
                return data.toString();
            }
            if ($gKvUL.isObject(data)) {
                $fd3c65eeb28abd71$var$setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
                return JSON.stringify(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            /*eslint no-param-reassign:0*/ if (typeof data === 'string') try {
                data = JSON.parse(data);
            } catch (e) {}
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    }
};
$fd3c65eeb28abd71$var$defaults.headers = {
    common: {
        'Accept': 'application/json, text/plain, */*'
    }
};
$gKvUL.forEach([
    'delete',
    'get',
    'head'
], function forEachMethodNoData(method) {
    $fd3c65eeb28abd71$var$defaults.headers[method] = {};
});
$gKvUL.forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    $fd3c65eeb28abd71$var$defaults.headers[method] = $gKvUL.merge($fd3c65eeb28abd71$var$DEFAULT_CONTENT_TYPE);
});
module.exports = $fd3c65eeb28abd71$var$defaults;

});
parcelRegister("kiL6T", function(module, exports) {
'use strict';

var $gKvUL = parcelRequire("gKvUL");
module.exports = function normalizeHeaderName(headers, normalizedName) {
    $gKvUL.forEach(headers, function processHeader(value, name) {
        if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
            headers[normalizedName] = value;
            delete headers[name];
        }
    });
};

});

parcelRegister("at5cb", function(module, exports) {
'use strict';

var $gKvUL = parcelRequire("gKvUL");

var $kk0E9 = parcelRequire("kk0E9");

var $8JRzs = parcelRequire("8JRzs");

var $cbIsf = parcelRequire("cbIsf");

var $7GD7a = parcelRequire("7GD7a");

var $lDriZ = parcelRequire("lDriZ");

var $889er = parcelRequire("889er");

var $kjF3e = parcelRequire("kjF3e");
module.exports = function xhrAdapter(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        var requestData = config.data;
        var requestHeaders = config.headers;
        if ($gKvUL.isFormData(requestData)) delete requestHeaders['Content-Type']; // Let the browser set it
        var request = new XMLHttpRequest();
        // HTTP basic authentication
        if (config.auth) {
            var username = config.auth.username || '';
            var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
            requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
        }
        var fullPath = $7GD7a(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), $cbIsf(fullPath, config.params, config.paramsSerializer), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        // Listen for ready state
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) return;
            // Prepare the response
            var responseHeaders = 'getAllResponseHeaders' in request ? $lDriZ(request.getAllResponseHeaders()) : null;
            var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
            var response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            $kk0E9(resolve, reject, response);
            // Clean up request
            request = null;
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject($kjF3e('Request aborted', config, 'ECONNABORTED', request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject($kjF3e('Network Error', config, null, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
            reject($kjF3e(timeoutErrorMessage, config, 'ECONNABORTED', request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if ($gKvUL.isStandardBrowserEnv()) {
            // Add xsrf header
            var xsrfValue = (config.withCredentials || $889er(fullPath)) && config.xsrfCookieName ? $8JRzs.read(config.xsrfCookieName) : undefined;
            if (xsrfValue) requestHeaders[config.xsrfHeaderName] = xsrfValue;
        }
        // Add headers to the request
        if ('setRequestHeader' in request) $gKvUL.forEach(requestHeaders, function setRequestHeader(val, key) {
            if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') // Remove Content-Type if data is undefined
            delete requestHeaders[key];
            else // Otherwise add header to the request
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!$gKvUL.isUndefined(config.withCredentials)) request.withCredentials = !!config.withCredentials;
        // Add responseType to request if needed
        if (config.responseType) try {
            request.responseType = config.responseType;
        } catch (e) {
            // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
            // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
            if (config.responseType !== 'json') throw e;
        }
        // Handle progress if needed
        if (typeof config.onDownloadProgress === 'function') request.addEventListener('progress', config.onDownloadProgress);
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === 'function' && request.upload) request.upload.addEventListener('progress', config.onUploadProgress);
        if (config.cancelToken) // Handle cancellation
        config.cancelToken.promise.then(function onCanceled(cancel) {
            if (!request) return;
            request.abort();
            reject(cancel);
            // Clean up request
            request = null;
        });
        if (!requestData) requestData = null;
        // Send the request
        request.send(requestData);
    });
};

});
parcelRegister("kk0E9", function(module, exports) {
'use strict';

var $kjF3e = parcelRequire("kjF3e");
/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */ module.exports = function settle(resolve, reject, response) {
    var validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject($kjF3e('Request failed with status code ' + response.status, response.config, null, response.request, response));
};

});
parcelRegister("kjF3e", function(module, exports) {
'use strict';

var $8v8A7 = parcelRequire("8v8A7");
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */ module.exports = function createError(message, config, code, request, response) {
    var error = new Error(message);
    return $8v8A7(error, config, code, request, response);
};

});
parcelRegister("8v8A7", function(module, exports) {
'use strict';
/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */ module.exports = function enhanceError(error, config, code, request, response) {
    error.config = config;
    if (code) error.code = code;
    error.request = request;
    error.response = response;
    error.isAxiosError = true;
    error.toJSON = function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: this.config,
            code: this.code
        };
    };
    return error;
};

});



parcelRegister("8JRzs", function(module, exports) {
'use strict';

var $gKvUL = parcelRequire("gKvUL");
module.exports = $gKvUL.isStandardBrowserEnv() ? // Standard browser envs support document.cookie
function standardBrowserEnv() {
    return {
        write: function write(name, value, expires, path, domain, secure) {
            var cookie = [];
            cookie.push(name + '=' + encodeURIComponent(value));
            if ($gKvUL.isNumber(expires)) cookie.push('expires=' + new Date(expires).toGMTString());
            if ($gKvUL.isString(path)) cookie.push('path=' + path);
            if ($gKvUL.isString(domain)) cookie.push('domain=' + domain);
            if (secure === true) cookie.push('secure');
            document.cookie = cookie.join('; ');
        },
        read: function read(name) {
            var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
            return match ? decodeURIComponent(match[3]) : null;
        },
        remove: function remove(name) {
            this.write(name, '', Date.now() - 86400000);
        }
    };
}() : // Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return {
        write: function write() {},
        read: function read() {
            return null;
        },
        remove: function remove() {}
    };
}();

});

parcelRegister("7GD7a", function(module, exports) {
'use strict';

var $ckHwb = parcelRequire("ckHwb");

var $fE4ul = parcelRequire("fE4ul");
/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */ module.exports = function buildFullPath(baseURL, requestedURL) {
    if (baseURL && !$ckHwb(requestedURL)) return $fE4ul(baseURL, requestedURL);
    return requestedURL;
};

});
parcelRegister("ckHwb", function(module, exports) {
'use strict';
/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */ module.exports = function isAbsoluteURL(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};

});

parcelRegister("fE4ul", function(module, exports) {
'use strict';
/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */ module.exports = function combineURLs(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
};

});


parcelRegister("lDriZ", function(module, exports) {
'use strict';

var $gKvUL = parcelRequire("gKvUL");
// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var $fc026bbf9ee156f1$var$ignoreDuplicateOf = [
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
];
/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */ module.exports = function parseHeaders(headers) {
    var parsed = {};
    var key;
    var val;
    var i;
    if (!headers) return parsed;
    $gKvUL.forEach(headers.split('\n'), function parser(line) {
        i = line.indexOf(':');
        key = $gKvUL.trim(line.substr(0, i)).toLowerCase();
        val = $gKvUL.trim(line.substr(i + 1));
        if (key) {
            if (parsed[key] && $fc026bbf9ee156f1$var$ignoreDuplicateOf.indexOf(key) >= 0) return;
            if (key === 'set-cookie') parsed[key] = (parsed[key] ? parsed[key] : []).concat([
                val
            ]);
            else parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
        }
    });
    return parsed;
};

});

parcelRegister("889er", function(module, exports) {
'use strict';

var $gKvUL = parcelRequire("gKvUL");
module.exports = $gKvUL.isStandardBrowserEnv() ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;
    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        var href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute('href', href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute('href', href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === '/' ? urlParsingNode.pathname : '/' + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        var parsed = $gKvUL.isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();

});




parcelRegister("lk5EI", function(module, exports) {
'use strict';

var $gKvUL = parcelRequire("gKvUL");
/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */ module.exports = function mergeConfig(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    var config = {};
    var valueFromConfig2Keys = [
        'url',
        'method',
        'data'
    ];
    var mergeDeepPropertiesKeys = [
        'headers',
        'auth',
        'proxy',
        'params'
    ];
    var defaultToConfig2Keys = [
        'baseURL',
        'transformRequest',
        'transformResponse',
        'paramsSerializer',
        'timeout',
        'timeoutMessage',
        'withCredentials',
        'adapter',
        'responseType',
        'xsrfCookieName',
        'xsrfHeaderName',
        'onUploadProgress',
        'onDownloadProgress',
        'decompress',
        'maxContentLength',
        'maxBodyLength',
        'maxRedirects',
        'transport',
        'httpAgent',
        'httpsAgent',
        'cancelToken',
        'socketPath',
        'responseEncoding'
    ];
    var directMergeKeys = [
        'validateStatus'
    ];
    function getMergedValue(target, source) {
        if ($gKvUL.isPlainObject(target) && $gKvUL.isPlainObject(source)) return $gKvUL.merge(target, source);
        else if ($gKvUL.isPlainObject(source)) return $gKvUL.merge({}, source);
        else if ($gKvUL.isArray(source)) return source.slice();
        return source;
    }
    function mergeDeepProperties(prop) {
        if (!$gKvUL.isUndefined(config2[prop])) config[prop] = getMergedValue(config1[prop], config2[prop]);
        else if (!$gKvUL.isUndefined(config1[prop])) config[prop] = getMergedValue(undefined, config1[prop]);
    }
    $gKvUL.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
        if (!$gKvUL.isUndefined(config2[prop])) config[prop] = getMergedValue(undefined, config2[prop]);
    });
    $gKvUL.forEach(mergeDeepPropertiesKeys, mergeDeepProperties);
    $gKvUL.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
        if (!$gKvUL.isUndefined(config2[prop])) config[prop] = getMergedValue(undefined, config2[prop]);
        else if (!$gKvUL.isUndefined(config1[prop])) config[prop] = getMergedValue(undefined, config1[prop]);
    });
    $gKvUL.forEach(directMergeKeys, function merge(prop) {
        if (prop in config2) config[prop] = getMergedValue(config1[prop], config2[prop]);
        else if (prop in config1) config[prop] = getMergedValue(undefined, config1[prop]);
    });
    var axiosKeys = valueFromConfig2Keys.concat(mergeDeepPropertiesKeys).concat(defaultToConfig2Keys).concat(directMergeKeys);
    var otherKeys = Object.keys(config1).concat(Object.keys(config2)).filter(function filterAxiosKeys(key) {
        return axiosKeys.indexOf(key) === -1;
    });
    $gKvUL.forEach(otherKeys, mergeDeepProperties);
    return config;
};

});


parcelRegister("4Tkeq", function(module, exports) {
'use strict';
/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */ function $38fbfe0afbd5bf1e$var$Cancel(message) {
    this.message = message;
}
$38fbfe0afbd5bf1e$var$Cancel.prototype.toString = function toString() {
    return 'Cancel' + (this.message ? ': ' + this.message : '');
};
$38fbfe0afbd5bf1e$var$Cancel.prototype.__CANCEL__ = true;
module.exports = $38fbfe0afbd5bf1e$var$Cancel;

});

parcelRegister("lAKPy", function(module, exports) {
'use strict';

var $4Tkeq = parcelRequire("4Tkeq");
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */ function $fb81495929d8a282$var$CancelToken(executor) {
    if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
    var resolvePromise;
    this.promise = new Promise(function promiseExecutor(resolve) {
        resolvePromise = resolve;
    });
    var token = this;
    executor(function cancel(message) {
        if (token.reason) // Cancellation has already been requested
        return;
        token.reason = new $4Tkeq(message);
        resolvePromise(token.reason);
    });
}
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ $fb81495929d8a282$var$CancelToken.prototype.throwIfRequested = function throwIfRequested() {
    if (this.reason) throw this.reason;
};
/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */ $fb81495929d8a282$var$CancelToken.source = function source() {
    var cancel;
    var token = new $fb81495929d8a282$var$CancelToken(function executor(c) {
        cancel = c;
    });
    return {
        token: token,
        cancel: cancel
    };
};
module.exports = $fb81495929d8a282$var$CancelToken;

});

parcelRegister("JEeti", function(module, exports) {
'use strict';
/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */ module.exports = function spread(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
};

});

parcelRegister("dxy9O", function(module, exports) {
'use strict';
/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */ module.exports = function isAxiosError(payload) {
    return typeof payload === 'object' && payload.isAxiosError === true;
};

});



parcelRegister("er9E0", function(module, exports) {

$parcel$export(module.exports, "setIsDisqualified", () => $a82b117199549e31$export$7e839dd9debc8735);
$parcel$export(module.exports, "setSkipEndRedirect", () => $a82b117199549e31$export$22574faa6b71e292);
$parcel$export(module.exports, "setSessionEndStepSentForLeadId", () => $a82b117199549e31$export$d049e111d975f618);
$parcel$export(module.exports, "params", () => $a82b117199549e31$export$281ad3752a540efe);
$parcel$export(module.exports, "updateUrlWithEventId", () => $a82b117199549e31$export$67c3813303f36705);
$parcel$export(module.exports, "setActionParam", () => $a82b117199549e31$export$f207dbb64820efb5);
$parcel$export(module.exports, "refresh", () => $a82b117199549e31$export$2d6e9b4c68afb6c8);
$parcel$export(module.exports, "refreshProvidersStore", () => $a82b117199549e31$export$f5d37b22a37ae152);
$parcel$export(module.exports, "navigate", () => $a82b117199549e31$export$ff7962acd6052c28);
$parcel$export(module.exports, "getClassScreen", () => $a82b117199549e31$export$1dfb5749e0d45017);
$parcel$export(module.exports, "triggerCalendarRedirectIfConfigured", () => $a82b117199549e31$export$39ccafc4ee198671);
$parcel$export(module.exports, "customFeildGoBackAnimationHandler", () => $a82b117199549e31$export$761f74d8484bb72);
$parcel$export(module.exports, "pageListeners", () => $a82b117199549e31$export$ac0a2d8195cb6300);
$parcel$export(module.exports, "openAskQuestion", () => $a82b117199549e31$export$6bd5242d993fb825);
$parcel$export(module.exports, "openInstantQuotes", () => $a82b117199549e31$export$486aa3bbc2e80894);
$parcel$export(module.exports, "openBookAppointment", () => $a82b117199549e31$export$ef4493d1bd6ba7a);
$parcel$export(module.exports, "openInstantQuote", () => $a82b117199549e31$export$760cc41da9292fcf);
$parcel$export(module.exports, "openScheduleConsultation", () => $a82b117199549e31$export$7b7618bcf54ff47e);
$parcel$export(module.exports, "directToAllServices", () => $a82b117199549e31$export$b610d221f209283c);
$parcel$export(module.exports, "doFoCus", () => $a82b117199549e31$export$f2aa1c67b71925f0);
$parcel$export(module.exports, "handleCheckProviders", () => $a82b117199549e31$export$3a0acffdefec7ad9);
$parcel$export(module.exports, "goToProviderScheduleLink", () => $a82b117199549e31$export$fbff1ffc5f9e64ec);

var $cIxq8 = parcelRequire("cIxq8");

var $cEKee = parcelRequire("cEKee");

var $knjAn = parcelRequire("knjAn");

var $4tyfr = parcelRequire("4tyfr");

var $futhG = parcelRequire("futhG");

var $ijygk = parcelRequire("ijygk");

var $2q2gk = parcelRequire("2q2gk");

var $8QS3m = parcelRequire("8QS3m");

var $d0tLC = parcelRequire("d0tLC");

var $hKRW3 = parcelRequire("hKRW3");

var $9bGUq = parcelRequire("9bGUq");

var $hlXLP = parcelRequire("hlXLP");

var $fJKn4 = parcelRequire("fJKn4");

var $cbfUF = parcelRequire("cbfUF");

var $62LVp = parcelRequire("62LVp");

var $2XKfp = parcelRequire("2XKfp");

var $1H8Mz = parcelRequire("1H8Mz");

var $sFKcc = parcelRequire("sFKcc");

var $5xphE = parcelRequire("5xphE");

var $alq6e = parcelRequire("alq6e");

var $5q2KL = parcelRequire("5q2KL");

var $gsdGr = parcelRequire("gsdGr");

var $cOK4N = parcelRequire("cOK4N");

var $bLott = parcelRequire("bLott");

var $a5XF8 = parcelRequire("a5XF8");

var $hprW2 = parcelRequire("hprW2");

var $d6VOC = parcelRequire("d6VOC");

var $4Le5k = parcelRequire("4Le5k");

var $lmlIJ = parcelRequire("lmlIJ");

var $3UENa = parcelRequire("3UENa");

var $hGWxM = parcelRequire("hGWxM");

var $hltT2 = parcelRequire("hltT2");

var $63Hky = parcelRequire("63Hky");

var $ig8jH = parcelRequire("ig8jH");
parcelRequire("99TAZ");
/** Tracks which lead we already sent consult/prebook step with sessionEnded=true for (avoids duplicate consult requests). */ let $a82b117199549e31$var$_sessionEndStepSentForLeadId = null;
/** When true, navigate(THE_END) shows the thank-you / disqualification screen instead of following redirectUrl. */ let $a82b117199549e31$var$_isDisqualified = false;
function $a82b117199549e31$export$7e839dd9debc8735(val) {
    $a82b117199549e31$var$_isDisqualified = val;
}
/** When true, the next navigate(THE_END) skips the thank-you redirect entirely.
 * Set by non-booking flows (ask a question / Text Us): thank_you_redirect_url
 * points at a booking system, which rejects a question submission's bare hit
 * (Treat Medspa task 68359 — "Invalid Booking URL"). One-shot: reset on use. */ let $a82b117199549e31$var$_skipEndRedirect = false;
function $a82b117199549e31$export$22574faa6b71e292(val) {
    $a82b117199549e31$var$_skipEndRedirect = val;
}
function $a82b117199549e31$export$d049e111d975f618(id) {
    $a82b117199549e31$var$_sessionEndStepSentForLeadId = id;
}
function $a82b117199549e31$var$updateBookAppointmentButtonText() {
    const customText = (0, $cEKee.widgetOptions)?.find((item)=>item.type === 'book_appointment')?.button_text;
    const button = document.querySelector('.requestConsult__container .requestConsult__btn .text');
    if (customText && button) button.textContent = customText;
}
var $a82b117199549e31$export$43a94859c3a5e761 = '';
function $a82b117199549e31$export$281ad3752a540efe(param) {
    // Normalize ?? to ? so form_id is parsed (e.g. /??form_id=xxx)
    const search = (window.location.search || '').replace(/^\?+/, '?');
    const urlParams = new URLSearchParams(search);
    return urlParams.get(param);
}
function $a82b117199549e31$export$67c3813303f36705(eventId, resume = null) {
    if (!eventId) return;
    const id = String(eventId);
    const stamp = (url)=>{
        url.searchParams.set('event_id', id);
        if (resume?.signature && resume?.expires) {
            url.searchParams.set('resume_signature', resume.signature);
            url.searchParams.set('resume_expires', String(resume.expires));
        }
    };
    try {
        const url = new URL(window.location.href);
        stamp(url);
        window.history.replaceState({}, '', url.toString());
    } catch (_) {}
    if (window.top !== window.self) try {
        const topUrl = new URL(window.top.location.href);
        stamp(topUrl);
        window.top.history.replaceState({}, '', topUrl.toString());
    } catch (_) {}
}
function $a82b117199549e31$export$f207dbb64820efb5(action) {
    if (!action) return;
    try {
        const url = new URL(window.location.href);
        url.searchParams.set('action', action);
        window.history.replaceState({}, '', url.toString());
    } catch (_) {}
    if (window.top !== window.self) try {
        const topUrl = new URL(window.top.location.href);
        topUrl.searchParams.set('action', action);
        window.top.history.replaceState({}, '', topUrl.toString());
    } catch (_) {}
}
function $a82b117199549e31$export$2d6e9b4c68afb6c8() {
    /* Close all opening popup in all services screen */ document.querySelectorAll('.popup__open').forEach((i)=>i.classList.remove('popup__open'));
    /* Hide all background showed when popup opening */ document.querySelectorAll('.popup__background').forEach((i)=>i.classList.remove('displayed'));
    document.querySelectorAll('.move-to-right').forEach((i)=>i.classList.remove('move-to-right'));
    /* Turn off all loading */ (0, $2XKfp.toggleLoading)(false);
    (0, $2XKfp.toggleLoadingIframe)(false);
    /* clear all iframe screen */ (0, $hlXLP.clearAllWidgetIframe)();
    /* Reset procedures and providers to origin data */ (0, $cEKee.setProcedures)((0, $cEKee.originProcedures));
    (0, $cEKee.setProviders)((0, $cEKee.originProviders));
    /* Reset data in dropdowns */ (0, $sFKcc.loadSelectSearchProcedure)((0, $cEKee.originProcedures));
    if ((0, $cEKee.providers).length > 1) (0, $5xphE.loadProvidersDropdown)((0, $cEKee.originProviders));
    /* Remove selected providers in providers selection screen */ (0, $62LVp.removeAllSelectProvider)();
    /* Remove selected procedures in all services screen */ (0, $fJKn4.removeAllProcedures)();
    /* Remove selected location in Location selection screen */ (0, $cbfUF.removeAllSelectedLocation)();
    /* Clear inputs in Request consultation screen*/ (0, $9bGUq.clearInputsConsult)();
    /* Clear inputs in ask question screen */ (0, $1H8Mz.clearInputsAskQs)();
    /* Clear dropdowns in Request consultation screen */ (0, $9bGUq.clearLocationDropdown)();
    (0, $9bGUq.clearProcedureDropdown)();
    (0, $9bGUq.clearProviderDropdown)();
    /* Clear language dropdown validation state */ $a82b117199549e31$var$clearLanguageDropdownValidation();
    (0, $9bGUq.clearCustomFields)();
    (0, $62LVp.removeHiddenClassInProvider)();
    (0, $cEKee.setIsInstantQuote)(false);
    $a82b117199549e31$export$f5d37b22a37ae152(false);
    (0, $cEKee.setCustomFields)((0, $cEKee.form)?.form?.custom_fields || []);
    document.querySelector('.surgical-option__btn')?.classList.add('disabled');
    (0, $cOK4N.removeStyleSurgicalOptionSelected)((0, $cEKee.surgicalOption));
    (0, $cEKee.setSurgicalOption)(null);
    document.querySelector('.consultSummary__container')?.classList?.remove('show-consult-summary-question');
    document.querySelector('.endScreen__container')?.classList?.remove('show-the-end-screen');
    document.querySelectorAll('.book-appointment').forEach((i)=>i.classList.remove('book-appointment'));
    document.querySelectorAll('.ask-question__btn').forEach((i)=>i.textContent = (0, $knjAn.t)('ask_a_question'));
    document.querySelectorAll('.providerScheduling__container .schedule__option').forEach((j)=>j.classList.remove('selected'));
    document.querySelector('.seeServices__container')?.classList.remove('procedure-in-booking');
    document.querySelectorAll('.procedure__price-duration').forEach((j)=>j.classList.remove('procedure__price-duration--show'));
    document.querySelector('.providers__container')?.classList?.remove('provider-in-booking');
    document.querySelector('.no-preference-provider')?.classList?.add('hidden');
    if (document.querySelector('.phone--input invalid')) document.querySelector('.phone--input invalid').value = '';
    document.querySelector('.phone--input invalid')?.blur();
    if (document.querySelector('.requestConsult__container .requestConsult__btn')) document.querySelector('.requestConsult__container .requestConsult__btn').classList.remove('disabled');
    if (document.querySelector('.requestConsult__container .requestConsult__btn .loader__icon')) document.querySelector('.requestConsult__container .requestConsult__btn .loader__icon').style.display = 'none';
    document.querySelector('.gender__container .gender--selected')?.classList.remove('gender--selected');
    (0, $cEKee.setSelectedGender)(null);
    (0, $futhG.removeFullName)();
    document.querySelector('.email__container .email__valid')?.classList.add('hidden');
    document.querySelector('.email__container .email__invalid')?.classList.add('hidden');
    (0, $ijygk.removeEmail)();
    document.querySelector('.fullNames__container .fullName__valid')?.classList.add('hidden');
    document.querySelector('.fullNames__container .fullName__invalid ')?.classList.add('hidden');
    let imagesUploads = document.querySelector('.uploadPhotos__container .imagesUpload');
    if (imagesUploads) imagesUploads.innerHTML = '';
    (0, $cEKee.resetPagesDom)();
    (0, $cEKee.setIsBookAppointment)(false);
    (0, $cEKee.setDataSlot)({});
    // Reset calendar state so stale carousel items don't persist across sessions
    (0, $alq6e.resetPageSelectTime)();
    (0, $cEKee.setCurrentDateInUse)(0);
    (0, $cEKee.setSelectedLocationId)(null);
}
function $a82b117199549e31$var$clearLanguageDropdownValidation() {
    const languageDropdowns = [
        '.requestConsult__container [data-form="languageConsult"]',
        '.verifyInformation__container [data-form="languageVerify"]'
    ];
    languageDropdowns.forEach((selector)=>{
        const formItem = document.querySelector(selector);
        if (formItem) formItem.classList.remove('invalid');
    });
}
function $a82b117199549e31$var$showScreen(className) {
    const element = document.querySelector(className);
    (0, $cEKee.addPagesDom)(element);
    // goBack() parks `pointer-events: none` on the page it navigates away from
    // and only ever restores 'auto' on the page it pops back to. Without this
    // reset, any screen that was once one-below during a back-navigation comes
    // back visible, on top and completely inert — clicks and inputs do nothing
    // and no error is shown.
    element.style.pointerEvents = 'auto';
    (0, $cEKee.pagesDom)[(0, $cEKee.pagesDom).length - 1].style.zIndex = (parseInt((0, $cEKee.pagesDom)[(0, $cEKee.pagesDom).length - 2].style.zIndex) + 1).toString();
}
const $a82b117199549e31$var$disableScrollWhenBlurInput = ()=>{
    document.querySelectorAll('input').forEach((input)=>{
        input.addEventListener('focus', $a82b117199549e31$var$handleFocus);
        input.addEventListener('blur', $a82b117199549e31$var$handleBlur);
    });
};
const $a82b117199549e31$var$handleFocus = ()=>{
    parent.postMessage((0, $cIxq8.EVENT_MESSAGE).ENABLE_SCROLL, "*");
};
const $a82b117199549e31$var$handleBlur = ()=>{
    parent.postMessage((0, $cIxq8.EVENT_MESSAGE).DISABLE_SCROLL, "*");
};
async function $a82b117199549e31$export$ff7962acd6052c28(page) {
    console.log('[DBG] navigate ->', page);
    const screen = $a82b117199549e31$export$1dfb5749e0d45017(page);
    /* Show full-screen loading overlay immediately so user doesn't see a previous/random page while transitioning */ (0, $2XKfp.toggleLoading)(true);
    try {
        if (0, $cIxq8.MOBILE_SCREEN) $a82b117199549e31$var$disableScrollWhenBlurInput();
        (0, $4tyfr.applyDisclaimerFooters)();
        if ((0, $cEKee.isDesktopVer) || page === (0, $cIxq8.SCREEN).NOTFOUND_APPOINTMENT) {
            const container = document?.querySelector(`${screen} .screen__content`);
            container?.style.setProperty('--header-height', '0px');
            if (page !== (0, $cIxq8.SCREEN).REQUEST_CONSULT) container?.querySelector('.title__wrapper')?.classList.add("hidden");
            if (!container?.querySelector('.infoStaff')) (0, $hltT2.renderStaffInfoHeader)(null, null, screen.replace('.', ''), true);
        }
        const intakeRedirectUrl = await $a82b117199549e31$export$b9dd42b4e24f01b4(page);
        if (page === (0, $cIxq8.SCREEN).THE_END && $a82b117199549e31$var$_skipEndRedirect) $a82b117199549e31$var$_skipEndRedirect = false;
        else if (page === (0, $cIxq8.SCREEN).THE_END && !$a82b117199549e31$var$_isDisqualified) {
            const selectedLoc = (0, $cEKee.locationId) && (0, $cEKee.locations).find((l)=>l.id === (0, $cEKee.locationId));
            // The signed intake handoff wins: it is one of our own forms, minted
            // server-side for this widget, and its token already carries the
            // identity — so nothing is appended to it in the clear.
            if (intakeRedirectUrl) {
                // window.top, not window.parent: the real embed nests two iframes
                // (widget.js's iframe, then assistant.html inside it) and
                // allow-top-navigation only covers navigating window.top.
                window.top.location = intakeRedirectUrl;
                return;
            }
            const dest = selectedLoc?.scheduling_link || (0, $cEKee.redirectUrl);
            if (dest) {
                const nameParts = ((0, $cEKee.fullName) || '').trim().split(/\s+/);
                const firstName = (0, $cEKee.leadInfo)?.first_name || nameParts[0] || '';
                const lastName = (0, $cEKee.leadInfo)?.last_name || (nameParts.length > 1 ? nameParts.slice(1).join(' ') : '');
                const leadEmail = (0, $cEKee.leadInfo)?.email || (0, $cEKee.email) || '';
                const leadPhone = (0, $cEKee.leadInfo)?.phone || (0, $cEKee.phone) || '';
                const params = new URLSearchParams();
                if (firstName) params.set('first_name', firstName);
                if (lastName) params.set('last_name', lastName);
                if (leadEmail) params.set('email', leadEmail);
                if (leadPhone) params.set('phone', leadPhone);
                const qs = params.toString();
                const separator = dest.includes('?') ? '&' : '?';
                window.parent.location.href = qs ? `${dest}${separator}${qs}` : dest;
                return;
            }
        }
        if (page === (0, $cIxq8.SCREEN).THE_END && $a82b117199549e31$var$_isDisqualified) {
            const endContainer = document.querySelector('.endScreen__container');
            if (endContainer) endContainer.classList.add('endScreen__container--disqualified');
            const endImg = document.querySelector('.endScreen__container img');
            if (endImg) endImg.style.display = 'none';
            const mainText = document.querySelector('.endScreen__container .main-text');
            if (mainText) mainText.style.display = 'none';
            const msg = (0, $cEKee.form)?.appointment_channel?.disqualification_message ?? (0, $cEKee.form)?.consult_disqualification_message;
            if (msg) {
                const el = document.querySelector('.endScreen__container .notify-text');
                if (el) el.innerHTML = msg;
            }
        }
        const removeLastSelectOnlyPage = (className)=>{
            const lastPage = (0, $cEKee.pagesDom)[(0, $cEKee.pagesDom).length - 1];
            if (lastPage?.classList.contains(className)) {
                // Demote the popped screen: screens are never hidden, so a stale
                // high z-index left here keeps it painted above later screens.
                lastPage.style.zIndex = '1';
                (0, $cEKee.removeLastPagesDom)();
                removeLastSelectOnlyPage(className);
            }
        };
        if (page === (0, $cIxq8.SCREEN).SELECT_ONLY_DATE) removeLastSelectOnlyPage('selectOnlyDate__container');
        else if (page === (0, $cIxq8.SCREEN).SELECT_ONLY_TIME) removeLastSelectOnlyPage('selectOnlyTime__container');
        $a82b117199549e31$var$showScreen(screen);
    } finally{
        (0, $2XKfp.toggleLoading)(false);
    }
}
function $a82b117199549e31$export$39ccafc4ee198671() {
    const url = (0, $cEKee.getCalendarRedirectUrl)();
    if (!url) return;
    setTimeout(()=>{
        // window.parent.location.href = url throws cross-origin (writing a
        // property on another origin's Location object is blocked; whole-property
        // assignment is required). window.top (not window.parent) is required
        // because the real embed nests two iframes deep (widget.js's own iframe,
        // then assistant.html inside it) — sandbox's allow-top-navigation only
        // covers navigating window.top, not an intermediate ancestor.
        window.top.location = url;
    }, 2000);
}
async function $a82b117199549e31$export$b9dd42b4e24f01b4(page) {
    if (!(0, $cEKee.leadInfo)?.id) return;
    const { collect_patient_information_first_before_scheduling: collect_patient_information_first_before_scheduling } = (0, $cEKee.form)?.appointment_channel || {};
    if (page === (0, $cIxq8.SCREEN).UPLOAD_PHOTOS) await (0, $2q2gk.updateLeadStep)((0, $cEKee.leadInfo).id, 'pre_upload');
    if (page === (0, $cIxq8.SCREEN).APPOINTMENT_CONFIRMED && (0, $cEKee.appointmentChannelId) && collect_patient_information_first_before_scheduling) // Keepalive: triggerCalendarRedirectIfConfigured may navigate window.top
    // ~2s after this screen renders, which would abort a plain axios/XHR call
    // still in flight.
    (0, $2q2gk.updateLeadStepKeepalive)((0, $cEKee.leadInfo).id, 'prebook', 'true');
    if (page === (0, $cIxq8.SCREEN).THE_END) {
        if ((0, $cEKee.eventPayload) && (0, $cEKee.eventPayload)?.status === 'request') return;
        // Only send consult/prebook with sessionEnded=true once per lead to avoid duplicate consult requests
        if ($a82b117199549e31$var$_sessionEndStepSentForLeadId === (0, $cEKee.leadInfo).id) return;
        $a82b117199549e31$var$_sessionEndStepSentForLeadId = (0, $cEKee.leadInfo).id;
        const step = (0, $cEKee.appointmentChannelId) && collect_patient_information_first_before_scheduling ? 'prebook' : 'consult';
        const response = await (0, $2q2gk.updateLeadStep)((0, $cEKee.leadInfo).id, step, 'true', step === 'consult' ? (0, $cEKee.typedIdentity)() : {});
        // 204 for every widget without an intake handoff configured; a JSON body
        // only when this widget hands off to an intake form.
        return response?.data?.intake_redirect_url;
    }
}
function $a82b117199549e31$export$28fca2ccfd38b8f(screen) {
    let page = $a82b117199549e31$export$1dfb5749e0d45017(screen);
    if ((0, $cEKee.pagesDom).length - 2 > 0) (0, $cEKee.pagesDom)[(0, $cEKee.pagesDom).length - 2].style.pointerEvents = 'none';
    if (screen === (0, $cIxq8.SCREEN).SEE_ALL_SERVICES) {
        document.querySelector('.seeServices__container .category_wrapper').innerHTML = '';
        document.querySelector('.seeServices__container .procedures__container').innerHTML = '';
    }
    document.querySelector(page).style.zIndex = '1';
    document.querySelector(page).willChange = 'auto';
    (0, $cEKee.removeLastPagesDom)();
    (0, $cEKee.pagesDom)[(0, $cEKee.pagesDom).length - 1].style.pointerEvents = 'auto';
    /* Current screen is menu option screen */ if ((0, $cEKee.pagesDom).length === 1) $a82b117199549e31$export$2d6e9b4c68afb6c8();
    switch(screen){
        case (0, $cIxq8.SCREEN).ASK_QUESTION:
            (0, $1H8Mz.clearInputsAskQs)();
            break;
        case (0, $cIxq8.SCREEN).REQUEST_CONSULT:
            (0, $9bGUq.clearInputsConsult)();
            break;
        case (0, $cIxq8.SCREEN).SEE_ALL_SERVICES:
            (0, $fJKn4.removeAllProcedures)();
            (0, $cEKee.setProcedureSelectionType)((0, $cEKee.form)?.appointment_channel?.selection_type || (0, $cEKee.form).selection_type);
            break;
        case (0, $cIxq8.SCREEN).SELECT_TIME:
            (0, $alq6e.resetPageSelectTime)();
            document.querySelector(`.providers__list .provider[data-provider-id="${(0, $cEKee.providerId)}"]`).click();
            break;
        case (0, $cIxq8.SCREEN).SURGICAL:
            document.querySelector('.validateDigitsContinue__btn').classList.add('disabled');
            (0, $cEKee.setIsBookAppointment)(false);
            break;
        case (0, $cIxq8.SCREEN).VALIDATE_DIGITS:
            document.getElementById('validateDigits0').value = '';
            document.getElementById('validateDigits1').value = '';
            document.getElementById('validateDigits2').value = '';
            document.getElementById('validateDigits3').value = '';
            break;
        case (0, $cIxq8.SCREEN).REGISTER_NEW_PATIENT:
            (0, $5q2KL.resetPageRegisterNewPatientsFormData)();
            break;
        case (0, $cIxq8.SCREEN).PROVIDERS:
            (0, $cEKee.setProviderId)('');
            (0, $62LVp.removeHiddenClassInProvider)();
            document.querySelector('.providers__container')?.classList?.remove('provider-in-booking');
            document.querySelector('.no-preference-provider')?.classList?.add('hidden');
            break;
        case (0, $cIxq8.SCREEN).SELECT_GENDER:
            (0, $cEKee.setIsInstantQuote)(false);
            break;
        case (0, $cIxq8.SCREEN).PHONE:
            (0, $gsdGr.removePhone)();
            break;
        case (0, $cIxq8.SCREEN).ALL_QUESTIONS:
            break;
        default:
            break;
    }
}
function $a82b117199549e31$export$761f74d8484bb72(pageClass) {
    document.getElementById('consult-summary')?.focus();
    document.querySelector(pageClass).style.zIndex = '1';
    (0, $cEKee.removeLastPagesDom)();
}
function $a82b117199549e31$export$1dfb5749e0d45017(screen) {
    switch(screen){
        case (0, $cIxq8.SCREEN).DASHBOARD:
            return '.mainMenu__container';
        case (0, $cIxq8.SCREEN).ASK_QUESTION:
            return '.askQuestion__container';
        case (0, $cIxq8.SCREEN).THE_END:
            return '.endScreen__container';
        case (0, $cIxq8.SCREEN).REQUEST_CONSULT:
            return '.requestConsult__container';
        case (0, $cIxq8.SCREEN).CONSULT_DOB:
            return '.consultDob__container';
        case (0, $cIxq8.SCREEN).INSTANT_QUOTE:
            return '.widgetScreen__container.instant-quote';
        case (0, $cIxq8.SCREEN).PROCEDURE_ELIGIBILITY:
            return '.widgetScreen__container.procedure-eligibility';
        case (0, $cIxq8.SCREEN).SEE_ALL_SERVICES:
            return '.seeServices__container';
        case (0, $cIxq8.SCREEN).PROVIDERS:
            return '.providers__container';
        case (0, $cIxq8.SCREEN).SERVICES_IFRAME:
            return '.widgetScreen__container.see-services';
        case (0, $cIxq8.SCREEN).TOP_QUESTION:
            return '.topQuestion__container';
        case (0, $cIxq8.SCREEN).LOCATIONS:
            return '.locations__container';
        case (0, $cIxq8.SCREEN).CONSULT_SUMMARY:
            return '.consultSummary__container';
        case (0, $cIxq8.SCREEN).CONSULT_SCHEDULING:
            return '.consultScheduling__container';
        case (0, $cIxq8.SCREEN).PROVIDER_SCHEDULING:
            return '.providerScheduling__container';
        case (0, $cIxq8.SCREEN).SERVICE_SUMMARY:
            return '.serviceSummary__container';
        case (0, $cIxq8.SCREEN).INTERESTS:
            return '.interests__container';
        case (0, $cIxq8.SCREEN).FULL_NAME:
            return '.fullNames__container';
        case (0, $cIxq8.SCREEN).EMAIL:
            return '.email__container';
        case (0, $cIxq8.SCREEN).PHONE:
            return '.phone__container';
        case (0, $cIxq8.SCREEN).INSTANT_QUOTE_SUMMARY:
            return '.instant_quote_summary__container';
        case (0, $cIxq8.SCREEN).SURGICAL:
            return '.surgical__container';
        case (0, $cIxq8.SCREEN).VALIDATE_DIGITS:
            return '.validateDigits__container';
        case (0, $cIxq8.SCREEN).SELECT_TIME:
            return '.selectTime__container';
        case (0, $cIxq8.SCREEN).SELECT_ONLY_DATE:
            return '.selectOnlyDate__container';
        case (0, $cIxq8.SCREEN).SELECT_ONLY_TIME:
            return '.selectOnlyTime__container';
        case (0, $cIxq8.SCREEN).MAIN_MENU:
            return '.mainMenu__container';
        case (0, $cIxq8.SCREEN).REGISTER_NEW_PATIENT:
            return '.register-new-patient__container';
        case (0, $cIxq8.SCREEN).ADDRESS_COLLECTION:
            return '.address-collection__container';
        case (0, $cIxq8.SCREEN).APPOINTMENT_SUMMARY:
            return '.appointment-summary__container';
        case (0, $cIxq8.SCREEN).CARD_COLLECTION:
            return '.card-collection__container';
        case (0, $cIxq8.SCREEN).APPOINTMENT_CONFIRMED:
            return '.appointment-confirmed__container';
        case (0, $cIxq8.SCREEN).APPOINTMENT_CANCEL:
            return '.appointment-cancel__container';
        case (0, $cIxq8.SCREEN).APPOINTMENT_RESCHEDULE:
            return '.appointment-reschedule__container';
        case (0, $cIxq8.SCREEN).APPOINTMENT_RESCHEDULE_REASON:
            return '.appointment-reschedule-reason__container';
        case (0, $cIxq8.SCREEN).UPLOAD_PHOTOS:
            return '.uploadPhotos__container';
        case (0, $cIxq8.SCREEN).SELECT_GENDER:
            return '.gender__container';
        case (0, $cIxq8.SCREEN).BODY_AREA_SELECTION:
            return '.bodyAreaSelection__container';
        case (0, $cIxq8.SCREEN).VERIFY_INFORMATION:
            return '.verifyInformation__container';
        case (0, $cIxq8.SCREEN).ALL_QUESTIONS:
            return '.allQuestions__container';
        case (0, $cIxq8.SCREEN).PATIENTS:
            return '.patients__container';
        case (0, $cIxq8.SCREEN).DELIVERY_MODE:
            return '.deliveryMode__container';
        case (0, $cIxq8.SCREEN).NOTFOUND_APPOINTMENT:
            return '.notfound__container';
        case (0, $cIxq8.SCREEN).CALLUS:
            return '.callus_container';
        case (0, $cIxq8.SCREEN).CATEGORIES:
            return '.categories__container';
        case (0, $cIxq8.SCREEN).TEXTAREA_QUESTION:
        case (0, $cIxq8.SCREEN).CHECKBOX_QUESTION:
        case (0, $cIxq8.SCREEN).TEXT_QUESTION:
        case (0, $cIxq8.SCREEN).SELECT_QUESTION:
        case (0, $cIxq8.SCREEN).DATE_QUESTION:
        case (0, $cIxq8.SCREEN).NUMBER_QUESTION:
        case (0, $cIxq8.SCREEN).HEIGHT_QUESTION:
            return `${0, $cEKee.nameScreenDynamic}`;
        default:
            break;
    }
}
function $a82b117199549e31$export$ac0a2d8195cb6300() {
    /* Select FAQs */ if (document.querySelector(`#${(0, $cIxq8.SCREEN).FAQS}`)) document.querySelector(`#${(0, $cIxq8.SCREEN).FAQS}`).onclick = ()=>$a82b117199549e31$export$68a263d6d1614ba5();
    /* Select Ask A Question */ if (document.querySelector(`#${(0, $cIxq8.SCREEN).ASK_QUESTION}`)) document.querySelector(`#${(0, $cIxq8.SCREEN).ASK_QUESTION}`).onclick = ()=>$a82b117199549e31$export$6bd5242d993fb825();
    /* Select Text Us */ if (document.querySelector(`#${(0, $cIxq8.SCREEN).TEXT_US}`)) document.querySelector(`#${(0, $cIxq8.SCREEN).TEXT_US}`).onclick = ()=>$a82b117199549e31$export$ff7962acd6052c28((0, $cIxq8.SCREEN).ASK_QUESTION);
    /* Select instant quote */ if (document.querySelector(`#${(0, $cIxq8.SCREEN).INSTANT_QUOTE}`)) document.querySelector(`#${(0, $cIxq8.SCREEN).INSTANT_QUOTE}`).onclick = ()=>$a82b117199549e31$export$486aa3bbc2e80894((0, $cIxq8.SCREEN).INSTANT_QUOTE);
    /* Select Call */ if (document.querySelector(`#call.option`)) document.querySelector('#call.option').onclick = ()=>$a82b117199549e31$export$7277c1b70a19f0f5((0, $cIxq8.SCREEN).CALLUS);
    /* Select Book Appointment */ if (document.querySelector(`#${(0, $cIxq8.SCREEN).BOOK_APPOINTMENT}`)) document.querySelector(`#${(0, $cIxq8.SCREEN).BOOK_APPOINTMENT}`).onclick = ()=>$a82b117199549e31$export$ef4493d1bd6ba7a();
    /* Select Custom Option */ let tempOptionsDom = document.querySelectorAll(`.option`);
    if (tempOptionsDom && tempOptionsDom.length > 0) tempOptionsDom.forEach((item)=>{
        if (item.id.includes('custom_option-')) {
            const baseHref = item.querySelector('a').href;
            // onclick (not addEventListener) so re-running this setup
            // replaces the handler instead of stacking a duplicate one.
            item.onclick = ()=>{
                const adParams = new URLSearchParams();
                const advertisingParams = [
                    'gad_source',
                    'gad_campaignid',
                    'gbraid',
                    'gclid',
                    'utm_source',
                    'utm_medium',
                    'utm_campaign',
                    'utm_term',
                    'utm_content',
                    'fbclid',
                    'msclkid',
                    'ttclid',
                    'oppref'
                ];
                try {
                    const parentUrl = new URL(window.parent.location.href);
                    advertisingParams.forEach((param)=>{
                        if (parentUrl.searchParams.has(param)) adParams.append(param, parentUrl.searchParams.get(param));
                    });
                } catch (error) {
                    try {
                        const currentUrl = new URL(window.location.href);
                        advertisingParams.forEach((param)=>{
                            if (currentUrl.searchParams.has(param)) adParams.append(param, currentUrl.searchParams.get(param));
                        });
                    } catch (fallbackError) {
                    // 
                    }
                }
                // Attribution handoff: the widget already created a Visitor
                // (with this session's PaidAdClick) — pass its id so a
                // standalone intake form can tie its lead back to the ad
                // click and fire the Google Ads conversion. Read at click
                // time: the visitor is created async after page load.
                const trackedVisitorId = (0, $cEKee.visitorId) || window.visitor_id;
                if (trackedVisitorId) adParams.append('visitor_id', String(trackedVisitorId));
                // Rebuild from the pristine href every click — never
                // mutate a shared variable, or a second click appends
                // visitor_id/ad params a second time (duplicate params).
                let targetHref = baseHref;
                if (adParams.toString()) {
                    const customUrl = new URL(baseHref);
                    adParams.forEach((value, key)=>{
                        customUrl.searchParams.set(key, value);
                    });
                    targetHref = customUrl.toString();
                }
                window.open(targetHref, '_blank');
            };
        }
    });
    $a82b117199549e31$var$navigateGoBack();
    $a82b117199549e31$var$navigateGoBackOneStep();
}
function $a82b117199549e31$var$navigateGoBack() {
    document.querySelectorAll('.screen .back-arrow').forEach((i)=>{
        i.onclick = ()=>$a82b117199549e31$export$28fca2ccfd38b8f(i.getAttribute('data-screen'));
    });
    document.querySelectorAll('.screen .backOneStep__btn').forEach((i)=>{
        i.onclick = ()=>$a82b117199549e31$export$28fca2ccfd38b8f(i.getAttribute('data-screen'));
    });
}
function $a82b117199549e31$var$navigateGoBackOneStep() {
    document.querySelectorAll('.screen .back-to-before-step').forEach((i)=>{
        i.onclick = ()=>$a82b117199549e31$export$28fca2ccfd38b8f(i.getAttribute('data-screen'));
    });
}
function $a82b117199549e31$export$760cc41da9292fcf() {
    (0, $cEKee.setAccessToken)((0, $cEKee.form).token);
    (0, $cEKee.setIsInstantQuote)(true);
    $a82b117199549e31$var$handleCheckProjectCategory();
}
function $a82b117199549e31$export$7b7618bcf54ff47e() {
    if ((0, $cEKee.locations).length === 1) {
        const locationConsultElement = document.querySelector('#locationConsult');
        if (locationConsultElement) locationConsultElement.value = (0, $cEKee.locations)[0]?.name;
        (0, $cEKee.setLocationId)((0, $cEKee.locations)[0]?.id);
        document.querySelector('.requestConsult__container div[data-form="locationConsult"]')?.classList.remove('invalid');
        document.querySelector('.requestConsult__container .locationsDropdown__wrapper')?.classList.add('selected');
    }
    if ((0, $cEKee.providers).length === 1) {
        const id = (0, $cEKee.providers)[0].id;
        (0, $cEKee.setProviderId)(id);
        const newProcedures = (0, $cEKee.providers).find((j)=>j.id === id).procedures;
        (0, $sFKcc.loadSelectSearchProcedure)(newProcedures);
        (0, $9bGUq.clearProcedureDropdown)();
    }
    if (!(0, $cEKee.scheduling)) {
        (0, $sFKcc.loadSelectSearchProcedure)((0, $cEKee.procedures));
        (0, $9bGUq.toggleSelectProcedure)((0, $cIxq8.CLOSE));
        (0, $9bGUq.toggleSelectProvider)((0, $cIxq8.CLOSE));
        $a82b117199549e31$export$ef4493d1bd6ba7a();
    } else $a82b117199549e31$export$ff7962acd6052c28((0, $cIxq8.SCREEN).INSTANT_QUOTE);
}
function $a82b117199549e31$export$68a263d6d1614ba5() {
    $a82b117199549e31$export$ff7962acd6052c28((0, $cIxq8.SCREEN).TOP_QUESTION);
}
function $a82b117199549e31$export$6bd5242d993fb825() {
    $a82b117199549e31$export$ff7962acd6052c28((0, $cIxq8.SCREEN).ASK_QUESTION);
}
async function $a82b117199549e31$export$486aa3bbc2e80894(screen) {
    $a82b117199549e31$export$f5d37b22a37ae152(false);
    $a82b117199549e31$export$43a94859c3a5e761 = screen;
    (0, $cEKee.setIsInstantQuote)(true);
    $a82b117199549e31$var$handleCheckProjectCategory();
}
async function $a82b117199549e31$export$7277c1b70a19f0f5(screen) {
    const phoneNumbers = (0, $cEKee.form)?.main_phone_number ? [
        (0, $cEKee.form).main_phone_number
    ] : (0, $cEKee.form)?.locations;
    if (phoneNumbers.length > 1) {
        $a82b117199549e31$export$ff7962acd6052c28(screen);
        (0, $63Hky.renderUILocationCall)();
    } else {
        const phoneNumber = (0, $cEKee.form)?.main_phone_number || ((0, $cEKee.form)?.locations?.length === 1 ? (0, $cEKee.form)?.locations[0]?.phone : null) || (0, $cEKee.phoneToCall);
        window.parent.location.href = `tel:${phoneNumber}`;
    }
}
function $a82b117199549e31$var$shouldShowStaffSelection(hostType, staffCount) {
    // Auto-select soonest provider: never show the provider-selection step.
    if ((0, $cEKee.isAutoSelectSoonestProviderEnabled)()) return false;
    switch(hostType){
        case 0, $cIxq8.HOST_TYPE_ONE_ON_ONE:
            return staffCount > 1;
        case 0, $cIxq8.HOST_TYPE_ROUND_ROBIN:
        case 0, $cIxq8.HOST_TYPE_COLLECTIVE:
            return false;
        default:
            return (0, $cEKee.form)?.appointment_channel?.visitor_can_choose_the_staff;
    }
}
function $a82b117199549e31$var$getHostType() {
    return (0, $cEKee.form)?.appointment_channel?.host || (0, $cIxq8.HOST_TYPE_ONE_ON_ONE);
}
function $a82b117199549e31$var$selectStaffByRoundRobin(staffs) {
    if (!staffs || staffs.length === 0) return null;
    return staffs[0];
}
function $a82b117199549e31$var$selectStaffByCollective(staffs) {
    if (!staffs || staffs.length === 0) return null;
    return staffs;
}
function $a82b117199549e31$export$b610d221f209283c(button, procedures) {
    (0, $hKRW3.setTextForServicesButton)(button);
    (0, $8QS3m.loadCategories)(procedures);
    (0, $d0tLC.loadProcedures)(procedures);
    if (isBookAppointment) {
        const enableCategorySelection = (0, $cEKee.form)?.appointment_channel?.enable_category_selection;
        if (enableCategorySelection && procedures.length > 1) {
            const filteredCategories = categories.filter((category)=>isHasProcedureBelongToCategory(category, procedures));
            if (filteredCategories.length > 0) {
                loadCategoryList(filteredCategories);
                categorySelectionListeners();
                $a82b117199549e31$export$ff7962acd6052c28((0, $cIxq8.SCREEN).CATEGORIES);
                return;
            }
        }
    }
    $a82b117199549e31$export$ff7962acd6052c28((0, $cIxq8.SCREEN).SEE_ALL_SERVICES);
}
async function $a82b117199549e31$export$ef4493d1bd6ba7a() {
    console.log('[DBG] openBookAppointment enter, leadTextId=', (0, $cEKee.leadTextId));
    // Respect API appointment_request_type "form" so consult request + consult_request_fields are shown
    const apiRequestType = (0, $cEKee.form).appointment_request_type;
    let appointmentRequestType = apiRequestType === (0, $cIxq8.APPOINTMENT_REQUEST_FORM) ? (0, $cIxq8.APPOINTMENT_REQUEST_FORM) : (0, $cEKee.appointmentChannelId) ? (0, $cIxq8.APPOINTMENT_REQUEST_CALENDAR) : apiRequestType;
    if (appointmentRequestType === (0, $cIxq8.APPOINTMENT_REQUEST_CALENDAR)) {
        const fields = (0, $cEKee.form)?.appointment_channel?.qualification_form?.custom_fields || [];
        (0, $cEKee.setCustomFields)(fields);
    }
    (0, $cEKee.setAppointmentQuestionsCompleted)(false);
    // Fresh flow entry: clear any prior Virtual/In-Person choice so the gated
    // delivery-mode step re-prompts. Needed for single-location channels, which
    // skip the location Continue button (the other reset point).
    (0, $cEKee.setSelectedDeliveryMode)(null);
    $a82b117199549e31$export$f5d37b22a37ae152(appointmentRequestType === (0, $cIxq8.APPOINTMENT_REQUEST_CALENDAR));
    const lengthServiceType = Object.keys((0, $cEKee.form).service_types).length;
    (0, $cEKee.setIsBookAppointment)(true);
    (0, $cEKee.setAccessToken)((0, $cEKee.form).token);
    const staffsOfAppointmentChannel = (0, $cEKee.form)?.appointment_channel?.staffs?.filter((staff)=>staff?.online_booking);
    const { collect_patient_information_first_before_scheduling: collect_patient_information_first_before_scheduling, procedures: proceduresCalendar, location: location, staffs: staffs } = (0, $cEKee.form)?.appointment_channel || {};
    if ((0, $cEKee.form)?.appointment_channel?.procedures?.length) {
        const proceduresOnlineBooking = (0, $cEKee.form)?.appointment_channel?.procedures?.filter((p)=>p?.online_booking);
        (0, $cEKee.setProceduresOfAppointmentChannel)(proceduresOnlineBooking);
        if ((0, $cEKee.appointmentChannelId) && proceduresOnlineBooking?.length > 1) (0, $cEKee.setProcedures)(proceduresOnlineBooking);
    }
    if (appointmentRequestType === (0, $cIxq8.APPOINTMENT_REQUEST_FORM)) $a82b117199549e31$var$updateBookAppointmentButtonText();
    if (Object.keys(proceduresCalendar).length) {
        const values = Object.values(proceduresCalendar);
        const proceduresOnlineBooking = values?.filter((p)=>p?.online_booking);
        (0, $cEKee.setProceduresOfAppointmentChannel)(proceduresOnlineBooking);
        (0, $cEKee.setForm)({
            ...(0, $cEKee.form),
            appointment_channel: {
                ...(0, $cEKee.form)?.appointment_channel,
                procedures: Object.values(proceduresCalendar)
            }
        });
        if ((0, $cEKee.appointmentChannelId) && proceduresOnlineBooking?.length > 1) (0, $cEKee.setProcedures)(proceduresOnlineBooking);
    }
    if ((0, $cEKee.appointmentChannelId) && (!(0, $cEKee.proceduresOfAppointmentChannel)?.length || !staffsOfAppointmentChannel?.length)) {
        $a82b117199549e31$export$ff7962acd6052c28((0, $cIxq8.SCREEN).NOTFOUND_APPOINTMENT);
        return;
    }
    const hostType = $a82b117199549e31$var$getHostType();
    if ((0, $cEKee.appointmentChannelId) && staffsOfAppointmentChannel?.length > 0) {
        if (hostType === (0, $cIxq8.HOST_TYPE_ROUND_ROBIN)) {
            const selectedStaff = $a82b117199549e31$var$selectStaffByRoundRobin(staffsOfAppointmentChannel);
            if (selectedStaff) {
                (0, $cEKee.setStaffId)(selectedStaff.id);
                (0, $cEKee.setProviderId)(selectedStaff.id);
            }
        } else if (hostType === (0, $cIxq8.HOST_TYPE_COLLECTIVE)) {
            const selectedStaffs = $a82b117199549e31$var$selectStaffByCollective(staffsOfAppointmentChannel);
            if (selectedStaffs && selectedStaffs.length > 0) {
                (0, $cEKee.setStaffId)(selectedStaffs[0].id);
                (0, $cEKee.setProviderId)(selectedStaffs[0].id);
            }
        }
    }
    if (lengthServiceType >= 2 || (0, $cEKee.appointmentChannelId)) {
        if (0, $cEKee.staffId) {
            const checkStaffId = (0, $cEKee.form)?.staff?.findIndex((staff)=>staff.id === +(0, $cEKee.staffId));
            if (checkStaffId >= 0 && !(0, $cEKee.appointmentChannelId)) await (0, $a5XF8.fetchProcedureByStaff)(+(0, $cEKee.staffId));
        }
        console.log('[DBG] gate', appointmentRequestType, collect_patient_information_first_before_scheduling, (0, $cEKee.leadTextId));
        if (appointmentRequestType !== (0, $cIxq8.APPOINTMENT_REQUEST_CALENDAR) || (0, $cEKee.appointmentChannelId) && collect_patient_information_first_before_scheduling && !(0, $cEKee.leadTextId)) {
            if (0, $cEKee.procedureIdSelected) (0, $cOK4N.preSelectProcedure)();
            if (0, $cEKee.staffId) (0, $sFKcc.loadSelectSearchProcedure)((0, $cEKee.procedures));
            const foundProcedure = (0, $cEKee.procedures)?.find((i)=>i?.id === +(0, $cEKee.procedureIdSelected));
            if (foundProcedure) (0, $cEKee.setSurgicalOption)(Boolean(foundProcedure.surgical));
            if (collect_patient_information_first_before_scheduling && (0, $cEKee.appointmentChannelId)) {
                const staffsOnlineBooking = staffs?.filter((staff)=>staff?.online_booking);
                if (proceduresCalendar?.length === 1) {
                    (0, $cEKee.setProcedureIdSelected)(proceduresCalendar[0]?.id);
                    (0, $cOK4N.preSelectProcedure)();
                }
                if (location) (0, $cEKee.setLocationId)(location.id);
                (0, $cEKee.setProviders)(staffsOnlineBooking);
                if (staffsOnlineBooking?.length === 1) (0, $cEKee.setProviderId)(staffsOnlineBooking[0]?.id);
                (0, $sFKcc.loadSelectSearchProcedure)(proceduresCalendar);
                const title = document.querySelector('.requestConsult__container .title__content');
                if (title) title.textContent = (0, $knjAn.t)('enter_patient_information');
                const btn = document.querySelector('.requestConsult__container .requestConsult__btn .text');
                if (btn) {
                    const customBtnText = (0, $cEKee.widgetOptions)?.find((item)=>item.type === 'book_appointment')?.button_text;
                    btn.textContent = customBtnText || (0, $knjAn.t)('book_appointment');
                }
            }
            $a82b117199549e31$export$ff7962acd6052c28((0, $cIxq8.SCREEN).REQUEST_CONSULT);
        } else {
            if (!(0, $cEKee.staffId) && staffsOfAppointmentChannel?.length && (0, $cEKee.appointmentChannelId)) (0, $cEKee.setStaffId)(staffsOfAppointmentChannel[0]?.id);
            if (!(0, $cEKee.procedureIdSelected) && (0, $cEKee.proceduresOfAppointmentChannel) && (0, $cEKee.appointmentChannelId) && (0, $cEKee.form)?.appointment_channel?.procedures?.length === 1) (0, $cEKee.setProcedureIdSelected)((0, $cEKee.proceduresOfAppointmentChannel)[0]?.id);
            if (0, $cEKee.appointmentChannelId) {
                // Only auto-select when there is genuinely a single location.
                // With more than one location we always require the patient to
                // pick one rather than defaulting (which produced misleading
                // location data on abandoned flows).
                console.log('[DBG] else-branch appointmentChannelId, locations=', JSON.stringify((0, $cEKee.locations)?.map?.((l)=>l.id)));
                if ((0, $cEKee.locations)?.length === 1) {
                    (0, $cEKee.setSelectedLocation)((0, $cEKee.locations)[0]?.id);
                    (0, $hGWxM.handleLocationPage)();
                } else $a82b117199549e31$export$ff7962acd6052c28((0, $cIxq8.SCREEN).LOCATIONS);
                return;
            }
            if ((0, $cEKee.staffId) && (0, $cEKee.procedureIdSelected)) $a82b117199549e31$var$handleProcedureSelection();
            else if (0, $cEKee.appointmentChannelId) {
                (0, $lmlIJ.patientListeners)();
                if ((0, $ig8jH.isPageHidden)('patient_page', (0, $cEKee.hiddenPages))) (0, $lmlIJ.patientContinueBtnHandler)();
                else {
                    (0, $lmlIJ.patientListeners)();
                    $a82b117199549e31$export$ff7962acd6052c28((0, $cIxq8.SCREEN).PATIENTS);
                }
            } else $a82b117199549e31$export$ff7962acd6052c28((0, $cIxq8.SCREEN).SURGICAL);
        }
    } else {
        let service = Object.values((0, $cEKee.form).service_types)[0];
        const hostType = $a82b117199549e31$var$getHostType();
        const staffsOfAppointmentChannel = (0, $cEKee.form)?.appointment_channel?.staffs?.filter((staff)=>staff?.online_booking);
        const staffCount = staffsOfAppointmentChannel?.length || 0;
        if ((0, $cEKee.appointmentChannelId) && $a82b117199549e31$var$shouldShowStaffSelection(hostType, staffCount)) {
            if ((0, $cEKee.locations)?.length === 1) {
                (0, $cEKee.setSelectedLocation)((0, $cEKee.locations)[0]?.id);
                (0, $hGWxM.handleLocationPage)();
            } else $a82b117199549e31$export$ff7962acd6052c28((0, $cIxq8.SCREEN).LOCATIONS);
            return;
        }
        if (0, $cEKee.procedureIdSelected) (0, $cOK4N.preSelectProcedure)();
        if (0, $cEKee.staffId) {
            const checkStaffId = (0, $cEKee.form)?.staff?.findIndex((staff)=>staff.id === +(0, $cEKee.staffId));
            if (checkStaffId >= 0) {
                await (0, $a5XF8.fetchProcedureByStaff)(+(0, $cEKee.staffId));
                (0, $sFKcc.loadSelectSearchProcedure)((0, $cEKee.procedures));
            }
        }
        if (service === 'surgical') {
            if (appointmentRequestType === (0, $cIxq8.APPOINTMENT_REQUEST_CALENDAR)) {
                if (0, $cEKee.appointmentChannelId) $a82b117199549e31$var$handleProcedureSelection();
                else if ((0, $ig8jH.isPageHidden)('patient_page', (0, $cEKee.hiddenPages))) (0, $lmlIJ.patientContinueBtnHandler)();
                else {
                    (0, $lmlIJ.patientListeners)();
                    $a82b117199549e31$export$ff7962acd6052c28((0, $cIxq8.SCREEN).PATIENTS);
                }
            } else $a82b117199549e31$export$ff7962acd6052c28((0, $cIxq8.SCREEN).REQUEST_CONSULT);
        } else if (appointmentRequestType === (0, $cIxq8.APPOINTMENT_REQUEST_CALENDAR)) {
            if (0, $cEKee.appointmentChannelId) $a82b117199549e31$var$handleProcedureSelection();
            else if ((0, $ig8jH.isPageHidden)('patient_page', (0, $cEKee.hiddenPages))) (0, $lmlIJ.patientContinueBtnHandler)();
            else {
                (0, $lmlIJ.patientListeners)();
                $a82b117199549e31$export$ff7962acd6052c28((0, $cIxq8.SCREEN).PATIENTS);
            }
        } else $a82b117199549e31$export$ff7962acd6052c28((0, $cIxq8.SCREEN).REQUEST_CONSULT);
    }
}
const $a82b117199549e31$var$handleProcedureSelection = ()=>{
    let foundProcedure = (0, $cEKee.procedures).find((p)=>p?.id === +(0, $cEKee.procedureIdSelected));
    if (!foundProcedure && !(0, $cEKee.appointmentChannelId)) $a82b117199549e31$export$ff7962acd6052c28((0, $cIxq8.SCREEN).SURGICAL);
    else {
        if (foundProcedure || (0, $cEKee.form)?.procedures?.length === 1) {
            foundProcedure = (0, $cEKee.proceduresOfAppointmentChannel)[0];
            (0, $cEKee.setSurgicalOption)(Boolean(foundProcedure.surgical));
            (0, $cEKee.setPatientSelected)(foundProcedure.type);
            (0, $cEKee.setSelectedProcedures)([
                foundProcedure.id
            ]);
        }
        $a82b117199549e31$var$handleClickContinueServiceBtn();
    }
};
const $a82b117199549e31$var$handleClickContinueServiceBtn = async ()=>{
    if (0, $cEKee.staffId) {
        const foundProvider = (0, $cEKee.providers)?.find((i)=>i?.id === +(0, $cEKee.staffId));
        const getLocationId = foundProvider?.location_ids?.includes((0, $cEKee.selectedLocation)) || foundProvider?.location_ids[0];
        (0, $cEKee.setSelectedLocation)(getLocationId);
        (0, $a5XF8.handleSelectProvider)(null, +(0, $cEKee.staffId) || foundProvider?.id);
        (0, $a5XF8.handleProviderContinueBtn)();
    } else {
        if ((0, $cEKee.selectedProcedures).length > 0) {
            let res = await (0, $3UENa.getProceduresStaffByProcedureIds)((0, $cEKee.selectedProcedures));
            (0, $cEKee.setStaffProcedures)(res?.data?.data || []);
        }
        if ((0, $cEKee.locations)?.length === 1) {
            (0, $cEKee.setSelectedLocation)((0, $cEKee.locations)[0]?.id);
            (0, $hGWxM.handleLocationPage)();
        } else $a82b117199549e31$export$ff7962acd6052c28((0, $cIxq8.SCREEN).LOCATIONS);
    }
};
function $a82b117199549e31$export$f2aa1c67b71925f0(targetInput) {
    const fakeInput = document.createElement('input');
    fakeInput.setAttribute('type', 'tel');
    fakeInput.setAttribute('inputmode', 'tel');
    fakeInput.style.position = 'absolute';
    fakeInput.style.opacity = 0;
    fakeInput.style.height = 0;
    fakeInput.style.fontSize = '16px';
    document.body.prepend(fakeInput);
    fakeInput.focus();
    setTimeout(()=>{
        targetInput.focus();
        fakeInput.remove();
    }, 400);
}
function $a82b117199549e31$var$handleCheckProjectCategory() {
    if (0, $cEKee.showMaleFemalePage) {
        (0, $bLott.selectGenderListeners)();
        $a82b117199549e31$export$ff7962acd6052c28((0, $cIxq8.SCREEN).SELECT_GENDER);
    } else if (0, $cEKee.showBodyAreaSelection) {
        (0, $d6VOC.renderbodySelectionUI)((0, $cEKee.selectedGender) || 'non-binary');
        (0, $4Le5k.bodyAreaSelectionListeners)();
        $a82b117199549e31$export$ff7962acd6052c28((0, $cIxq8.SCREEN).BODY_AREA_SELECTION);
    } else (0, $cEKee.staffId) ? (0, $a5XF8.handleSelectProvider)() : $a82b117199549e31$export$3a0acffdefec7ad9();
}
function $a82b117199549e31$export$3a0acffdefec7ad9() {
    if ((0, $cEKee.isInInstantQuote) && (0, $cEKee.locations)?.length > 1) {
        $a82b117199549e31$export$ff7962acd6052c28((0, $cIxq8.SCREEN).LOCATIONS);
        return;
    }
    // Auto-select soonest provider: never show the provider screen; engage the
    // existing "any provider" (-1) path so the server assigns the soonest provider.
    if ((0, $cEKee.isAutoSelectSoonestProviderEnabled)()) {
        (0, $cEKee.setStaffId)(-1);
        (0, $a5XF8.handleSelectProvider)(null, -1);
        (0, $a5XF8.handleProviderContinueBtn)();
        return;
    }
    if ((0, $cEKee.providers).length > 0 && (0, $cEKee.staffId) === 0) {
        (0, $cEKee.setSelectedLocation)((0, $cEKee.locations)[0].id);
        (0, $hprW2.loadProviderList)((0, $cEKee.providers).filter((provider)=>provider.location_ids?.includes((0, $cEKee.selectedLocation))));
        (0, $62LVp.renderContinueBtn)();
        (0, $a5XF8.providerListeners)();
        $a82b117199549e31$export$ff7962acd6052c28((0, $cIxq8.SCREEN).PROVIDERS);
    } else if (0, $cEKee.isInInstantQuote) {
        (0, $8QS3m.loadCategories)((0, $a5XF8.filterProcedures)((0, $cEKee.procedures)));
        (0, $d0tLC.loadProcedures)((0, $a5XF8.filterProcedures)((0, $cEKee.procedures)));
        $a82b117199549e31$export$ff7962acd6052c28((0, $cIxq8.SCREEN).SEE_ALL_SERVICES);
    }
}
const $a82b117199549e31$export$fbff1ffc5f9e64ec = ()=>{
    const ids = (0, $cEKee.form)?.appointment_channel?.staffs?.map((i)=>i.id);
    let listProvider = (0, $cEKee.providers).filter((provider)=>ids.includes(provider.id));
    listProvider = listProvider.filter((provider)=>provider.location_ids?.includes((0, $cEKee.selectedLocation)));
    (0, $hprW2.loadProviderList)(listProvider);
    document.querySelector('.providers__container')?.classList?.add('provider-in-booking');
    (0, $62LVp.renderContinueBtn)();
    (0, $a5XF8.providerListeners)();
    document.querySelector('.providers__container .providerBack__btn')?.classList?.add('hiden');
    if (0, $cEKee.appointmentChannelId) document.querySelector('.providers__container .providerContinue__btn ')?.classList?.add('hide');
    $a82b117199549e31$export$ff7962acd6052c28((0, $cIxq8.SCREEN).PROVIDERS);
};
function $a82b117199549e31$export$f5d37b22a37ae152(isFromAppointmentChannel = false) {
    let providers = [];
    if (isFromAppointmentChannel) providers = (0, $cEKee.form).appointment_channel?.staffs?.filter((provider)=>provider?.online_booking);
    else providers = (0, $cEKee.form).staff;
    const sortedProviders = (providers || []).sort((a, b)=>Number(a?.order) - Number(b?.order));
    (0, $cEKee.setProviders)(Object.values(sortedProviders));
    (0, $cEKee.setOriginProviders)(Object.values(sortedProviders));
}

});
parcelRegister("cIxq8", function(module, exports) {

$parcel$export(module.exports, "SCREEN", () => $942384b840e564a6$export$f636b5b56f1d624a);
$parcel$export(module.exports, "MOBILE_SCREEN", () => $942384b840e564a6$export$c6064f55c4ae4962);
$parcel$export(module.exports, "DESKTOP_SCREEN", () => $942384b840e564a6$export$6b4e448d728230a7);
$parcel$export(module.exports, "ADDONS_SELECT_TYPE", () => $942384b840e564a6$export$e290a18c3e9f9651);
$parcel$export(module.exports, "countriesNotSupported", () => $942384b840e564a6$export$2dc806bc8d890ce5);
$parcel$export(module.exports, "countriesPrioritized", () => $942384b840e564a6$export$dd10d3971c7f862e);
$parcel$export(module.exports, "OPEN", () => $942384b840e564a6$export$bb29a81b503a982c);
$parcel$export(module.exports, "CLOSE", () => $942384b840e564a6$export$8a54946d138ed125);
$parcel$export(module.exports, "HIDE", () => $942384b840e564a6$export$7a302b3efb32a64b);
$parcel$export(module.exports, "EVENT_MESSAGE", () => $942384b840e564a6$export$d09687bcc0ac2500);
$parcel$export(module.exports, "PROCEDURE_SELECTION_TYPE", () => $942384b840e564a6$export$aad293c9a2b377a3);
$parcel$export(module.exports, "PATIENT_TYPE", () => $942384b840e564a6$export$5da75c2991b55770);
$parcel$export(module.exports, "APPOINTMENT_DATE_RANGE", () => $942384b840e564a6$export$314a72b892760a8e);
$parcel$export(module.exports, "ESTIMATE_ID_PARAM", () => $942384b840e564a6$export$84ff1006dbf158b1);
$parcel$export(module.exports, "EVENT_ID_PARAM", () => $942384b840e564a6$export$2439b783724eea6b);
$parcel$export(module.exports, "UPLOAD_ID_PARAM", () => $942384b840e564a6$export$538ad595b3239d91);
$parcel$export(module.exports, "NEW_LEAD_UPLOAD", () => $942384b840e564a6$export$488544ed68025e90);
$parcel$export(module.exports, "IGNORE_IFRAME", () => $942384b840e564a6$export$20067a4bc56e191b);
$parcel$export(module.exports, "HIDE_WIDGET", () => $942384b840e564a6$export$f31efa83acbbd7c4);
$parcel$export(module.exports, "BOOK_APPOINTMENT_PARAM", () => $942384b840e564a6$export$718040dcf1ef3cd1);
$parcel$export(module.exports, "OPEN_BOOK_APPOINTMENT_MODAL", () => $942384b840e564a6$export$193d6ef79251f22d);
$parcel$export(module.exports, "FULL_PAGE", () => $942384b840e564a6$export$76d52ffe66008cad);
$parcel$export(module.exports, "ESTIMATE", () => $942384b840e564a6$export$cc48173a725c2d0c);
$parcel$export(module.exports, "APPOINTMENT_CHANNEL_ID", () => $942384b840e564a6$export$e8030c191bf8f652);
$parcel$export(module.exports, "DROPOFF_RESUME_PARAM", () => $942384b840e564a6$export$6d572d54a08e0fd0);
$parcel$export(module.exports, "UPDATE_APPOINTMENT_CHANNEL", () => $942384b840e564a6$export$7971739733e5b34d);
$parcel$export(module.exports, "ACTION_PARAM", () => $942384b840e564a6$export$e3e9b530a1dc4a3c);
$parcel$export(module.exports, "APPOINTMENT_ACTIONS", () => $942384b840e564a6$export$42275cc269899421);
$parcel$export(module.exports, "APPOINTMENT_REQUEST_FORM", () => $942384b840e564a6$export$de2d5e49f6d1e364);
$parcel$export(module.exports, "APPOINTMENT_REQUEST_CALENDAR", () => $942384b840e564a6$export$5e8c066485721cb3);
$parcel$export(module.exports, "HOST_TYPE_ONE_ON_ONE", () => $942384b840e564a6$export$12887f207b40b25c);
$parcel$export(module.exports, "HOST_TYPE_ROUND_ROBIN", () => $942384b840e564a6$export$60af00c473f58a34);
$parcel$export(module.exports, "HOST_TYPE_COLLECTIVE", () => $942384b840e564a6$export$ff0228611058ea1c);
/* Screens */ const $942384b840e564a6$export$f636b5b56f1d624a = {
    DASHBOARD: 'dashboard',
    ASK_QUESTION: 'ask_a_question',
    FAQS: 'faqs',
    THE_END: 'theEnd',
    REQUEST_CONSULT: 'schedule_consultation',
    CONSULT_DOB: 'consult_dob',
    WIDGET: 'widget',
    SEE_ALL_SERVICES: 'see_all_services',
    INSTANT_QUOTE: 'instant_quote',
    PROCEDURE_ELIGIBILITY: 'procedure_eligibility',
    CATEGORIES: 'categories',
    PROVIDERS: 'providers',
    SERVICES_IFRAME: 'service_iframe',
    TOP_QUESTION: 'top_question',
    LOCATIONS: 'locations',
    NON_SURGICAL_SERVICES: 'non_surgical_services',
    CONSULT_SUMMARY: 'consult_summary',
    CONSULT_SUMMARY_QUESTION: 'consult_summary_question',
    TEXT_US: 'text_us',
    CONSULT_SCHEDULING: 'consult_scheduling',
    PROVIDER_SCHEDULING: 'provider_scheduling',
    SERVICE_SUMMARY: 'service_summary',
    INTERESTS: 'interests',
    FULL_NAME: 'fullNames',
    EMAIL: 'email',
    PHONE: 'phone',
    INSTANT_QUOTE_SUMMARY: 'instant_quote_summary',
    BOOK_APPOINTMENT: 'book_appointment',
    SURGICAL: 'surgical',
    VALIDATE_DIGITS: 'validate_digits',
    SELECT_TIME: 'select_time',
    SELECT_ONLY_TIME: 'select_only_time',
    SELECT_ONLY_DATE: 'select_only_date',
    MAIN_MENU: 'mainMenu__container',
    REGISTER_NEW_PATIENT: 'register-new-patient',
    ADDRESS_COLLECTION: 'address-collection',
    APPOINTMENT_SUMMARY: 'appointment-summary',
    CARD_COLLECTION: 'card-collection',
    APPOINTMENT_CONFIRMED: 'appointment-confirmed',
    UPLOAD_PHOTOS: 'upload_photos',
    TEXTAREA_QUESTION: 'textarea_question',
    TEXT_QUESTION: 'text_question',
    SELECT_QUESTION: 'select_question',
    CHECKBOX_QUESTION: 'checkbox_question',
    DATE_QUESTION: 'date_question',
    NUMBER_QUESTION: 'number_question',
    SELECT_GENDER: 'select_gender',
    HEIGHT_QUESTION: 'height_question',
    BODY_AREA_SELECTION: 'body_area_selection',
    VERIFY_INFORMATION: 'verifyInformation',
    ALL_QUESTIONS: 'all_questions',
    PATIENTS: 'patients',
    DELIVERY_MODE: 'delivery_mode',
    NOTFOUND_APPOINTMENT: 'notfound_appointment',
    CALLUS: 'callus',
    APPOINTMENT_CANCEL: 'appointment_cancel',
    APPOINTMENT_RESCHEDULE: 'appointment_reschedule',
    APPOINTMENT_RESCHEDULE_REASON: 'appointment_reschedule_reason'
};
const $942384b840e564a6$export$c6064f55c4ae4962 = window.innerWidth < 576;
const $942384b840e564a6$export$6b4e448d728230a7 = window.innerWidth >= 1025;
const $942384b840e564a6$export$e290a18c3e9f9651 = {
    MULTI_SELECT: 'multi_select',
    SINGLE_SELECT: 'single_select'
};
const $942384b840e564a6$export$2dc806bc8d890ce5 = [
    'AC',
    'BQ',
    'GP',
    'MF',
    'NC',
    'PM',
    'RE',
    'SH',
    'SJ',
    'TA',
    'WF',
    'YT'
];
const $942384b840e564a6$export$dd10d3971c7f862e = [
    'US',
    'GB',
    'BR',
    'FR',
    'MX'
];
const $942384b840e564a6$export$756ea882743223a2 = {
    LIGHT: 'light',
    DARK: 'dark'
};
const $942384b840e564a6$export$bb29a81b503a982c = 'open';
const $942384b840e564a6$export$8a54946d138ed125 = 'close';
const $942384b840e564a6$export$7a302b3efb32a64b = 'hide';
const $942384b840e564a6$export$2d452de57541c2ad = {
    GET_PRICING: 'Get Pricing',
    REQUEST_CONSULTATION: 'Request Consultation',
    BOOK_APPOINTMENT: 'Book Appointment'
};
const $942384b840e564a6$export$d09687bcc0ac2500 = {
    REFRESH: 'refresh',
    DASHBOARD: 'dashboard',
    ASK_QUESTION: 'ask_a_question',
    THE_END: 'theEnd',
    REQUEST_CONSULT: 'schedule_consultation',
    WIDGET: 'widget',
    SEE_ALL_SERVICES: 'see_all_services',
    INSTANT_QUOTE: 'instant_quote',
    PROCEDURE_ELIGIBILITY: 'procedure_eligibility',
    PROVIDERS: 'providers',
    SERVICES_IFRAME: 'service_iframe',
    TOP_QUESTION: 'top_question',
    LOCATIONS: 'locations',
    NON_SURGICAL_SERVICES: 'non_surgical_services',
    CONSULT_SUMMARY: 'consult_summary',
    TEXT_US: 'text_us',
    FINISH_LOADING: 'finishLoading',
    FINISH_LOADING_IFRAME: 'finishLoadIframe',
    SELECT_GENDER: 'select_gender',
    BOOK_APPOINTMENT: 'book_appointment',
    BOOK_APPOINTMENT_MODAL: 'book_appointment_modal',
    TOGGLE_WIDGET: 'toggle_widget',
    OPEN_BOOK_APPOINTMENT_FLOW: 'open_book_appointment_flow',
    DISABLE_SCROLL: 'disable_scroll',
    ENABLE_SCROLL: 'enable_scroll',
    WIDGET_OPEN: 'widget_open'
};
const $942384b840e564a6$export$aad293c9a2b377a3 = {
    MULTI: 'multi',
    SINGLE: 'single'
};
const $942384b840e564a6$export$5da75c2991b55770 = {
    NEW_PATIENT: 'new-user',
    EXISTING: 'existing-user'
};
const $942384b840e564a6$export$6a85f574272410cb = 'https://storage.googleapis.com/pilotpractice-files/';
const $942384b840e564a6$export$314a72b892760a8e = 60;
const $942384b840e564a6$export$84ff1006dbf158b1 = 'estimate_id';
const $942384b840e564a6$export$2439b783724eea6b = 'event_id';
const $942384b840e564a6$export$538ad595b3239d91 = 'upload_id';
const $942384b840e564a6$export$488544ed68025e90 = 'upload';
const $942384b840e564a6$export$20067a4bc56e191b = 'ignore_iframe';
const $942384b840e564a6$export$5e6a3db9bff2e1ba = 'plastic_surgery';
const $942384b840e564a6$export$9f29bcaefd74b5ea = 'IS_LOAD_INSTANCE_QUOTE';
const $942384b840e564a6$export$f31efa83acbbd7c4 = 'hide_widget';
const $942384b840e564a6$export$718040dcf1ef3cd1 = 'book_appointment';
const $942384b840e564a6$export$193d6ef79251f22d = 'open__book_appointment_modal';
const $942384b840e564a6$export$76d52ffe66008cad = 'full_page';
const $942384b840e564a6$export$cc48173a725c2d0c = 'estimate';
const $942384b840e564a6$export$e8030c191bf8f652 = 'appointment_channel_id';
const $942384b840e564a6$export$6d572d54a08e0fd0 = 'dropoff_resume';
const $942384b840e564a6$export$7971739733e5b34d = 'updating';
const $942384b840e564a6$export$e3e9b530a1dc4a3c = 'action';
const $942384b840e564a6$export$42275cc269899421 = {
    CANCEL: 'cancel',
    RESCHEDULE: 'reschedule'
};
const $942384b840e564a6$export$de2d5e49f6d1e364 = 'form';
const $942384b840e564a6$export$5e8c066485721cb3 = 'calendar';
const $942384b840e564a6$export$12887f207b40b25c = 'one_on_one';
const $942384b840e564a6$export$60af00c473f58a34 = 'round_robin';
const $942384b840e564a6$export$ff0228611058ea1c = 'collective';

});

parcelRegister("cEKee", function(module, exports) {

$parcel$export(module.exports, "access_token", () => $936d147d7554e7ea$export$21cc1b2869ca026f);
$parcel$export(module.exports, "procedures", () => $936d147d7554e7ea$export$2b37a78bd182cf56);
$parcel$export(module.exports, "procedureId", () => $936d147d7554e7ea$export$8706035957f3fe10);
$parcel$export(module.exports, "countriesConsult", () => $936d147d7554e7ea$export$53c9d8a86c8d8b19);
$parcel$export(module.exports, "countriesAskQs", () => $936d147d7554e7ea$export$23f8ccba759705f6);
$parcel$export(module.exports, "countriesPhone", () => $936d147d7554e7ea$export$ca346a5f662fafbc);
$parcel$export(module.exports, "selectedCountry", () => $936d147d7554e7ea$export$d4024968ac37e486);
$parcel$export(module.exports, "selectedCodeNumber", () => $936d147d7554e7ea$export$dc211a099cc7f8f7);
$parcel$export(module.exports, "categories", () => $936d147d7554e7ea$export$2c76aca27257bcfa);
$parcel$export(module.exports, "redirectUrl", () => $936d147d7554e7ea$export$8bd32f43e6170583);
$parcel$export(module.exports, "webAssistantOptions", () => $936d147d7554e7ea$export$6c9233fa4daf00c);
$parcel$export(module.exports, "selectedProcedures", () => $936d147d7554e7ea$export$1d14e8eb3308e9de);
$parcel$export(module.exports, "selectedAddons", () => $936d147d7554e7ea$export$99499856eb1b93e4);
$parcel$export(module.exports, "providers", () => $936d147d7554e7ea$export$ccb2d1cc7ff715f5);
$parcel$export(module.exports, "originProviders", () => $936d147d7554e7ea$export$f1065fb5d877dfe5);
$parcel$export(module.exports, "originProcedures", () => $936d147d7554e7ea$export$d89b1f7f16e1d417);
$parcel$export(module.exports, "providerId", () => $936d147d7554e7ea$export$dbd5cc87ba9d6044);
$parcel$export(module.exports, "noPreferenceSelected", () => $936d147d7554e7ea$export$2e3ebba6a5ff8aa1);
$parcel$export(module.exports, "primaryColor", () => $936d147d7554e7ea$export$920341819d1fcda9);
$parcel$export(module.exports, "tooltip", () => $936d147d7554e7ea$export$4e6f96734dfe12f4);
$parcel$export(module.exports, "picture", () => $936d147d7554e7ea$export$1188214e9d38144e);
$parcel$export(module.exports, "locations", () => $936d147d7554e7ea$export$c2de8e0aab246379);
$parcel$export(module.exports, "locationId", () => $936d147d7554e7ea$export$9cc80391908b7363);
$parcel$export(module.exports, "scheduling", () => $936d147d7554e7ea$export$db91f62ac6eecc05);
$parcel$export(module.exports, "selectedLocation", () => $936d147d7554e7ea$export$5201463d03db65db);
$parcel$export(module.exports, "emailOptin", () => $936d147d7554e7ea$export$df9e7734f66e1ef0);
$parcel$export(module.exports, "phoneToCall", () => $936d147d7554e7ea$export$29f56256763a0b2e);
$parcel$export(module.exports, "form", () => $936d147d7554e7ea$export$6210fa4921d2a466);
$parcel$export(module.exports, "optionNames", () => $936d147d7554e7ea$export$effe79c4d2671adf);
$parcel$export(module.exports, "optionIcons", () => $936d147d7554e7ea$export$4e8734f1392470d8);
$parcel$export(module.exports, "widgetOptions", () => $936d147d7554e7ea$export$ea3264d2d623c576);
$parcel$export(module.exports, "formId", () => $936d147d7554e7ea$export$756156c2678845b2);
$parcel$export(module.exports, "staffId", () => $936d147d7554e7ea$export$b0086aff553c64fc);
$parcel$export(module.exports, "appUrl", () => $936d147d7554e7ea$export$625c2ae8ba020e36);
$parcel$export(module.exports, "procedureSelectionType", () => $936d147d7554e7ea$export$4bfcf809c431f08f);
$parcel$export(module.exports, "providerServiceSummary", () => $936d147d7554e7ea$export$f666299f50169b65);
$parcel$export(module.exports, "leadInfo", () => $936d147d7554e7ea$export$e589febb55df344);
$parcel$export(module.exports, "sourceParam", () => $936d147d7554e7ea$export$979592a903ddc724);
$parcel$export(module.exports, "visitorId", () => $936d147d7554e7ea$export$41bbaf3aab6b79c);
$parcel$export(module.exports, "selectedInterest", () => $936d147d7554e7ea$export$78c04edc2df10a7);
$parcel$export(module.exports, "interests", () => $936d147d7554e7ea$export$a29da57c7428098b);
$parcel$export(module.exports, "fullName", () => $936d147d7554e7ea$export$1d6cfa7493842c29);
$parcel$export(module.exports, "email", () => $936d147d7554e7ea$export$d290fa47940df19d);
$parcel$export(module.exports, "emailCheck", () => $936d147d7554e7ea$export$a30a5c4df63a24e7);
$parcel$export(module.exports, "phone", () => $936d147d7554e7ea$export$58ee0ea85d7a10b9);
$parcel$export(module.exports, "estimateInfo", () => $936d147d7554e7ea$export$47a889a479113fa3);
$parcel$export(module.exports, "isInInstantQuote", () => $936d147d7554e7ea$export$3ca5576cada1df2f);
$parcel$export(module.exports, "surgicalOption", () => $936d147d7554e7ea$export$6ffb261128c8deb1);
$parcel$export(module.exports, "isBookAppointment", () => $936d147d7554e7ea$export$33c27d83e6daad12);
$parcel$export(module.exports, "limitRightCarousel", () => $936d147d7554e7ea$export$5729173e65a42d6b);
$parcel$export(module.exports, "pagesDom", () => $936d147d7554e7ea$export$67c5d13aea60006);
$parcel$export(module.exports, "appointmentDateRange", () => $936d147d7554e7ea$export$24d306e87b265a2f);
$parcel$export(module.exports, "currentDateInUse", () => $936d147d7554e7ea$export$10403fdd3afca70e);
$parcel$export(module.exports, "carouselCountLeft", () => $936d147d7554e7ea$export$e82592ba6932b62f);
$parcel$export(module.exports, "isClickCheckBox", () => $936d147d7554e7ea$export$c59457f050ff01e6);
$parcel$export(module.exports, "isOTPTimeOut", () => $936d147d7554e7ea$export$b09c41c00821bf37);
$parcel$export(module.exports, "selectedAppointmentUnixTime", () => $936d147d7554e7ea$export$db7e57d5df394cf7);
$parcel$export(module.exports, "appointmentSummary", () => $936d147d7554e7ea$export$94266950ad79a364);
$parcel$export(module.exports, "eventPayload", () => $936d147d7554e7ea$export$89897f4d7e891019);
$parcel$export(module.exports, "eventId", () => $936d147d7554e7ea$export$aed28df7ac07d79a);
$parcel$export(module.exports, "appointmentDuration", () => $936d147d7554e7ea$export$eaaffbfebb502667);
$parcel$export(module.exports, "leadTextId", () => $936d147d7554e7ea$export$a4fcf475a512f7ef);
$parcel$export(module.exports, "customField", () => $936d147d7554e7ea$export$82c8c2cee582a640);
$parcel$export(module.exports, "customFields", () => $936d147d7554e7ea$export$aa45fd790825bd5d);
$parcel$export(module.exports, "fileUploadChannel", () => $936d147d7554e7ea$export$2fbd0ac33831ebfe);
$parcel$export(module.exports, "financing", () => $936d147d7554e7ea$export$f8d33fd9686aa43b);
$parcel$export(module.exports, "nameScreenDynamic", () => $936d147d7554e7ea$export$572349647eed34e6);
$parcel$export(module.exports, "listDataQuestion", () => $936d147d7554e7ea$export$34c7d7183bf9337d);
$parcel$export(module.exports, "listNamePageQuestion", () => $936d147d7554e7ea$export$7ef9e3726d7ffa55);
$parcel$export(module.exports, "firstQuestion", () => $936d147d7554e7ea$export$75a7bae8e6290c62);
$parcel$export(module.exports, "appointmentQuestionsCompleted", () => $936d147d7554e7ea$export$80aa718cf0df7897);
$parcel$export(module.exports, "questionnaireFields", () => $936d147d7554e7ea$export$cb9b880014e8f67d);
$parcel$export(module.exports, "questionnaireFormId", () => $936d147d7554e7ea$export$b1bd65275c949b1);
$parcel$export(module.exports, "selectedDateElement", () => $936d147d7554e7ea$export$de90ab88932d5445);
$parcel$export(module.exports, "selectedDatetime", () => $936d147d7554e7ea$export$c6dae5998c3fde36);
$parcel$export(module.exports, "selectedGender", () => $936d147d7554e7ea$export$8c5dee042cb090ae);
$parcel$export(module.exports, "eventRoom", () => $936d147d7554e7ea$export$439c74407cf0c880);
$parcel$export(module.exports, "consultationNonSurgicalPath", () => $936d147d7554e7ea$export$e1bf5795dda1b1bb);
$parcel$export(module.exports, "businessName", () => $936d147d7554e7ea$export$c4be9150db87d0c5);
$parcel$export(module.exports, "requestsGetSlotsTime", () => $936d147d7554e7ea$export$f10462b529434b88);
$parcel$export(module.exports, "nextRequestsGetSlotsTime", () => $936d147d7554e7ea$export$3f71b5ebd8a3fe41);
$parcel$export(module.exports, "showMaleFemalePage", () => $936d147d7554e7ea$export$735081ad78ca3fbb);
$parcel$export(module.exports, "progressQuestion", () => $936d147d7554e7ea$export$384c57b3dae7d290);
$parcel$export(module.exports, "staffProcedures", () => $936d147d7554e7ea$export$fae0ab6f5bf5f621);
$parcel$export(module.exports, "hidePricing", () => $936d147d7554e7ea$export$89dc19c33cdf29e0);
$parcel$export(module.exports, "skipInterestPage", () => $936d147d7554e7ea$export$4a3eeb74aa67b3b3);
$parcel$export(module.exports, "hideFutureSpecialsOptIn", () => $936d147d7554e7ea$export$f41624d3f418204a);
$parcel$export(module.exports, "showBodyAreaSelection", () => $936d147d7554e7ea$export$ee3b5c3b4bd567c5);
$parcel$export(module.exports, "bodyAreaSelected", () => $936d147d7554e7ea$export$fa2979807c1906b8);
$parcel$export(module.exports, "isModalPopup", () => $936d147d7554e7ea$export$312fed6421172618);
$parcel$export(module.exports, "projectId", () => $936d147d7554e7ea$export$e4bb003b4e7478a);
$parcel$export(module.exports, "patientSelected", () => $936d147d7554e7ea$export$6708be5b2877e7c7);
$parcel$export(module.exports, "selectedDeliveryMode", () => $936d147d7554e7ea$export$a7a34d4074acdd59);
$parcel$export(module.exports, "procedureIdSelected", () => $936d147d7554e7ea$export$a772016dbd7f2d0a);
$parcel$export(module.exports, "isDesktopVer", () => $936d147d7554e7ea$export$f3404ec2e18f1091);
$parcel$export(module.exports, "appointmentChannelId", () => $936d147d7554e7ea$export$e320b1b4aa778245);
$parcel$export(module.exports, "proceduresOfAppointmentChannel", () => $936d147d7554e7ea$export$f262b7d67c7f47d6);
$parcel$export(module.exports, "showSubscribedToOffersOption", () => $936d147d7554e7ea$export$662ec86199efc81a);
$parcel$export(module.exports, "selectedStaffAppointmentChannel", () => $936d147d7554e7ea$export$e0b69df04b8f0601);
$parcel$export(module.exports, "a2pConsentEnabled", () => $936d147d7554e7ea$export$572b7856662905cb);
$parcel$export(module.exports, "smsConsentTransactional", () => $936d147d7554e7ea$export$4ea6daf0a8fc2bcd);
$parcel$export(module.exports, "smsConsentPromotional", () => $936d147d7554e7ea$export$b4101eb519e7da73);
$parcel$export(module.exports, "termsAndPrivacyAccepted", () => $936d147d7554e7ea$export$aefe235cb995663c);
$parcel$export(module.exports, "isDisableSearchService", () => $936d147d7554e7ea$export$990e767c3a3dbc3b);
$parcel$export(module.exports, "isHiddenOnMobile", () => $936d147d7554e7ea$export$d8b47560443e4bda);
$parcel$export(module.exports, "isHiddenOnDesktop", () => $936d147d7554e7ea$export$ea42d1aea98f4578);
$parcel$export(module.exports, "selectedLocationId", () => $936d147d7554e7ea$export$9dfade5b294bdf9a);
$parcel$export(module.exports, "isHiddenPoweredBy", () => $936d147d7554e7ea$export$1f38455aba73c205);
$parcel$export(module.exports, "isWhitelabel", () => $936d147d7554e7ea$export$981105f0c1bf1520);
$parcel$export(module.exports, "isHideServiceDuration", () => $936d147d7554e7ea$export$14b41854e7c0a593);
$parcel$export(module.exports, "hiddenPages", () => $936d147d7554e7ea$export$4815d7fe1421f583);
$parcel$export(module.exports, "selectedLanguage", () => $936d147d7554e7ea$export$8d5a188d4295ebbb);
$parcel$export(module.exports, "shouldCollectPatientInfoFirstForWidget", () => $936d147d7554e7ea$export$44a7b45bcf9372f3);
$parcel$export(module.exports, "isFlowForCalendar", () => $936d147d7554e7ea$export$681855d4025a6d35);
$parcel$export(module.exports, "assignedStaffId", () => $936d147d7554e7ea$export$b81bf9d54bbd7028);
$parcel$export(module.exports, "initUI", () => $936d147d7554e7ea$export$538086cfe5d4570);
$parcel$export(module.exports, "tempLeadInfo", () => $936d147d7554e7ea$export$a4818ced93782893);
$parcel$export(module.exports, "setVisitorId", () => $936d147d7554e7ea$export$3e9081028a7ebcb7);
$parcel$export(module.exports, "setTooltip", () => $936d147d7554e7ea$export$92d4e20e0acb0b06);
$parcel$export(module.exports, "setPicture", () => $936d147d7554e7ea$export$425247eb8e3c1809);
$parcel$export(module.exports, "setLeadInfo", () => $936d147d7554e7ea$export$7d3e16ba8e650904);
$parcel$export(module.exports, "setAppointmentQuestionsCompleted", () => $936d147d7554e7ea$export$591f5193e49cce54);
$parcel$export(module.exports, "setQuestionnaireFields", () => $936d147d7554e7ea$export$f7dd582a01aada48);
$parcel$export(module.exports, "setQuestionnaireFormId", () => $936d147d7554e7ea$export$90db71fb715fdb88);
$parcel$export(module.exports, "clearQuestionnaireContext", () => $936d147d7554e7ea$export$ab0691d9dc09a0c9);
$parcel$export(module.exports, "setProcedureSelectionType", () => $936d147d7554e7ea$export$678b23c6386e0895);
$parcel$export(module.exports, "setAppUrl", () => $936d147d7554e7ea$export$b25fc0b379189cbb);
$parcel$export(module.exports, "setFormId", () => $936d147d7554e7ea$export$5c3d205f63ea473d);
$parcel$export(module.exports, "setStaffId", () => $936d147d7554e7ea$export$67884c907624e9fc);
$parcel$export(module.exports, "setProcedures", () => $936d147d7554e7ea$export$22b05a7ad9335c3);
$parcel$export(module.exports, "setRedirectUrl", () => $936d147d7554e7ea$export$1a2d62cc2d441a17);
$parcel$export(module.exports, "setCalendarRedirectUrl", () => $936d147d7554e7ea$export$b6b8dcf5b5549966);
$parcel$export(module.exports, "getCalendarRedirectUrl", () => $936d147d7554e7ea$export$e619152e8a283874);
$parcel$export(module.exports, "setCategories", () => $936d147d7554e7ea$export$5094e6521d9d77b5);
$parcel$export(module.exports, "setWebAssistantOptions", () => $936d147d7554e7ea$export$4bae4da9e5933a1a);
$parcel$export(module.exports, "setSelectedProcedures", () => $936d147d7554e7ea$export$f3cad2657cc6a5b4);
$parcel$export(module.exports, "setSelectedAddons", () => $936d147d7554e7ea$export$f69b5f33c3fa7a32);
$parcel$export(module.exports, "setCountriesConsult", () => $936d147d7554e7ea$export$5d2521aeba555174);
$parcel$export(module.exports, "setCountriesAskQs", () => $936d147d7554e7ea$export$e17179140e5c0076);
$parcel$export(module.exports, "setCountriesPhone", () => $936d147d7554e7ea$export$990c694f1f27a4c9);
$parcel$export(module.exports, "setSelectedCountry", () => $936d147d7554e7ea$export$da004da7546aa9d5);
$parcel$export(module.exports, "setSelectedCodeNumber", () => $936d147d7554e7ea$export$ae7e9dec1af2cd0);
$parcel$export(module.exports, "setProcedureId", () => $936d147d7554e7ea$export$12f659fb473fb5a8);
$parcel$export(module.exports, "setProviders", () => $936d147d7554e7ea$export$1525c0a2e0e58b1c);
$parcel$export(module.exports, "setOriginProviders", () => $936d147d7554e7ea$export$f0153a5cb3d554c7);
$parcel$export(module.exports, "setOriginProcedures", () => $936d147d7554e7ea$export$ed34fd3350fe51df);
$parcel$export(module.exports, "setProviderId", () => $936d147d7554e7ea$export$4d21e64afff0067e);
$parcel$export(module.exports, "setNoPreferenceSelected", () => $936d147d7554e7ea$export$180a1130c8986f40);
$parcel$export(module.exports, "setPrimaryColor", () => $936d147d7554e7ea$export$feb169734af636fb);
$parcel$export(module.exports, "setLocations", () => $936d147d7554e7ea$export$f82642d46cfbc06e);
$parcel$export(module.exports, "setInterests", () => $936d147d7554e7ea$export$119213c099c58877);
$parcel$export(module.exports, "setLocationId", () => $936d147d7554e7ea$export$4e64ef38b8934ff6);
$parcel$export(module.exports, "setSelectedLocation", () => $936d147d7554e7ea$export$e1139c89de44e2ba);
$parcel$export(module.exports, "setSelectedCategoryId", () => $936d147d7554e7ea$export$e513443b56bb8a37);
$parcel$export(module.exports, "setSelectedInterest", () => $936d147d7554e7ea$export$848bf0b3c2c7aad4);
$parcel$export(module.exports, "setEmailOptin", () => $936d147d7554e7ea$export$17d962a4645908df);
$parcel$export(module.exports, "setPhoneToCall", () => $936d147d7554e7ea$export$b39b638f434db77d);
$parcel$export(module.exports, "setForm", () => $936d147d7554e7ea$export$7d3e561073017b20);
$parcel$export(module.exports, "isAutoSelectSoonestProviderEnabled", () => $936d147d7554e7ea$export$1575f7ece802874b);
$parcel$export(module.exports, "setOptionNames", () => $936d147d7554e7ea$export$338cb702950422b);
$parcel$export(module.exports, "setOptionIcons", () => $936d147d7554e7ea$export$dae3d0ea77011dfb);
$parcel$export(module.exports, "setWidgetOptions", () => $936d147d7554e7ea$export$ff649cf9b965f06e);
$parcel$export(module.exports, "setFullName", () => $936d147d7554e7ea$export$4e1144162530b288);
$parcel$export(module.exports, "setEmail", () => $936d147d7554e7ea$export$ece24ec2321c6615);
$parcel$export(module.exports, "setEmailCheck", () => $936d147d7554e7ea$export$fb094c66fb3f1476);
$parcel$export(module.exports, "setPhone", () => $936d147d7554e7ea$export$ae8138d3f3853e8d);
$parcel$export(module.exports, "typedIdentity", () => $936d147d7554e7ea$export$d422b4daf6242dae);
$parcel$export(module.exports, "setEstimateInfo", () => $936d147d7554e7ea$export$ef1acef5f5f41060);
$parcel$export(module.exports, "setIsInstantQuote", () => $936d147d7554e7ea$export$7387afe5eec12d3e);
$parcel$export(module.exports, "setSurgicalOption", () => $936d147d7554e7ea$export$95448022a68b013f);
$parcel$export(module.exports, "setIsBookAppointment", () => $936d147d7554e7ea$export$c6bd753a3fdfeb19);
$parcel$export(module.exports, "setLimitRightCarousel", () => $936d147d7554e7ea$export$8f591cb0dec0de64);
$parcel$export(module.exports, "addPagesDom", () => $936d147d7554e7ea$export$c39bad7741296651);
$parcel$export(module.exports, "removeLastPagesDom", () => $936d147d7554e7ea$export$3fa6e350de39b267);
$parcel$export(module.exports, "resetPagesDom", () => $936d147d7554e7ea$export$f18465091ee5e6b5);
$parcel$export(module.exports, "setAppointmentDateRange", () => $936d147d7554e7ea$export$d5c94b772ad1ef47);
$parcel$export(module.exports, "setCurrentDateInUse", () => $936d147d7554e7ea$export$1f509029d088d3c4);
$parcel$export(module.exports, "setCarouselCountLeft", () => $936d147d7554e7ea$export$5cfdd16164d9b479);
$parcel$export(module.exports, "setIsClickCheckBox", () => $936d147d7554e7ea$export$e14fee16f8f261f3);
$parcel$export(module.exports, "setIsOTPTimeOut", () => $936d147d7554e7ea$export$61521aecfd367698);
$parcel$export(module.exports, "setSelectedAppointmentUnixTime", () => $936d147d7554e7ea$export$e0633b149da1f0ce);
$parcel$export(module.exports, "setAppointmentSummary", () => $936d147d7554e7ea$export$9fb9a86e3455a067);
$parcel$export(module.exports, "setEventPayload", () => $936d147d7554e7ea$export$47f6f7cfb5001f22);
$parcel$export(module.exports, "setEventId", () => $936d147d7554e7ea$export$e476319954670819);
$parcel$export(module.exports, "setAppointmentDuration", () => $936d147d7554e7ea$export$17c143516542544e);
$parcel$export(module.exports, "setLeadTextId", () => $936d147d7554e7ea$export$dd698878152e402b);
$parcel$export(module.exports, "setCustomField", () => $936d147d7554e7ea$export$74fe72d73147ae5e);
$parcel$export(module.exports, "setCustomFields", () => $936d147d7554e7ea$export$8a48360a9bcfa5fc);
$parcel$export(module.exports, "setFileUploadChannel", () => $936d147d7554e7ea$export$8c28a845506f045d);
$parcel$export(module.exports, "preQuestionnairePhotosDone", () => $936d147d7554e7ea$export$883936a3c2a66187);
$parcel$export(module.exports, "setPreQuestionnairePhotosDone", () => $936d147d7554e7ea$export$a075fa90f7a68190);
$parcel$export(module.exports, "consultDobStepDone", () => $936d147d7554e7ea$export$4906d785048f57e9);
$parcel$export(module.exports, "setConsultDobStepDone", () => $936d147d7554e7ea$export$ddb635a52610ef6a);
$parcel$export(module.exports, "setFinancing", () => $936d147d7554e7ea$export$a7c4471481dff6a6);
$parcel$export(module.exports, "setNameScreenDynamic", () => $936d147d7554e7ea$export$a24bb7b446032447);
$parcel$export(module.exports, "setListDataQuestion", () => $936d147d7554e7ea$export$d4ab1fce4c055fbf);
$parcel$export(module.exports, "setListNamePageQuestion", () => $936d147d7554e7ea$export$aab42330fef91fbd);
$parcel$export(module.exports, "setFirstQuestion", () => $936d147d7554e7ea$export$93154aa09312d9b3);
$parcel$export(module.exports, "setSelectedDateElement", () => $936d147d7554e7ea$export$bf8ebf37fe92d97b);
$parcel$export(module.exports, "setSelectedDatetime", () => $936d147d7554e7ea$export$ece006ba240716b0);
$parcel$export(module.exports, "setSelectedGender", () => $936d147d7554e7ea$export$df14d362ce37c11b);
$parcel$export(module.exports, "setEventRoom", () => $936d147d7554e7ea$export$b231c27782a8d157);
$parcel$export(module.exports, "setConsultationNonSurgicalPath", () => $936d147d7554e7ea$export$94e3abff6c293ab5);
$parcel$export(module.exports, "setBusinessName", () => $936d147d7554e7ea$export$a8fac873d7103eee);
$parcel$export(module.exports, "setRequestsGetSlotsTime", () => $936d147d7554e7ea$export$1b8b73387989d48c);
$parcel$export(module.exports, "setNextRequestsGetSlotsTime", () => $936d147d7554e7ea$export$373310640372823d);
$parcel$export(module.exports, "setShowMaleFemalePage", () => $936d147d7554e7ea$export$e6b576d1945053bb);
$parcel$export(module.exports, "setProgressQuestion", () => $936d147d7554e7ea$export$80f031059e6da39c);
$parcel$export(module.exports, "setStaffProcedures", () => $936d147d7554e7ea$export$e33daa79e3744c7b);
$parcel$export(module.exports, "setDataSlot", () => $936d147d7554e7ea$export$9bb0d3f4710c3f0b);
$parcel$export(module.exports, "setHidePricing", () => $936d147d7554e7ea$export$339997f23a662b07);
$parcel$export(module.exports, "setShowBodyAreaSelection", () => $936d147d7554e7ea$export$ce89955a3568cca1);
$parcel$export(module.exports, "setBodyAreaSelected", () => $936d147d7554e7ea$export$7b897402418dfcfd);
$parcel$export(module.exports, "setIsModalPopup", () => $936d147d7554e7ea$export$749b4d9846468161);
$parcel$export(module.exports, "setHasLead", () => $936d147d7554e7ea$export$748d568d01844c88);
$parcel$export(module.exports, "setProjectId", () => $936d147d7554e7ea$export$b3b5d26bd744f328);
$parcel$export(module.exports, "setPatientSelected", () => $936d147d7554e7ea$export$fd9681a64f739d88);
$parcel$export(module.exports, "setSelectedDeliveryMode", () => $936d147d7554e7ea$export$612db335e4763de3);
$parcel$export(module.exports, "setAccessToken", () => $936d147d7554e7ea$export$9bfe7023cfca0786);
$parcel$export(module.exports, "otpAccessToken", () => $936d147d7554e7ea$export$668b4f50475fe09c);
$parcel$export(module.exports, "setOtpAccessToken", () => $936d147d7554e7ea$export$28a32ecf491a6bba);
$parcel$export(module.exports, "setProcedureIdSelected", () => $936d147d7554e7ea$export$3f6e42aadbdc4079);
$parcel$export(module.exports, "setIsDesktopVer", () => $936d147d7554e7ea$export$2dc953754f30434d);
$parcel$export(module.exports, "setAppointmentChannelId", () => $936d147d7554e7ea$export$42389b2da30aa9a0);
$parcel$export(module.exports, "setProceduresOfAppointmentChannel", () => $936d147d7554e7ea$export$65be5ef0635a93b3);
$parcel$export(module.exports, "scopeProceduresToSelectedLocation", () => $936d147d7554e7ea$export$6580549c522556ea);
$parcel$export(module.exports, "setShowSubscribedToOffersOption", () => $936d147d7554e7ea$export$c53b11279c9741a7);
$parcel$export(module.exports, "setSkipInterestPage", () => $936d147d7554e7ea$export$b286a2ea45d92d63);
$parcel$export(module.exports, "setHideFutureSpecialsOptIn", () => $936d147d7554e7ea$export$c2d5f60e810f39cb);
$parcel$export(module.exports, "setSelectedStaffAppointmentChannel", () => $936d147d7554e7ea$export$c141b1e88659027);
$parcel$export(module.exports, "setSmsConsentTransactional", () => $936d147d7554e7ea$export$57e4140cef82ebb8);
$parcel$export(module.exports, "setSmsConsentPromotional", () => $936d147d7554e7ea$export$1c6fdd914c41fd35);
$parcel$export(module.exports, "setTermsAndPrivacyAccepted", () => $936d147d7554e7ea$export$42696779217dc5ad);
$parcel$export(module.exports, "setIsDisableSearchService", () => $936d147d7554e7ea$export$b457c7367d00fc71);
$parcel$export(module.exports, "setIsHiddenOnDesktop", () => $936d147d7554e7ea$export$cf99b7a3c5c361f4);
$parcel$export(module.exports, "setIsHiddenOnMobile", () => $936d147d7554e7ea$export$41fc911838fb6132);
$parcel$export(module.exports, "setSelectedLocationId", () => $936d147d7554e7ea$export$1394c384f87ca4a6);
$parcel$export(module.exports, "setIsHiddenPoweredBy", () => $936d147d7554e7ea$export$3636f1ab014388a7);
$parcel$export(module.exports, "setIsWhitelabel", () => $936d147d7554e7ea$export$6efa87a0637a9662);
$parcel$export(module.exports, "setIsHideServiceDuration", () => $936d147d7554e7ea$export$4a0426d8fef12e8c);
$parcel$export(module.exports, "setHiddenPages", () => $936d147d7554e7ea$export$7bc15c292d7528bf);
$parcel$export(module.exports, "setSelectedLanguage", () => $936d147d7554e7ea$export$8147cb6aa3eeadd4);
$parcel$export(module.exports, "setShouldCollectPatientInfoFirstForWidget", () => $936d147d7554e7ea$export$6fb79d35e32110eb);
$parcel$export(module.exports, "setIsFlowForCalendar", () => $936d147d7554e7ea$export$d2dcab61cd1e1bb6);
$parcel$export(module.exports, "setAssignedStaffId", () => $936d147d7554e7ea$export$868be97c6d742ac5);
$parcel$export(module.exports, "setInitUI", () => $936d147d7554e7ea$export$e93ef6f96ec6199b);
$parcel$export(module.exports, "setTempLeadInfo", () => $936d147d7554e7ea$export$5ec7c123c41e4033);
$parcel$export(module.exports, "setA2pConsentEnabled", () => $936d147d7554e7ea$export$48ab3686340cfba2);

var $cIxq8 = parcelRequire("cIxq8");
var $936d147d7554e7ea$export$21cc1b2869ca026f = '';
var $936d147d7554e7ea$export$99236bcc5d577ca5 = false;
var $936d147d7554e7ea$export$517113b01f92f5fe = (0, $cIxq8.SCREEN).DASHBOARD;
var $936d147d7554e7ea$export$fb47414b7f22a309 = null;
var $936d147d7554e7ea$export$2b37a78bd182cf56 = [];
var $936d147d7554e7ea$export$8706035957f3fe10 = null;
var $936d147d7554e7ea$export$53c9d8a86c8d8b19 = (0, $cIxq8.CLOSE);
var $936d147d7554e7ea$export$23f8ccba759705f6 = (0, $cIxq8.CLOSE);
var $936d147d7554e7ea$export$ca346a5f662fafbc = (0, $cIxq8.CLOSE);
var $936d147d7554e7ea$export$d4024968ac37e486 = 'US';
var $936d147d7554e7ea$export$dc211a099cc7f8f7 = '1';
var $936d147d7554e7ea$export$2c76aca27257bcfa = [];
var $936d147d7554e7ea$export$8bd32f43e6170583 = '';
var $936d147d7554e7ea$export$e1c2bfb561c51def = '';
var $936d147d7554e7ea$export$6c9233fa4daf00c = [];
var $936d147d7554e7ea$export$1d14e8eb3308e9de = [];
var $936d147d7554e7ea$export$99499856eb1b93e4 = [];
var $936d147d7554e7ea$export$580fd90acb1561ff = false;
var $936d147d7554e7ea$export$ccb2d1cc7ff715f5 = [];
var $936d147d7554e7ea$export$f1065fb5d877dfe5 = [];
var $936d147d7554e7ea$export$d89b1f7f16e1d417 = [];
var $936d147d7554e7ea$export$dbd5cc87ba9d6044 = '';
var $936d147d7554e7ea$export$2e3ebba6a5ff8aa1 = false;
var $936d147d7554e7ea$export$985623e0eea0b581 = [];
var $936d147d7554e7ea$export$920341819d1fcda9 = '';
var $936d147d7554e7ea$export$4e6f96734dfe12f4 = '';
var $936d147d7554e7ea$export$1188214e9d38144e = '';
var $936d147d7554e7ea$export$c2de8e0aab246379 = [];
var $936d147d7554e7ea$export$9cc80391908b7363 = '';
var $936d147d7554e7ea$export$db91f62ac6eecc05 = 0;
var $936d147d7554e7ea$export$5201463d03db65db = '';
var $936d147d7554e7ea$export$78368e9f8571c52d = '';
var $936d147d7554e7ea$export$df9e7734f66e1ef0 = false;
var $936d147d7554e7ea$export$29f56256763a0b2e = '';
var $936d147d7554e7ea$export$6210fa4921d2a466 = {};
var $936d147d7554e7ea$export$effe79c4d2671adf = {};
var $936d147d7554e7ea$export$4e8734f1392470d8 = {};
var $936d147d7554e7ea$export$ea3264d2d623c576 = [];
var $936d147d7554e7ea$export$756156c2678845b2 = '';
var $936d147d7554e7ea$export$b0086aff553c64fc = 0;
var $936d147d7554e7ea$export$625c2ae8ba020e36 = '';
var $936d147d7554e7ea$export$bd25287c41e91a91 = '';
var $936d147d7554e7ea$export$4bfcf809c431f08f = '';
var $936d147d7554e7ea$export$adfca638bebe93b2 = 0;
var $936d147d7554e7ea$export$80a1c2a49279f0a5 = 0;
var $936d147d7554e7ea$export$f666299f50169b65 = {};
var $936d147d7554e7ea$export$18e744c3f56ff61 = {};
var $936d147d7554e7ea$export$e589febb55df344 = null;
var $936d147d7554e7ea$export$979592a903ddc724 = '';
var $936d147d7554e7ea$export$41bbaf3aab6b79c = '';
var $936d147d7554e7ea$export$78c04edc2df10a7 = '';
var $936d147d7554e7ea$export$a29da57c7428098b = [];
var $936d147d7554e7ea$export$1d6cfa7493842c29 = '';
var $936d147d7554e7ea$export$d290fa47940df19d = '';
var $936d147d7554e7ea$export$a30a5c4df63a24e7 = false;
var $936d147d7554e7ea$export$58ee0ea85d7a10b9 = '';
var $936d147d7554e7ea$export$47a889a479113fa3 = {};
var $936d147d7554e7ea$export$3ca5576cada1df2f = false;
var $936d147d7554e7ea$export$6ffb261128c8deb1 = null;
var $936d147d7554e7ea$export$33c27d83e6daad12 = false;
var $936d147d7554e7ea$export$5729173e65a42d6b = 0;
var $936d147d7554e7ea$export$67c5d13aea60006 = [];
var $936d147d7554e7ea$export$24d306e87b265a2f = {};
var $936d147d7554e7ea$export$10403fdd3afca70e = 0;
var $936d147d7554e7ea$export$e82592ba6932b62f = 0;
var $936d147d7554e7ea$export$c59457f050ff01e6 = false;
var $936d147d7554e7ea$export$b09c41c00821bf37 = true;
var $936d147d7554e7ea$export$db7e57d5df394cf7 = '';
var $936d147d7554e7ea$export$94266950ad79a364 = {};
var $936d147d7554e7ea$export$89897f4d7e891019 = {};
var $936d147d7554e7ea$export$aed28df7ac07d79a = null;
var $936d147d7554e7ea$export$eaaffbfebb502667 = 0;
var $936d147d7554e7ea$export$a4fcf475a512f7ef = null;
var $936d147d7554e7ea$export$82c8c2cee582a640 = {};
var $936d147d7554e7ea$export$aa45fd790825bd5d = [];
var $936d147d7554e7ea$export$2fbd0ac33831ebfe = [];
var $936d147d7554e7ea$export$f8d33fd9686aa43b = [];
var $936d147d7554e7ea$export$572349647eed34e6 = '';
var $936d147d7554e7ea$export$3043319d48beed73 = false;
var $936d147d7554e7ea$export$34c7d7183bf9337d = {};
var $936d147d7554e7ea$export$7ef9e3726d7ffa55 = [];
var $936d147d7554e7ea$export$75a7bae8e6290c62 = false;
var $936d147d7554e7ea$export$80aa718cf0df7897 = false;
var $936d147d7554e7ea$export$cb9b880014e8f67d = null;
var $936d147d7554e7ea$export$b1bd65275c949b1 = null;
var $936d147d7554e7ea$export$de90ab88932d5445 = null;
var $936d147d7554e7ea$export$c6dae5998c3fde36 = null;
var $936d147d7554e7ea$export$8c5dee042cb090ae = null;
var $936d147d7554e7ea$export$439c74407cf0c880 = null;
var $936d147d7554e7ea$export$e1bf5795dda1b1bb = null;
var $936d147d7554e7ea$export$c4be9150db87d0c5 = '';
var $936d147d7554e7ea$export$f10462b529434b88 = [];
var $936d147d7554e7ea$export$3f71b5ebd8a3fe41 = [];
var $936d147d7554e7ea$export$735081ad78ca3fbb = false;
var $936d147d7554e7ea$export$384c57b3dae7d290 = {};
var $936d147d7554e7ea$export$fae0ab6f5bf5f621 = null;
var $936d147d7554e7ea$export$459febae41a3d770 = {};
var $936d147d7554e7ea$export$89dc19c33cdf29e0 = false;
var $936d147d7554e7ea$export$4a3eeb74aa67b3b3 = false;
var $936d147d7554e7ea$export$f41624d3f418204a = false;
var $936d147d7554e7ea$export$ee3b5c3b4bd567c5 = false;
var $936d147d7554e7ea$export$fa2979807c1906b8 = [];
var $936d147d7554e7ea$export$312fed6421172618 = false;
var $936d147d7554e7ea$export$5a44184e7d58560c = false;
var $936d147d7554e7ea$export$e4bb003b4e7478a = null;
var $936d147d7554e7ea$export$6708be5b2877e7c7 = null;
var $936d147d7554e7ea$export$a7a34d4074acdd59 = null;
var $936d147d7554e7ea$export$a772016dbd7f2d0a = null;
var $936d147d7554e7ea$export$f3404ec2e18f1091 = false;
var $936d147d7554e7ea$export$e320b1b4aa778245 = null;
var $936d147d7554e7ea$export$f262b7d67c7f47d6 = null;
var $936d147d7554e7ea$export$662ec86199efc81a = null;
var $936d147d7554e7ea$export$e0b69df04b8f0601 = null;
var $936d147d7554e7ea$export$41335685e1c67e99 = false;
var $936d147d7554e7ea$export$572b7856662905cb = false;
var $936d147d7554e7ea$export$4ea6daf0a8fc2bcd = false;
var $936d147d7554e7ea$export$b4101eb519e7da73 = false;
var $936d147d7554e7ea$export$aefe235cb995663c = false;
var $936d147d7554e7ea$export$990e767c3a3dbc3b = false;
var $936d147d7554e7ea$export$d8b47560443e4bda = false;
var $936d147d7554e7ea$export$ea42d1aea98f4578 = false;
var $936d147d7554e7ea$export$9dfade5b294bdf9a = null;
var $936d147d7554e7ea$export$1f38455aba73c205 = false;
var $936d147d7554e7ea$export$981105f0c1bf1520 = false;
var $936d147d7554e7ea$export$14b41854e7c0a593 = false;
var $936d147d7554e7ea$export$4815d7fe1421f583 = [];
var $936d147d7554e7ea$export$8d5a188d4295ebbb = 'en';
var $936d147d7554e7ea$export$44a7b45bcf9372f3 = false;
var $936d147d7554e7ea$export$681855d4025a6d35 = false;
var $936d147d7554e7ea$export$b81bf9d54bbd7028 = null;
var $936d147d7554e7ea$export$538086cfe5d4570 = 'floater';
var $936d147d7554e7ea$export$a4818ced93782893 = null;
function $936d147d7554e7ea$export$3e9081028a7ebcb7(val) {
    $936d147d7554e7ea$export$41bbaf3aab6b79c = val;
}
function $936d147d7554e7ea$export$92d4e20e0acb0b06(val) {
    $936d147d7554e7ea$export$4e6f96734dfe12f4 = val;
}
function $936d147d7554e7ea$export$425247eb8e3c1809(val) {
    $936d147d7554e7ea$export$1188214e9d38144e = val;
}
function $936d147d7554e7ea$export$c0e53150d1af2301(val) {
    $936d147d7554e7ea$export$979592a903ddc724 = val;
}
function $936d147d7554e7ea$export$7d3e16ba8e650904(val) {
    $936d147d7554e7ea$export$e589febb55df344 = val;
}
function $936d147d7554e7ea$export$591f5193e49cce54(val) {
    $936d147d7554e7ea$export$80aa718cf0df7897 = val;
}
function $936d147d7554e7ea$export$f7dd582a01aada48(val) {
    $936d147d7554e7ea$export$cb9b880014e8f67d = val;
}
function $936d147d7554e7ea$export$90db71fb715fdb88(val) {
    $936d147d7554e7ea$export$b1bd65275c949b1 = val;
}
function $936d147d7554e7ea$export$ab0691d9dc09a0c9() {
    $936d147d7554e7ea$export$cb9b880014e8f67d = null;
    $936d147d7554e7ea$export$b1bd65275c949b1 = null;
}
function $936d147d7554e7ea$export$7eb13f35a833eed6(val) {
    $936d147d7554e7ea$export$18e744c3f56ff61 = val;
}
function $936d147d7554e7ea$export$dd6bd2683c00785a(val) {
    $936d147d7554e7ea$export$f666299f50169b65 = val;
}
function $936d147d7554e7ea$export$e5d5e1c1822b6e56(start, end) {
    $936d147d7554e7ea$export$adfca638bebe93b2 = start;
    $936d147d7554e7ea$export$80a1c2a49279f0a5 = end;
}
function $936d147d7554e7ea$export$678b23c6386e0895(val) {
    $936d147d7554e7ea$export$4bfcf809c431f08f = val;
}
function $936d147d7554e7ea$export$d4bcaffc111d72e0(val) {
    $936d147d7554e7ea$export$bd25287c41e91a91 = val;
}
function $936d147d7554e7ea$export$b25fc0b379189cbb(val) {
    $936d147d7554e7ea$export$625c2ae8ba020e36 = val;
}
function $936d147d7554e7ea$export$5c3d205f63ea473d(val) {
    $936d147d7554e7ea$export$756156c2678845b2 = val;
}
function $936d147d7554e7ea$export$67884c907624e9fc(val) {
    $936d147d7554e7ea$export$b0086aff553c64fc = val;
}
function $936d147d7554e7ea$export$aa311a4215302e12(val) {
    $936d147d7554e7ea$export$99236bcc5d577ca5 = val;
}
function $936d147d7554e7ea$export$a364c5ef84862575(val) {
    $936d147d7554e7ea$export$517113b01f92f5fe = val;
}
function $936d147d7554e7ea$export$299b8ed5064518a7(val) {
    $936d147d7554e7ea$export$fb47414b7f22a309 = val;
}
function $936d147d7554e7ea$export$22b05a7ad9335c3(val) {
    $936d147d7554e7ea$export$2b37a78bd182cf56 = val;
}
function $936d147d7554e7ea$export$1a2d62cc2d441a17(val) {
    $936d147d7554e7ea$export$8bd32f43e6170583 = val;
}
function $936d147d7554e7ea$export$b6b8dcf5b5549966(val) {
    $936d147d7554e7ea$export$e1c2bfb561c51def = val;
}
function $936d147d7554e7ea$export$e619152e8a283874() {
    return $936d147d7554e7ea$export$e1c2bfb561c51def;
}
function $936d147d7554e7ea$export$5094e6521d9d77b5(val) {
    $936d147d7554e7ea$export$2c76aca27257bcfa = val;
}
function $936d147d7554e7ea$export$4bae4da9e5933a1a(val) {
    $936d147d7554e7ea$export$6c9233fa4daf00c = val;
}
function $936d147d7554e7ea$export$f3cad2657cc6a5b4(val) {
    $936d147d7554e7ea$export$1d14e8eb3308e9de = val;
}
function $936d147d7554e7ea$export$f69b5f33c3fa7a32(val) {
    $936d147d7554e7ea$export$99499856eb1b93e4 = val;
}
function $936d147d7554e7ea$export$5d2521aeba555174(val) {
    $936d147d7554e7ea$export$53c9d8a86c8d8b19 = val;
}
function $936d147d7554e7ea$export$e17179140e5c0076(val) {
    $936d147d7554e7ea$export$23f8ccba759705f6 = val;
}
function $936d147d7554e7ea$export$990c694f1f27a4c9(val) {
    $936d147d7554e7ea$export$ca346a5f662fafbc = val;
}
function $936d147d7554e7ea$export$da004da7546aa9d5(val) {
    $936d147d7554e7ea$export$d4024968ac37e486 = val;
}
function $936d147d7554e7ea$export$ae7e9dec1af2cd0(val) {
    $936d147d7554e7ea$export$dc211a099cc7f8f7 = val;
}
function $936d147d7554e7ea$export$12f659fb473fb5a8(val) {
    $936d147d7554e7ea$export$8706035957f3fe10 = val;
}
function $936d147d7554e7ea$export$171d3fb48907b6cf(val) {
    $936d147d7554e7ea$export$580fd90acb1561ff = val;
}
function $936d147d7554e7ea$export$1525c0a2e0e58b1c(val) {
    $936d147d7554e7ea$export$ccb2d1cc7ff715f5 = val;
}
function $936d147d7554e7ea$export$f0153a5cb3d554c7(val) {
    $936d147d7554e7ea$export$f1065fb5d877dfe5 = val;
}
function $936d147d7554e7ea$export$ed34fd3350fe51df(val) {
    $936d147d7554e7ea$export$d89b1f7f16e1d417 = val;
}
function $936d147d7554e7ea$export$4d21e64afff0067e(val) {
    $936d147d7554e7ea$export$dbd5cc87ba9d6044 = val;
}
function $936d147d7554e7ea$export$180a1130c8986f40(val) {
    $936d147d7554e7ea$export$2e3ebba6a5ff8aa1 = val;
}
function $936d147d7554e7ea$export$1ed55773ccdb58a(val) {
    $936d147d7554e7ea$export$985623e0eea0b581 = val;
}
function $936d147d7554e7ea$export$feb169734af636fb(val) {
    $936d147d7554e7ea$export$920341819d1fcda9 = val;
}
function $936d147d7554e7ea$export$f82642d46cfbc06e(val) {
    $936d147d7554e7ea$export$c2de8e0aab246379 = val;
}
function $936d147d7554e7ea$export$119213c099c58877(val) {
    $936d147d7554e7ea$export$a29da57c7428098b = val;
}
function $936d147d7554e7ea$export$4e64ef38b8934ff6(val) {
    $936d147d7554e7ea$export$9cc80391908b7363 = val;
}
function $936d147d7554e7ea$export$3b1f9a8b0f9b92ca(val) {
    $936d147d7554e7ea$export$db91f62ac6eecc05 = val;
}
function $936d147d7554e7ea$export$e1139c89de44e2ba(val) {
    $936d147d7554e7ea$export$5201463d03db65db = val;
}
function $936d147d7554e7ea$export$e513443b56bb8a37(val) {
    $936d147d7554e7ea$export$78368e9f8571c52d = val;
}
function $936d147d7554e7ea$export$848bf0b3c2c7aad4(val) {
    $936d147d7554e7ea$export$78c04edc2df10a7 = val;
}
function $936d147d7554e7ea$export$17d962a4645908df(val) {
    $936d147d7554e7ea$export$df9e7734f66e1ef0 = val;
}
function $936d147d7554e7ea$export$b39b638f434db77d(val) {
    $936d147d7554e7ea$export$29f56256763a0b2e = val;
}
function $936d147d7554e7ea$export$7d3e561073017b20(val) {
    $936d147d7554e7ea$export$6210fa4921d2a466 = val;
}
function $936d147d7554e7ea$export$1575f7ece802874b() {
    const channel = $936d147d7554e7ea$export$6210fa4921d2a466?.appointment_channel;
    if (!channel?.auto_select_soonest_provider) return false;
    if (channel?.auto_select_soonest_provider_new_patients_only && $936d147d7554e7ea$export$6708be5b2877e7c7 !== 'new_patient') return false;
    const onlineStaff = channel?.staffs?.filter((staff)=>staff?.online_booking) || [];
    return onlineStaff.length > 1;
}
function $936d147d7554e7ea$export$338cb702950422b(key, value) {
    $936d147d7554e7ea$export$effe79c4d2671adf[key] = value;
}
function $936d147d7554e7ea$export$dae3d0ea77011dfb(key, value) {
    $936d147d7554e7ea$export$4e8734f1392470d8[key] = value;
}
function $936d147d7554e7ea$export$ff649cf9b965f06e(val) {
    $936d147d7554e7ea$export$ea3264d2d623c576 = val;
}
function $936d147d7554e7ea$export$4e1144162530b288(val) {
    $936d147d7554e7ea$export$1d6cfa7493842c29 = val;
}
function $936d147d7554e7ea$export$ece24ec2321c6615(val) {
    $936d147d7554e7ea$export$d290fa47940df19d = val;
}
function $936d147d7554e7ea$export$fb094c66fb3f1476(val) {
    $936d147d7554e7ea$export$a30a5c4df63a24e7 = val;
}
function $936d147d7554e7ea$export$ae8138d3f3853e8d(val) {
    $936d147d7554e7ea$export$58ee0ea85d7a10b9 = val;
}
function $936d147d7554e7ea$export$d422b4daf6242dae() {
    const nameFromDom = (typeof document !== 'undefined' ? document.querySelector('#nameConsult')?.value : '') || '';
    const emailFromDom = (typeof document !== 'undefined' ? document.querySelector('#emailConsult')?.value : '') || '';
    const phoneFromDom = (typeof document !== 'undefined' ? document.querySelector('#phoneConsult')?.value : '') || '';
    const nameSource = (nameFromDom || $936d147d7554e7ea$export$1d6cfa7493842c29 || '').trim();
    const emailSource = (emailFromDom || $936d147d7554e7ea$export$d290fa47940df19d || '').trim();
    const phoneSource = (phoneFromDom || $936d147d7554e7ea$export$58ee0ea85d7a10b9 || '').trim();
    const nameParts = nameSource.split(/\s+/).filter(Boolean);
    return {
        ...nameParts[0] && {
            first_name: nameParts[0]
        },
        ...nameParts.length > 1 && {
            last_name: nameParts.slice(1).join(' ')
        },
        ...emailSource && {
            email: emailSource
        },
        ...phoneSource && {
            phone: phoneSource
        }
    };
}
function $936d147d7554e7ea$export$ef1acef5f5f41060(val) {
    $936d147d7554e7ea$export$47a889a479113fa3 = val;
}
function $936d147d7554e7ea$export$7387afe5eec12d3e(val) {
    $936d147d7554e7ea$export$3ca5576cada1df2f = val;
}
function $936d147d7554e7ea$export$95448022a68b013f(val) {
    $936d147d7554e7ea$export$6ffb261128c8deb1 = val;
}
function $936d147d7554e7ea$export$c6bd753a3fdfeb19(val) {
    $936d147d7554e7ea$export$33c27d83e6daad12 = val;
}
function $936d147d7554e7ea$export$8f591cb0dec0de64(val) {
    $936d147d7554e7ea$export$5729173e65a42d6b = val;
}
function $936d147d7554e7ea$export$c39bad7741296651(val) {
    $936d147d7554e7ea$export$67c5d13aea60006.push(val);
}
function $936d147d7554e7ea$export$3fa6e350de39b267() {
    $936d147d7554e7ea$export$67c5d13aea60006.pop();
}
function $936d147d7554e7ea$export$f18465091ee5e6b5() {
    let temp = $936d147d7554e7ea$export$67c5d13aea60006[0];
    $936d147d7554e7ea$export$67c5d13aea60006.forEach((element)=>{
        element.style.zIndex = '1';
    });
    $936d147d7554e7ea$export$67c5d13aea60006 = [];
    temp.style.zIndex = '2';
    $936d147d7554e7ea$export$c39bad7741296651(temp);
}
function $936d147d7554e7ea$export$d5c94b772ad1ef47(val) {
    $936d147d7554e7ea$export$24d306e87b265a2f = val;
}
function $936d147d7554e7ea$export$1f509029d088d3c4(val) {
    $936d147d7554e7ea$export$10403fdd3afca70e = val;
}
function $936d147d7554e7ea$export$5cfdd16164d9b479(val) {
    $936d147d7554e7ea$export$e82592ba6932b62f = val;
}
function $936d147d7554e7ea$export$e14fee16f8f261f3(val) {
    $936d147d7554e7ea$export$c59457f050ff01e6 = val;
}
function $936d147d7554e7ea$export$61521aecfd367698(val) {
    $936d147d7554e7ea$export$b09c41c00821bf37 = val;
}
function $936d147d7554e7ea$export$e0633b149da1f0ce(val) {
    $936d147d7554e7ea$export$db7e57d5df394cf7 = val;
}
function $936d147d7554e7ea$export$9fb9a86e3455a067(val) {
    $936d147d7554e7ea$export$94266950ad79a364 = val;
}
function $936d147d7554e7ea$export$47f6f7cfb5001f22(val) {
    $936d147d7554e7ea$export$89897f4d7e891019 = val;
}
function $936d147d7554e7ea$export$e476319954670819(val) {
    $936d147d7554e7ea$export$aed28df7ac07d79a = val;
}
function $936d147d7554e7ea$export$17c143516542544e(val) {
    $936d147d7554e7ea$export$eaaffbfebb502667 = val;
}
function $936d147d7554e7ea$export$dd698878152e402b(val) {
    $936d147d7554e7ea$export$a4fcf475a512f7ef = val;
}
function $936d147d7554e7ea$export$74fe72d73147ae5e(val) {
    $936d147d7554e7ea$export$82c8c2cee582a640 = val;
}
function $936d147d7554e7ea$export$8a48360a9bcfa5fc(val) {
    $936d147d7554e7ea$export$aa45fd790825bd5d = val;
}
function $936d147d7554e7ea$export$8c28a845506f045d(val) {
    $936d147d7554e7ea$export$2fbd0ac33831ebfe = val;
}
var $936d147d7554e7ea$export$883936a3c2a66187 = false;
function $936d147d7554e7ea$export$a075fa90f7a68190(val) {
    $936d147d7554e7ea$export$883936a3c2a66187 = val;
}
var $936d147d7554e7ea$export$4906d785048f57e9 = false;
function $936d147d7554e7ea$export$ddb635a52610ef6a(val) {
    $936d147d7554e7ea$export$4906d785048f57e9 = val;
}
function $936d147d7554e7ea$export$a7c4471481dff6a6(val) {
    $936d147d7554e7ea$export$f8d33fd9686aa43b = val;
}
function $936d147d7554e7ea$export$a24bb7b446032447(val) {
    $936d147d7554e7ea$export$572349647eed34e6 = val;
}
function $936d147d7554e7ea$export$d4ab1fce4c055fbf(val) {
    $936d147d7554e7ea$export$34c7d7183bf9337d = val;
}
function $936d147d7554e7ea$export$aab42330fef91fbd(val) {
    $936d147d7554e7ea$export$7ef9e3726d7ffa55 = val;
}
function $936d147d7554e7ea$export$93154aa09312d9b3(val) {
    $936d147d7554e7ea$export$75a7bae8e6290c62 = val;
}
function $936d147d7554e7ea$export$bf8ebf37fe92d97b(val) {
    $936d147d7554e7ea$export$de90ab88932d5445 = val;
}
function $936d147d7554e7ea$export$ece006ba240716b0(val) {
    $936d147d7554e7ea$export$c6dae5998c3fde36 = val;
}
function $936d147d7554e7ea$export$df14d362ce37c11b(val) {
    $936d147d7554e7ea$export$8c5dee042cb090ae = val;
}
function $936d147d7554e7ea$export$b231c27782a8d157(val) {
    $936d147d7554e7ea$export$439c74407cf0c880 = val;
}
function $936d147d7554e7ea$export$94e3abff6c293ab5(val) {
    $936d147d7554e7ea$export$e1bf5795dda1b1bb = val;
}
function $936d147d7554e7ea$export$a8fac873d7103eee(val) {
    $936d147d7554e7ea$export$c4be9150db87d0c5 = val;
}
function $936d147d7554e7ea$export$1b8b73387989d48c(val) {
    $936d147d7554e7ea$export$f10462b529434b88 = val;
}
function $936d147d7554e7ea$export$373310640372823d(val) {
    $936d147d7554e7ea$export$3f71b5ebd8a3fe41 = val;
}
function $936d147d7554e7ea$export$e6b576d1945053bb(val) {
    $936d147d7554e7ea$export$735081ad78ca3fbb = val;
}
function $936d147d7554e7ea$export$80f031059e6da39c(val) {
    $936d147d7554e7ea$export$384c57b3dae7d290 = val;
}
function $936d147d7554e7ea$export$e33daa79e3744c7b(val) {
    $936d147d7554e7ea$export$fae0ab6f5bf5f621 = val;
}
function $936d147d7554e7ea$export$9bb0d3f4710c3f0b(val) {
    $936d147d7554e7ea$export$459febae41a3d770 = val;
}
function $936d147d7554e7ea$export$339997f23a662b07(val) {
    $936d147d7554e7ea$export$89dc19c33cdf29e0 = val;
}
function $936d147d7554e7ea$export$ce89955a3568cca1(val) {
    $936d147d7554e7ea$export$ee3b5c3b4bd567c5 = val;
}
function $936d147d7554e7ea$export$7b897402418dfcfd(val) {
    $936d147d7554e7ea$export$fa2979807c1906b8 = val;
}
function $936d147d7554e7ea$export$749b4d9846468161(val) {
    $936d147d7554e7ea$export$312fed6421172618 = val;
}
function $936d147d7554e7ea$export$748d568d01844c88(val) {
    $936d147d7554e7ea$export$5a44184e7d58560c = val;
}
function $936d147d7554e7ea$export$b3b5d26bd744f328(val) {
    $936d147d7554e7ea$export$e4bb003b4e7478a = val;
}
function $936d147d7554e7ea$export$fd9681a64f739d88(val) {
    $936d147d7554e7ea$export$6708be5b2877e7c7 = val;
}
function $936d147d7554e7ea$export$612db335e4763de3(val) {
    $936d147d7554e7ea$export$a7a34d4074acdd59 = val;
}
function $936d147d7554e7ea$export$9bfe7023cfca0786(val) {
    $936d147d7554e7ea$export$21cc1b2869ca026f = val;
}
var $936d147d7554e7ea$export$668b4f50475fe09c = null;
function $936d147d7554e7ea$export$28a32ecf491a6bba(val) {
    $936d147d7554e7ea$export$668b4f50475fe09c = val;
}
function $936d147d7554e7ea$export$3f6e42aadbdc4079(val) {
    $936d147d7554e7ea$export$a772016dbd7f2d0a = val;
}
function $936d147d7554e7ea$export$2dc953754f30434d(val) {
    $936d147d7554e7ea$export$f3404ec2e18f1091 = val;
}
function $936d147d7554e7ea$export$42389b2da30aa9a0(val) {
    $936d147d7554e7ea$export$e320b1b4aa778245 = val;
}
function $936d147d7554e7ea$export$65be5ef0635a93b3(val) {
    $936d147d7554e7ea$export$f262b7d67c7f47d6 = val;
}
function $936d147d7554e7ea$export$6580549c522556ea(list) {
    if (!$936d147d7554e7ea$export$e320b1b4aa778245 || !Array.isArray(list) || list.length === 0) return list;
    const hasLocationScoped = list.some((p)=>p && p.location_id != null);
    if (!hasLocationScoped || !$936d147d7554e7ea$export$5201463d03db65db) return list;
    const locationId = parseInt($936d147d7554e7ea$export$5201463d03db65db, 10);
    const matched = list.filter((p)=>p.location_id == null || parseInt(p.location_id, 10) === locationId);
    // Collapse residual duplicate service ids, preferring the location-specific row.
    const byId = new Map();
    for (const p of matched){
        const existing = byId.get(p.id);
        if (!existing || existing.location_id == null && p.location_id != null) byId.set(p.id, p);
    }
    return Array.from(byId.values());
}
function $936d147d7554e7ea$export$c53b11279c9741a7(val) {
    $936d147d7554e7ea$export$662ec86199efc81a = val;
}
function $936d147d7554e7ea$export$b286a2ea45d92d63(val) {
    $936d147d7554e7ea$export$4a3eeb74aa67b3b3 = val;
}
function $936d147d7554e7ea$export$c2d5f60e810f39cb(val) {
    $936d147d7554e7ea$export$f41624d3f418204a = val;
}
function $936d147d7554e7ea$export$c141b1e88659027(val) {
    $936d147d7554e7ea$export$e0b69df04b8f0601 = val;
}
function $936d147d7554e7ea$export$b20ef3b52f138e02(val) {
    $936d147d7554e7ea$export$41335685e1c67e99 = val;
}
function $936d147d7554e7ea$export$57e4140cef82ebb8(val) {
    $936d147d7554e7ea$export$4ea6daf0a8fc2bcd = val;
}
function $936d147d7554e7ea$export$1c6fdd914c41fd35(val) {
    $936d147d7554e7ea$export$b4101eb519e7da73 = val;
}
function $936d147d7554e7ea$export$42696779217dc5ad(val) {
    $936d147d7554e7ea$export$aefe235cb995663c = val;
}
function $936d147d7554e7ea$export$b457c7367d00fc71(val) {
    $936d147d7554e7ea$export$990e767c3a3dbc3b = val;
}
function $936d147d7554e7ea$export$cf99b7a3c5c361f4(val) {
    $936d147d7554e7ea$export$ea42d1aea98f4578 = val;
}
function $936d147d7554e7ea$export$41fc911838fb6132(val) {
    $936d147d7554e7ea$export$d8b47560443e4bda = val;
}
function $936d147d7554e7ea$export$1394c384f87ca4a6(val) {
    $936d147d7554e7ea$export$9dfade5b294bdf9a = val;
}
function $936d147d7554e7ea$export$3636f1ab014388a7(val) {
    $936d147d7554e7ea$export$1f38455aba73c205 = val;
}
function $936d147d7554e7ea$export$6efa87a0637a9662(val) {
    $936d147d7554e7ea$export$981105f0c1bf1520 = val;
}
function $936d147d7554e7ea$export$4a0426d8fef12e8c(val) {
    $936d147d7554e7ea$export$14b41854e7c0a593 = val;
}
function $936d147d7554e7ea$export$7bc15c292d7528bf(val) {
    $936d147d7554e7ea$export$4815d7fe1421f583 = val;
}
function $936d147d7554e7ea$export$8147cb6aa3eeadd4(val) {
    $936d147d7554e7ea$export$8d5a188d4295ebbb = val;
}
function $936d147d7554e7ea$export$6fb79d35e32110eb(val) {
    $936d147d7554e7ea$export$44a7b45bcf9372f3 = val;
}
function $936d147d7554e7ea$export$d2dcab61cd1e1bb6(val) {
    $936d147d7554e7ea$export$681855d4025a6d35 = val;
}
function $936d147d7554e7ea$export$868be97c6d742ac5(val) {
    $936d147d7554e7ea$export$b81bf9d54bbd7028 = val;
}
function $936d147d7554e7ea$export$e93ef6f96ec6199b(val) {
    $936d147d7554e7ea$export$538086cfe5d4570 = val;
}
function $936d147d7554e7ea$export$5ec7c123c41e4033(val) {
    $936d147d7554e7ea$export$a4818ced93782893 = val;
}
function $936d147d7554e7ea$export$48ab3686340cfba2(val) {
    $936d147d7554e7ea$export$572b7856662905cb = val;
}

});

parcelRegister("knjAn", function(module, exports) {

$parcel$export(module.exports, "translateServerError", () => $ed5525f880b55dda$export$6580432b72204576);
$parcel$export(module.exports, "t", () => $ed5525f880b55dda$export$625550452a3fa3ec);
$parcel$export(module.exports, "tDefault", () => $ed5525f880b55dda$export$920c7765ed6965d8);

var $cEKee = parcelRequire("cEKee");
const $ed5525f880b55dda$var$translations = {
    en: {
        // Common
        'required': 'Required',
        'optional': 'Optional',
        'continue': 'Continue',
        'back': 'Back',
        'close': 'Close',
        'submit': 'Submit',
        'save': 'Save',
        'cancel': 'Cancel',
        'processing': 'Processing...',
        'loading': 'Loading...',
        'copy': 'Copy',
        'apply': 'Apply',
        'yes': 'Yes',
        'no': 'No',
        'from': 'From',
        'to': 'to',
        'total': 'Total',
        'minutes': 'minutes',
        'minute': 'minute',
        // Navigation / Dashboard
        'instant_actions': 'Instant actions',
        'book_appointment': 'Book Appointment',
        'instant_quote': 'Instant Quote',
        'ask_question': 'Ask a Question',
        'call_us': 'Call Us',
        'text_us': 'Text Us',
        // Name / Contact fields
        'full_name': 'Full Name',
        'full_name_placeholder': 'Enter your full name',
        'first_name': 'First Name',
        'last_name': 'Last Name',
        'email': 'Email address',
        'email_placeholder': 'Enter your email address',
        'phone': 'Phone number',
        'phone_placeholder': 'Enter your phone number',
        'dob': 'Date of Birth',
        'month': 'Month',
        'day': 'Day',
        'year': 'Year',
        'dob_step_title': 'One last thing',
        'dob_step_subtitle': 'Please enter your date of birth to complete your request.',
        // Gender
        'gender': 'Gender',
        'select_gender': 'Select gender',
        'male': 'Male',
        'female': 'Female',
        'other': 'Other',
        'prefer_not_to_say': 'Prefer not to say',
        // Address
        'address': 'Address',
        'zip_code': 'ZIP Code',
        'zip_code_placeholder': 'Enter your ZIP code',
        // Insurance
        'insurance': 'What is your insurance? (if you have one)',
        // Location / Provider
        'select_location': 'Select a location',
        'select_provider': 'Select a provider',
        'no_preference': 'No preference',
        'any_provider': 'Any provider',
        'soonest_available': 'soonest available',
        'no_locations_found': 'No locations found',
        'no_providers_found': 'No Providers Found',
        'location': 'Location',
        // Services / Procedures
        'select_category': 'Select a category',
        'no_categories_found': 'No Categories Found',
        'no_procedures_found': 'No Procedures Found',
        'add_procedure': 'Add procedure',
        'services': 'Services',
        'consultation_required': 'Consultation required for an estimate',
        // Add-ons
        'select_addons': 'Select Add-Ons',
        'select_all_that_applies': 'Select all that applies',
        'only_one_addon': 'You can only select 1 addon',
        'no_addons': 'No Add-Ons',
        'apply_addons': 'Apply Add-Ons',
        // Scheduling
        'no_schedules_found': 'No Schedules found.',
        'all_booked': '{provider} all booked on this day',
        'choose_another_day': 'Choose another day to view open slots',
        'next_available': 'Next available slot is {date}',
        'time_unavailable': 'Time unavailable',
        'duration': 'Duration: {duration} {unit}',
        // Days of week (abbreviated)
        'day_mon': 'Mon',
        'day_tue': 'Tue',
        'day_wed': 'Wed',
        'day_thu': 'Thu',
        'day_fri': 'Fri',
        'day_sat': 'Sat',
        'day_sun': 'Sun',
        // Appointment status
        'confirmed': 'Confirmed',
        'pending': 'Pending',
        'complete': 'Complete',
        'cancelled': 'Cancelled',
        // Appointment cancel
        'why_cancelling': 'Why are you cancelling?',
        'cancel_reason_emergency': 'Emergency',
        'cancel_reason_conflict': 'Conflict',
        'cancel_reason_not_needed': 'Not needed',
        'cancel_reason_placeholder': 'Tell us your reason for cancelling...',
        'cancel_appointment': 'Cancel Appointment',
        'cancel_provide_reason': 'Please provide a reason for cancellation',
        'cancel_min_chars': 'Please provide at least 10 characters for the cancellation reason',
        'cancel_success': 'Appointment cancelled successfully',
        'cancel_failed': 'Failed to cancel appointment. Please try again.',
        // Appointment reschedule
        'why_rescheduling': 'Please tell us why',
        'reschedule_reason_conflict': 'Schedule conflict',
        'reschedule_reason_emergency': 'Emergency',
        'reschedule_reason_personal': 'Personal reasons',
        'reschedule_reason_placeholder': 'Tell us your reason for rescheduling...',
        'confirm_reschedule': 'Confirm Reschedule',
        'reschedule_provide_reason': 'Please provide a reason for rescheduling',
        'reschedule_min_chars': 'Please provide at least 10 characters for the reschedule reason',
        'reschedule_success': 'Appointment rescheduled successfully',
        'reschedule_failed': 'Failed to reschedule appointment. Please try again.',
        // Appointment summary
        'no_procedures_selected': 'No procedures selected',
        // How did you hear
        'how_did_you_hear': 'How did you hear about us?',
        // Another question
        'another_question': 'I have another question',
        // Language
        'select_language': 'Select language',
        'language_english': 'English',
        'language_spanish': 'Spanish',
        'preferred_language': 'Preferred Language',
        // Upload
        'upload': 'Upload',
        // Height
        'feet': 'Ft',
        'inches': 'In',
        // Consult summary
        'total_services': 'Total ({count} services)',
        // Custom field
        'custom_field': 'Custom field',
        'select_an_option': 'Select an option',
        // Addons summary
        'addons_count': '+{count} addons',
        // Consult summary
        'free': 'Free',
        'consult_fee_applied': 'Consult fee is applied to service costs',
        // Staff info panel
        'meet_with': 'Meet with',
        'no_staffs': 'No staffs',
        'no_services': 'No services',
        'duration_label': 'Duration',
        'appointment_type': 'Appointment Type',
        'description': 'Description',
        'provider': 'Provider',
        'providers': 'Providers',
        'phone_label': 'Phone',
        'office_hours': 'Office Hours',
        'get_directions': 'Get directions',
        'services_available': 'services available',
        // Phone entry
        'phone_entry_subtitle': 'Enter your phone number to book an appointment',
        'your_phone_number': 'Your phone number',
        // Provider selection
        'no_preference': 'No preference',
        'team_members': 'Team members',
        // Custom questions
        'questions_submitted': 'Questions submitted successfully!',
        'questions_failed': 'Failed to submit questions. Please try again.',
        // Upload photos
        'skip_step': 'Skip Step',
        'uploaded': 'Uploaded',
        'upload_failed_status': 'Failed',
        'image_size_error': 'Image size should not be larger than 10mb',
        'image_type_error': 'Only jpg/jpeg/gif and png files are allowed!',
        // Footer
        'powered_by': 'Powered by',
        // Appointment confirmed page
        'reschedule': 'Reschedule',
        'start_paperwork': 'Start Paperwork',
        'book_new_appointment': 'Book New Appointment',
        'appointment_cancelled_page_title': 'This appointment was cancelled',
        'appointment_gone_page_title': 'This appointment is no longer available',
        'appointment_gone_page_subtitle': 'Need to come in? You can book a new appointment below.',
        'join_video_call': 'Join video call',
        'appointment_booked': 'Your appointment has been booked',
        'confirm_appointment_btn': 'Confirm Appointment',
        'book_new_appointment': 'Book New Appointment',
        'pending_approval_title': "Appointment pending \u2014 waiting for staff approval.",
        'pending_approval_desc': "This time is reserved, but your appointment is not confirmed yet. We'll notify you once our team approves it.",
        'inquiry_fallback_message': 'Our front desk will contact you shortly to schedule your appointment.',
        'cancelled_banner_title': 'Appointment cancelled',
        'cancelled_banner_desc': 'Your appointment has been successfully cancelled. You can book a new appointment anytime.',
        'appointment_cancelled_title': 'Your appointment has been cancelled',
        'confirm_cancel_dialog': 'Are you sure you want to cancel this appointment?',
        'address_copied': 'Address copied to clipboard',
        'confirm_appointment_success': 'Appointment confirmed!',
        'confirm_appointment_failed': 'Error confirming appointment. Please try again.',
        'error_event_id_not_found': 'Error: Event ID not found',
        'error_location_undefined': 'Error! Location is undefined.',
        'error_copy_failed': 'Error! Cannot copy to clipboard.',
        'error_room_url_unavailable': 'Event room URL is not available',
        'error_invalid_response': 'Invalid response from server',
        'error_event_cancelled': 'Event has been cancelled.',
        'error_load_appointment_summary': 'Unable to load appointment summary.',
        // Screen titles
        'top_asked_questions': 'Top asked questions',
        'request_consult_title': 'Request consult',
        'get_an_instant_estimate': 'Get an instant estimate',
        'consult_scheduling': 'Consult Scheduling',
        'hello_there': 'Hello there!',
        'when_done': 'When would you like this done?',
        'interest_just_curious': 'Just curious',
        'interest_as_soon_as_possible': 'As soon as possible',
        'interest_few_months': 'A few months',
        'enter_phone_number': 'Enter phone number',
        'appointment_booking_login': 'Appointment Booking Login',
        'enter_phone_to_book': 'Enter your phone number to book an appointment',
        'enter_4_digit_code': 'Enter 4 digit code sent to phone',
        'sent_to': 'Sent to',
        'resend': 'Resend',
        'enter_otp_code': 'Enter OTP Code',
        'register_as_new_patient': 'Register as new patient',
        'tell_us_about_yourself': 'Tell us about yourself',
        'client_portal_info': 'This information is needed to setup your client portal',
        'your_instant_quote': 'Your Instant Quote',
        'book_your_appointment': 'Book your appointment',
        'your_address': 'Your Address',
        'appointment_summary_title': 'Appointment summary',
        'payment_method': 'Payment method',
        'instant_quote_title': 'Instant quote',
        'we_will_reach_back': 'We will reach back to you',
        // Dynamic titles / screens
        'get_instant_estimate': 'Get your instant estimate',
        'select_services': 'Select services',
        'select_date_time': 'Select a Date & Time',
        'available_time': 'Available time',
        'select_time_with': 'Select Time with',
        // Provider / location errors
        'no_location_found': 'No location found',
        'provider_no_location': 'Provider does not offer this location',
        'provider_no_service': 'Provider does not offer this service',
        // Actions / buttons
        'book_now': 'Book now',
        'ask_a_question': 'Ask a question',
        'new_patient': 'New Patient',
        'returning_patient': 'Returning Patient',
        'qualification_form': 'Qualification Form',
        'more': 'More',
        'unsupported_question_type': 'Unsupported question type:',
        'enter_patient_information': 'Enter Patient Information',
        'saving': 'Saving...',
        'confirm': 'Confirm',
        'request_appointment': 'Request Appointment',
        'remove_procedure': 'Remove Procedure',
        'cannot_select_procedure': 'Cannot select this procedure if {name} is selected',
        // Formatting
        'per_month': '/mo',
        'virtual': 'Virtual',
        'virtual_meeting': 'Virtual Meeting',
        'virtual_appointment': 'Virtual appointment',
        'in_person': 'In-Person',
        'phone_call': 'Phone Call',
        'select_visit_type': 'How would you like to meet?',
        'virtual_visit_desc': 'Meet from the comfort of your home',
        'in_person_visit_desc': 'Visit the office in person',
        'phone_visit_desc': 'Meet over the phone',
        'phone_visit_desc_duration': 'Meet for a {duration}-minute phone call',
        'click_to_copy': 'Click to copy',
        'greeting_hi': 'Hi',
        // Placeholders
        'type_desired_service': 'Type Your Desired Service',
        'mobile_phone_placeholder': 'Mobile Phone',
        'full_name_short_placeholder': 'First Last',
        'whats_your_question': "What's your question?",
        'address_main_placeholder': '123 Main St',
        'apt_suite_placeholder': 'Apt 4B',
        'city_short': 'City',
        'state_short': 'State',
        'zip_short': 'ZIP',
        'select_dob': 'Select your date of birth.',
        'enter_first_name': 'Enter your first name',
        'enter_last_name': 'Enter your last name',
        // Field labels
        'your_full_name_label': 'Your full name',
        'your_first_last_name_label': 'Your first and last name',
        'your_email_address_label': 'Your email address',
        'email_address_label': 'Email address',
        'street_address_label': 'Street Address',
        'apt_suite_optional_label': 'Apt / Suite (optional)',
        // Server-returned error messages
        'server_error_unauthenticated': 'Session expired. Please try again.',
        'server_error_code_expired': 'The code has expired. Please request a new one.',
        'server_error_invalid_code': 'Invalid code. Please check and try again.',
        'server_error_invalid_data': 'The information provided is invalid. Please check and try again.',
        'server_error_too_many_attempts': 'Too many attempts. Please wait a moment and try again.',
        'server_error_generic': 'An error occurred. Please try again.',
        // Short / additional placeholders
        'first_last_name_placeholder': 'First and Last Name',
        'email_short': 'Email',
        'edit_btn': 'Edit',
        // Email screen
        'notify_future_specials': 'Notify me of future specials',
        // SMS consent aria-labels
        'sms_transactional_aria': 'Transactional and informational SMS consent',
        'terms_privacy_aria': 'Accept Terms and Conditions and Privacy Policy',
        'sms_promotional_aria': 'Promotional and marketing SMS consent',
        'sms_disclaimer': 'Message and data rates may apply. Message frequency varies. Reply STOP to unsubscribe, HELP for help.',
        // SMS consent label text (split around dynamic business name / links)
        'sms_transactional_before': 'I agree to receive transactional text messages and/or emails from ',
        'sms_transactional_after': ' (e.g. verification codes, account & care messages).',
        'sms_promotional_before': 'I agree to receive promotional text messages and/or emails from ',
        'sms_promotional_after': '. Message frequency varies. Message and data rates may apply. Reply STOP to unsubscribe.',
        'sms_passive_before': 'By continuing, you consent to receive text messages and/or emails from ',
        'sms_passive_after': '. Msg & data rates may apply. Message frequency varies. Reply STOP to opt out.',
        'terms_privacy_before': 'I accept the ',
        'terms_privacy_mid': ' and ',
        'terms_privacy_after': '.',
        'terms_and_conditions': 'Terms and Conditions',
        'privacy_policy': 'Privacy Policy',
        // Consult scheduling screen
        'ready_to_schedule': 'Ready to schedule a consultation?',
        'i_am_new_user': 'I am a new user',
        'i_am_existing_user': 'I am an existing user',
        // Instant quote
        'request_consultation': 'Request Consultation',
        'as_low_as': 'as low as',
        'total_lowercase': 'total',
        'cost_breakdown': 'Cost Breakdown',
        'no_estimate_info': 'No Estimate Information',
        'estimate_disclaimer': 'The result above is a rough estimate. Feel free to call/text for questions, or book a consult to get a personalized assessment and pricing.',
        // Surgical selection
        'surgical': 'Surgical',
        'non_surgical': 'Non-Surgical',
        // Address collection
        'address_subtitle': 'Please provide your address to complete your booking.',
        // Appointment summary
        'please_confirm_appointment': 'Please confirm your appointment',
        'minute_consult_required': 'Minute Consult Required for the Selected Services',
        'save_card_and_confirm': 'Save card and confirm',
        'sign_in': 'Sign in',
        'appointment_date': 'Appointment date',
        // Reschedule screens
        'reschedule_appointment': 'Reschedule appointment',
        'reschedule_your_appointment': 'Reschedule your appointment',
        'current_label': 'Current',
        'new_time_label': 'New time',
        // Provider scheduling
        'available_date': 'Available date',
        // Consult summary
        'still_interested_consult': 'Still interested, request a consultation',
        'consult_summary': 'Consult Summary',
        // Upload photos
        'upload_your_photos': 'Upload your photos',
        'upload_photos_desc': 'Upload your photos so our providers can assess your qualification',
        'upload_click_or_drag': 'Click or drag your photos to this area',
        'upload_multiple_files': 'you can upload more than 1 file',
        // Gender / body selection
        'select_your_gender': 'Select your gender',
        'select_problem_areas': 'Select one or more problem areas',
        // Book appointment
        'book_an_appointment': 'Book an Appointment',
        'click_continue_to_book': 'Click continue to book your appointment',
        // All questions screen
        'questions_title': 'Questions',
        // Verify information
        'verify_information_title': 'Verify Information',
        'verify_information_subtitle': 'Verify information',
        'verify_information_desc': 'Please verify information before continue',
        'verify_btn': 'Verify',
        // Patient selection
        'are_you_new_patient': 'Are you a new patient?',
        // Call us
        'select_location_to_call': 'Select Location to Call',
        // End screen
        'thanks': 'Thanks!',
        'message_received': "We got your message. We will be in touch soon!"
    },
    es: {
        // Common
        'required': 'Requerido',
        'optional': 'Opcional',
        'continue': 'Continuar',
        'back': "Atr\xe1s",
        'close': 'Cerrar',
        'submit': 'Enviar',
        'save': 'Guardar',
        'cancel': 'Cancelar',
        'processing': 'Procesando...',
        'loading': 'Cargando...',
        'copy': 'Copiar',
        'apply': 'Aplicar',
        'yes': "S\xed",
        'no': 'No',
        'from': 'Desde',
        'to': 'a',
        'total': 'Total',
        'minutes': 'minutos',
        'minute': 'minuto',
        // Navigation / Dashboard
        'instant_actions': "Acciones r\xe1pidas",
        'book_appointment': 'Reservar Cita',
        'instant_quote': "Cotizaci\xf3n Instant\xe1nea",
        'ask_question': 'Hacer una Pregunta',
        'call_us': "Ll\xe1manos",
        'text_us': "Escr\xedbenos",
        // Name / Contact fields
        'full_name': 'Nombre Completo',
        'full_name_placeholder': 'Ingrese su nombre completo',
        'first_name': 'Nombre',
        'last_name': 'Apellido',
        'email': "Correo electr\xf3nico",
        'email_placeholder': "Ingrese su correo electr\xf3nico",
        'phone': "N\xfamero de tel\xe9fono",
        'phone_placeholder': "Ingrese su n\xfamero de tel\xe9fono",
        'dob': 'Fecha de Nacimiento',
        'month': 'Mes',
        'day': "D\xeda",
        'year': "A\xf1o",
        'dob_step_title': "Una \xfaltima cosa",
        'dob_step_subtitle': 'Por favor ingrese su fecha de nacimiento para completar su solicitud.',
        // Gender
        'gender': "G\xe9nero",
        'select_gender': "Seleccionar g\xe9nero",
        'male': 'Masculino',
        'female': 'Femenino',
        'other': 'Otro',
        'prefer_not_to_say': 'Prefiero no decirlo',
        // Address
        'address': "Direcci\xf3n",
        'zip_code': "C\xf3digo Postal",
        'zip_code_placeholder': "Ingrese su c\xf3digo postal",
        // Insurance
        'insurance': "\xbfCu\xe1l es su seguro m\xe9dico? (si tiene uno)",
        // Location / Provider
        'select_location': "Seleccionar ubicaci\xf3n",
        'select_provider': 'Seleccionar proveedor',
        'no_preference': 'Sin preferencia',
        'any_provider': 'Cualquier proveedor',
        'soonest_available': "pr\xf3ximo disponible",
        'no_locations_found': 'No se encontraron ubicaciones',
        'no_providers_found': 'No se encontraron proveedores',
        'location': "Ubicaci\xf3n",
        // Services / Procedures
        'select_category': "Seleccionar categor\xeda",
        'no_categories_found': "No se encontraron categor\xedas",
        'no_procedures_found': 'No se encontraron procedimientos',
        'add_procedure': 'Agregar procedimiento',
        'services': 'Servicios',
        'consultation_required': 'Se requiere consulta para un presupuesto',
        // Add-ons
        'select_addons': 'Seleccionar Complementos',
        'select_all_that_applies': 'Seleccione todo lo que aplique',
        'only_one_addon': 'Solo puede seleccionar 1 complemento',
        'no_addons': 'Sin Complementos',
        'apply_addons': 'Aplicar Complementos',
        // Scheduling
        'no_schedules_found': 'No se encontraron horarios.',
        'all_booked': "{provider} completamente reservado este d\xeda",
        'choose_another_day': "Elija otro d\xeda para ver los horarios disponibles",
        'next_available': "Pr\xf3ximo horario disponible: {date}",
        'time_unavailable': 'Hora no disponible',
        'duration': "Duraci\xf3n: {duration} {unit}",
        // Days of week (abbreviated)
        'day_mon': 'Lun',
        'day_tue': 'Mar',
        'day_wed': "Mi\xe9",
        'day_thu': 'Jue',
        'day_fri': 'Vie',
        'day_sat': "S\xe1b",
        'day_sun': 'Dom',
        // Appointment status
        'confirmed': 'Confirmado',
        'pending': 'Pendiente',
        'complete': 'Completado',
        'cancelled': 'Cancelado',
        // Appointment cancel
        'why_cancelling': "\xbfPor qu\xe9 est\xe1 cancelando?",
        'cancel_reason_emergency': 'Emergencia',
        'cancel_reason_conflict': 'Conflicto de horario',
        'cancel_reason_not_needed': 'Ya no es necesario',
        'cancel_reason_placeholder': "D\xedganos el motivo de su cancelaci\xf3n...",
        'cancel_appointment': 'Cancelar Cita',
        'cancel_provide_reason': "Por favor proporcione un motivo de cancelaci\xf3n",
        'cancel_min_chars': "Por favor proporcione al menos 10 caracteres para el motivo de cancelaci\xf3n",
        'cancel_success': 'Cita cancelada exitosamente',
        'cancel_failed': 'Error al cancelar la cita. Por favor intente de nuevo.',
        // Appointment reschedule
        'why_rescheduling': "Por favor d\xedganos por qu\xe9",
        'reschedule_reason_conflict': 'Conflicto de horario',
        'reschedule_reason_emergency': 'Emergencia',
        'reschedule_reason_personal': 'Razones personales',
        'reschedule_reason_placeholder': "D\xedganos el motivo del cambio de cita...",
        'confirm_reschedule': 'Confirmar Cambio de Cita',
        'reschedule_provide_reason': 'Por favor proporcione un motivo para el cambio de cita',
        'reschedule_min_chars': 'Por favor proporcione al menos 10 caracteres para el motivo del cambio de cita',
        'reschedule_success': 'Cita reprogramada exitosamente',
        'reschedule_failed': 'Error al reprogramar la cita. Por favor intente de nuevo.',
        // Appointment summary
        'no_procedures_selected': 'No se seleccionaron procedimientos',
        // How did you hear
        'how_did_you_hear': "\xbfC\xf3mo se enter\xf3 de nosotros?",
        // Another question
        'another_question': 'Tengo otra pregunta',
        // Language
        'select_language': 'Seleccionar idioma',
        'language_english': 'English',
        'language_spanish': "Espa\xf1ol",
        'preferred_language': 'Idioma Preferido',
        // Upload
        'upload': 'Subir',
        // Height
        'feet': 'Pies',
        'inches': 'Pulgadas',
        // Consult summary
        'total_services': 'Total ({count} servicios)',
        // Custom field
        'custom_field': 'Campo personalizado',
        'select_an_option': "Seleccionar una opci\xf3n",
        // Addons summary
        'addons_count': '+{count} complementos',
        // Consult summary
        'free': 'Gratis',
        'consult_fee_applied': 'La tarifa de consulta se aplica a los costos del servicio',
        // Staff info panel
        'meet_with': 'Cita con',
        'no_staffs': 'Sin personal',
        'no_services': 'Sin servicios',
        'duration_label': "Duraci\xf3n",
        'appointment_type': 'Tipo de Cita',
        'description': "Descripci\xf3n",
        'provider': 'Proveedor',
        'providers': 'Proveedores',
        'phone_label': "Tel\xe9fono",
        'office_hours': "Horario de atenci\xf3n",
        'get_directions': "C\xf3mo llegar",
        'services_available': 'servicios disponibles',
        // Phone entry
        'phone_entry_subtitle': "Ingrese su n\xfamero de tel\xe9fono para reservar una cita",
        'your_phone_number': "Su n\xfamero de tel\xe9fono",
        // Provider selection
        'no_preference': 'Sin preferencia',
        'team_members': 'Miembros del equipo',
        // Custom questions
        'questions_submitted': "\xa1Preguntas enviadas exitosamente!",
        'questions_failed': 'Error al enviar las preguntas. Por favor intente de nuevo.',
        // Upload photos
        'skip_step': 'Omitir Paso',
        'uploaded': 'Subido',
        'upload_failed_status': 'Error',
        'image_size_error': "El tama\xf1o de la imagen no debe ser mayor a 10mb",
        'image_type_error': "\xa1Solo se permiten archivos jpg/jpeg/gif y png!",
        // Footer
        'powered_by': "Con tecnolog\xeda de",
        // Appointment confirmed page
        'reschedule': 'Reprogramar',
        'start_paperwork': 'Comenzar formularios',
        'book_new_appointment': 'Reservar nueva cita',
        'appointment_cancelled_page_title': 'Esta cita fue cancelada',
        'appointment_gone_page_title': "Esta cita ya no est\xe1 disponible",
        'appointment_gone_page_subtitle': "\xbfNecesita venir? Puede reservar una nueva cita a continuaci\xf3n.",
        'join_video_call': 'Unirse a la videollamada',
        'appointment_booked': 'Su cita ha sido reservada',
        'confirm_appointment_btn': 'Confirmar Cita',
        'book_new_appointment': 'Reservar Nueva Cita',
        'pending_approval_title': "Cita pendiente \u2014 esperando aprobaci\xf3n del personal.",
        'pending_approval_desc': "Este horario est\xe1 reservado, pero su cita a\xfan no est\xe1 confirmada. Le avisaremos cuando el equipo la apruebe.",
        'inquiry_fallback_message': "Nuestra recepci\xf3n se pondr\xe1 en contacto con usted en breve para programar su cita.",
        'cancelled_banner_title': 'Cita cancelada',
        'cancelled_banner_desc': 'Su cita ha sido cancelada exitosamente. Puede reservar una nueva cita en cualquier momento.',
        'appointment_cancelled_title': 'Su cita ha sido cancelada',
        'confirm_cancel_dialog': "\xbfEst\xe1 seguro de que desea cancelar esta cita?",
        'address_copied': "Direcci\xf3n copiada al portapapeles",
        'confirm_appointment_success': "\xa1Cita confirmada!",
        'confirm_appointment_failed': 'Error al confirmar la cita. Por favor intente de nuevo.',
        'error_event_id_not_found': 'Error: ID de evento no encontrado',
        'error_location_undefined': "\xa1Error! La ubicaci\xf3n no est\xe1 definida.",
        'error_copy_failed': "\xa1Error! No se puede copiar al portapapeles.",
        'error_room_url_unavailable': "La URL de la sala del evento no est\xe1 disponible",
        'error_invalid_response': "Respuesta inv\xe1lida del servidor",
        'error_event_cancelled': 'El evento ha sido cancelado.',
        'error_load_appointment_summary': 'No se pudo cargar el resumen de la cita.',
        // Screen titles
        'top_asked_questions': 'Preguntas frecuentes',
        'request_consult_title': 'Solicitar consulta',
        'get_an_instant_estimate': "Obtenga un estimado instant\xe1neo",
        'consult_scheduling': 'Programar consulta',
        'hello_there': "\xa1Hola!",
        'when_done': "\xbfCu\xe1ndo le gustar\xeda hacerlo?",
        'interest_just_curious': 'Solo curiosidad',
        'interest_as_soon_as_possible': 'Lo antes posible',
        'interest_few_months': 'En unos meses',
        'enter_phone_number': "Ingresar n\xfamero de tel\xe9fono",
        'appointment_booking_login': "Inicio de sesi\xf3n para reserva de cita",
        'enter_phone_to_book': "Ingresa tu n\xfamero de tel\xe9fono para reservar una cita",
        'enter_4_digit_code': "Ingresa el c\xf3digo de 4 d\xedgitos enviado a tu tel\xe9fono",
        'sent_to': 'Enviado a',
        'resend': 'Reenviar',
        'enter_otp_code': "Ingresar c\xf3digo OTP",
        'register_as_new_patient': 'Registrarse como nuevo paciente',
        'tell_us_about_yourself': "Cu\xe9ntenos sobre usted",
        'client_portal_info': "Esta informaci\xf3n es necesaria para configurar su portal de cliente",
        'your_instant_quote': "Su cotizaci\xf3n instant\xe1nea",
        'book_your_appointment': 'Reserve su cita',
        'your_address': "Su direcci\xf3n",
        'appointment_summary_title': 'Resumen de la cita',
        'payment_method': "M\xe9todo de pago",
        'instant_quote_title': "Cotizaci\xf3n instant\xe1nea",
        'we_will_reach_back': 'Nos comunicaremos con usted',
        // Dynamic titles / screens
        'get_instant_estimate': "Obtenga su estimado instant\xe1neo",
        'select_services': 'Seleccionar servicios',
        'select_date_time': 'Seleccionar fecha y hora',
        'available_time': 'Hora disponible',
        'select_time_with': 'Seleccionar hora con',
        // Provider / location errors
        'no_location_found': "No se encontr\xf3 ubicaci\xf3n",
        'provider_no_location': "El proveedor no ofrece esta ubicaci\xf3n",
        'provider_no_service': 'El proveedor no ofrece este servicio',
        // Actions / buttons
        'book_now': 'Reservar ahora',
        'ask_a_question': 'Hacer una pregunta',
        'new_patient': 'Paciente nuevo',
        'returning_patient': 'Paciente recurrente',
        'qualification_form': "Formulario de calificaci\xf3n",
        'more': "M\xe1s",
        'unsupported_question_type': 'Tipo de pregunta no compatible:',
        'enter_patient_information': "Ingresar informaci\xf3n del paciente",
        'saving': 'Guardando...',
        'confirm': 'Confirmar',
        'request_appointment': 'Solicitar cita',
        'remove_procedure': 'Quitar procedimiento',
        'cannot_select_procedure': "No puede seleccionar este procedimiento si {name} est\xe1 seleccionado",
        // Formatting
        'per_month': '/mes',
        'virtual': 'Virtual',
        'virtual_meeting': "Reuni\xf3n virtual",
        'virtual_appointment': 'Cita virtual',
        'in_person': 'En persona',
        'phone_call': "Llamada telef\xf3nica",
        'select_visit_type': "\xbfC\xf3mo prefiere reunirse?",
        'virtual_visit_desc': "Re\xfanase desde la comodidad de su hogar",
        'in_person_visit_desc': 'Visite el consultorio en persona',
        'phone_visit_desc': "Re\xfanase por tel\xe9fono",
        'phone_visit_desc_duration': "Re\xfanase en una llamada telef\xf3nica de {duration} minutos",
        'click_to_copy': 'Clic para copiar',
        'greeting_hi': 'Hola',
        // Placeholders
        'type_desired_service': 'Escriba el servicio deseado',
        'mobile_phone_placeholder': "Tel\xe9fono m\xf3vil",
        'full_name_short_placeholder': 'Nombre Apellido',
        'whats_your_question': "\xbfCu\xe1l es su pregunta?",
        'address_main_placeholder': 'Calle Principal 123',
        'apt_suite_placeholder': 'Apto 4B',
        'city_short': 'Ciudad',
        'state_short': 'Estado',
        'zip_short': 'CP',
        'select_dob': 'Seleccione su fecha de nacimiento.',
        'enter_first_name': 'Ingrese su nombre',
        'enter_last_name': 'Ingrese su apellido',
        // Field labels
        'your_full_name_label': 'Su nombre completo',
        'your_first_last_name_label': 'Su nombre y apellido',
        'your_email_address_label': "Su correo electr\xf3nico",
        'email_address_label': "Correo electr\xf3nico",
        'street_address_label': "Direcci\xf3n",
        'apt_suite_optional_label': 'Apto / Suite (opcional)',
        // Server-returned error messages
        'server_error_unauthenticated': "Sesi\xf3n expirada. Por favor intente de nuevo.",
        'server_error_code_expired': "El c\xf3digo ha expirado. Por favor solicite uno nuevo.",
        'server_error_invalid_code': "C\xf3digo inv\xe1lido. Por favor verifique e intente de nuevo.",
        'server_error_invalid_data': "La informaci\xf3n proporcionada es inv\xe1lida. Por favor verifique e intente de nuevo.",
        'server_error_too_many_attempts': 'Demasiados intentos. Por favor espere un momento e intente de nuevo.',
        'server_error_generic': "Ocurri\xf3 un error. Por favor intente de nuevo.",
        // Short / additional placeholders
        'first_last_name_placeholder': 'Nombre y Apellido',
        'email_short': 'Correo',
        'edit_btn': 'Editar',
        // Email screen
        'notify_future_specials': 'Notificarme sobre ofertas futuras',
        // SMS consent aria-labels
        'sms_transactional_aria': 'Consentimiento de SMS transaccional e informativo',
        'terms_privacy_aria': "Aceptar T\xe9rminos y Condiciones y Pol\xedtica de Privacidad",
        'sms_promotional_aria': 'Consentimiento de SMS promocional y de marketing',
        'sms_disclaimer': "Pueden aplicar tarifas de mensajes y datos. La frecuencia de mensajes var\xeda. Responda STOP para cancelar la suscripci\xf3n, HELP para ayuda.",
        // SMS consent label text (split around dynamic business name / links)
        'sms_transactional_before': 'Acepto recibir mensajes de texto y/o correos transaccionales de ',
        'sms_transactional_after': " (p.ej. c\xf3digos de verificaci\xf3n, mensajes de cuenta y atenci\xf3n).",
        'sms_promotional_before': 'Acepto recibir mensajes de texto y/o correos promocionales de ',
        'sms_promotional_after': ". La frecuencia de mensajes var\xeda. Pueden aplicar tarifas de mensajes y datos. Responda STOP para cancelar la suscripci\xf3n.",
        'sms_passive_before': 'Al continuar, acepto recibir mensajes de texto y/o correos de ',
        'sms_passive_after': ". Pueden aplicar tarifas de mensajes y datos. La frecuencia var\xeda. Responda STOP para cancelar.",
        'terms_privacy_before': 'Acepto los ',
        'terms_privacy_mid': ' y la ',
        'terms_privacy_after': '.',
        'terms_and_conditions': "T\xe9rminos y Condiciones",
        'privacy_policy': "Pol\xedtica de Privacidad",
        // Consult scheduling screen
        'ready_to_schedule': "\xbfListo para programar una consulta?",
        'i_am_new_user': 'Soy un nuevo usuario',
        'i_am_existing_user': 'Soy un usuario existente',
        // Instant quote
        'request_consultation': 'Solicitar Consulta',
        'as_low_as': 'desde',
        'total_lowercase': 'total',
        'cost_breakdown': 'Desglose de Costos',
        'no_estimate_info': "Sin Informaci\xf3n de Estimado",
        'estimate_disclaimer': "El resultado anterior es un estimado aproximado. No dude en llamar/escribir para preguntas, o reserve una consulta para obtener una evaluaci\xf3n y precio personalizados.",
        // Surgical selection
        'surgical': "Quir\xfargico",
        'non_surgical': "No Quir\xfargico",
        // Address collection
        'address_subtitle': "Por favor proporcione su direcci\xf3n para completar su reserva.",
        // Appointment summary
        'please_confirm_appointment': 'Por favor confirme su cita',
        'minute_consult_required': 'Minutos de Consulta Requeridos para los Servicios Seleccionados',
        'save_card_and_confirm': 'Guardar tarjeta y confirmar',
        'sign_in': "Iniciar sesi\xf3n",
        'appointment_date': 'Fecha de la cita',
        // Reschedule screens
        'reschedule_appointment': 'Reprogramar cita',
        'reschedule_your_appointment': 'Reprograme su cita',
        'current_label': 'Actual',
        'new_time_label': 'Nueva hora',
        // Provider scheduling
        'available_date': 'Fecha disponible',
        // Consult summary
        'still_interested_consult': "Todav\xeda interesado, solicitar una consulta",
        'consult_summary': 'Resumen de Consulta',
        // Upload photos
        'upload_your_photos': 'Subir tus fotos',
        'upload_photos_desc': "Sube tus fotos para que nuestros proveedores puedan evaluar tu calificaci\xf3n",
        'upload_click_or_drag': "Haz clic o arrastra tus fotos a esta \xe1rea",
        'upload_multiple_files': "puedes subir m\xe1s de 1 archivo",
        // Gender / body selection
        'select_your_gender': "Selecciona tu g\xe9nero",
        'select_problem_areas': "Selecciona una o m\xe1s \xe1reas problem\xe1ticas",
        // Book appointment
        'book_an_appointment': 'Reservar una Cita',
        'click_continue_to_book': 'Haz clic en continuar para reservar tu cita',
        // All questions screen
        'questions_title': 'Preguntas',
        // Verify information
        'verify_information_title': "Verificar Informaci\xf3n",
        'verify_information_subtitle': "Verificar informaci\xf3n",
        'verify_information_desc': "Por favor verifica la informaci\xf3n antes de continuar",
        'verify_btn': 'Verificar',
        // Patient selection
        'are_you_new_patient': "\xbfEres un paciente nuevo?",
        // Call us
        'select_location_to_call': "Seleccionar Ubicaci\xf3n para Llamar",
        // End screen
        'thanks': "\xa1Gracias!",
        'message_received': "Recibimos tu mensaje. \xa1Nos pondremos en contacto pronto!"
    }
};
// Map of known server-returned English error messages to i18n keys
const $ed5525f880b55dda$var$SERVER_ERROR_MAP = {
    'unauthenticated.': 'server_error_unauthenticated',
    'unauthenticated': 'server_error_unauthenticated',
    'session expired. please try again.': 'server_error_unauthenticated',
    'session expired': 'server_error_unauthenticated',
    'the code has expired.': 'server_error_code_expired',
    'invalid code.': 'server_error_invalid_code',
    'invalid otp': 'server_error_invalid_code',
    'the given data was invalid.': 'server_error_invalid_data',
    'too many attempts.': 'server_error_too_many_attempts',
    'too many requests.': 'server_error_too_many_attempts',
    'server error': 'server_error_generic',
    'internal server error': 'server_error_generic'
};
function $ed5525f880b55dda$export$6580432b72204576(message) {
    if (!message) return message;
    const key = $ed5525f880b55dda$var$SERVER_ERROR_MAP[message.toLowerCase().trim()];
    return key ? $ed5525f880b55dda$export$625550452a3fa3ec(key) : message;
}
function $ed5525f880b55dda$export$625550452a3fa3ec(key) {
    const lang = (0, $cEKee.selectedLanguage) || 'en';
    const dict = $ed5525f880b55dda$var$translations[lang] || $ed5525f880b55dda$var$translations['en'];
    return dict[key] ?? $ed5525f880b55dda$var$translations['en'][key] ?? key;
}
function $ed5525f880b55dda$export$920c7765ed6965d8(key) {
    return $ed5525f880b55dda$var$translations['en'][key] ?? key;
}

});

parcelRegister("4tyfr", function(module, exports) {

$parcel$export(module.exports, "applyDisclaimerFooters", () => $34246fcf6da32832$export$ad1c121edbfebed5);

var $cEKee = parcelRequire("cEKee");
/* Default --header-height is 90px with a 17px decorative strip; a disclaimer
   replaces the strip, so each screen needs (disclaimer height + 73px) freed. */ const $34246fcf6da32832$var$FOOTER_BASE = 73;
const $34246fcf6da32832$export$ad1c121edbfebed5 = ()=>{
    /* The module-level form holds the flat widget payload; some callers run
       before loadData() when it may still be the axios response shape. */ const disclaimer = (0, $cEKee.form)?.disclaimer ?? (0, $cEKee.form)?.data?.disclaimer;
    if (!disclaimer) return;
    /* Hosted scheduling-link desktop pages hide widget footers entirely. */ const assistantIframe = document.querySelector('.assistant__iframe');
    if (assistantIframe?.classList.contains('scheduling-link') && assistantIframe?.classList.contains('desktop-ver')) return;
    document.querySelectorAll('.widget-footer').forEach((footer)=>{
        const subFooter1 = footer.querySelector('.subFooter--1');
        if (!subFooter1) return;
        subFooter1.textContent = disclaimer;
        subFooter1.classList.add('disclaimer');
        subFooter1.style.height = 'auto';
        subFooter1.style.maxHeight = '80px';
        const height = subFooter1.clientHeight;
        /* Hidden right now (closed launcher, mobile-ver, display:none screen):
           keep the current values — a later pass re-measures once visible.
           Writing 0-based values here is what desynced the screens. */ if (!height) return;
        subFooter1.style.top = `-${height}px`;
        const mainEl = footer.closest('.mainMenu__container') || footer.closest('.screen');
        mainEl?.querySelector('.screen__content')?.style.setProperty('--header-height', `${height + $34246fcf6da32832$var$FOOTER_BASE}px`);
    });
};
let $34246fcf6da32832$var$resizeTimer = null;
window.addEventListener('resize', ()=>{
    clearTimeout($34246fcf6da32832$var$resizeTimer);
    $34246fcf6da32832$var$resizeTimer = setTimeout($34246fcf6da32832$export$ad1c121edbfebed5, 150);
});

});

parcelRegister("futhG", function(module, exports) {

$parcel$export(module.exports, "isValidFullName", () => $b4705f9a1f566582$export$a0889293100b9119);
$parcel$export(module.exports, "removeFullName", () => $b4705f9a1f566582$export$296f3957dfcfb79d);

var $cEKee = parcelRequire("cEKee");
function $b4705f9a1f566582$export$a0889293100b9119(name) {
    if (name.trim().includes(' ')) return true;
    return false;
}
function $b4705f9a1f566582$export$296f3957dfcfb79d() {
    (0, $cEKee.setFullName)('');
    const name = document.querySelector('#fullName');
    if (name) {
        name.value = '';
        document.querySelector('.fullNameContinue__btn').classList.add('disabled');
    }
}

});

parcelRegister("ijygk", function(module, exports) {

$parcel$export(module.exports, "removeEmail", () => $d5549420e809330a$export$f3ec87a1371a28bc);

var $cEKee = parcelRequire("cEKee");
function $d5549420e809330a$export$f3ec87a1371a28bc() {
    (0, $cEKee.setEmail)('');
    (0, $cEKee.setEmailCheck)(false);
    const email = document.querySelector('#email');
    if (email) {
        email.value = '';
        document.querySelector('.emailContinue__btn').classList.add('disabled');
    }
}

});

parcelRegister("2q2gk", function(module, exports) {

$parcel$export(module.exports, "createLead", () => $1c2fc3b9c40bda46$export$2496bb6232728ef1);
$parcel$export(module.exports, "updateLeadStep", () => $1c2fc3b9c40bda46$export$85c359102dade24d);
$parcel$export(module.exports, "updateLeadStepKeepalive", () => $1c2fc3b9c40bda46$export$35f1cfe0d5cd9d24);
$parcel$export(module.exports, "endLeadSession", () => $1c2fc3b9c40bda46$export$a5b5e8aaa1043a74);

var $er9E0 = parcelRequire("er9E0");

var $hvLQT = parcelRequire("hvLQT");

var $8yRQa = parcelRequire("8yRQa");
async function $1c2fc3b9c40bda46$export$2496bb6232728ef1(data) {
    if (parseInt((0, $er9E0.params)('has_source')) === 1) data['source'] = (0, $er9E0.params)('source');
    return await (0, $hvLQT.apiClient).POST(`api/leads`, data);
}
async function $1c2fc3b9c40bda46$export$d15836955ba527f3(id, data) {
    return await (0, $hvLQT.apiClient).POST(`api/leads/${id}`, data);
}
async function $1c2fc3b9c40bda46$export$85c359102dade24d(id, step, sessionEnded = 'false', identity = {}) {
    if (step === 'question') return await (0, $hvLQT.apiClient).PUT(`api/leads/${id}/step/${step}/true`);
    if (step === 'consult') {
        const timezone = (0, $8yRQa.getLocalTimezoneName)();
        // widget_uuid tells the API WHICH widget this consult came through, so a
        // test widget can run the intake handoff while the live one does not.
        const widgetUuid = (0, $er9E0.params)('form_id') || (0, $er9E0.params)('form');
        return await (0, $hvLQT.apiClient).PUT(`api/leads/${id}/step/${step}${sessionEnded ? `/${sessionEnded}` : ''}`, {
            ...timezone && {
                timezone: timezone
            },
            ...widgetUuid && {
                widget_uuid: widgetUuid
            },
            ...identity
        });
    }
    return await (0, $hvLQT.apiClient).PUT(`api/leads/${id}/step/${step}${sessionEnded ? `/${sessionEnded}` : ''}`);
}
function $1c2fc3b9c40bda46$export$35f1cfe0d5cd9d24(id, step, sessionEnded = 'false') {
    try {
        return fetch((0, $hvLQT.apiClient).apiUrl(`api/leads/${id}/step/${step}${sessionEnded ? `/${sessionEnded}` : ''}`), {
            method: 'PUT',
            keepalive: true,
            headers: (0, $hvLQT.apiClient).config().headers
        }).catch(()=>null);
    } catch (e) {
        return Promise.resolve(null);
    }
}
function $1c2fc3b9c40bda46$export$a5b5e8aaa1043a74(id) {
    try {
        return fetch((0, $hvLQT.apiClient).apiUrl(`api/leads/${id}/end-session`), {
            method: 'POST',
            keepalive: true,
            headers: (0, $hvLQT.apiClient).config().headers
        }).catch(()=>null);
    } catch (e) {
        return Promise.resolve(null);
    }
}

});
parcelRegister("8yRQa", function(module, exports) {

$parcel$export(module.exports, "getLocalTimezoneName", () => $63bb43451a706903$export$3fb0023f1048a620);
function $63bb43451a706903$export$3fb0023f1048a620() {
    try {
        return Intl.DateTimeFormat().resolvedOptions().timeZone || null;
    } catch (error) {
        return null;
    }
}

});


parcelRegister("8QS3m", function(module, exports) {

$parcel$export(module.exports, "loadCategories", () => $671d1be2f7e0537f$export$8a2309c206509e37);

var $9CQsA = parcelRequire("9CQsA");

var $cEKee = parcelRequire("cEKee");
function $671d1be2f7e0537f$export$8a2309c206509e37(procedures) {
    procedures = (0, $cEKee.scopeProceduresToSelectedLocation)(procedures);
    let categoryArray = [];
    const categoryWrapper = document.querySelector('.seeServices__container .category_wrapper');
    const listCategory = (0, $cEKee.bodyAreaSelected)?.map((item)=>item.name);
    let categoriesList = (0, $cEKee.categories).filter((i)=>{
        if ((0, $cEKee.showBodyAreaSelection) && !listCategory.includes(i.name)) return false;
        return (0, $9CQsA.isHasProcedureBelongToCategory)(i, procedures);
    });
    for (const i of categoriesList)categoryArray.push(i.name);
    categoryWrapper.innerHTML = '';
    /* The horizontal chip carousel is now always hidden: with more than one
       category the services list renders as a collapsible category menu (see
       loadProcedures) so the chips are redundant, and with a single category
       one chip jumping to the only section is pure noise (the section header
       is suppressed too, in loadProcedures). */ const categoryBar = document.querySelector('.seeServices__container .category');
    if (categoryBar) categoryBar.classList.add('category--hidden');
    var i;
    return;
}
function $671d1be2f7e0537f$var$handleCategoryOptionClickEvent() {
    const containerOffset = document.querySelector('.procedures__container').offsetTop;
    const targetOffset = document.querySelector(`#${this.getAttribute('data-id')}`).offsetTop;
    const scrollOffset = targetOffset - containerOffset;
    document.querySelector('.procedures__container').scrollTop = scrollOffset;
}

});
parcelRegister("9CQsA", function(module, exports) {

$parcel$export(module.exports, "isHasProcedureBelongToCategory", () => $70205b205009ab5d$export$8a0bb466473888e);
$parcel$export(module.exports, "convertCategory", () => $70205b205009ab5d$export$5a15aada14feb0e5);
function $70205b205009ab5d$export$63ed809dff8cc0df(categories, categorySetting) {
    let result = [];
    for (const i of categories)result.push(categorySetting[i]);
    return result;
}
function $70205b205009ab5d$export$8a0bb466473888e(category, procedures) {
    for (const i of procedures){
        if (i.service_categories?.map((i)=>i.name).includes(category.name)) return true;
    }
    return false;
}
function $70205b205009ab5d$export$5a15aada14feb0e5(category) {
    return category.replace(/[^a-zA-Z0-9]/g, '');
}
function $70205b205009ab5d$export$b77544b5f2d33977(category, procedures) {
    for (const i of procedures){
        if (i.surgical == 1) return true;
    }
    return false;
}

});


parcelRegister("d0tLC", function(module, exports) {

$parcel$export(module.exports, "loadProcedures", () => $97825d8bb866f2aa$export$9bcb6bd4f05f713);

var $9CQsA = parcelRequire("9CQsA");

var $knjAn = parcelRequire("knjAn");

var $3XRkp = parcelRequire("3XRkp");

var $8tpUR = parcelRequire("8tpUR");

var $cEKee = parcelRequire("cEKee");

var $aROBf = parcelRequire("aROBf");

var $lqW7O = parcelRequire("lqW7O");

var $1GjFv = parcelRequire("1GjFv");
function $97825d8bb866f2aa$export$9bcb6bd4f05f713(procedures) {
    procedures = (0, $cEKee.scopeProceduresToSelectedLocation)(procedures);
    const procedureContainer = document.querySelector('.procedures__container');
    procedureContainer.innerHTML = '';
    let categoriesList = [];
    const listCategory = (0, $cEKee.bodyAreaSelected)?.map((item)=>item.name);
    categoriesList = (0, $cEKee.categories).filter((i)=>{
        if ((0, $cEKee.showBodyAreaSelection) && !listCategory.includes(i.name)) return false;
        return (0, $9CQsA.isHasProcedureBelongToCategory)(i, procedures);
    });
    if (categoriesList.length <= 0) {
        procedureContainer.insertAdjacentHTML('beforeend', `
        <div class="noProcedures">${(0, $knjAn.t)('no_procedures_found')}</div>
        `);
        return;
    }
    /* Accordion mode: with more than one category the horizontal category
       carousel is hard to scan (chips overflow off-screen), so categories
       render as a collapsible menu instead — tap a category header to expand
       its services. Single-category channels keep the flat list.
       Sections start collapsed only when the menu is long (many services)
       AND there are 3+ categories; with just 2 categories (or a short menu)
       everything renders pre-expanded so visitors see it all at once. */ const useAccordion = categoriesList.length > 1;
    const startCollapsed = useAccordion && categoriesList.length >= 3 && procedures.length > 8;
    procedureContainer.classList.toggle('procedure-accordion', useAccordion);
    /* Page-aware ordering: when the widget is embedded on a page about one
       specific service (a service page or a landing page), the API hoists that
       service — and its category — to the front of these lists. A collapsed
       section would hide the hoist completely, so the priority service's own
       section always renders expanded. Nothing is auto-selected: the visitor
       still sees every category and can pick anything. */ /* variables.form holds the config PAYLOAD (loadData receives response.data),
       so priority_procedure_id lives at the top level — form.data is undefined
       here. Keep the .data fallback for any caller that stores the raw response
       (same pattern as disclaimerFooter.js). */ const priorityProcedureId = (0, $cEKee.form)?.priority_procedure_id ?? (0, $cEKee.form)?.data?.priority_procedure_id ?? null;
    const priorityCategoryNames = priorityProcedureId ? (procedures.find((item)=>Number(item.id) === Number(priorityProcedureId))?.service_categories ?? []).map((ca)=>ca.name) : [];
    for (const i of categoriesList){
        const collapseSection = startCollapsed && !priorityCategoryNames.includes(i.name);
        const sectionProcedureCount = procedures.filter((item)=>item.service_categories?.map((ca)=>ca.name).includes(i.name)).length;
        /* Single-category channels: the header would just repeat one name
           above the whole list, so it isn't rendered at all. */ const categoryHeader = categoriesList.length > 1 ? `
            <div class="category-section__wrapper${useAccordion ? ' category-section__wrapper--toggle' : ''}">
                ${i.icon ? `
                    <img loading="lazy" class="category__icon" src="${"https://storage.googleapis.com/pp-icons/"}${i.icon}">
                    ` : ''}
                <span class="category__text">${i.name}</span>
                ${useAccordion ? `<span class="category-section__toggle-right">
                        <span class="category__service-count">${sectionProcedureCount}</span>
                        <i class="ri-arrow-down-s-line category__chevron"></i>
                    </span>` : ''}
            </div>` : '';
        procedureContainer.insertAdjacentHTML('beforeend', `
        <div id="${(0, $9CQsA.convertCategory)(i.name)}" class="procedure-section__container${collapseSection ? ' procedure-section__collapsed' : ''}">
            ${categoryHeader}
        </div>
        `);
        let proceduresList = procedures.filter((item)=>{
            return item.service_categories?.map((ca)=>ca.name).includes(i.name);
        });
        /* NB: class list varies in accordion mode (adds
           procedure-section__collapsed), so match the class as a
           class selector — never as an exact class attribute. */ const procedureSectionContainer = document.querySelector(`[id='${(0, $9CQsA.convertCategory)(i.name)}'].procedure-section__container`);
        if (!useAccordion && categoriesList.indexOf(i) === categoriesList.length - 1) /* fake-height only serves the carousel's scroll-jump targets —
               in accordion mode it would leave a giant empty area. */ procedureSectionContainer.classList.add('procedure-section__fake-height');
        if (proceduresList.length > 0) procedureSectionContainer.insertAdjacentHTML('beforeend', `
            <div class="procedures-list">${$97825d8bb866f2aa$var$showListProcedure(proceduresList, i.name)}</div>
            `);
        else procedureSectionContainer.insertAdjacentHTML('beforeend', `
            <div class="no-procedure-text">${(0, $knjAn.t)('no_procedures_found')}</div>
            `);
    }
    if (useAccordion) document.querySelectorAll('.category-section__wrapper--toggle').forEach((header)=>{
        header.addEventListener('click', function() {
            this.closest('.procedure-section__container')?.classList.toggle('procedure-section__collapsed');
        });
    });
    $97825d8bb866f2aa$var$loadCheckBoxDetails(procedures);
    (0, $8tpUR.procedureListeners)();
    (0, $3XRkp.addonListeners)();
    document.querySelectorAll('.procedure__price').forEach((item)=>{
        item.style.backgroundColor = `${0, $cEKee.primaryColor}0f`;
    });
}
function $97825d8bb866f2aa$var$showListProcedure(procedureList, category) {
    let listProcedures = ``;
    for (const procedure of procedureList){
        const isHideServiceDurationOption = (0, $cEKee.isHideServiceDuration) || procedure?.hide_duration_on_select_service || (0, $cEKee.form)?.appointment_channel?.hide_duration_on_select_service;
        const price = procedure?.from || 0;
        const isShowFormText = procedure.force_addon_selection === 1 ? true : false;
        const filterAddOns = procedure?.procedure_addons?.filter((item)=>!item?.deleted_at);
        const shouldShowPricing = (0, $cEKee.form)?.appointment_channel?.show_pricing && procedure?.show_pricing || typeof (0, $cEKee.surgicalOption) === 'boolean' && !(0, $cEKee.surgicalOption);
        let procedureWrapper = `
        <div class="procedure__content">
            <div class="line__wrapper procedure" data-procedure-id="${procedure.id}" data-category="${category}">
                <div class="procedure__checkbox" data-procedure-id="${procedure.id}" data-category="${category}">
                    <i class="procedure__icon-check ri-check-line"></i>
                </div>
                <div class="procedure__name--wrapper">
                    <div class="procedure__info-wrapper">
                        <div class="procedure__name-duration">
                            <div class="procedure__name">${(0, $aROBf.procedureDisplayName)(procedure)}</div>
                            <div class="procedure__price-duration ${(0, $cEKee.surgicalOption) || isHideServiceDurationOption ? 'hidden' : ''}">${$97825d8bb866f2aa$export$31789a143286bead(procedure.duration)}</div>
                        </div>
                        <div class="procedure__price--wrapper ${(0, $cEKee.isBookAppointment) && price !== 0 && shouldShowPricing ? '' : 'hidden'}">
                            ${isShowFormText ? `<span>${(0, $knjAn.t)('from')}</span>` : ''}
                            <div class="procedure__price">$${price.toLocaleString('en-US', {
            maximumFractionDigits: 2
        })}</div>
                        </div> 
                    </div>
                    <div class="procedure__disableText"></div>
                </div>
                ${procedure.description ? `<span class="procedure__information procedure" data-procedure-id="${procedure.id}">
                        <i class="ri-question-line"></i>
                    </span>` : ""}
            </div>
            <div class="procedureBody__wrapper" data-procedure-id="${procedure.id}">
                ${(0, $1GjFv.loadProcedureInformation)(procedure, category)}
            </div>
            <div class="addonsSections__wrapper addon__container" data-procedure-id="${procedure.id}" data-category="${category}">
                ${filterAddOns?.length > 0 ? (0, $lqW7O.loadAddons)(procedure.id, category) : ''}
            </div>
        </div>
        `;
        listProcedures = listProcedures.concat(procedureWrapper);
    }
    return listProcedures;
}
function $97825d8bb866f2aa$var$loadCheckBoxDetails(procedures) {
    let checkBox = document.querySelectorAll('.procedure__checkbox');
    checkBox.forEach((i)=>{
        const procedure = procedures.find((p)=>p.id === parseInt(i.getAttribute('data-procedure-id')));
        const filterAddOns = procedure?.procedure_addons?.filter((item)=>!item.deleted_at);
        if (filterAddOns?.length > 0) i.insertAdjacentHTML('beforeend', `
            <span class="checkbox__count" data-procedure-id="${procedure.id}">0</span>
            <span class="checkbox__dots">...</span></div>
            `);
    });
}
function $97825d8bb866f2aa$export$31789a143286bead(durations) {
    if (!durations) return '';
    const durationTime = moment.duration(durations, 'm');
    if (durationTime.hours() === 1 && !durationTime.minutes()) return `60min`;
    return `${durationTime.hours() ? `${durationTime.hours()}h` : ''} ${durationTime.minutes()}min`;
}

});
parcelRegister("3XRkp", function(module, exports) {

$parcel$export(module.exports, "addonListeners", () => $2e303fa15e071283$export$e87feff2bd1bd744);

var $cIxq8 = parcelRequire("cIxq8");

var $cEKee = parcelRequire("cEKee");

var $iN6uF = parcelRequire("iN6uF");

var $fJKn4 = parcelRequire("fJKn4");
function $2e303fa15e071283$export$e87feff2bd1bd744() {
    /* on click outside to close pop up */ $2e303fa15e071283$var$clickOutsideToClosePopup();
    /* on click "No Add-Ons" */ $2e303fa15e071283$var$clickNoAddons();
    /* on select addon */ $2e303fa15e071283$var$onSelectAddons();
    /* On click Add Add-Ons button */ $2e303fa15e071283$var$clickAddAddons();
    /* On show addon description popup */ $2e303fa15e071283$var$openAddonDescription();
    /* On click Close description addon */ $2e303fa15e071283$var$closeAddonDescription();
    /* On click outside to close description addon */ $2e303fa15e071283$var$clickOutsideToCloseDescription();
    /* On click Apply btn */ $2e303fa15e071283$var$clickApplyButton();
}
function $2e303fa15e071283$var$clickOutsideToClosePopup() {
    const bg = document.querySelectorAll(`.popup__background.addons`);
    bg.forEach((i)=>{
        const procedureList = (0, $cEKee.appointmentChannelId) && (0, $cEKee.form)?.appointment_channel?.procedures?.length >= 1 ? (0, $cEKee.form)?.appointment_channel?.procedures : (0, $cEKee.procedures);
        const { id: id } = procedureList.find((p)=>p.id === parseInt(i.getAttribute('data-procedure-id')));
        const category = i.getAttribute('data-category');
        i.onclick = ()=>{
            if (0, $cEKee.isClickCheckBox) {
                (0, $iN6uF.toggleAddonsPopup)(id, category, (0, $cIxq8.CLOSE));
                (0, $fJKn4.addProcedure)(id);
            } else {
                (0, $iN6uF.toggleAddonsPopup)(id, category, (0, $cIxq8.CLOSE));
                (0, $iN6uF.removeAllAddons)(id);
            }
        };
    });
}
function $2e303fa15e071283$var$clickNoAddons() {
    const btn = document.querySelectorAll('.addons__closeBtn');
    btn.forEach((i)=>{
        const id = parseInt(i.getAttribute('data-procedure-id'));
        const category = i.getAttribute('data-category');
        i.onclick = ()=>{
            (0, $iN6uF.toggleAddonsPopup)(id, category, (0, $cIxq8.CLOSE));
            (0, $iN6uF.removeAllAddons)(id);
            (0, $fJKn4.addProcedure)(id);
        };
    });
}
function $2e303fa15e071283$var$onSelectAddons() {
    const checkBox = document.querySelectorAll('.line__wrapper.addon');
    const procedureList = (0, $cEKee.appointmentChannelId) && (0, $cEKee.form)?.appointment_channel?.procedures?.length >= 1 ? (0, $cEKee.form)?.appointment_channel?.procedures : (0, $cEKee.procedures);
    checkBox.forEach((i)=>{
        const procedureId = i.getAttribute('data-procedure-id');
        const addonId = i.getAttribute('data-addon-id');
        const selectType = procedureList.find((p)=>p.id === parseInt(procedureId)).addons_select_type;
        i.onclick = ()=>{
            if (selectType === (0, $cIxq8.ADDONS_SELECT_TYPE).MULTI_SELECT) {
                if ((0, $iN6uF.isCheckedAddons)(procedureId, addonId)) (0, $iN6uF.removeAddons)(procedureId, addonId);
                else (0, $iN6uF.addAddons)(procedureId, addonId);
            } else if (selectType === (0, $cIxq8.ADDONS_SELECT_TYPE).SINGLE_SELECT) {
                (0, $iN6uF.removeAllAddons)(procedureId);
                (0, $iN6uF.addAddons)(procedureId, addonId);
            }
        };
    });
}
function $2e303fa15e071283$var$clickAddAddons() {
    const addBtn = document.querySelectorAll('.addons__applyAddonBtn');
    addBtn.forEach((i)=>{
        const procedureId = parseInt(i.getAttribute('data-procedure-id'));
        const category = i.getAttribute('data-category');
        i.onclick = ()=>{
            (0, $iN6uF.applyAddons)(procedureId);
            (0, $iN6uF.toggleAddonsPopup)(procedureId, category, (0, $cIxq8.CLOSE));
        };
    });
}
function $2e303fa15e071283$var$openAddonDescription() {
    const infoBtn = document.querySelectorAll('.procedure__information.addon');
    infoBtn.forEach((i)=>{
        i.onclick = (e)=>{
            e.stopPropagation();
            (0, $iN6uF.toggleAddonDescription)(i.getAttribute('data-procedure-id'), i.getAttribute('data-addon-id'), i.getAttribute('data-category'), (0, $cIxq8.OPEN));
        };
    });
}
function $2e303fa15e071283$var$closeAddonDescription() {
    const closeInfoBtn = document.querySelectorAll('.addon-body__close-btn');
    closeInfoBtn.forEach((i)=>{
        i.onclick = ()=>{
            (0, $iN6uF.toggleAddonDescription)(i.getAttribute('data-procedure-id'), i.getAttribute('data-addon-id'), i.getAttribute('data-category'), (0, $cIxq8.CLOSE));
        };
    });
}
function $2e303fa15e071283$var$clickOutsideToCloseDescription() {
    const bgDescription = document.querySelectorAll('.popup__background.addon__information');
    bgDescription.forEach((i)=>{
        i.onclick = ()=>{
            (0, $iN6uF.toggleAddonDescription)(i.getAttribute('data-procedure-id'), i.getAttribute('data-addon-id'), i.getAttribute('data-category'), (0, $cIxq8.CLOSE));
        };
    });
}
function $2e303fa15e071283$var$clickApplyButton() {
    const applyBtn = document.querySelectorAll('.addonBody__applyBtn');
    applyBtn.forEach((i)=>{
        i.onclick = ()=>{
            (0, $iN6uF.applyAddon)(i.getAttribute('data-procedure-id'), i.getAttribute('data-addon-id'), i.getAttribute('data-category'));
        };
    });
}

});
parcelRegister("iN6uF", function(module, exports) {

$parcel$export(module.exports, "addAddons", () => $dae1d719957aba3a$export$134e6f73bd2d8aca);
$parcel$export(module.exports, "removeAddons", () => $dae1d719957aba3a$export$7a97b8e75199d5bb);
$parcel$export(module.exports, "removeAllAddons", () => $dae1d719957aba3a$export$662ea10b5eaeb84d);
$parcel$export(module.exports, "isCheckedAddons", () => $dae1d719957aba3a$export$9bb7468f9851b84a);
$parcel$export(module.exports, "toggleAddonsPopup", () => $dae1d719957aba3a$export$39dadac5a102a04);
$parcel$export(module.exports, "applyAddons", () => $dae1d719957aba3a$export$434f38e0a33c7954);
$parcel$export(module.exports, "toggleAddonDescription", () => $dae1d719957aba3a$export$2f0d0b83b70cc7ec);
$parcel$export(module.exports, "applyAddon", () => $dae1d719957aba3a$export$d665057f4f875cc9);

var $cIxq8 = parcelRequire("cIxq8");

var $cEKee = parcelRequire("cEKee");

var $fJKn4 = parcelRequire("fJKn4");
function $dae1d719957aba3a$export$134e6f73bd2d8aca(idProcedure, idAddon) {
    idProcedure = parseInt(idProcedure);
    idAddon = parseInt(idAddon);
    let addons = [
        ...(0, $cEKee.selectedAddons),
        {
            id: idAddon,
            procedureId: idProcedure
        }
    ];
    (0, $cEKee.setSelectedAddons)(addons);
    /* Change the checkbox */ const checkBoxes = document.querySelectorAll(`.addon__checkbox[data-procedure-id="${idProcedure}"][data-addon-id="${idAddon}"]`);
    checkBoxes.forEach((i)=>i.classList.add('is-checked'));
    $dae1d719957aba3a$var$updateAfterChangeAddon(idProcedure, idAddon, addons);
}
function $dae1d719957aba3a$export$7a97b8e75199d5bb(idProcedure, idAddon) {
    idProcedure = parseInt(idProcedure);
    idAddon = parseInt(idAddon);
    let addons = (0, $cEKee.selectedAddons).filter((i)=>!(i.id === idAddon && i.procedureId === idProcedure));
    (0, $cEKee.setSelectedAddons)(addons);
    /* Change the checkbox */ const checkBoxes = document.querySelectorAll(`.addon__checkbox[data-procedure-id="${idProcedure}"][data-addon-id="${idAddon}"]`);
    checkBoxes.forEach((i)=>i.classList.remove('is-checked'));
    $dae1d719957aba3a$var$updateAfterChangeAddon(idProcedure, idAddon, addons);
}
function $dae1d719957aba3a$var$updateAfterChangeAddon(idProcedure, idAddon, selectedAddons) {
    /* Check to enable Add-Ons button */ const btn = document.querySelectorAll(`.addons__applyAddonBtn[data-procedure-id="${idProcedure}"]`);
    if (selectedAddons.length > 0) {
        btn.forEach((i)=>i.classList.remove('disabled'));
        btn.forEach((i)=>i.classList.add('enabled'));
    } else {
        btn.forEach((i)=>i.classList.add('disabled'));
        btn.forEach((i)=>i.classList.remove('enabled'));
    }
    /* Change count addon */ const counts = document.querySelectorAll(`.checkbox__count[data-procedure-id="${CSS.escape(idProcedure)}"]`);
    counts.forEach((i)=>{
        i.textContent = selectedAddons.filter((i)=>i.procedureId === idProcedure).length;
    });
    /* Check unable/disabled Apply button in addon description popup */ const applyBtn = document.querySelectorAll(`.addonBody__applyBtn[data-procedure-id="${idProcedure}"][data-addon-id="${idAddon}"]`);
    if (selectedAddons.find((i)=>i.id === idAddon && i.procedureId === idProcedure)) applyBtn.forEach((i)=>i.classList.add('disabled'));
    else applyBtn.forEach((i)=>i.classList.remove('disabled'));
}
function $dae1d719957aba3a$export$662ea10b5eaeb84d(idProcedure) {
    idProcedure = parseInt(idProcedure);
    let addons = (0, $cEKee.selectedAddons).filter((i)=>i.procedureId !== idProcedure);
    (0, $cEKee.setSelectedAddons)(addons);
    $dae1d719957aba3a$export$a791bc72a9925b0c(idProcedure);
    /* Change count addon */ document.querySelectorAll(`.checkbox__count[data-procedure-id="${CSS.escape(idProcedure)}"]`).forEach((i)=>i.textContent = 0);
    /* Change procedure checkbox */ const checkBoxes = document.querySelectorAll(`.procedure__checkbox[data-procedure-id="${CSS.escape(idProcedure)}"]`);
    checkBoxes.forEach((i)=>{
        i.classList.remove('is-checked', 'count');
    });
    /* Check to enable Add-Ons button */ const btn = document.querySelectorAll(`.addons__applyAddonBtn[data-procedure-id="${idProcedure}"]`);
    /* Disable button in apply Add-Ons  */ btn.forEach((i)=>{
        i.classList.remove('enabled');
        i.classList.add('disabled');
    });
    /* Check unable/disabled Apply button in addon description popup */ const applyBtn = document.querySelectorAll(`.addonBody__applyBtn[data-procedure-id="${idProcedure}"]`);
    if (addons.find((i)=>i.procedureId === idProcedure)) applyBtn.forEach((i)=>i.classList.add('disabled'));
    else applyBtn.forEach((i)=>i.classList.remove('disabled'));
}
function $dae1d719957aba3a$export$9bb7468f9851b84a(idProcedure, idAddon) {
    idProcedure = parseInt(idProcedure);
    idAddon = parseInt(idAddon);
    if ((0, $cEKee.selectedAddons).find((i)=>i.id === idAddon && i.procedureId === idProcedure)) return true;
    else return false;
}
function $dae1d719957aba3a$export$39dadac5a102a04(procedureId, category, state) {
    const addonSectionClassName = `.addonsSections__wrapper[data-procedure-id=${CSS.escape(procedureId)}][data-category=${CSS.escape(category)}]`;
    const addonSection = document.querySelector(addonSectionClassName);
    if (state === (0, $cIxq8.OPEN)) {
        addonSection.classList.add('popup__open');
        addonSection.querySelector('.addonsSection__content').classList.add('addonsSection__content--selected');
        addonSection.querySelector('.popup__background').classList.remove('fadeOut');
        addonSection.querySelector('.popup__background').style.willChange = 'opacity';
        addonSection.querySelector('.popup__background').addEventListener('animationend', ()=>{
            addonSection.querySelector('.popup__background').style.willChange = 'auto';
        }, {
            once: true
        });
        addonSection.querySelector('.popup__background').classList.add('fadeIn');
        addonSection.querySelector('.addonsSection__content').classList.remove('fadeOutDown');
        addonSection.querySelector('.addonsSection__content').style.willChange = 'transform, opacity';
        addonSection.querySelector('.addonsSection__content').addEventListener('animationend', ()=>{
            addonSection.querySelector('.addonsSection__content').style.willChange = 'auto';
        }, {
            once: true
        });
        addonSection.querySelector('.addonsSection__content').classList.add('fadeInUp');
    } else if (state === (0, $cIxq8.CLOSE)) {
        addonSection.querySelector('.addonsSection__content').addEventListener('animationend', ()=>{
            addonSection.querySelector('.addonsSection__content').style.willChange = 'auto';
            addonSection.querySelector('.popup__background').style.willChange = 'auto';
            addonSection.classList.remove('popup__open');
            addonSection.querySelector('.addonsSection__content').classList.remove('fadeOutDown');
        }, {
            once: true
        });
        addonSection.querySelector('.addonsSection__content').classList.remove('addonsSection__content--selected');
        addonSection.querySelector('.popup__background').classList.remove('fadeIn');
        addonSection.querySelector('.popup__background').style.willChange = 'opacity, visibility';
        addonSection.querySelector('.popup__background').classList.add('fadeOut');
        addonSection.querySelector('.addonsSection__content').classList.remove('fadeInUp');
        addonSection.querySelector('.addonsSection__content').classList.add('fadeOutDown');
    }
}
function $dae1d719957aba3a$export$a791bc72a9925b0c(procedureId) {
    const checkedBox = document.querySelectorAll(`.addon__checkbox[data-procedure-id="${CSS.escape(procedureId)}"]`);
    checkedBox.forEach((i)=>{
        i.classList.remove('is-checked');
    });
}
function $dae1d719957aba3a$export$434f38e0a33c7954(procedureId) {
    const checkBoxes = document.querySelectorAll(`.procedure__checkbox[data-procedure-id="${CSS.escape(procedureId)}"]`);
    checkBoxes.forEach((i)=>i.classList.add('is-checked', 'count'));
    /* Add procedure */ (0, $fJKn4.addProcedure)(procedureId);
}
function $dae1d719957aba3a$export$2f0d0b83b70cc7ec(procedureId, addonId, category, state) {
    const descriptionWrapper = document.querySelector(`.addonBody__wrapper-line[data-procedure-id="${CSS.escape(procedureId)}"][data-addon-id="${CSS.escape(addonId)}"]`);
    let showAddons = descriptionWrapper.classList.contains('show-addons');
    document.querySelectorAll('.show-addons').forEach((item)=>{
        item.classList.remove('show-addons');
    });
    if (showAddons) descriptionWrapper.classList.add('show-addons');
    descriptionWrapper.classList.toggle('show-addons');
}
function $dae1d719957aba3a$export$d665057f4f875cc9(procedureId, addonId, category) {
    $dae1d719957aba3a$export$134e6f73bd2d8aca(procedureId, addonId);
    $dae1d719957aba3a$export$2f0d0b83b70cc7ec(procedureId, addonId, category, (0, $cIxq8.CLOSE));
}

});
parcelRegister("fJKn4", function(module, exports) {

$parcel$export(module.exports, "addProcedure", () => $b74f07540fd9a2ab$export$d7fbbc5b0098b232);
$parcel$export(module.exports, "removeAllProcedures", () => $b74f07540fd9a2ab$export$9b8b87d25839719b);
$parcel$export(module.exports, "removeProcedure", () => $b74f07540fd9a2ab$export$e9f395b9fb212ccf);
$parcel$export(module.exports, "isCheckedProcedure", () => $b74f07540fd9a2ab$export$56f6bce897209df6);
$parcel$export(module.exports, "toggleProcedureDescription", () => $b74f07540fd9a2ab$export$18169a90e2cc3b96);

var $knjAn = parcelRequire("knjAn");

var $cIxq8 = parcelRequire("cIxq8");

var $cEKee = parcelRequire("cEKee");

var $er9E0 = parcelRequire("er9E0");

var $iN6uF = parcelRequire("iN6uF");

var $iDiGD = parcelRequire("iDiGD");
function $b74f07540fd9a2ab$export$d7fbbc5b0098b232(id) {
    if (0, $cEKee.visitorId) (0, $iDiGD.updateVisitorAction)((0, $cEKee.visitorId), 'selected-service', {
        procedure_id: id
    }).catch((error)=>{
        console.error('Failed to track procedure selection:', error);
    });
    if ((0, $cEKee.procedureSelectionType) === (0, $cIxq8.PROCEDURE_SELECTION_TYPE).SINGLE) $b74f07540fd9a2ab$export$9b8b87d25839719b();
    if ((0, $cEKee.form)?.procedures_max_num_of_selection && (0, $cEKee.selectedProcedures).length === (0, $cEKee.form).procedures_max_num_of_selection) return;
    let proceduresArr = [
        ...(0, $cEKee.selectedProcedures),
        id
    ];
    (0, $cEKee.setSelectedProcedures)(proceduresArr);
    /* Change the checkbox */ const inputChecks = document.querySelectorAll(`.procedure__checkbox[data-procedure-id=${CSS.escape(id)}]`);
    inputChecks.forEach((i)=>i.classList.add('is-checked'));
    /* Change the Add/Remove Procedure button */ const btn = document.querySelectorAll(`.procedure-body__add-procedure-btn[data-procedure-id=${CSS.escape(id)}]`);
    btn.forEach((i)=>i.textContent = (0, $knjAn.t)('remove_procedure'));
    $b74f07540fd9a2ab$export$6771a8429b7c02b2();
    /* Check subProcedures to disable another procedure */ const procedure = (0, $cEKee.procedures).find((i)=>i.id === id);
    const subProceduresId = procedure ? procedure.sub_procedures?.map((i)=>i.id) || [] : [];
    for (const i of subProceduresId){
        let selectedSubProocedures = document.querySelectorAll(`.line__wrapper.procedure[data-procedure-id=${CSS.escape(i)}]`);
        if (selectedSubProocedures && selectedSubProocedures?.length > 0) selectedSubProocedures.forEach((selectedSubProocedure)=>{
            if (selectedSubProocedure) selectedSubProocedure.classList.add('disabled');
        });
        $b74f07540fd9a2ab$var$addDescriptionWhenProcedureDisabled(i, procedure.name);
    }
}
function $b74f07540fd9a2ab$export$e9f395b9fb212ccf(id) {
    let proceduresArr = (0, $cEKee.selectedProcedures).filter((i)=>i !== id);
    (0, $cEKee.setSelectedProcedures)(proceduresArr);
    /* Change the checkbox */ const inputChecks = document.querySelectorAll(`.procedure__checkbox[data-procedure-id=${CSS.escape(id)}]`);
    inputChecks.forEach((i)=>i.classList.remove('is-checked'));
    /* Change the Add/Remove Procedure button */ const btn = document.querySelectorAll(`.procedure-body__add-procedure-btn[data-procedure-id=${CSS.escape(id)}]`);
    btn.forEach((i)=>i.textContent = (0, $knjAn.t)('add_procedure'));
    $b74f07540fd9a2ab$export$6771a8429b7c02b2();
    /* Check subProcedures to enable another procedure */ let selectedProcedure = (0, $cEKee.procedures).find((i)=>i.id === id);
    const subProcedures = selectedProcedure ? selectedProcedure.sub_procedures.map((i)=>i.id) : [];
    for (const i of subProcedures){
        let selectedSubProocedures = document.querySelectorAll(`.line__wrapper.procedure[data-procedure-id=${CSS.escape(i)}]`);
        if (selectedSubProocedures && selectedSubProocedures?.length > 0) selectedSubProocedures.forEach((selectedSubProocedure)=>{
            if (selectedSubProocedure) selectedSubProocedure.classList.remove('disabled');
        });
    }
}
function $b74f07540fd9a2ab$export$9b8b87d25839719b() {
    for (const i of (0, $cEKee.selectedProcedures))(0, $iN6uF.removeAllAddons)(i);
    (0, $cEKee.setSelectedProcedures)([]);
    /* Change the checkbox */ const inputChecks = document.querySelectorAll(`.procedure__checkbox`);
    inputChecks.forEach((i)=>i.classList.remove('is-checked'));
    /* Enable all procedures */ document.querySelectorAll(`.line__wrapper.procedure`).forEach((i)=>i.classList.remove('disabled'));
    $b74f07540fd9a2ab$export$6771a8429b7c02b2();
}
function $b74f07540fd9a2ab$export$56f6bce897209df6(id) {
    if ((0, $cEKee.selectedProcedures).find((i)=>i === id)) return true;
    return false;
}
function $b74f07540fd9a2ab$export$18169a90e2cc3b96(id, state) {
    const descriptionWrapper = document.querySelector(`.procedureBody__wrapper[data-procedure-id="${CSS.escape(id)}"]`);
    if (state === (0, $cIxq8.OPEN)) {
        descriptionWrapper.classList.add('popup__open');
        descriptionWrapper.querySelector('.popup__background').classList.remove('fadeOut');
        descriptionWrapper.querySelector('.popup__background').style.willChange = 'opacity';
        descriptionWrapper.querySelector('.popup__background').addEventListener('animationend', ()=>{
            descriptionWrapper.querySelector('.popup__background').style.willChange = 'auto';
        }, {
            once: true
        });
        descriptionWrapper.querySelector('.popup__background').classList.add('fadeIn');
        descriptionWrapper.querySelector('.procedureBody__content').classList.remove('fadeOutDown');
        descriptionWrapper.querySelector('.procedureBody__content').style.willChange = 'transform, opacity';
        descriptionWrapper.querySelector('.procedureBody__content').addEventListener('animationend', ()=>{
            descriptionWrapper.querySelector('.procedureBody__content').style.willChange = 'auto';
        }, {
            once: true
        });
        descriptionWrapper.querySelector('.procedureBody__content').classList.add('fadeInUp');
    } else if (state === (0, $cIxq8.CLOSE)) {
        descriptionWrapper.querySelector('.procedureBody__content').addEventListener('animationend', ()=>{
            descriptionWrapper.querySelector('.procedureBody__content').style.willChange = 'auto';
            descriptionWrapper.querySelector('.popup__background').style.willChange = 'auto';
            descriptionWrapper.classList.remove('popup__open');
        }, {
            once: true
        });
        descriptionWrapper.querySelector('.popup__background').classList.remove('fadeIn');
        descriptionWrapper.querySelector('.popup__background').style.willChange = 'opacity, visibility';
        descriptionWrapper.querySelector('.popup__background').classList.add('fadeOut');
        descriptionWrapper.querySelector('.procedureBody__content').classList.remove('fadeInUp');
        descriptionWrapper.querySelector('.procedureBody__content').classList.add('fadeOutDown');
    }
}
function $b74f07540fd9a2ab$var$addDescriptionWhenProcedureDisabled(disableId, procedureName) {
    const disableProcedure = document.querySelectorAll(`.line__wrapper.procedure[data-procedure-id=${CSS.escape(disableId)}] .procedure__disableText`);
    disableProcedure.forEach((i)=>{
        i.innerHTML = (0, $knjAn.t)('cannot_select_procedure').replace('{name}', `<b>${procedureName}</b>`);
    });
}
function $b74f07540fd9a2ab$export$6771a8429b7c02b2() {
    const consultBtn = document.querySelector('.procedureContinue__btn');
    if ((0, $cEKee.selectedProcedures).length > 0) {
        consultBtn.removeAttribute('disabled');
        if ((0, $er9E0.params)('mobile')) document.querySelector('.seeServices__container .screen__content > .procedure__actions')?.classList.remove('hide');
    } else {
        consultBtn.setAttribute('disabled', true);
        if ((0, $er9E0.params)('mobile')) document.querySelector('.seeServices__container .screen__content > .procedure__actions')?.classList.add('hide');
    }
}

});
parcelRegister("iDiGD", function(module, exports) {

$parcel$export(module.exports, "createVisitor", () => $d90a5d50bea1af17$export$4c6a754ba35a29d0);
$parcel$export(module.exports, "updateVisitorAction", () => $d90a5d50bea1af17$export$dc381b1498246f93);

var $hvLQT = parcelRequire("hvLQT");
const $d90a5d50bea1af17$var$pendingActions = new Set();
async function $d90a5d50bea1af17$export$4c6a754ba35a29d0(data) {
    return await (0, $hvLQT.apiClient).POST(`api/visitors`, data);
}
async function $d90a5d50bea1af17$export$dc381b1498246f93(visitorId, action, data = {}) {
    if (!visitorId) return Promise.resolve();
    const actionKey = `${visitorId}-${action}-${JSON.stringify(data)}`;
    if ($d90a5d50bea1af17$var$pendingActions.has(actionKey)) return Promise.resolve();
    $d90a5d50bea1af17$var$pendingActions.add(actionKey);
    try {
        const result = await (0, $hvLQT.apiClient).PUT(`api/visitors/${visitorId}/action/${action}`, data);
        return result;
    } catch (error) {
        const status = error?.response?.status;
        if (status === 404) // Visitor not found (e.g. record missing, different env, or DB was reset) – tracking is optional
        return Promise.resolve();
        console.error(`Failed to update visitor action ${action}:`, error);
        throw error;
    } finally{
        setTimeout(()=>{
            $d90a5d50bea1af17$var$pendingActions.delete(actionKey);
        }, 500);
    }
}

});




parcelRegister("8tpUR", function(module, exports) {

$parcel$export(module.exports, "procedureListeners", () => $62b5228b956d164b$export$34d847466322028d);

var $cIxq8 = parcelRequire("cIxq8");

var $cEKee = parcelRequire("cEKee");

var $iN6uF = parcelRequire("iN6uF");

var $fJKn4 = parcelRequire("fJKn4");

var $er9E0 = parcelRequire("er9E0");

var $knjAn = parcelRequire("knjAn");
// Inquiry-only menu items (procedures.online_booking_option === 'inquiry',
// e.g. an "Others" tile): selecting one skips the calendar entirely — the
// visitor gets the thank-you screen and THE_END's updateStep() files the
// lead for front-desk follow-up.
function $62b5228b956d164b$var$routeInquiryProcedure(procedure) {
    if (procedure?.online_booking_option !== 'inquiry') return false;
    const notifyText = document.querySelector('.endScreen__container .notify-text');
    if (notifyText) notifyText.textContent = (0, $knjAn.t)('inquiry_fallback_message');
    (0, $er9E0.navigate)((0, $cIxq8.SCREEN).THE_END);
    return true;
}
function $62b5228b956d164b$export$34d847466322028d() {
    /* on click checkbox */ const procedureItems = document.querySelectorAll('.line__wrapper.procedure');
    const checkBox = document.querySelectorAll('.line__wrapper.procedure .procedure__checkbox');
    const enableCategorySelection = (0, $cEKee.form)?.appointment_channel?.enable_category_selection;
    const enableCategorySelectionForConsultation = (0, $cEKee.form)?.is_category_enabled;
    if ((0, $cEKee.isBookAppointment) && !(0, $cEKee.patientSelected) && !enableCategorySelection && !enableCategorySelectionForConsultation) {
        document.querySelector('.seeServices__container .procedure__actions .backOneStep__btn')?.classList.add('visibility-hidden');
        document.querySelector('.seeServices__container  .back-arrow')?.classList.add('visibility-hidden');
    } else {
        document.querySelector('.seeServices__container .procedure__actions .backOneStep__btn')?.classList?.remove('visibility-hidden');
        document.querySelector('.seeServices__container  .back-arrow')?.classList?.remove('visibility-hidden');
    }
    if ((0, $er9E0.params)('mobile')) document.querySelector('.seeServices__container .screen__content > .procedure__actions')?.classList.add('hide');
    else document.querySelector('.seeServices__container .screen__content > .procedure__actions')?.classList.remove('hide');
    const procedureList = (0, $cEKee.appointmentChannelId) && (0, $cEKee.form)?.appointment_channel?.procedures?.length >= 1 ? (0, $cEKee.form)?.appointment_channel?.procedures : (0, $cEKee.procedures);
    procedureItems.forEach((element, index)=>{
        const procedure = procedureList.find((p)=>p.id === parseInt(element.getAttribute('data-procedure-id')));
        const category = element.getAttribute('data-category');
        checkBox[index].addEventListener('click', (event)=>{
            event.stopPropagation();
            if ($62b5228b956d164b$var$routeInquiryProcedure(procedure)) return;
            if (procedure?.custom_booking_url) {
                window.open(procedure.custom_booking_url, '_blank');
                return;
            }
            (0, $cEKee.setIsClickCheckBox)(true);
            const filterAddOns = procedure?.procedure_addons?.filter((item)=>!item.deleted_at);
            if (filterAddOns?.length > 0) {
                if (procedure.addons_required) (0, $cEKee.setIsClickCheckBox)(false);
                /* Toggle addon popup */ if ((0, $fJKn4.isCheckedProcedure)(procedure.id)) {
                    (0, $fJKn4.removeProcedure)(procedure.id);
                    (0, $iN6uF.removeAllAddons)(procedure.id);
                } else (0, $iN6uF.toggleAddonsPopup)(procedure.id, category, (0, $cIxq8.OPEN));
            } else if ((0, $fJKn4.isCheckedProcedure)(procedure.id)) (0, $fJKn4.removeProcedure)(procedure.id);
            else (0, $fJKn4.addProcedure)(procedure.id);
        });
        element.addEventListener('click', ()=>{
            if ($62b5228b956d164b$var$routeInquiryProcedure(procedure)) return;
            if (procedure?.custom_booking_url) {
                window.open(procedure.custom_booking_url, '_blank');
                return;
            }
            const filterAddOns = procedure?.procedure_addons?.filter((item)=>!item.deleted_at);
            if (filterAddOns?.length > 0) {
                if ((0, $fJKn4.isCheckedProcedure)(procedure.id)) {
                    (0, $fJKn4.removeProcedure)(procedure.id);
                    (0, $iN6uF.removeAllAddons)(procedure.id);
                } else {
                    (0, $cEKee.setIsClickCheckBox)(false);
                    (0, $iN6uF.toggleAddonsPopup)(procedure.id, category, (0, $cIxq8.OPEN));
                }
            } else checkBox[index].click();
        });
    });
    /* on click show information */ const infoBtn = document.querySelectorAll('.procedure__information.procedure');
    infoBtn.forEach((i)=>{
        const procedureId = i.getAttribute('data-procedure-id');
        i.onclick = (e)=>{
            e.stopPropagation();
            (0, $fJKn4.toggleProcedureDescription)(procedureId, (0, $cIxq8.OPEN));
        };
    });
    /* on click close information */ const closeBtn = document.querySelectorAll('.procedure-body__close-btn');
    closeBtn.forEach((i)=>{
        const id = i.getAttribute('data-procedure-id');
        i.onclick = ()=>{
            (0, $fJKn4.toggleProcedureDescription)(id, (0, $cIxq8.CLOSE));
        };
    });
    /* on click outside to close information */ const bg = document.querySelectorAll('.popup__background.procedure__information');
    bg.forEach((i)=>{
        const id = i.getAttribute('data-procedure-id');
        i.onclick = ()=>{
            (0, $fJKn4.toggleProcedureDescription)(id, (0, $cIxq8.CLOSE));
        };
    });
    /* on click Add/Remove Procedure Button */ const btn = document.querySelectorAll('.procedure-body__add-procedure-btn');
    btn.forEach((i)=>{
        const id = parseInt(i.getAttribute('data-procedure-id'));
        const category = i.getAttribute('data-category');
        i.onclick = ()=>{
            if ((0, $fJKn4.isCheckedProcedure)(id)) {
                (0, $fJKn4.removeProcedure)(id);
                (0, $iN6uF.removeAllAddons)(id);
            } else {
                const procedure = (0, $cEKee.procedures).find((i)=>i.id === id);
                const filterAddOns = procedure?.procedure_addons?.filter((item)=>!item.deleted_at);
                if (filterAddOns?.length > 0) (0, $iN6uF.toggleAddonsPopup)(procedure.id, category, (0, $cIxq8.OPEN));
                else (0, $fJKn4.addProcedure)(id);
            }
            (0, $fJKn4.toggleProcedureDescription)(id, (0, $cIxq8.CLOSE));
        };
    });
    /* On click enter */ const screenProcedures = document.querySelector('.screen--procedures');
    if (screenProcedures) screenProcedures.addEventListener('keydown', $62b5228b956d164b$var$handlePressEnter);
}
function $62b5228b956d164b$var$handlePressEnter(event) {
    if (event.key === 'Enter' && !document.querySelector('.procedureContinue__btn').classList.contains('disabled')) document.querySelector('.procedureContinue__btn').click();
}

});

parcelRegister("aROBf", function(module, exports) {

$parcel$export(module.exports, "procedureDisplayName", () => $7e961ab2707c6ab6$export$46384266279b6c55);

var $cEKee = parcelRequire("cEKee");
function $7e961ab2707c6ab6$export$46384266279b6c55(procedure) {
    const name = procedure?.name ?? '';
    if (!(0, $cEKee.form)?.appointment_channel?.delivery_mode_selection) return name;
    if (procedure?.service_delivery_mode === 'fully_virtual') return name.replace(/\s*\((?=[^)]*(?:virtual|telehealth))[^)]*\)\s*$/i, '');
    if (procedure?.service_delivery_mode === 'phone_consultation') return name.replace(/\s*\((?=[^)]*(?:phone|call))[^)]*\)\s*$/i, '');
    return name;
}

});

parcelRegister("lqW7O", function(module, exports) {

$parcel$export(module.exports, "loadAddons", () => $f9a91d1cb987ed7a$export$6319174d79cd0a36);

var $cIxq8 = parcelRequire("cIxq8");

var $cEKee = parcelRequire("cEKee");

var $knjAn = parcelRequire("knjAn");
function $f9a91d1cb987ed7a$export$6319174d79cd0a36(procedureId, category) {
    let addonsContent = ``;
    const procedureList = (0, $cEKee.appointmentChannelId) && (0, $cEKee.form)?.appointment_channel?.procedures?.length >= 1 ? (0, $cEKee.form)?.appointment_channel?.procedures : (0, $cEKee.procedures);
    const procedure = procedureList.find((i)=>i.id === procedureId);
    addonsContent = `
    <div class="popup__background addons" data-procedure-id="${procedureId}" data-category="${category}"></div>
    <div class="addonsSection__content">
        <div class="addonsSection__head">
            <h4 class="addons__title">${(0, $knjAn.t)('select_addons')}</h4>
            <p class="addons__text">
                ( ${procedure.addons_select_type === (0, $cIxq8.ADDONS_SELECT_TYPE).MULTI_SELECT ? (0, $knjAn.t)('select_all_that_applies') : (0, $knjAn.t)('only_one_addon')} )
            </p>
        </div>
        <div class="addonsSections__body">
           ${$f9a91d1cb987ed7a$var$loadAddonList(procedure, category)}
        </div>
        <div class="addonsSection__actions">
            <div class="addons__closeBtn ${procedure?.addons_required ? 'visibility-hidden' : ''}" data-procedure-id="${procedure.id}" data-category="${category}">${(0, $knjAn.t)('no_addons')}</div>
            <div class="addons__applyAddonBtn disabled" data-procedure-id="${procedure.id}" data-category="${category}">${(0, $knjAn.t)('apply_addons')}</div>
        </div>
    </div>
    </div>
    `;
    return addonsContent;
}
function $f9a91d1cb987ed7a$var$loadAddonList(procedure, category) {
    const filterAddOns = procedure?.procedure_addons?.filter((item)=>!item.deleted_at);
    let list = ``;
    const hiddenQuestionLine = (0, $cEKee.isBookAppointment) ? "hidden" : "";
    for (const i of filterAddOns){
        const price = ((i.min_cost ? i.min_cost : 0) + (i.max_cost ? i.max_cost : 0)) / 2;
        const duration = !i.duration ? '' : i.duration > 1 ? i.duration + ' ' + (0, $knjAn.t)('minutes') : i.duration + ' ' + (0, $knjAn.t)('minute');
        list = list.concat(`
            <div class="addons__content">
                <div class="line__wrapper line__wrapper-addon addon" data-procedure-id="${procedure.id}" data-addon-id="${i.id}">
                    <div class='wrapper__addon'>
                    <div class="addon__checkbox" data-procedure-id="${procedure.id}" data-addon-id="${i.id}">
                        <i class="addon__icon-check ri-check-line"></i>
                    </div>
                    <div class="procedure__infor-wrapper">
                        <div class="addon__name--wrapper">
                            <div class="addon__name">${i.name}</div>
                            <div class="procedure__price-duration ${(0, $cEKee.surgicalOption) ? 'hidden' : ''}">${duration}</div>
                        </div>
                        <span class="procedure__price ${(0, $cEKee.isBookAppointment) && price !== 0 && !(0, $cEKee.surgicalOption) ? "" : "hidden"}">+$${price.toLocaleString('en-US', {
            maximumFractionDigits: 2
        })}</span>
                    </div>
                    ${i.description ? `<span class="procedure__information addon" data-procedure-id="${procedure.id}" data-addon-id="${i.id}" data-category="${category}">
                        <i class="ri-question-line ${hiddenQuestionLine}"></i>
                        </span>` : ""}
                    </div>
                    ${i.description ? `
                        <div class='desc__addons addonBody__wrapper-line' data-procedure-id="${procedure.id}" data-addon-id="${i.id}" data-category="${category}">
                        <p class="addon-body__text">${i.description}</p>
                        </div>
                        ` : ''}
                </div>
               
                <div class="addonBody__wrapper" data-procedure-id="${procedure.id}" data-addon-id="${i.id}">
                    ${$f9a91d1cb987ed7a$var$loadAddonInformation(procedure, i, category)}
                </div>
            </div>
        `);
    }
    return list;
}
function $f9a91d1cb987ed7a$var$loadAddonInformation(procedure, addon, category) {
    return `
    <div class="popup__background addon__information" data-procedure-id="${procedure.id}" data-addon-id="${addon.id}" data-category="${category}">
        <div class="addonBody__content">
            <h4 class="addon-body__title">${addon.name}</h4>
            <p class="addon-body__text">${addon.description}</p>
            <div class="addon__actions">
                <div class="addon-body__close-btn" data-procedure-id="${procedure.id}" data-addon-id="${addon.id}" data-category="${category}">
                    <i class="ri-close-line"></i>
                </div>
                <div class="addonBody__applyBtn" data-procedure-id="${procedure.id}" data-addon-id="${addon.id}" data-category="${category}">
                    ${(0, $knjAn.t)('apply')}
                </div>
            </div>
        </div>
    </div>
    `;
}

});

parcelRegister("1GjFv", function(module, exports) {

$parcel$export(module.exports, "loadProcedureInformation", () => $1398f8699c1fa847$export$23beba200511b30);

var $knjAn = parcelRequire("knjAn");

var $aROBf = parcelRequire("aROBf");
function $1398f8699c1fa847$export$23beba200511b30(procedure, category) {
    return `
        <div class="popup__background procedure__information" data-procedure-id="${procedure.id}"></div>
        <div class="procedureBody__content">
            <h4 class="procedureBody__title">${(0, $aROBf.procedureDisplayName)(procedure)}</h4>
            <p class="procedure-body__text">${procedure.description}</p>
            <div class="procedure__actions">
                <div class="procedure-body__close-btn" data-procedure-id="${procedure.id}">
                    <i class="ri-close-line"></i>
                </div>
                <div class="procedure-body__add-procedure-btn" data-procedure-id="${procedure.id}" data-category="${category}">${(0, $knjAn.t)('add_procedure')}</div>
            </div>
        </div>
    `;
}

});


parcelRegister("hKRW3", function(module, exports) {

$parcel$export(module.exports, "setTextForServicesButton", () => $ced091fe2c4f517c$export$e4ca1a621ba62861);
function $ced091fe2c4f517c$export$e4ca1a621ba62861(text) {
    document.querySelector('.procedureContinue__btn').textContent = text;
}

});

parcelRegister("9bGUq", function(module, exports) {

$parcel$export(module.exports, "toggleSelectProcedure", () => $6b066cf7d0b17f47$export$4e6e6b30a170ab0a);
$parcel$export(module.exports, "toggleSelectProvider", () => $6b066cf7d0b17f47$export$444d67524b125ed9);
$parcel$export(module.exports, "isValidFullName", () => $6b066cf7d0b17f47$export$a0889293100b9119);
$parcel$export(module.exports, "clearInputsConsult", () => $6b066cf7d0b17f47$export$d093b1f3b56a3bf4);
$parcel$export(module.exports, "clearLocationDropdown", () => $6b066cf7d0b17f47$export$73e06fa87a67c6c0);
$parcel$export(module.exports, "clearProcedureDropdown", () => $6b066cf7d0b17f47$export$fd4c4d209b0f55dc);
$parcel$export(module.exports, "clearProviderDropdown", () => $6b066cf7d0b17f47$export$8b7bded87a7b2918);
$parcel$export(module.exports, "clearEmailOptin", () => $6b066cf7d0b17f47$export$e7e040026f4c3217);
$parcel$export(module.exports, "toggleLocationDropdown", () => $6b066cf7d0b17f47$export$a20d4962307ec415);
$parcel$export(module.exports, "loadCustomFields", () => $6b066cf7d0b17f47$export$fc70132d796a85db);
$parcel$export(module.exports, "clearCustomFields", () => $6b066cf7d0b17f47$export$d43b16e2fdf88a16);

var $knjAn = parcelRequire("knjAn");

var $cIxq8 = parcelRequire("cIxq8");

var $cEKee = parcelRequire("cEKee");

var $hWSV7 = parcelRequire("hWSV7");

var $gZEOs = parcelRequire("gZEOs");

var $kF2gg = parcelRequire("kF2gg");

var $87Cn1 = parcelRequire("87Cn1");

var $5r2Yt = parcelRequire("5r2Yt");

var $8ZTdz = parcelRequire("8ZTdz");

var $62Jhk = parcelRequire("62Jhk");

var $er9E0 = parcelRequire("er9E0");

var $1BMUZ = parcelRequire("1BMUZ");

var $l4WR9 = parcelRequire("l4WR9");

var $5fptp = parcelRequire("5fptp");

var $cXbcK = parcelRequire("cXbcK");
function $6b066cf7d0b17f47$export$4e6e6b30a170ab0a(state) {
    const procedure = document.querySelector('.procedure__wrapper');
    if (!procedure) return;
    if (state === (0, $cIxq8.CLOSE) || procedure.classList.contains('open')) {
        procedure.classList.remove('open');
        parent.postMessage((0, $cIxq8.EVENT_MESSAGE).ENABLE_SCROLL, "*");
    } else procedure.classList.add('open');
}
function $6b066cf7d0b17f47$export$444d67524b125ed9(state) {
    const provider = document.querySelector('.providersDropdown__wrapper');
    if (!provider) return;
    if (state === (0, $cIxq8.CLOSE) || provider.classList.contains('open')) provider.classList.remove('open');
    else provider.classList.add('open');
}
function $6b066cf7d0b17f47$export$a0889293100b9119(name) {
    if (name.trim().includes(' ')) return true;
    return false;
}
function $6b066cf7d0b17f47$export$d093b1f3b56a3bf4() {
    document.querySelectorAll('.requestConsult__container .valid').forEach((i)=>{
        i.classList.remove('valid');
    });
    document.querySelectorAll('.requestConsult__container .invalid').forEach((i)=>{
        i.classList.remove('invalid');
    });
    document.querySelectorAll('.requestConsult__container input').forEach((i)=>{
        i.value = '';
    });
    $6b066cf7d0b17f47$export$73e06fa87a67c6c0();
    $6b066cf7d0b17f47$export$fd4c4d209b0f55dc();
    $6b066cf7d0b17f47$export$8b7bded87a7b2918();
    $6b066cf7d0b17f47$export$e7e040026f4c3217();
}
function $6b066cf7d0b17f47$export$a20d4962307ec415(state) {
    const location = document.querySelector('.locationsDropdown__wrapper');
    if (state === (0, $cIxq8.CLOSE) || location.classList.contains('open')) location.classList.remove('open');
    else location.classList.add('open');
}
function $6b066cf7d0b17f47$export$73e06fa87a67c6c0() {
    (0, $cEKee.setLocationId)('');
    if ((0, $cEKee.locations).length > 0) {
        const locationConsultElement = document.querySelector('#locationConsult');
        if (locationConsultElement) locationConsultElement.value = '';
        document.querySelector('.requestConsult__container .locationsDropdown__wrapper')?.classList.remove('selected');
    }
}
function $6b066cf7d0b17f47$export$8b7bded87a7b2918() {
    (0, $cEKee.setProviderId)('');
    (0, $cEKee.setNoPreferenceSelected)(false);
    if ((0, $cEKee.providers).length > 1) {
        if (document.querySelector('#providerConsult')) document.querySelector('#providerConsult').value = '';
        if (document.querySelector('.providersDropdown__wrapper')) document.querySelector('.providersDropdown__wrapper').classList.remove('selected');
    }
    if (0, $cEKee.staffId) {
        (0, $cEKee.setProviderId)(+(0, $cEKee.staffId));
        const provider = (0, $cEKee.providers)?.find((p)=>p.id === +(0, $cEKee.staffId));
        const getLocationId = provider?.location_ids?.includes((0, $cEKee.selectedLocation)) ? (0, $cEKee.selectedLocation) : provider?.location_ids[0];
        (0, $cEKee.setLocationId)(getLocationId);
    }
    if ((0, $cEKee.providers).length === 1) {
        const id = (0, $cEKee.providers)[0].id;
        (0, $cEKee.setProviderId)(id);
    }
}
function $6b066cf7d0b17f47$export$fd4c4d209b0f55dc() {
    (0, $cEKee.setProcedureId)('');
    document.querySelector('#procedureConsult').value = '';
    document.querySelector('.requestConsult__container .procedure__wrapper').classList.remove('selected');
}
function $6b066cf7d0b17f47$export$e7e040026f4c3217() {
    (0, $cEKee.setEmailOptin)(false);
    document.querySelectorAll('.emailOptin__checkbox').forEach((i)=>i.classList.remove('is-checked'));
}
function $6b066cf7d0b17f47$export$fc70132d796a85db(custom_fields) {
    // A field flagged `upload_before` shows the photo-upload screen right
    // before it. If the visitor uploads (>=1 `.upload-success`), the field is
    // skipped entirely; if they skip the upload, the question is asked.
    if (custom_fields?.upload_before && (0, $cEKee.fileUploadChannel) && !(0, $cEKee.preQuestionnairePhotosDone)) {
        (0, $kF2gg.uploadPhotosListeners)(()=>{
            (0, $cEKee.setPreQuestionnairePhotosDone)(true);
            const uploaded = document.querySelectorAll('.uploadPhotos__container .upload-success').length > 0;
            if (uploaded) $6b066cf7d0b17f47$var$skipQuestionAfterUpload(custom_fields);
            else $6b066cf7d0b17f47$export$fc70132d796a85db(custom_fields);
        });
        (0, $er9E0.navigate)((0, $cIxq8.SCREEN).UPLOAD_PHOTOS);
        return;
    }
    let html = '';
    let poweredByHtml = (0, $cEKee.isHiddenPoweredBy) ? '' : `
                <span>${(0, $knjAn.t)('powered_by')}<b style="margin-left: 3px;"><u class="powered_by"></u></b></span>
            `;
    switch(custom_fields.type){
        case 'height':
            {
                document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .heightQuestionContinue__btn`)?.classList.remove('disabled');
                document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .heightQuestionContinue__btn .loading__wrapper`)?.classList.add('hidden');
                const valueFeet = document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .height_feet`);
                const valueIn = document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .height_inch`);
                if (valueFeet) valueFeet.value = '';
                if (valueIn) valueIn.value = '';
                const loaderIcon = document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .loader__icon`);
                if (loaderIcon) {
                    loaderIcon.innerHTML = '';
                    loaderIcon.insertAdjacentHTML('beforeend', `<i class="ri-arrow-right-line"></i>`);
                }
                document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .heightQuestion__invalid`)?.classList.add('hidden');
                document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .heightQuestion__valid`)?.classList.add('hidden');
                html = `
            <div class="heightQuestion__container--${custom_fields?.id} heightQuestion__container screen">
                <div class="screen__content screen--height">
                    <div class="title__wrapper">
                        <span class="back-arrow hidden" data-screen="height_question">
                            <i class="ri-arrow-left-s-line"></i>
                        </span>
                        <span class="title__content">${(0, $knjAn.t)('qualification_form')}</span>
                    </div>
                    <div class='progressQuestion'>
                        <span class='progressQuestion__title'>Questions 
                            <span class='questionCurrent'>${(0, $cEKee.progressQuestion)?.currentQuestion || 0}</span> /
                            <span class='questionTotal'>${(0, $cEKee.progressQuestion)?.total || 0}</span></span>
                        <div class='progressQuestion__bar'>
                            <div class='progressQuestion__bar-current' style='width: ${(0, $cEKee.progressQuestion)?.progress || 0}%'></div>
                        </div>
                    </div>
                    <div class="heightboxQuestion__container">
                        <div class="heightQuestions--title">${custom_fields.title}</div>
                        <div class="heightQuestion" data-name=''>
                            <input id="height_feet" type="number" min="3" max="8" class="height_feet" />
                            <h3>${(0, $knjAn.t)('feet')}</h3>
                            <input id="height_inch" type="number" min="0" max="11" class="height_inch"  />
                            <h3>${(0, $knjAn.t)('inches')}</h3>
                            <span class="heightQuestion__valid hidden">
                                <i class="ri-check-line"></i>
                            </span>
                            <span class="heightQuestion__invalid hidden">
                                <i class="ri-close-line"></i>
                            </span>
                        </div>
                    </div>
                    <div class="heightQuestion__actions">
                        <span class="backOneStep__btn back-to-before-step heightQuestionBack__btn" data-screen="heightQuestion">
                            <i class="ri-arrow-left-line"></i>
                        </span>
                        <div class="heightQuestionContinue__btn disabled">
                            ${(0, $knjAn.t)('continue')} <span class="loader__icon"> <i class="ri-arrow-right-line"></i> </span>
                            <div class="loading__wrapper hidden">
                                <div class="loader">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        `;
            }
            break;
        case 'checkbox':
            {
                if (document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .checkboxContinue__btn`)) document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .checkboxContinue__btn`)?.classList.remove('disabled');
                document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .checkboxContinue__btn .loading__wrapper`)?.classList.add('hidden');
                const loaderIcon = document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .loader__icon`);
                if (loaderIcon) {
                    loaderIcon.innerHTML = '';
                    loaderIcon.insertAdjacentHTML('beforeend', `<i class="ri-arrow-right-line"></i>`);
                }
                html = `
                <div class="checkboxQuestion__container checkboxQuestion__container--${custom_fields?.id} screen">
                    <div class="screen__content screen--checkbox">
                        <div class="title__wrapper">
                            <span class="back-arrow hidden" data-screen="checkbox_question">
                                <i class="ri-arrow-left-s-line"></i>
                            </span>
                            <span class="title__content">${(0, $knjAn.t)('qualification_form')}</span>
                        </div>
                        <div class='progressQuestion'>
                            <span class='progressQuestion__title'>Questions 
                                <span class='questionCurrent'>${(0, $cEKee.progressQuestion)?.currentQuestion || 0}</span> /
                                <span class='questionTotal'>${(0, $cEKee.progressQuestion)?.total || 0}</span></span>
                            <div class='progressQuestion__bar'>
                                <div class='progressQuestion__bar-current' style='width: ${(0, $cEKee.progressQuestion)?.progress || 0}%'></div>
                            </div>
                        </div>
                        <div class="content__wrapper">
                            <div class="title__form">${custom_fields?.title || custom_fields?.label || ''}</div>
                            <form name="form-checkbox">
                                <div class="selectCheckboxContainer">
                                        <div class="select__boolean">
                                            <div class="step__list">
                                                <ul class="list-basic"> 
                                                    <li class="select__radio__row"><div>
                                                        <label class="checkbox-lg-container checkbox-round">
                                                            <input id="checkbox" type="radio" name="custom_fields" value="yes">
                                                                <span class="checkmark"></span>
                                                        </label>
                                                        <h3>${(0, $knjAn.t)('yes')}</h3>
                                                    </div></li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div class="select__boolean">
                                            <div class="step__list">
                                                <ul class="list-basic"> 
                                                    <li class="select__radio__row"><div>
                                                        <label class="checkbox-lg-container checkbox-round">
                                                            <input type="radio" id="checkbox" name="custom_fields" value="no">
                                                                <span class="checkmark"></span>
                                                        </label>
                                                        <h3>${(0, $knjAn.t)('no')}</h3>
                                                    </div></li>
                                                </ul>
                                            </div>
                                        </div>
                                </div>
                            </form>
    
                        </div>
                        <div class="checkbox__actions">
                            <span class="backOneStep__btn back-to-before-step checkboxQuestionBack__btn" data-screen="checkbox">
                                <i class="ri-arrow-left-line"></i>
                            </span>
                            <div class="checkboxContinue__btn disabled">
                                ${(0, $knjAn.t)('continue')} <span class="loader__icon"> <i class="ri-arrow-right-line"></i> </span>
                                <div class="loading__wrapper hidden">
                                    <div class="loader">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
    
                    <div class="widget-footer light-bg">
                        <span class="subFooter--1"></span>
                        <span class="subFooter--2"></span>
                        <span class="subFooter--3"></span>
                        <span class="subFooter--4">
                            ${poweredByHtml}
                        </span>
                        <span class="subFooter--5"></span>
                    </div>
                </div>
                `;
            }
            break;
        case 'textarea':
            {
                document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .textareaContinue__btn`)?.classList.remove('disabled');
                document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .textareaContinue__btn .loading__wrapper`)?.classList.add('hidden');
                const textAreaElement = document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .textareaQuestion`);
                const loaderIcon = document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .loader__icon`);
                if (textAreaElement) textAreaElement.value = '';
                if (loaderIcon) {
                    loaderIcon.innerHTML = '';
                    loaderIcon.insertAdjacentHTML('beforeend', `<i class="ri-arrow-right-line"></i>`);
                }
                html = `
            <div class="textareaQuestion__container textareaQuestion__container--${custom_fields?.id} screen">
                <div class="screen__content screen--textarea">
                    <div class="title__wrapper">
                        <span class="back-arrow hidden" data-screen="textarea_question">
                            <i class="ri-arrow-left-s-line"></i>
                        </span>
                        <span class="title__content">${(0, $knjAn.t)('qualification_form')}</span>
                    </div>
                    <div class='progressQuestion'>
                        <span class='progressQuestion__title'>Questions 
                            <span class='questionCurrent'>${(0, $cEKee.progressQuestion)?.currentQuestion || 0}</span> /
                            <span class='questionTotal'>${(0, $cEKee.progressQuestion)?.total || 0}</span></span>
                        <div class='progressQuestion__bar'>
                            <div class='progressQuestion__bar-current' style='width: ${(0, $cEKee.progressQuestion)?.progress || 0}%'></div>
                        </div>
                    </div>
                    <div class="content__wrapper">
                        <div class="title__form">${custom_fields?.title || custom_fields?.label || ''}</div>
                        <form>
                            <div data-form="textareaQuestion" class="form-control">
                                <textarea class="textareaQuestion" id="textareaQuestion" placeholder=""></textarea>
                            </div>
                        </form>
                    </div>
                    <div class="textarea__actions">
                        <span class="backOneStep__btn back-to-before-step textareaQuestionBack__btn" data-screen="textarea">
                            <i class="ri-arrow-left-line"></i>
                        </span>
                        <div class="textareaContinue__btn disabled">
                            ${(0, $knjAn.t)('continue')} <span class="loader__icon"> <i class="ri-arrow-right-line"></i> </span>
                            <div class="loading__wrapper hidden">
                                <div class="loader">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="widget-footer light-bg">
                    <span class="subFooter--1"></span>
                    <span class="subFooter--2"></span>
                    <span class="subFooter--3"></span>
                    <span class="subFooter--4">
                        ${poweredByHtml}
                    </span>
                    <span class="subFooter--5"></span>
                </div>
            </div>
            `;
            }
            break;
        case 'text':
            {
                document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .textQuestionContinue__btn`)?.classList.remove('disabled');
                document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .textQuestionContinue__btn .loading__wrapper`)?.classList.add('hidden');
                const value = document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .textQuestion--input`);
                if (value) value.value = '';
                const loaderIcon = document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .loader__icon`);
                if (loaderIcon) {
                    loaderIcon.innerHTML = '';
                    loaderIcon.insertAdjacentHTML('beforeend', `<i class="ri-arrow-right-line"></i>`);
                }
                document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .textQuestion__invalid`)?.classList.add('hidden');
                document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .textQuestion__valid`)?.classList.add('hidden');
                html = `
            <div class="textQuestion__container--${custom_fields?.id} textQuestion__container screen">
                <div class="screen__content screen--text">
                    <div class="title__wrapper">
                        <span class="back-arrow hidden" data-screen="text_question">
                            <i class="ri-arrow-left-s-line"></i>
                        </span>
                        <span class="title__content">${(0, $knjAn.t)('qualification_form')}</span>
                    </div>
                    <div class='progressQuestion'>
                        <span class='progressQuestion__title'>Questions 
                            <span class='questionCurrent'>${(0, $cEKee.progressQuestion)?.currentQuestion || 0}</span> /
                            <span class='questionTotal'>${(0, $cEKee.progressQuestion)?.total || 0}</span></span>
                        <div class='progressQuestion__bar'>
                            <div class='progressQuestion__bar-current' style='width: ${(0, $cEKee.progressQuestion)?.progress || 0}%'></div>
                        </div>
                    </div>
                    <div class="textboxQuestion__container">
                        <div class="textQuestions--title">${custom_fields.title}</div>
                        <div class="textQuestion" data-name=''>
                            <span class="textQuestion__valid hidden">
                                <i class="ri-check-line"></i>
                            </span>
                            <span class="textQuestion__invalid hidden">
                                <i class="ri-close-line"></i>
                            </span>
                            <input placeholder="${custom_fields?.placeholder || ''}" id="textQuestion" class="textQuestion--input" type="text"
                                autocomplete="off">
                            <label class="textQuestion__label">Text</label>
                        </div>
                    </div>
                    <div class="textQuestion__actions">
                        <span class="backOneStep__btn back-to-before-step textQuestionBack__btn" data-screen="textQuestion">
                            <i class="ri-arrow-left-line"></i>
                        </span>
                        <div class="textQuestionContinue__btn${custom_fields?.required === false ? '' : ' disabled'}">
                            ${(0, $knjAn.t)('continue')} <span class="loader__icon"> <i class="ri-arrow-right-line"></i> </span>
                            <div class="loading__wrapper hidden">
                                <div class="loader">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        `;
            }
            break;
        case 'select':
            {
                document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .selectContinue__btn`)?.classList.remove('disabled');
                document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .selectContinue__btn .loading__wrapper`)?.classList.add('hidden');
                const loaderIcon = document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .loader__icon`);
                if (loaderIcon) {
                    loaderIcon.innerHTML = '';
                    loaderIcon.insertAdjacentHTML('beforeend', `<i class="ri-arrow-right-line"></i>`);
                }
                html = `
                <div class="selectQuestion__container selectQuestion__container--${custom_fields?.id} screen">
                    <div class="screen__content screen--select">
                        <div class="title__wrapper">
                            <span class="back-arrow hidden" data-screen="select_question">
                                <i class="ri-arrow-left-s-line"></i>
                            </span>
                            <span class="title__content">${(0, $knjAn.t)('qualification_form')}</span>
                        </div>
                        <div class='progressQuestion'>
                            <span class='progressQuestion__title'>Questions 
                                <span class='questionCurrent'>${(0, $cEKee.progressQuestion)?.currentQuestion || 0}</span> /
                                <span class='questionTotal'>${(0, $cEKee.progressQuestion)?.total || 0}</span></span>
                            <div class='progressQuestion__bar'>
                                <div class='progressQuestion__bar-current' style='width: ${(0, $cEKee.progressQuestion)?.progress || 0}%'></div>
                            </div>
                        </div>
                        <div class="content__wrapper">
                            <div class="title__form">${custom_fields?.title || custom_fields?.label || ''}</div>
                            <div class="list-question">
                            </div>
                        </div>
                        <div class="select__actions">
                            <span class="backOneStep__btn back-to-before-step selectQuestionBack__btn" data-screen="select">
                                <i class="ri-arrow-left-line"></i>
                            </span>
                            <div class="selectContinue__btn disabled">
                                ${(0, $knjAn.t)('continue')} <span class="loader__icon"> <i class="ri-arrow-right-line"></i> </span>
                                <div class="loading__wrapper hidden">
                                    <div class="loader">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
    
                    <div class="widget-footer light-bg">
                        <span class="subFooter--1"></span>
                        <span class="subFooter--2"></span>
                        <span class="subFooter--3"></span>
                        <span class="subFooter--4">
                            ${poweredByHtml}
                        </span>
                        <span class="subFooter--5"></span>
                    </div>
                </div>
               `;
            }
            break;
        case 'date':
            {
                document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .dateQuestionContinue__btn`)?.classList.add('disabled');
                document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .dateQuestionContinue__btn .loading__wrapper`)?.classList.add('hidden');
                const valueDate = document.querySelector(`${(0, $cEKee.nameScreenDynamic)} #questionDatepicker--${(0, $cEKee.nameScreenDynamic)}`);
                if (valueDate) valueDate.value = '';
                const loaderIcon = document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .loader__icon`);
                if (loaderIcon) {
                    loaderIcon.innerHTML = '';
                    loaderIcon.insertAdjacentHTML('beforeend', `<i class="ri-arrow-right-line"></i>`);
                }
                html = `
            <div class="dateQuestion__container dateQuestion__container--${custom_fields?.id} screen">
                <div class="screen__content screen--date">
                    <div class="title__wrapper">
                        <span class="back-arrow hidden" data-screen="date_question">
                            <i class="ri-arrow-left-s-line"></i>
                        </span>
                        <span class="title__content">${(0, $knjAn.t)('qualification_form')}</span>
                    </div>
                    <div class='progressQuestion'>
                        <span class='progressQuestion__title'>Questions 
                            <span class='questionCurrent'>${(0, $cEKee.progressQuestion)?.currentQuestion || 0}</span> /
                            <span class='questionTotal'>${(0, $cEKee.progressQuestion)?.total || 0}</span></span>
                        <div class='progressQuestion__bar'>
                            <div class='progressQuestion__bar-current' style='width: ${(0, $cEKee.progressQuestion)?.progress || 0}%'></div>
                        </div>
                    </div>
                    <div class="dateboxQuestion__container">
                        <div class="dateQuestions--title">${custom_fields?.title}</div>
                        <div class="dateQuestion">
                            <i data-feather="calendar"></i>
                            <input id="questionDatepicker--dateQuestion__container--${custom_fields?.id}" class="dateQuestion--input" type="text" placeholder="MM/DD/YYYY" readonly>
                        </div>
                    </div>
                    <div class="dateQuestion__actions">
                        <span class="backOneStep__btn back-to-before-step dateQuestionBack__btn" data-screen="dateQuestion">
                            <i class="ri-arrow-left-line"></i>
                        </span>
                        <div class="dateQuestionContinue__btn disabled">
                            ${(0, $knjAn.t)('continue')} <span class="loader__icon"> <i class="ri-arrow-right-line"></i> </span>
                            <div class="loading__wrapper hidden">
                                <div class="loader">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            `;
            }
            break;
        case 'number':
            {
                document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .numberQuestionContinue__btn`)?.classList.remove('disabled');
                document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .numberQuestionContinue__btn .loading__wrapper`)?.classList.add('hidden');
                const value = document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .numberQuestion--input`);
                if (value) value.value = '';
                const loaderIcon = document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .loader__icon`);
                if (loaderIcon) {
                    loaderIcon.innerHTML = '';
                    loaderIcon.insertAdjacentHTML('beforeend', `<i class="ri-arrow-right-line"></i>`);
                }
                document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .numberQuestion__invalid`)?.classList.add('hidden');
                document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .numberQuestion__valid`)?.classList.add('hidden');
                html = `
                <div class="numberQuestion__container--${custom_fields?.id} numberQuestion__container screen">
                    <div class="screen__content screen--number">
                        <div class="title__wrapper">
                            <span class="back-arrow hidden" data-screen="number_question">
                                <i class="ri-arrow-left-s-line"></i>
                            </span>
                            <span class="title__content">${(0, $knjAn.t)('qualification_form')}</span>
                        </div>
                        <div class='progressQuestion'>
                            <span class='progressQuestion__title'>Questions 
                                <span class='questionCurrent'>${(0, $cEKee.progressQuestion)?.currentQuestion || 0}</span> /
                                <span class='questionTotal'>${(0, $cEKee.progressQuestion)?.total || 0}</span></span>
                            <div class='progressQuestion__bar'>
                                <div class='progressQuestion__bar-current' style='width: ${(0, $cEKee.progressQuestion)?.progress || 0}%'></div>
                            </div>
                        </div>
                        <div class="numberboxQuestion__container">
                            <div class="numberQuestions--title">${custom_fields.title}</div>
                            <div class="numberQuestion" data-name=''>
                                <span class="numberQuestion__valid hidden">
                                    <i class="ri-check-line"></i>
                                </span>
                                <span class="numberQuestion__invalid hidden">
                                    <i class="ri-close-line"></i>
                                </span>
                                <input min="0" placeholder="" id="numberQuestion" class="numberQuestion--input" type="number"
                                    autocomplete="off">
                                <label class="numberQuestion__label">Number</label>
                            </div>
                        </div>
                        <div class="numberQuestion__actions">
                            <span class="backOneStep__btn back-to-before-step numberQuestionBack__btn" data-screen="numberQuestion">
                                <i class="ri-arrow-left-line"></i>
                            </span>
                            <div class="numberQuestionContinue__btn disabled">
                                ${(0, $knjAn.t)('continue')} <span class="loader__icon"> <i class="ri-arrow-right-line"></i> </span>
                                <div class="loading__wrapper hidden">
                                    <div class="loader">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            `;
            }
            break;
        case 'multi_select':
            {
                document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .selectContinue__btn`)?.classList.remove('disabled');
                document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .selectContinue__btn .loading__wrapper`)?.classList.add('hidden');
                const loaderIcon = document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .loader__icon`);
                if (loaderIcon) {
                    loaderIcon.innerHTML = '';
                    loaderIcon.insertAdjacentHTML('beforeend', `<i class="ri-arrow-right-line"></i>`);
                }
                html = `
                <div class="selectQuestion__container multi_selectQuestion__container--${custom_fields?.id} screen">
                    <div class="screen__content screen--select">
                        <div class="title__wrapper">
                            <span class="back-arrow hidden" data-screen="multi_select_question">
                                <i class="ri-arrow-left-s-line"></i>
                            </span>
                            <span class="title__content">${(0, $knjAn.t)('qualification_form')}</span>
                        </div>
                        <div class='progressQuestion'>
                            <span class='progressQuestion__title'>Questions 
                                <span class='questionCurrent'>${(0, $cEKee.progressQuestion)?.currentQuestion || 0}</span> /
                                <span class='questionTotal'>${(0, $cEKee.progressQuestion)?.total || 0}</span></span>
                            <div class='progressQuestion__bar'>
                                <div class='progressQuestion__bar-current' style='width: ${(0, $cEKee.progressQuestion)?.progress || 0}%'></div>
                            </div>
                        </div>
                        <div class="content__wrapper">
                            <div class="title__form">${custom_fields?.title || custom_fields?.label || ''}</div>
                            <div class="list-question">
                            </div>
                        </div>
                        <div class="select__actions">
                            <span class="backOneStep__btn back-to-before-step selectQuestionBack__btn" data-screen="multi_select">
                                <i class="ri-arrow-left-line"></i>
                            </span>
                            <div class="selectContinue__btn disabled">
                                ${(0, $knjAn.t)('continue')} <span class="loader__icon"> <i class="ri-arrow-right-line"></i> </span>
                                <div class="loading__wrapper hidden">
                                    <div class="loader">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
    
                    <div class="widget-footer light-bg">
                        <span class="subFooter--1"></span>
                        <span class="subFooter--2"></span>
                        <span class="subFooter--3"></span>
                        <span class="subFooter--4">
                            ${poweredByHtml}
                        </span>
                        <span class="subFooter--5"></span>
                    </div>
                </div>
               `;
            }
            break;
    }
    if (!(0, $cEKee.listNamePageQuestion).find((list)=>list === `.${custom_fields?.type}Question__container--${custom_fields?.id}`)) document.querySelector('.assistant__iframe').insertAdjacentHTML('beforeend', html);
    if (custom_fields?.type === 'date') feather.replace();
    setTimeout(()=>{
        $6b066cf7d0b17f47$var$checkScreenByType(custom_fields.type, custom_fields?.id);
    }, 0);
}
function $6b066cf7d0b17f47$var$checkScreenByType(type, id) {
    (0, $cEKee.setNameScreenDynamic)(`.${type || ''}Question__container--${id || ''}`);
    switch(type){
        case 'text':
            if (!(0, $cEKee.listNamePageQuestion).find((list)=>list === (0, $cEKee.nameScreenDynamic)) || (0, $cEKee.firstQuestion)) {
                (0, $cXbcK.textQuestionListener)();
                if (!(0, $cEKee.firstQuestion)) (0, $cEKee.listNamePageQuestion).push((0, $cEKee.nameScreenDynamic));
                (0, $cEKee.setFirstQuestion)(false);
            }
            (0, $cEKee.setListNamePageQuestion)((0, $cEKee.listNamePageQuestion));
            (0, $er9E0.navigate)((0, $cIxq8.SCREEN).TEXT_QUESTION);
            setTimeout(()=>{
                const textNameInput = document.querySelector(`${(0, $cEKee.nameScreenDynamic)} #textQuestion`);
                if (textNameInput !== document.activeElement) textNameInput.focus();
            }, 500);
            break;
        case 'height':
            if (!(0, $cEKee.listNamePageQuestion).find((list)=>list === (0, $cEKee.nameScreenDynamic)) || (0, $cEKee.firstQuestion)) {
                (0, $62Jhk.heightQuestionListener)();
                if (!(0, $cEKee.firstQuestion)) (0, $cEKee.listNamePageQuestion).push((0, $cEKee.nameScreenDynamic));
                (0, $cEKee.setFirstQuestion)(false);
            }
            (0, $cEKee.setListNamePageQuestion)((0, $cEKee.listNamePageQuestion));
            (0, $er9E0.navigate)((0, $cIxq8.SCREEN).HEIGHT_QUESTION);
            setTimeout(()=>{
                if (document.getElementById('height_feet')) document.getElementById('height_feet').focus();
            }, 500);
            break;
        case 'textarea':
            if (!(0, $cEKee.listNamePageQuestion).find((list)=>list === (0, $cEKee.nameScreenDynamic)) || (0, $cEKee.firstQuestion)) {
                (0, $5fptp.textAreaQuestonListener)();
                if (!(0, $cEKee.firstQuestion)) (0, $cEKee.listNamePageQuestion).push((0, $cEKee.nameScreenDynamic));
                (0, $cEKee.setFirstQuestion)(false);
            }
            (0, $cEKee.setListNamePageQuestion)((0, $cEKee.listNamePageQuestion));
            (0, $er9E0.navigate)((0, $cIxq8.SCREEN).TEXTAREA_QUESTION);
            setTimeout(()=>{
                const textAreaNameInput = document.querySelector(`${(0, $cEKee.nameScreenDynamic)} #textareaQuestion`);
                if (textAreaNameInput !== document.activeElement) textAreaNameInput.focus();
            }, 500);
            break;
        case 'checkbox':
            if (!(0, $cEKee.listNamePageQuestion).find((list)=>list === (0, $cEKee.nameScreenDynamic)) || (0, $cEKee.firstQuestion)) {
                (0, $5r2Yt.checkboxQuestionListener)();
                if (!(0, $cEKee.firstQuestion)) (0, $cEKee.listNamePageQuestion).push((0, $cEKee.nameScreenDynamic));
                (0, $cEKee.setFirstQuestion)(false);
            }
            (0, $cEKee.setListNamePageQuestion)((0, $cEKee.listNamePageQuestion));
            (0, $er9E0.navigate)((0, $cIxq8.SCREEN).CHECKBOX_QUESTION);
            break;
        case 'select':
            if (!(0, $cEKee.listNamePageQuestion).find((list)=>list === (0, $cEKee.nameScreenDynamic)) || (0, $cEKee.firstQuestion)) {
                (0, $l4WR9.selectQuestionListener)();
                if (!(0, $cEKee.firstQuestion)) (0, $cEKee.listNamePageQuestion).push((0, $cEKee.nameScreenDynamic));
                (0, $cEKee.setFirstQuestion)(false);
            }
            (0, $cEKee.setListNamePageQuestion)((0, $cEKee.listNamePageQuestion));
            (0, $er9E0.navigate)((0, $cIxq8.SCREEN).SELECT_QUESTION);
            break;
        case 'date':
            if (!(0, $cEKee.listNamePageQuestion).find((list)=>list === (0, $cEKee.nameScreenDynamic)) || (0, $cEKee.firstQuestion)) {
                (0, $8ZTdz.dateQuestionListener)();
                if (!(0, $cEKee.firstQuestion)) (0, $cEKee.listNamePageQuestion).push((0, $cEKee.nameScreenDynamic));
                (0, $cEKee.setFirstQuestion)(false);
            }
            (0, $cEKee.setListNamePageQuestion)((0, $cEKee.listNamePageQuestion));
            (0, $er9E0.navigate)((0, $cIxq8.SCREEN).DATE_QUESTION);
            setTimeout(()=>{
                const dateQuestionInput = document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .dateQuestion--input.form-control.input`);
                if (dateQuestionInput !== document.activeElement) dateQuestionInput.focus();
            }, 500);
            break;
        case 'number':
            if (!(0, $cEKee.listNamePageQuestion).find((list)=>list === (0, $cEKee.nameScreenDynamic)) || (0, $cEKee.firstQuestion)) {
                (0, $1BMUZ.numberQuestionListener)();
                if (!(0, $cEKee.firstQuestion)) (0, $cEKee.listNamePageQuestion).push((0, $cEKee.nameScreenDynamic));
                (0, $cEKee.setFirstQuestion)(false);
            }
            (0, $cEKee.setListNamePageQuestion)((0, $cEKee.listNamePageQuestion));
            (0, $er9E0.navigate)((0, $cIxq8.SCREEN).NUMBER_QUESTION);
            setTimeout(()=>{
                const numberNameInput = document.querySelector(`${(0, $cEKee.nameScreenDynamic)} #numberQuestion`);
                if (numberNameInput !== document.activeElement) numberNameInput.focus();
            }, 500);
            break;
        case 'multi_select':
            if (!(0, $cEKee.listNamePageQuestion).find((list)=>list === (0, $cEKee.nameScreenDynamic)) || (0, $cEKee.firstQuestion)) {
                (0, $l4WR9.selectQuestionListener)();
                if (!(0, $cEKee.firstQuestion)) (0, $cEKee.listNamePageQuestion).push((0, $cEKee.nameScreenDynamic));
                (0, $cEKee.setFirstQuestion)(false);
            }
            (0, $cEKee.setListNamePageQuestion)((0, $cEKee.listNamePageQuestion));
            (0, $er9E0.navigate)((0, $cIxq8.SCREEN).SELECT_QUESTION);
            break;
    }
}
/**
 * Advance past an `upload_before` field the visitor satisfied by uploading.
 * If it was the last question, submit the collected answers and move on
 * (mirrors the last-question path in the per-question listeners).
 */ async function $6b066cf7d0b17f47$var$skipQuestionAfterUpload(field) {
    const fields = (0, $cEKee.questionnaireFields)?.length ? (0, $cEKee.questionnaireFields) : (0, $cEKee.form)?.appointment_channel?.qualification_form?.custom_fields ?? (0, $cEKee.form)?.form?.custom_fields ?? [];
    const idx = fields.findIndex((f)=>f && f.id == field.id);
    if (idx !== -1 && idx < fields.length - 1) {
        (0, $cEKee.setProgressQuestion)({
            ...(0, $cEKee.progressQuestion),
            currentQuestion: (0, $cEKee.progressQuestion).currentQuestion + 1,
            progress: ((0, $cEKee.progressQuestion).currentQuestion + 1) / (0, $cEKee.progressQuestion).total * 100
        });
        $6b066cf7d0b17f47$export$fc70132d796a85db(fields[idx + 1]);
        return;
    }
    try {
        const formId = (0, $cEKee.questionnaireFormId) ?? (0, $cEKee.form)?.form?.id;
        const fieldLabels = {};
        fields.forEach((f)=>{
            if (f && f.id) fieldLabels[f.id] = f.label || f.title || (0, $knjAn.t)('custom_field');
        });
        // The skipped question has no typed answer — record the upload as its
        // response, otherwise an all-upload questionnaire submits an empty
        // payload and the API's `custom_fields => required` rule 422s.
        const answers = {
            ...(0, $cEKee.listDataQuestion),
            [field.id]: (0, $cEKee.listDataQuestion)?.[field.id] || (0, $knjAn.t)('uploaded')
        };
        if (typeof formId === 'string' && formId.startsWith('ac-')) {
            const acId = parseInt(formId.replace(/^ac-/, ''), 10);
            await (0, $hWSV7.updateQualificationResponses)((0, $cEKee.leadTextId), acId, answers, fieldLabels);
        } else await (0, $hWSV7.updateConsultRequestFields)((0, $cEKee.leadTextId), answers, fieldLabels);
        $6b066cf7d0b17f47$export$d43b16e2fdf88a16();
        (0, $cEKee.clearQuestionnaireContext)();
        (0, $87Cn1.navigateToNextPage)();
    } catch (error) {
        (0, $gZEOs.toastError)(error.response?.data?.message);
    }
}
function $6b066cf7d0b17f47$export$d43b16e2fdf88a16() {
    /* Clear data custom_fields and list name page question */ (0, $cEKee.setListDataQuestion)({});
    (0, $cEKee.setListNamePageQuestion)([]);
    (0, $cEKee.setNameScreenDynamic)('');
    if (document.querySelector('.textQuestion__container')) document.querySelector('.textQuestion__container').remove();
    if (document.querySelector('.textareaQuestion__container')) {
        document.querySelector('.textareaQuestion__container').remove();
        document.querySelectorAll('.textareaQuestion__container')?.forEach((element)=>{
            element.remove();
        });
    }
    if (document.querySelector('.checkboxQuestion__container')) {
        document.querySelector('.checkboxQuestion__container').remove();
        document.querySelectorAll('.checkboxQuestion__container')?.forEach((element)=>{
            element.remove();
        });
    }
    if (document.querySelector('.selectQuestion__container')) document.querySelector('.selectQuestion__container').remove();
    if (document.querySelector('.dateQuestion__container')) document.querySelector('.dateQuestion__container').remove();
    if (document.querySelector('.numberQuestion__container')) document.querySelector('.numberQuestion__container').remove();
    if (document.querySelector('.heightQuestion__container')) document.querySelector('.heightQuestion__container').remove();
}

});
parcelRegister("hWSV7", function(module, exports) {

$parcel$export(module.exports, "updateConsultRequestFields", () => $d11274786ff8662b$export$2b69bf04a28dbe08);
$parcel$export(module.exports, "updateQualificationResponses", () => $d11274786ff8662b$export$92a4070d36475c83);

var $hvLQT = parcelRequire("hvLQT");
async function $d11274786ff8662b$export$1eea2fa74a3f3069(data) {
    return await (0, $hvLQT.apiClient).PUT(`api/templates/${data.id}/response`, {
        lead_text_id: data.lead_text_id,
        custom_fields: data.custom_fields
    });
}
async function $d11274786ff8662b$export$2b69bf04a28dbe08(leadTextId, customFields, fieldLabels = {}) {
    const body = {
        custom_fields: customFields
    };
    if (Object.keys(fieldLabels).length > 0) body.field_labels = fieldLabels;
    return await (0, $hvLQT.apiClient).PUT(`api/widget/leads/${leadTextId}/consult-request-fields`, body);
}
async function $d11274786ff8662b$export$92a4070d36475c83(leadTextId, appointmentChannelId, customFields, fieldLabels = {}, eventId = null) {
    const body = {
        appointment_channel_id: appointmentChannelId,
        custom_fields: customFields
    };
    if (Object.keys(fieldLabels).length > 0) body.field_labels = fieldLabels;
    if (eventId) body.event_id = eventId;
    return await (0, $hvLQT.apiClient).PUT(`api/widget/leads/${leadTextId}/qualification-responses`, body);
}

});

parcelRegister("gZEOs", function(module, exports) {

$parcel$export(module.exports, "toastError", () => $c5f2007317ce516f$export$2c5af35fde2282e7);

var $knjAn = parcelRequire("knjAn");
var $c5f2007317ce516f$var$timeOut = null;
const $c5f2007317ce516f$var$awaitTimeout = (delay)=>new Promise((resolve)=>$c5f2007317ce516f$var$timeOut = setTimeout(resolve, delay));
function $c5f2007317ce516f$export$2c5af35fde2282e7(message) {
    message = (0, $knjAn.translateServerError)(message);
    clearTimeout($c5f2007317ce516f$var$timeOut);
    const error = document.querySelector('.toast__container.error');
    error.querySelector('.error-msg').textContent = message;
    error.classList.add('show');
    $c5f2007317ce516f$var$awaitTimeout(5000).then($c5f2007317ce516f$var$closeErrorToast);
    document.querySelector('.toast__container.error .close-error').addEventListener('click', $c5f2007317ce516f$var$closeErrorToast);
}
function $c5f2007317ce516f$var$closeErrorToast() {
    const error = document.querySelector('.toast__container.error');
    error.addEventListener('transitionend', ()=>{
        error.querySelector('.error-msg').textContent = '';
    }, {
        once: true
    });
    error.classList.remove('show');
    clearTimeout($c5f2007317ce516f$var$timeOut);
}

});

parcelRegister("kF2gg", function(module, exports) {

$parcel$export(module.exports, "uploadPhotosListeners", () => $f0a96407b4db16ab$export$672ea0ef5f4d75af);

var $fmRoT = parcelRequire("fmRoT");

var $knjAn = parcelRequire("knjAn");

var $j59WD = parcelRequire("j59WD");

var $cIxq8 = parcelRequire("cIxq8");

var $cEKee = parcelRequire("cEKee");

var $gZEOs = parcelRequire("gZEOs");

var $er9E0 = parcelRequire("er9E0");
let $f0a96407b4db16ab$var$continueHandler = null;
/**
 * The card list comes from channelable.config (a JSON string set per project).
 * A channel saved without config used to render a header with ZERO upload
 * targets (the generic dropzone in the markup is permanently hidden and has
 * no handlers) — fall back to a single generic card so the screen is always
 * actionable.
 */ function $f0a96407b4db16ab$var$getUploadConfigOptions() {
    try {
        const parsed = JSON.parse((0, $cEKee.fileUploadChannel).channelable?.config);
        if (Array.isArray(parsed) && parsed.length > 0) return parsed;
    } catch (e) {
    // null / malformed config — use the fallback card
    }
    return [
        {
            id: 1,
            name: (0, $knjAn.t)('upload_your_photos')
        }
    ];
}
function $f0a96407b4db16ab$export$672ea0ef5f4d75af(onContinue) {
    if ((0, $cEKee.form)?.form?.custom_fields?.length > 0) {
        document.querySelector('.uploadPhotos__container .back-arrow')?.classList.add('hidden');
        document.querySelector('.uploadPhotos__container .uploadPhotos__actions .backOneStep__btn')?.classList.add('hidden');
    }
    const btnContinueUploads = document.querySelector('.uploadPhotos__container .uploadPhotosContinue__btn');
    if ((0, $cEKee.fileUploadChannel).channelable.required) {
        btnContinueUploads.innerHTML = `${(0, $knjAn.t)('continue')} <i class="ri-arrow-right-line"></i>`;
        btnContinueUploads.classList.add('disabled');
        feather.replace();
    }
    document.querySelector('.uploadPhotos__container .uploadPhotosContent').style.background = `${0, $cEKee.primaryColor}09`;
    document.querySelector('.uploadPhotos__container .uploadPhotosTop__heading-desc').innerText = (0, $cEKee.fileUploadChannel).channelable.description;
    $f0a96407b4db16ab$var$uploadPhotosListen(onContinue);
}
function $f0a96407b4db16ab$var$uploadPhotosListen(onContinue) {
    $f0a96407b4db16ab$var$loadListConfigOption();
    $f0a96407b4db16ab$var$loadEventForUploadFiles();
    /* On click enter */ const screenPhone = document.querySelector('.screen--uploads');
    if (screenPhone) screenPhone.addEventListener('keydown', (event)=>{
        if (event.key === 'Enter' && !document.querySelector('.uploadPhotosContinue__btn').classList.contains('disabled')) document.querySelector('.uploadPhotosContinue__btn').click();
    });
    /* on click Continue*/ const continueBtn = document.querySelector('.uploadPhotosContinue__btn');
    if ($f0a96407b4db16ab$var$continueHandler) continueBtn.removeEventListener('click', $f0a96407b4db16ab$var$continueHandler);
    $f0a96407b4db16ab$var$continueHandler = ()=>{
        if (typeof onContinue === 'function') onContinue();
        else (0, $er9E0.navigate)((0, $cIxq8.SCREEN).THE_END);
    };
    continueBtn.addEventListener('click', $f0a96407b4db16ab$var$continueHandler);
}
function $f0a96407b4db16ab$var$validateImage(image) {
    const extensions = [
        'jpeg',
        'png',
        'jpg',
        'gif'
    ];
    const fileExtension = image.type.split('/').pop();
    const fileSize = Math.round(image.size / 1024);
    if (fileSize > 100000) return {
        checkImage: false,
        error: (0, $knjAn.t)('image_size_error')
    };
    if (!extensions.includes(fileExtension)) return {
        checkImage: false,
        error: (0, $knjAn.t)('image_type_error')
    };
    return {
        checkImage: true
    };
}
function $f0a96407b4db16ab$var$handleUploadFiles(files, indexFileOptionConfig) {
    const photosUploadButton = document.querySelector('.uploadPhotos__container .uploadPhotosContinue__btn');
    let countFile = 0;
    Array.from(files)?.length > 0 && Array.from(files)?.forEach((fileImage)=>{
        const validImage = $f0a96407b4db16ab$var$validateImage(fileImage);
        if (validImage?.checkImage) {
            const CancelToken = (0, (/*@__PURE__*/$parcel$interopDefault($fmRoT))).CancelToken;
            const source = CancelToken.source();
            const elementItem = document.querySelector(`.imagesUploadItem-${indexFileOptionConfig}`);
            $f0a96407b4db16ab$export$3fd30d0b301f97b0(fileImage, (compressedItem)=>{
                const formData = new FormData();
                formData.append('file', compressedItem);
                formData.append('original_name', fileImage.name);
                formData.append('name', fileImage.name);
                if (photosUploadButton) photosUploadButton.classList.add('disabled');
                (0, $j59WD.uploadPhoto)(formData, elementItem, source).then(()=>{
                    countFile += 1;
                    if (countFile == Array.from(files)?.length) {
                        elementItem.querySelector('.button')?.classList.add('upload-success');
                        elementItem.querySelector('.button').innerHTML = ` <svg
                                                data-src="assets/icons/check-icon.svg"></svg>
                                            <span>${(0, $knjAn.t)('uploaded')}</span>`;
                        $f0a96407b4db16ab$var$checkRequiredUploads();
                    }
                    photosUploadButton.classList.remove('disabled');
                }).catch(()=>{
                    elementItem.querySelector('.button')?.classList.add('upload-failed');
                    elementItem.querySelector('.button').innerHTML = `  
                                            <i data-feather="x-circle"></i>
                                            <span>${(0, $knjAn.t)('upload_failed_status')}</span>`;
                    feather.replace();
                    if (photosUploadButton) photosUploadButton.classList.remove('disabled');
                });
            });
        } else (0, $gZEOs.toastError)(validImage?.error);
    });
}
function $f0a96407b4db16ab$export$3fd30d0b301f97b0(imageFile, callback) {
    let options = {
        maxSizeMB: 1,
        maxWidthOrHeight: 1920,
        useWebWorker: true
    };
    imageCompression(imageFile, options).then(function(compressedFile) {
        callback(compressedFile);
    }).catch(function(error) {
        (0, $gZEOs.toastError)(error.message);
    });
}
function $f0a96407b4db16ab$var$handleFileInputChange(event) {
    event.preventDefault();
    const files = event.target.files;
    $f0a96407b4db16ab$var$handleUploadFiles(files, event.target.getAttribute('data-id'));
}
function $f0a96407b4db16ab$var$handleFileDragOver(event) {
    event.preventDefault();
    this.classList.add('hover');
}
function $f0a96407b4db16ab$var$handleFileDragLeave(event) {
    event.preventDefault();
    this.classList.remove('hover');
}
function $f0a96407b4db16ab$var$handleFileDrop(event) {
    const inputFile = document.querySelector('.uploadPhotos__container input[type=file]');
    inputFile.value = '';
    event.preventDefault();
    this.classList.remove('hover');
    const files = event.dataTransfer.files;
    $f0a96407b4db16ab$var$handleUploadFiles(files, event.target.getAttribute('data-id'));
}
function $f0a96407b4db16ab$var$handleClickInputFile() {
    this.value = '';
}
function $f0a96407b4db16ab$var$checkRequiredUploads() {
    const photosUploadSuccess = document.querySelectorAll('.uploadPhotos__container .imagesUpload .imagesUploadItem .button');
    if (!(0, $cEKee.fileUploadChannel).channelable.required) {
        document.querySelector('.uploadPhotos__container .uploadPhotosContinue__btn').innerHTML = `${photosUploadSuccess.length > 0 ? (0, $knjAn.t)('continue') : (0, $knjAn.t)('skip_step')}
            <i class="ri-arrow-right-line"></i>`;
        feather.replace();
    } else {
        let countOptionFileConfig = 0;
        photosUploadSuccess.forEach((photoItem)=>{
            if (photoItem.classList.contains('upload-success')) countOptionFileConfig += 1;
            if (countOptionFileConfig == $f0a96407b4db16ab$var$getUploadConfigOptions().length) document.querySelector('.uploadPhotos__container .uploadPhotosContinue__btn').classList.remove('disabled');
        });
    }
}
function $f0a96407b4db16ab$var$loadListConfigOption() {
    const imagesUpload = document.querySelector('.uploadPhotos__container .imagesUpload');
    if (imagesUpload) // The listener can run more than once per session (e.g. re-entering
    // the flow) — re-appending would duplicate cards and lose upload state.
    {
        if (imagesUpload.children.length === 0) {
            let optionList = ``;
            for (const i of $f0a96407b4db16ab$var$getUploadConfigOptions())optionList = optionList.concat(`
                    <label class="label-${i.id}" data-id="${i.id}">
                        <div class="imagesUploadItem imagesUploadItem-${i.id}" data-id="${i.id}">
                            <div class="imagesUploadItem__info imagesUploadItem__info-${i.id}" data-id="${i.id}">
                                <div class="wrapName wrapName-${i.id}" data-id="${i.id}">
                                    <span class="imagesName imagesName-${i.id}" data-id="${i.id}">
                                    ${i.name}
                                    </span>
                                </div>
                            </div>
                            <div class="button button-${i.id}" data-id="${i.id}">
                            
                                    <span class="text-${i.id}" data-id="${i.id}">${(0, $knjAn.t)('upload')}</span>
                                    <input type="file" class="file-${i.id}" data-id="${i.id}" multiple hidden accept="image/png, image/gif, image/jpeg" />
                            </div>
                        </div>
                    </label>
                `);
            imagesUpload.insertAdjacentHTML(`beforeend`, optionList);
        }
    }
}
function $f0a96407b4db16ab$var$loadEventForUploadFiles() {
    for (const i of $f0a96407b4db16ab$var$getUploadConfigOptions()){
        const inputFile = document.querySelector(`.button-${i.id} input[type=file]`);
        const labelDrag = document.querySelector(`.label-${i.id}`);
        if (inputFile) {
            inputFile.addEventListener('change', $f0a96407b4db16ab$var$handleFileInputChange);
            inputFile.addEventListener('click', $f0a96407b4db16ab$var$handleClickInputFile);
        }
        if (labelDrag) {
            labelDrag.addEventListener('dragover', $f0a96407b4db16ab$var$handleFileDragOver);
            labelDrag.addEventListener('dragleave', $f0a96407b4db16ab$var$handleFileDragLeave);
            labelDrag.addEventListener('drop', $f0a96407b4db16ab$var$handleFileDrop);
        }
    }
}

});
parcelRegister("j59WD", function(module, exports) {

$parcel$export(module.exports, "uploadPhoto", () => $de4632c6ecaa9848$export$9bde0b6b4b88c9f2);

var $fmRoT = parcelRequire("fmRoT");

var $hvLQT = parcelRequire("hvLQT");

var $cEKee = parcelRequire("cEKee");
async function $de4632c6ecaa9848$export$9bde0b6b4b88c9f2(formData, item, source) {
    item.querySelector('.button').innerText = 'Uploading';
    return await (0, (/*@__PURE__*/$parcel$interopDefault($fmRoT))).request({
        headers: {
            ...(0, $hvLQT.apiClient).config().headers,
            "Content-Type": "multipart/form-data",
            Accept: 'application/json'
        },
        cancelToken: source.token,
        url: `${(0, $hvLQT.apiClient).apiUrl(`api/widget/leads/${(0, $cEKee.leadInfo)?.text_id}/files`)}`,
        method: 'post',
        data: formData
    });
}

});


parcelRegister("87Cn1", function(module, exports) {

$parcel$export(module.exports, "navigateToNextPage", () => $5e9cbdbf71a22eca$export$7eee81f3ef524f4b);
$parcel$export(module.exports, "navigateToNextPageWithClearFields", () => $5e9cbdbf71a22eca$export$c9faecbac686e1ba);

var $cIxq8 = parcelRequire("cIxq8");

var $cEKee = parcelRequire("cEKee");

var $9bGUq = parcelRequire("9bGUq");

var $kF2gg = parcelRequire("kF2gg");

var $er9E0 = parcelRequire("er9E0");

var $bsb2b = parcelRequire("bsb2b");

var $alq6e = parcelRequire("alq6e");
async function $5e9cbdbf71a22eca$export$7eee81f3ef524f4b() {
    const appointmentRequestType = (0, $cEKee.form).appointment_request_type;
    if (appointmentRequestType === (0, $cIxq8.APPOINTMENT_REQUEST_CALENDAR)) {
        if ((0, $cEKee.appointmentChannelId) && (0, $cEKee.leadInfo)) {
            // Questionnaire ran before calendar — no time selected yet, go to calendar
            if (!(0, $cEKee.selectedAppointmentUnixTime) && (0, $cEKee.form)?.appointment_channel?.show_questionnaire_before_scheduling) {
                (0, $er9E0.openBookAppointment)();
                return;
            }
            await (0, $alq6e.appointmentItemsClickEventHandler)((0, $cEKee.selectedAppointmentUnixTime), (0, $cEKee.leadInfo));
        } else {
            (0, $er9E0.navigate)((0, $cIxq8.SCREEN).VERIFY_INFORMATION);
            (0, $bsb2b.verifyInforListeners)((0, $cEKee.leadInfo));
        }
    } else if ((0, $cEKee.fileUploadChannel) && !(0, $cEKee.preQuestionnairePhotosDone)) {
        (0, $kF2gg.uploadPhotosListeners)();
        (0, $er9E0.navigate)((0, $cIxq8.SCREEN).UPLOAD_PHOTOS);
    } else (0, $er9E0.navigate)((0, $cIxq8.SCREEN).THE_END);
}
async function $5e9cbdbf71a22eca$export$c9faecbac686e1ba() {
    const apiRequestType = (0, $cEKee.form).appointment_request_type;
    let appointmentRequestType = apiRequestType === (0, $cIxq8.APPOINTMENT_REQUEST_FORM) ? (0, $cIxq8.APPOINTMENT_REQUEST_FORM) : (0, $cEKee.appointmentChannelId) ? (0, $cIxq8.APPOINTMENT_REQUEST_CALENDAR) : apiRequestType;
    if (appointmentRequestType === (0, $cIxq8.APPOINTMENT_REQUEST_CALENDAR)) {
        if ((0, $cEKee.appointmentChannelId) && (0, $cEKee.leadInfo)) {
            // Questionnaire ran before calendar — no time selected yet, go to calendar
            if (!(0, $cEKee.selectedAppointmentUnixTime) && (0, $cEKee.form)?.appointment_channel?.show_questionnaire_before_scheduling) {
                (0, $er9E0.openBookAppointment)();
                return;
            }
            await (0, $alq6e.appointmentItemsClickEventHandler)((0, $cEKee.selectedAppointmentUnixTime), (0, $cEKee.leadInfo));
        } else {
            (0, $er9E0.navigate)((0, $cIxq8.SCREEN).VERIFY_INFORMATION);
            (0, $bsb2b.verifyInforListeners)((0, $cEKee.leadInfo));
        }
    } else if ((0, $cEKee.fileUploadChannel) && !(0, $cEKee.preQuestionnairePhotosDone)) {
        (0, $kF2gg.uploadPhotosListeners)();
        (0, $er9E0.navigate)((0, $cIxq8.SCREEN).UPLOAD_PHOTOS).finally(()=>{
            (0, $9bGUq.clearCustomFields)();
        });
    } else (0, $er9E0.navigate)((0, $cIxq8.SCREEN).THE_END).finally(()=>{
        (0, $9bGUq.clearCustomFields)();
    });
}

});
parcelRegister("bsb2b", function(module, exports) {

$parcel$export(module.exports, "verifyInforListeners", () => $856ade642e447290$export$328e65d266f4e9a2);

var $gZEOs = parcelRequire("gZEOs");

var $cEKee = parcelRequire("cEKee");

var $8FUcK = parcelRequire("8FUcK");

var $k3ko8 = parcelRequire("k3ko8");

var $jmDLz = parcelRequire("jmDLz");

var $alq6e = parcelRequire("alq6e");

var $99TAZ = parcelRequire("99TAZ");

var $6jZoE = parcelRequire("6jZoE");

var $cIxq8 = parcelRequire("cIxq8");

var $er9E0 = parcelRequire("er9E0");

var $5oy7H = parcelRequire("5oy7H");

var $cFczh = parcelRequire("cFczh");

var $g2qZ3 = parcelRequire("g2qZ3");
var $856ade642e447290$var$verifySimpleConsentChecked = false;
function $856ade642e447290$export$328e65d266f4e9a2(lead) {
    // URL-param prefill (marketing handoff) fills only the gaps — any
    // server-known lead value wins over the query string.
    lead = (0, $cFczh.applyLeadPrefillDefaults)(lead);
    (0, $8FUcK.renderUIEditInfoLead)(lead);
    // Load language dropdown if enabled
    if ((0, $cEKee.form)?.show_language_dropdown) (0, $6jZoE.loadLanguageDropdownVerify)(lead?.language);
    // Reset consent state for this flow
    $856ade642e447290$var$verifySimpleConsentChecked = false;
    /* On click enter */ const screenPhone = document.querySelector('.verifyInformation__container');
    if (screenPhone) {
        // Re-entering this screen must not stack a second handler.
        screenPhone.removeEventListener('keydown', $856ade642e447290$var$handlePressEnter);
        screenPhone.addEventListener('keydown', $856ade642e447290$var$handlePressEnter);
    }
    $856ade642e447290$var$editInfoListener();
    // Initialize consent checkbox listeners for verify-info form
    $856ade642e447290$var$initVerifyConsentListeners();
    // Clear any stale in-flight `.disabled` lock from a previous visit. The
    // button is never disabled for missing input — clicking it jumps to the
    // first missing field instead (onClickContinueBtn), because a dead button
    // on a form that scrolls off-screen gives no hint what's wrong.
    $856ade642e447290$var$checkContinueBtnState();
}
function $856ade642e447290$var$initVerifyConsentListeners() {
    const container = document.querySelector('.verifyInformation__container');
    if (!container) return;
    if (0, $cEKee.a2pConsentEnabled) {
        // A2P mode: 3 checkboxes
        const transactionalCheckbox = container.querySelector('.sms-consent-transactional-checkbox');
        const promotionalCheckbox = container.querySelector('.sms-consent-promotional-checkbox');
        const termsPrivacyCheckbox = container.querySelector('.terms-privacy-checkbox');
        const transactionalRow = container.querySelector('.sms-consent-transactional-row');
        const promotionalRow = container.querySelector('.sms-consent-promotional-row');
        const termsPrivacyRow = container.querySelector('.terms-privacy-row');
        const handleTransactionalClick = (e)=>{
            e.preventDefault();
            if (transactionalCheckbox) {
                transactionalCheckbox.classList.toggle('is-checked');
                (0, $cEKee.setSmsConsentTransactional)(transactionalCheckbox.classList.contains('is-checked'));
                transactionalRow?.classList.remove('invalid');
                $856ade642e447290$var$checkContinueBtnState();
            }
        };
        const handlePromotionalClick = (e)=>{
            e.preventDefault();
            if (promotionalCheckbox) {
                promotionalCheckbox.classList.toggle('is-checked');
                (0, $cEKee.setSmsConsentPromotional)(promotionalCheckbox.classList.contains('is-checked'));
                $856ade642e447290$var$checkContinueBtnState();
            }
        };
        const handleTermsPrivacyClick = (e)=>{
            if (e.target.closest('.terms-link') || e.target.closest('.privacy-link')) return;
            e.preventDefault();
            if (termsPrivacyCheckbox) {
                termsPrivacyCheckbox.classList.toggle('is-checked');
                (0, $cEKee.setTermsAndPrivacyAccepted)(termsPrivacyCheckbox.classList.contains('is-checked'));
                termsPrivacyRow?.classList.remove('invalid');
                $856ade642e447290$var$checkContinueBtnState();
            }
        };
        if (transactionalRow && transactionalCheckbox) {
            transactionalRow.style.cursor = 'pointer';
            transactionalRow.onclick = handleTransactionalClick;
            transactionalCheckbox.addEventListener('keydown', (e)=>{
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    handleTransactionalClick(e);
                }
            });
        }
        if (promotionalRow && promotionalCheckbox) {
            promotionalRow.style.cursor = 'pointer';
            promotionalRow.onclick = handlePromotionalClick;
            promotionalCheckbox.addEventListener('keydown', (e)=>{
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    handlePromotionalClick(e);
                }
            });
        }
        if (termsPrivacyRow && termsPrivacyCheckbox) {
            termsPrivacyRow.style.cursor = 'pointer';
            termsPrivacyRow.onclick = handleTermsPrivacyClick;
            termsPrivacyCheckbox.addEventListener('keydown', (e)=>{
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    handleTermsPrivacyClick(e);
                }
            });
        }
    } else {
        // Simple mode: single checkbox
        const simpleCheckbox = container.querySelector('.sms-consent-simple-checkbox');
        const simpleRow = container.querySelector('.sms-consent-simple-row');
        const handleSimpleClick = (e)=>{
            e.preventDefault();
            if (simpleCheckbox) {
                simpleCheckbox.classList.toggle('is-checked');
                $856ade642e447290$var$verifySimpleConsentChecked = simpleCheckbox.classList.contains('is-checked');
                if ($856ade642e447290$var$verifySimpleConsentChecked) {
                    (0, $cEKee.setSmsConsentTransactional)(true);
                    (0, $cEKee.setTermsAndPrivacyAccepted)(true);
                } else {
                    (0, $cEKee.setSmsConsentTransactional)(false);
                    (0, $cEKee.setTermsAndPrivacyAccepted)(false);
                }
                simpleRow?.classList.remove('invalid');
                $856ade642e447290$var$checkContinueBtnState();
            }
        };
        if (simpleRow && simpleCheckbox) {
            simpleRow.style.cursor = 'pointer';
            simpleRow.onclick = handleSimpleClick;
            simpleCheckbox.addEventListener('keydown', (e)=>{
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    handleSimpleClick(e);
                }
            });
        }
    }
}
function $856ade642e447290$var$editInfoListener() {
    const screenPhone = document.querySelector('.verifyInformation__container');
    const verify = screenPhone.querySelector('.verify-infor__actions .verify-infor-continue__btn');
    if (verify) {
        // verifyInforListeners() runs again on every re-entry to this screen
        // (phone, validate-digits, navigation helper). Without the remove, the
        // handlers stack and a single click fires N concurrent bookings.
        verify.removeEventListener("click", $856ade642e447290$var$onClickContinueBtn);
        verify.addEventListener("click", $856ade642e447290$var$onClickContinueBtn);
    }
    // Prefilled contact rows render collapsed behind a summary card; the Edit
    // button re-expands the real inputs when the visitor needs to correct one.
    const editBtn = screenPhone.querySelector('.verify-infor-edit__btn');
    if (editBtn) editBtn.onclick = ()=>{
        const body = screenPhone.querySelector('.verify-infor__body');
        body?.classList.remove('prefilled-collapsed');
        body?.querySelector('.verify-infor__summary')?.remove();
        $856ade642e447290$var$checkContinueBtnState();
    };
    document.querySelectorAll('.verifyInformation__container input').forEach((element)=>{
        element.removeEventListener('input', $856ade642e447290$var$checkContinueBtnState, false);
        element.removeEventListener('keydown', $856ade642e447290$var$onKeyDownInput, false);
        element.addEventListener('input', $856ade642e447290$var$checkContinueBtnState, false);
        element.addEventListener('keydown', $856ade642e447290$var$onKeyDownInput, false);
    });
    // The gender select fires 'change', not 'input', so the generic input
    // binding above doesn't cover it (required when shown).
    const genderSelect = document.querySelector('.verifyInformation__container #genderVerify');
    if (genderSelect) {
        genderSelect.removeEventListener('change', $856ade642e447290$var$onGenderChange, false);
        genderSelect.addEventListener('change', $856ade642e447290$var$onGenderChange, false);
    }
    // Scope to THIS screen's DOB input: the register-new-patient page has its
    // own always-in-DOM #dobDatepicker earlier in document order, so a bare
    // id lookup binds/reads the wrong (hidden) input and the visitor's picked
    // date never submits.
    let datepicker = flatpickr(".verifyInformation__container #dobDatepicker", {
        maxDate: 'today',
        dateFormat: "M d, Y",
        altInput: true,
        altFormat: "F j, Y",
        // Prefill with the lead's existing DOB (ISO from the API) when present so
        // the verify page confirms rather than re-asks; empty otherwise.
        defaultDate: (0, $cEKee.leadInfo)?.date_of_birth || null,
        // The DOB input is readonly and fires no 'input' event; clear the
        // jump-to-field error state once a date is picked.
        onChange: ()=>{
            document.querySelector('.verifyInformation__container .dob-input')?.classList.remove('invalid');
            $856ade642e447290$var$checkContinueBtnState();
        }
    });
}
function $856ade642e447290$var$onGenderChange(e) {
    if (e?.target?.value) document.querySelector('.verifyInformation__container .gender-input')?.classList.remove('invalid');
    $856ade642e447290$var$checkContinueBtnState();
}
async function $856ade642e447290$var$onClickContinueBtn() {
    // The button is never disabled for missing input (a dead 50%-opacity button
    // gives no hint WHICH field is the problem, and on long forms the field is
    // off-screen entirely). Instead, clicking with something missing jumps to
    // the first offending field and shows its required/error state.
    const missing = $856ade642e447290$var$firstInvalidField();
    if (missing) {
        missing.wrapper?.classList.add('invalid');
        missing.wrapper?.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
        });
        missing.focus?.focus?.({
            preventScroll: true
        });
        return;
    }
    let loaderIcon = document.querySelector('.verify-infor-continue__btn .loader__icon');
    try {
        document.querySelector('.verify-infor-continue__btn')?.classList.add('disabled');
        document.querySelector('.verify-infor-continue__btn .loading__wrapper')?.classList.remove('hidden');
        if (loaderIcon) loaderIcon.innerHTML = `<img src="${0, $cEKee.appUrl}/assets/icons/rolling.png" />`;
        let nameInputDoms = document.querySelectorAll('.verifyInformation__container input');
        let fullName = nameInputDoms[0].value.trim();
        const [first_name, last_name] = $856ade642e447290$var$splitFullName(fullName);
        // Get language value from dropdown
        const languageInput = document.querySelector('.verifyInformation__container #languageVerify');
        const selectedLanguageValue = languageInput ? languageInput.value.trim() : '';
        const languageId = selectedLanguageValue ? (0, $6jZoE.getLanguageId)(selectedLanguageValue) : null;
        let data = {
            ...first_name && {
                first_name: first_name
            },
            ...last_name && {
                last_name: last_name
            },
            ...nameInputDoms[1].value && nameInputDoms[1].value !== (0, $cEKee.leadInfo)?.email && {
                email: nameInputDoms[1].value
            },
            ...(0, $k3ko8.parsePhoneNumberFromString)(nameInputDoms[2].value, (0, $cEKee.selectedCountry)).number !== (0, $cEKee.leadInfo)?.phone && {
                phone: (0, $k3ko8.parsePhoneNumberFromString)(nameInputDoms[2].value, (0, $cEKee.selectedCountry)).number
            },
            // DOB is only rendered on this page when the channel asks for it in a
            // book-first flow (see verifyInforAction.js). Submit it when present.
            ...(()=>{
                const dob = document.querySelector('.verifyInformation__container #dobDatepicker');
                return dob?.value ? {
                    date_of_birth: dob.value
                } : {};
            })(),
            // Gender, like DOB, is only rendered here when the channel/widget
            // asks for it (see verifyInforAction.js). Submit it when present.
            ...(()=>{
                const g = document.querySelector('.verifyInformation__container #genderVerify');
                return g?.value ? {
                    gender: g.value
                } : {};
            })(),
            ...languageId && {
                language: languageId
            },
            ...(0, $cEKee.visitorId) && {
                visitor_id: (0, $cEKee.visitorId)
            },
            sms_consent_transactional: (0, $cEKee.smsConsentTransactional),
            sms_consent_promotional: (0, $cEKee.smsConsentPromotional),
            terms_and_privacy_accepted: (0, $cEKee.termsAndPrivacyAccepted)
        };
        const leadTextId = (0, $cEKee.leadInfo)?.text_id;
        if (leadTextId && Object.keys(data).length) {
            const updatedLead = await (0, $jmDLz.updateLeadPortal)(leadTextId, data);
            if (updatedLead?.data) {
                // WidgetLeadResource is a strict allowlist and does NOT echo
                // date_of_birth/gender back, so merge what we just submitted
                // into the in-memory lead — otherwise flows that re-enter
                // appointmentItemsClickEventHandler with a different payload
                // (address collection, questionnaire) re-trigger the
                // verify-info detour forever.
                (0, $cEKee.setLeadInfo)({
                    ...updatedLead.data,
                    ...data
                });
                if (updatedLead.data.text_id) (0, $cEKee.setLeadTextId)(updatedLead.data.text_id);
            }
        }
        // Address is collected on its own page BEFORE the appointment is created, so
        // the booking can't be completed without it (see addressCollectionListeners).
        if ((0, $cEKee.form)?.appointment_channel?.collect_address) {
            (0, $er9E0.navigate)((0, $cIxq8.SCREEN).ADDRESS_COLLECTION);
            (0, $5oy7H.addressCollectionListeners)();
            return;
        }
        if ((0, $99TAZ.shouldTriggerAllQuestionsAfterValidation)()) {
            (0, $99TAZ.loadAllQuestionsFlow)();
            return;
        }
        await (0, $alq6e.appointmentItemsClickEventHandler)((0, $cEKee.selectedAppointmentUnixTime), data);
    } catch (error) {
        (0, $gZEOs.toastError)(error.response?.data?.message);
        const { email: email } = error.response?.data?.errors || {};
        if (email) document.querySelector(".verifyInformation__container .email-input ")?.classList?.add("invalid");
    } finally{
        if (loaderIcon) loaderIcon.innerHTML = '<i class="ri-arrow-right-line"></i>';
        document.querySelector('.verify-infor-continue__btn .loading__wrapper')?.classList.add('hidden');
        document.querySelector('.verify-infor-continue__btn')?.classList.remove('disabled');
    }
}
function $856ade642e447290$var$checkContinueBtnState(e) {
    const container = document.querySelector(".verifyInformation__container");
    if (container) {
        const target = e?.target;
        let value = target?.value;
        const classNames = [
            {
                className: "full_name-input",
                type: "full_name-input"
            },
            {
                className: "phone-input",
                type: "phone-input"
            }
        ];
        const inputErr = classNames.filter(({ className: className })=>target?.closest(`.${className}`)).map(({ type: type })=>type);
        inputErr.forEach((type)=>{
            const element = container.querySelector(`.${type}`);
            if (type === "full_name-input") {
                if (value && !$856ade642e447290$var$validateFullName(value)) value = "";
            }
            if (value) element?.classList?.contains("invalid") && element.classList.remove("invalid");
            else !element?.classList?.contains("invalid") && element.classList.add("invalid");
        });
    }
    // The button is intentionally NEVER disabled for missing input — clicking
    // it jumps to the first missing field instead (onClickContinueBtn). The
    // `.disabled` class is only used as an in-flight lock while a submission
    // request is running; make sure typing never strands it on.
    if ($856ade642e447290$export$60c024fdb76e949e()) document.querySelector('.verifyInformation__container .verify-infor-continue__btn')?.classList.remove('disabled');
}
function $856ade642e447290$var$onKeyDownInput(event) {
    if (event.key === 'Tab') event.stopPropagation();
}
function $856ade642e447290$var$handlePressEnter(event) {
    event.stopPropagation();
    if (event.key === 'Enter' && !document.querySelector(`.verifyInformation__container .verify-infor-continue__btn`).classList.contains('disabled')) document.querySelector(`.verifyInformation__container .verify-infor-continue__btn`).click();
}
function $856ade642e447290$export$d3d5c1e3a6eab89b() {
    document.querySelectorAll('.verifyInformation__container input').forEach((element)=>{
        element.value = '';
    });
}
function $856ade642e447290$var$isValidEmail(email) {
    // Use the same validator the rest of the widget uses. The old hand-rolled
    // regex capped the TLD at 4 characters, so anyone on .online / .clinic /
    // .dental / .health / .practice failed validation and got a permanently
    // disabled Continue button with no error text — they simply could not book.
    return (0, (/*@__PURE__*/$parcel$interopDefault($g2qZ3))).isEmail((email || '').trim());
}
function $856ade642e447290$var$validateFullName(fullName) {
    return fullName.split(" ")?.filter((i)=>!!i).length >= 2;
}
// Returns the first field blocking submission as { wrapper, focus } (wrapper
// gets `.invalid` + scrolled into view, focus gets keyboard focus), or null
// when the form is submittable. Field order matches the rendered order so the
// jump-on-click behavior in onClickContinueBtn walks the page top to bottom.
function $856ade642e447290$var$firstInvalidField() {
    const container = document.querySelector('.verifyInformation__container');
    if (!container) return null;
    const fullNameDom = container.querySelector('.full_name-input input');
    if (!$856ade642e447290$var$validateFullName(fullNameDom?.value || '')) return {
        wrapper: container.querySelector('.full_name-input'),
        focus: fullNameDom
    };
    const emailDom = container.querySelector('.email-input input');
    if (emailDom?.value && !$856ade642e447290$var$isValidEmail(emailDom.value)) return {
        wrapper: container.querySelector('.email-input'),
        focus: emailDom
    };
    // Email is optional; once it's empty or valid again, drop the error state.
    container.querySelector('.email-input')?.classList?.remove("invalid");
    const phoneDom = container.querySelector('.phone-input input');
    if (!phoneDom?.value) return {
        wrapper: container.querySelector('.phone-input'),
        focus: phoneDom
    };
    // DOB is required only when the channel asks for it (field rendered).
    // flatpickr altInput hides the real #dobDatepicker, so focus its visible
    // sibling input instead.
    const dobDom = container.querySelector('#dobDatepicker');
    if (dobDom && !dobDom.value) {
        const dobWrapper = container.querySelector('.dob-input');
        return {
            wrapper: dobWrapper,
            focus: dobWrapper?.querySelector('input.form-control') || dobDom
        };
    }
    // Gender, same rule: required only when rendered — an empty value here
    // would send the visitor back into the verify-info detour forever.
    const genderDom = container.querySelector('#genderVerify');
    if (genderDom && !genderDom.value) return {
        wrapper: container.querySelector('.gender-input'),
        focus: genderDom
    };
    if (0, $cEKee.a2pConsentEnabled) {
        if (!(0, $cEKee.smsConsentTransactional)) return {
            wrapper: container.querySelector('.sms-consent-transactional-row')
        };
        if (!(0, $cEKee.termsAndPrivacyAccepted)) return {
            wrapper: container.querySelector('.terms-privacy-row')
        };
    }
    return null;
}
function $856ade642e447290$export$60c024fdb76e949e() {
    return !$856ade642e447290$var$firstInvalidField();
}
function $856ade642e447290$var$splitFullName(fullName) {
    let nameParts = fullName.split(" ");
    let first_name = nameParts[0];
    let last_name = nameParts.slice(1).join(" ");
    return [
        first_name,
        last_name
    ];
}

});
parcelRegister("8FUcK", function(module, exports) {

$parcel$export(module.exports, "renderUIEditInfoLead", () => $650dc01f70f342e7$export$19749b30bb2474ee);

var $cEKee = parcelRequire("cEKee");

var $knjAn = parcelRequire("knjAn");

var $g2qZ3 = parcelRequire("g2qZ3");
const $650dc01f70f342e7$var$escapeHtml = (v)=>String(v).replace(/[&<>"']/g, (c)=>({
            '&': '&amp;',
            '<': '&lt;',
            '>': '&gt;',
            '"': '&quot;',
            "'": '&#39;'
        })[c]);
const $650dc01f70f342e7$export$19749b30bb2474ee = (lead)=>{
    const container = document.querySelector('.verifyInformation__container');
    if (!container) return;
    const card = container.querySelector('.card');
    card.innerHTML = "";
    const languageDropdownHTML = (0, $cEKee.form)?.show_language_dropdown ? `
        <div class="info__lead verify-infor__input language-input">
            <label>${(0, $knjAn.t)('preferred_language')}</label>
            <div class="language__dropdown-verify"></div>
        </div>
    ` : '';
    // Book-first flow: when the channel is set to "ask for DOB" but does NOT
    // collect patient info first, DOB has no earlier step to be gathered in, so
    // it must appear here on the verify-info page. The #dobDatepicker flatpickr
    // is initialized in editInfoListener(); the value is submitted from
    // onClickContinueBtn (verifyInforListenters.js).
    const dobHTML = (0, $cEKee.form)?.appointment_channel?.collect_dob || (0, $cEKee.form)?.show_dob_field && (0, $cEKee.form)?.appointment_channel?.collect_patient_information_first_before_scheduling ? `
        <div class="info__lead verify-infor__input dob-input">
            <label>${(0, $knjAn.t)('dob')} <span class='text__required'>* Required</span></label>
            <input id="dobDatepicker" type="text" placeholder="${(0, $knjAn.t)('select_dob')}" readonly />
        </div>
    ` : '';
    // Gender is never asked on the upfront prebook patient-info form (same
    // conversion reasoning as DOB above), so both drivers (channel
    // `collect_gender` and the widget-row `show_gender_field` on the prebook
    // flow) collect it here instead. Submitted from onClickContinueBtn.
    const genderOptions = [
        'male',
        'female',
        'other',
        'prefer_not_to_say'
    ];
    const genderHTML = (0, $cEKee.form)?.appointment_channel?.collect_gender || (0, $cEKee.form)?.show_gender_field && (0, $cEKee.form)?.appointment_channel?.collect_patient_information_first_before_scheduling ? `
        <div class="info__lead verify-infor__input gender-input">
            <label>${(0, $knjAn.t)('gender')} <span class='text__required'>* Required</span></label>
            <select id="genderVerify" aria-label="${(0, $knjAn.t)('gender')}">
                <option value="" disabled ${lead?.gender ? '' : 'selected'}>${(0, $knjAn.t)('select_gender')}</option>
                ${genderOptions.map((g)=>`<option value="${g}" ${lead?.gender === g ? 'selected' : ''}>${(0, $knjAn.t)(g)}</option>`).join('')}
            </select>
        </div>
    ` : '';
    const practiceNameText = (0, $cEKee.businessName) || '[Business Name]';
    let consentHTML = '';
    if (0, $cEKee.a2pConsentEnabled) consentHTML = `
            <div class="note__wrapper sms-consent__wrapper verify-info-consent">
                <div class="consent-row sms-consent-transactional-row">
                    <span class="noteOption__checkbox sms-consent-transactional-checkbox" role="button" tabindex="0" aria-label="Transactional and informational SMS consent"><i class="ri-check-line"></i></span>
                    <label class="sms-consent-label">I agree to receive transactional SMS from <span class="sms-consent-business-name">${practiceNameText}</span> (e.g. verification codes, account & care messages).</label>
                </div>
                <div class="consent-row terms-privacy-row">
                    <span class="noteOption__checkbox terms-privacy-checkbox" role="button" tabindex="0" aria-label="Accept Terms and Conditions and Privacy Policy"><i class="ri-check-line"></i></span>
                    <label class="sms-consent-label terms-privacy-label">I accept the <u class="link terms-link">Terms and Conditions</u> and <u class="link privacy-link">Privacy Policy</u>.</label>
                </div>
                <div class="consent-row sms-consent-promotional-row">
                    <span class="noteOption__checkbox sms-consent-promotional-checkbox" role="button" tabindex="0" aria-label="Promotional and marketing SMS consent"><i class="ri-check-line"></i></span>
                    <label class="sms-consent-label">I agree to receive promotional text messages and/or emails from <span class="sms-consent-business-name">${practiceNameText}</span>. Message frequency varies. Message and data rates may apply. Reply STOP to unsubscribe.</label>
                </div>
                <p class="sms-consent-disclaimer">Message and data rates may apply. Message frequency varies. Reply STOP to unsubscribe, HELP for help.</p>
            </div>
        `;
    // Collapse the contact rows the lead record already answers into a compact
    // read-only summary (with an Edit escape hatch) so the visitor only sees
    // the fields that still need input (typically just DOB on the late-DOB
    // detour). Collapse only when every required field is prefilled AND valid —
    // a hidden invalid value would dead-end the Continue button with no visible
    // error. The inputs stay in the DOM (display:none) because the submit and
    // validation paths read them positionally.
    const prefilledCollapsible = Boolean(lead?.first_name && lead?.last_name && lead?.phone && (!lead?.email || (0, (/*@__PURE__*/$parcel$interopDefault($g2qZ3))).isEmail(String(lead.email).trim())));
    const summaryHTML = prefilledCollapsible ? `
        <div class="verify-infor__summary">
            <div class="verify-infor__summary-fields">
                <div class="info__lead"><label>Full Name</label><span>${$650dc01f70f342e7$var$escapeHtml([
        lead.first_name,
        lead.last_name
    ].filter(Boolean).join(' '))}</span></div>
                <div class="info__lead"><label>Phone number</label><span>${$650dc01f70f342e7$var$escapeHtml(lead.phone)}</span></div>
                ${lead?.email ? `<div class="info__lead"><label>Email address</label><span>${$650dc01f70f342e7$var$escapeHtml(lead.email)}</span></div>` : ''}
            </div>
            <button type="button" class="edit-info__btn verify-infor-edit__btn" aria-label="Edit your information"><i class="ri-pencil-line"></i> Edit</button>
        </div>
    ` : '';
    card.insertAdjacentHTML('afterbegin', `
        <div class="verify-infor__body edit ${prefilledCollapsible ? 'prefilled-collapsed' : ''}">
            ${summaryHTML}
            <div class="info__lead verify-infor__input full_name-input ${!lead?.first_name || !lead?.last_name ? "invalid" : ""}">
                <label>Full Name <span class='text__required'>* Required</span></label>
                <input
                    type="text"
                    placeholder="Enter your full name"
                    value="${$650dc01f70f342e7$var$escapeHtml([
        lead?.first_name,
        lead?.last_name
    ].filter(Boolean).join(' '))}"
                />

            </div>
            <div class="info__lead verify-infor__input email-input">
                <label>Email address</label>
                <input type="text" placeholder="Enter your email address" value="${lead?.email ? $650dc01f70f342e7$var$escapeHtml(lead.email) : ""}" />
            </div>
            <div class="info__lead verify-infor__input phone-input ${!lead?.phone ? "invalid" : ""}">
                <label>Phone number <span class='text__required'>* Required</span></label>
                <input type="text" placeholder="Enter your phone number" value="${lead?.phone ? lead?.phone : ""}" />
            </div>
            ${dobHTML}
            ${genderHTML}
            ${languageDropdownHTML}
            ${consentHTML}
        </div>
    `);
};

});
parcelRegister("g2qZ3", function(module, exports) {
"use strict";
function $bad1c3ae594eb6ef$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $bad1c3ae594eb6ef$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $bad1c3ae594eb6ef$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $bad1c3ae594eb6ef$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bad1c3ae594eb6ef$var$_toDate = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("gr6fc")));

var $bad1c3ae594eb6ef$var$_toFloat = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("2dcMT")));

var $bad1c3ae594eb6ef$var$_toInt = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("ab0Id")));

var $bad1c3ae594eb6ef$var$_toBoolean = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("dtiFd")));

var $bad1c3ae594eb6ef$var$_equals = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("jXY5d")));

var $bad1c3ae594eb6ef$var$_contains = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("aZ85Q")));

var $bad1c3ae594eb6ef$var$_matches = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("5ZSE3")));

var $bad1c3ae594eb6ef$var$_isEmail = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("4tHKL")));

var $bad1c3ae594eb6ef$var$_isURL = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("4Cxzb")));

var $bad1c3ae594eb6ef$var$_isMACAddress = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("S05Bl")));

var $bad1c3ae594eb6ef$var$_isIP = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("k4gOC")));

var $bad1c3ae594eb6ef$var$_isIPRange = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("9xDwV")));

var $bad1c3ae594eb6ef$var$_isFQDN = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("hNevj")));

var $bad1c3ae594eb6ef$var$_isDate = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("akLR8")));

var $bad1c3ae594eb6ef$var$_isBoolean = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("5sk3S")));

var $bad1c3ae594eb6ef$var$_isLocale = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("9E8F4")));

var $bad1c3ae594eb6ef$var$_isAlpha = $bad1c3ae594eb6ef$var$_interopRequireWildcard((parcelRequire("fvxOe")));

var $bad1c3ae594eb6ef$var$_isAlphanumeric = $bad1c3ae594eb6ef$var$_interopRequireWildcard((parcelRequire("9AaLY")));

var $bad1c3ae594eb6ef$var$_isNumeric = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("b9xtB")));

var $bad1c3ae594eb6ef$var$_isPassportNumber = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("lpGGU")));

var $bad1c3ae594eb6ef$var$_isPort = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("anXSC")));

var $bad1c3ae594eb6ef$var$_isLowercase = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("8YYKA")));

var $bad1c3ae594eb6ef$var$_isUppercase = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("Y8gNP")));

var $bad1c3ae594eb6ef$var$_isIMEI = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("8DM8E")));

var $bad1c3ae594eb6ef$var$_isAscii = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("kv2Jx")));

var $bad1c3ae594eb6ef$var$_isFullWidth = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("bWCzj")));

var $bad1c3ae594eb6ef$var$_isHalfWidth = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("9f357")));

var $bad1c3ae594eb6ef$var$_isVariableWidth = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("jYPXr")));

var $bad1c3ae594eb6ef$var$_isMultibyte = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("81UkT")));

var $bad1c3ae594eb6ef$var$_isSemVer = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("6s9Ea")));

var $bad1c3ae594eb6ef$var$_isSurrogatePair = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("9zqOS")));

var $bad1c3ae594eb6ef$var$_isInt = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("3VTZw")));

var $bad1c3ae594eb6ef$var$_isFloat = $bad1c3ae594eb6ef$var$_interopRequireWildcard((parcelRequire("5ARir")));

var $bad1c3ae594eb6ef$var$_isDecimal = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("kfE9J")));

var $bad1c3ae594eb6ef$var$_isHexadecimal = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("38ASS")));

var $bad1c3ae594eb6ef$var$_isOctal = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("8h9xl")));

var $bad1c3ae594eb6ef$var$_isDivisibleBy = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("9v3dq")));

var $bad1c3ae594eb6ef$var$_isHexColor = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("5U1AD")));

var $bad1c3ae594eb6ef$var$_isRgbColor = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("4TDuE")));

var $bad1c3ae594eb6ef$var$_isHSL = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("1ItuH")));

var $bad1c3ae594eb6ef$var$_isISRC = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("gmTuo")));

var $bad1c3ae594eb6ef$var$_isIBAN = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("9ExTf")));

var $bad1c3ae594eb6ef$var$_isBIC = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("e8bY8")));

var $bad1c3ae594eb6ef$var$_isMD = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("gdrTg")));

var $bad1c3ae594eb6ef$var$_isHash = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("7D4H0")));

var $bad1c3ae594eb6ef$var$_isJWT = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("bRpBC")));

var $bad1c3ae594eb6ef$var$_isJSON = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("c8148")));

var $bad1c3ae594eb6ef$var$_isEmpty = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("9itI6")));

var $bad1c3ae594eb6ef$var$_isLength = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("eX4Zk")));

var $bad1c3ae594eb6ef$var$_isByteLength = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("lIM5C")));

var $bad1c3ae594eb6ef$var$_isUUID = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("99DHM")));

var $bad1c3ae594eb6ef$var$_isMongoId = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("jEKS4")));

var $bad1c3ae594eb6ef$var$_isAfter = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("fGRWQ")));

var $bad1c3ae594eb6ef$var$_isBefore = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("5bvc1")));

var $bad1c3ae594eb6ef$var$_isIn = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("kMIcK")));

var $bad1c3ae594eb6ef$var$_isCreditCard = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("bBCuW")));

var $bad1c3ae594eb6ef$var$_isIdentityCard = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("ilQ4n")));

var $bad1c3ae594eb6ef$var$_isEAN = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("5tfrP")));

var $bad1c3ae594eb6ef$var$_isISIN = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("doEvT")));

var $bad1c3ae594eb6ef$var$_isISBN = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("Eh5kE")));

var $bad1c3ae594eb6ef$var$_isISSN = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("dzNHd")));

var $bad1c3ae594eb6ef$var$_isTaxID = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("7Nii9")));

var $bad1c3ae594eb6ef$var$_isMobilePhone = $bad1c3ae594eb6ef$var$_interopRequireWildcard((parcelRequire("4kFi1")));

var $bad1c3ae594eb6ef$var$_isEthereumAddress = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("Gjy1y")));

var $bad1c3ae594eb6ef$var$_isCurrency = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("69Ecb")));

var $bad1c3ae594eb6ef$var$_isBtcAddress = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("ilHLb")));

var $bad1c3ae594eb6ef$var$_isISO = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("aWF3e")));

var $bad1c3ae594eb6ef$var$_isRFC = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("36TYP")));

var $bad1c3ae594eb6ef$var$_isISO31661Alpha = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("dVkQR")));

var $bad1c3ae594eb6ef$var$_isISO31661Alpha2 = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("lPnYX")));

var $bad1c3ae594eb6ef$var$_isBase = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("e8aAF")));

var $bad1c3ae594eb6ef$var$_isBase2 = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("bgzme")));

var $bad1c3ae594eb6ef$var$_isBase3 = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("2d8yt")));

var $bad1c3ae594eb6ef$var$_isDataURI = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("8REOh")));

var $bad1c3ae594eb6ef$var$_isMagnetURI = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("ix1xQ")));

var $bad1c3ae594eb6ef$var$_isMimeType = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("ifxP4")));

var $bad1c3ae594eb6ef$var$_isLatLong = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("hLP11")));

var $bad1c3ae594eb6ef$var$_isPostalCode = $bad1c3ae594eb6ef$var$_interopRequireWildcard((parcelRequire("7qOwX")));

var $bad1c3ae594eb6ef$var$_ltrim = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("77DLn")));

var $bad1c3ae594eb6ef$var$_rtrim = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("l0bpl")));

var $bad1c3ae594eb6ef$var$_trim = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("4wt0T")));

var $bad1c3ae594eb6ef$var$_escape = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("lhIbP")));

var $bad1c3ae594eb6ef$var$_unescape = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("Oufps")));

var $bad1c3ae594eb6ef$var$_stripLow = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("l68Ml")));

var $bad1c3ae594eb6ef$var$_whitelist = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("d4jRJ")));

var $bad1c3ae594eb6ef$var$_blacklist = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("hVEzS")));

var $bad1c3ae594eb6ef$var$_isWhitelisted = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("b8HgM")));

var $bad1c3ae594eb6ef$var$_normalizeEmail = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("j002o")));

var $bad1c3ae594eb6ef$var$_isSlug = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("dtWXT")));

var $bad1c3ae594eb6ef$var$_isLicensePlate = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("4fo1o")));

var $bad1c3ae594eb6ef$var$_isStrongPassword = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("9wP8Z")));

var $bad1c3ae594eb6ef$var$_isVAT = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("394HB")));
function $bad1c3ae594eb6ef$var$_getRequireWildcardCache() {
    if (typeof WeakMap !== "function") return null;
    var cache = new WeakMap();
    $bad1c3ae594eb6ef$var$_getRequireWildcardCache = function _getRequireWildcardCache() {
        return cache;
    };
    return cache;
}
function $bad1c3ae594eb6ef$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    if (obj === null || $bad1c3ae594eb6ef$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $bad1c3ae594eb6ef$var$_getRequireWildcardCache();
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $bad1c3ae594eb6ef$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $bad1c3ae594eb6ef$var$version = '13.6.0';
var $bad1c3ae594eb6ef$var$validator = {
    version: $bad1c3ae594eb6ef$var$version,
    toDate: $bad1c3ae594eb6ef$var$_toDate.default,
    toFloat: $bad1c3ae594eb6ef$var$_toFloat.default,
    toInt: $bad1c3ae594eb6ef$var$_toInt.default,
    toBoolean: $bad1c3ae594eb6ef$var$_toBoolean.default,
    equals: $bad1c3ae594eb6ef$var$_equals.default,
    contains: $bad1c3ae594eb6ef$var$_contains.default,
    matches: $bad1c3ae594eb6ef$var$_matches.default,
    isEmail: $bad1c3ae594eb6ef$var$_isEmail.default,
    isURL: $bad1c3ae594eb6ef$var$_isURL.default,
    isMACAddress: $bad1c3ae594eb6ef$var$_isMACAddress.default,
    isIP: $bad1c3ae594eb6ef$var$_isIP.default,
    isIPRange: $bad1c3ae594eb6ef$var$_isIPRange.default,
    isFQDN: $bad1c3ae594eb6ef$var$_isFQDN.default,
    isBoolean: $bad1c3ae594eb6ef$var$_isBoolean.default,
    isIBAN: $bad1c3ae594eb6ef$var$_isIBAN.default,
    isBIC: $bad1c3ae594eb6ef$var$_isBIC.default,
    isAlpha: $bad1c3ae594eb6ef$var$_isAlpha.default,
    isAlphaLocales: $bad1c3ae594eb6ef$var$_isAlpha.locales,
    isAlphanumeric: $bad1c3ae594eb6ef$var$_isAlphanumeric.default,
    isAlphanumericLocales: $bad1c3ae594eb6ef$var$_isAlphanumeric.locales,
    isNumeric: $bad1c3ae594eb6ef$var$_isNumeric.default,
    isPassportNumber: $bad1c3ae594eb6ef$var$_isPassportNumber.default,
    isPort: $bad1c3ae594eb6ef$var$_isPort.default,
    isLowercase: $bad1c3ae594eb6ef$var$_isLowercase.default,
    isUppercase: $bad1c3ae594eb6ef$var$_isUppercase.default,
    isAscii: $bad1c3ae594eb6ef$var$_isAscii.default,
    isFullWidth: $bad1c3ae594eb6ef$var$_isFullWidth.default,
    isHalfWidth: $bad1c3ae594eb6ef$var$_isHalfWidth.default,
    isVariableWidth: $bad1c3ae594eb6ef$var$_isVariableWidth.default,
    isMultibyte: $bad1c3ae594eb6ef$var$_isMultibyte.default,
    isSemVer: $bad1c3ae594eb6ef$var$_isSemVer.default,
    isSurrogatePair: $bad1c3ae594eb6ef$var$_isSurrogatePair.default,
    isInt: $bad1c3ae594eb6ef$var$_isInt.default,
    isIMEI: $bad1c3ae594eb6ef$var$_isIMEI.default,
    isFloat: $bad1c3ae594eb6ef$var$_isFloat.default,
    isFloatLocales: $bad1c3ae594eb6ef$var$_isFloat.locales,
    isDecimal: $bad1c3ae594eb6ef$var$_isDecimal.default,
    isHexadecimal: $bad1c3ae594eb6ef$var$_isHexadecimal.default,
    isOctal: $bad1c3ae594eb6ef$var$_isOctal.default,
    isDivisibleBy: $bad1c3ae594eb6ef$var$_isDivisibleBy.default,
    isHexColor: $bad1c3ae594eb6ef$var$_isHexColor.default,
    isRgbColor: $bad1c3ae594eb6ef$var$_isRgbColor.default,
    isHSL: $bad1c3ae594eb6ef$var$_isHSL.default,
    isISRC: $bad1c3ae594eb6ef$var$_isISRC.default,
    isMD5: $bad1c3ae594eb6ef$var$_isMD.default,
    isHash: $bad1c3ae594eb6ef$var$_isHash.default,
    isJWT: $bad1c3ae594eb6ef$var$_isJWT.default,
    isJSON: $bad1c3ae594eb6ef$var$_isJSON.default,
    isEmpty: $bad1c3ae594eb6ef$var$_isEmpty.default,
    isLength: $bad1c3ae594eb6ef$var$_isLength.default,
    isLocale: $bad1c3ae594eb6ef$var$_isLocale.default,
    isByteLength: $bad1c3ae594eb6ef$var$_isByteLength.default,
    isUUID: $bad1c3ae594eb6ef$var$_isUUID.default,
    isMongoId: $bad1c3ae594eb6ef$var$_isMongoId.default,
    isAfter: $bad1c3ae594eb6ef$var$_isAfter.default,
    isBefore: $bad1c3ae594eb6ef$var$_isBefore.default,
    isIn: $bad1c3ae594eb6ef$var$_isIn.default,
    isCreditCard: $bad1c3ae594eb6ef$var$_isCreditCard.default,
    isIdentityCard: $bad1c3ae594eb6ef$var$_isIdentityCard.default,
    isEAN: $bad1c3ae594eb6ef$var$_isEAN.default,
    isISIN: $bad1c3ae594eb6ef$var$_isISIN.default,
    isISBN: $bad1c3ae594eb6ef$var$_isISBN.default,
    isISSN: $bad1c3ae594eb6ef$var$_isISSN.default,
    isMobilePhone: $bad1c3ae594eb6ef$var$_isMobilePhone.default,
    isMobilePhoneLocales: $bad1c3ae594eb6ef$var$_isMobilePhone.locales,
    isPostalCode: $bad1c3ae594eb6ef$var$_isPostalCode.default,
    isPostalCodeLocales: $bad1c3ae594eb6ef$var$_isPostalCode.locales,
    isEthereumAddress: $bad1c3ae594eb6ef$var$_isEthereumAddress.default,
    isCurrency: $bad1c3ae594eb6ef$var$_isCurrency.default,
    isBtcAddress: $bad1c3ae594eb6ef$var$_isBtcAddress.default,
    isISO8601: $bad1c3ae594eb6ef$var$_isISO.default,
    isRFC3339: $bad1c3ae594eb6ef$var$_isRFC.default,
    isISO31661Alpha2: $bad1c3ae594eb6ef$var$_isISO31661Alpha.default,
    isISO31661Alpha3: $bad1c3ae594eb6ef$var$_isISO31661Alpha2.default,
    isBase32: $bad1c3ae594eb6ef$var$_isBase.default,
    isBase58: $bad1c3ae594eb6ef$var$_isBase2.default,
    isBase64: $bad1c3ae594eb6ef$var$_isBase3.default,
    isDataURI: $bad1c3ae594eb6ef$var$_isDataURI.default,
    isMagnetURI: $bad1c3ae594eb6ef$var$_isMagnetURI.default,
    isMimeType: $bad1c3ae594eb6ef$var$_isMimeType.default,
    isLatLong: $bad1c3ae594eb6ef$var$_isLatLong.default,
    ltrim: $bad1c3ae594eb6ef$var$_ltrim.default,
    rtrim: $bad1c3ae594eb6ef$var$_rtrim.default,
    trim: $bad1c3ae594eb6ef$var$_trim.default,
    escape: $bad1c3ae594eb6ef$var$_escape.default,
    unescape: $bad1c3ae594eb6ef$var$_unescape.default,
    stripLow: $bad1c3ae594eb6ef$var$_stripLow.default,
    whitelist: $bad1c3ae594eb6ef$var$_whitelist.default,
    blacklist: $bad1c3ae594eb6ef$var$_blacklist.default,
    isWhitelisted: $bad1c3ae594eb6ef$var$_isWhitelisted.default,
    normalizeEmail: $bad1c3ae594eb6ef$var$_normalizeEmail.default,
    toString: toString,
    isSlug: $bad1c3ae594eb6ef$var$_isSlug.default,
    isStrongPassword: $bad1c3ae594eb6ef$var$_isStrongPassword.default,
    isTaxID: $bad1c3ae594eb6ef$var$_isTaxID.default,
    isDate: $bad1c3ae594eb6ef$var$_isDate.default,
    isLicensePlate: $bad1c3ae594eb6ef$var$_isLicensePlate.default,
    isVAT: $bad1c3ae594eb6ef$var$_isVAT.default
};
var $bad1c3ae594eb6ef$var$_default = $bad1c3ae594eb6ef$var$validator;
module.exports.default = $bad1c3ae594eb6ef$var$_default;
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});
parcelRegister("gr6fc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $bf7402f0de7f81b7$var$toDate;

var $bf7402f0de7f81b7$var$_assertString = $bf7402f0de7f81b7$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $bf7402f0de7f81b7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $bf7402f0de7f81b7$var$toDate(date) {
    (0, $bf7402f0de7f81b7$var$_assertString.default)(date);
    date = Date.parse(date);
    return !isNaN(date) ? new Date(date) : null;
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});
parcelRegister("hZqWG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d18d08f8e9af886d$var$assertString;
function $d18d08f8e9af886d$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $d18d08f8e9af886d$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $d18d08f8e9af886d$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $d18d08f8e9af886d$var$_typeof(obj);
}
function $d18d08f8e9af886d$var$assertString(input) {
    var isString = typeof input === 'string' || input instanceof String;
    if (!isString) {
        var invalidType = $d18d08f8e9af886d$var$_typeof(input);
        if (input === null) invalidType = 'null';
        else if (invalidType === 'object') invalidType = input.constructor.name;
        throw new TypeError("Expected a string but received a ".concat(invalidType));
    }
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});


parcelRegister("2dcMT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $19c6b7089d1c44e5$var$toFloat;

var $19c6b7089d1c44e5$var$_isFloat = $19c6b7089d1c44e5$var$_interopRequireDefault((parcelRequire("5ARir")));
function $19c6b7089d1c44e5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $19c6b7089d1c44e5$var$toFloat(str) {
    if (!(0, $19c6b7089d1c44e5$var$_isFloat.default)(str)) return NaN;
    return parseFloat(str);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});
parcelRegister("5ARir", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4129a81d3aaabc96$var$isFloat;
module.exports.locales = void 0;

var $4129a81d3aaabc96$var$_assertString = $4129a81d3aaabc96$var$_interopRequireDefault((parcelRequire("hZqWG")));

var $alkZf = parcelRequire("alkZf");
function $4129a81d3aaabc96$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $4129a81d3aaabc96$var$isFloat(str, options) {
    (0, $4129a81d3aaabc96$var$_assertString.default)(str);
    options = options || {};
    var float = new RegExp("^(?:[-+])?(?:[0-9]+)?(?:\\".concat(options.locale ? $alkZf.decimal[options.locale] : '.', "[0-9]*)?(?:[eE][\\+\\-]?(?:[0-9]+))?$"));
    if (str === '' || str === '.' || str === '-' || str === '+') return false;
    var value = parseFloat(str.replace(',', '.'));
    return float.test(str) && (!options.hasOwnProperty('min') || value >= options.min) && (!options.hasOwnProperty('max') || value <= options.max) && (!options.hasOwnProperty('lt') || value < options.lt) && (!options.hasOwnProperty('gt') || value > options.gt);
}
var $4129a81d3aaabc96$var$locales = Object.keys($alkZf.decimal);
module.exports.locales = $4129a81d3aaabc96$var$locales;

});
parcelRegister("alkZf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.commaDecimal = module.exports.dotDecimal = module.exports.farsiLocales = module.exports.arabicLocales = module.exports.englishLocales = module.exports.decimal = module.exports.alphanumeric = module.exports.alpha = void 0;
var $787c2518b50629c5$var$alpha = {
    'en-US': /^[A-Z]+$/i,
    'az-AZ': /^[A-VXYZÇƏĞİıÖŞÜ]+$/i,
    'bg-BG': /^[А-Я]+$/i,
    'cs-CZ': /^[A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ]+$/i,
    'da-DK': /^[A-ZÆØÅ]+$/i,
    'de-DE': /^[A-ZÄÖÜß]+$/i,
    'el-GR': /^[Α-ώ]+$/i,
    'es-ES': /^[A-ZÁÉÍÑÓÚÜ]+$/i,
    'fa-IR': /^[ابپتثجچحخدذرزژسشصضطظعغفقکگلمنوهی]+$/i,
    'fr-FR': /^[A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ]+$/i,
    'it-IT': /^[A-ZÀÉÈÌÎÓÒÙ]+$/i,
    'nb-NO': /^[A-ZÆØÅ]+$/i,
    'nl-NL': /^[A-ZÁÉËÏÓÖÜÚ]+$/i,
    'nn-NO': /^[A-ZÆØÅ]+$/i,
    'hu-HU': /^[A-ZÁÉÍÓÖŐÚÜŰ]+$/i,
    'pl-PL': /^[A-ZĄĆĘŚŁŃÓŻŹ]+$/i,
    'pt-PT': /^[A-ZÃÁÀÂÄÇÉÊËÍÏÕÓÔÖÚÜ]+$/i,
    'ru-RU': /^[А-ЯЁ]+$/i,
    'sl-SI': /^[A-ZČĆĐŠŽ]+$/i,
    'sk-SK': /^[A-ZÁČĎÉÍŇÓŠŤÚÝŽĹŔĽÄÔ]+$/i,
    'sr-RS@latin': /^[A-ZČĆŽŠĐ]+$/i,
    'sr-RS': /^[А-ЯЂЈЉЊЋЏ]+$/i,
    'sv-SE': /^[A-ZÅÄÖ]+$/i,
    'th-TH': /^[ก-๐\s]+$/i,
    'tr-TR': /^[A-ZÇĞİıÖŞÜ]+$/i,
    'uk-UA': /^[А-ЩЬЮЯЄIЇҐі]+$/i,
    'vi-VN': /^[A-ZÀÁẠẢÃÂẦẤẬẨẪĂẰẮẶẲẴĐÈÉẸẺẼÊỀẾỆỂỄÌÍỊỈĨÒÓỌỎÕÔỒỐỘỔỖƠỜỚỢỞỠÙÚỤỦŨƯỪỨỰỬỮỲÝỴỶỸ]+$/i,
    'ku-IQ': /^[ئابپتجچحخدرڕزژسشعغفڤقکگلڵمنوۆھەیێيطؤثآإأكضصةظذ]+$/i,
    ar: /^[ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ]+$/,
    he: /^[א-ת]+$/,
    fa: /^['آاءأؤئبپتثجچحخدذرزژسشصضطظعغفقکگلمنوهةی']+$/i
};
module.exports.alpha = $787c2518b50629c5$var$alpha;
var $787c2518b50629c5$var$alphanumeric = {
    'en-US': /^[0-9A-Z]+$/i,
    'az-AZ': /^[0-9A-VXYZÇƏĞİıÖŞÜ]+$/i,
    'bg-BG': /^[0-9А-Я]+$/i,
    'cs-CZ': /^[0-9A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ]+$/i,
    'da-DK': /^[0-9A-ZÆØÅ]+$/i,
    'de-DE': /^[0-9A-ZÄÖÜß]+$/i,
    'el-GR': /^[0-9Α-ω]+$/i,
    'es-ES': /^[0-9A-ZÁÉÍÑÓÚÜ]+$/i,
    'fr-FR': /^[0-9A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ]+$/i,
    'it-IT': /^[0-9A-ZÀÉÈÌÎÓÒÙ]+$/i,
    'hu-HU': /^[0-9A-ZÁÉÍÓÖŐÚÜŰ]+$/i,
    'nb-NO': /^[0-9A-ZÆØÅ]+$/i,
    'nl-NL': /^[0-9A-ZÁÉËÏÓÖÜÚ]+$/i,
    'nn-NO': /^[0-9A-ZÆØÅ]+$/i,
    'pl-PL': /^[0-9A-ZĄĆĘŚŁŃÓŻŹ]+$/i,
    'pt-PT': /^[0-9A-ZÃÁÀÂÄÇÉÊËÍÏÕÓÔÖÚÜ]+$/i,
    'ru-RU': /^[0-9А-ЯЁ]+$/i,
    'sl-SI': /^[0-9A-ZČĆĐŠŽ]+$/i,
    'sk-SK': /^[0-9A-ZÁČĎÉÍŇÓŠŤÚÝŽĹŔĽÄÔ]+$/i,
    'sr-RS@latin': /^[0-9A-ZČĆŽŠĐ]+$/i,
    'sr-RS': /^[0-9А-ЯЂЈЉЊЋЏ]+$/i,
    'sv-SE': /^[0-9A-ZÅÄÖ]+$/i,
    'th-TH': /^[ก-๙\s]+$/i,
    'tr-TR': /^[0-9A-ZÇĞİıÖŞÜ]+$/i,
    'uk-UA': /^[0-9А-ЩЬЮЯЄIЇҐі]+$/i,
    'ku-IQ': /^[٠١٢٣٤٥٦٧٨٩0-9ئابپتجچحخدرڕزژسشعغفڤقکگلڵمنوۆھەیێيطؤثآإأكضصةظذ]+$/i,
    'vi-VN': /^[0-9A-ZÀÁẠẢÃÂẦẤẬẨẪĂẰẮẶẲẴĐÈÉẸẺẼÊỀẾỆỂỄÌÍỊỈĨÒÓỌỎÕÔỒỐỘỔỖƠỜỚỢỞỠÙÚỤỦŨƯỪỨỰỬỮỲÝỴỶỸ]+$/i,
    ar: /^[٠١٢٣٤٥٦٧٨٩0-9ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ]+$/,
    he: /^[0-9א-ת]+$/,
    fa: /^['0-9آاءأؤئبپتثجچحخدذرزژسشصضطظعغفقکگلمنوهةی۱۲۳۴۵۶۷۸۹۰']+$/i
};
module.exports.alphanumeric = $787c2518b50629c5$var$alphanumeric;
var $787c2518b50629c5$var$decimal = {
    'en-US': '.',
    ar: "\u066B"
};
module.exports.decimal = $787c2518b50629c5$var$decimal;
var $787c2518b50629c5$var$englishLocales = [
    'AU',
    'GB',
    'HK',
    'IN',
    'NZ',
    'ZA',
    'ZM'
];
module.exports.englishLocales = $787c2518b50629c5$var$englishLocales;
for(var $787c2518b50629c5$var$locale, $787c2518b50629c5$var$i = 0; $787c2518b50629c5$var$i < $787c2518b50629c5$var$englishLocales.length; $787c2518b50629c5$var$i++){
    $787c2518b50629c5$var$locale = "en-".concat($787c2518b50629c5$var$englishLocales[$787c2518b50629c5$var$i]);
    $787c2518b50629c5$var$alpha[$787c2518b50629c5$var$locale] = $787c2518b50629c5$var$alpha['en-US'];
    $787c2518b50629c5$var$alphanumeric[$787c2518b50629c5$var$locale] = $787c2518b50629c5$var$alphanumeric['en-US'];
    $787c2518b50629c5$var$decimal[$787c2518b50629c5$var$locale] = $787c2518b50629c5$var$decimal['en-US'];
} // Source: http://www.localeplanet.com/java/
var $787c2518b50629c5$var$arabicLocales = [
    'AE',
    'BH',
    'DZ',
    'EG',
    'IQ',
    'JO',
    'KW',
    'LB',
    'LY',
    'MA',
    'QM',
    'QA',
    'SA',
    'SD',
    'SY',
    'TN',
    'YE'
];
module.exports.arabicLocales = $787c2518b50629c5$var$arabicLocales;
for(var $787c2518b50629c5$var$_locale, $787c2518b50629c5$var$_i = 0; $787c2518b50629c5$var$_i < $787c2518b50629c5$var$arabicLocales.length; $787c2518b50629c5$var$_i++){
    $787c2518b50629c5$var$_locale = "ar-".concat($787c2518b50629c5$var$arabicLocales[$787c2518b50629c5$var$_i]);
    $787c2518b50629c5$var$alpha[$787c2518b50629c5$var$_locale] = $787c2518b50629c5$var$alpha.ar;
    $787c2518b50629c5$var$alphanumeric[$787c2518b50629c5$var$_locale] = $787c2518b50629c5$var$alphanumeric.ar;
    $787c2518b50629c5$var$decimal[$787c2518b50629c5$var$_locale] = $787c2518b50629c5$var$decimal.ar;
}
var $787c2518b50629c5$var$farsiLocales = [
    'IR',
    'AF'
];
module.exports.farsiLocales = $787c2518b50629c5$var$farsiLocales;
for(var $787c2518b50629c5$var$_locale2, $787c2518b50629c5$var$_i2 = 0; $787c2518b50629c5$var$_i2 < $787c2518b50629c5$var$farsiLocales.length; $787c2518b50629c5$var$_i2++){
    $787c2518b50629c5$var$_locale2 = "fa-".concat($787c2518b50629c5$var$farsiLocales[$787c2518b50629c5$var$_i2]);
    $787c2518b50629c5$var$alphanumeric[$787c2518b50629c5$var$_locale2] = $787c2518b50629c5$var$alphanumeric.fa;
    $787c2518b50629c5$var$decimal[$787c2518b50629c5$var$_locale2] = $787c2518b50629c5$var$decimal.ar;
} // Source: https://en.wikipedia.org/wiki/Decimal_mark
var $787c2518b50629c5$var$dotDecimal = [
    'ar-EG',
    'ar-LB',
    'ar-LY'
];
module.exports.dotDecimal = $787c2518b50629c5$var$dotDecimal;
var $787c2518b50629c5$var$commaDecimal = [
    'bg-BG',
    'cs-CZ',
    'da-DK',
    'de-DE',
    'el-GR',
    'en-ZM',
    'es-ES',
    'fr-CA',
    'fr-FR',
    'id-ID',
    'it-IT',
    'ku-IQ',
    'hu-HU',
    'nb-NO',
    'nn-NO',
    'nl-NL',
    'pl-PL',
    'pt-PT',
    'ru-RU',
    'sl-SI',
    'sr-RS@latin',
    'sr-RS',
    'sv-SE',
    'tr-TR',
    'uk-UA',
    'vi-VN'
];
module.exports.commaDecimal = $787c2518b50629c5$var$commaDecimal;
for(var $787c2518b50629c5$var$_i3 = 0; $787c2518b50629c5$var$_i3 < $787c2518b50629c5$var$dotDecimal.length; $787c2518b50629c5$var$_i3++)$787c2518b50629c5$var$decimal[$787c2518b50629c5$var$dotDecimal[$787c2518b50629c5$var$_i3]] = $787c2518b50629c5$var$decimal['en-US'];
for(var $787c2518b50629c5$var$_i4 = 0; $787c2518b50629c5$var$_i4 < $787c2518b50629c5$var$commaDecimal.length; $787c2518b50629c5$var$_i4++)$787c2518b50629c5$var$decimal[$787c2518b50629c5$var$commaDecimal[$787c2518b50629c5$var$_i4]] = ',';
$787c2518b50629c5$var$alpha['fr-CA'] = $787c2518b50629c5$var$alpha['fr-FR'];
$787c2518b50629c5$var$alphanumeric['fr-CA'] = $787c2518b50629c5$var$alphanumeric['fr-FR'];
$787c2518b50629c5$var$alpha['pt-BR'] = $787c2518b50629c5$var$alpha['pt-PT'];
$787c2518b50629c5$var$alphanumeric['pt-BR'] = $787c2518b50629c5$var$alphanumeric['pt-PT'];
$787c2518b50629c5$var$decimal['pt-BR'] = $787c2518b50629c5$var$decimal['pt-PT']; // see #862
$787c2518b50629c5$var$alpha['pl-Pl'] = $787c2518b50629c5$var$alpha['pl-PL'];
$787c2518b50629c5$var$alphanumeric['pl-Pl'] = $787c2518b50629c5$var$alphanumeric['pl-PL'];
$787c2518b50629c5$var$decimal['pl-Pl'] = $787c2518b50629c5$var$decimal['pl-PL']; // see #1455
$787c2518b50629c5$var$alpha['fa-AF'] = $787c2518b50629c5$var$alpha.fa;

});



parcelRegister("ab0Id", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $768b7be7bb7a2e5d$var$toInt;

var $768b7be7bb7a2e5d$var$_assertString = $768b7be7bb7a2e5d$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $768b7be7bb7a2e5d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $768b7be7bb7a2e5d$var$toInt(str, radix) {
    (0, $768b7be7bb7a2e5d$var$_assertString.default)(str);
    return parseInt(str, radix || 10);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("dtiFd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9cec7601b0e513ca$var$toBoolean;

var $9cec7601b0e513ca$var$_assertString = $9cec7601b0e513ca$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $9cec7601b0e513ca$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $9cec7601b0e513ca$var$toBoolean(str, strict) {
    (0, $9cec7601b0e513ca$var$_assertString.default)(str);
    if (strict) return str === '1' || /^true$/i.test(str);
    return str !== '0' && !/^false$/i.test(str) && str !== '';
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("jXY5d", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e8922243f7c899fb$var$equals;

var $e8922243f7c899fb$var$_assertString = $e8922243f7c899fb$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $e8922243f7c899fb$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $e8922243f7c899fb$var$equals(str, comparison) {
    (0, $e8922243f7c899fb$var$_assertString.default)(str);
    return str === comparison;
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("aZ85Q", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7ff5e1054c060d90$var$contains;

var $7ff5e1054c060d90$var$_assertString = $7ff5e1054c060d90$var$_interopRequireDefault((parcelRequire("hZqWG")));

var $7ff5e1054c060d90$var$_toString = $7ff5e1054c060d90$var$_interopRequireDefault((parcelRequire("dAq0G")));

var $7ff5e1054c060d90$var$_merge = $7ff5e1054c060d90$var$_interopRequireDefault((parcelRequire("9nDkO")));
function $7ff5e1054c060d90$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $7ff5e1054c060d90$var$defaulContainsOptions = {
    ignoreCase: false
};
function $7ff5e1054c060d90$var$contains(str, elem, options) {
    (0, $7ff5e1054c060d90$var$_assertString.default)(str);
    options = (0, $7ff5e1054c060d90$var$_merge.default)(options, $7ff5e1054c060d90$var$defaulContainsOptions);
    return options.ignoreCase ? str.toLowerCase().indexOf((0, $7ff5e1054c060d90$var$_toString.default)(elem).toLowerCase()) >= 0 : str.indexOf((0, $7ff5e1054c060d90$var$_toString.default)(elem)) >= 0;
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});
parcelRegister("dAq0G", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9e42d033f9ae4b35$var$toString;
function $9e42d033f9ae4b35$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $9e42d033f9ae4b35$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $9e42d033f9ae4b35$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $9e42d033f9ae4b35$var$_typeof(obj);
}
function $9e42d033f9ae4b35$var$toString(input) {
    if ($9e42d033f9ae4b35$var$_typeof(input) === 'object' && input !== null) {
        if (typeof input.toString === 'function') input = input.toString();
        else input = '[object Object]';
    } else if (input === null || typeof input === 'undefined' || isNaN(input) && !input.length) input = '';
    return String(input);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("9nDkO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6d44c6112d12dafe$var$merge;
function $6d44c6112d12dafe$var$merge() {
    var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var defaults = arguments.length > 1 ? arguments[1] : undefined;
    for(var key in defaults)if (typeof obj[key] === 'undefined') obj[key] = defaults[key];
    return obj;
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});


parcelRegister("5ZSE3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $45dd09a0b348eef1$var$matches;

var $45dd09a0b348eef1$var$_assertString = $45dd09a0b348eef1$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $45dd09a0b348eef1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $45dd09a0b348eef1$var$matches(str, pattern, modifiers) {
    (0, $45dd09a0b348eef1$var$_assertString.default)(str);
    if (Object.prototype.toString.call(pattern) !== '[object RegExp]') pattern = new RegExp(pattern, modifiers);
    return pattern.test(str);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("4tHKL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $342bcf524c691bd2$var$isEmail;

var $342bcf524c691bd2$var$_assertString = $342bcf524c691bd2$var$_interopRequireDefault((parcelRequire("hZqWG")));

var $342bcf524c691bd2$var$_merge = $342bcf524c691bd2$var$_interopRequireDefault((parcelRequire("9nDkO")));

var $342bcf524c691bd2$var$_isByteLength = $342bcf524c691bd2$var$_interopRequireDefault((parcelRequire("lIM5C")));

var $342bcf524c691bd2$var$_isFQDN = $342bcf524c691bd2$var$_interopRequireDefault((parcelRequire("hNevj")));

var $342bcf524c691bd2$var$_isIP = $342bcf524c691bd2$var$_interopRequireDefault((parcelRequire("k4gOC")));
function $342bcf524c691bd2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $342bcf524c691bd2$var$default_email_options = {
    allow_display_name: false,
    require_display_name: false,
    allow_utf8_local_part: true,
    require_tld: true,
    blacklisted_chars: '',
    ignore_max_length: false
};
/* eslint-disable max-len */ /* eslint-disable no-control-regex */ var $342bcf524c691bd2$var$splitNameAddress = /^([^\x00-\x1F\x7F-\x9F\cX]+)</i;
var $342bcf524c691bd2$var$emailUserPart = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~]+$/i;
var $342bcf524c691bd2$var$gmailUserPart = /^[a-z\d]+$/;
var $342bcf524c691bd2$var$quotedEmailUser = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f]))*$/i;
var $342bcf524c691bd2$var$emailUserUtf8Part = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+$/i;
var $342bcf524c691bd2$var$quotedEmailUserUtf8 = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*$/i;
var $342bcf524c691bd2$var$defaultMaxEmailLength = 254;
/* eslint-enable max-len */ /* eslint-enable no-control-regex */ /**
 * Validate display name according to the RFC2822: https://tools.ietf.org/html/rfc2822#appendix-A.1.2
 * @param {String} display_name
 */ function $342bcf524c691bd2$var$validateDisplayName(display_name) {
    var display_name_without_quotes = display_name.replace(/^"(.+)"$/, '$1'); // display name with only spaces is not valid
    if (!display_name_without_quotes.trim()) return false;
     // check whether display name contains illegal character
    var contains_illegal = /[\.";<>]/.test(display_name_without_quotes);
    if (contains_illegal) {
        // if contains illegal characters,
        // must to be enclosed in double-quotes, otherwise it's not a valid display name
        if (display_name_without_quotes === display_name) return false;
         // the quotes in display name must start with character symbol \
        var all_start_with_back_slash = display_name_without_quotes.split('"').length === display_name_without_quotes.split('\\"').length;
        if (!all_start_with_back_slash) return false;
    }
    return true;
}
function $342bcf524c691bd2$var$isEmail(str, options) {
    (0, $342bcf524c691bd2$var$_assertString.default)(str);
    options = (0, $342bcf524c691bd2$var$_merge.default)(options, $342bcf524c691bd2$var$default_email_options);
    if (options.require_display_name || options.allow_display_name) {
        var display_email = str.match($342bcf524c691bd2$var$splitNameAddress);
        if (display_email) {
            var display_name = display_email[1]; // Remove display name and angle brackets to get email address
            // Can be done in the regex but will introduce a ReDOS (See  #1597 for more info)
            str = str.replace(display_name, '').replace(/(^<|>$)/g, ''); // sometimes need to trim the last space to get the display name
            // because there may be a space between display name and email address
            // eg. myname <address@gmail.com>
            // the display name is `myname` instead of `myname `, so need to trim the last space
            if (display_name.endsWith(' ')) display_name = display_name.substr(0, display_name.length - 1);
            if (!$342bcf524c691bd2$var$validateDisplayName(display_name)) return false;
        } else if (options.require_display_name) return false;
    }
    if (!options.ignore_max_length && str.length > $342bcf524c691bd2$var$defaultMaxEmailLength) return false;
    var parts = str.split('@');
    var domain = parts.pop();
    var user = parts.join('@');
    var lower_domain = domain.toLowerCase();
    if (options.domain_specific_validation && (lower_domain === 'gmail.com' || lower_domain === 'googlemail.com')) {
        /*
      Previously we removed dots for gmail addresses before validating.
      This was removed because it allows `multiple..dots@gmail.com`
      to be reported as valid, but it is not.
      Gmail only normalizes single dots, removing them from here is pointless,
      should be done in normalizeEmail
    */ user = user.toLowerCase(); // Removing sub-address from username before gmail validation
        var username = user.split('+')[0]; // Dots are not included in gmail length restriction
        if (!(0, $342bcf524c691bd2$var$_isByteLength.default)(username.replace('.', ''), {
            min: 6,
            max: 30
        })) return false;
        var _user_parts = username.split('.');
        for(var i = 0; i < _user_parts.length; i++){
            if (!$342bcf524c691bd2$var$gmailUserPart.test(_user_parts[i])) return false;
        }
    }
    if (options.ignore_max_length === false && (!(0, $342bcf524c691bd2$var$_isByteLength.default)(user, {
        max: 64
    }) || !(0, $342bcf524c691bd2$var$_isByteLength.default)(domain, {
        max: 254
    }))) return false;
    if (!(0, $342bcf524c691bd2$var$_isFQDN.default)(domain, {
        require_tld: options.require_tld
    })) {
        if (!options.allow_ip_domain) return false;
        if (!(0, $342bcf524c691bd2$var$_isIP.default)(domain)) {
            if (!domain.startsWith('[') || !domain.endsWith(']')) return false;
            var noBracketdomain = domain.substr(1, domain.length - 2);
            if (noBracketdomain.length === 0 || !(0, $342bcf524c691bd2$var$_isIP.default)(noBracketdomain)) return false;
        }
    }
    if (user[0] === '"') {
        user = user.slice(1, user.length - 1);
        return options.allow_utf8_local_part ? $342bcf524c691bd2$var$quotedEmailUserUtf8.test(user) : $342bcf524c691bd2$var$quotedEmailUser.test(user);
    }
    var pattern = options.allow_utf8_local_part ? $342bcf524c691bd2$var$emailUserUtf8Part : $342bcf524c691bd2$var$emailUserPart;
    var user_parts = user.split('.');
    for(var _i = 0; _i < user_parts.length; _i++){
        if (!pattern.test(user_parts[_i])) return false;
    }
    if (options.blacklisted_chars) {
        if (user.search(new RegExp("[".concat(options.blacklisted_chars, "]+"), 'g')) !== -1) return false;
    }
    return true;
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});
parcelRegister("lIM5C", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $fd0302a416500dad$var$isByteLength;

var $fd0302a416500dad$var$_assertString = $fd0302a416500dad$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $fd0302a416500dad$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $fd0302a416500dad$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $fd0302a416500dad$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $fd0302a416500dad$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $fd0302a416500dad$var$_typeof(obj);
}
/* eslint-disable prefer-rest-params */ function $fd0302a416500dad$var$isByteLength(str, options) {
    (0, $fd0302a416500dad$var$_assertString.default)(str);
    var min;
    var max;
    if ($fd0302a416500dad$var$_typeof(options) === 'object') {
        min = options.min || 0;
        max = options.max;
    } else {
        // backwards compatibility: isByteLength(str, min [, max])
        min = arguments[1];
        max = arguments[2];
    }
    var len = encodeURI(str).split(/%..|./).length - 1;
    return len >= min && (typeof max === 'undefined' || len <= max);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("hNevj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $cf424376bb64783b$var$isFQDN;

var $cf424376bb64783b$var$_assertString = $cf424376bb64783b$var$_interopRequireDefault((parcelRequire("hZqWG")));

var $cf424376bb64783b$var$_merge = $cf424376bb64783b$var$_interopRequireDefault((parcelRequire("9nDkO")));
function $cf424376bb64783b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $cf424376bb64783b$var$default_fqdn_options = {
    require_tld: true,
    allow_underscores: false,
    allow_trailing_dot: false,
    allow_numeric_tld: false
};
function $cf424376bb64783b$var$isFQDN(str, options) {
    (0, $cf424376bb64783b$var$_assertString.default)(str);
    options = (0, $cf424376bb64783b$var$_merge.default)(options, $cf424376bb64783b$var$default_fqdn_options);
    /* Remove the optional trailing dot before checking validity */ if (options.allow_trailing_dot && str[str.length - 1] === '.') str = str.substring(0, str.length - 1);
    var parts = str.split('.');
    var tld = parts[parts.length - 1];
    if (options.require_tld) {
        // disallow fqdns without tld
        if (parts.length < 2) return false;
        if (!/^([a-z\u00a1-\uffff]{2,}|xn[a-z0-9-]{2,})$/i.test(tld)) return false;
         // disallow spaces && special characers
        if (/[\s\u2002-\u200B\u202F\u205F\u3000\uFEFF\uDB40\uDC20\u00A9\uFFFD]/.test(tld)) return false;
    } // reject numeric TLDs
    if (!options.allow_numeric_tld && /^\d+$/.test(tld)) return false;
    return parts.every(function(part) {
        if (part.length > 63) return false;
        if (!/^[a-z_\u00a1-\uffff0-9-]+$/i.test(part)) return false;
         // disallow full-width chars
        if (/[\uff01-\uff5e]/.test(part)) return false;
         // disallow parts starting or ending with hyphen
        if (/^-|-$/.test(part)) return false;
        if (!options.allow_underscores && /_/.test(part)) return false;
        return true;
    });
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("k4gOC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e9c1399487ce19b5$var$isIP;

var $e9c1399487ce19b5$var$_assertString = $e9c1399487ce19b5$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $e9c1399487ce19b5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
11.3.  Examples

   The following addresses

             fe80::1234 (on the 1st link of the node)
             ff02::5678 (on the 5th link of the node)
             ff08::9abc (on the 10th organization of the node)

   would be represented as follows:

             fe80::1234%1
             ff02::5678%5
             ff08::9abc%10

   (Here we assume a natural translation from a zone index to the
   <zone_id> part, where the Nth zone of any scope is translated into
   "N".)

   If we use interface names as <zone_id>, those addresses could also be
   represented as follows:

            fe80::1234%ne0
            ff02::5678%pvc1.3
            ff08::9abc%interface10

   where the interface "ne0" belongs to the 1st link, "pvc1.3" belongs
   to the 5th link, and "interface10" belongs to the 10th organization.
 * * */ var $e9c1399487ce19b5$var$IPv4SegmentFormat = '(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])';
var $e9c1399487ce19b5$var$IPv4AddressFormat = "(".concat($e9c1399487ce19b5$var$IPv4SegmentFormat, "[.]){3}").concat($e9c1399487ce19b5$var$IPv4SegmentFormat);
var $e9c1399487ce19b5$var$IPv4AddressRegExp = new RegExp("^".concat($e9c1399487ce19b5$var$IPv4AddressFormat, "$"));
var $e9c1399487ce19b5$var$IPv6SegmentFormat = '(?:[0-9a-fA-F]{1,4})';
var $e9c1399487ce19b5$var$IPv6AddressRegExp = new RegExp('^(' + "(?:".concat($e9c1399487ce19b5$var$IPv6SegmentFormat, ":){7}(?:").concat($e9c1399487ce19b5$var$IPv6SegmentFormat, "|:)|") + "(?:".concat($e9c1399487ce19b5$var$IPv6SegmentFormat, ":){6}(?:").concat($e9c1399487ce19b5$var$IPv4AddressFormat, "|:").concat($e9c1399487ce19b5$var$IPv6SegmentFormat, "|:)|") + "(?:".concat($e9c1399487ce19b5$var$IPv6SegmentFormat, ":){5}(?::").concat($e9c1399487ce19b5$var$IPv4AddressFormat, "|(:").concat($e9c1399487ce19b5$var$IPv6SegmentFormat, "){1,2}|:)|") + "(?:".concat($e9c1399487ce19b5$var$IPv6SegmentFormat, ":){4}(?:(:").concat($e9c1399487ce19b5$var$IPv6SegmentFormat, "){0,1}:").concat($e9c1399487ce19b5$var$IPv4AddressFormat, "|(:").concat($e9c1399487ce19b5$var$IPv6SegmentFormat, "){1,3}|:)|") + "(?:".concat($e9c1399487ce19b5$var$IPv6SegmentFormat, ":){3}(?:(:").concat($e9c1399487ce19b5$var$IPv6SegmentFormat, "){0,2}:").concat($e9c1399487ce19b5$var$IPv4AddressFormat, "|(:").concat($e9c1399487ce19b5$var$IPv6SegmentFormat, "){1,4}|:)|") + "(?:".concat($e9c1399487ce19b5$var$IPv6SegmentFormat, ":){2}(?:(:").concat($e9c1399487ce19b5$var$IPv6SegmentFormat, "){0,3}:").concat($e9c1399487ce19b5$var$IPv4AddressFormat, "|(:").concat($e9c1399487ce19b5$var$IPv6SegmentFormat, "){1,5}|:)|") + "(?:".concat($e9c1399487ce19b5$var$IPv6SegmentFormat, ":){1}(?:(:").concat($e9c1399487ce19b5$var$IPv6SegmentFormat, "){0,4}:").concat($e9c1399487ce19b5$var$IPv4AddressFormat, "|(:").concat($e9c1399487ce19b5$var$IPv6SegmentFormat, "){1,6}|:)|") + "(?::((?::".concat($e9c1399487ce19b5$var$IPv6SegmentFormat, "){0,5}:").concat($e9c1399487ce19b5$var$IPv4AddressFormat, "|(?::").concat($e9c1399487ce19b5$var$IPv6SegmentFormat, "){1,7}|:))") + ')(%[0-9a-zA-Z-.:]{1,})?$');
function $e9c1399487ce19b5$var$isIP(str) {
    var version = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    (0, $e9c1399487ce19b5$var$_assertString.default)(str);
    version = String(version);
    if (!version) return $e9c1399487ce19b5$var$isIP(str, 4) || $e9c1399487ce19b5$var$isIP(str, 6);
    if (version === '4') {
        if (!$e9c1399487ce19b5$var$IPv4AddressRegExp.test(str)) return false;
        var parts = str.split('.').sort(function(a, b) {
            return a - b;
        });
        return parts[3] <= 255;
    }
    if (version === '6') return !!$e9c1399487ce19b5$var$IPv6AddressRegExp.test(str);
    return false;
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});


parcelRegister("4Cxzb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $35d4bf9d9281792e$var$isURL;

var $35d4bf9d9281792e$var$_assertString = $35d4bf9d9281792e$var$_interopRequireDefault((parcelRequire("hZqWG")));

var $35d4bf9d9281792e$var$_isFQDN = $35d4bf9d9281792e$var$_interopRequireDefault((parcelRequire("hNevj")));

var $35d4bf9d9281792e$var$_isIP = $35d4bf9d9281792e$var$_interopRequireDefault((parcelRequire("k4gOC")));

var $35d4bf9d9281792e$var$_merge = $35d4bf9d9281792e$var$_interopRequireDefault((parcelRequire("9nDkO")));
function $35d4bf9d9281792e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/*
options for isURL method

require_protocol - if set as true isURL will return false if protocol is not present in the URL
require_valid_protocol - isURL will check if the URL's protocol is present in the protocols option
protocols - valid protocols can be modified with this option
require_host - if set as false isURL will not check if host is present in the URL
require_port - if set as true isURL will check if port is present in the URL
allow_protocol_relative_urls - if set as true protocol relative URLs will be allowed
validate_length - if set as false isURL will skip string length validation (IE maximum is 2083)

*/ var $35d4bf9d9281792e$var$default_url_options = {
    protocols: [
        'http',
        'https',
        'ftp'
    ],
    require_tld: true,
    require_protocol: false,
    require_host: true,
    require_port: false,
    require_valid_protocol: true,
    allow_underscores: false,
    allow_trailing_dot: false,
    allow_protocol_relative_urls: false,
    validate_length: true
};
var $35d4bf9d9281792e$var$wrapped_ipv6 = /^\[([^\]]+)\](?::([0-9]+))?$/;
function $35d4bf9d9281792e$var$isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
}
function $35d4bf9d9281792e$var$checkHost(host, matches) {
    for(var i = 0; i < matches.length; i++){
        var match = matches[i];
        if (host === match || $35d4bf9d9281792e$var$isRegExp(match) && match.test(host)) return true;
    }
    return false;
}
function $35d4bf9d9281792e$var$isURL(url, options) {
    (0, $35d4bf9d9281792e$var$_assertString.default)(url);
    if (!url || /[\s<>]/.test(url)) return false;
    if (url.indexOf('mailto:') === 0) return false;
    options = (0, $35d4bf9d9281792e$var$_merge.default)(options, $35d4bf9d9281792e$var$default_url_options);
    if (options.validate_length && url.length >= 2083) return false;
    var protocol, auth, host, hostname, port, port_str, split, ipv6;
    split = url.split('#');
    url = split.shift();
    split = url.split('?');
    url = split.shift();
    split = url.split('://');
    if (split.length > 1) {
        protocol = split.shift().toLowerCase();
        if (options.require_valid_protocol && options.protocols.indexOf(protocol) === -1) return false;
    } else if (options.require_protocol) return false;
    else if (url.substr(0, 2) === '//') {
        if (!options.allow_protocol_relative_urls) return false;
        split[0] = url.substr(2);
    }
    url = split.join('://');
    if (url === '') return false;
    split = url.split('/');
    url = split.shift();
    if (url === '' && !options.require_host) return true;
    split = url.split('@');
    if (split.length > 1) {
        if (options.disallow_auth) return false;
        if (split[0] === '' || split[0].substr(0, 1) === ':') return false;
        auth = split.shift();
        if (auth.indexOf(':') >= 0 && auth.split(':').length > 2) return false;
    }
    hostname = split.join('@');
    port_str = null;
    ipv6 = null;
    var ipv6_match = hostname.match($35d4bf9d9281792e$var$wrapped_ipv6);
    if (ipv6_match) {
        host = '';
        ipv6 = ipv6_match[1];
        port_str = ipv6_match[2] || null;
    } else {
        split = hostname.split(':');
        host = split.shift();
        if (split.length) port_str = split.join(':');
    }
    if (port_str !== null) {
        port = parseInt(port_str, 10);
        if (!/^[0-9]+$/.test(port_str) || port <= 0 || port > 65535) return false;
    } else if (options.require_port) return false;
    if (!(0, $35d4bf9d9281792e$var$_isIP.default)(host) && !(0, $35d4bf9d9281792e$var$_isFQDN.default)(host, options) && (!ipv6 || !(0, $35d4bf9d9281792e$var$_isIP.default)(ipv6, 6))) return false;
    host = host || ipv6;
    if (options.host_whitelist && !$35d4bf9d9281792e$var$checkHost(host, options.host_whitelist)) return false;
    if (options.host_blacklist && $35d4bf9d9281792e$var$checkHost(host, options.host_blacklist)) return false;
    return true;
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("S05Bl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0a251d00a80bd0ec$var$isMACAddress;

var $0a251d00a80bd0ec$var$_assertString = $0a251d00a80bd0ec$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $0a251d00a80bd0ec$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $0a251d00a80bd0ec$var$macAddress = /^(?:[0-9a-fA-F]{2}([-:\s]))([0-9a-fA-F]{2}\1){4}([0-9a-fA-F]{2})$/;
var $0a251d00a80bd0ec$var$macAddressNoSeparators = /^([0-9a-fA-F]){12}$/;
var $0a251d00a80bd0ec$var$macAddressWithDots = /^([0-9a-fA-F]{4}\.){2}([0-9a-fA-F]{4})$/;
function $0a251d00a80bd0ec$var$isMACAddress(str, options) {
    (0, $0a251d00a80bd0ec$var$_assertString.default)(str);
    /**
   * @deprecated `no_colons` TODO: remove it in the next major
  */ if (options && (options.no_colons || options.no_separators)) return $0a251d00a80bd0ec$var$macAddressNoSeparators.test(str);
    return $0a251d00a80bd0ec$var$macAddress.test(str) || $0a251d00a80bd0ec$var$macAddressWithDots.test(str);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("9xDwV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6f25dbf79de56c7d$var$isIPRange;

var $6f25dbf79de56c7d$var$_assertString = $6f25dbf79de56c7d$var$_interopRequireDefault((parcelRequire("hZqWG")));

var $6f25dbf79de56c7d$var$_isIP = $6f25dbf79de56c7d$var$_interopRequireDefault((parcelRequire("k4gOC")));
function $6f25dbf79de56c7d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $6f25dbf79de56c7d$var$subnetMaybe = /^\d{1,3}$/;
var $6f25dbf79de56c7d$var$v4Subnet = 32;
var $6f25dbf79de56c7d$var$v6Subnet = 128;
function $6f25dbf79de56c7d$var$isIPRange(str) {
    var version = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    (0, $6f25dbf79de56c7d$var$_assertString.default)(str);
    var parts = str.split('/'); // parts[0] -> ip, parts[1] -> subnet
    if (parts.length !== 2) return false;
    if (!$6f25dbf79de56c7d$var$subnetMaybe.test(parts[1])) return false;
     // Disallow preceding 0 i.e. 01, 02, ...
    if (parts[1].length > 1 && parts[1].startsWith('0')) return false;
    var isValidIP = (0, $6f25dbf79de56c7d$var$_isIP.default)(parts[0], version);
    if (!isValidIP) return false;
     // Define valid subnet according to IP's version
    var expectedSubnet = null;
    switch(String(version)){
        case '4':
            expectedSubnet = $6f25dbf79de56c7d$var$v4Subnet;
            break;
        case '6':
            expectedSubnet = $6f25dbf79de56c7d$var$v6Subnet;
            break;
        default:
            expectedSubnet = (0, $6f25dbf79de56c7d$var$_isIP.default)(parts[0], '6') ? $6f25dbf79de56c7d$var$v6Subnet : $6f25dbf79de56c7d$var$v4Subnet;
    }
    return parts[1] <= expectedSubnet && parts[1] >= 0;
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("akLR8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7860e4dd34e35154$var$isDate;

var $7860e4dd34e35154$var$_merge = $7860e4dd34e35154$var$_interopRequireDefault((parcelRequire("9nDkO")));
function $7860e4dd34e35154$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $7860e4dd34e35154$var$_slicedToArray(arr, i) {
    return $7860e4dd34e35154$var$_arrayWithHoles(arr) || $7860e4dd34e35154$var$_iterableToArrayLimit(arr, i) || $7860e4dd34e35154$var$_unsupportedIterableToArray(arr, i) || $7860e4dd34e35154$var$_nonIterableRest();
}
function $7860e4dd34e35154$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $7860e4dd34e35154$var$_iterableToArrayLimit(arr, i) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $7860e4dd34e35154$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $7860e4dd34e35154$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it;
    if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
        if (Array.isArray(o) || (it = $7860e4dd34e35154$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e2) {
                    throw _e2;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = o[Symbol.iterator]();
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e3) {
            didErr = true;
            err = _e3;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $7860e4dd34e35154$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $7860e4dd34e35154$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $7860e4dd34e35154$var$_arrayLikeToArray(o, minLen);
}
function $7860e4dd34e35154$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $7860e4dd34e35154$var$default_date_options = {
    format: 'YYYY/MM/DD',
    delimiters: [
        '/',
        '-'
    ],
    strictMode: false
};
function $7860e4dd34e35154$var$isValidFormat(format) {
    return /(^(y{4}|y{2})[\/-](m{1,2})[\/-](d{1,2})$)|(^(m{1,2})[\/-](d{1,2})[\/-]((y{4}|y{2})$))|(^(d{1,2})[\/-](m{1,2})[\/-]((y{4}|y{2})$))/gi.test(format);
}
function $7860e4dd34e35154$var$zip(date, format) {
    var zippedArr = [], len = Math.min(date.length, format.length);
    for(var i = 0; i < len; i++)zippedArr.push([
        date[i],
        format[i]
    ]);
    return zippedArr;
}
function $7860e4dd34e35154$var$isDate(input, options) {
    if (typeof options === 'string') // Allow backward compatbility for old format isDate(input [, format])
    options = (0, $7860e4dd34e35154$var$_merge.default)({
        format: options
    }, $7860e4dd34e35154$var$default_date_options);
    else options = (0, $7860e4dd34e35154$var$_merge.default)(options, $7860e4dd34e35154$var$default_date_options);
    if (typeof input === 'string' && $7860e4dd34e35154$var$isValidFormat(options.format)) {
        var formatDelimiter = options.delimiters.find(function(delimiter) {
            return options.format.indexOf(delimiter) !== -1;
        });
        var dateDelimiter = options.strictMode ? formatDelimiter : options.delimiters.find(function(delimiter) {
            return input.indexOf(delimiter) !== -1;
        });
        var dateAndFormat = $7860e4dd34e35154$var$zip(input.split(dateDelimiter), options.format.toLowerCase().split(formatDelimiter));
        var dateObj = {};
        var _iterator = $7860e4dd34e35154$var$_createForOfIteratorHelper(dateAndFormat), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var _step$value = $7860e4dd34e35154$var$_slicedToArray(_step.value, 2), dateWord = _step$value[0], formatWord = _step$value[1];
                if (dateWord.length !== formatWord.length) return false;
                dateObj[formatWord.charAt(0)] = dateWord;
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return new Date("".concat(dateObj.m, "/").concat(dateObj.d, "/").concat(dateObj.y)).getDate() === +dateObj.d;
    }
    if (!options.strictMode) return Object.prototype.toString.call(input) === '[object Date]' && isFinite(input);
    return false;
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("5sk3S", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3f8f2114237cf72d$var$isBoolean;

var $3f8f2114237cf72d$var$_assertString = $3f8f2114237cf72d$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $3f8f2114237cf72d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $3f8f2114237cf72d$var$isBoolean(str) {
    (0, $3f8f2114237cf72d$var$_assertString.default)(str);
    return [
        'true',
        'false',
        '1',
        '0'
    ].indexOf(str) >= 0;
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("9E8F4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $705e917039c621bf$var$isLocale;

var $705e917039c621bf$var$_assertString = $705e917039c621bf$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $705e917039c621bf$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $705e917039c621bf$var$localeReg = /^[A-Za-z]{2,4}([_-]([A-Za-z]{4}|[\d]{3}))?([_-]([A-Za-z]{2}|[\d]{3}))?$/;
function $705e917039c621bf$var$isLocale(str) {
    (0, $705e917039c621bf$var$_assertString.default)(str);
    if (str === 'en_US_POSIX' || str === 'ca_ES_VALENCIA') return true;
    return $705e917039c621bf$var$localeReg.test(str);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("fvxOe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b4a3fa1288ebd161$var$isAlpha;
module.exports.locales = void 0;

var $b4a3fa1288ebd161$var$_assertString = $b4a3fa1288ebd161$var$_interopRequireDefault((parcelRequire("hZqWG")));

var $alkZf = parcelRequire("alkZf");
function $b4a3fa1288ebd161$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $b4a3fa1288ebd161$var$isAlpha(_str) {
    var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en-US';
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    (0, $b4a3fa1288ebd161$var$_assertString.default)(_str);
    var str = _str;
    var ignore = options.ignore;
    if (ignore) {
        if (ignore instanceof RegExp) str = str.replace(ignore, '');
        else if (typeof ignore === 'string') str = str.replace(new RegExp("[".concat(ignore.replace(/[-[\]{}()*+?.,\\^$|#\\s]/g, '\\$&'), "]"), 'g'), ''); // escape regex for ignore
        else throw new Error('ignore should be instance of a String or RegExp');
    }
    if (locale in $alkZf.alpha) return $alkZf.alpha[locale].test(str);
    throw new Error("Invalid locale '".concat(locale, "'"));
}
var $b4a3fa1288ebd161$var$locales = Object.keys($alkZf.alpha);
module.exports.locales = $b4a3fa1288ebd161$var$locales;

});

parcelRegister("9AaLY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6f9fd5147e20bff2$var$isAlphanumeric;
module.exports.locales = void 0;

var $6f9fd5147e20bff2$var$_assertString = $6f9fd5147e20bff2$var$_interopRequireDefault((parcelRequire("hZqWG")));

var $alkZf = parcelRequire("alkZf");
function $6f9fd5147e20bff2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $6f9fd5147e20bff2$var$isAlphanumeric(_str) {
    var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en-US';
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    (0, $6f9fd5147e20bff2$var$_assertString.default)(_str);
    var str = _str;
    var ignore = options.ignore;
    if (ignore) {
        if (ignore instanceof RegExp) str = str.replace(ignore, '');
        else if (typeof ignore === 'string') str = str.replace(new RegExp("[".concat(ignore.replace(/[-[\]{}()*+?.,\\^$|#\\s]/g, '\\$&'), "]"), 'g'), ''); // escape regex for ignore
        else throw new Error('ignore should be instance of a String or RegExp');
    }
    if (locale in $alkZf.alphanumeric) return $alkZf.alphanumeric[locale].test(str);
    throw new Error("Invalid locale '".concat(locale, "'"));
}
var $6f9fd5147e20bff2$var$locales = Object.keys($alkZf.alphanumeric);
module.exports.locales = $6f9fd5147e20bff2$var$locales;

});

parcelRegister("b9xtB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $81ea80af3d27e27d$var$isNumeric;

var $81ea80af3d27e27d$var$_assertString = $81ea80af3d27e27d$var$_interopRequireDefault((parcelRequire("hZqWG")));

var $alkZf = parcelRequire("alkZf");
function $81ea80af3d27e27d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $81ea80af3d27e27d$var$numericNoSymbols = /^[0-9]+$/;
function $81ea80af3d27e27d$var$isNumeric(str, options) {
    (0, $81ea80af3d27e27d$var$_assertString.default)(str);
    if (options && options.no_symbols) return $81ea80af3d27e27d$var$numericNoSymbols.test(str);
    return new RegExp("^[+-]?([0-9]*[".concat((options || {}).locale ? $alkZf.decimal[options.locale] : '.', "])?[0-9]+$")).test(str);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("lpGGU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f96d0c4eeb9e4d0d$var$isPassportNumber;

var $f96d0c4eeb9e4d0d$var$_assertString = $f96d0c4eeb9e4d0d$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $f96d0c4eeb9e4d0d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * Reference:
 * https://en.wikipedia.org/ -- Wikipedia
 * https://docs.microsoft.com/en-us/microsoft-365/compliance/eu-passport-number -- EU Passport Number
 * https://countrycode.org/ -- Country Codes
 */ var $f96d0c4eeb9e4d0d$var$passportRegexByCountryCode = {
    AM: /^[A-Z]{2}\d{7}$/,
    // ARMENIA
    AR: /^[A-Z]{3}\d{6}$/,
    // ARGENTINA
    AT: /^[A-Z]\d{7}$/,
    // AUSTRIA
    AU: /^[A-Z]\d{7}$/,
    // AUSTRALIA
    BE: /^[A-Z]{2}\d{6}$/,
    // BELGIUM
    BG: /^\d{9}$/,
    // BULGARIA
    BR: /^[A-Z]{2}\d{6}$/,
    // BRAZIL
    BY: /^[A-Z]{2}\d{7}$/,
    // BELARUS
    CA: /^[A-Z]{2}\d{6}$/,
    // CANADA
    CH: /^[A-Z]\d{7}$/,
    // SWITZERLAND
    CN: /^[GE]\d{8}$/,
    // CHINA [G=Ordinary, E=Electronic] followed by 8-digits
    CY: /^[A-Z](\d{6}|\d{8})$/,
    // CYPRUS
    CZ: /^\d{8}$/,
    // CZECH REPUBLIC
    DE: /^[CFGHJKLMNPRTVWXYZ0-9]{9}$/,
    // GERMANY
    DK: /^\d{9}$/,
    // DENMARK
    DZ: /^\d{9}$/,
    // ALGERIA
    EE: /^([A-Z]\d{7}|[A-Z]{2}\d{7})$/,
    // ESTONIA (K followed by 7-digits), e-passports have 2 UPPERCASE followed by 7 digits
    ES: /^[A-Z0-9]{2}([A-Z0-9]?)\d{6}$/,
    // SPAIN
    FI: /^[A-Z]{2}\d{7}$/,
    // FINLAND
    FR: /^\d{2}[A-Z]{2}\d{5}$/,
    // FRANCE
    GB: /^\d{9}$/,
    // UNITED KINGDOM
    GR: /^[A-Z]{2}\d{7}$/,
    // GREECE
    HR: /^\d{9}$/,
    // CROATIA
    HU: /^[A-Z]{2}(\d{6}|\d{7})$/,
    // HUNGARY
    IE: /^[A-Z0-9]{2}\d{7}$/,
    // IRELAND
    IN: /^[A-Z]{1}-?\d{7}$/,
    // INDIA
    IR: /^[A-Z]\d{8}$/,
    // IRAN
    IS: /^(A)\d{7}$/,
    // ICELAND
    IT: /^[A-Z0-9]{2}\d{7}$/,
    // ITALY
    JP: /^[A-Z]{2}\d{7}$/,
    // JAPAN
    KR: /^[MS]\d{8}$/,
    // SOUTH KOREA, REPUBLIC OF KOREA, [S=PS Passports, M=PM Passports]
    LT: /^[A-Z0-9]{8}$/,
    // LITHUANIA
    LU: /^[A-Z0-9]{8}$/,
    // LUXEMBURG
    LV: /^[A-Z0-9]{2}\d{7}$/,
    // LATVIA
    LY: /^[A-Z0-9]{8}$/,
    // LIBYA
    MT: /^\d{7}$/,
    // MALTA
    MZ: /^([A-Z]{2}\d{7})|(\d{2}[A-Z]{2}\d{5})$/,
    // MOZAMBIQUE
    MY: /^[AHK]\d{8}$/,
    // MALAYSIA
    NL: /^[A-Z]{2}[A-Z0-9]{6}\d$/,
    // NETHERLANDS
    PO: /^[A-Z]{2}\d{7}$/,
    // POLAND
    PT: /^[A-Z]\d{6}$/,
    // PORTUGAL
    RO: /^\d{8,9}$/,
    // ROMANIA
    RU: /^\d{2}\d{2}\d{6}$/,
    // RUSSIAN FEDERATION
    SE: /^\d{8}$/,
    // SWEDEN
    SL: /^(P)[A-Z]\d{7}$/,
    // SLOVANIA
    SK: /^[0-9A-Z]\d{7}$/,
    // SLOVAKIA
    TR: /^[A-Z]\d{8}$/,
    // TURKEY
    UA: /^[A-Z]{2}\d{6}$/,
    // UKRAINE
    US: /^\d{9}$/ // UNITED STATES
};
/**
 * Check if str is a valid passport number
 * relative to provided ISO Country Code.
 *
 * @param {string} str
 * @param {string} countryCode
 * @return {boolean}
 */ function $f96d0c4eeb9e4d0d$var$isPassportNumber(str, countryCode) {
    (0, $f96d0c4eeb9e4d0d$var$_assertString.default)(str);
    /** Remove All Whitespaces, Convert to UPPERCASE */ var normalizedStr = str.replace(/\s/g, '').toUpperCase();
    return countryCode.toUpperCase() in $f96d0c4eeb9e4d0d$var$passportRegexByCountryCode && $f96d0c4eeb9e4d0d$var$passportRegexByCountryCode[countryCode].test(normalizedStr);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("anXSC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $78fa8043562920b1$var$isPort;

var $78fa8043562920b1$var$_isInt = $78fa8043562920b1$var$_interopRequireDefault((parcelRequire("3VTZw")));
function $78fa8043562920b1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $78fa8043562920b1$var$isPort(str) {
    return (0, $78fa8043562920b1$var$_isInt.default)(str, {
        min: 0,
        max: 65535
    });
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});
parcelRegister("3VTZw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2dd220af97ca2a6a$var$isInt;

var $2dd220af97ca2a6a$var$_assertString = $2dd220af97ca2a6a$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $2dd220af97ca2a6a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $2dd220af97ca2a6a$var$int = /^(?:[-+]?(?:0|[1-9][0-9]*))$/;
var $2dd220af97ca2a6a$var$intLeadingZeroes = /^[-+]?[0-9]+$/;
function $2dd220af97ca2a6a$var$isInt(str, options) {
    (0, $2dd220af97ca2a6a$var$_assertString.default)(str);
    options = options || {}; // Get the regex to use for testing, based on whether
    // leading zeroes are allowed or not.
    var regex = options.hasOwnProperty('allow_leading_zeroes') && !options.allow_leading_zeroes ? $2dd220af97ca2a6a$var$int : $2dd220af97ca2a6a$var$intLeadingZeroes; // Check min/max/lt/gt
    var minCheckPassed = !options.hasOwnProperty('min') || str >= options.min;
    var maxCheckPassed = !options.hasOwnProperty('max') || str <= options.max;
    var ltCheckPassed = !options.hasOwnProperty('lt') || str < options.lt;
    var gtCheckPassed = !options.hasOwnProperty('gt') || str > options.gt;
    return regex.test(str) && minCheckPassed && maxCheckPassed && ltCheckPassed && gtCheckPassed;
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});


parcelRegister("8YYKA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $68a30d16883720bb$var$isLowercase;

var $68a30d16883720bb$var$_assertString = $68a30d16883720bb$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $68a30d16883720bb$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $68a30d16883720bb$var$isLowercase(str) {
    (0, $68a30d16883720bb$var$_assertString.default)(str);
    return str === str.toLowerCase();
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("Y8gNP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0b4c04f6a35f5e6a$var$isUppercase;

var $0b4c04f6a35f5e6a$var$_assertString = $0b4c04f6a35f5e6a$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $0b4c04f6a35f5e6a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $0b4c04f6a35f5e6a$var$isUppercase(str) {
    (0, $0b4c04f6a35f5e6a$var$_assertString.default)(str);
    return str === str.toUpperCase();
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("8DM8E", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $64a74e9492c68bc9$var$isIMEI;

var $64a74e9492c68bc9$var$_assertString = $64a74e9492c68bc9$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $64a74e9492c68bc9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $64a74e9492c68bc9$var$imeiRegexWithoutHypens = /^[0-9]{15}$/;
var $64a74e9492c68bc9$var$imeiRegexWithHypens = /^\d{2}-\d{6}-\d{6}-\d{1}$/;
function $64a74e9492c68bc9$var$isIMEI(str, options) {
    (0, $64a74e9492c68bc9$var$_assertString.default)(str);
    options = options || {}; // default regex for checking imei is the one without hyphens
    var imeiRegex = $64a74e9492c68bc9$var$imeiRegexWithoutHypens;
    if (options.allow_hyphens) imeiRegex = $64a74e9492c68bc9$var$imeiRegexWithHypens;
    if (!imeiRegex.test(str)) return false;
    str = str.replace(/-/g, '');
    var sum = 0, mul = 2, l = 14;
    for(var i = 0; i < l; i++){
        var digit = str.substring(l - i - 1, l - i);
        var tp = parseInt(digit, 10) * mul;
        if (tp >= 10) sum += tp % 10 + 1;
        else sum += tp;
        if (mul === 1) mul += 1;
        else mul -= 1;
    }
    var chk = (10 - sum % 10) % 10;
    if (chk !== parseInt(str.substring(14, 15), 10)) return false;
    return true;
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("kv2Jx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $eec8d2af9a3df3c4$var$isAscii;

var $eec8d2af9a3df3c4$var$_assertString = $eec8d2af9a3df3c4$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $eec8d2af9a3df3c4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/* eslint-disable no-control-regex */ var $eec8d2af9a3df3c4$var$ascii = /^[\x00-\x7F]+$/;
/* eslint-enable no-control-regex */ function $eec8d2af9a3df3c4$var$isAscii(str) {
    (0, $eec8d2af9a3df3c4$var$_assertString.default)(str);
    return $eec8d2af9a3df3c4$var$ascii.test(str);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("bWCzj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8b23076cff48e676$var$isFullWidth;
module.exports.fullWidth = void 0;

var $8b23076cff48e676$var$_assertString = $8b23076cff48e676$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $8b23076cff48e676$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $8b23076cff48e676$var$fullWidth = /[^\u0020-\u007E\uFF61-\uFF9F\uFFA0-\uFFDC\uFFE8-\uFFEE0-9a-zA-Z]/;
module.exports.fullWidth = $8b23076cff48e676$var$fullWidth;
function $8b23076cff48e676$var$isFullWidth(str) {
    (0, $8b23076cff48e676$var$_assertString.default)(str);
    return $8b23076cff48e676$var$fullWidth.test(str);
}

});

parcelRegister("9f357", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6ba7e7b5b229752c$var$isHalfWidth;
module.exports.halfWidth = void 0;

var $6ba7e7b5b229752c$var$_assertString = $6ba7e7b5b229752c$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $6ba7e7b5b229752c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $6ba7e7b5b229752c$var$halfWidth = /[\u0020-\u007E\uFF61-\uFF9F\uFFA0-\uFFDC\uFFE8-\uFFEE0-9a-zA-Z]/;
module.exports.halfWidth = $6ba7e7b5b229752c$var$halfWidth;
function $6ba7e7b5b229752c$var$isHalfWidth(str) {
    (0, $6ba7e7b5b229752c$var$_assertString.default)(str);
    return $6ba7e7b5b229752c$var$halfWidth.test(str);
}

});

parcelRegister("jYPXr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e8bbeca350108392$var$isVariableWidth;

var $e8bbeca350108392$var$_assertString = $e8bbeca350108392$var$_interopRequireDefault((parcelRequire("hZqWG")));

var $bWCzj = parcelRequire("bWCzj");

var $9f357 = parcelRequire("9f357");
function $e8bbeca350108392$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $e8bbeca350108392$var$isVariableWidth(str) {
    (0, $e8bbeca350108392$var$_assertString.default)(str);
    return $bWCzj.fullWidth.test(str) && $9f357.halfWidth.test(str);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("81UkT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5d8a1de734322b4d$var$isMultibyte;

var $5d8a1de734322b4d$var$_assertString = $5d8a1de734322b4d$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $5d8a1de734322b4d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/* eslint-disable no-control-regex */ var $5d8a1de734322b4d$var$multibyte = /[^\x00-\x7F]/;
/* eslint-enable no-control-regex */ function $5d8a1de734322b4d$var$isMultibyte(str) {
    (0, $5d8a1de734322b4d$var$_assertString.default)(str);
    return $5d8a1de734322b4d$var$multibyte.test(str);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("6s9Ea", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4b2cd748ca06fca9$var$isSemVer;

var $4b2cd748ca06fca9$var$_assertString = $4b2cd748ca06fca9$var$_interopRequireDefault((parcelRequire("hZqWG")));

var $4b2cd748ca06fca9$var$_multilineRegex = $4b2cd748ca06fca9$var$_interopRequireDefault((parcelRequire("c33Zq")));
function $4b2cd748ca06fca9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * Regular Expression to match
 * semantic versioning (SemVer)
 * built from multi-line, multi-parts regexp
 * Reference: https://semver.org/
 */ var $4b2cd748ca06fca9$var$semanticVersioningRegex = (0, $4b2cd748ca06fca9$var$_multilineRegex.default)([
    '^(0|[1-9]\\d*)\\.(0|[1-9]\\d*)\\.(0|[1-9]\\d*)',
    '(?:-((?:0|[1-9]\\d*|\\d*[a-z-][0-9a-z-]*)(?:\\.(?:0|[1-9]\\d*|\\d*[a-z-][0-9a-z-]*))*))',
    '?(?:\\+([0-9a-z-]+(?:\\.[0-9a-z-]+)*))?$'
], 'i');
function $4b2cd748ca06fca9$var$isSemVer(str) {
    (0, $4b2cd748ca06fca9$var$_assertString.default)(str);
    return $4b2cd748ca06fca9$var$semanticVersioningRegex.test(str);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});
parcelRegister("c33Zq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8c58dc26bf230519$var$multilineRegexp;
/**
 * Build RegExp object from an array
 * of multiple/multi-line regexp parts
 *
 * @param {string[]} parts
 * @param {string} flags
 * @return {object} - RegExp object
 */ function $8c58dc26bf230519$var$multilineRegexp(parts, flags) {
    var regexpAsStringLiteral = parts.join('');
    return new RegExp(regexpAsStringLiteral, flags);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});


parcelRegister("9zqOS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6f7c2fba9f5b4a3d$var$isSurrogatePair;

var $6f7c2fba9f5b4a3d$var$_assertString = $6f7c2fba9f5b4a3d$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $6f7c2fba9f5b4a3d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $6f7c2fba9f5b4a3d$var$surrogatePair = /[\uD800-\uDBFF][\uDC00-\uDFFF]/;
function $6f7c2fba9f5b4a3d$var$isSurrogatePair(str) {
    (0, $6f7c2fba9f5b4a3d$var$_assertString.default)(str);
    return $6f7c2fba9f5b4a3d$var$surrogatePair.test(str);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("kfE9J", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ebe45b7e98c30788$var$isDecimal;

var $ebe45b7e98c30788$var$_merge = $ebe45b7e98c30788$var$_interopRequireDefault((parcelRequire("9nDkO")));

var $ebe45b7e98c30788$var$_assertString = $ebe45b7e98c30788$var$_interopRequireDefault((parcelRequire("hZqWG")));

var $ebe45b7e98c30788$var$_includes = $ebe45b7e98c30788$var$_interopRequireDefault((parcelRequire("50PTo")));

var $alkZf = parcelRequire("alkZf");
function $ebe45b7e98c30788$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $ebe45b7e98c30788$var$decimalRegExp(options) {
    var regExp = new RegExp("^[-+]?([0-9]+)?(\\".concat($alkZf.decimal[options.locale], "[0-9]{").concat(options.decimal_digits, "})").concat(options.force_decimal ? '' : '?', "$"));
    return regExp;
}
var $ebe45b7e98c30788$var$default_decimal_options = {
    force_decimal: false,
    decimal_digits: '1,',
    locale: 'en-US'
};
var $ebe45b7e98c30788$var$blacklist = [
    '',
    '-',
    '+'
];
function $ebe45b7e98c30788$var$isDecimal(str, options) {
    (0, $ebe45b7e98c30788$var$_assertString.default)(str);
    options = (0, $ebe45b7e98c30788$var$_merge.default)(options, $ebe45b7e98c30788$var$default_decimal_options);
    if (options.locale in $alkZf.decimal) return !(0, $ebe45b7e98c30788$var$_includes.default)($ebe45b7e98c30788$var$blacklist, str.replace(/ /g, '')) && $ebe45b7e98c30788$var$decimalRegExp(options).test(str);
    throw new Error("Invalid locale '".concat(options.locale, "'"));
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});
parcelRegister("50PTo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $3a6534927f41e9ed$var$includes = function includes(arr, val) {
    return arr.some(function(arrVal) {
        return val === arrVal;
    });
};
var $3a6534927f41e9ed$var$_default = $3a6534927f41e9ed$var$includes;
module.exports.default = $3a6534927f41e9ed$var$_default;
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});


parcelRegister("38ASS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $248ebae2a70d0d08$var$isHexadecimal;

var $248ebae2a70d0d08$var$_assertString = $248ebae2a70d0d08$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $248ebae2a70d0d08$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $248ebae2a70d0d08$var$hexadecimal = /^(0x|0h)?[0-9A-F]+$/i;
function $248ebae2a70d0d08$var$isHexadecimal(str) {
    (0, $248ebae2a70d0d08$var$_assertString.default)(str);
    return $248ebae2a70d0d08$var$hexadecimal.test(str);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("8h9xl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $60674f1165de5f72$var$isOctal;

var $60674f1165de5f72$var$_assertString = $60674f1165de5f72$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $60674f1165de5f72$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $60674f1165de5f72$var$octal = /^(0o)?[0-7]+$/i;
function $60674f1165de5f72$var$isOctal(str) {
    (0, $60674f1165de5f72$var$_assertString.default)(str);
    return $60674f1165de5f72$var$octal.test(str);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("9v3dq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6ea980d33c6d7212$var$isDivisibleBy;

var $6ea980d33c6d7212$var$_assertString = $6ea980d33c6d7212$var$_interopRequireDefault((parcelRequire("hZqWG")));

var $6ea980d33c6d7212$var$_toFloat = $6ea980d33c6d7212$var$_interopRequireDefault((parcelRequire("2dcMT")));
function $6ea980d33c6d7212$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $6ea980d33c6d7212$var$isDivisibleBy(str, num) {
    (0, $6ea980d33c6d7212$var$_assertString.default)(str);
    return (0, $6ea980d33c6d7212$var$_toFloat.default)(str) % parseInt(num, 10) === 0;
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("5U1AD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $44c36a6c4bb8e24e$var$isHexColor;

var $44c36a6c4bb8e24e$var$_assertString = $44c36a6c4bb8e24e$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $44c36a6c4bb8e24e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $44c36a6c4bb8e24e$var$hexcolor = /^#?([0-9A-F]{3}|[0-9A-F]{4}|[0-9A-F]{6}|[0-9A-F]{8})$/i;
function $44c36a6c4bb8e24e$var$isHexColor(str) {
    (0, $44c36a6c4bb8e24e$var$_assertString.default)(str);
    return $44c36a6c4bb8e24e$var$hexcolor.test(str);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("4TDuE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $390aef0b3566d2f4$var$isRgbColor;

var $390aef0b3566d2f4$var$_assertString = $390aef0b3566d2f4$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $390aef0b3566d2f4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $390aef0b3566d2f4$var$rgbColor = /^rgb\((([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5]),){2}([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])\)$/;
var $390aef0b3566d2f4$var$rgbaColor = /^rgba\((([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5]),){3}(0?\.\d|1(\.0)?|0(\.0)?)\)$/;
var $390aef0b3566d2f4$var$rgbColorPercent = /^rgb\((([0-9]%|[1-9][0-9]%|100%),){2}([0-9]%|[1-9][0-9]%|100%)\)/;
var $390aef0b3566d2f4$var$rgbaColorPercent = /^rgba\((([0-9]%|[1-9][0-9]%|100%),){3}(0?\.\d|1(\.0)?|0(\.0)?)\)/;
function $390aef0b3566d2f4$var$isRgbColor(str) {
    var includePercentValues = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    (0, $390aef0b3566d2f4$var$_assertString.default)(str);
    if (!includePercentValues) return $390aef0b3566d2f4$var$rgbColor.test(str) || $390aef0b3566d2f4$var$rgbaColor.test(str);
    return $390aef0b3566d2f4$var$rgbColor.test(str) || $390aef0b3566d2f4$var$rgbaColor.test(str) || $390aef0b3566d2f4$var$rgbColorPercent.test(str) || $390aef0b3566d2f4$var$rgbaColorPercent.test(str);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("1ItuH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1400c76cc59fcb10$var$isHSL;

var $1400c76cc59fcb10$var$_assertString = $1400c76cc59fcb10$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $1400c76cc59fcb10$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $1400c76cc59fcb10$var$hslComma = /^hsla?\(((\+|\-)?([0-9]+(\.[0-9]+)?(e(\+|\-)?[0-9]+)?|\.[0-9]+(e(\+|\-)?[0-9]+)?))(deg|grad|rad|turn)?(,(\+|\-)?([0-9]+(\.[0-9]+)?(e(\+|\-)?[0-9]+)?|\.[0-9]+(e(\+|\-)?[0-9]+)?)%){2}(,((\+|\-)?([0-9]+(\.[0-9]+)?(e(\+|\-)?[0-9]+)?|\.[0-9]+(e(\+|\-)?[0-9]+)?)%?))?\)$/i;
var $1400c76cc59fcb10$var$hslSpace = /^hsla?\(((\+|\-)?([0-9]+(\.[0-9]+)?(e(\+|\-)?[0-9]+)?|\.[0-9]+(e(\+|\-)?[0-9]+)?))(deg|grad|rad|turn)?(\s(\+|\-)?([0-9]+(\.[0-9]+)?(e(\+|\-)?[0-9]+)?|\.[0-9]+(e(\+|\-)?[0-9]+)?)%){2}\s?(\/\s((\+|\-)?([0-9]+(\.[0-9]+)?(e(\+|\-)?[0-9]+)?|\.[0-9]+(e(\+|\-)?[0-9]+)?)%?)\s?)?\)$/i;
function $1400c76cc59fcb10$var$isHSL(str) {
    (0, $1400c76cc59fcb10$var$_assertString.default)(str); // Strip duplicate spaces before calling the validation regex (See  #1598 for more info)
    var strippedStr = str.replace(/\s+/g, ' ').replace(/\s?(hsla?\(|\)|,)\s?/ig, '$1');
    if (strippedStr.indexOf(',') !== -1) return $1400c76cc59fcb10$var$hslComma.test(strippedStr);
    return $1400c76cc59fcb10$var$hslSpace.test(strippedStr);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("gmTuo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $bea9be6c80bd86c5$var$isISRC;

var $bea9be6c80bd86c5$var$_assertString = $bea9be6c80bd86c5$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $bea9be6c80bd86c5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// see http://isrc.ifpi.org/en/isrc-standard/code-syntax
var $bea9be6c80bd86c5$var$isrc = /^[A-Z]{2}[0-9A-Z]{3}\d{2}\d{5}$/;
function $bea9be6c80bd86c5$var$isISRC(str) {
    (0, $bea9be6c80bd86c5$var$_assertString.default)(str);
    return $bea9be6c80bd86c5$var$isrc.test(str);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("9ExTf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7072235819306928$var$isIBAN;

var $7072235819306928$var$_assertString = $7072235819306928$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $7072235819306928$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * List of country codes with
 * corresponding IBAN regular expression
 * Reference: https://en.wikipedia.org/wiki/International_Bank_Account_Number
 */ var $7072235819306928$var$ibanRegexThroughCountryCode = {
    AD: /^(AD[0-9]{2})\d{8}[A-Z0-9]{12}$/,
    AE: /^(AE[0-9]{2})\d{3}\d{16}$/,
    AL: /^(AL[0-9]{2})\d{8}[A-Z0-9]{16}$/,
    AT: /^(AT[0-9]{2})\d{16}$/,
    AZ: /^(AZ[0-9]{2})[A-Z0-9]{4}\d{20}$/,
    BA: /^(BA[0-9]{2})\d{16}$/,
    BE: /^(BE[0-9]{2})\d{12}$/,
    BG: /^(BG[0-9]{2})[A-Z]{4}\d{6}[A-Z0-9]{8}$/,
    BH: /^(BH[0-9]{2})[A-Z]{4}[A-Z0-9]{14}$/,
    BR: /^(BR[0-9]{2})\d{23}[A-Z]{1}[A-Z0-9]{1}$/,
    BY: /^(BY[0-9]{2})[A-Z0-9]{4}\d{20}$/,
    CH: /^(CH[0-9]{2})\d{5}[A-Z0-9]{12}$/,
    CR: /^(CR[0-9]{2})\d{18}$/,
    CY: /^(CY[0-9]{2})\d{8}[A-Z0-9]{16}$/,
    CZ: /^(CZ[0-9]{2})\d{20}$/,
    DE: /^(DE[0-9]{2})\d{18}$/,
    DK: /^(DK[0-9]{2})\d{14}$/,
    DO: /^(DO[0-9]{2})[A-Z]{4}\d{20}$/,
    EE: /^(EE[0-9]{2})\d{16}$/,
    EG: /^(EG[0-9]{2})\d{25}$/,
    ES: /^(ES[0-9]{2})\d{20}$/,
    FI: /^(FI[0-9]{2})\d{14}$/,
    FO: /^(FO[0-9]{2})\d{14}$/,
    FR: /^(FR[0-9]{2})\d{10}[A-Z0-9]{11}\d{2}$/,
    GB: /^(GB[0-9]{2})[A-Z]{4}\d{14}$/,
    GE: /^(GE[0-9]{2})[A-Z0-9]{2}\d{16}$/,
    GI: /^(GI[0-9]{2})[A-Z]{4}[A-Z0-9]{15}$/,
    GL: /^(GL[0-9]{2})\d{14}$/,
    GR: /^(GR[0-9]{2})\d{7}[A-Z0-9]{16}$/,
    GT: /^(GT[0-9]{2})[A-Z0-9]{4}[A-Z0-9]{20}$/,
    HR: /^(HR[0-9]{2})\d{17}$/,
    HU: /^(HU[0-9]{2})\d{24}$/,
    IE: /^(IE[0-9]{2})[A-Z0-9]{4}\d{14}$/,
    IL: /^(IL[0-9]{2})\d{19}$/,
    IQ: /^(IQ[0-9]{2})[A-Z]{4}\d{15}$/,
    IR: /^(IR[0-9]{2})0\d{2}0\d{18}$/,
    IS: /^(IS[0-9]{2})\d{22}$/,
    IT: /^(IT[0-9]{2})[A-Z]{1}\d{10}[A-Z0-9]{12}$/,
    JO: /^(JO[0-9]{2})[A-Z]{4}\d{22}$/,
    KW: /^(KW[0-9]{2})[A-Z]{4}[A-Z0-9]{22}$/,
    KZ: /^(KZ[0-9]{2})\d{3}[A-Z0-9]{13}$/,
    LB: /^(LB[0-9]{2})\d{4}[A-Z0-9]{20}$/,
    LC: /^(LC[0-9]{2})[A-Z]{4}[A-Z0-9]{24}$/,
    LI: /^(LI[0-9]{2})\d{5}[A-Z0-9]{12}$/,
    LT: /^(LT[0-9]{2})\d{16}$/,
    LU: /^(LU[0-9]{2})\d{3}[A-Z0-9]{13}$/,
    LV: /^(LV[0-9]{2})[A-Z]{4}[A-Z0-9]{13}$/,
    MC: /^(MC[0-9]{2})\d{10}[A-Z0-9]{11}\d{2}$/,
    MD: /^(MD[0-9]{2})[A-Z0-9]{20}$/,
    ME: /^(ME[0-9]{2})\d{18}$/,
    MK: /^(MK[0-9]{2})\d{3}[A-Z0-9]{10}\d{2}$/,
    MR: /^(MR[0-9]{2})\d{23}$/,
    MT: /^(MT[0-9]{2})[A-Z]{4}\d{5}[A-Z0-9]{18}$/,
    MU: /^(MU[0-9]{2})[A-Z]{4}\d{19}[A-Z]{3}$/,
    MZ: /^(MZ[0-9]{2})\d{21}$/,
    NL: /^(NL[0-9]{2})[A-Z]{4}\d{10}$/,
    NO: /^(NO[0-9]{2})\d{11}$/,
    PK: /^(PK[0-9]{2})[A-Z0-9]{4}\d{16}$/,
    PL: /^(PL[0-9]{2})\d{24}$/,
    PS: /^(PS[0-9]{2})[A-Z0-9]{4}\d{21}$/,
    PT: /^(PT[0-9]{2})\d{21}$/,
    QA: /^(QA[0-9]{2})[A-Z]{4}[A-Z0-9]{21}$/,
    RO: /^(RO[0-9]{2})[A-Z]{4}[A-Z0-9]{16}$/,
    RS: /^(RS[0-9]{2})\d{18}$/,
    SA: /^(SA[0-9]{2})\d{2}[A-Z0-9]{18}$/,
    SC: /^(SC[0-9]{2})[A-Z]{4}\d{20}[A-Z]{3}$/,
    SE: /^(SE[0-9]{2})\d{20}$/,
    SI: /^(SI[0-9]{2})\d{15}$/,
    SK: /^(SK[0-9]{2})\d{20}$/,
    SM: /^(SM[0-9]{2})[A-Z]{1}\d{10}[A-Z0-9]{12}$/,
    SV: /^(SV[0-9]{2})[A-Z0-9]{4}\d{20}$/,
    TL: /^(TL[0-9]{2})\d{19}$/,
    TN: /^(TN[0-9]{2})\d{20}$/,
    TR: /^(TR[0-9]{2})\d{5}[A-Z0-9]{17}$/,
    UA: /^(UA[0-9]{2})\d{6}[A-Z0-9]{19}$/,
    VA: /^(VA[0-9]{2})\d{18}$/,
    VG: /^(VG[0-9]{2})[A-Z0-9]{4}\d{16}$/,
    XK: /^(XK[0-9]{2})\d{16}$/
};
/**
 * Check whether string has correct universal IBAN format
 * The IBAN consists of up to 34 alphanumeric characters, as follows:
 * Country Code using ISO 3166-1 alpha-2, two letters
 * check digits, two digits and
 * Basic Bank Account Number (BBAN), up to 30 alphanumeric characters.
 * NOTE: Permitted IBAN characters are: digits [0-9] and the 26 latin alphabetic [A-Z]
 *
 * @param {string} str - string under validation
 * @return {boolean}
 */ function $7072235819306928$var$hasValidIbanFormat(str) {
    // Strip white spaces and hyphens
    var strippedStr = str.replace(/[\s\-]+/gi, '').toUpperCase();
    var isoCountryCode = strippedStr.slice(0, 2).toUpperCase();
    return isoCountryCode in $7072235819306928$var$ibanRegexThroughCountryCode && $7072235819306928$var$ibanRegexThroughCountryCode[isoCountryCode].test(strippedStr);
}
/**
   * Check whether string has valid IBAN Checksum
   * by performing basic mod-97 operation and
   * the remainder should equal 1
   * -- Start by rearranging the IBAN by moving the four initial characters to the end of the string
   * -- Replace each letter in the string with two digits, A -> 10, B = 11, Z = 35
   * -- Interpret the string as a decimal integer and
   * -- compute the remainder on division by 97 (mod 97)
   * Reference: https://en.wikipedia.org/wiki/International_Bank_Account_Number
   *
   * @param {string} str
   * @return {boolean}
   */ function $7072235819306928$var$hasValidIbanChecksum(str) {
    var strippedStr = str.replace(/[^A-Z0-9]+/gi, '').toUpperCase(); // Keep only digits and A-Z latin alphabetic
    var rearranged = strippedStr.slice(4) + strippedStr.slice(0, 4);
    var alphaCapsReplacedWithDigits = rearranged.replace(/[A-Z]/g, function(char) {
        return char.charCodeAt(0) - 55;
    });
    var remainder = alphaCapsReplacedWithDigits.match(/\d{1,7}/g).reduce(function(acc, value) {
        return Number(acc + value) % 97;
    }, '');
    return remainder === 1;
}
function $7072235819306928$var$isIBAN(str) {
    (0, $7072235819306928$var$_assertString.default)(str);
    return $7072235819306928$var$hasValidIbanFormat(str) && $7072235819306928$var$hasValidIbanChecksum(str);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("e8bY8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a49b18d144a3295b$var$isBIC;

var $a49b18d144a3295b$var$_assertString = $a49b18d144a3295b$var$_interopRequireDefault((parcelRequire("hZqWG")));

var $dVkQR = parcelRequire("dVkQR");
function $a49b18d144a3295b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// https://en.wikipedia.org/wiki/ISO_9362
var $a49b18d144a3295b$var$isBICReg = /^[A-Za-z]{6}[A-Za-z0-9]{2}([A-Za-z0-9]{3})?$/;
function $a49b18d144a3295b$var$isBIC(str) {
    (0, $a49b18d144a3295b$var$_assertString.default)(str); // toUpperCase() should be removed when a new major version goes out that changes
    // the regex to [A-Z] (per the spec).
    if ($dVkQR.CountryCodes.indexOf(str.slice(4, 6).toUpperCase()) < 0) return false;
    return $a49b18d144a3295b$var$isBICReg.test(str);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});
parcelRegister("dVkQR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a230c5ed9d5317f3$var$isISO31661Alpha2;
module.exports.CountryCodes = void 0;

var $a230c5ed9d5317f3$var$_assertString = $a230c5ed9d5317f3$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $a230c5ed9d5317f3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// from https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2
var $a230c5ed9d5317f3$var$validISO31661Alpha2CountriesCodes = [
    'AD',
    'AE',
    'AF',
    'AG',
    'AI',
    'AL',
    'AM',
    'AO',
    'AQ',
    'AR',
    'AS',
    'AT',
    'AU',
    'AW',
    'AX',
    'AZ',
    'BA',
    'BB',
    'BD',
    'BE',
    'BF',
    'BG',
    'BH',
    'BI',
    'BJ',
    'BL',
    'BM',
    'BN',
    'BO',
    'BQ',
    'BR',
    'BS',
    'BT',
    'BV',
    'BW',
    'BY',
    'BZ',
    'CA',
    'CC',
    'CD',
    'CF',
    'CG',
    'CH',
    'CI',
    'CK',
    'CL',
    'CM',
    'CN',
    'CO',
    'CR',
    'CU',
    'CV',
    'CW',
    'CX',
    'CY',
    'CZ',
    'DE',
    'DJ',
    'DK',
    'DM',
    'DO',
    'DZ',
    'EC',
    'EE',
    'EG',
    'EH',
    'ER',
    'ES',
    'ET',
    'FI',
    'FJ',
    'FK',
    'FM',
    'FO',
    'FR',
    'GA',
    'GB',
    'GD',
    'GE',
    'GF',
    'GG',
    'GH',
    'GI',
    'GL',
    'GM',
    'GN',
    'GP',
    'GQ',
    'GR',
    'GS',
    'GT',
    'GU',
    'GW',
    'GY',
    'HK',
    'HM',
    'HN',
    'HR',
    'HT',
    'HU',
    'ID',
    'IE',
    'IL',
    'IM',
    'IN',
    'IO',
    'IQ',
    'IR',
    'IS',
    'IT',
    'JE',
    'JM',
    'JO',
    'JP',
    'KE',
    'KG',
    'KH',
    'KI',
    'KM',
    'KN',
    'KP',
    'KR',
    'KW',
    'KY',
    'KZ',
    'LA',
    'LB',
    'LC',
    'LI',
    'LK',
    'LR',
    'LS',
    'LT',
    'LU',
    'LV',
    'LY',
    'MA',
    'MC',
    'MD',
    'ME',
    'MF',
    'MG',
    'MH',
    'MK',
    'ML',
    'MM',
    'MN',
    'MO',
    'MP',
    'MQ',
    'MR',
    'MS',
    'MT',
    'MU',
    'MV',
    'MW',
    'MX',
    'MY',
    'MZ',
    'NA',
    'NC',
    'NE',
    'NF',
    'NG',
    'NI',
    'NL',
    'NO',
    'NP',
    'NR',
    'NU',
    'NZ',
    'OM',
    'PA',
    'PE',
    'PF',
    'PG',
    'PH',
    'PK',
    'PL',
    'PM',
    'PN',
    'PR',
    'PS',
    'PT',
    'PW',
    'PY',
    'QA',
    'RE',
    'RO',
    'RS',
    'RU',
    'RW',
    'SA',
    'SB',
    'SC',
    'SD',
    'SE',
    'SG',
    'SH',
    'SI',
    'SJ',
    'SK',
    'SL',
    'SM',
    'SN',
    'SO',
    'SR',
    'SS',
    'ST',
    'SV',
    'SX',
    'SY',
    'SZ',
    'TC',
    'TD',
    'TF',
    'TG',
    'TH',
    'TJ',
    'TK',
    'TL',
    'TM',
    'TN',
    'TO',
    'TR',
    'TT',
    'TV',
    'TW',
    'TZ',
    'UA',
    'UG',
    'UM',
    'US',
    'UY',
    'UZ',
    'VA',
    'VC',
    'VE',
    'VG',
    'VI',
    'VN',
    'VU',
    'WF',
    'WS',
    'YE',
    'YT',
    'ZA',
    'ZM',
    'ZW'
];
function $a230c5ed9d5317f3$var$isISO31661Alpha2(str) {
    (0, $a230c5ed9d5317f3$var$_assertString.default)(str);
    return $a230c5ed9d5317f3$var$validISO31661Alpha2CountriesCodes.indexOf(str.toUpperCase()) >= 0;
}
var $a230c5ed9d5317f3$var$CountryCodes = $a230c5ed9d5317f3$var$validISO31661Alpha2CountriesCodes;
module.exports.CountryCodes = $a230c5ed9d5317f3$var$CountryCodes;

});


parcelRegister("gdrTg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $bce37eb1c1c7fe42$var$isMD5;

var $bce37eb1c1c7fe42$var$_assertString = $bce37eb1c1c7fe42$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $bce37eb1c1c7fe42$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $bce37eb1c1c7fe42$var$md5 = /^[a-f0-9]{32}$/;
function $bce37eb1c1c7fe42$var$isMD5(str) {
    (0, $bce37eb1c1c7fe42$var$_assertString.default)(str);
    return $bce37eb1c1c7fe42$var$md5.test(str);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("7D4H0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $58dfd0c424e5d590$var$isHash;

var $58dfd0c424e5d590$var$_assertString = $58dfd0c424e5d590$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $58dfd0c424e5d590$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $58dfd0c424e5d590$var$lengths = {
    md5: 32,
    md4: 32,
    sha1: 40,
    sha256: 64,
    sha384: 96,
    sha512: 128,
    ripemd128: 32,
    ripemd160: 40,
    tiger128: 32,
    tiger160: 40,
    tiger192: 48,
    crc32: 8,
    crc32b: 8
};
function $58dfd0c424e5d590$var$isHash(str, algorithm) {
    (0, $58dfd0c424e5d590$var$_assertString.default)(str);
    var hash = new RegExp("^[a-fA-F0-9]{".concat($58dfd0c424e5d590$var$lengths[algorithm], "}$"));
    return hash.test(str);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("bRpBC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8a2881bb7933cdca$var$isJWT;

var $8a2881bb7933cdca$var$_assertString = $8a2881bb7933cdca$var$_interopRequireDefault((parcelRequire("hZqWG")));

var $8a2881bb7933cdca$var$_isBase = $8a2881bb7933cdca$var$_interopRequireDefault((parcelRequire("2d8yt")));
function $8a2881bb7933cdca$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $8a2881bb7933cdca$var$isJWT(str) {
    (0, $8a2881bb7933cdca$var$_assertString.default)(str);
    var dotSplit = str.split('.');
    var len = dotSplit.length;
    if (len > 3 || len < 2) return false;
    return dotSplit.reduce(function(acc, currElem) {
        return acc && (0, $8a2881bb7933cdca$var$_isBase.default)(currElem, {
            urlSafe: true
        });
    }, true);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});
parcelRegister("2d8yt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $19c36e838f8f524b$var$isBase64;

var $19c36e838f8f524b$var$_assertString = $19c36e838f8f524b$var$_interopRequireDefault((parcelRequire("hZqWG")));

var $19c36e838f8f524b$var$_merge = $19c36e838f8f524b$var$_interopRequireDefault((parcelRequire("9nDkO")));
function $19c36e838f8f524b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $19c36e838f8f524b$var$notBase64 = /[^A-Z0-9+\/=]/i;
var $19c36e838f8f524b$var$urlSafeBase64 = /^[A-Z0-9_\-]*$/i;
var $19c36e838f8f524b$var$defaultBase64Options = {
    urlSafe: false
};
function $19c36e838f8f524b$var$isBase64(str, options) {
    (0, $19c36e838f8f524b$var$_assertString.default)(str);
    options = (0, $19c36e838f8f524b$var$_merge.default)(options, $19c36e838f8f524b$var$defaultBase64Options);
    var len = str.length;
    if (options.urlSafe) return $19c36e838f8f524b$var$urlSafeBase64.test(str);
    if (len % 4 !== 0 || $19c36e838f8f524b$var$notBase64.test(str)) return false;
    var firstPaddingChar = str.indexOf('=');
    return firstPaddingChar === -1 || firstPaddingChar === len - 1 || firstPaddingChar === len - 2 && str[len - 1] === '=';
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});


parcelRegister("c8148", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8d470f009bf41c55$var$isJSON;

var $8d470f009bf41c55$var$_assertString = $8d470f009bf41c55$var$_interopRequireDefault((parcelRequire("hZqWG")));

var $8d470f009bf41c55$var$_merge = $8d470f009bf41c55$var$_interopRequireDefault((parcelRequire("9nDkO")));
function $8d470f009bf41c55$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $8d470f009bf41c55$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $8d470f009bf41c55$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $8d470f009bf41c55$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $8d470f009bf41c55$var$_typeof(obj);
}
var $8d470f009bf41c55$var$default_json_options = {
    allow_primitives: false
};
function $8d470f009bf41c55$var$isJSON(str, options) {
    (0, $8d470f009bf41c55$var$_assertString.default)(str);
    try {
        options = (0, $8d470f009bf41c55$var$_merge.default)(options, $8d470f009bf41c55$var$default_json_options);
        var primitives = [];
        if (options.allow_primitives) primitives = [
            null,
            false,
            true
        ];
        var obj = JSON.parse(str);
        return primitives.includes(obj) || !!obj && $8d470f009bf41c55$var$_typeof(obj) === 'object';
    } catch (e) {
    /* ignore */ }
    return false;
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("9itI6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6c4cd75abfa8bb24$var$isEmpty;

var $6c4cd75abfa8bb24$var$_assertString = $6c4cd75abfa8bb24$var$_interopRequireDefault((parcelRequire("hZqWG")));

var $6c4cd75abfa8bb24$var$_merge = $6c4cd75abfa8bb24$var$_interopRequireDefault((parcelRequire("9nDkO")));
function $6c4cd75abfa8bb24$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $6c4cd75abfa8bb24$var$default_is_empty_options = {
    ignore_whitespace: false
};
function $6c4cd75abfa8bb24$var$isEmpty(str, options) {
    (0, $6c4cd75abfa8bb24$var$_assertString.default)(str);
    options = (0, $6c4cd75abfa8bb24$var$_merge.default)(options, $6c4cd75abfa8bb24$var$default_is_empty_options);
    return (options.ignore_whitespace ? str.trim().length : str.length) === 0;
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("eX4Zk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ae2a71e7d26a4a8b$var$isLength;

var $ae2a71e7d26a4a8b$var$_assertString = $ae2a71e7d26a4a8b$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $ae2a71e7d26a4a8b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $ae2a71e7d26a4a8b$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $ae2a71e7d26a4a8b$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $ae2a71e7d26a4a8b$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $ae2a71e7d26a4a8b$var$_typeof(obj);
}
/* eslint-disable prefer-rest-params */ function $ae2a71e7d26a4a8b$var$isLength(str, options) {
    (0, $ae2a71e7d26a4a8b$var$_assertString.default)(str);
    var min;
    var max;
    if ($ae2a71e7d26a4a8b$var$_typeof(options) === 'object') {
        min = options.min || 0;
        max = options.max;
    } else {
        // backwards compatibility: isLength(str, min [, max])
        min = arguments[1] || 0;
        max = arguments[2];
    }
    var surrogatePairs = str.match(/[\uD800-\uDBFF][\uDC00-\uDFFF]/g) || [];
    var len = str.length - surrogatePairs.length;
    return len >= min && (typeof max === 'undefined' || len <= max);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("99DHM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6aa3c0ee63d0e523$var$isUUID;

var $6aa3c0ee63d0e523$var$_assertString = $6aa3c0ee63d0e523$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $6aa3c0ee63d0e523$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $6aa3c0ee63d0e523$var$uuid = {
    3: /^[0-9A-F]{8}-[0-9A-F]{4}-3[0-9A-F]{3}-[0-9A-F]{4}-[0-9A-F]{12}$/i,
    4: /^[0-9A-F]{8}-[0-9A-F]{4}-4[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
    5: /^[0-9A-F]{8}-[0-9A-F]{4}-5[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
    all: /^[0-9A-F]{8}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{12}$/i
};
function $6aa3c0ee63d0e523$var$isUUID(str) {
    var version = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'all';
    (0, $6aa3c0ee63d0e523$var$_assertString.default)(str);
    var pattern = $6aa3c0ee63d0e523$var$uuid[version];
    return pattern && pattern.test(str);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("jEKS4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e4f61c62c0f4de4a$var$isMongoId;

var $e4f61c62c0f4de4a$var$_assertString = $e4f61c62c0f4de4a$var$_interopRequireDefault((parcelRequire("hZqWG")));

var $e4f61c62c0f4de4a$var$_isHexadecimal = $e4f61c62c0f4de4a$var$_interopRequireDefault((parcelRequire("38ASS")));
function $e4f61c62c0f4de4a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $e4f61c62c0f4de4a$var$isMongoId(str) {
    (0, $e4f61c62c0f4de4a$var$_assertString.default)(str);
    return (0, $e4f61c62c0f4de4a$var$_isHexadecimal.default)(str) && str.length === 24;
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("fGRWQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b6c4a03b7a1fc8a6$var$isAfter;

var $b6c4a03b7a1fc8a6$var$_assertString = $b6c4a03b7a1fc8a6$var$_interopRequireDefault((parcelRequire("hZqWG")));

var $b6c4a03b7a1fc8a6$var$_toDate = $b6c4a03b7a1fc8a6$var$_interopRequireDefault((parcelRequire("gr6fc")));
function $b6c4a03b7a1fc8a6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $b6c4a03b7a1fc8a6$var$isAfter(str) {
    var date = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : String(new Date());
    (0, $b6c4a03b7a1fc8a6$var$_assertString.default)(str);
    var comparison = (0, $b6c4a03b7a1fc8a6$var$_toDate.default)(date);
    var original = (0, $b6c4a03b7a1fc8a6$var$_toDate.default)(str);
    return !!(original && comparison && original > comparison);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("5bvc1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3c662d12926f8713$var$isBefore;

var $3c662d12926f8713$var$_assertString = $3c662d12926f8713$var$_interopRequireDefault((parcelRequire("hZqWG")));

var $3c662d12926f8713$var$_toDate = $3c662d12926f8713$var$_interopRequireDefault((parcelRequire("gr6fc")));
function $3c662d12926f8713$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $3c662d12926f8713$var$isBefore(str) {
    var date = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : String(new Date());
    (0, $3c662d12926f8713$var$_assertString.default)(str);
    var comparison = (0, $3c662d12926f8713$var$_toDate.default)(date);
    var original = (0, $3c662d12926f8713$var$_toDate.default)(str);
    return !!(original && comparison && original < comparison);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("kMIcK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f21a9475445da859$var$isIn;

var $f21a9475445da859$var$_assertString = $f21a9475445da859$var$_interopRequireDefault((parcelRequire("hZqWG")));

var $f21a9475445da859$var$_toString = $f21a9475445da859$var$_interopRequireDefault((parcelRequire("dAq0G")));
function $f21a9475445da859$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f21a9475445da859$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $f21a9475445da859$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $f21a9475445da859$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $f21a9475445da859$var$_typeof(obj);
}
function $f21a9475445da859$var$isIn(str, options) {
    (0, $f21a9475445da859$var$_assertString.default)(str);
    var i;
    if (Object.prototype.toString.call(options) === '[object Array]') {
        var array = [];
        for(i in options)// https://github.com/gotwarlost/istanbul/blob/master/ignoring-code-for-coverage.md#ignoring-code-for-coverage-purposes
        // istanbul ignore else
        if (({}).hasOwnProperty.call(options, i)) array[i] = (0, $f21a9475445da859$var$_toString.default)(options[i]);
        return array.indexOf(str) >= 0;
    } else if ($f21a9475445da859$var$_typeof(options) === 'object') return options.hasOwnProperty(str);
    else if (options && typeof options.indexOf === 'function') return options.indexOf(str) >= 0;
    return false;
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("bBCuW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8731034d9066fcdf$var$isCreditCard;

var $8731034d9066fcdf$var$_assertString = $8731034d9066fcdf$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $8731034d9066fcdf$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/* eslint-disable max-len */ var $8731034d9066fcdf$var$creditCard = /^(?:4[0-9]{12}(?:[0-9]{3,6})?|5[1-5][0-9]{14}|(222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}|6(?:011|5[0-9][0-9])[0-9]{12,15}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|(?:2131|1800|35\d{3})\d{11}|6[27][0-9]{14})$/;
/* eslint-enable max-len */ function $8731034d9066fcdf$var$isCreditCard(str) {
    (0, $8731034d9066fcdf$var$_assertString.default)(str);
    var sanitized = str.replace(/[- ]+/g, '');
    if (!$8731034d9066fcdf$var$creditCard.test(sanitized)) return false;
    var sum = 0;
    var digit;
    var tmpNum;
    var shouldDouble;
    for(var i = sanitized.length - 1; i >= 0; i--){
        digit = sanitized.substring(i, i + 1);
        tmpNum = parseInt(digit, 10);
        if (shouldDouble) {
            tmpNum *= 2;
            if (tmpNum >= 10) sum += tmpNum % 10 + 1;
            else sum += tmpNum;
        } else sum += tmpNum;
        shouldDouble = !shouldDouble;
    }
    return !!(sum % 10 === 0 ? sanitized : false);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("ilQ4n", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d5c2941d31196eff$var$isIdentityCard;

var $d5c2941d31196eff$var$_assertString = $d5c2941d31196eff$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $d5c2941d31196eff$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $d5c2941d31196eff$var$validators = {
    ES: function ES(str) {
        (0, $d5c2941d31196eff$var$_assertString.default)(str);
        var DNI = /^[0-9X-Z][0-9]{7}[TRWAGMYFPDXBNJZSQVHLCKE]$/;
        var charsValue = {
            X: 0,
            Y: 1,
            Z: 2
        };
        var controlDigits = [
            'T',
            'R',
            'W',
            'A',
            'G',
            'M',
            'Y',
            'F',
            'P',
            'D',
            'X',
            'B',
            'N',
            'J',
            'Z',
            'S',
            'Q',
            'V',
            'H',
            'L',
            'C',
            'K',
            'E'
        ]; // sanitize user input
        var sanitized = str.trim().toUpperCase(); // validate the data structure
        if (!DNI.test(sanitized)) return false;
         // validate the control digit
        var number = sanitized.slice(0, -1).replace(/[X,Y,Z]/g, function(char) {
            return charsValue[char];
        });
        return sanitized.endsWith(controlDigits[number % 23]);
    },
    IN: function IN(str) {
        var DNI = /^[1-9]\d{3}\s?\d{4}\s?\d{4}$/; // multiplication table
        var d = [
            [
                0,
                1,
                2,
                3,
                4,
                5,
                6,
                7,
                8,
                9
            ],
            [
                1,
                2,
                3,
                4,
                0,
                6,
                7,
                8,
                9,
                5
            ],
            [
                2,
                3,
                4,
                0,
                1,
                7,
                8,
                9,
                5,
                6
            ],
            [
                3,
                4,
                0,
                1,
                2,
                8,
                9,
                5,
                6,
                7
            ],
            [
                4,
                0,
                1,
                2,
                3,
                9,
                5,
                6,
                7,
                8
            ],
            [
                5,
                9,
                8,
                7,
                6,
                0,
                4,
                3,
                2,
                1
            ],
            [
                6,
                5,
                9,
                8,
                7,
                1,
                0,
                4,
                3,
                2
            ],
            [
                7,
                6,
                5,
                9,
                8,
                2,
                1,
                0,
                4,
                3
            ],
            [
                8,
                7,
                6,
                5,
                9,
                3,
                2,
                1,
                0,
                4
            ],
            [
                9,
                8,
                7,
                6,
                5,
                4,
                3,
                2,
                1,
                0
            ]
        ]; // permutation table
        var p = [
            [
                0,
                1,
                2,
                3,
                4,
                5,
                6,
                7,
                8,
                9
            ],
            [
                1,
                5,
                7,
                6,
                2,
                8,
                3,
                0,
                9,
                4
            ],
            [
                5,
                8,
                0,
                3,
                7,
                9,
                6,
                1,
                4,
                2
            ],
            [
                8,
                9,
                1,
                6,
                0,
                4,
                3,
                5,
                2,
                7
            ],
            [
                9,
                4,
                5,
                3,
                1,
                2,
                6,
                8,
                7,
                0
            ],
            [
                4,
                2,
                8,
                6,
                5,
                7,
                3,
                9,
                0,
                1
            ],
            [
                2,
                7,
                9,
                3,
                8,
                0,
                6,
                4,
                1,
                5
            ],
            [
                7,
                0,
                4,
                6,
                9,
                1,
                3,
                2,
                5,
                8
            ]
        ]; // sanitize user input
        var sanitized = str.trim(); // validate the data structure
        if (!DNI.test(sanitized)) return false;
        var c = 0;
        var invertedArray = sanitized.replace(/\s/g, '').split('').map(Number).reverse();
        invertedArray.forEach(function(val, i) {
            c = d[c][p[i % 8][val]];
        });
        return c === 0;
    },
    IR: function IR(str) {
        if (!str.match(/^\d{10}$/)) return false;
        str = "0000".concat(str).substr(str.length - 6);
        if (parseInt(str.substr(3, 6), 10) === 0) return false;
        var lastNumber = parseInt(str.substr(9, 1), 10);
        var sum = 0;
        for(var i = 0; i < 9; i++)sum += parseInt(str.substr(i, 1), 10) * (10 - i);
        sum %= 11;
        return sum < 2 && lastNumber === sum || sum >= 2 && lastNumber === 11 - sum;
    },
    IT: function IT(str) {
        if (str.length !== 9) return false;
        if (str === 'CA00000AA') return false; // https://it.wikipedia.org/wiki/Carta_d%27identit%C3%A0_elettronica_italiana
        return str.search(/C[A-Z][0-9]{5}[A-Z]{2}/i) > -1;
    },
    NO: function NO(str) {
        var sanitized = str.trim();
        if (isNaN(Number(sanitized))) return false;
        if (sanitized.length !== 11) return false;
        if (sanitized === '00000000000') return false; // https://no.wikipedia.org/wiki/F%C3%B8dselsnummer
        var f = sanitized.split('').map(Number);
        var k1 = (11 - (3 * f[0] + 7 * f[1] + 6 * f[2] + 1 * f[3] + 8 * f[4] + 9 * f[5] + 4 * f[6] + 5 * f[7] + 2 * f[8]) % 11) % 11;
        var k2 = (11 - (5 * f[0] + 4 * f[1] + 3 * f[2] + 2 * f[3] + 7 * f[4] + 6 * f[5] + 5 * f[6] + 4 * f[7] + 3 * f[8] + 2 * k1) % 11) % 11;
        if (k1 !== f[9] || k2 !== f[10]) return false;
        return true;
    },
    'he-IL': function heIL(str) {
        var DNI = /^\d{9}$/; // sanitize user input
        var sanitized = str.trim(); // validate the data structure
        if (!DNI.test(sanitized)) return false;
        var id = sanitized;
        var sum = 0, incNum;
        for(var i = 0; i < id.length; i++){
            incNum = Number(id[i]) * (i % 2 + 1); // Multiply number by 1 or 2
            sum += incNum > 9 ? incNum - 9 : incNum; // Sum the digits up and add to total
        }
        return sum % 10 === 0;
    },
    'ar-LY': function arLY(str) {
        // Libya National Identity Number NIN is 12 digits, the first digit is either 1 or 2
        var NIN = /^(1|2)\d{11}$/; // sanitize user input
        var sanitized = str.trim(); // validate the data structure
        if (!NIN.test(sanitized)) return false;
        return true;
    },
    'ar-TN': function arTN(str) {
        var DNI = /^\d{8}$/; // sanitize user input
        var sanitized = str.trim(); // validate the data structure
        if (!DNI.test(sanitized)) return false;
        return true;
    },
    'zh-CN': function zhCN(str) {
        var provincesAndCities = [
            '11',
            '12',
            '13',
            '14',
            '15',
            '21',
            '22',
            '23',
            '31',
            '32',
            '33',
            '34',
            '35',
            '36',
            '37',
            '41',
            '42',
            '43',
            '44',
            '45',
            '46',
            '50',
            '51',
            '52',
            '53',
            '54',
            '61',
            '62',
            '63',
            '64',
            '65',
            '71',
            '81',
            '82',
            '91' // 国外
        ];
        var powers = [
            '7',
            '9',
            '10',
            '5',
            '8',
            '4',
            '2',
            '1',
            '6',
            '3',
            '7',
            '9',
            '10',
            '5',
            '8',
            '4',
            '2'
        ];
        var parityBit = [
            '1',
            '0',
            'X',
            '9',
            '8',
            '7',
            '6',
            '5',
            '4',
            '3',
            '2'
        ];
        var checkAddressCode = function checkAddressCode(addressCode) {
            return provincesAndCities.includes(addressCode);
        };
        var checkBirthDayCode = function checkBirthDayCode(birDayCode) {
            var yyyy = parseInt(birDayCode.substring(0, 4), 10);
            var mm = parseInt(birDayCode.substring(4, 6), 10);
            var dd = parseInt(birDayCode.substring(6), 10);
            var xdata = new Date(yyyy, mm - 1, dd);
            if (xdata > new Date()) return false; // eslint-disable-next-line max-len
            else if (xdata.getFullYear() === yyyy && xdata.getMonth() === mm - 1 && xdata.getDate() === dd) return true;
            return false;
        };
        var getParityBit = function getParityBit(idCardNo) {
            var id17 = idCardNo.substring(0, 17);
            var power = 0;
            for(var i = 0; i < 17; i++)power += parseInt(id17.charAt(i), 10) * parseInt(powers[i], 10);
            var mod = power % 11;
            return parityBit[mod];
        };
        var checkParityBit = function checkParityBit(idCardNo) {
            return getParityBit(idCardNo) === idCardNo.charAt(17).toUpperCase();
        };
        var check15IdCardNo = function check15IdCardNo(idCardNo) {
            var check = /^[1-9]\d{7}((0[1-9])|(1[0-2]))((0[1-9])|([1-2][0-9])|(3[0-1]))\d{3}$/.test(idCardNo);
            if (!check) return false;
            var addressCode = idCardNo.substring(0, 2);
            check = checkAddressCode(addressCode);
            if (!check) return false;
            var birDayCode = "19".concat(idCardNo.substring(6, 12));
            check = checkBirthDayCode(birDayCode);
            if (!check) return false;
            return true;
        };
        var check18IdCardNo = function check18IdCardNo(idCardNo) {
            var check = /^[1-9]\d{5}[1-9]\d{3}((0[1-9])|(1[0-2]))((0[1-9])|([1-2][0-9])|(3[0-1]))\d{3}(\d|x|X)$/.test(idCardNo);
            if (!check) return false;
            var addressCode = idCardNo.substring(0, 2);
            check = checkAddressCode(addressCode);
            if (!check) return false;
            var birDayCode = idCardNo.substring(6, 14);
            check = checkBirthDayCode(birDayCode);
            if (!check) return false;
            return checkParityBit(idCardNo);
        };
        var checkIdCardNo = function checkIdCardNo(idCardNo) {
            var check = /^\d{15}|(\d{17}(\d|x|X))$/.test(idCardNo);
            if (!check) return false;
            if (idCardNo.length === 15) return check15IdCardNo(idCardNo);
            return check18IdCardNo(idCardNo);
        };
        return checkIdCardNo(str);
    },
    'zh-TW': function zhTW(str) {
        var ALPHABET_CODES = {
            A: 10,
            B: 11,
            C: 12,
            D: 13,
            E: 14,
            F: 15,
            G: 16,
            H: 17,
            I: 34,
            J: 18,
            K: 19,
            L: 20,
            M: 21,
            N: 22,
            O: 35,
            P: 23,
            Q: 24,
            R: 25,
            S: 26,
            T: 27,
            U: 28,
            V: 29,
            W: 32,
            X: 30,
            Y: 31,
            Z: 33
        };
        var sanitized = str.trim().toUpperCase();
        if (!/^[A-Z][0-9]{9}$/.test(sanitized)) return false;
        return Array.from(sanitized).reduce(function(sum, number, index) {
            if (index === 0) {
                var code = ALPHABET_CODES[number];
                return code % 10 * 9 + Math.floor(code / 10);
            }
            if (index === 9) return (10 - sum % 10 - Number(number)) % 10 === 0;
            return sum + Number(number) * (9 - index);
        }, 0);
    }
};
function $d5c2941d31196eff$var$isIdentityCard(str, locale) {
    (0, $d5c2941d31196eff$var$_assertString.default)(str);
    if (locale in $d5c2941d31196eff$var$validators) return $d5c2941d31196eff$var$validators[locale](str);
    else if (locale === 'any') {
        for(var key in $d5c2941d31196eff$var$validators)// https://github.com/gotwarlost/istanbul/blob/master/ignoring-code-for-coverage.md#ignoring-code-for-coverage-purposes
        // istanbul ignore else
        if ($d5c2941d31196eff$var$validators.hasOwnProperty(key)) {
            var validator = $d5c2941d31196eff$var$validators[key];
            if (validator(str)) return true;
        }
        return false;
    }
    throw new Error("Invalid locale '".concat(locale, "'"));
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("5tfrP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3fbba4ca931cf742$var$isEAN;

var $3fbba4ca931cf742$var$_assertString = $3fbba4ca931cf742$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $3fbba4ca931cf742$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * The most commonly used EAN standard is
 * the thirteen-digit EAN-13, while the
 * less commonly used 8-digit EAN-8 barcode was
 * introduced for use on small packages.
 * Also EAN/UCC-14 is used for Grouping of individual
 * trade items above unit level(Intermediate, Carton or Pallet).
 * For more info about EAN-14 checkout: https://www.gtin.info/itf-14-barcodes/
 * EAN consists of:
 * GS1 prefix, manufacturer code, product code and check digit
 * Reference: https://en.wikipedia.org/wiki/International_Article_Number
 * Reference: https://www.gtin.info/
 */ /**
 * Define EAN Lenghts; 8 for EAN-8; 13 for EAN-13; 14 for EAN-14
 * and Regular Expression for valid EANs (EAN-8, EAN-13, EAN-14),
 * with exact numberic matching of 8 or 13 or 14 digits [0-9]
 */ var $3fbba4ca931cf742$var$LENGTH_EAN_8 = 8;
var $3fbba4ca931cf742$var$LENGTH_EAN_14 = 14;
var $3fbba4ca931cf742$var$validEanRegex = /^(\d{8}|\d{13}|\d{14})$/;
/**
 * Get position weight given:
 * EAN length and digit index/position
 *
 * @param {number} length
 * @param {number} index
 * @return {number}
 */ function $3fbba4ca931cf742$var$getPositionWeightThroughLengthAndIndex(length, index) {
    if (length === $3fbba4ca931cf742$var$LENGTH_EAN_8 || length === $3fbba4ca931cf742$var$LENGTH_EAN_14) return index % 2 === 0 ? 3 : 1;
    return index % 2 === 0 ? 1 : 3;
}
/**
 * Calculate EAN Check Digit
 * Reference: https://en.wikipedia.org/wiki/International_Article_Number#Calculation_of_checksum_digit
 *
 * @param {string} ean
 * @return {number}
 */ function $3fbba4ca931cf742$var$calculateCheckDigit(ean) {
    var checksum = ean.slice(0, -1).split('').map(function(char, index) {
        return Number(char) * $3fbba4ca931cf742$var$getPositionWeightThroughLengthAndIndex(ean.length, index);
    }).reduce(function(acc, partialSum) {
        return acc + partialSum;
    }, 0);
    var remainder = 10 - checksum % 10;
    return remainder < 10 ? remainder : 0;
}
/**
 * Check if string is valid EAN:
 * Matches EAN-8/EAN-13/EAN-14 regex
 * Has valid check digit.
 *
 * @param {string} str
 * @return {boolean}
 */ function $3fbba4ca931cf742$var$isEAN(str) {
    (0, $3fbba4ca931cf742$var$_assertString.default)(str);
    var actualCheckDigit = Number(str.slice(-1));
    return $3fbba4ca931cf742$var$validEanRegex.test(str) && actualCheckDigit === $3fbba4ca931cf742$var$calculateCheckDigit(str);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("doEvT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9c0cf15b883fddea$var$isISIN;

var $9c0cf15b883fddea$var$_assertString = $9c0cf15b883fddea$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $9c0cf15b883fddea$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $9c0cf15b883fddea$var$isin = /^[A-Z]{2}[0-9A-Z]{9}[0-9]$/; // this link details how the check digit is calculated:
// https://www.isin.org/isin-format/. it is a little bit
// odd in that it works with digits, not numbers. in order
// to make only one pass through the ISIN characters, the
// each alpha character is handled as 2 characters within
// the loop.
function $9c0cf15b883fddea$var$isISIN(str) {
    (0, $9c0cf15b883fddea$var$_assertString.default)(str);
    if (!$9c0cf15b883fddea$var$isin.test(str)) return false;
    var double = true;
    var sum = 0; // convert values
    for(var i = str.length - 2; i >= 0; i--)if (str[i] >= 'A' && str[i] <= 'Z') {
        var value = str[i].charCodeAt(0) - 55;
        var lo = value % 10;
        var hi = Math.trunc(value / 10); // letters have two digits, so handle the low order
        // and high order digits separately.
        for(var _i = 0, _arr = [
            lo,
            hi
        ]; _i < _arr.length; _i++){
            var digit = _arr[_i];
            if (double) {
                if (digit >= 5) sum += 1 + (digit - 5) * 2;
                else sum += digit * 2;
            } else sum += digit;
            double = !double;
        }
    } else {
        var _digit = str[i].charCodeAt(0) - '0'.charCodeAt(0);
        if (double) {
            if (_digit >= 5) sum += 1 + (_digit - 5) * 2;
            else sum += _digit * 2;
        } else sum += _digit;
        double = !double;
    }
    var check = Math.trunc((sum + 9) / 10) * 10 - sum;
    return +str[str.length - 1] === check;
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("Eh5kE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0790fd4450fa1eb9$var$isISBN;

var $0790fd4450fa1eb9$var$_assertString = $0790fd4450fa1eb9$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $0790fd4450fa1eb9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $0790fd4450fa1eb9$var$isbn10Maybe = /^(?:[0-9]{9}X|[0-9]{10})$/;
var $0790fd4450fa1eb9$var$isbn13Maybe = /^(?:[0-9]{13})$/;
var $0790fd4450fa1eb9$var$factor = [
    1,
    3
];
function $0790fd4450fa1eb9$var$isISBN(str) {
    var version = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    (0, $0790fd4450fa1eb9$var$_assertString.default)(str);
    version = String(version);
    if (!version) return $0790fd4450fa1eb9$var$isISBN(str, 10) || $0790fd4450fa1eb9$var$isISBN(str, 13);
    var sanitized = str.replace(/[\s-]+/g, '');
    var checksum = 0;
    var i;
    if (version === '10') {
        if (!$0790fd4450fa1eb9$var$isbn10Maybe.test(sanitized)) return false;
        for(i = 0; i < 9; i++)checksum += (i + 1) * sanitized.charAt(i);
        if (sanitized.charAt(9) === 'X') checksum += 100;
        else checksum += 10 * sanitized.charAt(9);
        if (checksum % 11 === 0) return !!sanitized;
    } else if (version === '13') {
        if (!$0790fd4450fa1eb9$var$isbn13Maybe.test(sanitized)) return false;
        for(i = 0; i < 12; i++)checksum += $0790fd4450fa1eb9$var$factor[i % 2] * sanitized.charAt(i);
        if (sanitized.charAt(12) - (10 - checksum % 10) % 10 === 0) return !!sanitized;
    }
    return false;
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("dzNHd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9e2517d1df39314e$var$isISSN;

var $9e2517d1df39314e$var$_assertString = $9e2517d1df39314e$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $9e2517d1df39314e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $9e2517d1df39314e$var$issn = '^\\d{4}-?\\d{3}[\\dX]$';
function $9e2517d1df39314e$var$isISSN(str) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    (0, $9e2517d1df39314e$var$_assertString.default)(str);
    var testIssn = $9e2517d1df39314e$var$issn;
    testIssn = options.require_hyphen ? testIssn.replace('?', '') : testIssn;
    testIssn = options.case_sensitive ? new RegExp(testIssn) : new RegExp(testIssn, 'i');
    if (!testIssn.test(str)) return false;
    var digits = str.replace('-', '').toUpperCase();
    var checksum = 0;
    for(var i = 0; i < digits.length; i++){
        var digit = digits[i];
        checksum += (digit === 'X' ? 10 : +digit) * (8 - i);
    }
    return checksum % 11 === 0;
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("7Nii9", function(module, exports) {
"use strict";
function $5acb4c63d2aa1a61$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $5acb4c63d2aa1a61$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $5acb4c63d2aa1a61$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $5acb4c63d2aa1a61$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5acb4c63d2aa1a61$var$isTaxID;

var $5acb4c63d2aa1a61$var$_assertString = $5acb4c63d2aa1a61$var$_interopRequireDefault((parcelRequire("hZqWG")));

var $5acb4c63d2aa1a61$var$algorithms = $5acb4c63d2aa1a61$var$_interopRequireWildcard((parcelRequire("3SUDT")));

var $5acb4c63d2aa1a61$var$_isDate = $5acb4c63d2aa1a61$var$_interopRequireDefault((parcelRequire("akLR8")));
function $5acb4c63d2aa1a61$var$_getRequireWildcardCache() {
    if (typeof WeakMap !== "function") return null;
    var cache = new WeakMap();
    $5acb4c63d2aa1a61$var$_getRequireWildcardCache = function _getRequireWildcardCache() {
        return cache;
    };
    return cache;
}
function $5acb4c63d2aa1a61$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    if (obj === null || $5acb4c63d2aa1a61$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $5acb4c63d2aa1a61$var$_getRequireWildcardCache();
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $5acb4c63d2aa1a61$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $5acb4c63d2aa1a61$var$_toConsumableArray(arr) {
    return $5acb4c63d2aa1a61$var$_arrayWithoutHoles(arr) || $5acb4c63d2aa1a61$var$_iterableToArray(arr) || $5acb4c63d2aa1a61$var$_unsupportedIterableToArray(arr) || $5acb4c63d2aa1a61$var$_nonIterableSpread();
}
function $5acb4c63d2aa1a61$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $5acb4c63d2aa1a61$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $5acb4c63d2aa1a61$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $5acb4c63d2aa1a61$var$_arrayLikeToArray(o, minLen);
}
function $5acb4c63d2aa1a61$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $5acb4c63d2aa1a61$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $5acb4c63d2aa1a61$var$_arrayLikeToArray(arr);
}
function $5acb4c63d2aa1a61$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
/**
 * TIN Validation
 * Validates Tax Identification Numbers (TINs) from the US, EU member states and the United Kingdom.
 *
 * EU-UK:
 * National TIN validity is calculated using public algorithms as made available by DG TAXUD.
 *
 * See `https://ec.europa.eu/taxation_customs/tin/specs/FS-TIN%20Algorithms-Public.docx` for more information.
 *
 * US:
 * An Employer Identification Number (EIN), also known as a Federal Tax Identification Number,
 *  is used to identify a business entity.
 *
 * NOTES:
 *  - Prefix 47 is being reserved for future use
 *  - Prefixes 26, 27, 45, 46 and 47 were previously assigned by the Philadelphia campus.
 *
 * See `http://www.irs.gov/Businesses/Small-Businesses-&-Self-Employed/How-EINs-are-Assigned-and-Valid-EIN-Prefixes`
 * for more information.
 */ // Locale functions
/*
 * bg-BG validation function
 * (Edinen graždanski nomer (EGN/ЕГН), persons only)
 * Checks if birth date (first six digits) is valid and calculates check (last) digit
 */ function $5acb4c63d2aa1a61$var$bgBgCheck(tin) {
    // Extract full year, normalize month and check birth date validity
    var century_year = tin.slice(0, 2);
    var month = parseInt(tin.slice(2, 4), 10);
    if (month > 40) {
        month -= 40;
        century_year = "20".concat(century_year);
    } else if (month > 20) {
        month -= 20;
        century_year = "18".concat(century_year);
    } else century_year = "19".concat(century_year);
    if (month < 10) month = "0".concat(month);
    var date = "".concat(century_year, "/").concat(month, "/").concat(tin.slice(4, 6));
    if (!(0, $5acb4c63d2aa1a61$var$_isDate.default)(date, 'YYYY/MM/DD')) return false;
     // split digits into an array for further processing
    var digits = tin.split('').map(function(a) {
        return parseInt(a, 10);
    }); // Calculate checksum by multiplying digits with fixed values
    var multip_lookup = [
        2,
        4,
        8,
        5,
        10,
        9,
        7,
        3,
        6
    ];
    var checksum = 0;
    for(var i = 0; i < multip_lookup.length; i++)checksum += digits[i] * multip_lookup[i];
    checksum = checksum % 11 === 10 ? 0 : checksum % 11;
    return checksum === digits[9];
}
/*
 * cs-CZ validation function
 * (Rodné číslo (RČ), persons only)
 * Checks if birth date (first six digits) is valid and divisibility by 11
 * Material not in DG TAXUD document sourced from:
 * -`https://lorenc.info/3MA381/overeni-spravnosti-rodneho-cisla.htm`
 * -`https://www.mvcr.cz/clanek/rady-a-sluzby-dokumenty-rodne-cislo.aspx`
 */ function $5acb4c63d2aa1a61$var$csCzCheck(tin) {
    tin = tin.replace(/\W/, ''); // Extract full year from TIN length
    var full_year = parseInt(tin.slice(0, 2), 10);
    if (tin.length === 10) {
        if (full_year < 54) full_year = "20".concat(full_year);
        else full_year = "19".concat(full_year);
    } else {
        if (tin.slice(6) === '000') return false;
         // Three-zero serial not assigned before 1954
        if (full_year < 54) full_year = "19".concat(full_year);
        else return false; // No 18XX years seen in any of the resources
    } // Add missing zero if needed
    if (full_year.length === 3) full_year = [
        full_year.slice(0, 2),
        '0',
        full_year.slice(2)
    ].join('');
     // Extract month from TIN and normalize
    var month = parseInt(tin.slice(2, 4), 10);
    if (month > 50) month -= 50;
    if (month > 20) {
        // Month-plus-twenty was only introduced in 2004
        if (parseInt(full_year, 10) < 2004) return false;
        month -= 20;
    }
    if (month < 10) month = "0".concat(month);
     // Check date validity
    var date = "".concat(full_year, "/").concat(month, "/").concat(tin.slice(4, 6));
    if (!(0, $5acb4c63d2aa1a61$var$_isDate.default)(date, 'YYYY/MM/DD')) return false;
     // Verify divisibility by 11
    if (tin.length === 10) {
        if (parseInt(tin, 10) % 11 !== 0) {
            // Some numbers up to and including 1985 are still valid if
            // check (last) digit equals 0 and modulo of first 9 digits equals 10
            var checkdigit = parseInt(tin.slice(0, 9), 10) % 11;
            if (parseInt(full_year, 10) < 1986 && checkdigit === 10) {
                if (parseInt(tin.slice(9), 10) !== 0) return false;
            } else return false;
        }
    }
    return true;
}
/*
 * de-AT validation function
 * (Abgabenkontonummer, persons/entities)
 * Verify TIN validity by calling luhnCheck()
 */ function $5acb4c63d2aa1a61$var$deAtCheck(tin) {
    return $5acb4c63d2aa1a61$var$algorithms.luhnCheck(tin);
}
/*
 * de-DE validation function
 * (Steueridentifikationsnummer (Steuer-IdNr.), persons only)
 * Tests for single duplicate/triplicate value, then calculates ISO 7064 check (last) digit
 * Partial implementation of spec (same result with both algorithms always)
 */ function $5acb4c63d2aa1a61$var$deDeCheck(tin) {
    // Split digits into an array for further processing
    var digits = tin.split('').map(function(a) {
        return parseInt(a, 10);
    }); // Fill array with strings of number positions
    var occurences = [];
    for(var i = 0; i < digits.length - 1; i++){
        occurences.push('');
        for(var j = 0; j < digits.length - 1; j++)if (digits[i] === digits[j]) occurences[i] += j;
    } // Remove digits with one occurence and test for only one duplicate/triplicate
    occurences = occurences.filter(function(a) {
        return a.length > 1;
    });
    if (occurences.length !== 2 && occurences.length !== 3) return false;
     // In case of triplicate value only two digits are allowed next to each other
    if (occurences[0].length === 3) {
        var trip_locations = occurences[0].split('').map(function(a) {
            return parseInt(a, 10);
        });
        var recurrent = 0; // Amount of neighbour occurences
        for(var _i = 0; _i < trip_locations.length - 1; _i++)if (trip_locations[_i] + 1 === trip_locations[_i + 1]) recurrent += 1;
        if (recurrent === 2) return false;
    }
    return $5acb4c63d2aa1a61$var$algorithms.iso7064Check(tin);
}
/*
 * dk-DK validation function
 * (CPR-nummer (personnummer), persons only)
 * Checks if birth date (first six digits) is valid and assigned to century (seventh) digit,
 * and calculates check (last) digit
 */ function $5acb4c63d2aa1a61$var$dkDkCheck(tin) {
    tin = tin.replace(/\W/, ''); // Extract year, check if valid for given century digit and add century
    var year = parseInt(tin.slice(4, 6), 10);
    var century_digit = tin.slice(6, 7);
    switch(century_digit){
        case '0':
        case '1':
        case '2':
        case '3':
            year = "19".concat(year);
            break;
        case '4':
        case '9':
            if (year < 37) year = "20".concat(year);
            else year = "19".concat(year);
            break;
        default:
            if (year < 37) year = "20".concat(year);
            else if (year > 58) year = "18".concat(year);
            else return false;
            break;
    } // Add missing zero if needed
    if (year.length === 3) year = [
        year.slice(0, 2),
        '0',
        year.slice(2)
    ].join('');
     // Check date validity
    var date = "".concat(year, "/").concat(tin.slice(2, 4), "/").concat(tin.slice(0, 2));
    if (!(0, $5acb4c63d2aa1a61$var$_isDate.default)(date, 'YYYY/MM/DD')) return false;
     // Split digits into an array for further processing
    var digits = tin.split('').map(function(a) {
        return parseInt(a, 10);
    });
    var checksum = 0;
    var weight = 4; // Multiply by weight and add to checksum
    for(var i = 0; i < 9; i++){
        checksum += digits[i] * weight;
        weight -= 1;
        if (weight === 1) weight = 7;
    }
    checksum %= 11;
    if (checksum === 1) return false;
    return checksum === 0 ? digits[9] === 0 : digits[9] === 11 - checksum;
}
/*
 * el-CY validation function
 * (Arithmos Forologikou Mitroou (AFM/ΑΦΜ), persons only)
 * Verify TIN validity by calculating ASCII value of check (last) character
 */ function $5acb4c63d2aa1a61$var$elCyCheck(tin) {
    // split digits into an array for further processing
    var digits = tin.slice(0, 8).split('').map(function(a) {
        return parseInt(a, 10);
    });
    var checksum = 0; // add digits in even places
    for(var i = 1; i < digits.length; i += 2)checksum += digits[i];
     // add digits in odd places
    for(var _i2 = 0; _i2 < digits.length; _i2 += 2)if (digits[_i2] < 2) checksum += 1 - digits[_i2];
    else {
        checksum += 2 * (digits[_i2] - 2) + 5;
        if (digits[_i2] > 4) checksum += 2;
    }
    return String.fromCharCode(checksum % 26 + 65) === tin.charAt(8);
}
/*
 * el-GR validation function
 * (Arithmos Forologikou Mitroou (AFM/ΑΦΜ), persons/entities)
 * Verify TIN validity by calculating check (last) digit
 * Algorithm not in DG TAXUD document- sourced from:
 * - `http://epixeirisi.gr/%CE%9A%CE%A1%CE%99%CE%A3%CE%99%CE%9C%CE%91-%CE%98%CE%95%CE%9C%CE%91%CE%A4%CE%91-%CE%A6%CE%9F%CE%A1%CE%9F%CE%9B%CE%9F%CE%93%CE%99%CE%91%CE%A3-%CE%9A%CE%91%CE%99-%CE%9B%CE%9F%CE%93%CE%99%CE%A3%CE%A4%CE%99%CE%9A%CE%97%CE%A3/23791/%CE%91%CF%81%CE%B9%CE%B8%CE%BC%CF%8C%CF%82-%CE%A6%CE%BF%CF%81%CE%BF%CE%BB%CE%BF%CE%B3%CE%B9%CE%BA%CE%BF%CF%8D-%CE%9C%CE%B7%CF%84%CF%81%CF%8E%CE%BF%CF%85`
 */ function $5acb4c63d2aa1a61$var$elGrCheck(tin) {
    // split digits into an array for further processing
    var digits = tin.split('').map(function(a) {
        return parseInt(a, 10);
    });
    var checksum = 0;
    for(var i = 0; i < 8; i++)checksum += digits[i] * Math.pow(2, 8 - i);
    return checksum % 11 % 10 === digits[8];
}
/*
 * en-GB validation function (should go here if needed)
 * (National Insurance Number (NINO) or Unique Taxpayer Reference (UTR),
 * persons/entities respectively)
 */ /*
 * en-IE validation function
 * (Personal Public Service Number (PPS No), persons only)
 * Verify TIN validity by calculating check (second to last) character
 */ function $5acb4c63d2aa1a61$var$enIeCheck(tin) {
    var checksum = $5acb4c63d2aa1a61$var$algorithms.reverseMultiplyAndSum(tin.split('').slice(0, 7).map(function(a) {
        return parseInt(a, 10);
    }), 8);
    if (tin.length === 9 && tin[8] !== 'W') checksum += (tin[8].charCodeAt(0) - 64) * 9;
    checksum %= 23;
    if (checksum === 0) return tin[7].toUpperCase() === 'W';
    return tin[7].toUpperCase() === String.fromCharCode(64 + checksum);
} // Valid US IRS campus prefixes
var $5acb4c63d2aa1a61$var$enUsCampusPrefix = {
    andover: [
        '10',
        '12'
    ],
    atlanta: [
        '60',
        '67'
    ],
    austin: [
        '50',
        '53'
    ],
    brookhaven: [
        '01',
        '02',
        '03',
        '04',
        '05',
        '06',
        '11',
        '13',
        '14',
        '16',
        '21',
        '22',
        '23',
        '25',
        '34',
        '51',
        '52',
        '54',
        '55',
        '56',
        '57',
        '58',
        '59',
        '65'
    ],
    cincinnati: [
        '30',
        '32',
        '35',
        '36',
        '37',
        '38',
        '61'
    ],
    fresno: [
        '15',
        '24'
    ],
    internet: [
        '20',
        '26',
        '27',
        '45',
        '46',
        '47'
    ],
    kansas: [
        '40',
        '44'
    ],
    memphis: [
        '94',
        '95'
    ],
    ogden: [
        '80',
        '90'
    ],
    philadelphia: [
        '33',
        '39',
        '41',
        '42',
        '43',
        '46',
        '48',
        '62',
        '63',
        '64',
        '66',
        '68',
        '71',
        '72',
        '73',
        '74',
        '75',
        '76',
        '77',
        '81',
        '82',
        '83',
        '84',
        '85',
        '86',
        '87',
        '88',
        '91',
        '92',
        '93',
        '98',
        '99'
    ],
    sba: [
        '31'
    ]
}; // Return an array of all US IRS campus prefixes
function $5acb4c63d2aa1a61$var$enUsGetPrefixes() {
    var prefixes = [];
    for(var location in $5acb4c63d2aa1a61$var$enUsCampusPrefix)// https://github.com/gotwarlost/istanbul/blob/master/ignoring-code-for-coverage.md#ignoring-code-for-coverage-purposes
    // istanbul ignore else
    if ($5acb4c63d2aa1a61$var$enUsCampusPrefix.hasOwnProperty(location)) prefixes.push.apply(prefixes, $5acb4c63d2aa1a61$var$_toConsumableArray($5acb4c63d2aa1a61$var$enUsCampusPrefix[location]));
    return prefixes;
}
/*
 * en-US validation function
 * Verify that the TIN starts with a valid IRS campus prefix
 */ function $5acb4c63d2aa1a61$var$enUsCheck(tin) {
    return $5acb4c63d2aa1a61$var$enUsGetPrefixes().indexOf(tin.substr(0, 2)) !== -1;
}
/*
 * es-ES validation function
 * (Documento Nacional de Identidad (DNI)
 * or Número de Identificación de Extranjero (NIE), persons only)
 * Verify TIN validity by calculating check (last) character
 */ function $5acb4c63d2aa1a61$var$esEsCheck(tin) {
    // Split characters into an array for further processing
    var chars = tin.toUpperCase().split(''); // Replace initial letter if needed
    if (isNaN(parseInt(chars[0], 10)) && chars.length > 1) {
        var lead_replace = 0;
        switch(chars[0]){
            case 'Y':
                lead_replace = 1;
                break;
            case 'Z':
                lead_replace = 2;
                break;
            default:
        }
        chars.splice(0, 1, lead_replace); // Fill with zeros if smaller than proper
    } else while(chars.length < 9)chars.unshift(0);
     // Calculate checksum and check according to lookup
    var lookup = [
        'T',
        'R',
        'W',
        'A',
        'G',
        'M',
        'Y',
        'F',
        'P',
        'D',
        'X',
        'B',
        'N',
        'J',
        'Z',
        'S',
        'Q',
        'V',
        'H',
        'L',
        'C',
        'K',
        'E'
    ];
    chars = chars.join('');
    var checksum = parseInt(chars.slice(0, 8), 10) % 23;
    return chars[8] === lookup[checksum];
}
/*
 * et-EE validation function
 * (Isikukood (IK), persons only)
 * Checks if birth date (century digit and six following) is valid and calculates check (last) digit
 * Material not in DG TAXUD document sourced from:
 * - `https://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-identification-numbers/Estonia-TIN.pdf`
 */ function $5acb4c63d2aa1a61$var$etEeCheck(tin) {
    // Extract year and add century
    var full_year = tin.slice(1, 3);
    var century_digit = tin.slice(0, 1);
    switch(century_digit){
        case '1':
        case '2':
            full_year = "18".concat(full_year);
            break;
        case '3':
        case '4':
            full_year = "19".concat(full_year);
            break;
        default:
            full_year = "20".concat(full_year);
            break;
    } // Check date validity
    var date = "".concat(full_year, "/").concat(tin.slice(3, 5), "/").concat(tin.slice(5, 7));
    if (!(0, $5acb4c63d2aa1a61$var$_isDate.default)(date, 'YYYY/MM/DD')) return false;
     // Split digits into an array for further processing
    var digits = tin.split('').map(function(a) {
        return parseInt(a, 10);
    });
    var checksum = 0;
    var weight = 1; // Multiply by weight and add to checksum
    for(var i = 0; i < 10; i++){
        checksum += digits[i] * weight;
        weight += 1;
        if (weight === 10) weight = 1;
    } // Do again if modulo 11 of checksum is 10
    if (checksum % 11 === 10) {
        checksum = 0;
        weight = 3;
        for(var _i3 = 0; _i3 < 10; _i3++){
            checksum += digits[_i3] * weight;
            weight += 1;
            if (weight === 10) weight = 1;
        }
        if (checksum % 11 === 10) return digits[10] === 0;
    }
    return checksum % 11 === digits[10];
}
/*
 * fi-FI validation function
 * (Henkilötunnus (HETU), persons only)
 * Checks if birth date (first six digits plus century symbol) is valid
 * and calculates check (last) digit
 */ function $5acb4c63d2aa1a61$var$fiFiCheck(tin) {
    // Extract year and add century
    var full_year = tin.slice(4, 6);
    var century_symbol = tin.slice(6, 7);
    switch(century_symbol){
        case '+':
            full_year = "18".concat(full_year);
            break;
        case '-':
            full_year = "19".concat(full_year);
            break;
        default:
            full_year = "20".concat(full_year);
            break;
    } // Check date validity
    var date = "".concat(full_year, "/").concat(tin.slice(2, 4), "/").concat(tin.slice(0, 2));
    if (!(0, $5acb4c63d2aa1a61$var$_isDate.default)(date, 'YYYY/MM/DD')) return false;
     // Calculate check character
    var checksum = parseInt(tin.slice(0, 6) + tin.slice(7, 10), 10) % 31;
    if (checksum < 10) return checksum === parseInt(tin.slice(10), 10);
    checksum -= 10;
    var letters_lookup = [
        'A',
        'B',
        'C',
        'D',
        'E',
        'F',
        'H',
        'J',
        'K',
        'L',
        'M',
        'N',
        'P',
        'R',
        'S',
        'T',
        'U',
        'V',
        'W',
        'X',
        'Y'
    ];
    return letters_lookup[checksum] === tin.slice(10);
}
/*
 * fr/nl-BE validation function
 * (Numéro national (N.N.), persons only)
 * Checks if birth date (first six digits) is valid and calculates check (last two) digits
 */ function $5acb4c63d2aa1a61$var$frBeCheck(tin) {
    // Zero month/day value is acceptable
    if (tin.slice(2, 4) !== '00' || tin.slice(4, 6) !== '00') {
        // Extract date from first six digits of TIN
        var date = "".concat(tin.slice(0, 2), "/").concat(tin.slice(2, 4), "/").concat(tin.slice(4, 6));
        if (!(0, $5acb4c63d2aa1a61$var$_isDate.default)(date, 'YY/MM/DD')) return false;
    }
    var checksum = 97 - parseInt(tin.slice(0, 9), 10) % 97;
    var checkdigits = parseInt(tin.slice(9, 11), 10);
    if (checksum !== checkdigits) {
        checksum = 97 - parseInt("2".concat(tin.slice(0, 9)), 10) % 97;
        if (checksum !== checkdigits) return false;
    }
    return true;
}
/*
 * fr-FR validation function
 * (Numéro fiscal de référence (numéro SPI), persons only)
 * Verify TIN validity by calculating check (last three) digits
 */ function $5acb4c63d2aa1a61$var$frFrCheck(tin) {
    tin = tin.replace(/\s/g, '');
    var checksum = parseInt(tin.slice(0, 10), 10) % 511;
    var checkdigits = parseInt(tin.slice(10, 13), 10);
    return checksum === checkdigits;
}
/*
 * fr/lb-LU validation function
 * (numéro d’identification personnelle, persons only)
 * Verify birth date validity and run Luhn and Verhoeff checks
 */ function $5acb4c63d2aa1a61$var$frLuCheck(tin) {
    // Extract date and check validity
    var date = "".concat(tin.slice(0, 4), "/").concat(tin.slice(4, 6), "/").concat(tin.slice(6, 8));
    if (!(0, $5acb4c63d2aa1a61$var$_isDate.default)(date, 'YYYY/MM/DD')) return false;
     // Run Luhn check
    if (!$5acb4c63d2aa1a61$var$algorithms.luhnCheck(tin.slice(0, 12))) return false;
     // Remove Luhn check digit and run Verhoeff check
    return $5acb4c63d2aa1a61$var$algorithms.verhoeffCheck("".concat(tin.slice(0, 11)).concat(tin[12]));
}
/*
 * hr-HR validation function
 * (Osobni identifikacijski broj (OIB), persons/entities)
 * Verify TIN validity by calling iso7064Check(digits)
 */ function $5acb4c63d2aa1a61$var$hrHrCheck(tin) {
    return $5acb4c63d2aa1a61$var$algorithms.iso7064Check(tin);
}
/*
 * hu-HU validation function
 * (Adóazonosító jel, persons only)
 * Verify TIN validity by calculating check (last) digit
 */ function $5acb4c63d2aa1a61$var$huHuCheck(tin) {
    // split digits into an array for further processing
    var digits = tin.split('').map(function(a) {
        return parseInt(a, 10);
    });
    var checksum = 8;
    for(var i = 1; i < 9; i++)checksum += digits[i] * (i + 1);
    return checksum % 11 === digits[9];
}
/*
 * lt-LT validation function (should go here if needed)
 * (Asmens kodas, persons/entities respectively)
 * Current validation check is alias of etEeCheck- same format applies
 */ /*
 * it-IT first/last name validity check
 * Accepts it-IT TIN-encoded names as a three-element character array and checks their validity
 * Due to lack of clarity between resources ("Are only Italian consonants used?
 * What happens if a person has X in their name?" etc.) only two test conditions
 * have been implemented:
 * Vowels may only be followed by other vowels or an X character
 * and X characters after vowels may only be followed by other X characters.
 */ function $5acb4c63d2aa1a61$var$itItNameCheck(name) {
    // true at the first occurence of a vowel
    var vowelflag = false; // true at the first occurence of an X AFTER vowel
    // (to properly handle last names with X as consonant)
    var xflag = false;
    for(var i = 0; i < 3; i++){
        if (!vowelflag && /[AEIOU]/.test(name[i])) vowelflag = true;
        else if (!xflag && vowelflag && name[i] === 'X') xflag = true;
        else if (i > 0) {
            if (vowelflag && !xflag) {
                if (!/[AEIOU]/.test(name[i])) return false;
            }
            if (xflag) {
                if (!/X/.test(name[i])) return false;
            }
        }
    }
    return true;
}
/*
 * it-IT validation function
 * (Codice fiscale (TIN-IT), persons only)
 * Verify name, birth date and codice catastale validity
 * and calculate check character.
 * Material not in DG-TAXUD document sourced from:
 * `https://en.wikipedia.org/wiki/Italian_fiscal_code`
 */ function $5acb4c63d2aa1a61$var$itItCheck(tin) {
    // Capitalize and split characters into an array for further processing
    var chars = tin.toUpperCase().split(''); // Check first and last name validity calling itItNameCheck()
    if (!$5acb4c63d2aa1a61$var$itItNameCheck(chars.slice(0, 3))) return false;
    if (!$5acb4c63d2aa1a61$var$itItNameCheck(chars.slice(3, 6))) return false;
     // Convert letters in number spaces back to numbers if any
    var number_locations = [
        6,
        7,
        9,
        10,
        12,
        13,
        14
    ];
    var number_replace = {
        L: '0',
        M: '1',
        N: '2',
        P: '3',
        Q: '4',
        R: '5',
        S: '6',
        T: '7',
        U: '8',
        V: '9'
    };
    for(var _i4 = 0, _number_locations = number_locations; _i4 < _number_locations.length; _i4++){
        var i = _number_locations[_i4];
        if (chars[i] in number_replace) chars.splice(i, 1, number_replace[chars[i]]);
    } // Extract month and day, and check date validity
    var month_replace = {
        A: '01',
        B: '02',
        C: '03',
        D: '04',
        E: '05',
        H: '06',
        L: '07',
        M: '08',
        P: '09',
        R: '10',
        S: '11',
        T: '12'
    };
    var month = month_replace[chars[8]];
    var day = parseInt(chars[9] + chars[10], 10);
    if (day > 40) day -= 40;
    if (day < 10) day = "0".concat(day);
    var date = "".concat(chars[6]).concat(chars[7], "/").concat(month, "/").concat(day);
    if (!(0, $5acb4c63d2aa1a61$var$_isDate.default)(date, 'YY/MM/DD')) return false;
     // Calculate check character by adding up even and odd characters as numbers
    var checksum = 0;
    for(var _i5 = 1; _i5 < chars.length - 1; _i5 += 2){
        var char_to_int = parseInt(chars[_i5], 10);
        if (isNaN(char_to_int)) char_to_int = chars[_i5].charCodeAt(0) - 65;
        checksum += char_to_int;
    }
    var odd_convert = {
        // Maps of characters at odd places
        A: 1,
        B: 0,
        C: 5,
        D: 7,
        E: 9,
        F: 13,
        G: 15,
        H: 17,
        I: 19,
        J: 21,
        K: 2,
        L: 4,
        M: 18,
        N: 20,
        O: 11,
        P: 3,
        Q: 6,
        R: 8,
        S: 12,
        T: 14,
        U: 16,
        V: 10,
        W: 22,
        X: 25,
        Y: 24,
        Z: 23,
        0: 1,
        1: 0
    };
    for(var _i6 = 0; _i6 < chars.length - 1; _i6 += 2){
        var _char_to_int = 0;
        if (chars[_i6] in odd_convert) _char_to_int = odd_convert[chars[_i6]];
        else {
            var multiplier = parseInt(chars[_i6], 10);
            _char_to_int = 2 * multiplier + 1;
            if (multiplier > 4) _char_to_int += 2;
        }
        checksum += _char_to_int;
    }
    if (String.fromCharCode(65 + checksum % 26) !== chars[15]) return false;
    return true;
}
/*
 * lv-LV validation function
 * (Personas kods (PK), persons only)
 * Check validity of birth date and calculate check (last) digit
 * Support only for old format numbers (not starting with '32', issued before 2017/07/01)
 * Material not in DG TAXUD document sourced from:
 * `https://boot.ritakafija.lv/forums/index.php?/topic/88314-personas-koda-algoritms-%C4%8Deksumma/`
 */ function $5acb4c63d2aa1a61$var$lvLvCheck(tin) {
    tin = tin.replace(/\W/, ''); // Extract date from TIN
    var day = tin.slice(0, 2);
    if (day !== '32') {
        // No date/checksum check if new format
        var month = tin.slice(2, 4);
        if (month !== '00') {
            // No date check if unknown month
            var full_year = tin.slice(4, 6);
            switch(tin[6]){
                case '0':
                    full_year = "18".concat(full_year);
                    break;
                case '1':
                    full_year = "19".concat(full_year);
                    break;
                default:
                    full_year = "20".concat(full_year);
                    break;
            } // Check date validity
            var date = "".concat(full_year, "/").concat(tin.slice(2, 4), "/").concat(day);
            if (!(0, $5acb4c63d2aa1a61$var$_isDate.default)(date, 'YYYY/MM/DD')) return false;
        } // Calculate check digit
        var checksum = 1101;
        var multip_lookup = [
            1,
            6,
            3,
            7,
            9,
            10,
            5,
            8,
            4,
            2
        ];
        for(var i = 0; i < tin.length - 1; i++)checksum -= parseInt(tin[i], 10) * multip_lookup[i];
        return parseInt(tin[10], 10) === checksum % 11;
    }
    return true;
}
/*
 * mt-MT validation function
 * (Identity Card Number or Unique Taxpayer Reference, persons/entities)
 * Verify Identity Card Number structure (no other tests found)
 */ function $5acb4c63d2aa1a61$var$mtMtCheck(tin) {
    if (tin.length !== 9) {
        // No tests for UTR
        var chars = tin.toUpperCase().split(''); // Fill with zeros if smaller than proper
        while(chars.length < 8)chars.unshift(0);
         // Validate format according to last character
        switch(tin[7]){
            case 'A':
            case 'P':
                if (parseInt(chars[6], 10) === 0) return false;
                break;
            default:
                var first_part = parseInt(chars.join('').slice(0, 5), 10);
                if (first_part > 32000) return false;
                var second_part = parseInt(chars.join('').slice(5, 7), 10);
                if (first_part === second_part) return false;
        }
    }
    return true;
}
/*
 * nl-NL validation function
 * (Burgerservicenummer (BSN) or Rechtspersonen Samenwerkingsverbanden Informatie Nummer (RSIN),
 * persons/entities respectively)
 * Verify TIN validity by calculating check (last) digit (variant of MOD 11)
 */ function $5acb4c63d2aa1a61$var$nlNlCheck(tin) {
    return $5acb4c63d2aa1a61$var$algorithms.reverseMultiplyAndSum(tin.split('').slice(0, 8).map(function(a) {
        return parseInt(a, 10);
    }), 9) % 11 === parseInt(tin[8], 10);
}
/*
 * pl-PL validation function
 * (Powszechny Elektroniczny System Ewidencji Ludności (PESEL)
 * or Numer identyfikacji podatkowej (NIP), persons/entities)
 * Verify TIN validity by validating birth date (PESEL) and calculating check (last) digit
 */ function $5acb4c63d2aa1a61$var$plPlCheck(tin) {
    // NIP
    if (tin.length === 10) {
        // Calculate last digit by multiplying with lookup
        var lookup = [
            6,
            5,
            7,
            2,
            3,
            4,
            5,
            6,
            7
        ];
        var _checksum = 0;
        for(var i = 0; i < lookup.length; i++)_checksum += parseInt(tin[i], 10) * lookup[i];
        _checksum %= 11;
        if (_checksum === 10) return false;
        return _checksum === parseInt(tin[9], 10);
    } // PESEL
    // Extract full year using month
    var full_year = tin.slice(0, 2);
    var month = parseInt(tin.slice(2, 4), 10);
    if (month > 80) {
        full_year = "18".concat(full_year);
        month -= 80;
    } else if (month > 60) {
        full_year = "22".concat(full_year);
        month -= 60;
    } else if (month > 40) {
        full_year = "21".concat(full_year);
        month -= 40;
    } else if (month > 20) {
        full_year = "20".concat(full_year);
        month -= 20;
    } else full_year = "19".concat(full_year);
     // Add leading zero to month if needed
    if (month < 10) month = "0".concat(month);
     // Check date validity
    var date = "".concat(full_year, "/").concat(month, "/").concat(tin.slice(4, 6));
    if (!(0, $5acb4c63d2aa1a61$var$_isDate.default)(date, 'YYYY/MM/DD')) return false;
     // Calculate last digit by mulitplying with odd one-digit numbers except 5
    var checksum = 0;
    var multiplier = 1;
    for(var _i7 = 0; _i7 < tin.length - 1; _i7++){
        checksum += parseInt(tin[_i7], 10) * multiplier % 10;
        multiplier += 2;
        if (multiplier > 10) multiplier = 1;
        else if (multiplier === 5) multiplier += 2;
    }
    checksum = 10 - checksum % 10;
    return checksum === parseInt(tin[10], 10);
}
/*
* pt-BR validation function
* (Cadastro de Pessoas Físicas (CPF, persons)
* Cadastro Nacional de Pessoas Jurídicas (CNPJ, entities)
* Both inputs will be validated
*/ function $5acb4c63d2aa1a61$var$ptBrCheck(tin) {
    tin = tin.replace(/[^\d]+/g, '');
    if (tin === '') return false;
    if (tin.length === 11) {
        var _sum;
        var ramainder;
        _sum = 0;
        tin = tin.replace(/[^\d]+/g, '');
        if (tin === '11111111111' || tin === '22222222222' || tin === '33333333333' || tin === '44444444444' || tin === '55555555555' || tin === '66666666666' || tin === '77777777777' || tin === '88888888888' || tin === '99999999999' || tin === '00000000000') return false;
        for(var i = 1; i <= 9; i++)_sum += parseInt(tin.substring(i - 1, i), 10) * (11 - i);
        ramainder = _sum * 10 % 11;
        if (ramainder === 10 || ramainder === 11) ramainder = 0;
        if (ramainder !== parseInt(tin.substring(9, 10), 10)) return false;
        _sum = 0;
        for(var _i8 = 1; _i8 <= 10; _i8++)_sum += parseInt(tin.substring(_i8 - 1, _i8), 10) * (12 - _i8);
        ramainder = _sum * 10 % 11;
        if (ramainder === 10 || ramainder === 11) ramainder = 0;
        if (ramainder !== parseInt(tin.substring(10, 11), 10)) return false;
        return true;
    }
    if (tin.length !== 14) return false;
    if (tin === '00000000000000' || tin === '11111111111111' || tin === '22222222222222' || tin === '33333333333333' || tin === '44444444444444' || tin === '55555555555555' || tin === '66666666666666' || tin === '77777777777777' || tin === '88888888888888' || tin === '99999999999999') return false;
    var length = tin.length - 2;
    var identifiers = tin.substring(0, length);
    var verificators = tin.substring(length);
    var sum = 0;
    var pos = length - 7;
    for(var _i9 = length; _i9 >= 1; _i9--){
        sum += identifiers.charAt(length - _i9) * pos;
        pos -= 1;
        if (pos < 2) pos = 9;
    }
    var result = sum % 11 < 2 ? 0 : 11 - sum % 11;
    if (result !== parseInt(verificators.charAt(0), 10)) return false;
    length += 1;
    identifiers = tin.substring(0, length);
    sum = 0;
    pos = length - 7;
    for(var _i10 = length; _i10 >= 1; _i10--){
        sum += identifiers.charAt(length - _i10) * pos;
        pos -= 1;
        if (pos < 2) pos = 9;
    }
    result = sum % 11 < 2 ? 0 : 11 - sum % 11;
    if (result !== parseInt(verificators.charAt(1), 10)) return false;
    return true;
}
/*
 * pt-PT validation function
 * (Número de identificação fiscal (NIF), persons/entities)
 * Verify TIN validity by calculating check (last) digit (variant of MOD 11)
 */ function $5acb4c63d2aa1a61$var$ptPtCheck(tin) {
    var checksum = 11 - $5acb4c63d2aa1a61$var$algorithms.reverseMultiplyAndSum(tin.split('').slice(0, 8).map(function(a) {
        return parseInt(a, 10);
    }), 9) % 11;
    if (checksum > 9) return parseInt(tin[8], 10) === 0;
    return checksum === parseInt(tin[8], 10);
}
/*
 * ro-RO validation function
 * (Cod Numeric Personal (CNP) or Cod de înregistrare fiscală (CIF),
 * persons only)
 * Verify CNP validity by calculating check (last) digit (test not found for CIF)
 * Material not in DG TAXUD document sourced from:
 * `https://en.wikipedia.org/wiki/National_identification_number#Romania`
 */ function $5acb4c63d2aa1a61$var$roRoCheck(tin) {
    if (tin.slice(0, 4) !== '9000') {
        // No test found for this format
        // Extract full year using century digit if possible
        var full_year = tin.slice(1, 3);
        switch(tin[0]){
            case '1':
            case '2':
                full_year = "19".concat(full_year);
                break;
            case '3':
            case '4':
                full_year = "18".concat(full_year);
                break;
            case '5':
            case '6':
                full_year = "20".concat(full_year);
                break;
            default:
        } // Check date validity
        var date = "".concat(full_year, "/").concat(tin.slice(3, 5), "/").concat(tin.slice(5, 7));
        if (date.length === 8) {
            if (!(0, $5acb4c63d2aa1a61$var$_isDate.default)(date, 'YY/MM/DD')) return false;
        } else if (!(0, $5acb4c63d2aa1a61$var$_isDate.default)(date, 'YYYY/MM/DD')) return false;
         // Calculate check digit
        var digits = tin.split('').map(function(a) {
            return parseInt(a, 10);
        });
        var multipliers = [
            2,
            7,
            9,
            1,
            4,
            6,
            3,
            5,
            8,
            2,
            7,
            9
        ];
        var checksum = 0;
        for(var i = 0; i < multipliers.length; i++)checksum += digits[i] * multipliers[i];
        if (checksum % 11 === 10) return digits[12] === 1;
        return digits[12] === checksum % 11;
    }
    return true;
}
/*
 * sk-SK validation function
 * (Rodné číslo (RČ) or bezvýznamové identifikačné číslo (BIČ), persons only)
 * Checks validity of pre-1954 birth numbers (rodné číslo) only
 * Due to the introduction of the pseudo-random BIČ it is not possible to test
 * post-1954 birth numbers without knowing whether they are BIČ or RČ beforehand
 */ function $5acb4c63d2aa1a61$var$skSkCheck(tin) {
    if (tin.length === 9) {
        tin = tin.replace(/\W/, '');
        if (tin.slice(6) === '000') return false;
         // Three-zero serial not assigned before 1954
        // Extract full year from TIN length
        var full_year = parseInt(tin.slice(0, 2), 10);
        if (full_year > 53) return false;
        if (full_year < 10) full_year = "190".concat(full_year);
        else full_year = "19".concat(full_year);
         // Extract month from TIN and normalize
        var month = parseInt(tin.slice(2, 4), 10);
        if (month > 50) month -= 50;
        if (month < 10) month = "0".concat(month);
         // Check date validity
        var date = "".concat(full_year, "/").concat(month, "/").concat(tin.slice(4, 6));
        if (!(0, $5acb4c63d2aa1a61$var$_isDate.default)(date, 'YYYY/MM/DD')) return false;
    }
    return true;
}
/*
 * sl-SI validation function
 * (Davčna številka, persons/entities)
 * Verify TIN validity by calculating check (last) digit (variant of MOD 11)
 */ function $5acb4c63d2aa1a61$var$slSiCheck(tin) {
    var checksum = 11 - $5acb4c63d2aa1a61$var$algorithms.reverseMultiplyAndSum(tin.split('').slice(0, 7).map(function(a) {
        return parseInt(a, 10);
    }), 8) % 11;
    if (checksum === 10) return parseInt(tin[7], 10) === 0;
    return checksum === parseInt(tin[7], 10);
}
/*
 * sv-SE validation function
 * (Personnummer or samordningsnummer, persons only)
 * Checks validity of birth date and calls luhnCheck() to validate check (last) digit
 */ function $5acb4c63d2aa1a61$var$svSeCheck(tin) {
    // Make copy of TIN and normalize to two-digit year form
    var tin_copy = tin.slice(0);
    if (tin.length > 11) tin_copy = tin_copy.slice(2);
     // Extract date of birth
    var full_year = '';
    var month = tin_copy.slice(2, 4);
    var day = parseInt(tin_copy.slice(4, 6), 10);
    if (tin.length > 11) full_year = tin.slice(0, 4);
    else {
        full_year = tin.slice(0, 2);
        if (tin.length === 11 && day < 60) {
            // Extract full year from centenarian symbol
            // Should work just fine until year 10000 or so
            var current_year = new Date().getFullYear().toString();
            var current_century = parseInt(current_year.slice(0, 2), 10);
            current_year = parseInt(current_year, 10);
            if (tin[6] === '-') {
                if (parseInt("".concat(current_century).concat(full_year), 10) > current_year) full_year = "".concat(current_century - 1).concat(full_year);
                else full_year = "".concat(current_century).concat(full_year);
            } else {
                full_year = "".concat(current_century - 1).concat(full_year);
                if (current_year - parseInt(full_year, 10) < 100) return false;
            }
        }
    } // Normalize day and check date validity
    if (day > 60) day -= 60;
    if (day < 10) day = "0".concat(day);
    var date = "".concat(full_year, "/").concat(month, "/").concat(day);
    if (date.length === 8) {
        if (!(0, $5acb4c63d2aa1a61$var$_isDate.default)(date, 'YY/MM/DD')) return false;
    } else if (!(0, $5acb4c63d2aa1a61$var$_isDate.default)(date, 'YYYY/MM/DD')) return false;
    return $5acb4c63d2aa1a61$var$algorithms.luhnCheck(tin.replace(/\W/, ''));
} // Locale lookup objects
/*
 * Tax id regex formats for various locales
 *
 * Where not explicitly specified in DG-TAXUD document both
 * uppercase and lowercase letters are acceptable.
 */ var $5acb4c63d2aa1a61$var$taxIdFormat = {
    'bg-BG': /^\d{10}$/,
    'cs-CZ': /^\d{6}\/{0,1}\d{3,4}$/,
    'de-AT': /^\d{9}$/,
    'de-DE': /^[1-9]\d{10}$/,
    'dk-DK': /^\d{6}-{0,1}\d{4}$/,
    'el-CY': /^[09]\d{7}[A-Z]$/,
    'el-GR': /^([0-4]|[7-9])\d{8}$/,
    'en-GB': /^\d{10}$|^(?!GB|NK|TN|ZZ)(?![DFIQUV])[A-Z](?![DFIQUVO])[A-Z]\d{6}[ABCD ]$/i,
    'en-IE': /^\d{7}[A-W][A-IW]{0,1}$/i,
    'en-US': /^\d{2}[- ]{0,1}\d{7}$/,
    'es-ES': /^(\d{0,8}|[XYZKLM]\d{7})[A-HJ-NP-TV-Z]$/i,
    'et-EE': /^[1-6]\d{6}(00[1-9]|0[1-9][0-9]|[1-6][0-9]{2}|70[0-9]|710)\d$/,
    'fi-FI': /^\d{6}[-+A]\d{3}[0-9A-FHJ-NPR-Y]$/i,
    'fr-BE': /^\d{11}$/,
    'fr-FR': /^[0-3]\d{12}$|^[0-3]\d\s\d{2}(\s\d{3}){3}$/,
    // Conforms both to official spec and provided example
    'fr-LU': /^\d{13}$/,
    'hr-HR': /^\d{11}$/,
    'hu-HU': /^8\d{9}$/,
    'it-IT': /^[A-Z]{6}[L-NP-V0-9]{2}[A-EHLMPRST][L-NP-V0-9]{2}[A-ILMZ][L-NP-V0-9]{3}[A-Z]$/i,
    'lv-LV': /^\d{6}-{0,1}\d{5}$/,
    // Conforms both to DG TAXUD spec and original research
    'mt-MT': /^\d{3,7}[APMGLHBZ]$|^([1-8])\1\d{7}$/i,
    'nl-NL': /^\d{9}$/,
    'pl-PL': /^\d{10,11}$/,
    'pt-BR': /^\d{11,14}$/,
    'pt-PT': /^\d{9}$/,
    'ro-RO': /^\d{13}$/,
    'sk-SK': /^\d{6}\/{0,1}\d{3,4}$/,
    'sl-SI': /^[1-9]\d{7}$/,
    'sv-SE': /^(\d{6}[-+]{0,1}\d{4}|(18|19|20)\d{6}[-+]{0,1}\d{4})$/
}; // taxIdFormat locale aliases
$5acb4c63d2aa1a61$var$taxIdFormat['lb-LU'] = $5acb4c63d2aa1a61$var$taxIdFormat['fr-LU'];
$5acb4c63d2aa1a61$var$taxIdFormat['lt-LT'] = $5acb4c63d2aa1a61$var$taxIdFormat['et-EE'];
$5acb4c63d2aa1a61$var$taxIdFormat['nl-BE'] = $5acb4c63d2aa1a61$var$taxIdFormat['fr-BE']; // Algorithmic tax id check functions for various locales
var $5acb4c63d2aa1a61$var$taxIdCheck = {
    'bg-BG': $5acb4c63d2aa1a61$var$bgBgCheck,
    'cs-CZ': $5acb4c63d2aa1a61$var$csCzCheck,
    'de-AT': $5acb4c63d2aa1a61$var$deAtCheck,
    'de-DE': $5acb4c63d2aa1a61$var$deDeCheck,
    'dk-DK': $5acb4c63d2aa1a61$var$dkDkCheck,
    'el-CY': $5acb4c63d2aa1a61$var$elCyCheck,
    'el-GR': $5acb4c63d2aa1a61$var$elGrCheck,
    'en-IE': $5acb4c63d2aa1a61$var$enIeCheck,
    'en-US': $5acb4c63d2aa1a61$var$enUsCheck,
    'es-ES': $5acb4c63d2aa1a61$var$esEsCheck,
    'et-EE': $5acb4c63d2aa1a61$var$etEeCheck,
    'fi-FI': $5acb4c63d2aa1a61$var$fiFiCheck,
    'fr-BE': $5acb4c63d2aa1a61$var$frBeCheck,
    'fr-FR': $5acb4c63d2aa1a61$var$frFrCheck,
    'fr-LU': $5acb4c63d2aa1a61$var$frLuCheck,
    'hr-HR': $5acb4c63d2aa1a61$var$hrHrCheck,
    'hu-HU': $5acb4c63d2aa1a61$var$huHuCheck,
    'it-IT': $5acb4c63d2aa1a61$var$itItCheck,
    'lv-LV': $5acb4c63d2aa1a61$var$lvLvCheck,
    'mt-MT': $5acb4c63d2aa1a61$var$mtMtCheck,
    'nl-NL': $5acb4c63d2aa1a61$var$nlNlCheck,
    'pl-PL': $5acb4c63d2aa1a61$var$plPlCheck,
    'pt-BR': $5acb4c63d2aa1a61$var$ptBrCheck,
    'pt-PT': $5acb4c63d2aa1a61$var$ptPtCheck,
    'ro-RO': $5acb4c63d2aa1a61$var$roRoCheck,
    'sk-SK': $5acb4c63d2aa1a61$var$skSkCheck,
    'sl-SI': $5acb4c63d2aa1a61$var$slSiCheck,
    'sv-SE': $5acb4c63d2aa1a61$var$svSeCheck
}; // taxIdCheck locale aliases
$5acb4c63d2aa1a61$var$taxIdCheck['lb-LU'] = $5acb4c63d2aa1a61$var$taxIdCheck['fr-LU'];
$5acb4c63d2aa1a61$var$taxIdCheck['lt-LT'] = $5acb4c63d2aa1a61$var$taxIdCheck['et-EE'];
$5acb4c63d2aa1a61$var$taxIdCheck['nl-BE'] = $5acb4c63d2aa1a61$var$taxIdCheck['fr-BE']; // Regexes for locales where characters should be omitted before checking format
var $5acb4c63d2aa1a61$var$allsymbols = /[-\\\/!@#$%\^&\*\(\)\+\=\[\]]+/g;
var $5acb4c63d2aa1a61$var$sanitizeRegexes = {
    'de-AT': $5acb4c63d2aa1a61$var$allsymbols,
    'de-DE': /[\/\\]/g,
    'fr-BE': $5acb4c63d2aa1a61$var$allsymbols
}; // sanitizeRegexes locale aliases
$5acb4c63d2aa1a61$var$sanitizeRegexes['nl-BE'] = $5acb4c63d2aa1a61$var$sanitizeRegexes['fr-BE'];
/*
 * Validator function
 * Return true if the passed string is a valid tax identification number
 * for the specified locale.
 * Throw an error exception if the locale is not supported.
 */ function $5acb4c63d2aa1a61$var$isTaxID(str) {
    var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en-US';
    (0, $5acb4c63d2aa1a61$var$_assertString.default)(str); // Copy TIN to avoid replacement if sanitized
    var strcopy = str.slice(0);
    if (locale in $5acb4c63d2aa1a61$var$taxIdFormat) {
        if (locale in $5acb4c63d2aa1a61$var$sanitizeRegexes) strcopy = strcopy.replace($5acb4c63d2aa1a61$var$sanitizeRegexes[locale], '');
        if (!$5acb4c63d2aa1a61$var$taxIdFormat[locale].test(strcopy)) return false;
        if (locale in $5acb4c63d2aa1a61$var$taxIdCheck) return $5acb4c63d2aa1a61$var$taxIdCheck[locale](strcopy);
         // Fallthrough; not all locales have algorithmic checks
        return true;
    }
    throw new Error("Invalid locale '".concat(locale, "'"));
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});
parcelRegister("3SUDT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.iso7064Check = $2d425a3de7836668$var$iso7064Check;
module.exports.luhnCheck = $2d425a3de7836668$var$luhnCheck;
module.exports.reverseMultiplyAndSum = $2d425a3de7836668$var$reverseMultiplyAndSum;
module.exports.verhoeffCheck = $2d425a3de7836668$var$verhoeffCheck;
/**
 * Algorithmic validation functions
 * May be used as is or implemented in the workflow of other validators.
 */ /*
 * ISO 7064 validation function
 * Called with a string of numbers (incl. check digit)
 * to validate according to ISO 7064 (MOD 11, 10).
 */ function $2d425a3de7836668$var$iso7064Check(str) {
    var checkvalue = 10;
    for(var i = 0; i < str.length - 1; i++)checkvalue = (parseInt(str[i], 10) + checkvalue) % 10 === 0 ? 9 : (parseInt(str[i], 10) + checkvalue) % 10 * 2 % 11;
    checkvalue = checkvalue === 1 ? 0 : 11 - checkvalue;
    return checkvalue === parseInt(str[10], 10);
}
/*
 * Luhn (mod 10) validation function
 * Called with a string of numbers (incl. check digit)
 * to validate according to the Luhn algorithm.
 */ function $2d425a3de7836668$var$luhnCheck(str) {
    var checksum = 0;
    var second = false;
    for(var i = str.length - 1; i >= 0; i--){
        if (second) {
            var product = parseInt(str[i], 10) * 2;
            if (product > 9) // sum digits of product and add to checksum
            checksum += product.toString().split('').map(function(a) {
                return parseInt(a, 10);
            }).reduce(function(a, b) {
                return a + b;
            }, 0);
            else checksum += product;
        } else checksum += parseInt(str[i], 10);
        second = !second;
    }
    return checksum % 10 === 0;
}
/*
 * Reverse TIN multiplication and summation helper function
 * Called with an array of single-digit integers and a base multiplier
 * to calculate the sum of the digits multiplied in reverse.
 * Normally used in variations of MOD 11 algorithmic checks.
 */ function $2d425a3de7836668$var$reverseMultiplyAndSum(digits, base) {
    var total = 0;
    for(var i = 0; i < digits.length; i++)total += digits[i] * (base - i);
    return total;
}
/*
 * Verhoeff validation helper function
 * Called with a string of numbers
 * to validate according to the Verhoeff algorithm.
 */ function $2d425a3de7836668$var$verhoeffCheck(str) {
    var d_table = [
        [
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9
        ],
        [
            1,
            2,
            3,
            4,
            0,
            6,
            7,
            8,
            9,
            5
        ],
        [
            2,
            3,
            4,
            0,
            1,
            7,
            8,
            9,
            5,
            6
        ],
        [
            3,
            4,
            0,
            1,
            2,
            8,
            9,
            5,
            6,
            7
        ],
        [
            4,
            0,
            1,
            2,
            3,
            9,
            5,
            6,
            7,
            8
        ],
        [
            5,
            9,
            8,
            7,
            6,
            0,
            4,
            3,
            2,
            1
        ],
        [
            6,
            5,
            9,
            8,
            7,
            1,
            0,
            4,
            3,
            2
        ],
        [
            7,
            6,
            5,
            9,
            8,
            2,
            1,
            0,
            4,
            3
        ],
        [
            8,
            7,
            6,
            5,
            9,
            3,
            2,
            1,
            0,
            4
        ],
        [
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1,
            0
        ]
    ];
    var p_table = [
        [
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9
        ],
        [
            1,
            5,
            7,
            6,
            2,
            8,
            3,
            0,
            9,
            4
        ],
        [
            5,
            8,
            0,
            3,
            7,
            9,
            6,
            1,
            4,
            2
        ],
        [
            8,
            9,
            1,
            6,
            0,
            4,
            3,
            5,
            2,
            7
        ],
        [
            9,
            4,
            5,
            3,
            1,
            2,
            6,
            8,
            7,
            0
        ],
        [
            4,
            2,
            8,
            6,
            5,
            7,
            3,
            9,
            0,
            1
        ],
        [
            2,
            7,
            9,
            3,
            8,
            0,
            6,
            4,
            1,
            5
        ],
        [
            7,
            0,
            4,
            6,
            9,
            1,
            3,
            2,
            5,
            8
        ]
    ]; // Copy (to prevent replacement) and reverse
    var str_copy = str.split('').reverse().join('');
    var checksum = 0;
    for(var i = 0; i < str_copy.length; i++)checksum = d_table[checksum][p_table[i % 8][parseInt(str_copy[i], 10)]];
    return checksum === 0;
}

});


parcelRegister("4kFi1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $32790ef4fc8dd756$var$isMobilePhone;
module.exports.locales = void 0;

var $32790ef4fc8dd756$var$_assertString = $32790ef4fc8dd756$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $32790ef4fc8dd756$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/* eslint-disable max-len */ var $32790ef4fc8dd756$var$phones = {
    'am-AM': /^(\+?374|0)((10|[9|7][0-9])\d{6}$|[2-4]\d{7}$)/,
    'ar-AE': /^((\+?971)|0)?5[024568]\d{7}$/,
    'ar-BH': /^(\+?973)?(3|6)\d{7}$/,
    'ar-DZ': /^(\+?213|0)(5|6|7)\d{8}$/,
    'ar-LB': /^(\+?961)?((3|81)\d{6}|7\d{7})$/,
    'ar-EG': /^((\+?20)|0)?1[0125]\d{8}$/,
    'ar-IQ': /^(\+?964|0)?7[0-9]\d{8}$/,
    'ar-JO': /^(\+?962|0)?7[789]\d{7}$/,
    'ar-KW': /^(\+?965)[569]\d{7}$/,
    'ar-LY': /^((\+?218)|0)?(9[1-6]\d{7}|[1-8]\d{7,9})$/,
    'ar-MA': /^(?:(?:\+|00)212|0)[5-7]\d{8}$/,
    'ar-OM': /^((\+|00)968)?(9[1-9])\d{6}$/,
    'ar-SA': /^(!?(\+?966)|0)?5\d{8}$/,
    'ar-SY': /^(!?(\+?963)|0)?9\d{8}$/,
    'ar-TN': /^(\+?216)?[2459]\d{7}$/,
    'az-AZ': /^(\+994|0)(5[015]|7[07]|99)\d{7}$/,
    'bs-BA': /^((((\+|00)3876)|06))((([0-3]|[5-6])\d{6})|(4\d{7}))$/,
    'be-BY': /^(\+?375)?(24|25|29|33|44)\d{7}$/,
    'bg-BG': /^(\+?359|0)?8[789]\d{7}$/,
    'bn-BD': /^(\+?880|0)1[13456789][0-9]{8}$/,
    'ca-AD': /^(\+376)?[346]\d{5}$/,
    'cs-CZ': /^(\+?420)? ?[1-9][0-9]{2} ?[0-9]{3} ?[0-9]{3}$/,
    'da-DK': /^(\+?45)?\s?\d{2}\s?\d{2}\s?\d{2}\s?\d{2}$/,
    'de-DE': /^(\+49)?0?[1|3]([0|5][0-45-9]\d|6([23]|0\d?)|7([0-57-9]|6\d))\d{7}$/,
    'de-AT': /^(\+43|0)\d{1,4}\d{3,12}$/,
    'de-CH': /^(\+41|0)([1-9])\d{1,9}$/,
    'de-LU': /^(\+352)?((6\d1)\d{6})$/,
    'el-GR': /^(\+?30|0)?(69\d{8})$/,
    'en-AU': /^(\+?61|0)4\d{8}$/,
    'en-GB': /^(\+?44|0)7\d{9}$/,
    'en-GG': /^(\+?44|0)1481\d{6}$/,
    'en-GH': /^(\+233|0)(20|50|24|54|27|57|26|56|23|28|55|59)\d{7}$/,
    'en-HK': /^(\+?852[-\s]?)?[456789]\d{3}[-\s]?\d{4}$/,
    'en-MO': /^(\+?853[-\s]?)?[6]\d{3}[-\s]?\d{4}$/,
    'en-IE': /^(\+?353|0)8[356789]\d{7}$/,
    'en-IN': /^(\+?91|0)?[6789]\d{9}$/,
    'en-KE': /^(\+?254|0)(7|1)\d{8}$/,
    'en-MT': /^(\+?356|0)?(99|79|77|21|27|22|25)[0-9]{6}$/,
    'en-MU': /^(\+?230|0)?\d{8}$/,
    'en-NG': /^(\+?234|0)?[789]\d{9}$/,
    'en-NZ': /^(\+?64|0)[28]\d{7,9}$/,
    'en-PK': /^((\+92)|(0092))-{0,1}\d{3}-{0,1}\d{7}$|^\d{11}$|^\d{4}-\d{7}$/,
    'en-PH': /^(09|\+639)\d{9}$/,
    'en-RW': /^(\+?250|0)?[7]\d{8}$/,
    'en-SG': /^(\+65)?[3689]\d{7}$/,
    'en-SL': /^(\+?232|0)\d{8}$/,
    'en-TZ': /^(\+?255|0)?[67]\d{8}$/,
    'en-UG': /^(\+?256|0)?[7]\d{8}$/,
    'en-US': /^((\+1|1)?( |-)?)?(\([2-9][0-9]{2}\)|[2-9][0-9]{2})( |-)?([2-9][0-9]{2}( |-)?[0-9]{4})$/,
    'en-ZA': /^(\+?27|0)\d{9}$/,
    'en-ZM': /^(\+?26)?09[567]\d{7}$/,
    'en-ZW': /^(\+263)[0-9]{9}$/,
    'es-AR': /^\+?549(11|[2368]\d)\d{8}$/,
    'es-BO': /^(\+?591)?(6|7)\d{7}$/,
    'es-CO': /^(\+?57)?3(0(0|1|2|4|5)|1\d|2[0-4]|5(0|1))\d{7}$/,
    'es-CL': /^(\+?56|0)[2-9]\d{1}\d{7}$/,
    'es-CR': /^(\+506)?[2-8]\d{7}$/,
    'es-DO': /^(\+?1)?8[024]9\d{7}$/,
    'es-HN': /^(\+?504)?[9|8]\d{7}$/,
    'es-EC': /^(\+?593|0)([2-7]|9[2-9])\d{7}$/,
    'es-ES': /^(\+?34)?[6|7]\d{8}$/,
    'es-PE': /^(\+?51)?9\d{8}$/,
    'es-MX': /^(\+?52)?(1|01)?\d{10,11}$/,
    'es-PA': /^(\+?507)\d{7,8}$/,
    'es-PY': /^(\+?595|0)9[9876]\d{7}$/,
    'es-UY': /^(\+598|0)9[1-9][\d]{6}$/,
    'et-EE': /^(\+?372)?\s?(5|8[1-4])\s?([0-9]\s?){6,7}$/,
    'fa-IR': /^(\+?98[\-\s]?|0)9[0-39]\d[\-\s]?\d{3}[\-\s]?\d{4}$/,
    'fi-FI': /^(\+?358|0)\s?(4(0|1|2|4|5|6)?|50)\s?(\d\s?){4,8}\d$/,
    'fj-FJ': /^(\+?679)?\s?\d{3}\s?\d{4}$/,
    'fo-FO': /^(\+?298)?\s?\d{2}\s?\d{2}\s?\d{2}$/,
    'fr-FR': /^(\+?33|0)[67]\d{8}$/,
    'fr-GF': /^(\+?594|0|00594)[67]\d{8}$/,
    'fr-GP': /^(\+?590|0|00590)[67]\d{8}$/,
    'fr-MQ': /^(\+?596|0|00596)[67]\d{8}$/,
    'fr-RE': /^(\+?262|0|00262)[67]\d{8}$/,
    'he-IL': /^(\+972|0)([23489]|5[012345689]|77)[1-9]\d{6}$/,
    'hu-HU': /^(\+?36)(20|30|70)\d{7}$/,
    'id-ID': /^(\+?62|0)8(1[123456789]|2[1238]|3[1238]|5[12356789]|7[78]|9[56789]|8[123456789])([\s?|\d]{5,11})$/,
    'it-IT': /^(\+?39)?\s?3\d{2} ?\d{6,7}$/,
    'it-SM': /^((\+378)|(0549)|(\+390549)|(\+3780549))?6\d{5,9}$/,
    'ja-JP': /^(\+81[ \-]?(\(0\))?|0)[6789]0[ \-]?\d{4}[ \-]?\d{4}$/,
    'ka-GE': /^(\+?995)?(5|79)\d{7}$/,
    'kk-KZ': /^(\+?7|8)?7\d{9}$/,
    'kl-GL': /^(\+?299)?\s?\d{2}\s?\d{2}\s?\d{2}$/,
    'ko-KR': /^((\+?82)[ \-]?)?0?1([0|1|6|7|8|9]{1})[ \-]?\d{3,4}[ \-]?\d{4}$/,
    'lt-LT': /^(\+370|8)\d{8}$/,
    'lv-LV': /^(\+?371)2\d{7}$/,
    'ms-MY': /^(\+?6?01){1}(([0145]{1}(\-|\s)?\d{7,8})|([236789]{1}(\s|\-)?\d{7}))$/,
    'mz-MZ': /^(\+?258)?8[234567]\d{7}$/,
    'nb-NO': /^(\+?47)?[49]\d{7}$/,
    'ne-NP': /^(\+?977)?9[78]\d{8}$/,
    'nl-BE': /^(\+?32|0)4?\d{8}$/,
    'nl-NL': /^(((\+|00)?31\(0\))|((\+|00)?31)|0)6{1}\d{8}$/,
    'nn-NO': /^(\+?47)?[49]\d{7}$/,
    'pl-PL': /^(\+?48)? ?[5-8]\d ?\d{3} ?\d{2} ?\d{2}$/,
    'pt-BR': /^((\+?55\ ?[1-9]{2}\ ?)|(\+?55\ ?\([1-9]{2}\)\ ?)|(0[1-9]{2}\ ?)|(\([1-9]{2}\)\ ?)|([1-9]{2}\ ?))((\d{4}\-?\d{4})|(9[2-9]{1}\d{3}\-?\d{4}))$/,
    'pt-PT': /^(\+?351)?9[1236]\d{7}$/,
    'pt-AO': /^(\+244)\d{9}$/,
    'ro-RO': /^(\+?4?0)\s?7\d{2}(\/|\s|\.|\-)?\d{3}(\s|\.|\-)?\d{3}$/,
    'ru-RU': /^(\+?7|8)?9\d{9}$/,
    'si-LK': /^(?:0|94|\+94)?(7(0|1|2|5|6|7|8)( |-)?\d)\d{6}$/,
    'sl-SI': /^(\+386\s?|0)(\d{1}\s?\d{3}\s?\d{2}\s?\d{2}|\d{2}\s?\d{3}\s?\d{3})$/,
    'sk-SK': /^(\+?421)? ?[1-9][0-9]{2} ?[0-9]{3} ?[0-9]{3}$/,
    'sq-AL': /^(\+355|0)6[789]\d{6}$/,
    'sr-RS': /^(\+3816|06)[- \d]{5,9}$/,
    'sv-SE': /^(\+?46|0)[\s\-]?7[\s\-]?[02369]([\s\-]?\d){7}$/,
    'th-TH': /^(\+66|66|0)\d{9}$/,
    'tr-TR': /^(\+?90|0)?5\d{9}$/,
    'uk-UA': /^(\+?38|8)?0\d{9}$/,
    'uz-UZ': /^(\+?998)?(6[125-79]|7[1-69]|88|9\d)\d{7}$/,
    'vi-VN': /^(\+?84|0)((3([2-9]))|(5([2689]))|(7([0|6-9]))|(8([1-9]))|(9([0-9])))([0-9]{7})$/,
    'zh-CN': /^((\+|00)86)?1([3456789][0-9]|4[579]|6[67]|7[01235678]|9[012356789])[0-9]{8}$/,
    'zh-TW': /^(\+?886\-?|0)?9\d{8}$/
};
/* eslint-enable max-len */ // aliases
$32790ef4fc8dd756$var$phones['en-CA'] = $32790ef4fc8dd756$var$phones['en-US'];
$32790ef4fc8dd756$var$phones['fr-CA'] = $32790ef4fc8dd756$var$phones['en-CA'];
$32790ef4fc8dd756$var$phones['fr-BE'] = $32790ef4fc8dd756$var$phones['nl-BE'];
$32790ef4fc8dd756$var$phones['zh-HK'] = $32790ef4fc8dd756$var$phones['en-HK'];
$32790ef4fc8dd756$var$phones['zh-MO'] = $32790ef4fc8dd756$var$phones['en-MO'];
$32790ef4fc8dd756$var$phones['ga-IE'] = $32790ef4fc8dd756$var$phones['en-IE'];
$32790ef4fc8dd756$var$phones['fr-CH'] = $32790ef4fc8dd756$var$phones['de-CH'];
$32790ef4fc8dd756$var$phones['it-CH'] = $32790ef4fc8dd756$var$phones['fr-CH'];
function $32790ef4fc8dd756$var$isMobilePhone(str, locale, options) {
    (0, $32790ef4fc8dd756$var$_assertString.default)(str);
    if (options && options.strictMode && !str.startsWith('+')) return false;
    if (Array.isArray(locale)) return locale.some(function(key) {
        // https://github.com/gotwarlost/istanbul/blob/master/ignoring-code-for-coverage.md#ignoring-code-for-coverage-purposes
        // istanbul ignore else
        if ($32790ef4fc8dd756$var$phones.hasOwnProperty(key)) {
            var phone = $32790ef4fc8dd756$var$phones[key];
            if (phone.test(str)) return true;
        }
        return false;
    });
    else if (locale in $32790ef4fc8dd756$var$phones) return $32790ef4fc8dd756$var$phones[locale].test(str); // alias falsey locale as 'any'
    else if (!locale || locale === 'any') {
        for(var key in $32790ef4fc8dd756$var$phones)// istanbul ignore else
        if ($32790ef4fc8dd756$var$phones.hasOwnProperty(key)) {
            var phone = $32790ef4fc8dd756$var$phones[key];
            if (phone.test(str)) return true;
        }
        return false;
    }
    throw new Error("Invalid locale '".concat(locale, "'"));
}
var $32790ef4fc8dd756$var$locales = Object.keys($32790ef4fc8dd756$var$phones);
module.exports.locales = $32790ef4fc8dd756$var$locales;

});

parcelRegister("Gjy1y", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $07f31623c5c5b6f1$var$isEthereumAddress;

var $07f31623c5c5b6f1$var$_assertString = $07f31623c5c5b6f1$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $07f31623c5c5b6f1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $07f31623c5c5b6f1$var$eth = /^(0x)[0-9a-f]{40}$/i;
function $07f31623c5c5b6f1$var$isEthereumAddress(str) {
    (0, $07f31623c5c5b6f1$var$_assertString.default)(str);
    return $07f31623c5c5b6f1$var$eth.test(str);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("69Ecb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $47b2c35952174662$var$isCurrency;

var $47b2c35952174662$var$_merge = $47b2c35952174662$var$_interopRequireDefault((parcelRequire("9nDkO")));

var $47b2c35952174662$var$_assertString = $47b2c35952174662$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $47b2c35952174662$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $47b2c35952174662$var$currencyRegex(options) {
    var decimal_digits = "\\d{".concat(options.digits_after_decimal[0], "}");
    options.digits_after_decimal.forEach(function(digit, index) {
        if (index !== 0) decimal_digits = "".concat(decimal_digits, "|\\d{").concat(digit, "}");
    });
    var symbol = "(".concat(options.symbol.replace(/\W/, function(m) {
        return "\\".concat(m);
    }), ")").concat(options.require_symbol ? '' : '?'), negative = '-?', whole_dollar_amount_without_sep = '[1-9]\\d*', whole_dollar_amount_with_sep = "[1-9]\\d{0,2}(\\".concat(options.thousands_separator, "\\d{3})*"), valid_whole_dollar_amounts = [
        '0',
        whole_dollar_amount_without_sep,
        whole_dollar_amount_with_sep
    ], whole_dollar_amount = "(".concat(valid_whole_dollar_amounts.join('|'), ")?"), decimal_amount = "(\\".concat(options.decimal_separator, "(").concat(decimal_digits, "))").concat(options.require_decimal ? '' : '?');
    var pattern = whole_dollar_amount + (options.allow_decimal || options.require_decimal ? decimal_amount : ''); // default is negative sign before symbol, but there are two other options (besides parens)
    if (options.allow_negatives && !options.parens_for_negatives) {
        if (options.negative_sign_after_digits) pattern += negative;
        else if (options.negative_sign_before_digits) pattern = negative + pattern;
    } // South African Rand, for example, uses R 123 (space) and R-123 (no space)
    if (options.allow_negative_sign_placeholder) pattern = "( (?!\\-))?".concat(pattern);
    else if (options.allow_space_after_symbol) pattern = " ?".concat(pattern);
    else if (options.allow_space_after_digits) pattern += '( (?!$))?';
    if (options.symbol_after_digits) pattern += symbol;
    else pattern = symbol + pattern;
    if (options.allow_negatives) {
        if (options.parens_for_negatives) pattern = "(\\(".concat(pattern, "\\)|").concat(pattern, ")");
        else if (!(options.negative_sign_before_digits || options.negative_sign_after_digits)) pattern = negative + pattern;
    } // ensure there's a dollar and/or decimal amount, and that
    // it doesn't start with a space or a negative sign followed by a space
    return new RegExp("^(?!-? )(?=.*\\d)".concat(pattern, "$"));
}
var $47b2c35952174662$var$default_currency_options = {
    symbol: '$',
    require_symbol: false,
    allow_space_after_symbol: false,
    symbol_after_digits: false,
    allow_negatives: true,
    parens_for_negatives: false,
    negative_sign_before_digits: false,
    negative_sign_after_digits: false,
    allow_negative_sign_placeholder: false,
    thousands_separator: ',',
    decimal_separator: '.',
    allow_decimal: true,
    require_decimal: false,
    digits_after_decimal: [
        2
    ],
    allow_space_after_digits: false
};
function $47b2c35952174662$var$isCurrency(str, options) {
    (0, $47b2c35952174662$var$_assertString.default)(str);
    options = (0, $47b2c35952174662$var$_merge.default)(options, $47b2c35952174662$var$default_currency_options);
    return $47b2c35952174662$var$currencyRegex(options).test(str);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("ilHLb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d5bc2200059d86b7$var$isBtcAddress;

var $d5bc2200059d86b7$var$_assertString = $d5bc2200059d86b7$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $d5bc2200059d86b7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// supports Bech32 addresses
var $d5bc2200059d86b7$var$bech32 = /^(bc1)[a-z0-9]{25,39}$/;
var $d5bc2200059d86b7$var$base58 = /^(1|3)[A-HJ-NP-Za-km-z1-9]{25,39}$/;
function $d5bc2200059d86b7$var$isBtcAddress(str) {
    (0, $d5bc2200059d86b7$var$_assertString.default)(str); // check for bech32
    if (str.startsWith('bc1')) return $d5bc2200059d86b7$var$bech32.test(str);
    return $d5bc2200059d86b7$var$base58.test(str);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("aWF3e", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7f7f2a0b9464276d$var$isISO8601;

var $7f7f2a0b9464276d$var$_assertString = $7f7f2a0b9464276d$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $7f7f2a0b9464276d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/* eslint-disable max-len */ // from http://goo.gl/0ejHHW
var $7f7f2a0b9464276d$var$iso8601 = /^([\+-]?\d{4}(?!\d{2}\b))((-?)((0[1-9]|1[0-2])(\3([12]\d|0[1-9]|3[01]))?|W([0-4]\d|5[0-3])(-?[1-7])?|(00[1-9]|0[1-9]\d|[12]\d{2}|3([0-5]\d|6[1-6])))([T\s]((([01]\d|2[0-3])((:?)[0-5]\d)?|24:?00)([\.,]\d+(?!:))?)?(\17[0-5]\d([\.,]\d+)?)?([zZ]|([\+-])([01]\d|2[0-3]):?([0-5]\d)?)?)?)?$/; // same as above, except with a strict 'T' separator between date and time
var $7f7f2a0b9464276d$var$iso8601StrictSeparator = /^([\+-]?\d{4}(?!\d{2}\b))((-?)((0[1-9]|1[0-2])(\3([12]\d|0[1-9]|3[01]))?|W([0-4]\d|5[0-3])(-?[1-7])?|(00[1-9]|0[1-9]\d|[12]\d{2}|3([0-5]\d|6[1-6])))([T]((([01]\d|2[0-3])((:?)[0-5]\d)?|24:?00)([\.,]\d+(?!:))?)?(\17[0-5]\d([\.,]\d+)?)?([zZ]|([\+-])([01]\d|2[0-3]):?([0-5]\d)?)?)?)?$/;
/* eslint-enable max-len */ var $7f7f2a0b9464276d$var$isValidDate = function isValidDate(str) {
    // str must have passed the ISO8601 check
    // this check is meant to catch invalid dates
    // like 2009-02-31
    // first check for ordinal dates
    var ordinalMatch = str.match(/^(\d{4})-?(\d{3})([ T]{1}\.*|$)/);
    if (ordinalMatch) {
        var oYear = Number(ordinalMatch[1]);
        var oDay = Number(ordinalMatch[2]); // if is leap year
        if (oYear % 4 === 0 && oYear % 100 !== 0 || oYear % 400 === 0) return oDay <= 366;
        return oDay <= 365;
    }
    var match = str.match(/(\d{4})-?(\d{0,2})-?(\d*)/).map(Number);
    var year = match[1];
    var month = match[2];
    var day = match[3];
    var monthString = month ? "0".concat(month).slice(-2) : month;
    var dayString = day ? "0".concat(day).slice(-2) : day; // create a date object and compare
    var d = new Date("".concat(year, "-").concat(monthString || '01', "-").concat(dayString || '01'));
    if (month && day) return d.getUTCFullYear() === year && d.getUTCMonth() + 1 === month && d.getUTCDate() === day;
    return true;
};
function $7f7f2a0b9464276d$var$isISO8601(str) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    (0, $7f7f2a0b9464276d$var$_assertString.default)(str);
    var check = options.strictSeparator ? $7f7f2a0b9464276d$var$iso8601StrictSeparator.test(str) : $7f7f2a0b9464276d$var$iso8601.test(str);
    if (check && options.strict) return $7f7f2a0b9464276d$var$isValidDate(str);
    return check;
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("36TYP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $243d5b20df38b9fe$var$isRFC3339;

var $243d5b20df38b9fe$var$_assertString = $243d5b20df38b9fe$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $243d5b20df38b9fe$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/* Based on https://tools.ietf.org/html/rfc3339#section-5.6 */ var $243d5b20df38b9fe$var$dateFullYear = /[0-9]{4}/;
var $243d5b20df38b9fe$var$dateMonth = /(0[1-9]|1[0-2])/;
var $243d5b20df38b9fe$var$dateMDay = /([12]\d|0[1-9]|3[01])/;
var $243d5b20df38b9fe$var$timeHour = /([01][0-9]|2[0-3])/;
var $243d5b20df38b9fe$var$timeMinute = /[0-5][0-9]/;
var $243d5b20df38b9fe$var$timeSecond = /([0-5][0-9]|60)/;
var $243d5b20df38b9fe$var$timeSecFrac = /(\.[0-9]+)?/;
var $243d5b20df38b9fe$var$timeNumOffset = new RegExp("[-+]".concat($243d5b20df38b9fe$var$timeHour.source, ":").concat($243d5b20df38b9fe$var$timeMinute.source));
var $243d5b20df38b9fe$var$timeOffset = new RegExp("([zZ]|".concat($243d5b20df38b9fe$var$timeNumOffset.source, ")"));
var $243d5b20df38b9fe$var$partialTime = new RegExp("".concat($243d5b20df38b9fe$var$timeHour.source, ":").concat($243d5b20df38b9fe$var$timeMinute.source, ":").concat($243d5b20df38b9fe$var$timeSecond.source).concat($243d5b20df38b9fe$var$timeSecFrac.source));
var $243d5b20df38b9fe$var$fullDate = new RegExp("".concat($243d5b20df38b9fe$var$dateFullYear.source, "-").concat($243d5b20df38b9fe$var$dateMonth.source, "-").concat($243d5b20df38b9fe$var$dateMDay.source));
var $243d5b20df38b9fe$var$fullTime = new RegExp("".concat($243d5b20df38b9fe$var$partialTime.source).concat($243d5b20df38b9fe$var$timeOffset.source));
var $243d5b20df38b9fe$var$rfc3339 = new RegExp("".concat($243d5b20df38b9fe$var$fullDate.source, "[ tT]").concat($243d5b20df38b9fe$var$fullTime.source));
function $243d5b20df38b9fe$var$isRFC3339(str) {
    (0, $243d5b20df38b9fe$var$_assertString.default)(str);
    return $243d5b20df38b9fe$var$rfc3339.test(str);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("lPnYX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $fe40f6c125f0e17f$var$isISO31661Alpha3;

var $fe40f6c125f0e17f$var$_assertString = $fe40f6c125f0e17f$var$_interopRequireDefault((parcelRequire("hZqWG")));

var $fe40f6c125f0e17f$var$_includes = $fe40f6c125f0e17f$var$_interopRequireDefault((parcelRequire("50PTo")));
function $fe40f6c125f0e17f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// from https://en.wikipedia.org/wiki/ISO_3166-1_alpha-3
var $fe40f6c125f0e17f$var$validISO31661Alpha3CountriesCodes = [
    'AFG',
    'ALA',
    'ALB',
    'DZA',
    'ASM',
    'AND',
    'AGO',
    'AIA',
    'ATA',
    'ATG',
    'ARG',
    'ARM',
    'ABW',
    'AUS',
    'AUT',
    'AZE',
    'BHS',
    'BHR',
    'BGD',
    'BRB',
    'BLR',
    'BEL',
    'BLZ',
    'BEN',
    'BMU',
    'BTN',
    'BOL',
    'BES',
    'BIH',
    'BWA',
    'BVT',
    'BRA',
    'IOT',
    'BRN',
    'BGR',
    'BFA',
    'BDI',
    'KHM',
    'CMR',
    'CAN',
    'CPV',
    'CYM',
    'CAF',
    'TCD',
    'CHL',
    'CHN',
    'CXR',
    'CCK',
    'COL',
    'COM',
    'COG',
    'COD',
    'COK',
    'CRI',
    'CIV',
    'HRV',
    'CUB',
    'CUW',
    'CYP',
    'CZE',
    'DNK',
    'DJI',
    'DMA',
    'DOM',
    'ECU',
    'EGY',
    'SLV',
    'GNQ',
    'ERI',
    'EST',
    'ETH',
    'FLK',
    'FRO',
    'FJI',
    'FIN',
    'FRA',
    'GUF',
    'PYF',
    'ATF',
    'GAB',
    'GMB',
    'GEO',
    'DEU',
    'GHA',
    'GIB',
    'GRC',
    'GRL',
    'GRD',
    'GLP',
    'GUM',
    'GTM',
    'GGY',
    'GIN',
    'GNB',
    'GUY',
    'HTI',
    'HMD',
    'VAT',
    'HND',
    'HKG',
    'HUN',
    'ISL',
    'IND',
    'IDN',
    'IRN',
    'IRQ',
    'IRL',
    'IMN',
    'ISR',
    'ITA',
    'JAM',
    'JPN',
    'JEY',
    'JOR',
    'KAZ',
    'KEN',
    'KIR',
    'PRK',
    'KOR',
    'KWT',
    'KGZ',
    'LAO',
    'LVA',
    'LBN',
    'LSO',
    'LBR',
    'LBY',
    'LIE',
    'LTU',
    'LUX',
    'MAC',
    'MKD',
    'MDG',
    'MWI',
    'MYS',
    'MDV',
    'MLI',
    'MLT',
    'MHL',
    'MTQ',
    'MRT',
    'MUS',
    'MYT',
    'MEX',
    'FSM',
    'MDA',
    'MCO',
    'MNG',
    'MNE',
    'MSR',
    'MAR',
    'MOZ',
    'MMR',
    'NAM',
    'NRU',
    'NPL',
    'NLD',
    'NCL',
    'NZL',
    'NIC',
    'NER',
    'NGA',
    'NIU',
    'NFK',
    'MNP',
    'NOR',
    'OMN',
    'PAK',
    'PLW',
    'PSE',
    'PAN',
    'PNG',
    'PRY',
    'PER',
    'PHL',
    'PCN',
    'POL',
    'PRT',
    'PRI',
    'QAT',
    'REU',
    'ROU',
    'RUS',
    'RWA',
    'BLM',
    'SHN',
    'KNA',
    'LCA',
    'MAF',
    'SPM',
    'VCT',
    'WSM',
    'SMR',
    'STP',
    'SAU',
    'SEN',
    'SRB',
    'SYC',
    'SLE',
    'SGP',
    'SXM',
    'SVK',
    'SVN',
    'SLB',
    'SOM',
    'ZAF',
    'SGS',
    'SSD',
    'ESP',
    'LKA',
    'SDN',
    'SUR',
    'SJM',
    'SWZ',
    'SWE',
    'CHE',
    'SYR',
    'TWN',
    'TJK',
    'TZA',
    'THA',
    'TLS',
    'TGO',
    'TKL',
    'TON',
    'TTO',
    'TUN',
    'TUR',
    'TKM',
    'TCA',
    'TUV',
    'UGA',
    'UKR',
    'ARE',
    'GBR',
    'USA',
    'UMI',
    'URY',
    'UZB',
    'VUT',
    'VEN',
    'VNM',
    'VGB',
    'VIR',
    'WLF',
    'ESH',
    'YEM',
    'ZMB',
    'ZWE'
];
function $fe40f6c125f0e17f$var$isISO31661Alpha3(str) {
    (0, $fe40f6c125f0e17f$var$_assertString.default)(str);
    return (0, $fe40f6c125f0e17f$var$_includes.default)($fe40f6c125f0e17f$var$validISO31661Alpha3CountriesCodes, str.toUpperCase());
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("e8aAF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a49a07144f7aa9af$var$isBase32;

var $a49a07144f7aa9af$var$_assertString = $a49a07144f7aa9af$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $a49a07144f7aa9af$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $a49a07144f7aa9af$var$base32 = /^[A-Z2-7]+=*$/;
function $a49a07144f7aa9af$var$isBase32(str) {
    (0, $a49a07144f7aa9af$var$_assertString.default)(str);
    var len = str.length;
    if (len % 8 === 0 && $a49a07144f7aa9af$var$base32.test(str)) return true;
    return false;
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("bgzme", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $021de18270a25cdd$var$isBase58;

var $021de18270a25cdd$var$_assertString = $021de18270a25cdd$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $021de18270a25cdd$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// Accepted chars - 123456789ABCDEFGH JKLMN PQRSTUVWXYZabcdefghijk mnopqrstuvwxyz
var $021de18270a25cdd$var$base58Reg = /^[A-HJ-NP-Za-km-z1-9]*$/;
function $021de18270a25cdd$var$isBase58(str) {
    (0, $021de18270a25cdd$var$_assertString.default)(str);
    if ($021de18270a25cdd$var$base58Reg.test(str)) return true;
    return false;
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("8REOh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6742edfa489dd2ed$var$isDataURI;

var $6742edfa489dd2ed$var$_assertString = $6742edfa489dd2ed$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $6742edfa489dd2ed$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $6742edfa489dd2ed$var$validMediaType = /^[a-z]+\/[a-z0-9\-\+]+$/i;
var $6742edfa489dd2ed$var$validAttribute = /^[a-z\-]+=[a-z0-9\-]+$/i;
var $6742edfa489dd2ed$var$validData = /^[a-z0-9!\$&'\(\)\*\+,;=\-\._~:@\/\?%\s]*$/i;
function $6742edfa489dd2ed$var$isDataURI(str) {
    (0, $6742edfa489dd2ed$var$_assertString.default)(str);
    var data = str.split(',');
    if (data.length < 2) return false;
    var attributes = data.shift().trim().split(';');
    var schemeAndMediaType = attributes.shift();
    if (schemeAndMediaType.substr(0, 5) !== 'data:') return false;
    var mediaType = schemeAndMediaType.substr(5);
    if (mediaType !== '' && !$6742edfa489dd2ed$var$validMediaType.test(mediaType)) return false;
    for(var i = 0; i < attributes.length; i++){
        if (!(i === attributes.length - 1 && attributes[i].toLowerCase() === 'base64') && !$6742edfa489dd2ed$var$validAttribute.test(attributes[i])) return false;
    }
    for(var _i = 0; _i < data.length; _i++){
        if (!$6742edfa489dd2ed$var$validData.test(data[_i])) return false;
    }
    return true;
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("ix1xQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d7dc81d17a256047$var$isMagnetURI;

var $d7dc81d17a256047$var$_assertString = $d7dc81d17a256047$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $d7dc81d17a256047$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $d7dc81d17a256047$var$magnetURI = /^magnet:\?xt=urn:[a-z0-9]+:[a-z0-9]{32,40}&dn=.+&tr=.+$/i;
function $d7dc81d17a256047$var$isMagnetURI(url) {
    (0, $d7dc81d17a256047$var$_assertString.default)(url);
    return $d7dc81d17a256047$var$magnetURI.test(url.trim());
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("ifxP4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d493dd330f4b6dfc$var$isMimeType;

var $d493dd330f4b6dfc$var$_assertString = $d493dd330f4b6dfc$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $d493dd330f4b6dfc$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/*
  Checks if the provided string matches to a correct Media type format (MIME type)

  This function only checks is the string format follows the
  etablished rules by the according RFC specifications.
  This function supports 'charset' in textual media types
  (https://tools.ietf.org/html/rfc6657).

  This function does not check against all the media types listed
  by the IANA (https://www.iana.org/assignments/media-types/media-types.xhtml)
  because of lightness purposes : it would require to include
  all these MIME types in this librairy, which would weigh it
  significantly. This kind of effort maybe is not worth for the use that
  this function has in this entire librairy.

  More informations in the RFC specifications :
  - https://tools.ietf.org/html/rfc2045
  - https://tools.ietf.org/html/rfc2046
  - https://tools.ietf.org/html/rfc7231#section-3.1.1.1
  - https://tools.ietf.org/html/rfc7231#section-3.1.1.5
*/ // Match simple MIME types
// NB :
//   Subtype length must not exceed 100 characters.
//   This rule does not comply to the RFC specs (what is the max length ?).
var $d493dd330f4b6dfc$var$mimeTypeSimple = /^(application|audio|font|image|message|model|multipart|text|video)\/[a-zA-Z0-9\.\-\+]{1,100}$/i; // eslint-disable-line max-len
// Handle "charset" in "text/*"
var $d493dd330f4b6dfc$var$mimeTypeText = /^text\/[a-zA-Z0-9\.\-\+]{1,100};\s?charset=("[a-zA-Z0-9\.\-\+\s]{0,70}"|[a-zA-Z0-9\.\-\+]{0,70})(\s?\([a-zA-Z0-9\.\-\+\s]{1,20}\))?$/i; // eslint-disable-line max-len
// Handle "boundary" in "multipart/*"
var $d493dd330f4b6dfc$var$mimeTypeMultipart = /^multipart\/[a-zA-Z0-9\.\-\+]{1,100}(;\s?(boundary|charset)=("[a-zA-Z0-9\.\-\+\s]{0,70}"|[a-zA-Z0-9\.\-\+]{0,70})(\s?\([a-zA-Z0-9\.\-\+\s]{1,20}\))?){0,2}$/i; // eslint-disable-line max-len
function $d493dd330f4b6dfc$var$isMimeType(str) {
    (0, $d493dd330f4b6dfc$var$_assertString.default)(str);
    return $d493dd330f4b6dfc$var$mimeTypeSimple.test(str) || $d493dd330f4b6dfc$var$mimeTypeText.test(str) || $d493dd330f4b6dfc$var$mimeTypeMultipart.test(str);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("hLP11", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $cefe66122bbf91f0$var$isLatLong;

var $cefe66122bbf91f0$var$_assertString = $cefe66122bbf91f0$var$_interopRequireDefault((parcelRequire("hZqWG")));

var $cefe66122bbf91f0$var$_merge = $cefe66122bbf91f0$var$_interopRequireDefault((parcelRequire("9nDkO")));
function $cefe66122bbf91f0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $cefe66122bbf91f0$var$lat = /^\(?[+-]?(90(\.0+)?|[1-8]?\d(\.\d+)?)$/;
var $cefe66122bbf91f0$var$long = /^\s?[+-]?(180(\.0+)?|1[0-7]\d(\.\d+)?|\d{1,2}(\.\d+)?)\)?$/;
var $cefe66122bbf91f0$var$latDMS = /^(([1-8]?\d)\D+([1-5]?\d|60)\D+([1-5]?\d|60)(\.\d+)?|90\D+0\D+0)\D+[NSns]?$/i;
var $cefe66122bbf91f0$var$longDMS = /^\s*([1-7]?\d{1,2}\D+([1-5]?\d|60)\D+([1-5]?\d|60)(\.\d+)?|180\D+0\D+0)\D+[EWew]?$/i;
var $cefe66122bbf91f0$var$defaultLatLongOptions = {
    checkDMS: false
};
function $cefe66122bbf91f0$var$isLatLong(str, options) {
    (0, $cefe66122bbf91f0$var$_assertString.default)(str);
    options = (0, $cefe66122bbf91f0$var$_merge.default)(options, $cefe66122bbf91f0$var$defaultLatLongOptions);
    if (!str.includes(',')) return false;
    var pair = str.split(',');
    if (pair[0].startsWith('(') && !pair[1].endsWith(')') || pair[1].endsWith(')') && !pair[0].startsWith('(')) return false;
    if (options.checkDMS) return $cefe66122bbf91f0$var$latDMS.test(pair[0]) && $cefe66122bbf91f0$var$longDMS.test(pair[1]);
    return $cefe66122bbf91f0$var$lat.test(pair[0]) && $cefe66122bbf91f0$var$long.test(pair[1]);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("7qOwX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5692286c0b9ed50a$var$isPostalCode;
module.exports.locales = void 0;

var $5692286c0b9ed50a$var$_assertString = $5692286c0b9ed50a$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $5692286c0b9ed50a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// common patterns
var $5692286c0b9ed50a$var$threeDigit = /^\d{3}$/;
var $5692286c0b9ed50a$var$fourDigit = /^\d{4}$/;
var $5692286c0b9ed50a$var$fiveDigit = /^\d{5}$/;
var $5692286c0b9ed50a$var$sixDigit = /^\d{6}$/;
var $5692286c0b9ed50a$var$patterns = {
    AD: /^AD\d{3}$/,
    AT: $5692286c0b9ed50a$var$fourDigit,
    AU: $5692286c0b9ed50a$var$fourDigit,
    AZ: /^AZ\d{4}$/,
    BE: $5692286c0b9ed50a$var$fourDigit,
    BG: $5692286c0b9ed50a$var$fourDigit,
    BR: /^\d{5}-\d{3}$/,
    BY: /2[1-4]{1}\d{4}$/,
    CA: /^[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][\s\-]?\d[ABCEGHJ-NPRSTV-Z]\d$/i,
    CH: $5692286c0b9ed50a$var$fourDigit,
    CN: /^(0[1-7]|1[012356]|2[0-7]|3[0-6]|4[0-7]|5[1-7]|6[1-7]|7[1-5]|8[1345]|9[09])\d{4}$/,
    CZ: /^\d{3}\s?\d{2}$/,
    DE: $5692286c0b9ed50a$var$fiveDigit,
    DK: $5692286c0b9ed50a$var$fourDigit,
    DO: $5692286c0b9ed50a$var$fiveDigit,
    DZ: $5692286c0b9ed50a$var$fiveDigit,
    EE: $5692286c0b9ed50a$var$fiveDigit,
    ES: /^(5[0-2]{1}|[0-4]{1}\d{1})\d{3}$/,
    FI: $5692286c0b9ed50a$var$fiveDigit,
    FR: /^\d{2}\s?\d{3}$/,
    GB: /^(gir\s?0aa|[a-z]{1,2}\d[\da-z]?\s?(\d[a-z]{2})?)$/i,
    GR: /^\d{3}\s?\d{2}$/,
    HR: /^([1-5]\d{4}$)/,
    HT: /^HT\d{4}$/,
    HU: $5692286c0b9ed50a$var$fourDigit,
    ID: $5692286c0b9ed50a$var$fiveDigit,
    IE: /^(?!.*(?:o))[A-Za-z]\d[\dw]\s\w{4}$/i,
    IL: /^(\d{5}|\d{7})$/,
    IN: /^((?!10|29|35|54|55|65|66|86|87|88|89)[1-9][0-9]{5})$/,
    IR: /\b(?!(\d)\1{3})[13-9]{4}[1346-9][013-9]{5}\b/,
    IS: $5692286c0b9ed50a$var$threeDigit,
    IT: $5692286c0b9ed50a$var$fiveDigit,
    JP: /^\d{3}\-\d{4}$/,
    KE: $5692286c0b9ed50a$var$fiveDigit,
    KR: /^(\d{5}|\d{6})$/,
    LI: /^(948[5-9]|949[0-7])$/,
    LT: /^LT\-\d{5}$/,
    LU: $5692286c0b9ed50a$var$fourDigit,
    LV: /^LV\-\d{4}$/,
    MX: $5692286c0b9ed50a$var$fiveDigit,
    MT: /^[A-Za-z]{3}\s{0,1}\d{4}$/,
    MY: $5692286c0b9ed50a$var$fiveDigit,
    NL: /^\d{4}\s?[a-z]{2}$/i,
    NO: $5692286c0b9ed50a$var$fourDigit,
    NP: /^(10|21|22|32|33|34|44|45|56|57)\d{3}$|^(977)$/i,
    NZ: $5692286c0b9ed50a$var$fourDigit,
    PL: /^\d{2}\-\d{3}$/,
    PR: /^00[679]\d{2}([ -]\d{4})?$/,
    PT: /^\d{4}\-\d{3}?$/,
    RO: $5692286c0b9ed50a$var$sixDigit,
    RU: $5692286c0b9ed50a$var$sixDigit,
    SA: $5692286c0b9ed50a$var$fiveDigit,
    SE: /^[1-9]\d{2}\s?\d{2}$/,
    SG: $5692286c0b9ed50a$var$sixDigit,
    SI: $5692286c0b9ed50a$var$fourDigit,
    SK: /^\d{3}\s?\d{2}$/,
    TH: $5692286c0b9ed50a$var$fiveDigit,
    TN: $5692286c0b9ed50a$var$fourDigit,
    TW: /^\d{3}(\d{2})?$/,
    UA: $5692286c0b9ed50a$var$fiveDigit,
    US: /^\d{5}(-\d{4})?$/,
    ZA: $5692286c0b9ed50a$var$fourDigit,
    ZM: $5692286c0b9ed50a$var$fiveDigit
};
var $5692286c0b9ed50a$var$locales = Object.keys($5692286c0b9ed50a$var$patterns);
module.exports.locales = $5692286c0b9ed50a$var$locales;
function $5692286c0b9ed50a$var$isPostalCode(str, locale) {
    (0, $5692286c0b9ed50a$var$_assertString.default)(str);
    if (locale in $5692286c0b9ed50a$var$patterns) return $5692286c0b9ed50a$var$patterns[locale].test(str);
    else if (locale === 'any') {
        for(var key in $5692286c0b9ed50a$var$patterns)// https://github.com/gotwarlost/istanbul/blob/master/ignoring-code-for-coverage.md#ignoring-code-for-coverage-purposes
        // istanbul ignore else
        if ($5692286c0b9ed50a$var$patterns.hasOwnProperty(key)) {
            var pattern = $5692286c0b9ed50a$var$patterns[key];
            if (pattern.test(str)) return true;
        }
        return false;
    }
    throw new Error("Invalid locale '".concat(locale, "'"));
}

});

parcelRegister("77DLn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $52f807f7ca36aa45$var$ltrim;

var $52f807f7ca36aa45$var$_assertString = $52f807f7ca36aa45$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $52f807f7ca36aa45$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $52f807f7ca36aa45$var$ltrim(str, chars) {
    (0, $52f807f7ca36aa45$var$_assertString.default)(str); // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions#Escaping
    var pattern = chars ? new RegExp("^[".concat(chars.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), "]+"), 'g') : /^\s+/g;
    return str.replace(pattern, '');
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("l0bpl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f4a272643984d26b$var$rtrim;

var $f4a272643984d26b$var$_assertString = $f4a272643984d26b$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $f4a272643984d26b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f4a272643984d26b$var$rtrim(str, chars) {
    (0, $f4a272643984d26b$var$_assertString.default)(str); // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions#Escaping
    var pattern = chars ? new RegExp("[".concat(chars.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), "]+$"), 'g') : /(\s)+$/g;
    return str.replace(pattern, '');
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("4wt0T", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $34b0a80b14e7b38f$var$trim;

var $34b0a80b14e7b38f$var$_rtrim = $34b0a80b14e7b38f$var$_interopRequireDefault((parcelRequire("l0bpl")));

var $34b0a80b14e7b38f$var$_ltrim = $34b0a80b14e7b38f$var$_interopRequireDefault((parcelRequire("77DLn")));
function $34b0a80b14e7b38f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $34b0a80b14e7b38f$var$trim(str, chars) {
    return (0, $34b0a80b14e7b38f$var$_rtrim.default)((0, $34b0a80b14e7b38f$var$_ltrim.default)(str, chars), chars);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("lhIbP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f7ed76b251dcd1fd$var$escape;

var $f7ed76b251dcd1fd$var$_assertString = $f7ed76b251dcd1fd$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $f7ed76b251dcd1fd$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f7ed76b251dcd1fd$var$escape(str) {
    (0, $f7ed76b251dcd1fd$var$_assertString.default)(str);
    return str.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#x27;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/\//g, '&#x2F;').replace(/\\/g, '&#x5C;').replace(/`/g, '&#96;');
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("Oufps", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $097c222895162552$var$unescape;

var $097c222895162552$var$_assertString = $097c222895162552$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $097c222895162552$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $097c222895162552$var$unescape(str) {
    (0, $097c222895162552$var$_assertString.default)(str);
    return str.replace(/&amp;/g, '&').replace(/&quot;/g, '"').replace(/&#x27;/g, "'").replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&#x2F;/g, '/').replace(/&#x5C;/g, '\\').replace(/&#96;/g, '`');
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("l68Ml", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f5c0f7cd3eb51c3e$var$stripLow;

var $f5c0f7cd3eb51c3e$var$_assertString = $f5c0f7cd3eb51c3e$var$_interopRequireDefault((parcelRequire("hZqWG")));

var $f5c0f7cd3eb51c3e$var$_blacklist = $f5c0f7cd3eb51c3e$var$_interopRequireDefault((parcelRequire("hVEzS")));
function $f5c0f7cd3eb51c3e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f5c0f7cd3eb51c3e$var$stripLow(str, keep_new_lines) {
    (0, $f5c0f7cd3eb51c3e$var$_assertString.default)(str);
    var chars = keep_new_lines ? '\\x00-\\x09\\x0B\\x0C\\x0E-\\x1F\\x7F' : '\\x00-\\x1F\\x7F';
    return (0, $f5c0f7cd3eb51c3e$var$_blacklist.default)(str, chars);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});
parcelRegister("hVEzS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d0d73c6d2b68ff07$var$blacklist;

var $d0d73c6d2b68ff07$var$_assertString = $d0d73c6d2b68ff07$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $d0d73c6d2b68ff07$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $d0d73c6d2b68ff07$var$blacklist(str, chars) {
    (0, $d0d73c6d2b68ff07$var$_assertString.default)(str);
    return str.replace(new RegExp("[".concat(chars, "]+"), 'g'), '');
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});


parcelRegister("d4jRJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $983b0ef670b4c2a7$var$whitelist;

var $983b0ef670b4c2a7$var$_assertString = $983b0ef670b4c2a7$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $983b0ef670b4c2a7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $983b0ef670b4c2a7$var$whitelist(str, chars) {
    (0, $983b0ef670b4c2a7$var$_assertString.default)(str);
    return str.replace(new RegExp("[^".concat(chars, "]+"), 'g'), '');
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("b8HgM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $81c2017f0aec10fa$var$isWhitelisted;

var $81c2017f0aec10fa$var$_assertString = $81c2017f0aec10fa$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $81c2017f0aec10fa$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $81c2017f0aec10fa$var$isWhitelisted(str, chars) {
    (0, $81c2017f0aec10fa$var$_assertString.default)(str);
    for(var i = str.length - 1; i >= 0; i--){
        if (chars.indexOf(str[i]) === -1) return false;
    }
    return true;
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("j002o", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $dd4e0bd9ef8f5472$var$normalizeEmail;

var $dd4e0bd9ef8f5472$var$_merge = $dd4e0bd9ef8f5472$var$_interopRequireDefault((parcelRequire("9nDkO")));
function $dd4e0bd9ef8f5472$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $dd4e0bd9ef8f5472$var$default_normalize_email_options = {
    // The following options apply to all email addresses
    // Lowercases the local part of the email address.
    // Please note this may violate RFC 5321 as per http://stackoverflow.com/a/9808332/192024).
    // The domain is always lowercased, as per RFC 1035
    all_lowercase: true,
    // The following conversions are specific to GMail
    // Lowercases the local part of the GMail address (known to be case-insensitive)
    gmail_lowercase: true,
    // Removes dots from the local part of the email address, as that's ignored by GMail
    gmail_remove_dots: true,
    // Removes the subaddress (e.g. "+foo") from the email address
    gmail_remove_subaddress: true,
    // Conversts the googlemail.com domain to gmail.com
    gmail_convert_googlemaildotcom: true,
    // The following conversions are specific to Outlook.com / Windows Live / Hotmail
    // Lowercases the local part of the Outlook.com address (known to be case-insensitive)
    outlookdotcom_lowercase: true,
    // Removes the subaddress (e.g. "+foo") from the email address
    outlookdotcom_remove_subaddress: true,
    // The following conversions are specific to Yahoo
    // Lowercases the local part of the Yahoo address (known to be case-insensitive)
    yahoo_lowercase: true,
    // Removes the subaddress (e.g. "-foo") from the email address
    yahoo_remove_subaddress: true,
    // The following conversions are specific to Yandex
    // Lowercases the local part of the Yandex address (known to be case-insensitive)
    yandex_lowercase: true,
    // The following conversions are specific to iCloud
    // Lowercases the local part of the iCloud address (known to be case-insensitive)
    icloud_lowercase: true,
    // Removes the subaddress (e.g. "+foo") from the email address
    icloud_remove_subaddress: true
}; // List of domains used by iCloud
var $dd4e0bd9ef8f5472$var$icloud_domains = [
    'icloud.com',
    'me.com'
]; // List of domains used by Outlook.com and its predecessors
// This list is likely incomplete.
// Partial reference:
// https://blogs.office.com/2013/04/17/outlook-com-gets-two-step-verification-sign-in-by-alias-and-new-international-domains/
var $dd4e0bd9ef8f5472$var$outlookdotcom_domains = [
    'hotmail.at',
    'hotmail.be',
    'hotmail.ca',
    'hotmail.cl',
    'hotmail.co.il',
    'hotmail.co.nz',
    'hotmail.co.th',
    'hotmail.co.uk',
    'hotmail.com',
    'hotmail.com.ar',
    'hotmail.com.au',
    'hotmail.com.br',
    'hotmail.com.gr',
    'hotmail.com.mx',
    'hotmail.com.pe',
    'hotmail.com.tr',
    'hotmail.com.vn',
    'hotmail.cz',
    'hotmail.de',
    'hotmail.dk',
    'hotmail.es',
    'hotmail.fr',
    'hotmail.hu',
    'hotmail.id',
    'hotmail.ie',
    'hotmail.in',
    'hotmail.it',
    'hotmail.jp',
    'hotmail.kr',
    'hotmail.lv',
    'hotmail.my',
    'hotmail.ph',
    'hotmail.pt',
    'hotmail.sa',
    'hotmail.sg',
    'hotmail.sk',
    'live.be',
    'live.co.uk',
    'live.com',
    'live.com.ar',
    'live.com.mx',
    'live.de',
    'live.es',
    'live.eu',
    'live.fr',
    'live.it',
    'live.nl',
    'msn.com',
    'outlook.at',
    'outlook.be',
    'outlook.cl',
    'outlook.co.il',
    'outlook.co.nz',
    'outlook.co.th',
    'outlook.com',
    'outlook.com.ar',
    'outlook.com.au',
    'outlook.com.br',
    'outlook.com.gr',
    'outlook.com.pe',
    'outlook.com.tr',
    'outlook.com.vn',
    'outlook.cz',
    'outlook.de',
    'outlook.dk',
    'outlook.es',
    'outlook.fr',
    'outlook.hu',
    'outlook.id',
    'outlook.ie',
    'outlook.in',
    'outlook.it',
    'outlook.jp',
    'outlook.kr',
    'outlook.lv',
    'outlook.my',
    'outlook.ph',
    'outlook.pt',
    'outlook.sa',
    'outlook.sg',
    'outlook.sk',
    'passport.com'
]; // List of domains used by Yahoo Mail
// This list is likely incomplete
var $dd4e0bd9ef8f5472$var$yahoo_domains = [
    'rocketmail.com',
    'yahoo.ca',
    'yahoo.co.uk',
    'yahoo.com',
    'yahoo.de',
    'yahoo.fr',
    'yahoo.in',
    'yahoo.it',
    'ymail.com'
]; // List of domains used by yandex.ru
var $dd4e0bd9ef8f5472$var$yandex_domains = [
    'yandex.ru',
    'yandex.ua',
    'yandex.kz',
    'yandex.com',
    'yandex.by',
    'ya.ru'
]; // replace single dots, but not multiple consecutive dots
function $dd4e0bd9ef8f5472$var$dotsReplacer(match) {
    if (match.length > 1) return match;
    return '';
}
function $dd4e0bd9ef8f5472$var$normalizeEmail(email, options) {
    options = (0, $dd4e0bd9ef8f5472$var$_merge.default)(options, $dd4e0bd9ef8f5472$var$default_normalize_email_options);
    var raw_parts = email.split('@');
    var domain = raw_parts.pop();
    var user = raw_parts.join('@');
    var parts = [
        user,
        domain
    ]; // The domain is always lowercased, as it's case-insensitive per RFC 1035
    parts[1] = parts[1].toLowerCase();
    if (parts[1] === 'gmail.com' || parts[1] === 'googlemail.com') {
        // Address is GMail
        if (options.gmail_remove_subaddress) parts[0] = parts[0].split('+')[0];
        if (options.gmail_remove_dots) // this does not replace consecutive dots like example..email@gmail.com
        parts[0] = parts[0].replace(/\.+/g, $dd4e0bd9ef8f5472$var$dotsReplacer);
        if (!parts[0].length) return false;
        if (options.all_lowercase || options.gmail_lowercase) parts[0] = parts[0].toLowerCase();
        parts[1] = options.gmail_convert_googlemaildotcom ? 'gmail.com' : parts[1];
    } else if ($dd4e0bd9ef8f5472$var$icloud_domains.indexOf(parts[1]) >= 0) {
        // Address is iCloud
        if (options.icloud_remove_subaddress) parts[0] = parts[0].split('+')[0];
        if (!parts[0].length) return false;
        if (options.all_lowercase || options.icloud_lowercase) parts[0] = parts[0].toLowerCase();
    } else if ($dd4e0bd9ef8f5472$var$outlookdotcom_domains.indexOf(parts[1]) >= 0) {
        // Address is Outlook.com
        if (options.outlookdotcom_remove_subaddress) parts[0] = parts[0].split('+')[0];
        if (!parts[0].length) return false;
        if (options.all_lowercase || options.outlookdotcom_lowercase) parts[0] = parts[0].toLowerCase();
    } else if ($dd4e0bd9ef8f5472$var$yahoo_domains.indexOf(parts[1]) >= 0) {
        // Address is Yahoo
        if (options.yahoo_remove_subaddress) {
            var components = parts[0].split('-');
            parts[0] = components.length > 1 ? components.slice(0, -1).join('-') : components[0];
        }
        if (!parts[0].length) return false;
        if (options.all_lowercase || options.yahoo_lowercase) parts[0] = parts[0].toLowerCase();
    } else if ($dd4e0bd9ef8f5472$var$yandex_domains.indexOf(parts[1]) >= 0) {
        if (options.all_lowercase || options.yandex_lowercase) parts[0] = parts[0].toLowerCase();
        parts[1] = 'yandex.ru'; // all yandex domains are equal, 1st preferred
    } else if (options.all_lowercase) // Any other address
    parts[0] = parts[0].toLowerCase();
    return parts.join('@');
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("dtWXT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9d0bb90990bd8b34$var$isSlug;

var $9d0bb90990bd8b34$var$_assertString = $9d0bb90990bd8b34$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $9d0bb90990bd8b34$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $9d0bb90990bd8b34$var$charsetRegex = /^[^\s-_](?!.*?[-_]{2,})[a-z0-9-\\][^\s]*[^-_\s]$/;
function $9d0bb90990bd8b34$var$isSlug(str) {
    (0, $9d0bb90990bd8b34$var$_assertString.default)(str);
    return $9d0bb90990bd8b34$var$charsetRegex.test(str);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("4fo1o", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $317b324b592a2f03$var$isLicensePlate;

var $317b324b592a2f03$var$_assertString = $317b324b592a2f03$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $317b324b592a2f03$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $317b324b592a2f03$var$validators = {
    'de-DE': function deDE(str) {
        return /^((AW|UL|AK|GA|AÖ|LF|AZ|AM|AS|ZE|AN|AB|A|KG|KH|BA|EW|BZ|HY|KM|BT|HP|B|BC|BI|BO|FN|TT|ÜB|BN|AH|BS|FR|HB|ZZ|BB|BK|BÖ|OC|OK|CW|CE|C|CO|LH|CB|KW|LC|LN|DA|DI|DE|DH|SY|NÖ|DO|DD|DU|DN|D|EI|EA|EE|FI|EM|EL|EN|PF|ED|EF|ER|AU|ZP|E|ES|NT|EU|FL|FO|FT|FF|F|FS|FD|FÜ|GE|G|GI|GF|GS|ZR|GG|GP|GR|NY|ZI|GÖ|GZ|GT|HA|HH|HM|HU|WL|HZ|WR|RN|HK|HD|HN|HS|GK|HE|HF|RZ|HI|HG|HO|HX|IK|IL|IN|J|JL|KL|KA|KS|KF|KE|KI|KT|KO|KN|KR|KC|KU|K|LD|LL|LA|L|OP|LM|LI|LB|LU|LÖ|HL|LG|MD|GN|MZ|MA|ML|MR|MY|AT|DM|MC|NZ|RM|RG|MM|ME|MB|MI|FG|DL|HC|MW|RL|MK|MG|MÜ|WS|MH|M|MS|NU|NB|ND|NM|NK|NW|NR|NI|NF|DZ|EB|OZ|TG|TO|N|OA|GM|OB|CA|EH|FW|OF|OL|OE|OG|BH|LR|OS|AA|GD|OH|KY|NP|WK|PB|PA|PE|PI|PS|P|PM|PR|RA|RV|RE|R|H|SB|WN|RS|RD|RT|BM|NE|GV|RP|SU|GL|RO|GÜ|RH|EG|RW|PN|SK|MQ|RU|SZ|RI|SL|SM|SC|HR|FZ|VS|SW|SN|CR|SE|SI|SO|LP|SG|NH|SP|IZ|ST|BF|TE|HV|OD|SR|S|AC|DW|ZW|TF|TS|TR|TÜ|UM|PZ|TP|UE|UN|UH|MN|KK|VB|V|AE|PL|RC|VG|GW|PW|VR|VK|KB|WA|WT|BE|WM|WE|AP|MO|WW|FB|WZ|WI|WB|JE|WF|WO|W|WÜ|BL|Z|GC)[- ]?[A-Z]{1,2}[- ]?\d{1,4}|(AIC|FDB|ABG|SLN|SAW|KLZ|BUL|ESB|NAB|SUL|WST|ABI|AZE|BTF|KÖT|DKB|FEU|ROT|ALZ|SMÜ|WER|AUR|NOR|DÜW|BRK|HAB|TÖL|WOR|BAD|BAR|BER|BIW|EBS|KEM|MÜB|PEG|BGL|BGD|REI|WIL|BKS|BIR|WAT|BOR|BOH|BOT|BRB|BLK|HHM|NEB|NMB|WSF|LEO|HDL|WMS|WZL|BÜS|CHA|KÖZ|ROD|WÜM|CLP|NEC|COC|ZEL|COE|CUX|DAH|LDS|DEG|DEL|RSL|DLG|DGF|LAN|HEI|MED|DON|KIB|ROK|JÜL|MON|SLE|EBE|EIC|HIG|WBS|BIT|PRÜ|LIB|EMD|WIT|ERH|HÖS|ERZ|ANA|ASZ|MAB|MEK|STL|SZB|FDS|HCH|HOR|WOL|FRG|GRA|WOS|FRI|FFB|GAP|GER|BRL|CLZ|GTH|NOH|HGW|GRZ|LÖB|NOL|WSW|DUD|HMÜ|OHA|KRU|HAL|HAM|HBS|QLB|HVL|NAU|HAS|EBN|GEO|HOH|HDH|ERK|HER|WAN|HEF|ROF|HBN|ALF|HSK|USI|NAI|REH|SAN|KÜN|ÖHR|HOL|WAR|ARN|BRG|GNT|HOG|WOH|KEH|MAI|PAR|RID|ROL|KLE|GEL|KUS|KYF|ART|SDH|LDK|DIL|MAL|VIB|LER|BNA|GHA|GRM|MTL|WUR|LEV|LIF|STE|WEL|LIP|VAI|LUP|HGN|LBZ|LWL|PCH|STB|DAN|MKK|SLÜ|MSP|TBB|MGH|MTK|BIN|MSH|EIL|HET|SGH|BID|MYK|MSE|MST|MÜR|WRN|MEI|GRH|RIE|MZG|MIL|OBB|BED|FLÖ|MOL|FRW|SEE|SRB|AIB|MOS|BCH|ILL|SOB|NMS|NEA|SEF|UFF|NEW|VOH|NDH|TDO|NWM|GDB|GVM|WIS|NOM|EIN|GAN|LAU|HEB|OHV|OSL|SFB|ERB|LOS|BSK|KEL|BSB|MEL|WTL|OAL|FÜS|MOD|OHZ|OPR|BÜR|PAF|PLÖ|CAS|GLA|REG|VIT|ECK|SIM|GOA|EMS|DIZ|GOH|RÜD|SWA|NES|KÖN|MET|LRO|BÜZ|DBR|ROS|TET|HRO|ROW|BRV|HIP|PAN|GRI|SHK|EIS|SRO|SOK|LBS|SCZ|MER|QFT|SLF|SLS|HOM|SLK|ASL|BBG|SBK|SFT|SHG|MGN|MEG|ZIG|SAD|NEN|OVI|SHA|BLB|SIG|SON|SPN|FOR|GUB|SPB|IGB|WND|STD|STA|SDL|OBG|HST|BOG|SHL|PIR|FTL|SEB|SÖM|SÜW|TIR|SAB|TUT|ANG|SDT|LÜN|LSZ|MHL|VEC|VER|VIE|OVL|ANK|OVP|SBG|UEM|UER|WLG|GMN|NVP|RDG|RÜG|DAU|FKB|WAF|WAK|SLZ|WEN|SOG|APD|WUG|GUN|ESW|WIZ|WES|DIN|BRA|BÜD|WHV|HWI|GHC|WTM|WOB|WUN|MAK|SEL|OCH|HOT|WDA)[- ]?(([A-Z][- ]?\d{1,4})|([A-Z]{2}[- ]?\d{1,3})))[- ]?(E|H)?$/.test(str);
    },
    'de-LI': function deLI(str) {
        return /^FL[- ]?\d{1,5}[UZ]?$/.test(str);
    },
    'pt-PT': function ptPT(str) {
        return /^([A-Z]{2}|[0-9]{2})[ -·]?([A-Z]{2}|[0-9]{2})[ -·]?([A-Z]{2}|[0-9]{2})$/.test(str);
    },
    'sq-AL': function sqAL(str) {
        return /^[A-Z]{2}[- ]?((\d{3}[- ]?(([A-Z]{2})|T))|(R[- ]?\d{3}))$/.test(str);
    },
    'pt-BR': function ptBR(str) {
        return /^[A-Z]{3}[ -]?[0-9][A-Z][0-9]{2}|[A-Z]{3}[ -]?[0-9]{4}$/.test(str);
    }
};
function $317b324b592a2f03$var$isLicensePlate(str, locale) {
    (0, $317b324b592a2f03$var$_assertString.default)(str);
    if (locale in $317b324b592a2f03$var$validators) return $317b324b592a2f03$var$validators[locale](str);
    else if (locale === 'any') {
        for(var key in $317b324b592a2f03$var$validators){
            /* eslint guard-for-in: 0 */ var validator = $317b324b592a2f03$var$validators[key];
            if (validator(str)) return true;
        }
        return false;
    }
    throw new Error("Invalid locale '".concat(locale, "'"));
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("9wP8Z", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6efec65f0adfb8f9$var$isStrongPassword;

var $6efec65f0adfb8f9$var$_merge = $6efec65f0adfb8f9$var$_interopRequireDefault((parcelRequire("9nDkO")));

var $6efec65f0adfb8f9$var$_assertString = $6efec65f0adfb8f9$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $6efec65f0adfb8f9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $6efec65f0adfb8f9$var$upperCaseRegex = /^[A-Z]$/;
var $6efec65f0adfb8f9$var$lowerCaseRegex = /^[a-z]$/;
var $6efec65f0adfb8f9$var$numberRegex = /^[0-9]$/;
var $6efec65f0adfb8f9$var$symbolRegex = /^[-#!$@%^&*()_+|~=`{}\[\]:";'<>?,.\/ ]$/;
var $6efec65f0adfb8f9$var$defaultOptions = {
    minLength: 8,
    minLowercase: 1,
    minUppercase: 1,
    minNumbers: 1,
    minSymbols: 1,
    returnScore: false,
    pointsPerUnique: 1,
    pointsPerRepeat: 0.5,
    pointsForContainingLower: 10,
    pointsForContainingUpper: 10,
    pointsForContainingNumber: 10,
    pointsForContainingSymbol: 10
};
/* Counts number of occurrences of each char in a string
 * could be moved to util/ ?
*/ function $6efec65f0adfb8f9$var$countChars(str) {
    var result = {};
    Array.from(str).forEach(function(char) {
        var curVal = result[char];
        if (curVal) result[char] += 1;
        else result[char] = 1;
    });
    return result;
}
/* Return information about a password */ function $6efec65f0adfb8f9$var$analyzePassword(password) {
    var charMap = $6efec65f0adfb8f9$var$countChars(password);
    var analysis = {
        length: password.length,
        uniqueChars: Object.keys(charMap).length,
        uppercaseCount: 0,
        lowercaseCount: 0,
        numberCount: 0,
        symbolCount: 0
    };
    Object.keys(charMap).forEach(function(char) {
        /* istanbul ignore else */ if ($6efec65f0adfb8f9$var$upperCaseRegex.test(char)) analysis.uppercaseCount += charMap[char];
        else if ($6efec65f0adfb8f9$var$lowerCaseRegex.test(char)) analysis.lowercaseCount += charMap[char];
        else if ($6efec65f0adfb8f9$var$numberRegex.test(char)) analysis.numberCount += charMap[char];
        else if ($6efec65f0adfb8f9$var$symbolRegex.test(char)) analysis.symbolCount += charMap[char];
    });
    return analysis;
}
function $6efec65f0adfb8f9$var$scorePassword(analysis, scoringOptions) {
    var points = 0;
    points += analysis.uniqueChars * scoringOptions.pointsPerUnique;
    points += (analysis.length - analysis.uniqueChars) * scoringOptions.pointsPerRepeat;
    if (analysis.lowercaseCount > 0) points += scoringOptions.pointsForContainingLower;
    if (analysis.uppercaseCount > 0) points += scoringOptions.pointsForContainingUpper;
    if (analysis.numberCount > 0) points += scoringOptions.pointsForContainingNumber;
    if (analysis.symbolCount > 0) points += scoringOptions.pointsForContainingSymbol;
    return points;
}
function $6efec65f0adfb8f9$var$isStrongPassword(str) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    (0, $6efec65f0adfb8f9$var$_assertString.default)(str);
    var analysis = $6efec65f0adfb8f9$var$analyzePassword(str);
    options = (0, $6efec65f0adfb8f9$var$_merge.default)(options || {}, $6efec65f0adfb8f9$var$defaultOptions);
    if (options.returnScore) return $6efec65f0adfb8f9$var$scorePassword(analysis, options);
    return analysis.length >= options.minLength && analysis.lowercaseCount >= options.minLowercase && analysis.uppercaseCount >= options.minUppercase && analysis.numberCount >= options.minNumbers && analysis.symbolCount >= options.minSymbols;
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("394HB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $24a5dc2863b9a16a$var$isVAT;
module.exports.vatMatchers = void 0;

var $24a5dc2863b9a16a$var$_assertString = $24a5dc2863b9a16a$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $24a5dc2863b9a16a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $24a5dc2863b9a16a$var$vatMatchers = {
    GB: /^GB((\d{3} \d{4} ([0-8][0-9]|9[0-6]))|(\d{9} \d{3})|(((GD[0-4])|(HA[5-9]))[0-9]{2}))$/,
    IT: /^(IT)?[0-9]{11}$/
};
module.exports.vatMatchers = $24a5dc2863b9a16a$var$vatMatchers;
function $24a5dc2863b9a16a$var$isVAT(str, countryCode) {
    (0, $24a5dc2863b9a16a$var$_assertString.default)(str);
    (0, $24a5dc2863b9a16a$var$_assertString.default)(countryCode);
    if (countryCode in $24a5dc2863b9a16a$var$vatMatchers) return $24a5dc2863b9a16a$var$vatMatchers[countryCode].test(str);
    throw new Error("Invalid country code: '".concat(countryCode, "'"));
}

});



parcelRegister("k3ko8", function(module, exports) {

$parcel$export(module.exports, "parsePhoneNumberFromString", () => $e993e727eec22084$export$9c5cae3d55d8e910);

var $1c9lJ = parcelRequire("1c9lJ");

var $gAr6H = parcelRequire("gAr6H");
function $e993e727eec22084$export$9c5cae3d55d8e910() {
    return (0, $1c9lJ.withMetadata)((0, $gAr6H.default), arguments);
}

});
parcelRegister("1c9lJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0dee2a11cd7413e4$export$2e2bcd8739ae039);
$parcel$export(module.exports, "withMetadata", () => $0dee2a11cd7413e4$export$164451d7043c1432);
// Importing from `.json.js` a workaround for a bug in web browsers' "native"
// ES6 importing system which is uncapable of importing "*.json" files.
// https://github.com/catamphetamine/libphonenumber-js/issues/239

var $4fWe9 = parcelRequire("4fWe9");
var $0dee2a11cd7413e4$export$2e2bcd8739ae039 = (0, $4fWe9.default);
function $0dee2a11cd7413e4$export$164451d7043c1432(func, _arguments) {
    var args = Array.prototype.slice.call(_arguments);
    args.push((0, $4fWe9.default));
    return func.apply(this, args);
}

});
parcelRegister("4fWe9", function(module, exports) {

$parcel$export(module.exports, "default", () => $3195bad5b20c0860$export$2e2bcd8739ae039);
// This file is a workaround for a bug in web browsers' "native"
// ES6 importing system which is uncapable of importing "*.json" files.
// https://github.com/catamphetamine/libphonenumber-js/issues/239
var $3195bad5b20c0860$export$2e2bcd8739ae039 = {
    "version": 4,
    "country_calling_codes": {
        "1": [
            "US",
            "AG",
            "AI",
            "AS",
            "BB",
            "BM",
            "BS",
            "CA",
            "DM",
            "DO",
            "GD",
            "GU",
            "JM",
            "KN",
            "KY",
            "LC",
            "MP",
            "MS",
            "PR",
            "SX",
            "TC",
            "TT",
            "VC",
            "VG",
            "VI"
        ],
        "7": [
            "RU",
            "KZ"
        ],
        "20": [
            "EG"
        ],
        "27": [
            "ZA"
        ],
        "30": [
            "GR"
        ],
        "31": [
            "NL"
        ],
        "32": [
            "BE"
        ],
        "33": [
            "FR"
        ],
        "34": [
            "ES"
        ],
        "36": [
            "HU"
        ],
        "39": [
            "IT",
            "VA"
        ],
        "40": [
            "RO"
        ],
        "41": [
            "CH"
        ],
        "43": [
            "AT"
        ],
        "44": [
            "GB",
            "GG",
            "IM",
            "JE"
        ],
        "45": [
            "DK"
        ],
        "46": [
            "SE"
        ],
        "47": [
            "NO",
            "SJ"
        ],
        "48": [
            "PL"
        ],
        "49": [
            "DE"
        ],
        "51": [
            "PE"
        ],
        "52": [
            "MX"
        ],
        "53": [
            "CU"
        ],
        "54": [
            "AR"
        ],
        "55": [
            "BR"
        ],
        "56": [
            "CL"
        ],
        "57": [
            "CO"
        ],
        "58": [
            "VE"
        ],
        "60": [
            "MY"
        ],
        "61": [
            "AU",
            "CC",
            "CX"
        ],
        "62": [
            "ID"
        ],
        "63": [
            "PH"
        ],
        "64": [
            "NZ"
        ],
        "65": [
            "SG"
        ],
        "66": [
            "TH"
        ],
        "81": [
            "JP"
        ],
        "82": [
            "KR"
        ],
        "84": [
            "VN"
        ],
        "86": [
            "CN"
        ],
        "90": [
            "TR"
        ],
        "91": [
            "IN"
        ],
        "92": [
            "PK"
        ],
        "93": [
            "AF"
        ],
        "94": [
            "LK"
        ],
        "95": [
            "MM"
        ],
        "98": [
            "IR"
        ],
        "211": [
            "SS"
        ],
        "212": [
            "MA",
            "EH"
        ],
        "213": [
            "DZ"
        ],
        "216": [
            "TN"
        ],
        "218": [
            "LY"
        ],
        "220": [
            "GM"
        ],
        "221": [
            "SN"
        ],
        "222": [
            "MR"
        ],
        "223": [
            "ML"
        ],
        "224": [
            "GN"
        ],
        "225": [
            "CI"
        ],
        "226": [
            "BF"
        ],
        "227": [
            "NE"
        ],
        "228": [
            "TG"
        ],
        "229": [
            "BJ"
        ],
        "230": [
            "MU"
        ],
        "231": [
            "LR"
        ],
        "232": [
            "SL"
        ],
        "233": [
            "GH"
        ],
        "234": [
            "NG"
        ],
        "235": [
            "TD"
        ],
        "236": [
            "CF"
        ],
        "237": [
            "CM"
        ],
        "238": [
            "CV"
        ],
        "239": [
            "ST"
        ],
        "240": [
            "GQ"
        ],
        "241": [
            "GA"
        ],
        "242": [
            "CG"
        ],
        "243": [
            "CD"
        ],
        "244": [
            "AO"
        ],
        "245": [
            "GW"
        ],
        "246": [
            "IO"
        ],
        "247": [
            "AC"
        ],
        "248": [
            "SC"
        ],
        "249": [
            "SD"
        ],
        "250": [
            "RW"
        ],
        "251": [
            "ET"
        ],
        "252": [
            "SO"
        ],
        "253": [
            "DJ"
        ],
        "254": [
            "KE"
        ],
        "255": [
            "TZ"
        ],
        "256": [
            "UG"
        ],
        "257": [
            "BI"
        ],
        "258": [
            "MZ"
        ],
        "260": [
            "ZM"
        ],
        "261": [
            "MG"
        ],
        "262": [
            "RE",
            "YT"
        ],
        "263": [
            "ZW"
        ],
        "264": [
            "NA"
        ],
        "265": [
            "MW"
        ],
        "266": [
            "LS"
        ],
        "267": [
            "BW"
        ],
        "268": [
            "SZ"
        ],
        "269": [
            "KM"
        ],
        "290": [
            "SH",
            "TA"
        ],
        "291": [
            "ER"
        ],
        "297": [
            "AW"
        ],
        "298": [
            "FO"
        ],
        "299": [
            "GL"
        ],
        "350": [
            "GI"
        ],
        "351": [
            "PT"
        ],
        "352": [
            "LU"
        ],
        "353": [
            "IE"
        ],
        "354": [
            "IS"
        ],
        "355": [
            "AL"
        ],
        "356": [
            "MT"
        ],
        "357": [
            "CY"
        ],
        "358": [
            "FI",
            "AX"
        ],
        "359": [
            "BG"
        ],
        "370": [
            "LT"
        ],
        "371": [
            "LV"
        ],
        "372": [
            "EE"
        ],
        "373": [
            "MD"
        ],
        "374": [
            "AM"
        ],
        "375": [
            "BY"
        ],
        "376": [
            "AD"
        ],
        "377": [
            "MC"
        ],
        "378": [
            "SM"
        ],
        "380": [
            "UA"
        ],
        "381": [
            "RS"
        ],
        "382": [
            "ME"
        ],
        "383": [
            "XK"
        ],
        "385": [
            "HR"
        ],
        "386": [
            "SI"
        ],
        "387": [
            "BA"
        ],
        "389": [
            "MK"
        ],
        "420": [
            "CZ"
        ],
        "421": [
            "SK"
        ],
        "423": [
            "LI"
        ],
        "500": [
            "FK"
        ],
        "501": [
            "BZ"
        ],
        "502": [
            "GT"
        ],
        "503": [
            "SV"
        ],
        "504": [
            "HN"
        ],
        "505": [
            "NI"
        ],
        "506": [
            "CR"
        ],
        "507": [
            "PA"
        ],
        "508": [
            "PM"
        ],
        "509": [
            "HT"
        ],
        "590": [
            "GP",
            "BL",
            "MF"
        ],
        "591": [
            "BO"
        ],
        "592": [
            "GY"
        ],
        "593": [
            "EC"
        ],
        "594": [
            "GF"
        ],
        "595": [
            "PY"
        ],
        "596": [
            "MQ"
        ],
        "597": [
            "SR"
        ],
        "598": [
            "UY"
        ],
        "599": [
            "CW",
            "BQ"
        ],
        "670": [
            "TL"
        ],
        "672": [
            "NF"
        ],
        "673": [
            "BN"
        ],
        "674": [
            "NR"
        ],
        "675": [
            "PG"
        ],
        "676": [
            "TO"
        ],
        "677": [
            "SB"
        ],
        "678": [
            "VU"
        ],
        "679": [
            "FJ"
        ],
        "680": [
            "PW"
        ],
        "681": [
            "WF"
        ],
        "682": [
            "CK"
        ],
        "683": [
            "NU"
        ],
        "685": [
            "WS"
        ],
        "686": [
            "KI"
        ],
        "687": [
            "NC"
        ],
        "688": [
            "TV"
        ],
        "689": [
            "PF"
        ],
        "690": [
            "TK"
        ],
        "691": [
            "FM"
        ],
        "692": [
            "MH"
        ],
        "850": [
            "KP"
        ],
        "852": [
            "HK"
        ],
        "853": [
            "MO"
        ],
        "855": [
            "KH"
        ],
        "856": [
            "LA"
        ],
        "880": [
            "BD"
        ],
        "886": [
            "TW"
        ],
        "960": [
            "MV"
        ],
        "961": [
            "LB"
        ],
        "962": [
            "JO"
        ],
        "963": [
            "SY"
        ],
        "964": [
            "IQ"
        ],
        "965": [
            "KW"
        ],
        "966": [
            "SA"
        ],
        "967": [
            "YE"
        ],
        "968": [
            "OM"
        ],
        "970": [
            "PS"
        ],
        "971": [
            "AE"
        ],
        "972": [
            "IL"
        ],
        "973": [
            "BH"
        ],
        "974": [
            "QA"
        ],
        "975": [
            "BT"
        ],
        "976": [
            "MN"
        ],
        "977": [
            "NP"
        ],
        "992": [
            "TJ"
        ],
        "993": [
            "TM"
        ],
        "994": [
            "AZ"
        ],
        "995": [
            "GE"
        ],
        "996": [
            "KG"
        ],
        "998": [
            "UZ"
        ]
    },
    "countries": {
        "AC": [
            "247",
            "00",
            "(?:[01589]\\d|[46])\\d{4}",
            [
                5,
                6
            ]
        ],
        "AD": [
            "376",
            "00",
            "(?:1|6\\d)\\d{7}|[135-9]\\d{5}",
            [
                6,
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "[135-9]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6"
                    ]
                ]
            ]
        ],
        "AE": [
            "971",
            "00",
            "(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{2,9})",
                    "$1 $2",
                    [
                        "60|8"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[236]|[479][2-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{5})",
                    "$1 $2 $3",
                    [
                        "[479]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "AF": [
            "93",
            "00",
            "[2-7]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-7]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "AG": [
            "1",
            "011",
            "(?:268|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "1|([457]\\d{6})$",
            "268$1",
            0,
            "268"
        ],
        "AI": [
            "1",
            "011",
            "(?:264|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "1|([2457]\\d{6})$",
            "264$1",
            0,
            "264"
        ],
        "AL": [
            "355",
            "00",
            "(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}",
            [
                6,
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3,4})",
                    "$1 $2",
                    [
                        "80|9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "4[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2358][2-5]|4"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[23578]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "6"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "AM": [
            "374",
            "00",
            "(?:[1-489]\\d|55|60|77)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[89]0"
                    ],
                    "0 $1"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "2|3[12]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "1|47"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[3-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "AO": [
            "244",
            "00",
            "[29]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[29]"
                    ]
                ]
            ]
        ],
        "AR": [
            "54",
            "00",
            "(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}",
            [
                10,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{2})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])",
                        "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)",
                        "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
                        "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "1"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[68]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "[23]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d)(\\d{4})(\\d{2})(\\d{4})",
                    "$2 15-$3-$4",
                    [
                        "9(?:2[2-469]|3[3-578])",
                        "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))",
                        "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)",
                        "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
                        "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3-$4"
                ],
                [
                    "(\\d)(\\d{2})(\\d{4})(\\d{4})",
                    "$2 15-$3-$4",
                    [
                        "91"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3-$4"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{5})",
                    "$1-$2-$3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{4})",
                    "$2 15-$3-$4",
                    [
                        "9"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3-$4"
                ]
            ],
            "0",
            0,
            "0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?",
            "9$1"
        ],
        "AS": [
            "1",
            "011",
            "(?:[58]\\d\\d|684|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "1|([267]\\d{6})$",
            "684$1",
            0,
            "684"
        ],
        "AT": [
            "43",
            "00",
            "1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}",
            [
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d)(\\d{3,12})",
                    "$1 $2",
                    [
                        "1(?:11|[2-9])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})",
                    "$1 $2",
                    [
                        "517"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,5})",
                    "$1 $2",
                    [
                        "5[079]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,10})",
                    "$1 $2",
                    [
                        "(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3,9})",
                    "$1 $2",
                    [
                        "[2-467]|5[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4,7})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "AU": [
            "61",
            "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
            "1(?:[0-79]\\d{7,8}|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}",
            [
                5,
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3,4})",
                    "$1 $2",
                    [
                        "16"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2,4})",
                    "$1 $2 $3",
                    [
                        "16"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "14|4"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2378]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1(?:30|[89])"
                    ]
                ]
            ],
            "0",
            0,
            "0|(183[12])",
            0,
            0,
            0,
            [
                [
                    "(?:(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|3(?:[0-3589]\\d|4[0-578]|6[1-9]|7[0-35-9])|7(?:[013-57-9]\\d|2[0-8]))\\d{3}|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4]))|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}",
                    [
                        9
                    ]
                ],
                [
                    "4(?:83[0-38]|93[0-4])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[06-9]|7[02-9]|8[0-24-9]|9[0-27-9])\\d{6}",
                    [
                        9
                    ]
                ],
                [
                    "180(?:0\\d{3}|2)\\d{3}",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "190[0-26]\\d{6}",
                    [
                        10
                    ]
                ],
                0,
                0,
                0,
                [
                    "163\\d{2,6}",
                    [
                        5,
                        6,
                        7,
                        8,
                        9
                    ]
                ],
                [
                    "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",
                    [
                        9
                    ]
                ],
                [
                    "13(?:00\\d{3}|45[0-4])\\d{3}|13\\d{4}",
                    [
                        6,
                        8,
                        10
                    ]
                ]
            ],
            "0011"
        ],
        "AW": [
            "297",
            "00",
            "(?:[25-79]\\d\\d|800)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[25-9]"
                    ]
                ]
            ]
        ],
        "AX": [
            "358",
            "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))",
            "2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            "18",
            0,
            "00"
        ],
        "AZ": [
            "994",
            "00",
            "365\\d{6}|(?:[124579]\\d|60|88)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "90"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "1[28]|2|365|46",
                        "1[28]|2|365|46",
                        "1[28]|2|365(?:[0-46-9]|5[0-35-9])|46"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[13-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "BA": [
            "387",
            "00",
            "6\\d{8}|(?:[35689]\\d|49|70)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6[1-3]|[7-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2-$3",
                    [
                        "[3-5]|6[56]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "6"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "BB": [
            "1",
            "011",
            "(?:246|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "1|([2-9]\\d{6})$",
            "246$1",
            0,
            "246"
        ],
        "BD": [
            "880",
            "00",
            "1\\d{9}|2\\d{7,8}|88\\d{4,6}|(?:8[0-79]|9\\d)\\d{4,8}|(?:[346]\\d|[57])\\d{5,8}",
            [
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{4,6})",
                    "$1-$2",
                    [
                        "31[5-8]|[459]1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,7})",
                    "$1-$2",
                    [
                        "3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:28|4[14]|5)|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3,6})",
                    "$1-$2",
                    [
                        "[13-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{7,8})",
                    "$1-$2",
                    [
                        "2"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "BE": [
            "32",
            "00",
            "4\\d{8}|[1-9]\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "(?:80|9)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[239]|4[23]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[15-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "4"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "BF": [
            "226",
            "00",
            "[025-7]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[025-7]"
                    ]
                ]
            ]
        ],
        "BG": [
            "359",
            "00",
            "[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}",
            [
                6,
                7,
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d)(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "43[1-6]|70[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "(?:70|8)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "43[1-7]|7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[48]|9[08]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "BH": [
            "973",
            "00",
            "[136-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[13679]|8[047]"
                    ]
                ]
            ]
        ],
        "BI": [
            "257",
            "00",
            "(?:[267]\\d|31)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2367]"
                    ]
                ]
            ]
        ],
        "BJ": [
            "229",
            "00",
            "[25689]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[25689]"
                    ]
                ]
            ]
        ],
        "BL": [
            "590",
            "00",
            "(?:590|(?:69|80)\\d|976)\\d{6}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "590(?:2[7-9]|5[12]|87)\\d{4}"
                ],
                [
                    "69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"
                ],
                [
                    "80[0-5]\\d{6}"
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "976[01]\\d{5}"
                ]
            ]
        ],
        "BM": [
            "1",
            "011",
            "(?:441|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "1|([2-8]\\d{6})$",
            "441$1",
            0,
            "441"
        ],
        "BN": [
            "673",
            "00",
            "[2-578]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-578]"
                    ]
                ]
            ]
        ],
        "BO": [
            "591",
            "00(?:1\\d)?",
            "(?:[2-467]\\d\\d|8001)\\d{5}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "[23]|4[46]"
                    ]
                ],
                [
                    "(\\d{8})",
                    "$1",
                    [
                        "[67]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ],
            "0",
            0,
            "0(1\\d)?"
        ],
        "BQ": [
            "599",
            "00",
            "(?:[34]1|7\\d)\\d{5}",
            [
                7
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "[347]"
        ],
        "BR": [
            "55",
            "00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)",
            "(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-24679]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}",
            [
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "300|4(?:0[02]|37)",
                        "4(?:02|37)0|[34]00"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2,3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "(?:[358]|90)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{2})(\\d{5})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "[16][1-9]|[2-57-9]"
                    ],
                    "($1)"
                ]
            ],
            "0",
            0,
            "(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?",
            "$2"
        ],
        "BS": [
            "1",
            "011",
            "(?:242|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "1|([3-8]\\d{6})$",
            "242$1",
            0,
            "242"
        ],
        "BT": [
            "975",
            "00",
            "[17]\\d{7}|[2-8]\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-68]|7[246]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "1[67]|7"
                    ]
                ]
            ]
        ],
        "BW": [
            "267",
            "00",
            "(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}",
            [
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "90"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[24-6]|3[15-79]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[37]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "BY": [
            "375",
            "810",
            "(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}",
            [
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "800"
                    ],
                    "8 $1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,4})",
                    "$1 $2 $3",
                    [
                        "800"
                    ],
                    "8 $1"
                ],
                [
                    "(\\d{4})(\\d{2})(\\d{3})",
                    "$1 $2-$3",
                    [
                        "1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])",
                        "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"
                    ],
                    "8 0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "1(?:[56]|7[467])|2[1-3]"
                    ],
                    "8 0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "[1-4]"
                    ],
                    "8 0$1"
                ],
                [
                    "(\\d{3})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "8 $1"
                ]
            ],
            "8",
            0,
            "0|80?",
            0,
            0,
            0,
            0,
            "8~10"
        ],
        "BZ": [
            "501",
            "00",
            "(?:0800\\d|[2-8])\\d{6}",
            [
                7,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[2-8]"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})(\\d{3})",
                    "$1-$2-$3-$4",
                    [
                        "0"
                    ]
                ]
            ]
        ],
        "CA": [
            "1",
            "011",
            "(?:[2-8]\\d|90)\\d{8}",
            [
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:2(?:04|[23]6|[48]9|50)|3(?:06|43|6[578])|4(?:03|1[68]|3[178]|50|74)|5(?:06|1[49]|48|79|8[17])|6(?:04|13|39|47|72)|7(?:0[59]|78|8[02])|8(?:[06]7|19|25|73)|90[25])[2-9]\\d{6}"
                ],
                [
                    ""
                ],
                [
                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"
                ],
                [
                    "900[2-9]\\d{6}"
                ],
                [
                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:00|2[12]|33|44|66|77|88)|622)[2-9]\\d{6}"
                ],
                0,
                0,
                0,
                [
                    "600[2-9]\\d{6}"
                ]
            ]
        ],
        "CC": [
            "61",
            "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
            "1(?:[0-79]\\d|8[0-24-9])\\d{7}|[148]\\d{8}|1\\d{5,7}",
            [
                6,
                7,
                8,
                9,
                10
            ],
            0,
            "0",
            0,
            "0|([59]\\d{7})$",
            "8$1",
            0,
            0,
            [
                [
                    "8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}",
                    [
                        9
                    ]
                ],
                [
                    "4(?:83[0-38]|93[0-4])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[06-9]|7[02-9]|8[0-24-9]|9[0-27-9])\\d{6}",
                    [
                        9
                    ]
                ],
                [
                    "180(?:0\\d{3}|2)\\d{3}",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "190[0-26]\\d{6}",
                    [
                        10
                    ]
                ],
                0,
                0,
                0,
                0,
                [
                    "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",
                    [
                        9
                    ]
                ],
                [
                    "13(?:00\\d{3}|45[0-4])\\d{3}|13\\d{4}",
                    [
                        6,
                        8,
                        10
                    ]
                ]
            ],
            "0011"
        ],
        "CD": [
            "243",
            "00",
            "[189]\\d{8}|[1-68]\\d{6}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "88"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "[1-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "CF": [
            "236",
            "00",
            "(?:[27]\\d{3}|8776)\\d{4}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[278]"
                    ]
                ]
            ]
        ],
        "CG": [
            "242",
            "00",
            "222\\d{6}|(?:0\\d|80)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "801"
                    ]
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[02]"
                    ]
                ]
            ]
        ],
        "CH": [
            "41",
            "00",
            "8\\d{11}|[2-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8[047]|90"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-79]|81"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "CI": [
            "225",
            "00",
            "[02]\\d{9}",
            [
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d)(\\d{5})",
                    "$1 $2 $3 $4",
                    [
                        "2"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ]
            ]
        ],
        "CK": [
            "682",
            "00",
            "[2-578]\\d{4}",
            [
                5
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1 $2",
                    [
                        "[2-578]"
                    ]
                ]
            ]
        ],
        "CL": [
            "56",
            "(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0",
            "12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}",
            [
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{5})(\\d{4})",
                    "$1 $2",
                    [
                        "219",
                        "2196"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "44"
                    ]
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2[1-3]"
                    ],
                    "($1)"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9[2-9]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "60|8"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "60"
                    ]
                ]
            ]
        ],
        "CM": [
            "237",
            "00",
            "[26]\\d{8}|88\\d{6,7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "88"
                    ]
                ],
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "[26]|88"
                    ]
                ]
            ]
        ],
        "CN": [
            "86",
            "00|1(?:[12]\\d|79)\\d\\d00",
            "1[127]\\d{8,9}|2\\d{9}(?:\\d{2})?|[12]\\d{6,7}|86\\d{6}|(?:1[03-689]\\d|6)\\d{7,9}|(?:[3-579]\\d|8[0-57-9])\\d{6,9}",
            [
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{5,6})",
                    "$1 $2",
                    [
                        "(?:10|2[0-57-9])[19]",
                        "(?:10|2[0-57-9])(?:10|9[56])",
                        "(?:10|2[0-57-9])(?:100|9[56])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5,6})",
                    "$1 $2",
                    [
                        "3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]",
                        "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]",
                        "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])",
                        "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "(?:4|80)0"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "10|2(?:[02-57-9]|1[1-9])",
                        "10|2(?:[02-57-9]|1[1-9])",
                        "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{7,8})",
                    "$1 $2",
                    [
                        "9"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "80"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[3-578]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1[3-9]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "[12]"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0",
            0,
            "0|(1(?:[12]\\d|79)\\d\\d)",
            0,
            0,
            0,
            0,
            "00"
        ],
        "CO": [
            "57",
            "00(?:4(?:[14]4|56)|[579])",
            "(?:(?:1\\d|[36])\\d{3}|9101)\\d{6}|[124-8]\\d{7}",
            [
                8,
                10,
                11
            ],
            [
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "[146][2-9]|[2578]"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "6"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "[39]"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{7})",
                    "$1-$2-$3",
                    [
                        "1"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ]
            ],
            "0",
            0,
            "0([3579]|4(?:[14]4|56))?"
        ],
        "CR": [
            "506",
            "00",
            "(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}",
            [
                8,
                10
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-7]|8[3-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[89]"
                    ]
                ]
            ],
            0,
            0,
            "(19(?:0[0-2468]|1[09]|20|66|77|99))"
        ],
        "CU": [
            "53",
            "119",
            "[27]\\d{6,7}|[34]\\d{5,7}|(?:5|8\\d\\d)\\d{7}",
            [
                6,
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{4,6})",
                    "$1 $2",
                    [
                        "2[1-4]|[34]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{6,7})",
                    "$1 $2",
                    [
                        "7"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "5"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "CV": [
            "238",
            "0",
            "(?:[2-59]\\d\\d|800)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[2-589]"
                    ]
                ]
            ]
        ],
        "CW": [
            "599",
            "00",
            "(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[3467]"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9[4-8]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            "[69]"
        ],
        "CX": [
            "61",
            "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
            "1(?:[0-79]\\d|8[0-24-9])\\d{7}|[148]\\d{8}|1\\d{5,7}",
            [
                6,
                7,
                8,
                9,
                10
            ],
            0,
            "0",
            0,
            "0|([59]\\d{7})$",
            "8$1",
            0,
            0,
            [
                [
                    "8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}",
                    [
                        9
                    ]
                ],
                [
                    "4(?:83[0-38]|93[0-4])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[06-9]|7[02-9]|8[0-24-9]|9[0-27-9])\\d{6}",
                    [
                        9
                    ]
                ],
                [
                    "180(?:0\\d{3}|2)\\d{3}",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "190[0-26]\\d{6}",
                    [
                        10
                    ]
                ],
                0,
                0,
                0,
                0,
                [
                    "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",
                    [
                        9
                    ]
                ],
                [
                    "13(?:00\\d{3}|45[0-4])\\d{3}|13\\d{4}",
                    [
                        6,
                        8,
                        10
                    ]
                ]
            ],
            "0011"
        ],
        "CY": [
            "357",
            "00",
            "(?:[279]\\d|[58]0)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[257-9]"
                    ]
                ]
            ]
        ],
        "CZ": [
            "420",
            "00",
            "(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-8]|9[015-7]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ]
                ]
            ]
        ],
        "DE": [
            "49",
            "00",
            "[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:[12]\\d|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[05]\\d|31|[46][1-8])\\d{1,9}",
            [
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12,
                13,
                14,
                15
            ],
            [
                [
                    "(\\d{2})(\\d{3,13})",
                    "$1 $2",
                    [
                        "3[02]|40|[68]9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,12})",
                    "$1 $2",
                    [
                        "2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1",
                        "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{2,11})",
                    "$1 $2",
                    [
                        "[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]",
                        "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "138"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{2,10})",
                    "$1 $2",
                    [
                        "3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5,11})",
                    "$1 $2",
                    [
                        "181"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{4,10})",
                    "$1 $2 $3",
                    [
                        "1(?:3|80)|9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7,8})",
                    "$1 $2",
                    [
                        "1[67]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7,12})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{6})",
                    "$1 $2",
                    [
                        "185",
                        "1850",
                        "18500"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{7})",
                    "$1 $2",
                    [
                        "18[68]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{6})",
                    "$1 $2",
                    [
                        "15[0568]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{7})",
                    "$1 $2",
                    [
                        "15[1279]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{8})",
                    "$1 $2",
                    [
                        "18"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{7,8})",
                    "$1 $2 $3",
                    [
                        "1(?:6[023]|7)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{2})(\\d{7})",
                    "$1 $2 $3",
                    [
                        "15[279]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{8})",
                    "$1 $2 $3",
                    [
                        "15"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "DJ": [
            "253",
            "00",
            "(?:2\\d|77)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[27]"
                    ]
                ]
            ]
        ],
        "DK": [
            "45",
            "00",
            "[2-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-9]"
                    ]
                ]
            ]
        ],
        "DM": [
            "1",
            "011",
            "(?:[58]\\d\\d|767|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "1|([2-7]\\d{6})$",
            "767$1",
            0,
            "767"
        ],
        "DO": [
            "1",
            "011",
            "(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            "8001|8[024]9"
        ],
        "DZ": [
            "213",
            "00",
            "(?:[1-4]|[5-79]\\d|80)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[1-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-8]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "EC": [
            "593",
            "00",
            "1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}",
            [
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "[2-7]"
                    ],
                    "(0$1)",
                    0,
                    "$1-$2-$3"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        "EE": [
            "372",
            "00",
            "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}",
            [
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88",
                        "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3,4})",
                    "$1 $2",
                    [
                        "[45]|8(?:00|[1-49])",
                        "[45]|8(?:00[1-9]|[1-49])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "EG": [
            "20",
            "00",
            "[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{7,8})",
                    "$1 $2",
                    [
                        "[23]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{6,7})",
                    "$1 $2",
                    [
                        "1[35]|[4-6]|8[2468]|9[235-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[189]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "EH": [
            "212",
            "00",
            "[5-8]\\d{8}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            "528[89]"
        ],
        "ER": [
            "291",
            "00",
            "[178]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[178]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ES": [
            "34",
            "00",
            "[5-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[89]00"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-9]"
                    ]
                ]
            ]
        ],
        "ET": [
            "251",
            "00",
            "(?:11|[2-59]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-59]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "FI": [
            "358",
            "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))",
            "[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d)(\\d{4,9})",
                    "$1 $2",
                    [
                        "[2568][1-8]|3(?:0[1-9]|[1-9])|9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,7})",
                    "$1 $2",
                    [
                        "[12]00|[368]|70[07-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4,8})",
                    "$1 $2",
                    [
                        "[1245]|7[135]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{6,10})",
                    "$1 $2",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            "1[03-79]|[2-9]",
            0,
            "00"
        ],
        "FJ": [
            "679",
            "0(?:0|52)",
            "45\\d{5}|(?:0800\\d|[235-9])\\d{6}",
            [
                7,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[235-9]|45"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "FK": [
            "500",
            "00",
            "[2-7]\\d{4}",
            [
                5
            ]
        ],
        "FM": [
            "691",
            "00",
            "(?:[39]\\d\\d|820)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[389]"
                    ]
                ]
            ]
        ],
        "FO": [
            "298",
            "00",
            "[2-9]\\d{5}",
            [
                6
            ],
            [
                [
                    "(\\d{6})",
                    "$1",
                    [
                        "[2-9]"
                    ]
                ]
            ],
            0,
            0,
            "(10(?:01|[12]0|88))"
        ],
        "FR": [
            "33",
            "00",
            "[1-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0 $1"
                ],
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "[1-79]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "GA": [
            "241",
            "00",
            "(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "11|[67]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ]
            ],
            0,
            0,
            "0(11\\d{6}|6[256]\\d{6}|7[47]\\d{6})",
            "$1"
        ],
        "GB": [
            "44",
            "00",
            "[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}",
            [
                7,
                9,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "800",
                        "8001",
                        "80011",
                        "800111",
                        "8001111"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "845",
                        "8454",
                        "84546",
                        "845464"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "800"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{4,5})",
                    "$1 $2",
                    [
                        "1(?:38|5[23]|69|76|94)",
                        "1(?:(?:38|69)7|5(?:24|39)|768|946)",
                        "1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5,6})",
                    "$1 $2",
                    [
                        "1(?:[2-69][02-9]|[78])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[25]|7(?:0|6[02-9])",
                        "[25]|7(?:0|6(?:[03-9]|2[356]))"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1389]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0235])|4(?:[0-5]\\d\\d|69[7-9]|70[0359])|(?:5[0-26-9]|[78][0-49])\\d\\d|6(?:[0-4]\\d\\d|50[02459]))|2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d\\d|1(?:[0-7]\\d\\d|8(?:[02]\\d|1[0-278])))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}",
                    [
                        9,
                        10
                    ]
                ],
                [
                    "7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "80[08]\\d{7}|800\\d{6}|8001111"
                ],
                [
                    "(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "70\\d{8}",
                    [
                        10
                    ]
                ],
                0,
                [
                    "(?:3[0347]|55)\\d{8}",
                    [
                        10
                    ]
                ],
                [
                    "76(?:464|652)\\d{5}|76(?:0[0-2]|2[356]|34|4[01347]|5[49]|6[0-369]|77|81|9[139])\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "56\\d{8}",
                    [
                        10
                    ]
                ]
            ],
            0,
            " x"
        ],
        "GD": [
            "1",
            "011",
            "(?:473|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "1|([2-9]\\d{6})$",
            "473$1",
            0,
            "473"
        ],
        "GE": [
            "995",
            "00",
            "(?:[3-57]\\d\\d|800)\\d{6}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "70"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "32"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[57]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[348]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "GF": [
            "594",
            "00",
            "(?:[56]94|80\\d|976)\\d{6}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[569]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "GG": [
            "44",
            "00",
            "(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?",
            [
                7,
                9,
                10
            ],
            0,
            "0",
            0,
            "0|([25-9]\\d{5})$",
            "1481$1",
            0,
            0,
            [
                [
                    "1481[25-9]\\d{5}",
                    [
                        10
                    ]
                ],
                [
                    "7(?:(?:781|839)\\d|911[17])\\d{5}",
                    [
                        10
                    ]
                ],
                [
                    "80[08]\\d{7}|800\\d{6}|8001111"
                ],
                [
                    "(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "70\\d{8}",
                    [
                        10
                    ]
                ],
                0,
                [
                    "(?:3[0347]|55)\\d{8}",
                    [
                        10
                    ]
                ],
                [
                    "76(?:464|652)\\d{5}|76(?:0[0-2]|2[356]|34|4[01347]|5[49]|6[0-369]|77|81|9[139])\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "56\\d{8}",
                    [
                        10
                    ]
                ]
            ]
        ],
        "GH": [
            "233",
            "00",
            "(?:[235]\\d{3}|800)\\d{5}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[235]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "GI": [
            "350",
            "00",
            "(?:[25]\\d\\d|606)\\d{5}",
            [
                8
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "2"
                    ]
                ]
            ]
        ],
        "GL": [
            "299",
            "00",
            "(?:19|[2-689]\\d|70)\\d{4}",
            [
                6
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "19|[2-9]"
                    ]
                ]
            ]
        ],
        "GM": [
            "220",
            "00",
            "[2-9]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-9]"
                    ]
                ]
            ]
        ],
        "GN": [
            "224",
            "00",
            "722\\d{6}|(?:3|6\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "3"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[67]"
                    ]
                ]
            ]
        ],
        "GP": [
            "590",
            "00",
            "(?:590|(?:69|80)\\d|976)\\d{6}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[569]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "590(?:0[1-68]|1[0-2]|2[0-68]|3[1289]|4[0-24-9]|5[3-579]|6[0189]|7[08]|8[0-689]|9\\d)\\d{4}"
                ],
                [
                    "69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"
                ],
                [
                    "80[0-5]\\d{6}"
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "976[01]\\d{5}"
                ]
            ]
        ],
        "GQ": [
            "240",
            "00",
            "222\\d{6}|(?:3\\d|55|[89]0)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[235]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "[89]"
                    ]
                ]
            ]
        ],
        "GR": [
            "30",
            "00",
            "5005000\\d{3}|8\\d{9,10}|(?:[269]\\d|70)\\d{8}",
            [
                10,
                11
            ],
            [
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "21|7"
                    ]
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2689]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "GT": [
            "502",
            "00",
            "(?:1\\d{3}|[2-7])\\d{7}",
            [
                8,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-7]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ]
        ],
        "GU": [
            "1",
            "011",
            "(?:[58]\\d\\d|671|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "1|([3-9]\\d{6})$",
            "671$1",
            0,
            "671"
        ],
        "GW": [
            "245",
            "00",
            "[49]\\d{8}|4\\d{6}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "40"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[49]"
                    ]
                ]
            ]
        ],
        "GY": [
            "592",
            "001",
            "(?:862\\d|9008)\\d{3}|(?:[2-46]\\d|77)\\d{5}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-46-9]"
                    ]
                ]
            ]
        ],
        "HK": [
            "852",
            "00(?:30|5[09]|[126-9]?)",
            "8[0-46-9]\\d{6,7}|9\\d{4}(?:\\d(?:\\d(?:\\d{4})?)?)?|(?:[235-79]\\d|46)\\d{6}",
            [
                5,
                6,
                7,
                8,
                9,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{2,5})",
                    "$1 $2",
                    [
                        "900",
                        "9003"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "HN": [
            "504",
            "00",
            "8\\d{10}|[237-9]\\d{7}",
            [
                8,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "[237-9]"
                    ]
                ]
            ]
        ],
        "HR": [
            "385",
            "00",
            "(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}",
            [
                6,
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "6[01]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[67]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-5]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "HT": [
            "509",
            "00",
            "[2-489]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-489]"
                    ]
                ]
            ]
        ],
        "HU": [
            "36",
            "00",
            "[235-7]\\d{8}|[1-9]\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "(06 $1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"
                    ],
                    "(06 $1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-9]"
                    ],
                    "06 $1"
                ]
            ],
            "06"
        ],
        "ID": [
            "62",
            "00[89]",
            "(?:(?:00[1-9]|8\\d)\\d{4}|[1-36])\\d{6}|00\\d{10}|[1-9]\\d{8,10}|[2-9]\\d{7}",
            [
                7,
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "15"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5,9})",
                    "$1 $2",
                    [
                        "2[124]|[36]1"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{5,7})",
                    "$1 $2",
                    [
                        "800"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5,8})",
                    "$1 $2",
                    [
                        "[2-79]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3,4})(\\d{3})",
                    "$1-$2-$3",
                    [
                        "8[1-35-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6,8})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "804"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "80"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4,5})",
                    "$1-$2-$3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "IE": [
            "353",
            "00",
            "(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}",
            [
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "2[24-9]|47|58|6[237-9]|9[35-9]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[45]0"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2569]|4[1-69]|7[14]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "70"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "81"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[78]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "4"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "IL": [
            "972",
            "0(?:0|1[2-9])",
            "1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}",
            [
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{4})(\\d{3})",
                    "$1-$2",
                    [
                        "125"
                    ]
                ],
                [
                    "(\\d{4})(\\d{2})(\\d{2})",
                    "$1-$2-$3",
                    [
                        "121"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[2-489]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[57]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1-$2-$3",
                    [
                        "12"
                    ]
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1-$2",
                    [
                        "159"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{3})",
                    "$1-$2-$3-$4",
                    [
                        "1[7-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})",
                    "$1-$2 $3-$4",
                    [
                        "15"
                    ]
                ]
            ],
            "0"
        ],
        "IM": [
            "44",
            "00",
            "1624\\d{6}|(?:[3578]\\d|90)\\d{8}",
            [
                10
            ],
            0,
            "0",
            0,
            "0|([25-8]\\d{5})$",
            "1624$1",
            0,
            "74576|(?:16|7[56])24"
        ],
        "IN": [
            "91",
            "00",
            "(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}",
            [
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d{8})",
                    "$1",
                    [
                        "5(?:0|2[23]|3[03]|[67]1|88)",
                        "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)",
                        "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{4})(\\d{4,5})",
                    "$1 $2",
                    [
                        "180",
                        "1800"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "140"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "11|2[02]|33|4[04]|79[1-7]|80[2-46]",
                        "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])",
                        "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]",
                        "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]",
                        "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807",
                        "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]",
                        "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{5})(\\d{5})",
                    "$1 $2",
                    [
                        "[6-9]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{4})(\\d{2,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1(?:6|8[06])",
                        "1(?:6|8[06]0)"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "18"
                    ],
                    0,
                    1
                ]
            ],
            "0"
        ],
        "IO": [
            "246",
            "00",
            "3\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "3"
                    ]
                ]
            ]
        ],
        "IQ": [
            "964",
            "00",
            "(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "IR": [
            "98",
            "00",
            "[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}",
            [
                4,
                5,
                6,
                7,
                10
            ],
            [
                [
                    "(\\d{4,5})",
                    "$1",
                    [
                        "96"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4,5})",
                    "$1 $2",
                    [
                        "(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-8]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "IS": [
            "354",
            "00|1(?:0(?:01|[12]0)|100)",
            "(?:38\\d|[4-9])\\d{6}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[4-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "3"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "IT": [
            "39",
            "00",
            "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}",
            [
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{2})(\\d{4,6})",
                    "$1 $2",
                    [
                        "0[26]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3,6})",
                    "$1 $2",
                    [
                        "0[13-57-9][0159]|8(?:03|4[17]|9[245])",
                        "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|[45][0-4]))"
                    ]
                ],
                [
                    "(\\d{4})(\\d{2,6})",
                    "$1 $2",
                    [
                        "0(?:[13-579][2-46-8]|8[236-8])"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "894"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0[26]|5"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "1[4679]|[38]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0[13-57-9][0159]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "0[26]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4,5})",
                    "$1 $2 $3",
                    [
                        "3"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}"
                ],
                [
                    "3[1-9]\\d{8}|3[2-9]\\d{7}",
                    [
                        9,
                        10
                    ]
                ],
                [
                    "80(?:0\\d{3}|3)\\d{3}",
                    [
                        6,
                        9
                    ]
                ],
                [
                    "(?:0878\\d\\d|89(?:2|4[5-9]\\d))\\d{3}|89[45][0-4]\\d\\d|(?:1(?:44|6[346])|89(?:5[5-9]|9))\\d{6}",
                    [
                        6,
                        8,
                        9,
                        10
                    ]
                ],
                [
                    "1(?:78\\d|99)\\d{6}",
                    [
                        9,
                        10
                    ]
                ],
                0,
                0,
                0,
                [
                    "55\\d{8}",
                    [
                        10
                    ]
                ],
                [
                    "84(?:[08]\\d{3}|[17])\\d{3}",
                    [
                        6,
                        9
                    ]
                ]
            ]
        ],
        "JE": [
            "44",
            "00",
            "1534\\d{6}|(?:[3578]\\d|90)\\d{8}",
            [
                10
            ],
            0,
            "0",
            0,
            "0|([0-24-8]\\d{5})$",
            "1534$1",
            0,
            0,
            [
                [
                    "1534[0-24-8]\\d{5}"
                ],
                [
                    "7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97[7-9]))\\d{5}"
                ],
                [
                    "80(?:07(?:35|81)|8901)\\d{4}"
                ],
                [
                    "(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}"
                ],
                [
                    "701511\\d{4}"
                ],
                0,
                [
                    "(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}"
                ],
                [
                    "76(?:464|652)\\d{5}|76(?:0[0-2]|2[356]|34|4[01347]|5[49]|6[0-369]|77|81|9[139])\\d{6}"
                ],
                [
                    "56\\d{8}"
                ]
            ]
        ],
        "JM": [
            "1",
            "011",
            "(?:[58]\\d\\d|658|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            "658|876"
        ],
        "JO": [
            "962",
            "00",
            "(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2356]|87"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{5,6})",
                    "$1 $2",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "70"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "JP": [
            "81",
            "010",
            "00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}",
            [
                8,
                9,
                10,
                11,
                12,
                13,
                14,
                15,
                16,
                17
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1-$2-$3",
                    [
                        "(?:12|57|99)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d)(\\d{4})",
                    "$1-$2-$3",
                    [
                        "1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51|63)|9(?:49|80|9[16])",
                        "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9]|636)|9(?:496|802|9(?:1[23]|69))|1(?:45|58)[67]",
                        "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9]|636[457-9])|9(?:496|802|9(?:1[23]|69))|1(?:45|58)[67]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "60"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[36]|4(?:2[09]|7[01])",
                        "[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[27-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])",
                        "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9])|5(?:2|3[045]|4[0-369]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|49|51|6(?:[0-24]|36|5[0-3589]|72|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:49|55|83)[29]|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]",
                        "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[23]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|72|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]",
                        "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|7[015-9]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17|3[015-9]))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9(?:[019]|4[1-3]|6(?:[0-47-9]|5[01346-9])))|3(?:[29]|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[23]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|72|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|829(?:2|66)|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[14]|[289][2-9]|5[3-9]|7[2-4679]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "800"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[257-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "KE": [
            "254",
            "000",
            "(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}",
            [
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5,7})",
                    "$1 $2",
                    [
                        "[24-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "[17]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "KG": [
            "996",
            "00",
            "8\\d{9}|(?:[235-8]\\d|99)\\d{7}",
            [
                9,
                10
            ],
            [
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "3(?:1[346]|[24-79])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[235-79]|88"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d)(\\d{2,3})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "KH": [
            "855",
            "00[14-9]",
            "1\\d{9}|[1-9]\\d{7,8}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        "KI": [
            "686",
            "00",
            "(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}",
            [
                5,
                8
            ],
            0,
            "0"
        ],
        "KM": [
            "269",
            "00",
            "[3478]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[3478]"
                    ]
                ]
            ]
        ],
        "KN": [
            "1",
            "011",
            "(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "1|([2-7]\\d{6})$",
            "869$1",
            0,
            "869"
        ],
        "KP": [
            "850",
            "00|99",
            "85\\d{6}|(?:19\\d|[2-7])\\d{7}",
            [
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "KR": [
            "82",
            "00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))",
            "00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}",
            [
                5,
                6,
                8,
                9,
                10,
                11,
                12,
                13,
                14
            ],
            [
                [
                    "(\\d{2})(\\d{3,4})",
                    "$1-$2",
                    [
                        "(?:3[1-3]|[46][1-4]|5[1-5])1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d)(\\d{3,4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "60|8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[1346]|5[1-5]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[57]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "5"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            "0(8(?:[1-46-8]|5\\d\\d))?"
        ],
        "KW": [
            "965",
            "00",
            "(?:18|[2569]\\d\\d)\\d{5}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{4})(\\d{3,4})",
                    "$1 $2",
                    [
                        "[169]|2(?:[235]|4[1-35-9])|52"
                    ]
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[25]"
                    ]
                ]
            ]
        ],
        "KY": [
            "1",
            "011",
            "(?:345|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "1|([2-9]\\d{6})$",
            "345$1",
            0,
            "345"
        ],
        "KZ": [
            "7",
            "810",
            "(?:33622|8\\d{8})\\d{5}|[78]\\d{9}",
            [
                10,
                14
            ],
            0,
            "8",
            0,
            0,
            0,
            0,
            "33|7",
            0,
            "8~10"
        ],
        "LA": [
            "856",
            "00",
            "[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2[13]|3[14]|[4-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "30[013-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "[23]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "LB": [
            "961",
            "00",
            "[27-9]\\d{7}|[13-9]\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[27-9]"
                    ]
                ]
            ],
            "0"
        ],
        "LC": [
            "1",
            "011",
            "(?:[58]\\d\\d|758|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "1|([2-8]\\d{6})$",
            "758$1",
            0,
            "758"
        ],
        "LI": [
            "423",
            "00",
            "90\\d{5}|(?:[2378]|6\\d\\d)\\d{6}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[237-9]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "69"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6"
                    ]
                ]
            ],
            "0",
            0,
            "0|(1001)"
        ],
        "LK": [
            "94",
            "00",
            "[1-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[1-689]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "LR": [
            "231",
            "00",
            "(?:2|33|5\\d|77|88)\\d{7}|[4-6]\\d{6}",
            [
                7,
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[4-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[3578]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "LS": [
            "266",
            "00",
            "(?:[256]\\d\\d|800)\\d{5}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2568]"
                    ]
                ]
            ]
        ],
        "LT": [
            "370",
            "00",
            "(?:[3469]\\d|52|[78]0)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "52[0-7]"
                    ],
                    "(8-$1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[7-9]"
                    ],
                    "8 $1",
                    1
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "37|4(?:[15]|6[1-8])"
                    ],
                    "(8-$1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[3-6]"
                    ],
                    "(8-$1)",
                    1
                ]
            ],
            "8",
            0,
            "[08]"
        ],
        "LU": [
            "352",
            "00",
            "35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}",
            [
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1 $2",
                    [
                        "2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "20[2-689]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})",
                    "$1 $2 $3 $4",
                    [
                        "2(?:[0367]|4[3-8])"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "80[01]|90[015]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "20"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "2(?:[0367]|4[3-8])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})",
                    "$1 $2 $3 $4",
                    [
                        "[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"
                    ]
                ]
            ],
            0,
            0,
            "(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)"
        ],
        "LV": [
            "371",
            "00",
            "(?:[268]\\d|90)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[269]|8[01]"
                    ]
                ]
            ]
        ],
        "LY": [
            "218",
            "00",
            "[2-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{7})",
                    "$1-$2",
                    [
                        "[2-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MA": [
            "212",
            "00",
            "[5-8]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{5})(\\d{4})",
                    "$1-$2",
                    [
                        "5(?:29|38)",
                        "5(?:29|38)[89]",
                        "5(?:29|38)[89]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "5[45]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5})",
                    "$1-$2",
                    [
                        "5(?:2[2-489]|3[5-9]|9)|892",
                        "5(?:2(?:[2-49]|8[235-9])|3[5-9]|9)|892"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1-$2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1-$2",
                    [
                        "[5-7]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "5(?:29(?:[189][05]|2[29]|3[01])|38[89][05])\\d{4}|5(?:2(?:[0-25-7]\\d|3[1-578]|4[02-46-8]|8[0235-7]|90)|3(?:[0-47]\\d|5[02-9]|6[02-8]|80|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}"
                ],
                [
                    "(?:6(?:[0-79]\\d|8[0-247-9])|7(?:0\\d|1[0-3]|6[1267]|7[0-57]))\\d{6}"
                ],
                [
                    "80\\d{7}"
                ],
                [
                    "89\\d{7}"
                ],
                0,
                0,
                0,
                0,
                [
                    "592(?:4[0-2]|93)\\d{4}"
                ]
            ]
        ],
        "MC": [
            "377",
            "00",
            "(?:[3489]|6\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "4"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[389]"
                    ]
                ],
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "6"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MD": [
            "373",
            "00",
            "(?:[235-7]\\d|[89]0)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "22|3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[25-7]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ME": [
            "382",
            "00",
            "(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MF": [
            "590",
            "00",
            "(?:590|(?:69|80)\\d|976)\\d{6}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "590(?:0[079]|[14]3|[27][79]|30|5[0-268]|87)\\d{4}"
                ],
                [
                    "69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"
                ],
                [
                    "80[0-5]\\d{6}"
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "976[01]\\d{5}"
                ]
            ]
        ],
        "MG": [
            "261",
            "00",
            "[23]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{3})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[23]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            "0|([24-9]\\d{6})$",
            "20$1"
        ],
        "MH": [
            "692",
            "011",
            "329\\d{4}|(?:[256]\\d|45)\\d{5}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[2-6]"
                    ]
                ]
            ],
            "1"
        ],
        "MK": [
            "389",
            "00",
            "[2-578]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[347]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[58]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ML": [
            "223",
            "00",
            "[24-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[24-9]"
                    ]
                ]
            ]
        ],
        "MM": [
            "95",
            "00",
            "1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}",
            [
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "16|2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[45]|6(?:0[23]|[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[12]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[4-7]|8[1-35]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4,6})",
                    "$1 $2 $3",
                    [
                        "9(?:2[0-4]|[35-9]|4[137-9])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "92"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{5})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MN": [
            "976",
            "001",
            "[12]\\d{7,9}|[57-9]\\d{7}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[12]1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[57-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{5,6})",
                    "$1 $2",
                    [
                        "[12]2[1-3]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5,6})",
                    "$1 $2",
                    [
                        "[12](?:27|3[2-8]|4[2-68]|5[1-4689])",
                        "[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{4,5})",
                    "$1 $2",
                    [
                        "[12]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MO": [
            "853",
            "00",
            "0800\\d{3}|(?:28|[68]\\d)\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{4})(\\d{3})",
                    "$1 $2",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[268]"
                    ]
                ]
            ]
        ],
        "MP": [
            "1",
            "011",
            "[58]\\d{9}|(?:67|90)0\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "1|([2-9]\\d{6})$",
            "670$1",
            0,
            "670"
        ],
        "MQ": [
            "596",
            "00",
            "(?:69|80)\\d{7}|(?:59|97)6\\d{6}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[569]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MR": [
            "222",
            "00",
            "(?:[2-4]\\d\\d|800)\\d{5}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-48]"
                    ]
                ]
            ]
        ],
        "MS": [
            "1",
            "011",
            "(?:[58]\\d\\d|664|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "1|([34]\\d{6})$",
            "664$1",
            0,
            "664"
        ],
        "MT": [
            "356",
            "00",
            "3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2357-9]"
                    ]
                ]
            ]
        ],
        "MU": [
            "230",
            "0(?:0|[24-7]0|3[03])",
            "(?:5|8\\d\\d)\\d{7}|[2-468]\\d{6}",
            [
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-46]|8[013]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "5"
                    ]
                ],
                [
                    "(\\d{5})(\\d{5})",
                    "$1 $2",
                    [
                        "8"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "020"
        ],
        "MV": [
            "960",
            "0(?:0|19)",
            "(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}",
            [
                7,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[3467]|9[13-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "MW": [
            "265",
            "00",
            "(?:[19]\\d|[23]1|77|88)\\d{7}|1\\d{6}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1[2-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[137-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MX": [
            "52",
            "0[09]",
            "1(?:65[0-689]|99[1-9])\\d{7}|(?:1(?:[0147]\\d|[235][1-9]|6[0-46-9]|8[1-79]|9[1-8])|[2-9]\\d)\\d{8}",
            [
                10,
                11
            ],
            [
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "33|5[56]|81"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-9]"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d)(\\d{2})(\\d{4})(\\d{4})",
                    "$2 $3 $4",
                    [
                        "1(?:33|5[56]|81)"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{4})",
                    "$2 $3 $4",
                    [
                        "1"
                    ],
                    0,
                    1
                ]
            ],
            "01",
            0,
            "0(?:[12]|4[45])|1",
            0,
            0,
            0,
            0,
            "00"
        ],
        "MY": [
            "60",
            "00",
            "1\\d{8,9}|(?:3\\d|[4-9])\\d{7}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "[4-79]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1-$2 $3",
                    [
                        "1(?:[02469]|[378][1-9])|8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2})(\\d{4})",
                    "$1-$2-$3-$4",
                    [
                        "1[36-8]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "15"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MZ": [
            "258",
            "00",
            "(?:2|8\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2|8[2-79]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "NA": [
            "264",
            "00",
            "[68]\\d{7,8}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "88"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "6"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "87"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "NC": [
            "687",
            "00",
            "[2-57-9]\\d{5}",
            [
                6
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1.$2.$3",
                    [
                        "[2-57-9]"
                    ]
                ]
            ]
        ],
        "NE": [
            "227",
            "00",
            "[027-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "08"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[089]|2[013]|7[04]"
                    ]
                ]
            ]
        ],
        "NF": [
            "672",
            "00",
            "[13]\\d{5}",
            [
                6
            ],
            [
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "1[0-3]"
                    ]
                ],
                [
                    "(\\d)(\\d{5})",
                    "$1 $2",
                    [
                        "[13]"
                    ]
                ]
            ],
            0,
            0,
            "([0-258]\\d{4})$",
            "3$1"
        ],
        "NG": [
            "234",
            "009",
            "(?:[124-7]|9\\d{3})\\d{6}|[1-9]\\d{7}|[78]\\d{9,13}",
            [
                7,
                8,
                10,
                11,
                12,
                13,
                14
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "78"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[12]|9(?:0[3-9]|[1-9])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "[3-7]|8[2-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[7-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4,5})",
                    "$1 $2 $3",
                    [
                        "[78]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5})(\\d{5,6})",
                    "$1 $2 $3",
                    [
                        "[78]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "NI": [
            "505",
            "00",
            "(?:1800|[25-8]\\d{3})\\d{4}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[125-8]"
                    ]
                ]
            ]
        ],
        "NL": [
            "31",
            "00",
            "(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|[89]\\d{6,9}|1\\d{4,5}",
            [
                5,
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4,7})",
                    "$1 $2",
                    [
                        "[89]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "66"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{8})",
                    "$1 $2",
                    [
                        "6"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-57-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "NO": [
            "47",
            "00",
            "(?:0|[2-9]\\d{3})\\d{4}",
            [
                5,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[489]|59"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[235-7]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            "[02-689]|7[0-8]"
        ],
        "NP": [
            "977",
            "00",
            "(?:1\\d|9)\\d{9}|[1-9]\\d{7}",
            [
                8,
                10,
                11
            ],
            [
                [
                    "(\\d)(\\d{7})",
                    "$1-$2",
                    [
                        "1[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1-$2",
                    [
                        "1[01]|[2-8]|9(?:[1-579]|6[2-6])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1-$2",
                    [
                        "9"
                    ]
                ]
            ],
            "0"
        ],
        "NR": [
            "674",
            "00",
            "(?:444|(?:55|8\\d)\\d|666)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[4-68]"
                    ]
                ]
            ]
        ],
        "NU": [
            "683",
            "00",
            "(?:[47]|888\\d)\\d{3}",
            [
                4,
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "NZ": [
            "64",
            "0(?:0|161)",
            "[29]\\d{7,9}|50\\d{5}(?:\\d{2,3})?|6[0-35-9]\\d{6}|7\\d{7,8}|8\\d{4,9}|(?:11\\d|[34])\\d{7}",
            [
                5,
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3,8})",
                    "$1 $2",
                    [
                        "8[1-579]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "50[036-8]|[89]0",
                        "50(?:[0367]|88)|[89]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "24|[346]|7[2-57-9]|9[2-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2(?:10|74)|[59]|80"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1|2[028]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,5})",
                    "$1 $2 $3",
                    [
                        "2(?:[169]|7[0-35-9])|7|86"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "OM": [
            "968",
            "00",
            "(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}",
            [
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{4,6})",
                    "$1 $2",
                    [
                        "[58]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "2"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[179]"
                    ]
                ]
            ]
        ],
        "PA": [
            "507",
            "00",
            "8\\d{9}|[68]\\d{7}|[1-57-9]\\d{6}",
            [
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[1-57-9]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "[68]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "PE": [
            "51",
            "19(?:1[124]|77|90)00",
            "(?:[14-8]|9\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "80"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[4-8]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "9"
                    ]
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            " Anexo "
        ],
        "PF": [
            "689",
            "00",
            "4\\d{5}(?:\\d{2})?|8\\d{7,8}",
            [
                6,
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "44"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "4|8[7-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "PG": [
            "675",
            "00|140[1-3]",
            "(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "18|[2-69]|85"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[78]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "PH": [
            "63",
            "00",
            "(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}",
            [
                6,
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d)(\\d{5})",
                    "$1 $2",
                    [
                        "2"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{4})(\\d{4,6})",
                    "$1 $2",
                    [
                        "3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2",
                        "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{5})(\\d{4})",
                    "$1 $2",
                    [
                        "346|4(?:27|9[35])|883",
                        "3469|4(?:279|9(?:30|56))|8834"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[3-7]|8[2-8]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        "PK": [
            "92",
            "00",
            "122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}",
            [
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{2,7})",
                    "$1 $2 $3",
                    [
                        "[89]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{3})(\\d{6,7})",
                    "$1 $2",
                    [
                        "2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])",
                        "9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{7,8})",
                    "$1 $2",
                    [
                        "(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{5})(\\d{5})",
                    "$1 $2",
                    [
                        "58"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "[24-9]"
                    ],
                    "(0$1)"
                ]
            ],
            "0"
        ],
        "PL": [
            "48",
            "00",
            "6\\d{5}(?:\\d{2})?|8\\d{9}|[1-9]\\d{6}(?:\\d{2})?",
            [
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{5})",
                    "$1",
                    [
                        "19"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "11|64"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1",
                        "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "64"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "1[2-8]|[2-7]|8[1-79]|9[145]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "PM": [
            "508",
            "00",
            "(?:[45]|80\\d\\d)\\d{5}",
            [
                6,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[45]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "PR": [
            "1",
            "011",
            "(?:[589]\\d\\d|787)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            "787|939"
        ],
        "PS": [
            "970",
            "00",
            "[2489]2\\d{6}|(?:1\\d|5)\\d{8}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2489]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        "PT": [
            "351",
            "00",
            "1693\\d{5}|(?:[26-9]\\d|30)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2[12]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "16|[236-9]"
                    ]
                ]
            ]
        ],
        "PW": [
            "680",
            "01[12]",
            "(?:[24-8]\\d\\d|345|900)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-9]"
                    ]
                ]
            ]
        ],
        "PY": [
            "595",
            "00",
            "59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}",
            [
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{3,6})",
                    "$1 $2",
                    [
                        "[2-9]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{4,5})",
                    "$1 $2",
                    [
                        "2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "87"
                    ]
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "9(?:[5-79]|8[1-6])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ]
                ]
            ],
            "0"
        ],
        "QA": [
            "974",
            "00",
            "[2-7]\\d{7}|800\\d{4}(?:\\d{2})?|2\\d{6}",
            [
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "2[126]|8"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-7]"
                    ]
                ]
            ]
        ],
        "RE": [
            "262",
            "00",
            "9769\\d{5}|(?:26|[68]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2689]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            "26[23]|69|[89]"
        ],
        "RO": [
            "40",
            "00",
            "(?:[237]\\d|[89]0)\\d{7}|[23]\\d{5}",
            [
                6,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "2[3-6]",
                        "2[3-6]\\d9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "219|31"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[23]1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[237-9]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            " int "
        ],
        "RS": [
            "381",
            "00",
            "38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}",
            [
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3,9})",
                    "$1 $2",
                    [
                        "(?:2[389]|39)0|[7-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5,10})",
                    "$1 $2",
                    [
                        "[1-36]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "RU": [
            "7",
            "810",
            "8\\d{13}|[347-9]\\d{9}",
            [
                10,
                14
            ],
            [
                [
                    "(\\d{4})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "7(?:1[0-8]|2[1-9])",
                        "7(?:1(?:[0-6]2|7|8[27])|2(?:1[23]|[2-9]2))",
                        "7(?:1(?:[0-6]2|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{5})(\\d)(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "7(?:1[0-68]|2[1-9])",
                        "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))",
                        "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "[349]|8(?:[02-7]|1[1-8])"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{4})(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "8 ($1)"
                ]
            ],
            "8",
            0,
            0,
            0,
            0,
            "3[04-689]|[489]",
            0,
            "8~10"
        ],
        "RW": [
            "250",
            "00",
            "(?:06|[27]\\d\\d|[89]00)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[7-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ]
                ]
            ],
            "0"
        ],
        "SA": [
            "966",
            "00",
            "92\\d{7}|(?:[15]|8\\d)\\d{8}",
            [
                9,
                10
            ],
            [
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "9"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "81"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ],
            "0"
        ],
        "SB": [
            "677",
            "0[01]",
            "(?:[1-6]|[7-9]\\d\\d)\\d{4}",
            [
                5,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "7|8[4-9]|9(?:[1-8]|9[0-8])"
                    ]
                ]
            ]
        ],
        "SC": [
            "248",
            "010|0[0-2]",
            "8000\\d{3}|(?:[249]\\d|64)\\d{5}",
            [
                7
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[246]|9[57]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "SD": [
            "249",
            "00",
            "[19]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[19]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "SE": [
            "46",
            "00",
            "(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}",
            [
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2,3})(\\d{2})",
                    "$1-$2 $3",
                    [
                        "20"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "9(?:00|39|44)"
                    ],
                    "0$1",
                    0,
                    "$1 $2"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})",
                    "$1-$2 $3",
                    [
                        "[12][136]|3[356]|4[0246]|6[03]|90[1-9]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d)(\\d{2,3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2,3})(\\d{2})",
                    "$1-$2 $3",
                    [
                        "1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d{3})(\\d{2,3})(\\d{3})",
                    "$1-$2 $3",
                    [
                        "9(?:00|39|44)"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "10|7"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{3})",
                    "$1-$2 $3 $4",
                    [
                        "9"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4 $5",
                    [
                        "[26]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4 $5"
                ]
            ],
            "0"
        ],
        "SG": [
            "65",
            "0[0-3]\\d",
            "(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}",
            [
                8,
                10,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[369]|8(?:0[1-4]|[1-9])"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "7"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ]
        ],
        "SH": [
            "290",
            "00",
            "(?:[256]\\d|8)\\d{3}",
            [
                4,
                5
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "[256]"
        ],
        "SI": [
            "386",
            "00|10(?:22|66|88|99)",
            "[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}",
            [
                5,
                6,
                7,
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3,6})",
                    "$1 $2",
                    [
                        "8[09]|9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "59|8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[37][01]|4[0139]|51|6"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[1-57]"
                    ],
                    "(0$1)"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "SJ": [
            "47",
            "00",
            "0\\d{4}|(?:[489]\\d|[57]9)\\d{6}",
            [
                5,
                8
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "79"
        ],
        "SK": [
            "421",
            "00",
            "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}",
            [
                6,
                7,
                9
            ],
            [
                [
                    "(\\d)(\\d{2})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "21"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "[3-5][1-8]1",
                        "[3-5][1-8]1[67]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{2})",
                    "$1/$2 $3 $4",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[689]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1/$2 $3 $4",
                    [
                        "[3-5]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "SL": [
            "232",
            "00",
            "(?:[237-9]\\d|66)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[236-9]"
                    ],
                    "(0$1)"
                ]
            ],
            "0"
        ],
        "SM": [
            "378",
            "00",
            "(?:0549|[5-7]\\d)\\d{6}",
            [
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-7]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "0"
                    ]
                ]
            ],
            0,
            0,
            "([89]\\d{5})$",
            "0549$1"
        ],
        "SN": [
            "221",
            "00",
            "(?:[378]\\d|93)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[379]"
                    ]
                ]
            ]
        ],
        "SO": [
            "252",
            "00",
            "[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}",
            [
                6,
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "8[125]"
                    ]
                ],
                [
                    "(\\d{6})",
                    "$1",
                    [
                        "[134]"
                    ]
                ],
                [
                    "(\\d)(\\d{6})",
                    "$1 $2",
                    [
                        "[15]|2[0-79]|3[0-46-8]|4[0-7]"
                    ]
                ],
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "24|[67]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[3478]|64|90"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5,7})",
                    "$1 $2",
                    [
                        "1|28|6(?:0[5-7]|[1-35-9])|9[2-9]"
                    ]
                ]
            ],
            "0"
        ],
        "SR": [
            "597",
            "00",
            "(?:[2-5]|68|[78]\\d)\\d{5}",
            [
                6,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1-$2-$3",
                    [
                        "56"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})",
                    "$1-$2",
                    [
                        "[2-5]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[6-8]"
                    ]
                ]
            ]
        ],
        "SS": [
            "211",
            "00",
            "[19]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[19]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ST": [
            "239",
            "00",
            "(?:22|9\\d)\\d{5}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[29]"
                    ]
                ]
            ]
        ],
        "SV": [
            "503",
            "00",
            "[267]\\d{7}|[89]00\\d{4}(?:\\d{4})?",
            [
                7,
                8,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[89]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[267]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ]
                ]
            ]
        ],
        "SX": [
            "1",
            "011",
            "7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "1|(5\\d{6})$",
            "721$1",
            0,
            "721"
        ],
        "SY": [
            "963",
            "00",
            "[1-39]\\d{8}|[1-5]\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[1-5]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0"
        ],
        "SZ": [
            "268",
            "00",
            "0800\\d{4}|(?:[237]\\d|900)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[0237]"
                    ]
                ],
                [
                    "(\\d{5})(\\d{4})",
                    "$1 $2",
                    [
                        "9"
                    ]
                ]
            ]
        ],
        "TA": [
            "290",
            "00",
            "8\\d{3}",
            [
                4
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "8"
        ],
        "TC": [
            "1",
            "011",
            "(?:[58]\\d\\d|649|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "1|([2-479]\\d{6})$",
            "649$1",
            0,
            "649"
        ],
        "TD": [
            "235",
            "00|16",
            "(?:22|[69]\\d|77)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2679]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "TG": [
            "228",
            "00",
            "[279]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[279]"
                    ]
                ]
            ]
        ],
        "TH": [
            "66",
            "00[1-9]",
            "1\\d{9}|[1689]\\d{8}|[1-57]\\d{7}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[13-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        "TJ": [
            "992",
            "810",
            "(?:00|11|[2-57-9]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{6})(\\d)(\\d{2})",
                    "$1 $2 $3",
                    [
                        "331",
                        "3317"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[34]7|91[78]"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{4})(\\d)(\\d{4})",
                    "$1 $2 $3",
                    [
                        "3[1-5]"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[02-57-9]|11"
                    ],
                    0,
                    1
                ]
            ],
            "8",
            0,
            0,
            0,
            0,
            0,
            0,
            "8~10"
        ],
        "TK": [
            "690",
            "00",
            "[2-47]\\d{3,6}",
            [
                4,
                5,
                6,
                7
            ]
        ],
        "TL": [
            "670",
            "00",
            "7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-489]|70"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "7"
                    ]
                ]
            ]
        ],
        "TM": [
            "993",
            "810",
            "[1-6]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "12"
                    ],
                    "(8 $1)"
                ],
                [
                    "(\\d{3})(\\d)(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "[1-5]"
                    ],
                    "(8 $1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "6"
                    ],
                    "8 $1"
                ]
            ],
            "8",
            0,
            0,
            0,
            0,
            0,
            0,
            "8~10"
        ],
        "TN": [
            "216",
            "00",
            "[2-57-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-57-9]"
                    ]
                ]
            ]
        ],
        "TO": [
            "676",
            "00",
            "(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}",
            [
                5,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1-$2",
                    [
                        "[2-4]|50|6[09]|7[0-24-69]|8[05]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})",
                    "$1 $2",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[5-9]"
                    ]
                ]
            ]
        ],
        "TR": [
            "90",
            "00",
            "4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}",
            [
                7,
                10,
                12,
                13
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "512|8[01589]|90"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "5(?:[0-59]|61)",
                        "5(?:[0-59]|616)",
                        "5(?:[0-59]|6161)"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[24][1-8]|3[1-9]"
                    ],
                    "(0$1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{6,7})",
                    "$1 $2 $3",
                    [
                        "80"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0"
        ],
        "TT": [
            "1",
            "011",
            "(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "1|([2-46-8]\\d{6})$",
            "868$1",
            0,
            "868"
        ],
        "TV": [
            "688",
            "00",
            "(?:2|7\\d\\d|90)\\d{4}",
            [
                5,
                6,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1 $2",
                    [
                        "2"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "90"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "7"
                    ]
                ]
            ]
        ],
        "TW": [
            "886",
            "0(?:0[25-79]|19)",
            "[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}",
            [
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{2})(\\d)(\\d{4})",
                    "$1 $2 $3",
                    [
                        "202"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[258]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]",
                        "[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[49]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4,5})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "#"
        ],
        "TZ": [
            "255",
            "00[056]",
            "(?:[26-8]\\d|41|90)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[24]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[67]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "UA": [
            "380",
            "00",
            "[89]\\d{9}|[3-9]\\d{8}",
            [
                9,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]",
                        "6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "4[45][0-5]|5(?:0|6[37])|6(?:[12][018]|[36-8])|7|89|9[1-9]|(?:48|57)[0137-9]",
                        "4[45][0-5]|5(?:0|6(?:3[14-7]|7))|6(?:[12][018]|[36-8])|7|89|9[1-9]|(?:48|57)[0137-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "[3-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "0~0"
        ],
        "UG": [
            "256",
            "00[057]",
            "800\\d{6}|(?:[29]0|[347]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "202",
                        "2024"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "[27-9]|4(?:6[45]|[7-9])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "[34]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "US": [
            "1",
            "011",
            "[2-9]\\d{9}",
            [
                10
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "($1) $2-$3",
                    [
                        "[2-9]"
                    ],
                    0,
                    1,
                    "$1-$2-$3"
                ]
            ],
            "1",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:2(?:0[1-35-9]|1[02-9]|2[03-589]|3[149]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-57-9]|1[02-9]|2[01356]|3[0-24679]|4[167]|5[12]|6[014]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[39]|7[0589]|8[04])|5(?:0[1-57-9]|1[0235-8]|20|3[0149]|4[01]|5[19]|6[1-47]|7[0-5]|8[056])|6(?:0[1-35-9]|1[024-9]|2[03689]|[34][016]|5[0179]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-7]|3[1247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[08]|3[0-289]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01579]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}"
                ],
                [
                    ""
                ],
                [
                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"
                ],
                [
                    "900[2-9]\\d{6}"
                ],
                [
                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}"
                ]
            ]
        ],
        "UY": [
            "598",
            "0(?:0|1[3-9]\\d)",
            "4\\d{9}|[249]\\d{7}|(?:[49]\\d|80)\\d{5}",
            [
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "405|8|90"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[24]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "4"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "00",
            " int. "
        ],
        "UZ": [
            "998",
            "810",
            "(?:33|55|[679]\\d|88)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[35-9]"
                    ],
                    "8 $1"
                ]
            ],
            "8",
            0,
            0,
            0,
            0,
            0,
            0,
            "8~10"
        ],
        "VA": [
            "39",
            "00",
            "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}",
            [
                6,
                7,
                8,
                9,
                10,
                11
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "06698"
        ],
        "VC": [
            "1",
            "011",
            "(?:[58]\\d\\d|784|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "1|([2-7]\\d{6})$",
            "784$1",
            0,
            "784"
        ],
        "VE": [
            "58",
            "00",
            "[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}",
            [
                10
            ],
            [
                [
                    "(\\d{3})(\\d{7})",
                    "$1-$2",
                    [
                        "[24-689]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "VG": [
            "1",
            "011",
            "(?:284|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "1|([2-578]\\d{6})$",
            "284$1",
            0,
            "284"
        ],
        "VI": [
            "1",
            "011",
            "[58]\\d{9}|(?:34|90)0\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "1|([2-9]\\d{6})$",
            "340$1",
            0,
            "340"
        ],
        "VN": [
            "84",
            "00",
            "[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}",
            [
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "80"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{4})(\\d{4,6})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[69]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[3578]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2[48]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0"
        ],
        "VU": [
            "678",
            "00",
            "[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}",
            [
                5,
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[57-9]"
                    ]
                ]
            ]
        ],
        "WF": [
            "681",
            "00",
            "(?:40|72)\\d{4}|8\\d{5}(?:\\d{3})?",
            [
                6,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[478]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "WS": [
            "685",
            "0",
            "(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}",
            [
                5,
                6,
                7,
                10
            ],
            [
                [
                    "(\\d{5})",
                    "$1",
                    [
                        "[2-5]|6[1-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3,7})",
                    "$1 $2",
                    [
                        "[68]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "7"
                    ]
                ]
            ]
        ],
        "XK": [
            "383",
            "00",
            "[23]\\d{7,8}|(?:4\\d\\d|[89]00)\\d{5}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[23]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "YE": [
            "967",
            "00",
            "(?:1|7\\d)\\d{7}|[1-7]\\d{6}",
            [
                7,
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[1-6]|7[24-68]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "YT": [
            "262",
            "00",
            "80\\d{7}|(?:26|63)9\\d{6}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            "269|63"
        ],
        "ZA": [
            "27",
            "00",
            "[1-79]\\d{8}|8\\d{4,9}",
            [
                5,
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3,4})",
                    "$1 $2",
                    [
                        "8[1-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "8[1-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "860"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ZM": [
            "260",
            "00",
            "(?:63|80)0\\d{6}|(?:21|[79]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[28]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "[79]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ZW": [
            "263",
            "00",
            "2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}",
            [
                5,
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{3,5})",
                    "$1 $2",
                    [
                        "2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2,4})",
                    "$1 $2 $3",
                    [
                        "[49]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "80"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2",
                        "2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)",
                        "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,5})",
                    "$1 $2",
                    [
                        "1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "29[013-9]|39|54"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3,5})",
                    "$1 $2",
                    [
                        "(?:25|54)8",
                        "258|5483"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ]
    },
    "nonGeographic": {
        "800": [
            "800",
            0,
            "(?:005|[1-9]\\d\\d)\\d{5}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "\\d"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                [
                    "(?:005|[1-9]\\d\\d)\\d{5}"
                ]
            ]
        ],
        "808": [
            "808",
            0,
            "[1-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[1-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "[1-9]\\d{7}"
                ]
            ]
        ],
        "870": [
            "870",
            0,
            "7\\d{11}|[35-7]\\d{8}",
            [
                9,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[35-7]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}"
                ]
            ]
        ],
        "878": [
            "878",
            0,
            "10\\d{10}",
            [
                12
            ],
            [
                [
                    "(\\d{2})(\\d{5})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "10\\d{10}"
                ]
            ]
        ],
        "881": [
            "881",
            0,
            "[0-36-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "[0-36-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "[0-36-9]\\d{8}"
                ]
            ]
        ],
        "882": [
            "882",
            0,
            "[13]\\d{6}(?:\\d{2,5})?|285\\d{9}|(?:[19]\\d|49)\\d{6}",
            [
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "16|342"
                    ]
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "4"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[19]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "3[23]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "34[57]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "34"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4,5})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "[1-3]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "342\\d{4}|(?:337|49)\\d{6}|3(?:2|47|7\\d{3})\\d{7}",
                    [
                        7,
                        8,
                        9,
                        10,
                        12
                    ]
                ],
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:(?:285\\d\\d|3(?:45|[69]\\d{3}))\\d|9[89])\\d{6}"
                ]
            ]
        ],
        "883": [
            "883",
            0,
            "210\\d{7}|51\\d{7}(?:\\d{3})?",
            [
                9,
                10,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "510"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "510"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "5"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "(?:210|51[013]0\\d)\\d{7}|5100\\d{5}"
                ]
            ]
        ],
        "888": [
            "888",
            0,
            "\\d{11}",
            [
                11
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{5})",
                    "$1 $2 $3"
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "\\d{11}"
                ]
            ]
        ],
        "979": [
            "979",
            0,
            "[1359]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1359]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                [
                    "[1359]\\d{8}"
                ]
            ]
        ]
    }
};

});


parcelRegister("gAr6H", function(module, exports) {

$parcel$export(module.exports, "default", () => $c13509054e39a1d1$export$2e2bcd8739ae039);

var $lORaT = parcelRequire("lORaT");

var $lnAnA = parcelRequire("lnAnA");
function $c13509054e39a1d1$export$2e2bcd8739ae039() {
    var _normalizeArguments = (0, $lORaT.normalizeArguments)(arguments), text = _normalizeArguments.text, options = _normalizeArguments.options, metadata = _normalizeArguments.metadata;
    return (0, $lnAnA.default)(text, options, metadata);
}

});
parcelRegister("lORaT", function(module, exports) {

$parcel$export(module.exports, "normalizeArguments", () => $fe2783d9f9ccca74$export$abc60e668512edf9);

var $aKJ8g = parcelRequire("aKJ8g");
function $fe2783d9f9ccca74$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $fe2783d9f9ccca74$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $fe2783d9f9ccca74$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $fe2783d9f9ccca74$var$_typeof(obj);
}
function $fe2783d9f9ccca74$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            $fe2783d9f9ccca74$var$_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function $fe2783d9f9ccca74$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $fe2783d9f9ccca74$var$_slicedToArray(arr, i) {
    return $fe2783d9f9ccca74$var$_arrayWithHoles(arr) || $fe2783d9f9ccca74$var$_iterableToArrayLimit(arr, i) || $fe2783d9f9ccca74$var$_nonIterableRest();
}
function $fe2783d9f9ccca74$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
function $fe2783d9f9ccca74$var$_iterableToArrayLimit(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $fe2783d9f9ccca74$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $fe2783d9f9ccca74$export$2e2bcd8739ae039() {
    var _normalizeArguments = $fe2783d9f9ccca74$export$abc60e668512edf9(arguments), text = _normalizeArguments.text, options = _normalizeArguments.options, metadata = _normalizeArguments.metadata;
    return (0, $aKJ8g.default)(text, options, metadata);
}
function $fe2783d9f9ccca74$export$abc60e668512edf9(args) {
    var _Array$prototype$slic = Array.prototype.slice.call(args), _Array$prototype$slic2 = $fe2783d9f9ccca74$var$_slicedToArray(_Array$prototype$slic, 4), arg_1 = _Array$prototype$slic2[0], arg_2 = _Array$prototype$slic2[1], arg_3 = _Array$prototype$slic2[2], arg_4 = _Array$prototype$slic2[3];
    var text;
    var options;
    var metadata; // If the phone number is passed as a string.
    // `parsePhoneNumber('88005553535', ...)`.
    if (typeof arg_1 === 'string') text = arg_1;
    else throw new TypeError('A text for parsing must be a string.'); // If "default country" argument is being passed then move it to `options`.
    // `parsePhoneNumber('88005553535', 'RU', [options], metadata)`.
    if (!arg_2 || typeof arg_2 === 'string') {
        if (arg_4) {
            options = arg_3;
            metadata = arg_4;
        } else {
            options = undefined;
            metadata = arg_3;
        }
        if (arg_2) options = $fe2783d9f9ccca74$var$_objectSpread({
            defaultCountry: arg_2
        }, options);
    } else if ($fe2783d9f9ccca74$var$isObject(arg_2)) {
        if (arg_3) {
            options = arg_2;
            metadata = arg_3;
        } else metadata = arg_2;
    } else throw new Error("Invalid second argument: ".concat(arg_2));
    return {
        text: text,
        options: options,
        metadata: metadata
    };
} // Otherwise istanbul would show this as "branch not covered".
/* istanbul ignore next */ var $fe2783d9f9ccca74$var$isObject = function isObject(_) {
    return $fe2783d9f9ccca74$var$_typeof(_) === 'object';
};

});
parcelRegister("aKJ8g", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d413597caf73a03$export$2e2bcd8739ae039);

var $fQWPU = parcelRequire("fQWPU");
function $7d413597caf73a03$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            $7d413597caf73a03$var$_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function $7d413597caf73a03$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $7d413597caf73a03$export$2e2bcd8739ae039(text, options, metadata) {
    return (0, $fQWPU.default)(text, $7d413597caf73a03$var$_objectSpread({}, options, {
        v2: true
    }), metadata);
}

});
parcelRegister("fQWPU", function(module, exports) {

$parcel$export(module.exports, "default", () => $b8a959fb4d51e573$export$2e2bcd8739ae039);
// This is a port of Google Android `libphonenumber`'s
// `phonenumberutil.js` of December 31th, 2018.
//
// https://github.com/googlei18n/libphonenumber/commits/master/javascript/i18n/phonenumbers/phonenumberutil.js

var $hoHfs = parcelRequire("hoHfs");

var $1nVPX = parcelRequire("1nVPX");

var $lijQr = parcelRequire("lijQr");

var $6K6oP = parcelRequire("6K6oP");

var $a5PYs = parcelRequire("a5PYs");

var $81pt0 = parcelRequire("81pt0");

var $lijQr = parcelRequire("lijQr");

var $idCyj = parcelRequire("idCyj");

var $cJRin = parcelRequire("cJRin");

var $3bOc3 = parcelRequire("3bOc3");

var $jyfse = parcelRequire("jyfse");

var $l3IVT = parcelRequire("l3IVT");


var $lO22f = parcelRequire("lO22f");


var $3wXuM = parcelRequire("3wXuM");
// This prevents malicious input from consuming CPU.
var $b8a959fb4d51e573$var$MAX_INPUT_STRING_LENGTH = 250; // This consists of the plus symbol, digits, and arabic-indic digits.
var $b8a959fb4d51e573$var$PHONE_NUMBER_START_PATTERN = new RegExp('[' + (0, $hoHfs.PLUS_CHARS) + (0, $hoHfs.VALID_DIGITS) + ']'); // Regular expression of trailing characters that we want to remove.
// A trailing `#` is sometimes used when writing phone numbers with extensions in US.
// Example: "+1 (645) 123 1234-910#" number has extension "910".
var $b8a959fb4d51e573$var$AFTER_PHONE_NUMBER_END_PATTERN = new RegExp('[^' + (0, $hoHfs.VALID_DIGITS) + '#' + ']+$');
var $b8a959fb4d51e573$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE = false; // Examples:
function $b8a959fb4d51e573$export$2e2bcd8739ae039(text, options, metadata) {
    // If assigning the `{}` default value is moved to the arguments above,
    // code coverage would decrease for some weird reason.
    options = options || {};
    metadata = new (0, $lijQr.default)(metadata); // Validate `defaultCountry`.
    if (options.defaultCountry && !metadata.hasCountry(options.defaultCountry)) {
        if (options.v2) throw new (0, $1nVPX.default)('INVALID_COUNTRY');
        throw new Error("Unknown country: ".concat(options.defaultCountry));
    } // Parse the phone number.
    var _parseInput = $b8a959fb4d51e573$var$parseInput(text, options.v2, options.extract), formattedPhoneNumber = _parseInput.number, ext = _parseInput.ext, error = _parseInput.error; // If the phone number is not viable then return nothing.
    if (!formattedPhoneNumber) {
        if (options.v2) {
            if (error === 'TOO_SHORT') throw new (0, $1nVPX.default)('TOO_SHORT');
            throw new (0, $1nVPX.default)('NOT_A_NUMBER');
        }
        return {};
    }
    var _parsePhoneNumber = $b8a959fb4d51e573$var$parsePhoneNumber(formattedPhoneNumber, options.defaultCountry, options.defaultCallingCode, metadata), country = _parsePhoneNumber.country, nationalNumber = _parsePhoneNumber.nationalNumber, countryCallingCode = _parsePhoneNumber.countryCallingCode, carrierCode = _parsePhoneNumber.carrierCode;
    if (!metadata.hasSelectedNumberingPlan()) {
        if (options.v2) throw new (0, $1nVPX.default)('INVALID_COUNTRY');
        return {};
    } // Validate national (significant) number length.
    if (!nationalNumber || nationalNumber.length < (0, $hoHfs.MIN_LENGTH_FOR_NSN)) {
        // Won't throw here because the regexp already demands length > 1.
        /* istanbul ignore if */ if (options.v2) throw new (0, $1nVPX.default)('TOO_SHORT');
         // Google's demo just throws an error in this case.
        return {};
    } // Validate national (significant) number length.
    //
    // A sidenote:
    //
    // They say that sometimes national (significant) numbers
    // can be longer than `MAX_LENGTH_FOR_NSN` (e.g. in Germany).
    // https://github.com/googlei18n/libphonenumber/blob/7e1748645552da39c4e1ba731e47969d97bdb539/resources/phonenumber.proto#L36
    // Such numbers will just be discarded.
    //
    if (nationalNumber.length > (0, $hoHfs.MAX_LENGTH_FOR_NSN)) {
        if (options.v2) throw new (0, $1nVPX.default)('TOO_LONG');
         // Google's demo just throws an error in this case.
        return {};
    }
    if (options.v2) {
        var phoneNumber = new (0, $3bOc3.default)(countryCallingCode, nationalNumber, metadata.metadata);
        if (country) phoneNumber.country = country;
        if (carrierCode) phoneNumber.carrierCode = carrierCode;
        if (ext) phoneNumber.ext = ext;
        return phoneNumber;
    } // Check if national phone number pattern matches the number.
    // National number pattern is different for each country,
    // even for those ones which are part of the "NANPA" group.
    var valid = (options.extended ? metadata.hasSelectedNumberingPlan() : country) ? (0, $jyfse.default)(nationalNumber, metadata.nationalNumberPattern()) : false;
    if (!options.extended) return valid ? $b8a959fb4d51e573$var$result(country, nationalNumber, ext) : {};
     // isInternational: countryCallingCode !== undefined
    return {
        country: country,
        countryCallingCode: countryCallingCode,
        carrierCode: carrierCode,
        valid: valid,
        possible: valid ? true : options.extended === true && metadata.possibleLengths() && (0, $idCyj.isPossibleNumber)(nationalNumber, metadata) ? true : false,
        phone: nationalNumber,
        ext: ext
    };
}
/**
 * Extracts a formatted phone number from text.
 * Doesn't guarantee that the extracted phone number
 * is a valid phone number (for example, doesn't validate its length).
 * @param  {string} text
 * @param  {boolean} [extract] — If `false`, then will parse the entire `text` as a phone number.
 * @param  {boolean} [throwOnError] — By default, it won't throw if the text is too long.
 * @return {string}
 * @example
 * // Returns "(213) 373-4253".
 * extractFormattedPhoneNumber("Call (213) 373-4253 for assistance.")
 */ function $b8a959fb4d51e573$var$extractFormattedPhoneNumber(text, extract, throwOnError) {
    if (!text) return;
    if (text.length > $b8a959fb4d51e573$var$MAX_INPUT_STRING_LENGTH) {
        if (throwOnError) throw new (0, $1nVPX.default)('TOO_LONG');
        return;
    }
    if (extract === false) return text;
     // Attempt to extract a possible number from the string passed in
    var startsAt = text.search($b8a959fb4d51e573$var$PHONE_NUMBER_START_PATTERN);
    if (startsAt < 0) return;
    return text // Trim everything to the left of the phone number
    .slice(startsAt) // Remove trailing non-numerical characters
    .replace($b8a959fb4d51e573$var$AFTER_PHONE_NUMBER_END_PATTERN, '');
}
/**
 * @param  {string} text - Input.
 * @param  {boolean} v2 - Legacy API functions don't pass `v2: true` flag.
 * @param  {boolean} [extract] - Whether to extract a phone number from `text`, or attempt to parse the entire text as a phone number.
 * @return {object} `{ ?number, ?ext }`.
 */ function $b8a959fb4d51e573$var$parseInput(text, v2, extract) {
    // Parse RFC 3966 phone number URI.
    if (text && text.indexOf('tel:') === 0) return (0, $cJRin.parseRFC3966)(text);
    var number = $b8a959fb4d51e573$var$extractFormattedPhoneNumber(text, extract, v2); // If the phone number is not viable, then abort.
    if (!number) return {};
    if (!(0, $6K6oP.default)(number)) {
        if ((0, $6K6oP.isViablePhoneNumberStart)(number)) return {
            error: 'TOO_SHORT'
        };
        return {};
    } // Attempt to parse extension first, since it doesn't require region-specific
    // data and we want to have the non-normalised number here.
    var withExtensionStripped = (0, $a5PYs.default)(number);
    if (withExtensionStripped.ext) return withExtensionStripped;
    return {
        number: number
    };
}
/**
 * Creates `parse()` result object.
 */ function $b8a959fb4d51e573$var$result(country, nationalNumber, ext) {
    var result = {
        country: country,
        phone: nationalNumber
    };
    if (ext) result.ext = ext;
    return result;
}
/**
 * Parses a viable phone number.
 * @param {string} formattedPhoneNumber — Example: "(213) 373-4253".
 * @param {string} [defaultCountry]
 * @param {string} [defaultCallingCode]
 * @param {Metadata} metadata
 * @return {object} Returns `{ country: string?, countryCallingCode: string?, nationalNumber: string? }`.
 */ function $b8a959fb4d51e573$var$parsePhoneNumber(formattedPhoneNumber, defaultCountry, defaultCallingCode, metadata) {
    // Extract calling code from phone number.
    var _extractCountryCallin = (0, $l3IVT.default)((0, $81pt0.default)(formattedPhoneNumber), defaultCountry, defaultCallingCode, metadata.metadata), countryCallingCode = _extractCountryCallin.countryCallingCode, number = _extractCountryCallin.number; // Choose a country by `countryCallingCode`.
    var country;
    if (countryCallingCode) metadata.selectNumberingPlan(countryCallingCode);
    else if (number && (defaultCountry || defaultCallingCode)) {
        metadata.selectNumberingPlan(defaultCountry, defaultCallingCode);
        if (defaultCountry) country = defaultCountry;
        else {
            /* istanbul ignore if */ if ($b8a959fb4d51e573$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
                if (metadata.isNonGeographicCallingCode(defaultCallingCode)) country = '001';
            }
        }
        countryCallingCode = defaultCallingCode || (0, $lijQr.getCountryCallingCode)(defaultCountry, metadata.metadata);
    } else return {};
    if (!number) return {
        countryCallingCode: countryCallingCode
    };
    var _extractNationalNumbe = (0, $lO22f.default)((0, $81pt0.default)(number), metadata), nationalNumber = _extractNationalNumbe.nationalNumber, carrierCode = _extractNationalNumbe.carrierCode; // Sometimes there are several countries
    // corresponding to the same country phone code
    // (e.g. NANPA countries all having `1` country phone code).
    // Therefore, to reliably determine the exact country,
    // national (significant) number should have been parsed first.
    //
    // When `metadata.json` is generated, all "ambiguous" country phone codes
    // get their countries populated with the full set of
    // "phone number type" regular expressions.
    //
    var exactCountry = (0, $3wXuM.default)(countryCallingCode, nationalNumber, metadata);
    if (exactCountry) {
        country = exactCountry;
        /* istanbul ignore if */ if (exactCountry === '001') ;
        else metadata.country(country);
    }
    return {
        country: country,
        countryCallingCode: countryCallingCode,
        nationalNumber: nationalNumber,
        carrierCode: carrierCode
    };
}

});
parcelRegister("hoHfs", function(module, exports) {

$parcel$export(module.exports, "MIN_LENGTH_FOR_NSN", () => $caa639c664fc3f13$export$cd8355bcbe13154);
$parcel$export(module.exports, "MAX_LENGTH_FOR_NSN", () => $caa639c664fc3f13$export$85ddd8c9b243679b);
$parcel$export(module.exports, "MAX_LENGTH_COUNTRY_CODE", () => $caa639c664fc3f13$export$514717690676fb4a);
$parcel$export(module.exports, "VALID_DIGITS", () => $caa639c664fc3f13$export$852d1d4a47329634);
$parcel$export(module.exports, "VALID_PUNCTUATION", () => $caa639c664fc3f13$export$7f01587e28f9194);
$parcel$export(module.exports, "PLUS_CHARS", () => $caa639c664fc3f13$export$207c99ccf3902df8);
// The minimum length of the national significant number.
var $caa639c664fc3f13$export$cd8355bcbe13154 = 2; // The ITU says the maximum length should be 15,
var $caa639c664fc3f13$export$85ddd8c9b243679b = 17; // The maximum length of the country calling code.
var $caa639c664fc3f13$export$514717690676fb4a = 3; // Digits accepted in phone numbers
var $caa639c664fc3f13$export$852d1d4a47329634 = "0-9\uFF10-\uFF19\u0660-\u0669\u06F0-\u06F9"; // `DASHES` will be right after the opening square bracket of the "character class"
var $caa639c664fc3f13$var$DASHES = "-\u2010-\u2015\u2212\u30FC\uFF0D";
var $caa639c664fc3f13$var$SLASHES = "\uFF0F/";
var $caa639c664fc3f13$var$DOTS = "\uFF0E.";
var $caa639c664fc3f13$export$20542845033f576e = " \xA0\xAD\u200B\u2060\u3000";
var $caa639c664fc3f13$var$BRACKETS = "()\uFF08\uFF09\uFF3B\uFF3D\\[\\]"; // export const OPENING_BRACKETS = '(\uFF08\uFF3B\\\['
var $caa639c664fc3f13$var$TILDES = "~\u2053\u223C\uFF5E"; // Regular expression of acceptable punctuation found in phone numbers. This
var $caa639c664fc3f13$export$7f01587e28f9194 = "".concat($caa639c664fc3f13$var$DASHES).concat($caa639c664fc3f13$var$SLASHES).concat($caa639c664fc3f13$var$DOTS).concat($caa639c664fc3f13$export$20542845033f576e).concat($caa639c664fc3f13$var$BRACKETS).concat($caa639c664fc3f13$var$TILDES);
var $caa639c664fc3f13$export$207c99ccf3902df8 = "+\uFF0B"; // const LEADING_PLUS_CHARS_PATTERN = new RegExp('^[' + PLUS_CHARS + ']+')

});

parcelRegister("1nVPX", function(module, exports) {

$parcel$export(module.exports, "default", () => $1024cdac75ec2b33$export$2e2bcd8739ae039);
function $1024cdac75ec2b33$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
// https://stackoverflow.com/a/46971044/970769
var $1024cdac75ec2b33$export$2e2bcd8739ae039 = function ParseError(code) {
    $1024cdac75ec2b33$var$_classCallCheck(this, ParseError);
    this.name = this.constructor.name;
    this.message = code;
    this.stack = new Error(code).stack;
};
$1024cdac75ec2b33$export$2e2bcd8739ae039.prototype = Object.create(Error.prototype);
$1024cdac75ec2b33$export$2e2bcd8739ae039.prototype.constructor = $1024cdac75ec2b33$export$2e2bcd8739ae039;

});

parcelRegister("lijQr", function(module, exports) {

$parcel$export(module.exports, "default", () => $f80aac35004a54c3$export$2e2bcd8739ae039);
$parcel$export(module.exports, "getCountryCallingCode", () => $f80aac35004a54c3$export$32876ca2f1919cf0);
$parcel$export(module.exports, "isSupportedCountry", () => $f80aac35004a54c3$export$bd9e113b8b17202a);

var $25Yvi = parcelRequire("25Yvi");
function $f80aac35004a54c3$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $f80aac35004a54c3$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $f80aac35004a54c3$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $f80aac35004a54c3$var$_typeof(obj);
}
function $f80aac35004a54c3$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $f80aac35004a54c3$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $f80aac35004a54c3$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $f80aac35004a54c3$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $f80aac35004a54c3$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
// "country_phone_code_to_countries" to "country_calling_codes".
var $f80aac35004a54c3$var$V2 = '1.0.18'; // Added "idd_prefix" and "default_idd_prefix".
var $f80aac35004a54c3$var$V3 = '1.2.0'; // Moved `001` country code to "nonGeographic" section of metadata.
var $f80aac35004a54c3$var$V4 = '1.7.35';
var $f80aac35004a54c3$var$DEFAULT_EXT_PREFIX = ' ext. ';
var $f80aac35004a54c3$var$CALLING_CODE_REG_EXP = /^\d+$/;
/**
 * See: https://gitlab.com/catamphetamine/libphonenumber-js/blob/master/METADATA.md
 */ var $f80aac35004a54c3$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Metadata(metadata) {
        $f80aac35004a54c3$var$_classCallCheck(this, Metadata);
        $f80aac35004a54c3$export$a0b100d4662a8795(metadata);
        this.metadata = metadata;
        $f80aac35004a54c3$var$setVersion.call(this, metadata);
    }
    $f80aac35004a54c3$var$_createClass(Metadata, [
        {
            key: "getCountries",
            value: function getCountries() {
                return Object.keys(this.metadata.countries).filter(function(_) {
                    return _ !== '001';
                });
            }
        },
        {
            key: "getCountryMetadata",
            value: function getCountryMetadata(countryCode) {
                return this.metadata.countries[countryCode];
            }
        },
        {
            key: "nonGeographic",
            value: function nonGeographic() {
                if (this.v1 || this.v2 || this.v3) return; // `nonGeographical` was a typo.
                // It's present in metadata generated from `1.7.35` to `1.7.37`.
                return this.metadata.nonGeographic || this.metadata.nonGeographical;
            }
        },
        {
            key: "hasCountry",
            value: function hasCountry(country) {
                return this.getCountryMetadata(country) !== undefined;
            }
        },
        {
            key: "hasCallingCode",
            value: function hasCallingCode(callingCode) {
                if (this.getCountryCodesForCallingCode(callingCode)) return true;
                if (this.nonGeographic()) {
                    if (this.nonGeographic()[callingCode]) return true;
                } else {
                    // A hacky workaround for old custom metadata (generated before V4).
                    var countryCodes = this.countryCallingCodes()[callingCode];
                    if (countryCodes && countryCodes.length === 1 && countryCodes[0] === '001') return true;
                }
            }
        },
        {
            key: "isNonGeographicCallingCode",
            value: function isNonGeographicCallingCode(callingCode) {
                if (this.nonGeographic()) return this.nonGeographic()[callingCode] ? true : false;
                else return this.getCountryCodesForCallingCode(callingCode) ? false : true;
            } // Deprecated.
        },
        {
            key: "country",
            value: function country(countryCode) {
                return this.selectNumberingPlan(countryCode);
            }
        },
        {
            key: "selectNumberingPlan",
            value: function selectNumberingPlan(countryCode, callingCode) {
                // Supports just passing `callingCode` as the first argument.
                if (countryCode && $f80aac35004a54c3$var$CALLING_CODE_REG_EXP.test(countryCode)) {
                    callingCode = countryCode;
                    countryCode = null;
                }
                if (countryCode && countryCode !== '001') {
                    if (!this.hasCountry(countryCode)) throw new Error("Unknown country: ".concat(countryCode));
                    this.numberingPlan = new $f80aac35004a54c3$var$NumberingPlan(this.getCountryMetadata(countryCode), this);
                } else if (callingCode) {
                    if (!this.hasCallingCode(callingCode)) throw new Error("Unknown calling code: ".concat(callingCode));
                    this.numberingPlan = new $f80aac35004a54c3$var$NumberingPlan(this.getNumberingPlanMetadata(callingCode), this);
                } else this.numberingPlan = undefined;
                return this;
            }
        },
        {
            key: "getCountryCodesForCallingCode",
            value: function getCountryCodesForCallingCode(callingCode) {
                var countryCodes = this.countryCallingCodes()[callingCode];
                if (countryCodes) {
                    // Metadata before V4 included "non-geographic entity" calling codes
                    // inside `country_calling_codes` (for example, `"881":["001"]`).
                    // Now the semantics of `country_calling_codes` has changed:
                    // it's specifically for "countries" now.
                    // Older versions of custom metadata will simply skip parsing
                    // "non-geographic entity" phone numbers with new versions
                    // of this library: it's not considered a bug,
                    // because such numbers are extremely rare,
                    // and developers extremely rarely use custom metadata.
                    if (countryCodes.length === 1 && countryCodes[0].length === 3) return;
                    return countryCodes;
                }
            }
        },
        {
            key: "getCountryCodeForCallingCode",
            value: function getCountryCodeForCallingCode(callingCode) {
                var countryCodes = this.getCountryCodesForCallingCode(callingCode);
                if (countryCodes) return countryCodes[0];
            }
        },
        {
            key: "getNumberingPlanMetadata",
            value: function getNumberingPlanMetadata(callingCode) {
                var countryCode = this.getCountryCodeForCallingCode(callingCode);
                if (countryCode) return this.getCountryMetadata(countryCode);
                if (this.nonGeographic()) {
                    var metadata = this.nonGeographic()[callingCode];
                    if (metadata) return metadata;
                } else {
                    // A hacky workaround for old custom metadata (generated before V4).
                    var countryCodes = this.countryCallingCodes()[callingCode];
                    if (countryCodes && countryCodes.length === 1 && countryCodes[0] === '001') return this.metadata.countries['001'];
                }
            } // Deprecated.
        },
        {
            key: "countryCallingCode",
            value: function countryCallingCode() {
                return this.numberingPlan.callingCode();
            } // Deprecated.
        },
        {
            key: "IDDPrefix",
            value: function IDDPrefix() {
                return this.numberingPlan.IDDPrefix();
            } // Deprecated.
        },
        {
            key: "defaultIDDPrefix",
            value: function defaultIDDPrefix() {
                return this.numberingPlan.defaultIDDPrefix();
            } // Deprecated.
        },
        {
            key: "nationalNumberPattern",
            value: function nationalNumberPattern() {
                return this.numberingPlan.nationalNumberPattern();
            } // Deprecated.
        },
        {
            key: "possibleLengths",
            value: function possibleLengths() {
                return this.numberingPlan.possibleLengths();
            } // Deprecated.
        },
        {
            key: "formats",
            value: function formats() {
                return this.numberingPlan.formats();
            } // Deprecated.
        },
        {
            key: "nationalPrefixForParsing",
            value: function nationalPrefixForParsing() {
                return this.numberingPlan.nationalPrefixForParsing();
            } // Deprecated.
        },
        {
            key: "nationalPrefixTransformRule",
            value: function nationalPrefixTransformRule() {
                return this.numberingPlan.nationalPrefixTransformRule();
            } // Deprecated.
        },
        {
            key: "leadingDigits",
            value: function leadingDigits() {
                return this.numberingPlan.leadingDigits();
            } // Deprecated.
        },
        {
            key: "hasTypes",
            value: function hasTypes() {
                return this.numberingPlan.hasTypes();
            } // Deprecated.
        },
        {
            key: "type",
            value: function type(_type) {
                return this.numberingPlan.type(_type);
            } // Deprecated.
        },
        {
            key: "ext",
            value: function ext() {
                return this.numberingPlan.ext();
            }
        },
        {
            key: "countryCallingCodes",
            value: function countryCallingCodes() {
                if (this.v1) return this.metadata.country_phone_code_to_countries;
                return this.metadata.country_calling_codes;
            } // Deprecated.
        },
        {
            key: "chooseCountryByCountryCallingCode",
            value: function chooseCountryByCountryCallingCode(callingCode) {
                return this.selectNumberingPlan(callingCode);
            }
        },
        {
            key: "hasSelectedNumberingPlan",
            value: function hasSelectedNumberingPlan() {
                return this.numberingPlan !== undefined;
            }
        }
    ]);
    return Metadata;
}();
var $f80aac35004a54c3$var$NumberingPlan = /*#__PURE__*/ function() {
    function NumberingPlan(metadata, globalMetadataObject) {
        $f80aac35004a54c3$var$_classCallCheck(this, NumberingPlan);
        this.globalMetadataObject = globalMetadataObject;
        this.metadata = metadata;
        $f80aac35004a54c3$var$setVersion.call(this, globalMetadataObject.metadata);
    }
    $f80aac35004a54c3$var$_createClass(NumberingPlan, [
        {
            key: "callingCode",
            value: function callingCode() {
                return this.metadata[0];
            } // Formatting information for regions which share
        },
        {
            key: "getDefaultCountryMetadataForRegion",
            value: function getDefaultCountryMetadataForRegion() {
                return this.globalMetadataObject.getNumberingPlanMetadata(this.callingCode());
            }
        },
        {
            key: "IDDPrefix",
            value: function IDDPrefix() {
                if (this.v1 || this.v2) return;
                return this.metadata[1];
            }
        },
        {
            key: "defaultIDDPrefix",
            value: function defaultIDDPrefix() {
                if (this.v1 || this.v2) return;
                return this.metadata[12];
            }
        },
        {
            key: "nationalNumberPattern",
            value: function nationalNumberPattern() {
                if (this.v1 || this.v2) return this.metadata[1];
                return this.metadata[2];
            }
        },
        {
            key: "possibleLengths",
            value: function possibleLengths() {
                if (this.v1) return;
                return this.metadata[this.v2 ? 2 : 3];
            }
        },
        {
            key: "_getFormats",
            value: function _getFormats(metadata) {
                return metadata[this.v1 ? 2 : this.v2 ? 3 : 4];
            } // For countries of the same region (e.g. NANPA)
        },
        {
            key: "formats",
            value: function formats() {
                var _this = this;
                var formats = this._getFormats(this.metadata) || this._getFormats(this.getDefaultCountryMetadataForRegion()) || [];
                return formats.map(function(_) {
                    return new $f80aac35004a54c3$var$Format(_, _this);
                });
            }
        },
        {
            key: "nationalPrefix",
            value: function nationalPrefix() {
                return this.metadata[this.v1 ? 3 : this.v2 ? 4 : 5];
            }
        },
        {
            key: "_getNationalPrefixFormattingRule",
            value: function _getNationalPrefixFormattingRule(metadata) {
                return metadata[this.v1 ? 4 : this.v2 ? 5 : 6];
            } // For countries of the same region (e.g. NANPA)
        },
        {
            key: "nationalPrefixFormattingRule",
            value: function nationalPrefixFormattingRule() {
                return this._getNationalPrefixFormattingRule(this.metadata) || this._getNationalPrefixFormattingRule(this.getDefaultCountryMetadataForRegion());
            }
        },
        {
            key: "_nationalPrefixForParsing",
            value: function _nationalPrefixForParsing() {
                return this.metadata[this.v1 ? 5 : this.v2 ? 6 : 7];
            }
        },
        {
            key: "nationalPrefixForParsing",
            value: function nationalPrefixForParsing() {
                // If `national_prefix_for_parsing` is not set explicitly,
                // then infer it from `national_prefix` (if any)
                return this._nationalPrefixForParsing() || this.nationalPrefix();
            }
        },
        {
            key: "nationalPrefixTransformRule",
            value: function nationalPrefixTransformRule() {
                return this.metadata[this.v1 ? 6 : this.v2 ? 7 : 8];
            }
        },
        {
            key: "_getNationalPrefixIsOptionalWhenFormatting",
            value: function _getNationalPrefixIsOptionalWhenFormatting() {
                return !!this.metadata[this.v1 ? 7 : this.v2 ? 8 : 9];
            } // For countries of the same region (e.g. NANPA)
        },
        {
            key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
            value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
                return this._getNationalPrefixIsOptionalWhenFormatting(this.metadata) || this._getNationalPrefixIsOptionalWhenFormatting(this.getDefaultCountryMetadataForRegion());
            }
        },
        {
            key: "leadingDigits",
            value: function leadingDigits() {
                return this.metadata[this.v1 ? 8 : this.v2 ? 9 : 10];
            }
        },
        {
            key: "types",
            value: function types() {
                return this.metadata[this.v1 ? 9 : this.v2 ? 10 : 11];
            }
        },
        {
            key: "hasTypes",
            value: function hasTypes() {
                // Versions 1.2.0 - 1.2.4: can be `[]`.
                /* istanbul ignore next */ if (this.types() && this.types().length === 0) return false;
                 // Versions <= 1.2.4: can be `undefined`.
                // Version >= 1.2.5: can be `0`.
                return !!this.types();
            }
        },
        {
            key: "type",
            value: function type(_type2) {
                if (this.hasTypes() && $f80aac35004a54c3$var$getType(this.types(), _type2)) return new $f80aac35004a54c3$var$Type($f80aac35004a54c3$var$getType(this.types(), _type2), this);
            }
        },
        {
            key: "ext",
            value: function ext() {
                if (this.v1 || this.v2) return $f80aac35004a54c3$var$DEFAULT_EXT_PREFIX;
                return this.metadata[13] || $f80aac35004a54c3$var$DEFAULT_EXT_PREFIX;
            }
        }
    ]);
    return NumberingPlan;
}();
var $f80aac35004a54c3$var$Format = /*#__PURE__*/ function() {
    function Format(format, metadata) {
        $f80aac35004a54c3$var$_classCallCheck(this, Format);
        this._format = format;
        this.metadata = metadata;
    }
    $f80aac35004a54c3$var$_createClass(Format, [
        {
            key: "pattern",
            value: function pattern() {
                return this._format[0];
            }
        },
        {
            key: "format",
            value: function format() {
                return this._format[1];
            }
        },
        {
            key: "leadingDigitsPatterns",
            value: function leadingDigitsPatterns() {
                return this._format[2] || [];
            }
        },
        {
            key: "nationalPrefixFormattingRule",
            value: function nationalPrefixFormattingRule() {
                return this._format[3] || this.metadata.nationalPrefixFormattingRule();
            }
        },
        {
            key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
            value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
                return !!this._format[4] || this.metadata.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
            }
        },
        {
            key: "nationalPrefixIsMandatoryWhenFormattingInNationalFormat",
            value: function nationalPrefixIsMandatoryWhenFormattingInNationalFormat() {
                // National prefix is omitted if there's no national prefix formatting rule
                // set for this country, or when the national prefix formatting rule
                // contains no national prefix itself, or when this rule is set but
                // national prefix is optional for this phone number format
                // (and it is not enforced explicitly)
                return this.usesNationalPrefix() && !this.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
            } // Checks whether national prefix formatting rule contains national prefix.
        },
        {
            key: "usesNationalPrefix",
            value: function usesNationalPrefix() {
                return this.nationalPrefixFormattingRule() && // Check that national prefix formatting rule is not a "dummy" one.
                !$f80aac35004a54c3$var$FIRST_GROUP_ONLY_PREFIX_PATTERN.test(this.nationalPrefixFormattingRule()) // In compressed metadata, `this.nationalPrefixFormattingRule()` is `0`
                 ? true : false;
            }
        },
        {
            key: "internationalFormat",
            value: function internationalFormat() {
                return this._format[5] || this.format();
            }
        }
    ]);
    return Format;
}();
/**
 * A pattern that is used to determine if the national prefix formatting rule
 * has the first group only, i.e., does not start with the national prefix.
 * Note that the pattern explicitly allows for unbalanced parentheses.
 */ var $f80aac35004a54c3$var$FIRST_GROUP_ONLY_PREFIX_PATTERN = /^\(?\$1\)?$/;
var $f80aac35004a54c3$var$Type = /*#__PURE__*/ function() {
    function Type(type, metadata) {
        $f80aac35004a54c3$var$_classCallCheck(this, Type);
        this.type = type;
        this.metadata = metadata;
    }
    $f80aac35004a54c3$var$_createClass(Type, [
        {
            key: "pattern",
            value: function pattern() {
                if (this.metadata.v1) return this.type;
                return this.type[0];
            }
        },
        {
            key: "possibleLengths",
            value: function possibleLengths() {
                if (this.metadata.v1) return;
                return this.type[1] || this.metadata.possibleLengths();
            }
        }
    ]);
    return Type;
}();
function $f80aac35004a54c3$var$getType(types, type) {
    switch(type){
        case 'FIXED_LINE':
            return types[0];
        case 'MOBILE':
            return types[1];
        case 'TOLL_FREE':
            return types[2];
        case 'PREMIUM_RATE':
            return types[3];
        case 'PERSONAL_NUMBER':
            return types[4];
        case 'VOICEMAIL':
            return types[5];
        case 'UAN':
            return types[6];
        case 'PAGER':
            return types[7];
        case 'VOIP':
            return types[8];
        case 'SHARED_COST':
            return types[9];
    }
}
function $f80aac35004a54c3$export$a0b100d4662a8795(metadata) {
    if (!metadata) throw new Error('[libphonenumber-js] `metadata` argument not passed. Check your arguments.');
     // `country_phone_code_to_countries` was renamed to
    // `country_calling_codes` in `1.0.18`.
    if (!$f80aac35004a54c3$var$is_object(metadata) || !$f80aac35004a54c3$var$is_object(metadata.countries)) throw new Error("[libphonenumber-js] `metadata` argument was passed but it's not a valid metadata. Must be an object having `.countries` child object property. Got ".concat($f80aac35004a54c3$var$is_object(metadata) ? 'an object of shape: { ' + Object.keys(metadata).join(', ') + ' }' : 'a ' + $f80aac35004a54c3$var$type_of(metadata) + ': ' + metadata, "."));
} // Babel transforms `typeof` into some "branches"
// so istanbul will show this as "branch not covered".
/* istanbul ignore next */ var $f80aac35004a54c3$var$is_object = function is_object(_) {
    return $f80aac35004a54c3$var$_typeof(_) === 'object';
}; // Babel transforms `typeof` into some "branches"
// so istanbul will show this as "branch not covered".
/* istanbul ignore next */ var $f80aac35004a54c3$var$type_of = function type_of(_) {
    return $f80aac35004a54c3$var$_typeof(_);
};
function $f80aac35004a54c3$export$9b48c965eafc2cf6(country, metadata) {
    metadata = new $f80aac35004a54c3$export$2e2bcd8739ae039(metadata);
    if (metadata.hasCountry(country)) return metadata.country(country).ext();
    return $f80aac35004a54c3$var$DEFAULT_EXT_PREFIX;
}
function $f80aac35004a54c3$export$32876ca2f1919cf0(country, metadata) {
    metadata = new $f80aac35004a54c3$export$2e2bcd8739ae039(metadata);
    if (metadata.hasCountry(country)) return metadata.country(country).countryCallingCode();
    throw new Error("Unknown country: ".concat(country));
}
function $f80aac35004a54c3$export$bd9e113b8b17202a(country, metadata) {
    // metadata = new Metadata(metadata)
    // return metadata.hasCountry(country)
    return metadata.countries[country] !== undefined;
}
function $f80aac35004a54c3$var$setVersion(metadata) {
    var version = metadata.version;
    if (typeof version === 'number') {
        this.v1 = version === 1;
        this.v2 = version === 2;
        this.v3 = version === 3;
        this.v4 = version === 4;
    } else {
        if (!version) this.v1 = true;
        else if ((0, $25Yvi.default)(version, $f80aac35004a54c3$var$V3) === -1) this.v2 = true;
        else if ((0, $25Yvi.default)(version, $f80aac35004a54c3$var$V4) === -1) this.v3 = true;
        else this.v4 = true;
    }
} // const ISO_COUNTRY_CODE = /^[A-Z]{2}$/
 // function isCountryCode(countryCode) {
 // 	return ISO_COUNTRY_CODE.test(countryCodeOrCountryCallingCode)
 // }

});
parcelRegister("25Yvi", function(module, exports) {

$parcel$export(module.exports, "default", () => $186afb3191e0d707$export$2e2bcd8739ae039);
// Copy-pasted from:
// https://github.com/substack/semver-compare/blob/master/index.js
//
// Inlining this function because some users reported issues with
// importing from `semver-compare` in a browser with ES6 "native" modules.
//
// Fixes `semver-compare` not being able to compare versions with alpha/beta/etc "tags".
// https://github.com/catamphetamine/libphonenumber-js/issues/381
function $186afb3191e0d707$export$2e2bcd8739ae039(a, b) {
    a = a.split('-');
    b = b.split('-');
    var pa = a[0].split('.');
    var pb = b[0].split('.');
    for(var i = 0; i < 3; i++){
        var na = Number(pa[i]);
        var nb = Number(pb[i]);
        if (na > nb) return 1;
        if (nb > na) return -1;
        if (!isNaN(na) && isNaN(nb)) return 1;
        if (isNaN(na) && !isNaN(nb)) return -1;
    }
    if (a[1] && b[1]) return a[1] > b[1] ? 1 : a[1] < b[1] ? -1 : 0;
    return !a[1] && b[1] ? 1 : a[1] && !b[1] ? -1 : 0;
}

});


parcelRegister("6K6oP", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e8c00bca37e184a$export$2e2bcd8739ae039);
$parcel$export(module.exports, "isViablePhoneNumberStart", () => $4e8c00bca37e184a$export$4c3f76c95c05197c);

var $hoHfs = parcelRequire("hoHfs");

var $gVDsZ = parcelRequire("gVDsZ");
//  Checks we have at least three leading digits, and only valid punctuation,
//  alpha characters and digits in the phone number. Does not include extension
//  data. The symbol 'x' is allowed here as valid punctuation since it is often
//  used as a placeholder for carrier codes, for example in Brazilian phone
//  numbers. We also allow multiple '+' characters at the start.
//
//  Corresponds to the following:
//  [digits]{minLengthNsn}|
//  plus_sign*
//  (([punctuation]|[star])*[digits]){3,}([punctuation]|[star]|[digits]|[alpha])*
//
//  The first reg-ex is to allow short numbers (two digits long) to be parsed if
//  they are entered as "15" etc, but only if there is no punctuation in them.
//  The second expression restricts the number of digits to three or more, but
//  then allows them to be in international form, and to have alpha-characters
//  and punctuation. We split up the two reg-exes here and combine them when
//  creating the reg-ex VALID_PHONE_NUMBER_PATTERN itself so we can prefix it
//  with ^ and append $ to each branch.
//
//  "Note VALID_PUNCTUATION starts with a -,
//   so must be the first in the range" (c) Google devs.
//  (wtf did they mean by saying that; probably nothing)
//
var $4e8c00bca37e184a$var$MIN_LENGTH_PHONE_NUMBER_PATTERN = '[' + (0, $hoHfs.VALID_DIGITS) + ']{' + (0, $hoHfs.MIN_LENGTH_FOR_NSN) + '}'; //
var $4e8c00bca37e184a$export$a77dd7471651eee = '[' + (0, $hoHfs.PLUS_CHARS) + ']{0,1}' + '(?:' + '[' + (0, $hoHfs.VALID_PUNCTUATION) + ']*' + '[' + (0, $hoHfs.VALID_DIGITS) + ']' + '){3,}' + '[' + (0, $hoHfs.VALID_PUNCTUATION) + (0, $hoHfs.VALID_DIGITS) + ']*'; // This regular expression isn't present in Google's `libphonenumber`
// and is only used to determine whether the phone number being input
// is too short for it to even consider it a "valid" number.
// This is just a way to differentiate between a really invalid phone
// number like "abcde" and a valid phone number that a user has just
// started inputting, like "+1" or "1": both these cases would be
// considered `NOT_A_NUMBER` by Google's `libphonenumber`, but this
// library can provide a more detailed error message — whether it's
// really "not a number", or is it just a start of a valid phone number.
var $4e8c00bca37e184a$var$VALID_PHONE_NUMBER_START_REG_EXP = new RegExp("^[" + (0, $hoHfs.PLUS_CHARS) + ']{0,1}' + '(?:' + '[' + (0, $hoHfs.VALID_PUNCTUATION) + ']*' + '[' + (0, $hoHfs.VALID_DIGITS) + ']' + '){1,2}' + '$', 'i');
var $4e8c00bca37e184a$export$a2d12a04749c087d = $4e8c00bca37e184a$export$a77dd7471651eee + // Phone number extensions
'(?:' + (0, $gVDsZ.default)() + ')?'; // The combined regular expression for valid phone numbers:
//
var $4e8c00bca37e184a$var$VALID_PHONE_NUMBER_PATTERN = new RegExp('^' + $4e8c00bca37e184a$var$MIN_LENGTH_PHONE_NUMBER_PATTERN + '$' + '|' + // Or a longer fully parsed phone number (min 3 characters)
'^' + $4e8c00bca37e184a$export$a2d12a04749c087d + '$', 'i'); // Checks to see if the string of characters could possibly be a phone number at
function $4e8c00bca37e184a$export$2e2bcd8739ae039(number) {
    return number.length >= (0, $hoHfs.MIN_LENGTH_FOR_NSN) && $4e8c00bca37e184a$var$VALID_PHONE_NUMBER_PATTERN.test(number);
} // This is just a way to differentiate between a really invalid phone
function $4e8c00bca37e184a$export$4c3f76c95c05197c(number) {
    return $4e8c00bca37e184a$var$VALID_PHONE_NUMBER_START_REG_EXP.test(number);
}

});
parcelRegister("gVDsZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5309573f87def67$export$2e2bcd8739ae039);

var $hoHfs = parcelRequire("hoHfs");
var $c5309573f87def67$var$RFC3966_EXTN_PREFIX = ';ext=';
/**
 * Helper method for constructing regular expressions for parsing. Creates
 * an expression that captures up to max_length digits.
 * @return {string} RegEx pattern to capture extension digits.
 */ var $c5309573f87def67$var$getExtensionDigitsPattern = function getExtensionDigitsPattern(maxLength) {
    return "([".concat((0, $hoHfs.VALID_DIGITS), "]{1,").concat(maxLength, "})");
};
function $c5309573f87def67$export$2e2bcd8739ae039(purpose) {
    // We cap the maximum length of an extension based on the ambiguity of the way
    // the extension is prefixed. As per ITU, the officially allowed length for
    // extensions is actually 40, but we don't support this since we haven't seen real
    // examples and this introduces many false interpretations as the extension labels
    // are not standardized.
    /** @type {string} */ var extLimitAfterExplicitLabel = '20';
    /** @type {string} */ var extLimitAfterLikelyLabel = '15';
    /** @type {string} */ var extLimitAfterAmbiguousChar = '9';
    /** @type {string} */ var extLimitWhenNotSure = '6';
    /** @type {string} */ var possibleSeparatorsBetweenNumberAndExtLabel = "[ \xA0\\t,]*"; // Optional full stop (.) or colon, followed by zero or more spaces/tabs/commas.
    /** @type {string} */ var possibleCharsAfterExtLabel = "[:\\.\uFF0E]?[ \xA0\\t,-]*";
    /** @type {string} */ var optionalExtnSuffix = "#?"; // Here the extension is called out in more explicit way, i.e mentioning it obvious
    // patterns like "ext.".
    /** @type {string} */ var explicitExtLabels = "(?:e?xt(?:ensi(?:o\u0301?|\xF3))?n?|\uFF45?\uFF58\uFF54\uFF4E?|\u0434\u043E\u0431|anexo)"; // One-character symbols that can be used to indicate an extension, and less
    // commonly used or more ambiguous extension labels.
    /** @type {string} */ var ambiguousExtLabels = "(?:[x\uFF58#\uFF03~\uFF5E]|int|\uFF49\uFF4E\uFF54)"; // When extension is not separated clearly.
    /** @type {string} */ var ambiguousSeparator = "[- ]+"; // This is the same as possibleSeparatorsBetweenNumberAndExtLabel, but not matching
    // comma as extension label may have it.
    /** @type {string} */ var possibleSeparatorsNumberExtLabelNoComma = "[ \xA0\\t]*"; // ",," is commonly used for auto dialling the extension when connected. First
    // comma is matched through possibleSeparatorsBetweenNumberAndExtLabel, so we do
    // not repeat it here. Semi-colon works in Iphone and Android also to pop up a
    // button with the extension number following.
    /** @type {string} */ var autoDiallingAndExtLabelsFound = "(?:,{2}|;)";
    /** @type {string} */ var rfcExtn = $c5309573f87def67$var$RFC3966_EXTN_PREFIX + $c5309573f87def67$var$getExtensionDigitsPattern(extLimitAfterExplicitLabel);
    /** @type {string} */ var explicitExtn = possibleSeparatorsBetweenNumberAndExtLabel + explicitExtLabels + possibleCharsAfterExtLabel + $c5309573f87def67$var$getExtensionDigitsPattern(extLimitAfterExplicitLabel) + optionalExtnSuffix;
    /** @type {string} */ var ambiguousExtn = possibleSeparatorsBetweenNumberAndExtLabel + ambiguousExtLabels + possibleCharsAfterExtLabel + $c5309573f87def67$var$getExtensionDigitsPattern(extLimitAfterAmbiguousChar) + optionalExtnSuffix;
    /** @type {string} */ var americanStyleExtnWithSuffix = ambiguousSeparator + $c5309573f87def67$var$getExtensionDigitsPattern(extLimitWhenNotSure) + "#";
    /** @type {string} */ var autoDiallingExtn = possibleSeparatorsNumberExtLabelNoComma + autoDiallingAndExtLabelsFound + possibleCharsAfterExtLabel + $c5309573f87def67$var$getExtensionDigitsPattern(extLimitAfterLikelyLabel) + optionalExtnSuffix;
    /** @type {string} */ var onlyCommasExtn = possibleSeparatorsNumberExtLabelNoComma + "(?:,)+" + possibleCharsAfterExtLabel + $c5309573f87def67$var$getExtensionDigitsPattern(extLimitAfterAmbiguousChar) + optionalExtnSuffix; // The first regular expression covers RFC 3966 format, where the extension is added
    // using ";ext=". The second more generic where extension is mentioned with explicit
    // labels like "ext:". In both the above cases we allow more numbers in extension than
    // any other extension labels. The third one captures when single character extension
    // labels or less commonly used labels are used. In such cases we capture fewer
    // extension digits in order to reduce the chance of falsely interpreting two
    // numbers beside each other as a number + extension. The fourth one covers the
    // special case of American numbers where the extension is written with a hash
    // at the end, such as "- 503#". The fifth one is exclusively for extension
    // autodialling formats which are used when dialling and in this case we accept longer
    // extensions. The last one is more liberal on the number of commas that acts as
    // extension labels, so we have a strict cap on the number of digits in such extensions.
    return rfcExtn + "|" + explicitExtn + "|" + ambiguousExtn + "|" + americanStyleExtnWithSuffix + "|" + autoDiallingExtn + "|" + onlyCommasExtn;
}

});


parcelRegister("a5PYs", function(module, exports) {

$parcel$export(module.exports, "default", () => $7592affeb0e135a4$export$2e2bcd8739ae039);

var $gVDsZ = parcelRequire("gVDsZ");
// 1 or more valid digits, for use when parsing.
var $7592affeb0e135a4$var$EXTN_PATTERN = new RegExp('(?:' + (0, $gVDsZ.default)() + ')$', 'i'); // Strips any extension (as in, the part of the number dialled after the call is
function $7592affeb0e135a4$export$2e2bcd8739ae039(number) {
    var start = number.search($7592affeb0e135a4$var$EXTN_PATTERN);
    if (start < 0) return {};
     // If we find a potential extension, and the number preceding this is a viable
    // number, we assume it is an extension.
    var numberWithoutExtension = number.slice(0, start);
    var matches = number.match($7592affeb0e135a4$var$EXTN_PATTERN);
    var i = 1;
    while(i < matches.length){
        if (matches[i]) return {
            number: numberWithoutExtension,
            ext: matches[i]
        };
        i++;
    }
}

});

parcelRegister("81pt0", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d722be4de9b0760$export$2e2bcd8739ae039);

var $fkobN = parcelRequire("fkobN");
function $5d722be4de9b0760$export$2e2bcd8739ae039(string) {
    var result = ''; // Using `.split('')` here instead of normal `for ... of`
    // because the importing application doesn't neccessarily include an ES6 polyfill.
    // The `.split('')` approach discards "exotic" UTF-8 characters
    // (the ones consisting of four bytes) but digits
    // (including non-European ones) don't fall into that range
    // so such "exotic" characters would be discarded anyway.
    for(var _iterator = string.split(''), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;){
        var _ref;
        if (_isArray) {
            if (_i >= _iterator.length) break;
            _ref = _iterator[_i++];
        } else {
            _i = _iterator.next();
            if (_i.done) break;
            _ref = _i.value;
        }
        var character = _ref;
        result += $5d722be4de9b0760$export$13d8790d7fb84c28(character, result) || '';
    }
    return result;
}
function $5d722be4de9b0760$export$13d8790d7fb84c28(character, prevParsedCharacters) {
    // Only allow a leading `+`.
    if (character === '+') {
        // If this `+` is not the first parsed character
        // then discard it.
        if (prevParsedCharacters) return;
        return '+';
    } // Allow digits.
    return (0, $fkobN.parseDigit)(character);
}

});
parcelRegister("fkobN", function(module, exports) {

$parcel$export(module.exports, "parseDigit", () => $b28b7cc57bbfdda6$export$1d16fddea1437169);
$parcel$export(module.exports, "default", () => $b28b7cc57bbfdda6$export$2e2bcd8739ae039);
// These mappings map a character (key) to a specific digit that should
// replace it for normalization purposes. Non-European digits that
// may be used in phone numbers are mapped to a European equivalent.
//
// E.g. in Iraq they don't write `+442323234` but rather `+٤٤٢٣٢٣٢٣٤`.
//
var $b28b7cc57bbfdda6$export$2848f3d68c08fe69 = {
    '0': '0',
    '1': '1',
    '2': '2',
    '3': '3',
    '4': '4',
    '5': '5',
    '6': '6',
    '7': '7',
    '8': '8',
    '9': '9',
    "\uFF10": '0',
    // Fullwidth digit 0
    "\uFF11": '1',
    // Fullwidth digit 1
    "\uFF12": '2',
    // Fullwidth digit 2
    "\uFF13": '3',
    // Fullwidth digit 3
    "\uFF14": '4',
    // Fullwidth digit 4
    "\uFF15": '5',
    // Fullwidth digit 5
    "\uFF16": '6',
    // Fullwidth digit 6
    "\uFF17": '7',
    // Fullwidth digit 7
    "\uFF18": '8',
    // Fullwidth digit 8
    "\uFF19": '9',
    // Fullwidth digit 9
    "\u0660": '0',
    // Arabic-indic digit 0
    "\u0661": '1',
    // Arabic-indic digit 1
    "\u0662": '2',
    // Arabic-indic digit 2
    "\u0663": '3',
    // Arabic-indic digit 3
    "\u0664": '4',
    // Arabic-indic digit 4
    "\u0665": '5',
    // Arabic-indic digit 5
    "\u0666": '6',
    // Arabic-indic digit 6
    "\u0667": '7',
    // Arabic-indic digit 7
    "\u0668": '8',
    // Arabic-indic digit 8
    "\u0669": '9',
    // Arabic-indic digit 9
    "\u06F0": '0',
    // Eastern-Arabic digit 0
    "\u06F1": '1',
    // Eastern-Arabic digit 1
    "\u06F2": '2',
    // Eastern-Arabic digit 2
    "\u06F3": '3',
    // Eastern-Arabic digit 3
    "\u06F4": '4',
    // Eastern-Arabic digit 4
    "\u06F5": '5',
    // Eastern-Arabic digit 5
    "\u06F6": '6',
    // Eastern-Arabic digit 6
    "\u06F7": '7',
    // Eastern-Arabic digit 7
    "\u06F8": '8',
    // Eastern-Arabic digit 8
    "\u06F9": '9' // Eastern-Arabic digit 9
};
function $b28b7cc57bbfdda6$export$1d16fddea1437169(character) {
    return $b28b7cc57bbfdda6$export$2848f3d68c08fe69[character];
}
function $b28b7cc57bbfdda6$export$2e2bcd8739ae039(string) {
    var result = ''; // Using `.split('')` here instead of normal `for ... of`
    // because the importing application doesn't neccessarily include an ES6 polyfill.
    // The `.split('')` approach discards "exotic" UTF-8 characters
    // (the ones consisting of four bytes) but digits
    // (including non-European ones) don't fall into that range
    // so such "exotic" characters would be discarded anyway.
    for(var _iterator = string.split(''), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;){
        var _ref;
        if (_isArray) {
            if (_i >= _iterator.length) break;
            _ref = _iterator[_i++];
        } else {
            _i = _iterator.next();
            if (_i.done) break;
            _ref = _i.value;
        }
        var character = _ref;
        var digit = $b28b7cc57bbfdda6$export$1d16fddea1437169(character);
        if (digit) result += digit;
    }
    return result;
}

});


parcelRegister("idCyj", function(module, exports) {

$parcel$export(module.exports, "default", () => $d437589d475d3664$export$2e2bcd8739ae039);
$parcel$export(module.exports, "isPossibleNumber", () => $d437589d475d3664$export$4f8890cedf1e0497);

var $lijQr = parcelRequire("lijQr");

var $jllIH = parcelRequire("jllIH");
function $d437589d475d3664$export$2e2bcd8739ae039(input, options, metadata) {
    /* istanbul ignore if */ if (options === undefined) options = {};
    metadata = new (0, $lijQr.default)(metadata);
    if (options.v2) {
        if (!input.countryCallingCode) throw new Error('Invalid phone number object passed');
        metadata.selectNumberingPlan(input.countryCallingCode);
    } else {
        if (!input.phone) return false;
        if (input.country) {
            if (!metadata.hasCountry(input.country)) throw new Error("Unknown country: ".concat(input.country));
            metadata.country(input.country);
        } else {
            if (!input.countryCallingCode) throw new Error('Invalid phone number object passed');
            metadata.selectNumberingPlan(input.countryCallingCode);
        }
    }
    if (metadata.possibleLengths()) return $d437589d475d3664$export$4f8890cedf1e0497(input.phone || input.nationalNumber, metadata);
    else {
        // There was a bug between `1.7.35` and `1.7.37` where "possible_lengths"
        // were missing for "non-geographical" numbering plans.
        // Just assume the number is possible in such cases:
        // it's unlikely that anyone generated their custom metadata
        // in that short period of time (one day).
        // This code can be removed in some future major version update.
        if (input.countryCallingCode && metadata.isNonGeographicCallingCode(input.countryCallingCode)) // "Non-geographic entities" did't have `possibleLengths`
        // due to a bug in metadata generation process.
        return true;
        else throw new Error('Missing "possibleLengths" in metadata. Perhaps the metadata has been generated before v1.0.18.');
    }
}
function $d437589d475d3664$export$4f8890cedf1e0497(nationalNumber, metadata) {
    //, isInternational) {
    switch((0, $jllIH.default)(nationalNumber, metadata)){
        case 'IS_POSSIBLE':
            return true;
        // This library ignores "local-only" phone numbers (for simplicity).
        // See the readme for more info on what are "local-only" phone numbers.
        // case 'IS_POSSIBLE_LOCAL_ONLY':
        // 	return !isInternational
        default:
            return false;
    }
}

});
parcelRegister("jllIH", function(module, exports) {

$parcel$export(module.exports, "default", () => $e150d39adca76f23$export$2e2bcd8739ae039);

var $OBrgA = parcelRequire("OBrgA");
function $e150d39adca76f23$export$2e2bcd8739ae039(nationalNumber, metadata) {
    return $e150d39adca76f23$export$69333f603c7d5931(nationalNumber, undefined, metadata);
} // Checks whether a number is possible for the country based on its length.
function $e150d39adca76f23$export$69333f603c7d5931(nationalNumber, type, metadata) {
    var type_info = metadata.type(type); // There should always be "<possiblePengths/>" set for every type element.
    // This is declared in the XML schema.
    // For size efficiency, where a sub-description (e.g. fixed-line)
    // has the same "<possiblePengths/>" as the "general description", this is missing,
    // so we fall back to the "general description". Where no numbers of the type
    // exist at all, there is one possible length (-1) which is guaranteed
    // not to match the length of any real phone number.
    var possible_lengths = type_info && type_info.possibleLengths() || metadata.possibleLengths(); // let local_lengths    = type_info && type.possibleLengthsLocal() || metadata.possibleLengthsLocal()
    // Metadata before version `1.0.18` didn't contain `possible_lengths`.
    if (!possible_lengths) return 'IS_POSSIBLE';
    if (type === 'FIXED_LINE_OR_MOBILE') {
        // No such country in metadata.
        /* istanbul ignore next */ if (!metadata.type('FIXED_LINE')) // The rare case has been encountered where no fixedLine data is available
        // (true for some non-geographic entities), so we just check mobile.
        return $e150d39adca76f23$export$69333f603c7d5931(nationalNumber, 'MOBILE', metadata);
        var mobile_type = metadata.type('MOBILE');
        if (mobile_type) // Merge the mobile data in if there was any. "Concat" creates a new
        // array, it doesn't edit possible_lengths in place, so we don't need a copy.
        // Note that when adding the possible lengths from mobile, we have
        // to again check they aren't empty since if they are this indicates
        // they are the same as the general desc and should be obtained from there.
        possible_lengths = (0, $OBrgA.default)(possible_lengths, mobile_type.possibleLengths()); // The current list is sorted; we need to merge in the new list and
    } else if (type && !type_info) return 'INVALID_LENGTH';
    var actual_length = nationalNumber.length; // In `libphonenumber-js` all "local-only" formats are dropped for simplicity.
    // // This is safe because there is never an overlap beween the possible lengths
    // // and the local-only lengths; this is checked at build time.
    // if (local_lengths && local_lengths.indexOf(nationalNumber.length) >= 0)
    // {
    // 	return 'IS_POSSIBLE_LOCAL_ONLY'
    // }
    var minimum_length = possible_lengths[0];
    if (minimum_length === actual_length) return 'IS_POSSIBLE';
    if (minimum_length > actual_length) return 'TOO_SHORT';
    if (possible_lengths[possible_lengths.length - 1] < actual_length) return 'TOO_LONG';
     // We skip the first element since we've already checked it.
    return possible_lengths.indexOf(actual_length, 1) >= 0 ? 'IS_POSSIBLE' : 'INVALID_LENGTH';
}

});
parcelRegister("OBrgA", function(module, exports) {

$parcel$export(module.exports, "default", () => $0981b63057bf1955$export$2e2bcd8739ae039);
/**
 * Merges two arrays.
 * @param  {*} a
 * @param  {*} b
 * @return {*}
 */ function $0981b63057bf1955$export$2e2bcd8739ae039(a, b) {
    var merged = a.slice();
    for(var _iterator = b, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;){
        var _ref;
        if (_isArray) {
            if (_i >= _iterator.length) break;
            _ref = _iterator[_i++];
        } else {
            _i = _iterator.next();
            if (_i.done) break;
            _ref = _i.value;
        }
        var element = _ref;
        if (a.indexOf(element) < 0) merged.push(element);
    }
    return merged.sort(function(a, b) {
        return a - b;
    }); // ES6 version, requires Set polyfill.
// let merged = new Set(a)
// for (const element of b) {
// 	merged.add(i)
// }
// return Array.from(merged).sort((a, b) => a - b)
}

});



parcelRegister("cJRin", function(module, exports) {

$parcel$export(module.exports, "parseRFC3966", () => $946307579c3e17b5$export$26fe644d7d92bb13);
$parcel$export(module.exports, "formatRFC3966", () => $946307579c3e17b5$export$d4f2d2bc1159d115);

var $6K6oP = parcelRequire("6K6oP");
function $946307579c3e17b5$var$_slicedToArray(arr, i) {
    return $946307579c3e17b5$var$_arrayWithHoles(arr) || $946307579c3e17b5$var$_iterableToArrayLimit(arr, i) || $946307579c3e17b5$var$_nonIterableRest();
}
function $946307579c3e17b5$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
function $946307579c3e17b5$var$_iterableToArrayLimit(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $946307579c3e17b5$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $946307579c3e17b5$export$26fe644d7d92bb13(text) {
    var number;
    var ext; // Replace "tel:" with "tel=" for parsing convenience.
    text = text.replace(/^tel:/, 'tel=');
    for(var _iterator = text.split(';'), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;){
        var _ref;
        if (_isArray) {
            if (_i >= _iterator.length) break;
            _ref = _iterator[_i++];
        } else {
            _i = _iterator.next();
            if (_i.done) break;
            _ref = _i.value;
        }
        var part = _ref;
        var _part$split = part.split('='), _part$split2 = $946307579c3e17b5$var$_slicedToArray(_part$split, 2), name = _part$split2[0], value = _part$split2[1];
        switch(name){
            case 'tel':
                number = value;
                break;
            case 'ext':
                ext = value;
                break;
            case 'phone-context':
                // Only "country contexts" are supported.
                // "Domain contexts" are ignored.
                if (value[0] === '+') number = value + number;
                break;
        }
    } // If the phone number is not viable, then abort.
    if (!(0, $6K6oP.default)(number)) return {};
    var result = {
        number: number
    };
    if (ext) result.ext = ext;
    return result;
}
function $946307579c3e17b5$export$d4f2d2bc1159d115(_ref2) {
    var number = _ref2.number, ext = _ref2.ext;
    if (!number) return '';
    if (number[0] !== '+') throw new Error("\"formatRFC3966()\" expects \"number\" to be in E.164 format.");
    return "tel:".concat(number).concat(ext ? ';ext=' + ext : '');
}

});

parcelRegister("3bOc3", function(module, exports) {

$parcel$export(module.exports, "default", () => $25295587638b13c7$export$2e2bcd8739ae039);

var $lijQr = parcelRequire("lijQr");

var $idCyj = parcelRequire("idCyj");

var $bYZ6l = parcelRequire("bYZ6l");


var $2oXUa = parcelRequire("2oXUa");

var $8Vlxt = parcelRequire("8Vlxt");
function $25295587638b13c7$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            $25295587638b13c7$var$_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function $25295587638b13c7$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $25295587638b13c7$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $25295587638b13c7$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $25295587638b13c7$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $25295587638b13c7$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $25295587638b13c7$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
var $25295587638b13c7$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE = false;
var $25295587638b13c7$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function PhoneNumber(countryCallingCode, nationalNumber, metadata) {
        $25295587638b13c7$var$_classCallCheck(this, PhoneNumber);
        if (!countryCallingCode) throw new TypeError('`country` or `countryCallingCode` not passed');
        if (!nationalNumber) throw new TypeError('`nationalNumber` not passed');
        if (!metadata) throw new TypeError('`metadata` not passed');
        var _metadata = new (0, $lijQr.default)(metadata); // If country code is passed then derive `countryCallingCode` from it.
        // Also store the country code as `.country`.
        if ($25295587638b13c7$var$isCountryCode(countryCallingCode)) {
            this.country = countryCallingCode;
            _metadata.country(countryCallingCode);
            countryCallingCode = _metadata.countryCallingCode();
        } else {
            /* istanbul ignore if */ if ($25295587638b13c7$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
                if (_metadata.isNonGeographicCallingCode(countryCallingCode)) this.country = '001';
            }
        }
        this.countryCallingCode = countryCallingCode;
        this.nationalNumber = nationalNumber;
        this.number = '+' + this.countryCallingCode + this.nationalNumber;
        this.metadata = metadata;
    }
    $25295587638b13c7$var$_createClass(PhoneNumber, [
        {
            key: "isPossible",
            value: function isPossible() {
                return (0, $idCyj.default)(this, {
                    v2: true
                }, this.metadata);
            }
        },
        {
            key: "isValid",
            value: function isValid() {
                return (0, $bYZ6l.default)(this, {
                    v2: true
                }, this.metadata);
            }
        },
        {
            key: "isNonGeographic",
            value: function isNonGeographic() {
                var metadata = new (0, $lijQr.default)(this.metadata);
                return metadata.isNonGeographicCallingCode(this.countryCallingCode);
            }
        },
        {
            key: "isEqual",
            value: function isEqual(phoneNumber) {
                return this.number === phoneNumber.number && this.ext === phoneNumber.ext;
            } // // Is just an alias for `this.isValid() && this.country === country`.
        },
        {
            key: "getType",
            value: function getType() {
                return (0, $2oXUa.default)(this, {
                    v2: true
                }, this.metadata);
            }
        },
        {
            key: "format",
            value: function format(_format, options) {
                return (0, $8Vlxt.default)(this, _format, options ? $25295587638b13c7$var$_objectSpread({}, options, {
                    v2: true
                }) : {
                    v2: true
                }, this.metadata);
            }
        },
        {
            key: "formatNational",
            value: function formatNational(options) {
                return this.format('NATIONAL', options);
            }
        },
        {
            key: "formatInternational",
            value: function formatInternational(options) {
                return this.format('INTERNATIONAL', options);
            }
        },
        {
            key: "getURI",
            value: function getURI(options) {
                return this.format('RFC3966', options);
            }
        }
    ]);
    return PhoneNumber;
}();
var $25295587638b13c7$var$isCountryCode = function isCountryCode(value) {
    return /^[A-Z]{2}$/.test(value);
};

});
parcelRegister("bYZ6l", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b94b1c307b2dce6$export$2e2bcd8739ae039);

var $lijQr = parcelRequire("lijQr");

var $jyfse = parcelRequire("jyfse");

var $2oXUa = parcelRequire("2oXUa");
function $8b94b1c307b2dce6$export$2e2bcd8739ae039(input, options, metadata) {
    // If assigning the `{}` default value is moved to the arguments above,
    // code coverage would decrease for some weird reason.
    options = options || {};
    metadata = new (0, $lijQr.default)(metadata); // This is just to support `isValidNumber({})`
    // for cases when `parseNumber()` returns `{}`.
    if (!input.country) return false;
    metadata.selectNumberingPlan(input.country, input.countryCallingCode); // By default, countries only have type regexps when it's required for
    // distinguishing different countries having the same `countryCallingCode`.
    if (metadata.hasTypes()) return (0, $2oXUa.default)(input, options, metadata.metadata) !== undefined;
     // If there are no type regexps for this country in metadata then use
    // `nationalNumberPattern` as a "better than nothing" replacement.
    var national_number = options.v2 ? input.nationalNumber : input.phone;
    return (0, $jyfse.default)(national_number, metadata.nationalNumberPattern());
}

});
parcelRegister("jyfse", function(module, exports) {

$parcel$export(module.exports, "default", () => $e3bd2e2fc8506edb$export$2e2bcd8739ae039);
/**
 * Checks whether the entire input sequence can be matched
 * against the regular expression.
 * @return {boolean}
 */ function $e3bd2e2fc8506edb$export$2e2bcd8739ae039(text, regular_expression) {
    // If assigning the `''` default value is moved to the arguments above,
    // code coverage would decrease for some weird reason.
    text = text || '';
    return new RegExp('^(?:' + regular_expression + ')$').test(text);
}

});

parcelRegister("2oXUa", function(module, exports) {

$parcel$export(module.exports, "default", () => $1bfc4a83ba58b3fa$export$2e2bcd8739ae039);

var $lijQr = parcelRequire("lijQr");

var $jyfse = parcelRequire("jyfse");
var $1bfc4a83ba58b3fa$var$NON_FIXED_LINE_PHONE_TYPES = [
    'MOBILE',
    'PREMIUM_RATE',
    'TOLL_FREE',
    'SHARED_COST',
    'VOIP',
    'PERSONAL_NUMBER',
    'PAGER',
    'UAN',
    'VOICEMAIL'
]; // Finds out national phone number type (fixed line, mobile, etc)
function $1bfc4a83ba58b3fa$export$2e2bcd8739ae039(input, options, metadata) {
    // If assigning the `{}` default value is moved to the arguments above,
    // code coverage would decrease for some weird reason.
    options = options || {}; // When `parse()` returned `{}`
    // meaning that the phone number is not a valid one.
    if (!input.country) return;
    metadata = new (0, $lijQr.default)(metadata);
    metadata.selectNumberingPlan(input.country, input.countryCallingCode);
    var nationalNumber = options.v2 ? input.nationalNumber : input.phone; // The following is copy-pasted from the original function:
    // https://github.com/googlei18n/libphonenumber/blob/3ea547d4fbaa2d0b67588904dfa5d3f2557c27ff/javascript/i18n/phonenumbers/phonenumberutil.js#L2835
    // Is this national number even valid for this country
    if (!(0, $jyfse.default)(nationalNumber, metadata.nationalNumberPattern())) return;
     // Is it fixed line number
    if ($1bfc4a83ba58b3fa$export$7bd37b39ade0214d(nationalNumber, 'FIXED_LINE', metadata)) {
        // Because duplicate regular expressions are removed
        // to reduce metadata size, if "mobile" pattern is ""
        // then it means it was removed due to being a duplicate of the fixed-line pattern.
        //
        if (metadata.type('MOBILE') && metadata.type('MOBILE').pattern() === '') return 'FIXED_LINE_OR_MOBILE';
         // v1 metadata.
        // Legacy.
        // Deprecated.
        if (!metadata.type('MOBILE')) return 'FIXED_LINE_OR_MOBILE';
         // Check if the number happens to qualify as both fixed line and mobile.
        // (no such country in the minimal metadata set)
        /* istanbul ignore if */ if ($1bfc4a83ba58b3fa$export$7bd37b39ade0214d(nationalNumber, 'MOBILE', metadata)) return 'FIXED_LINE_OR_MOBILE';
        return 'FIXED_LINE';
    }
    for(var _i = 0, _NON_FIXED_LINE_PHONE = $1bfc4a83ba58b3fa$var$NON_FIXED_LINE_PHONE_TYPES; _i < _NON_FIXED_LINE_PHONE.length; _i++){
        var type = _NON_FIXED_LINE_PHONE[_i];
        if ($1bfc4a83ba58b3fa$export$7bd37b39ade0214d(nationalNumber, type, metadata)) return type;
    }
}
function $1bfc4a83ba58b3fa$export$7bd37b39ade0214d(nationalNumber, type, metadata) {
    type = metadata.type(type);
    if (!type || !type.pattern()) return false;
     // Check if any possible number lengths are present;
    // if so, we use them to avoid checking
    // the validation pattern if they don't match.
    // If they are absent, this means they match
    // the general description, which we have
    // already checked before a specific number type.
    if (type.possibleLengths() && type.possibleLengths().indexOf(nationalNumber.length) < 0) return false;
    return (0, $jyfse.default)(nationalNumber, type.pattern());
}

});


parcelRegister("8Vlxt", function(module, exports) {

$parcel$export(module.exports, "default", () => $67f45ac1bdf1f00b$export$2e2bcd8739ae039);

var $jyfse = parcelRequire("jyfse");

var $cQ2v2 = parcelRequire("cQ2v2");

var $lijQr = parcelRequire("lijQr");

var $daLpQ = parcelRequire("daLpQ");

var $cJRin = parcelRequire("cJRin");
function $67f45ac1bdf1f00b$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            $67f45ac1bdf1f00b$var$_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function $67f45ac1bdf1f00b$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $67f45ac1bdf1f00b$var$DEFAULT_OPTIONS = {
    formatExtension: function formatExtension(formattedNumber, extension, metadata) {
        return "".concat(formattedNumber).concat(metadata.ext()).concat(extension);
    } // Formats a phone number
};
function $67f45ac1bdf1f00b$export$2e2bcd8739ae039(input, format, options, metadata) {
    // Apply default options.
    if (options) options = $67f45ac1bdf1f00b$var$_objectSpread({}, $67f45ac1bdf1f00b$var$DEFAULT_OPTIONS, options);
    else options = $67f45ac1bdf1f00b$var$DEFAULT_OPTIONS;
    metadata = new (0, $lijQr.default)(metadata);
    if (input.country && input.country !== '001') {
        // Validate `input.country`.
        if (!metadata.hasCountry(input.country)) throw new Error("Unknown country: ".concat(input.country));
        metadata.country(input.country);
    } else if (input.countryCallingCode) metadata.selectNumberingPlan(input.countryCallingCode);
    else return input.phone || '';
    var countryCallingCode = metadata.countryCallingCode();
    var nationalNumber = options.v2 ? input.nationalNumber : input.phone; // This variable should have been declared inside `case`s
    // but Babel has a bug and it says "duplicate variable declaration".
    var number;
    switch(format){
        case 'NATIONAL':
            // Legacy argument support.
            // (`{ country: ..., phone: '' }`)
            if (!nationalNumber) return '';
            number = $67f45ac1bdf1f00b$var$formatNationalNumber(nationalNumber, input.carrierCode, 'NATIONAL', metadata, options);
            return $67f45ac1bdf1f00b$var$addExtension(number, input.ext, metadata, options.formatExtension);
        case 'INTERNATIONAL':
            // Legacy argument support.
            // (`{ country: ..., phone: '' }`)
            if (!nationalNumber) return "+".concat(countryCallingCode);
            number = $67f45ac1bdf1f00b$var$formatNationalNumber(nationalNumber, null, 'INTERNATIONAL', metadata, options);
            number = "+".concat(countryCallingCode, " ").concat(number);
            return $67f45ac1bdf1f00b$var$addExtension(number, input.ext, metadata, options.formatExtension);
        case 'E.164':
            // `E.164` doesn't define "phone number extensions".
            return "+".concat(countryCallingCode).concat(nationalNumber);
        case 'RFC3966':
            return (0, $cJRin.formatRFC3966)({
                number: "+".concat(countryCallingCode).concat(nationalNumber),
                ext: input.ext
            });
        // For reference, here's Google's IDD formatter:
        // https://github.com/google/libphonenumber/blob/32719cf74e68796788d1ca45abc85dcdc63ba5b9/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L1546
        // Not saying that this IDD formatter replicates it 1:1, but it seems to work.
        // Who would even need to format phone numbers in IDD format anyway?
        case 'IDD':
            if (!options.fromCountry) return; // throw new Error('`fromCountry` option not passed for IDD-prefixed formatting.')
            var formattedNumber = $67f45ac1bdf1f00b$var$formatIDD(nationalNumber, input.carrierCode, countryCallingCode, options.fromCountry, metadata);
            return $67f45ac1bdf1f00b$var$addExtension(formattedNumber, input.ext, metadata, options.formatExtension);
        default:
            throw new Error("Unknown \"format\" argument passed to \"formatNumber()\": \"".concat(format, "\""));
    }
}
function $67f45ac1bdf1f00b$var$formatNationalNumber(number, carrierCode, formatAs, metadata, options) {
    var format = $67f45ac1bdf1f00b$var$chooseFormatForNumber(metadata.formats(), number);
    if (!format) return number;
    return (0, $cQ2v2.default)(number, format, {
        useInternationalFormat: formatAs === 'INTERNATIONAL',
        withNationalPrefix: format.nationalPrefixIsOptionalWhenFormattingInNationalFormat() && options && options.nationalPrefix === false ? false : true,
        carrierCode: carrierCode,
        metadata: metadata
    });
}
function $67f45ac1bdf1f00b$var$chooseFormatForNumber(availableFormats, nationalNnumber) {
    for(var _iterator = availableFormats, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;){
        var _ref;
        if (_isArray) {
            if (_i >= _iterator.length) break;
            _ref = _iterator[_i++];
        } else {
            _i = _iterator.next();
            if (_i.done) break;
            _ref = _i.value;
        }
        var format = _ref;
        // Validate leading digits
        if (format.leadingDigitsPatterns().length > 0) {
            // The last leading_digits_pattern is used here, as it is the most detailed
            var lastLeadingDigitsPattern = format.leadingDigitsPatterns()[format.leadingDigitsPatterns().length - 1]; // If leading digits don't match then move on to the next phone number format
            if (nationalNnumber.search(lastLeadingDigitsPattern) !== 0) continue;
        } // Check that the national number matches the phone number format regular expression
        if ((0, $jyfse.default)(nationalNnumber, format.pattern())) return format;
    }
}
function $67f45ac1bdf1f00b$var$addExtension(formattedNumber, ext, metadata, formatExtension) {
    return ext ? formatExtension(formattedNumber, ext, metadata) : formattedNumber;
}
function $67f45ac1bdf1f00b$var$formatIDD(nationalNumber, carrierCode, countryCallingCode, fromCountry, metadata) {
    var fromCountryCallingCode = (0, $lijQr.getCountryCallingCode)(fromCountry, metadata.metadata); // When calling within the same country calling code.
    if (fromCountryCallingCode === countryCallingCode) {
        var formattedNumber = $67f45ac1bdf1f00b$var$formatNationalNumber(nationalNumber, carrierCode, 'NATIONAL', metadata); // For NANPA regions, return the national format for these regions
        // but prefix it with the country calling code.
        if (countryCallingCode === '1') return countryCallingCode + ' ' + formattedNumber;
         // If regions share a country calling code, the country calling code need
        // not be dialled. This also applies when dialling within a region, so this
        // if clause covers both these cases. Technically this is the case for
        // dialling from La Reunion to other overseas departments of France (French
        // Guiana, Martinique, Guadeloupe), but not vice versa - so we don't cover
        // this edge case for now and for those cases return the version including
        // country calling code. Details here:
        // http://www.petitfute.com/voyage/225-info-pratiques-reunion
        //
        return formattedNumber;
    }
    var iddPrefix = (0, $daLpQ.default)(fromCountry, undefined, metadata.metadata);
    if (iddPrefix) return "".concat(iddPrefix, " ").concat(countryCallingCode, " ").concat($67f45ac1bdf1f00b$var$formatNationalNumber(nationalNumber, null, 'INTERNATIONAL', metadata));
}

});
parcelRegister("cQ2v2", function(module, exports) {

$parcel$export(module.exports, "FIRST_GROUP_PATTERN", () => $958c47b8ffb0646a$export$4f32ad1c51a7a6be);
$parcel$export(module.exports, "default", () => $958c47b8ffb0646a$export$2e2bcd8739ae039);

var $1o9N5 = parcelRequire("1o9N5");
var $958c47b8ffb0646a$export$4f32ad1c51a7a6be = /(\$\d)/;
function $958c47b8ffb0646a$export$2e2bcd8739ae039(number, format, _ref) {
    var useInternationalFormat = _ref.useInternationalFormat, withNationalPrefix = _ref.withNationalPrefix, carrierCode = _ref.carrierCode, metadata = _ref.metadata;
    var formattedNumber = number.replace(new RegExp(format.pattern()), useInternationalFormat ? format.internationalFormat() : // because that one is only used when formatting phone numbers
    // for dialing from a mobile phone, and this is not a dialing library.
    // carrierCode && format.domesticCarrierCodeFormattingRule()
    // 	// First, replace the $CC in the formatting rule with the desired carrier code.
    // 	// Then, replace the $FG in the formatting rule with the first group
    // 	// and the carrier code combined in the appropriate way.
    // 	? format.format().replace(FIRST_GROUP_PATTERN, format.domesticCarrierCodeFormattingRule().replace('$CC', carrierCode))
    // 	: (
    // 		withNationalPrefix && format.nationalPrefixFormattingRule()
    // 			? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule())
    // 			: format.format()
    // 	)
    withNationalPrefix && format.nationalPrefixFormattingRule() ? format.format().replace($958c47b8ffb0646a$export$4f32ad1c51a7a6be, format.nationalPrefixFormattingRule()) : format.format());
    if (useInternationalFormat) return (0, $1o9N5.default)(formattedNumber);
    return formattedNumber;
}

});
parcelRegister("1o9N5", function(module, exports) {

$parcel$export(module.exports, "default", () => $102fa0905276e10f$export$2e2bcd8739ae039);

var $hoHfs = parcelRequire("hoHfs");
function $102fa0905276e10f$export$2e2bcd8739ae039(formattedNumber) {
    return formattedNumber.replace(new RegExp("[".concat((0, $hoHfs.VALID_PUNCTUATION), "]+"), 'g'), ' ').trim();
}

});


parcelRegister("daLpQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $9970fd541d189be2$export$2e2bcd8739ae039);

var $lijQr = parcelRequire("lijQr");
/**
 * Pattern that makes it easy to distinguish whether a region has a single
 * international dialing prefix or not. If a region has a single international
 * prefix (e.g. 011 in USA), it will be represented as a string that contains
 * a sequence of ASCII digits, and possibly a tilde, which signals waiting for
 * the tone. If there are multiple available international prefixes in a
 * region, they will be represented as a regex string that always contains one
 * or more characters that are not ASCII digits or a tilde.
 */ var $9970fd541d189be2$var$SINGLE_IDD_PREFIX_REG_EXP = /^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/; // For regions that have multiple IDD prefixes
function $9970fd541d189be2$export$2e2bcd8739ae039(country, callingCode, metadata) {
    var countryMetadata = new (0, $lijQr.default)(metadata);
    countryMetadata.selectNumberingPlan(country, callingCode);
    if (countryMetadata.defaultIDDPrefix()) return countryMetadata.defaultIDDPrefix();
    if ($9970fd541d189be2$var$SINGLE_IDD_PREFIX_REG_EXP.test(countryMetadata.IDDPrefix())) return countryMetadata.IDDPrefix();
}

});



parcelRegister("l3IVT", function(module, exports) {

$parcel$export(module.exports, "default", () => $f54cbb82e68a0281$export$2e2bcd8739ae039);

var $lQq7N = parcelRequire("lQq7N");

var $6yPcr = parcelRequire("6yPcr");

var $lijQr = parcelRequire("lijQr");

var $hoHfs = parcelRequire("hoHfs");
function $f54cbb82e68a0281$export$2e2bcd8739ae039(number, country, callingCode, metadata) {
    if (!number) return {};
     // If this is not an international phone number,
    // then either extract an "IDD" prefix, or extract a
    // country calling code from a number by autocorrecting it
    // by prepending a leading `+` in cases when it starts
    // with the country calling code.
    // https://wikitravel.org/en/International_dialling_prefix
    // https://github.com/catamphetamine/libphonenumber-js/issues/376
    if (number[0] !== '+') {
        // Convert an "out-of-country" dialing phone number
        // to a proper international phone number.
        var numberWithoutIDD = (0, $lQq7N.default)(number, country, callingCode, metadata); // If an IDD prefix was stripped then
        // convert the number to international one
        // for subsequent parsing.
        if (numberWithoutIDD && numberWithoutIDD !== number) number = '+' + numberWithoutIDD;
        else {
            // Check to see if the number starts with the country calling code
            // for the default country. If so, we remove the country calling code,
            // and do some checks on the validity of the number before and after.
            // https://github.com/catamphetamine/libphonenumber-js/issues/376
            if (country || callingCode) {
                var _extractCountryCallin = (0, $6yPcr.default)(number, country, callingCode, metadata), countryCallingCode = _extractCountryCallin.countryCallingCode, shorterNumber = _extractCountryCallin.number;
                if (countryCallingCode) return {
                    countryCallingCode: countryCallingCode,
                    number: shorterNumber
                };
            }
            return {
                number: number
            };
        }
    } // Fast abortion: country codes do not begin with a '0'
    if (number[1] === '0') return {};
    metadata = new (0, $lijQr.default)(metadata); // The thing with country phone codes
    // is that they are orthogonal to each other
    // i.e. there's no such country phone code A
    // for which country phone code B exists
    // where B starts with A.
    // Therefore, while scanning digits,
    // if a valid country code is found,
    // that means that it is the country code.
    //
    var i = 2;
    while(i - 1 <= (0, $hoHfs.MAX_LENGTH_COUNTRY_CODE) && i <= number.length){
        var _countryCallingCode = number.slice(1, i);
        if (metadata.hasCallingCode(_countryCallingCode)) {
            metadata.selectNumberingPlan(_countryCallingCode);
            return {
                countryCallingCode: _countryCallingCode,
                number: number.slice(i)
            };
        }
        i++;
    }
    return {};
}

});
parcelRegister("lQq7N", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe72b81dc9349c1d$export$2e2bcd8739ae039);

var $lijQr = parcelRequire("lijQr");

var $hoHfs = parcelRequire("hoHfs");
var $fe72b81dc9349c1d$var$CAPTURING_DIGIT_PATTERN = new RegExp('([' + (0, $hoHfs.VALID_DIGITS) + '])');
function $fe72b81dc9349c1d$export$2e2bcd8739ae039(number, country, callingCode, metadata) {
    if (!country) return;
     // Check if the number is IDD-prefixed.
    var countryMetadata = new (0, $lijQr.default)(metadata);
    countryMetadata.selectNumberingPlan(country, callingCode);
    var IDDPrefixPattern = new RegExp(countryMetadata.IDDPrefix());
    if (number.search(IDDPrefixPattern) !== 0) return;
     // Strip IDD prefix.
    number = number.slice(number.match(IDDPrefixPattern)[0].length); // If there're any digits after an IDD prefix,
    // then those digits are a country calling code.
    // Since no country code starts with a `0`,
    // the code below validates that the next digit (if present) is not `0`.
    var matchedGroups = number.match($fe72b81dc9349c1d$var$CAPTURING_DIGIT_PATTERN);
    if (matchedGroups && matchedGroups[1] != null && matchedGroups[1].length > 0) {
        if (matchedGroups[1] === '0') return;
    }
    return number;
}

});

parcelRegister("6yPcr", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c6da243f5876ae1$export$2e2bcd8739ae039);

var $lijQr = parcelRequire("lijQr");

var $jyfse = parcelRequire("jyfse");

var $lO22f = parcelRequire("lO22f");

var $jllIH = parcelRequire("jllIH");

var $lijQr = parcelRequire("lijQr");
function $4c6da243f5876ae1$export$2e2bcd8739ae039(number, country, callingCode, metadata) {
    var countryCallingCode = country ? (0, $lijQr.getCountryCallingCode)(country, metadata) : callingCode;
    if (number.indexOf(countryCallingCode) === 0) {
        metadata = new (0, $lijQr.default)(metadata);
        metadata.selectNumberingPlan(country, callingCode);
        var possibleShorterNumber = number.slice(countryCallingCode.length);
        var _extractNationalNumbe = (0, $lO22f.default)(possibleShorterNumber, metadata), possibleShorterNationalNumber = _extractNationalNumbe.nationalNumber;
        var _extractNationalNumbe2 = (0, $lO22f.default)(number, metadata), nationalNumber = _extractNationalNumbe2.nationalNumber; // If the number was not valid before but is valid now,
        // or if it was too long before, we consider the number
        // with the country calling code stripped to be a better result
        // and keep that instead.
        // For example, in Germany (+49), `49` is a valid area code,
        // so if a number starts with `49`, it could be both a valid
        // national German number or an international number without
        // a leading `+`.
        if (!(0, $jyfse.default)(nationalNumber, metadata.nationalNumberPattern()) && (0, $jyfse.default)(possibleShorterNationalNumber, metadata.nationalNumberPattern()) || (0, $jllIH.default)(nationalNumber, metadata) === 'TOO_LONG') return {
            countryCallingCode: countryCallingCode,
            number: possibleShorterNumber
        };
    }
    return {
        number: number
    };
}

});
parcelRegister("lO22f", function(module, exports) {

$parcel$export(module.exports, "default", () => $fdffd8ab78eb7a6a$export$2e2bcd8739ae039);

var $7H2OH = parcelRequire("7H2OH");

var $jyfse = parcelRequire("jyfse");

var $jllIH = parcelRequire("jllIH");
function $fdffd8ab78eb7a6a$export$2e2bcd8739ae039(number, metadata) {
    // Parsing national prefixes and carrier codes
    // is only required for local phone numbers
    // but some people don't understand that
    // and sometimes write international phone numbers
    // with national prefixes (or maybe even carrier codes).
    // http://ucken.blogspot.ru/2016/03/trunk-prefixes-in-skype4b.html
    // Google's original library forgives such mistakes
    // and so does this library, because it has been requested:
    // https://github.com/catamphetamine/libphonenumber-js/issues/127
    var _extractNationalNumbe = (0, $7H2OH.default)(number, metadata), nationalNumber = _extractNationalNumbe.nationalNumber, carrierCode = _extractNationalNumbe.carrierCode;
    if (!$fdffd8ab78eb7a6a$var$shouldExtractNationalPrefix(number, nationalNumber, metadata)) // Don't strip the national prefix.
    return {
        nationalNumber: number
    };
     // If a national prefix has been extracted, check to see
    // if the resultant number isn't too short.
    // Same code in Google's `libphonenumber`:
    // https://github.com/google/libphonenumber/blob/e326fa1fc4283bb05eb35cb3c15c18f98a31af33/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L3291-L3302
    // For some reason, they do this check right after the `national_number_pattern` check
    // this library does in `shouldExtractNationalPrefix()` function.
    // Why is there a second "resultant" number validity check?
    // They don't provide an explanation.
    // This library just copies the behavior.
    if (number.length !== nationalNumber.length + (carrierCode ? carrierCode.length : 0)) // If not using legacy generated metadata (before version `1.0.18`)
    // then it has "possible lengths", so use those to validate the number length.
    {
        if (metadata.possibleLengths()) // "We require that the NSN remaining after stripping the national prefix and
        // carrier code be long enough to be a possible length for the region.
        // Otherwise, we don't do the stripping, since the original number could be
        // a valid short number."
        // https://github.com/google/libphonenumber/blob/876268eb1ad6cdc1b7b5bef17fc5e43052702d57/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L3236-L3250
        switch((0, $jllIH.default)(nationalNumber, metadata)){
            case 'TOO_SHORT':
            case 'INVALID_LENGTH':
                // case 'IS_POSSIBLE_LOCAL_ONLY':
                // Don't strip the national prefix.
                return {
                    nationalNumber: number
                };
        }
    }
    return {
        nationalNumber: nationalNumber,
        carrierCode: carrierCode
    };
} // In some countries, the same digit could be a national prefix
// or a leading digit of a valid phone number.
// For example, in Russia, national prefix is `8`,
// and also `800 555 35 35` is a valid number
// in which `8` is not a national prefix, but the first digit
// of a national (significant) number.
// Same's with Belarus:
// `82004910060` is a valid national (significant) number,
// but `2004910060` is not.
// To support such cases (to prevent the code from always stripping
// national prefix), a condition is imposed: a national prefix
// is not extracted when the original number is "viable" and the
// resultant number is not, a "viable" national number being the one
// that matches `national_number_pattern`.
function $fdffd8ab78eb7a6a$var$shouldExtractNationalPrefix(number, nationalSignificantNumber, metadata) {
    // The equivalent in Google's code is:
    // https://github.com/google/libphonenumber/blob/e326fa1fc4283bb05eb35cb3c15c18f98a31af33/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L2969-L3004
    if ((0, $jyfse.default)(number, metadata.nationalNumberPattern()) && !(0, $jyfse.default)(nationalSignificantNumber, metadata.nationalNumberPattern())) return false;
     // Just "possible" number check would be more relaxed, so it's not used.
    // if (isPossibleNumber(number, metadata) &&
    // 	!isPossibleNumber(numberWithNationalPrefixExtracted, metadata)) {
    // 	return false
    // }
    return true;
}

});
parcelRegister("7H2OH", function(module, exports) {

$parcel$export(module.exports, "default", () => $599ebbe585179a66$export$2e2bcd8739ae039);
/**
 * Strips any national prefix (such as 0, 1) present in a
 * (possibly incomplete) number provided.
 * "Carrier codes" are only used  in Colombia and Brazil,
 * and only when dialing within those countries from a mobile phone to a fixed line number.
 * Sometimes it won't actually strip national prefix
 * and will instead prepend some digits to the `number`:
 * for example, when number `2345678` is passed with `VI` country selected,
 * it will return `{ number: "3402345678" }`, because `340` area code is prepended.
 * @param {string} number — National number digits.
 * @param {object} metadata — Metadata with country selected.
 * @return {object} `{ nationalNumber: string, nationalPrefix: string? carrierCode: string? }`.
 */ function $599ebbe585179a66$export$2e2bcd8739ae039(number, metadata) {
    if (number && metadata.numberingPlan.nationalPrefixForParsing()) {
        // See METADATA.md for the description of
        // `national_prefix_for_parsing` and `national_prefix_transform_rule`.
        // Attempt to parse the first digits as a national prefix.
        var prefixPattern = new RegExp('^(?:' + metadata.numberingPlan.nationalPrefixForParsing() + ')');
        var prefixMatch = prefixPattern.exec(number);
        if (prefixMatch) {
            var nationalNumber;
            var carrierCode; // https://gitlab.com/catamphetamine/libphonenumber-js/-/blob/master/METADATA.md#national_prefix_for_parsing--national_prefix_transform_rule
            // If a `national_prefix_for_parsing` has any "capturing groups"
            // then it means that the national (significant) number is equal to
            // those "capturing groups" transformed via `national_prefix_transform_rule`,
            // and nothing could be said about the actual national prefix:
            // what is it and was it even there.
            // If a `national_prefix_for_parsing` doesn't have any "capturing groups",
            // then everything it matches is a national prefix.
            // To determine whether `national_prefix_for_parsing` matched any
            // "capturing groups", the value of the result of calling `.exec()`
            // is looked at, and if it has non-undefined values where there're
            // "capturing groups" in the regular expression, then it means
            // that "capturing groups" have been matched.
            // It's not possible to tell whether there'll be any "capturing gropus"
            // before the matching process, because a `national_prefix_for_parsing`
            // could exhibit both behaviors.
            var capturedGroupsCount = prefixMatch.length - 1;
            var hasCapturedGroups = capturedGroupsCount > 0 && prefixMatch[capturedGroupsCount];
            if (metadata.nationalPrefixTransformRule() && hasCapturedGroups) {
                nationalNumber = number.replace(prefixPattern, metadata.nationalPrefixTransformRule()); // If there's more than one captured group,
                // then carrier code is the second one.
                if (capturedGroupsCount > 1) carrierCode = prefixMatch[1];
            } else {
                // `prefixBeforeNationalNumber` is the whole substring matched by
                // the `national_prefix_for_parsing` regular expression.
                // There seem to be no guarantees that it's just a national prefix.
                // For example, if there's a carrier code, it's gonna be a
                // part of `prefixBeforeNationalNumber` too.
                var prefixBeforeNationalNumber = prefixMatch[0];
                nationalNumber = number.slice(prefixBeforeNationalNumber.length); // If there's at least one captured group,
                // then carrier code is the first one.
                if (hasCapturedGroups) carrierCode = prefixMatch[1];
            } // Tries to guess whether a national prefix was present in the input.
            // This is not something copy-pasted from Google's library:
            // they don't seem to have an equivalent for that.
            // So this isn't an "officially approved" way of doing something like that.
            // But since there seems no other existing method, this library uses it.
            var nationalPrefix;
            if (hasCapturedGroups) {
                var possiblePositionOfTheFirstCapturedGroup = number.indexOf(prefixMatch[1]);
                var possibleNationalPrefix = number.slice(0, possiblePositionOfTheFirstCapturedGroup); // Example: an Argentinian (AR) phone number `0111523456789`.
                // `prefixMatch[0]` is `01115`, and `$1` is `11`,
                // and the rest of the phone number is `23456789`.
                // The national number is transformed via `9$1` to `91123456789`.
                // National prefix `0` is detected being present at the start.
                // if (possibleNationalPrefix.indexOf(metadata.numberingPlan.nationalPrefix()) === 0) {
                if (possibleNationalPrefix === metadata.numberingPlan.nationalPrefix()) nationalPrefix = metadata.numberingPlan.nationalPrefix();
            } else nationalPrefix = prefixMatch[0];
            return {
                nationalNumber: nationalNumber,
                nationalPrefix: nationalPrefix,
                carrierCode: carrierCode
            };
        }
    }
    return {
        nationalNumber: number
    };
}

});




parcelRegister("3wXuM", function(module, exports) {

$parcel$export(module.exports, "default", () => $292282cd70c66425$export$2e2bcd8739ae039);

var $lijQr = parcelRequire("lijQr");

var $2oXUa = parcelRequire("2oXUa");
var $292282cd70c66425$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE = false;
function $292282cd70c66425$export$2e2bcd8739ae039(callingCode, nationalPhoneNumber, metadata) {
    /* istanbul ignore if */ if ($292282cd70c66425$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
        if (metadata.isNonGeographicCallingCode(callingCode)) return '001';
    } // Is always non-empty, because `callingCode` is always valid
    var possibleCountries = metadata.getCountryCodesForCallingCode(callingCode);
    if (!possibleCountries) return;
     // If there's just one country corresponding to the country code,
    // then just return it, without further phone number digits validation.
    if (possibleCountries.length === 1) return possibleCountries[0];
    return $292282cd70c66425$var$selectCountryFromList(possibleCountries, nationalPhoneNumber, metadata.metadata);
}
function $292282cd70c66425$var$selectCountryFromList(possibleCountries, nationalPhoneNumber, metadata) {
    // Re-create `metadata` because it will be selecting a `country`.
    metadata = new (0, $lijQr.default)(metadata);
    for(var _iterator = possibleCountries, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;){
        var _ref;
        if (_isArray) {
            if (_i >= _iterator.length) break;
            _ref = _iterator[_i++];
        } else {
            _i = _iterator.next();
            if (_i.done) break;
            _ref = _i.value;
        }
        var country = _ref;
        metadata.country(country); // Leading digits check would be the simplest one
        if (metadata.leadingDigits()) {
            if (nationalPhoneNumber && nationalPhoneNumber.search(metadata.leadingDigits()) === 0) return country;
        } else if ((0, $2oXUa.default)({
            phone: nationalPhoneNumber,
            country: country
        }, undefined, metadata.metadata)) return country;
    }
}

});




parcelRegister("lnAnA", function(module, exports) {

$parcel$export(module.exports, "default", () => $f907f7246eca08f1$export$2e2bcd8739ae039);

var $aKJ8g = parcelRequire("aKJ8g");

var $1nVPX = parcelRequire("1nVPX");

var $lijQr = parcelRequire("lijQr");
function $f907f7246eca08f1$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            $f907f7246eca08f1$var$_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function $f907f7246eca08f1$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $f907f7246eca08f1$export$2e2bcd8739ae039(text, options, metadata) {
    // Validate `defaultCountry`.
    if (options && options.defaultCountry && !(0, $lijQr.isSupportedCountry)(options.defaultCountry, metadata)) options = $f907f7246eca08f1$var$_objectSpread({}, options, {
        defaultCountry: undefined
    });
     // Parse phone number.
    try {
        return (0, $aKJ8g.default)(text, options, metadata);
    } catch (error) {
        /* istanbul ignore else */ if (error instanceof (0, $1nVPX.default)) ;
        else throw error;
    }
}

});



parcelRegister("jmDLz", function(module, exports) {

$parcel$export(module.exports, "sendOTPCode", () => $e18eeb295de6d4ba$export$da4a3cdbfcd735da);
$parcel$export(module.exports, "loginPortal", () => $e18eeb295de6d4ba$export$c0cd4001d066060d);
$parcel$export(module.exports, "createBookingToken", () => $e18eeb295de6d4ba$export$d791eb0705c108cf);
$parcel$export(module.exports, "updateLeadPortal", () => $e18eeb295de6d4ba$export$b9f285a7ad44eea2);

var $fmRoT = parcelRequire("fmRoT");

var $hvLQT = parcelRequire("hvLQT");

var $er9E0 = parcelRequire("er9E0");

var $cEKee = parcelRequire("cEKee");
async function $e18eeb295de6d4ba$export$da4a3cdbfcd735da(phoneNumber) {
    return await (0, $hvLQT.apiClient).POST('api/twilio/verification/token', {
        phone: phoneNumber
    });
}
async function $e18eeb295de6d4ba$export$c3e6f60c4cf2d6d9(phoneNumber, otpCode) {
    return await (0, $hvLQT.apiClient).POST('api/appointment-token', {
        phone: phoneNumber,
        code: otpCode
    });
}
async function $e18eeb295de6d4ba$export$c0cd4001d066060d(phoneNumber, otpCode, project, visitorId) {
    return await (0, (/*@__PURE__*/$parcel$interopDefault($fmRoT))).request({
        headers: {
            ...(0, $hvLQT.apiClient).config().headers
        },
        method: 'POST',
        url: `${(0, $hvLQT.apiClient).apiUrl(`api/widget/project/${project}/login/phone/${phoneNumber}`)}`,
        data: {
            phone: phoneNumber,
            code: otpCode,
            project: project,
            visitor_id: visitorId
        }
    });
}
// Ids of the service(s) the visitor picked earlier in the booking flow.
// Service lists record the choice in selectedProcedures; single-service and
// URL-preselected flows use procedureIdSelected. Accept either.
function $e18eeb295de6d4ba$var$selectedProcedureIds() {
    const ids = [];
    if (0, $cEKee.procedureIdSelected) ids.push((0, $cEKee.procedureIdSelected));
    if (Array.isArray((0, $cEKee.selectedProcedures))) ids.push(...(0, $cEKee.selectedProcedures));
    return [
        ...new Set(ids.map((id)=>parseInt(id, 10)).filter((id)=>Number.isInteger(id) && id > 0))
    ];
}
async function $e18eeb295de6d4ba$export$d791eb0705c108cf(appointmentChannelId, payload) {
    // The lead is created HERE, two screens after the service was picked, so
    // the selection has to ride along — otherwise a drop-off before the final
    // confirm leaves a lead (and its "Unfinished Booking" ticket) with no
    // service. The API validates the ids against the channel and ignores junk.
    const procedureIds = $e18eeb295de6d4ba$var$selectedProcedureIds();
    return await (0, $hvLQT.apiClient).POST(`api/widget/appointment-channel/${appointmentChannelId}/booking-token`, procedureIds.length ? {
        ...payload,
        procedure_ids: procedureIds
    } : payload);
}
async function $e18eeb295de6d4ba$export$b9f285a7ad44eea2(lead_id, data) {
    if (parseInt((0, $er9E0.params)('has_source')) === 1 && (0, $er9E0.params)('source')) data['source'] = (0, $er9E0.params)('source');
    return await (0, $hvLQT.apiClient).POST(`api/widget/leads/${lead_id}`, data);
}
async function $e18eeb295de6d4ba$export$269463aa76de5b5() {
    return await (0, $hvLQT.apiClient).GET('sanctum/csrf-cookie');
}

});

parcelRegister("alq6e", function(module, exports) {

$parcel$export(module.exports, "getAppoitmentsDatetime", () => $78801c5fa156690c$export$2f8ee7f32af01f9f);
$parcel$export(module.exports, "clickDateCarouselItem", () => $78801c5fa156690c$export$be85d4e01c9474bc);
$parcel$export(module.exports, "appointmentItemsClickEventHandler", () => $78801c5fa156690c$export$16b12bebab71e24f);
$parcel$export(module.exports, "loadSpinnerIcon", () => $78801c5fa156690c$export$4d9d36f9e948c129);
$parcel$export(module.exports, "resetPageSelectTime", () => $78801c5fa156690c$export$de29d67d57fc8f3b);
$parcel$export(module.exports, "clickOnlyDateCarouselItem", () => $78801c5fa156690c$export$ed7231779fea24d5);
$parcel$export(module.exports, "loadAppointmentSummary", () => $78801c5fa156690c$export$e58522e1e5e6879);

var $cNdCr = parcelRequire("cNdCr");

var $cIxq8 = parcelRequire("cIxq8");

var $l4e3W = parcelRequire("l4e3W");

var $8yRQa = parcelRequire("8yRQa");

var $cEKee = parcelRequire("cEKee");

var $2BtZD = parcelRequire("2BtZD");

var $cDpNn = parcelRequire("cDpNn");

var $gZEOs = parcelRequire("gZEOs");

var $f3IK4 = parcelRequire("f3IK4");
parcelRequire("5oy7H");

var $hOgIi = parcelRequire("hOgIi");

var $gEfFu = parcelRequire("gEfFu");

var $avR5a = parcelRequire("avR5a");

var $er9E0 = parcelRequire("er9E0");

var $hSkqV = parcelRequire("hSkqV");

var $e4miY = parcelRequire("e4miY");

var $bUtOS = parcelRequire("bUtOS");

var $6oS6b = parcelRequire("6oS6b");

var $9bGUq = parcelRequire("9bGUq");

var $99TAZ = parcelRequire("99TAZ");

var $bsb2b = parcelRequire("bsb2b");
function $78801c5fa156690c$export$2f8ee7f32af01f9f() {
    let dateArray = [];
    let monthArray = [];
    if (!(0, $cEKee.currentDateInUse)) (0, $cEKee.setCurrentDateInUse)(moment().unix());
    let currentDate = (0, $cEKee.appointmentChannelId) ? moment().startOf('month').unix() : moment((0, $cEKee.currentDateInUse) * 1000).startOf('day').unix();
    const dateRange = (0, $cEKee.form)?.appointment_channel?.max_advance_into_the_future_in_days || (0, $cIxq8.APPOINTMENT_DATE_RANGE);
    const maxBookDate = (0, $l4e3W.addDays)(moment().endOf('day').unix(), dateRange);
    // Stop at the channel's real booking horizon instead of rounding out to the
    // end of that month: those trailing cells are always rejected by the server
    // (past `max_advance`), and every extra day costs a per-day availability
    // sweep in the fully-booked-days call.
    let stopDate = maxBookDate;
    while(currentDate < stopDate){
        let currentDateObj = (0, $l4e3W.convertUnixTimeToObjectDate)(currentDate);
        dateArray.push({
            date: currentDateObj.date,
            day: currentDateObj.day,
            month: currentDateObj.month,
            year: currentDateObj.year,
            unixTime: currentDate,
            monthId: null
        });
        if (monthArray.findIndex((element)=>element.month === currentDateObj.month && element.year === currentDateObj.year) == -1) {
            monthArray.push({
                id: null,
                month: currentDateObj.month,
                year: currentDateObj.year,
                dateCount: 1
            });
            monthArray[monthArray.length - 1].id = monthArray.length - 1;
        } else monthArray[monthArray.length - 1].dateCount += 1;
        currentDate = (0, $l4e3W.addDays)(moment(currentDate * 1000).startOf('day').unix(), 1);
    }
    return {
        dateArr: dateArray,
        monthArr: monthArray
    };
}
function $78801c5fa156690c$export$be85d4e01c9474bc(clickedDate) {
    let i = 0;
    let len = (0, $cEKee.appointmentDateRange).dateArr.length;
    while(i < len){
        let appointmentDateObj = (0, $l4e3W.convertUnixTimeToObjectDate)((0, $cEKee.appointmentDateRange).dateArr[i].unixTime);
        let availableAppointmentObj = (0, $l4e3W.convertUnixTimeToObjectDate)(clickedDate);
        if ((0, $l4e3W.CompareObjectDate)(appointmentDateObj, availableAppointmentObj)) {
            let buttons = document.querySelectorAll(`${(0, $cEKee.appointmentChannelId) && !(0, $cEKee.shouldCollectPatientInfoFirstForWidget) ? '.selectOnlyDate__container' : '.selectTime__container'} .selectTime__wrappers .selectTime__carousel ${(0, $cEKee.appointmentChannelId) && !(0, $cEKee.shouldCollectPatientInfoFirstForWidget) ? '.selectOnlyTime-carousel__list' : '.selectTime-carousel__list '} .selectTime-carousel__item button`);
            const buttonsArray = Array.from(buttons)?.filter((btn)=>{
                let div = btn?.closest('.selectTime-carousel__item');
                return div && div.style.visibility !== 'hidden';
            });
            if (buttonsArray.length) buttonsArray[i].click();
            let dateLeftBtn = document.querySelector(`${(0, $cEKee.appointmentChannelId) && !(0, $cEKee.shouldCollectPatientInfoFirstForWidget) ? '.selectOnlyDate__container' : '.selectTime__container'} .date__left`);
            let dateRightBtn = document.querySelector(`${(0, $cEKee.appointmentChannelId) && !(0, $cEKee.shouldCollectPatientInfoFirstForWidget) ? '.selectOnlyDate__container' : '.selectTime__container'} .date__right`);
            let targetPage = Math.floor(i / 5);
            if (targetPage > (0, $cEKee.carouselCountLeft)) {
                let step = targetPage - (0, $cEKee.carouselCountLeft);
                for(let i = 0; i < step; i++)dateRightBtn.click();
            } else if (targetPage < (0, $cEKee.carouselCountLeft)) {
                let step = (0, $cEKee.carouselCountLeft) - targetPage;
                for(let i = 0; i < step; i++)dateLeftBtn.click();
            }
            break;
        }
        i++;
    }
}
function $78801c5fa156690c$var$getStaffIdForHostType() {
    const hostType = (0, $cEKee.form)?.appointment_channel?.host;
    if (hostType === (0, $cIxq8.HOST_TYPE_ROUND_ROBIN) || hostType === (0, $cIxq8.HOST_TYPE_COLLECTIVE)) {
        if (0, $cEKee.assignedStaffId) return 0, $cEKee.assignedStaffId;
        return null;
    }
    // "Any Provider" mode: use the staff assigned to the selected slot
    if ((0, $cEKee.providerId) === -1) return (0, $cEKee.assignedStaffId) || null;
    const selectedProviderId = (0, $cEKee.providerId) || (0, $cEKee.staffId);
    const staff = (0, $cEKee.providers).find((provider)=>provider.id === selectedProviderId);
    return staff?.id;
}
async function $78801c5fa156690c$export$16b12bebab71e24f(timeValue, dataInfoLead = null) {
    (0, $cEKee.setSelectedAppointmentUnixTime)(timeValue);
    const qualificationFields = (0, $cEKee.appointmentChannelId) ? (0, $cEKee.form)?.appointment_channel?.qualification_form?.custom_fields || [] : [];
    // upload_before fields (e.g. insurance-card photo → skip typing the
    // member ID) run one-per-page as the LAST step before reserving: slot
    // chosen, then upload/questions, then createEvent. Completion re-enters
    // this handler via navigateToNextPageWithClearFields, so mark questions
    // completed BEFORE starting the flow to break the re-entry loop. Channels
    // with show_questionnaire_before_scheduling already ran this pre-calendar.
    if ((0, $cEKee.appointmentChannelId) && qualificationFields.length > 0 && !(0, $cEKee.appointmentQuestionsCompleted) && !(0, $cEKee.form)?.appointment_channel?.show_questionnaire_before_scheduling && qualificationFields.some((f)=>f?.upload_before)) {
        (0, $cEKee.setAppointmentQuestionsCompleted)(true);
        (0, $cEKee.setListDataQuestion)({});
        (0, $cEKee.setListNamePageQuestion)([]);
        (0, $cEKee.setQuestionnaireFields)(qualificationFields);
        (0, $cEKee.setQuestionnaireFormId)((0, $cEKee.form)?.appointment_channel?.qualification_form?.id);
        (0, $cEKee.setProgressQuestion)({
            currentQuestion: 1,
            total: qualificationFields.length,
            progress: 1 / qualificationFields.length * 100
        });
        (0, $cEKee.setCustomField)(qualificationFields[0]);
        (0, $cEKee.setFirstQuestion)(true);
        (0, $9bGUq.loadCustomFields)(qualificationFields[0]);
        return;
    }
    if ((0, $cEKee.appointmentChannelId) && qualificationFields.length > 0 && !(0, $cEKee.appointmentQuestionsCompleted) && (0, $99TAZ.shouldShowAllQuestions)()) {
        if (!(0, $cEKee.customFields)?.length) (0, $cEKee.setCustomFields)(qualificationFields);
        (0, $99TAZ.loadAllQuestionsFlow)();
        return;
    }
    $78801c5fa156690c$export$4d9d36f9e948c129();
    if (0, $cEKee.leadInfo) {
        const action = (0, $er9E0.params)((0, $cIxq8.ACTION_PARAM));
        if (action === (0, $cIxq8.APPOINTMENT_ACTIONS).RESCHEDULE) {
            let startEndTime = timeValue.split('/');
            let newStartTime = parseInt(startEndTime[0]);
            let newEndTime = parseInt(startEndTime[1]);
            $78801c5fa156690c$export$4d9d36f9e948c129(false);
            (0, $bUtOS.loadAppointmentRescheduleReason)(newStartTime, newEndTime);
            (0, $6oS6b.appointmentRescheduleReasonListeners)();
            document.querySelector((0, $er9E0.getClassScreen)((0, $cIxq8.SCREEN).APPOINTMENT_RESCHEDULE_REASON)).style.transition = 'none';
            (0, $er9E0.navigate)((0, $cIxq8.SCREEN).APPOINTMENT_RESCHEDULE_REASON);
            return;
        }
        // DOB is asked as late as possible (conversion): channels with
        // `collect_dob` no longer render it on the upfront prebook form, so a
        // lead can reach slot selection without one. Detour through the
        // verify-info page — it already renders a required, prefilled DOB
        // field — whose Continue re-enters this handler with the DOB in
        // `dataInfoLead`, which breaks the loop even if the lead payload the
        // API returns ever omits `date_of_birth`.
        // The widget-row `show_dob_field` is suppressed on the prebook
        // patient-info form for the same conversion reason, so it also needs
        // the verify-info detour on that flow (sheduleConsult.js).
        const prebookWidgetDob = (0, $cEKee.form)?.show_dob_field && (0, $cEKee.form)?.appointment_channel?.collect_patient_information_first_before_scheduling;
        // Gender follows the same late-ask rule as DOB: never on the upfront
        // patient-info page, so channels/widgets that ask for it detour
        // through the verify-info page too (it renders a required select).
        const prebookWidgetGender = (0, $cEKee.form)?.show_gender_field && (0, $cEKee.form)?.appointment_channel?.collect_patient_information_first_before_scheduling;
        const needsDob = ((0, $cEKee.form)?.appointment_channel?.collect_dob || prebookWidgetDob) && !(0, $cEKee.leadInfo)?.date_of_birth && !dataInfoLead?.date_of_birth;
        const needsGender = ((0, $cEKee.form)?.appointment_channel?.collect_gender || prebookWidgetGender) && !(0, $cEKee.leadInfo)?.gender && !dataInfoLead?.gender;
        if (needsDob || needsGender) {
            $78801c5fa156690c$export$4d9d36f9e948c129(false);
            (0, $er9E0.navigate)((0, $cIxq8.SCREEN).VERIFY_INFORMATION);
            (0, $bsb2b.verifyInforListeners)((0, $cEKee.leadInfo));
            return;
        }
        if ((0, $cEKee.providers).length > 0) {
            let provider = (0, $cEKee.providers).find((i)=>i.id === (0, $cEKee.providerId));
            const procedureList = (0, $cEKee.appointmentChannelId) && (0, $cEKee.form)?.appointment_channel?.procedures?.length >= 1 ? (0, $cEKee.form)?.appointment_channel?.procedures : (0, $cEKee.procedures);
            let selectedProceduresObj = (0, $cEKee.selectedProcedures).map((i)=>procedureList.find((j)=>j.id === +i)).filter(Boolean);
            if (!selectedProceduresObj?.length && (0, $cEKee.appointmentChannelId)) {
                // Empty-selection fallback. The selection can be legitimately
                // empty (info-first flows that never show the picker) but it can
                // also have been WIPED after a valid auto-select (back-navigation
                // clears it; fetchProcedureByStaff zeroes it on a 0-match
                // provider intersection). Sending the whole menu makes a
                // single-selection channel 422 ("Please select a service to
                // book.") — so narrow by the visitor's patient type first, the
                // same filter goToServices() auto-selects with. Only if that is
                // still ambiguous do we send the wider list and let the server
                // decide.
                const menu = ((0, $cEKee.proceduresOfAppointmentChannel) ?? []).filter((p)=>p?.online_booking);
                const byPatientType = (0, $cEKee.patientSelected) && (0, $cEKee.patientSelected) !== 'all' ? menu.filter((p)=>[
                        (0, $cEKee.patientSelected),
                        'new_and_returning_patient'
                    ].includes(p?.type)) : menu;
                selectedProceduresObj = byPatientType.length ? byPatientType : menu;
            }
            const staffsOfAppointmentChannel = (0, $cEKee.form)?.appointment_channel?.staffs?.filter((staff)=>staff?.online_booking);
            // "Any Provider": resolve from the slot's assigned staff
            if (!provider && (0, $cEKee.providerId) === -1 && (0, $cEKee.assignedStaffId)) provider = staffsOfAppointmentChannel?.find((s)=>s.id === +(0, $cEKee.assignedStaffId));
            if (!provider && (0, $cEKee.appointmentChannelId) && staffsOfAppointmentChannel?.length) provider = staffsOfAppointmentChannel?.[0];
            if (selectedProceduresObj) (0, $f3IK4.loadConsultDetail)(provider, selectedProceduresObj);
            let startEndTime = timeValue.split('/');
            let startTime = parseInt(startEndTime[0]);
            let endTime = parseInt(startEndTime[1]);
            let payload = {
                location_id: (0, $cEKee.locationId),
                type: "standard",
                procedure_ids: selectedProceduresObj.map((i)=>i.id) || [],
                procedure_addon_ids: (0, $cEKee.selectedAddons).map((i)=>i.id) || [],
                participants: [
                    {
                        name: `${(0, $cEKee.leadInfo).first_name} ${(0, $cEKee.leadInfo).last_name}`,
                        participable_type: "App\\Models\\Lead",
                        participable_id: (0, $cEKee.leadInfo).id
                    },
                    ...$78801c5fa156690c$var$getStaffIdForHostType() ? [
                        {
                            name: `${provider.first_name} ${provider.last_name}`,
                            participable_type: "App\\Models\\Staff",
                            participable_id: provider.id
                        }
                    ] : []
                ],
                start_time: startTime,
                end_time: endTime,
                status: "pending",
                description: `${(0, $cEKee.leadInfo).first_name} ${(0, $cEKee.leadInfo).last_name} appointment with ${provider.first_name} ${provider.last_name} - ${moment(startTime * 1000).format('dddd DD MMMM - hh:mm A')}`,
                title: `${(0, $cEKee.businessName) ? `${0, $cEKee.businessName} - Consult` : `Appointment with ${provider.first_name} ${provider.last_name}`}`
            };
            payload.participants.forEach((item, index)=>{
                if ((0, $cEKee.leadInfo).email && (0, $cEKee.leadInfo).email.length > 0 && item.participable_type === 'App\\Models\\Lead') payload.participants[index]['email'] = (0, $cEKee.leadInfo).email;
            });
            const timezone = (0, $8yRQa.getLocalTimezoneName)();
            let createEventPayload = {
                start_time: startTime,
                procedure_ids: ((0, $cEKee.appointmentChannelId) && (0, $cEKee.form).appointment_channel.procedures?.length === 1 ? (0, $cEKee.form).appointment_channel.procedures || [] : selectedProceduresObj).map((i)=>i.id) || [],
                procedure_addon_ids: (0, $cEKee.selectedAddons).map((i)=>i.id) || [],
                lead_id: (0, $cEKee.leadInfo).id,
                title: payload.title,
                staff_id: $78801c5fa156690c$var$getStaffIdForHostType(),
                ...(0, $cEKee.selectedLocation) && {
                    location_id: (0, $cEKee.selectedLocation)
                },
                ...dataInfoLead && {
                    lead_info: {
                        ...dataInfoLead,
                        ...timezone && {
                            timezone: timezone
                        }
                    }
                },
                ...(0, $cEKee.patientSelected) && (0, $cEKee.patientSelected) !== 'all' && {
                    patient_type: (0, $cEKee.patientSelected)
                }
            };
            try {
                let createEventRes = await (0, $cNdCr.createEvent)((0, $cEKee.form).appointment_channel.id, createEventPayload);
                if (createEventRes?.data?.participants?.length) {
                    const foundLead = createEventRes.data.participants.find((participant)=>participant.participable_type === 'App\\Models\\Lead')?.participable;
                    if (foundLead) {
                        (0, $cEKee.setLeadTextId)(foundLead.text_id);
                        (0, $cEKee.setLeadInfo)(foundLead);
                    }
                }
                // Hold-then-book: for widgets with an intake form configured
                // the API returns the intake URL at CREATE time and leaves the
                // event pending — the slot is held, staff aren't notified,
                // nothing syncs to the EHR yet. Submitting the intake is what
                // actually books it, so redirect before any confirm call.
                const holdIntakeUrl = createEventRes?.data?.intake_redirect_url;
                if (holdIntakeUrl) {
                    window.parent.location.href = holdIntakeUrl;
                    return;
                }
                let confirmEventRes = await (0, $cNdCr.confirmEvent)(createEventRes.data.id, (0, $cEKee.form).appointment_channel.id);
                (0, $cEKee.setAppointmentSummary)(confirmEventRes.data);
                (0, $cEKee.setAppointmentDuration)({
                    duration: confirmEventRes.data.duration || 0,
                    requires_consult: confirmEventRes.data.requires_consult
                });
                (0, $cEKee.setEventPayload)(payload);
                (0, $cEKee.setEventId)(createEventRes.data.id);
                if ($78801c5fa156690c$var$shouldSkipQuestions() || (0, $cEKee.appointmentChannelId)) {
                    // Address is collected on the "Verify your information" page
                    // (see verifyInforListenters.js), so no dedicated address screen here.
                    const needsDepositOrCard = (0, $cEKee.form)?.appointment_channel?.collect_card_on_booking && (0, $cEKee.form)?.stripe_publishable_key;
                    if (needsDepositOrCard) // Consolidated final step: condensed recap + card form on one
                    // screen. A standalone summary screen before the card ask reads
                    // like a confirmation, so patients leave believing they booked.
                    (0, $avR5a.loadCardCollection)();
                    else {
                        const confirmRes = await (0, $cNdCr.updateEvevntStatus)(createEventRes.data.id);
                        // Slot → intake handoff: the API returns this only for
                        // widgets configured with an intake form. Send the
                        // visitor straight into their paperwork (Solv-style) —
                        // the URL carries a signed token with the booking, so
                        // the form shows what they booked without PHI in the
                        // query string.
                        const intakeUrl = confirmRes?.data?.intake_redirect_url;
                        if (intakeUrl) {
                            window.parent.location.href = intakeUrl;
                            return;
                        }
                        (0, $cEKee.setEventRoom)(confirmRes.data.event_room || null);
                        (0, $cEKee.setEventPayload)(confirmRes.data);
                        (0, $cDpNn.loadAppointmentConfirmed)();
                        (0, $hOgIi.appointmentConfirmedListeners)();
                        (0, $er9E0.navigate)((0, $cIxq8.SCREEN).APPOINTMENT_CONFIRMED);
                        (0, $er9E0.triggerCalendarRedirectIfConfigured)();
                    }
                } else $78801c5fa156690c$var$loadQuestionnaire();
            } catch (error) {
                (0, $gZEOs.toastError)(error.response?.data?.message);
            } finally{
                $78801c5fa156690c$export$4d9d36f9e948c129(false);
            }
        }
    } else try {
        (0, $hSkqV.registerNewPatientInputFieldListeners)();
        (0, $hSkqV.registerNewPatientContinueBtnListeners)();
        (0, $er9E0.navigate)((0, $cIxq8.SCREEN).REGISTER_NEW_PATIENT);
    } catch (error) {
        (0, $gZEOs.toastError)(error.response?.data?.message);
    } finally{
        $78801c5fa156690c$export$4d9d36f9e948c129(false);
    }
}
async function $78801c5fa156690c$export$28e08eff11ac64f6(containerClass) {
    document.querySelector(containerClass).innerHTML = '';
}
async function $78801c5fa156690c$export$bb87b552e8e17618() {
    const containerClass = (0, $cEKee.appointmentChannelId) && !(0, $cEKee.shouldCollectPatientInfoFirstForWidget) ? '.selectOnlyDate__container .selectTime__list' : '.selectTime__container .selectTime__list';
    await $78801c5fa156690c$export$28e08eff11ac64f6(containerClass);
}
async function $78801c5fa156690c$export$1d9c601a1a6d05() {
    (0, $cEKee.setCarouselCountLeft)(0);
    const containerClass = (0, $cEKee.appointmentChannelId) && !(0, $cEKee.shouldCollectPatientInfoFirstForWidget) ? '.selectOnlyDate__container .selectTime-carousel__list' : '.selectTime__container .selectTime-carousel__list';
    await $78801c5fa156690c$export$28e08eff11ac64f6(containerClass);
}
async function $78801c5fa156690c$export$de29d67d57fc8f3b() {
    $78801c5fa156690c$export$1d9c601a1a6d05();
    $78801c5fa156690c$export$bb87b552e8e17618();
}
async function $78801c5fa156690c$export$4d9d36f9e948c129(isLoading = true) {
    if (!isLoading) {
        document.querySelectorAll('.selectTime__list .selectTime__item').forEach((element)=>{
            element.style.pointerEvents = 'auto';
        });
        document.querySelector(`[data-time-value="${(0, $cEKee.selectedAppointmentUnixTime)}"] .selectTime__right-arrow`)?.classList.remove('hidden');
        document.querySelector(`[data-time-value="${(0, $cEKee.selectedAppointmentUnixTime)}"] .selectTime__spinner`)?.classList.add('hidden');
    } else {
        document.querySelectorAll('.selectTime__list .selectTime__item').forEach((element)=>{
            element.style.pointerEvents = 'none';
        });
        document.querySelector(`[data-time-value="${(0, $cEKee.selectedAppointmentUnixTime)}"] .selectTime__right-arrow`)?.classList.add('hidden');
        document.querySelector(`[data-time-value="${(0, $cEKee.selectedAppointmentUnixTime)}"] .selectTime__spinner`)?.classList.remove('hidden');
    }
}
function $78801c5fa156690c$export$ed7231779fea24d5(clickedDate) {
    const dateContainer = document.querySelectorAll('.selectOnlyDate__container .selectTime-carousel__item-Month');
    const dateList = document.querySelector('.selectOnlyDate__container .selectOnlyTime-carousel__list');
    const selectTimeItemWidth = document.querySelector('.selectOnlyDate__container .selectTime__carousel')?.offsetWidth || 0;
    const maxWidth = (dateContainer.length - 1) * selectTimeItemWidth;
    let targetIndex = -1;
    let i = 0;
    let len = (0, $cEKee.appointmentDateRange).dateArr.length;
    while(i < len){
        let appointmentDateObj = (0, $l4e3W.convertUnixTimeToObjectDate)((0, $cEKee.appointmentDateRange).dateArr[i].unixTime);
        let availableAppointmentObj = (0, $l4e3W.convertUnixTimeToObjectDate)(clickedDate);
        if ((0, $l4e3W.CompareObjectDate)(appointmentDateObj, availableAppointmentObj)) {
            targetIndex = i;
            break;
        }
        i++;
    }
    if (targetIndex !== -1) {
        const targetMonth = Math.floor(targetIndex / 30);
        let currentWidth = targetMonth * selectTimeItemWidth;
        currentWidth = Math.min(currentWidth, maxWidth);
        dateList.style.transform = `translateX(-${currentWidth}px)`;
        (0, $e4miY.leadMonthCurrent)(Math.floor(currentWidth / selectTimeItemWidth));
        const dateLeftBtn = document.querySelector('.selectOnlyDate__container .date__left');
        const dateRightBtn = document.querySelector('.selectOnlyDate__container .date__right');
        if (currentWidth <= 0) dateLeftBtn.classList.add('date__left-right--disable');
        else dateLeftBtn.classList.remove('date__left-right--disable');
        if (currentWidth >= maxWidth) dateRightBtn.classList.add('date__left-right--disable');
        else dateRightBtn.classList.remove('date__left-right--disable');
        const buttons = document.querySelectorAll('.selectOnlyDate__container .selectTime-carousel__item button');
        const buttonsArray = Array.from(buttons)?.filter((btn)=>{
            let div = btn?.closest('.selectTime-carousel__item');
            return div && div.style.visibility !== 'hidden';
        });
        if (buttonsArray.length && buttonsArray[targetIndex]) buttonsArray[targetIndex].click();
    }
}
function $78801c5fa156690c$var$shouldSkipQuestions() {
    const questionnaire = (0, $cEKee.appointmentChannelId) ? (0, $cEKee.form)?.appointment_channel?.qualification_form?.custom_fields : (0, $cEKee.form)?.form?.custom_fields;
    if (questionnaire?.length) return false;
    return (0, $cEKee.providerId) !== 172;
}
function $78801c5fa156690c$var$loadQuestionnaire() {
    const questionnaire = (0, $cEKee.appointmentChannelId) ? (0, $cEKee.form)?.appointment_channel?.qualification_form?.custom_fields : (0, $cEKee.form)?.form?.custom_fields;
    if (!questionnaire?.length) return;
    const firstQuestion = questionnaire[0];
    const totalQuestions = questionnaire.length;
    (0, $cEKee.setProgressQuestion)({
        currentQuestion: 1,
        total: totalQuestions,
        progress: 1 / totalQuestions * 100
    });
    (0, $cEKee.setCustomField)(firstQuestion);
    (0, $cEKee.setFirstQuestion)(true);
    (0, $9bGUq.loadCustomFields)((0, $cEKee.customField));
}
function $78801c5fa156690c$export$e58522e1e5e6879() {
    (0, $2BtZD.loadAppoimentsSummary)();
    (0, $er9E0.navigate)((0, $cIxq8.SCREEN).APPOINTMENT_SUMMARY);
    (0, $gEfFu.appointmentSummaryListeners)();
}

});
parcelRegister("cNdCr", function(module, exports) {

$parcel$export(module.exports, "createEvent", () => $9504a0125d492264$export$c30017717ce2168e);
$parcel$export(module.exports, "confirmEvent", () => $9504a0125d492264$export$160d650f72818829);
$parcel$export(module.exports, "updateEvevntStatus", () => $9504a0125d492264$export$955b2dd753c57e77);
$parcel$export(module.exports, "createEventPaymentMethodSetupIntent", () => $9504a0125d492264$export$6d05ed1b653c8c6c);
$parcel$export(module.exports, "saveEventPaymentMethod", () => $9504a0125d492264$export$6b20b4e7b7d8a16a);
$parcel$export(module.exports, "getEvevntInfoById", () => $9504a0125d492264$export$afb9c7282f6d5543);
$parcel$export(module.exports, "getEventStatus", () => $9504a0125d492264$export$8564f62bdc4bfd8c);
$parcel$export(module.exports, "getEventResume", () => $9504a0125d492264$export$9d26de88cfb7e168);
$parcel$export(module.exports, "getLeadResumeToken", () => $9504a0125d492264$export$fd26b7059f7afd70);
$parcel$export(module.exports, "cancelEvent", () => $9504a0125d492264$export$e9caaaecfee38128);
$parcel$export(module.exports, "rescheduleAppointment", () => $9504a0125d492264$export$d49bf8b0d6ea0efc);
$parcel$export(module.exports, "primeRescheduleSignatureParams", () => $9504a0125d492264$export$fbc6c99b6a19dd32);

var $er9E0 = parcelRequire("er9E0");

var $hvLQT = parcelRequire("hvLQT");

var $cEKee = parcelRequire("cEKee");
/** Cache signed params so reschedule/cancel still work if the URL is changed (e.g. navigation or iframe). */ let $9504a0125d492264$var$cachedSignedParams = null;
/**
 * widget_uuid tells the API WHICH widget this booking came through, so a
 * widget configured with an intake handoff (intake_template_id) can hand back
 * an `intake_redirect_url` to send the visitor into their paperwork.
 */ function $9504a0125d492264$var$widgetUuidFromUrl() {
    const query = new URLSearchParams(window.location.search);
    return query.get('form_id') || query.get('form');
}
async function $9504a0125d492264$export$c30017717ce2168e(appointmentChannel, payload) {
    const widgetUuid = $9504a0125d492264$var$widgetUuidFromUrl();
    return await (0, $hvLQT.apiClient).POST(`api/widget/events/appointment-channel/${appointmentChannel}`, {
        ...payload,
        ...(0, $cEKee.typedIdentity)(),
        ...widgetUuid ? {
            widget_uuid: widgetUuid
        } : {}
    });
}
async function $9504a0125d492264$export$160d650f72818829(eventId, appointmentChannel) {
    return await (0, $hvLQT.apiClient).GET(`api/events/${eventId}/appointment-channel/${appointmentChannel}/confirmation`);
}
async function $9504a0125d492264$export$955b2dd753c57e77(eventId) {
    const widgetUuid = $9504a0125d492264$var$widgetUuidFromUrl();
    return await (0, $hvLQT.apiClient).PUT(`api/widget/events/${eventId}/confirm`, {
        ...(0, $cEKee.typedIdentity)(),
        ...widgetUuid ? {
            widget_uuid: widgetUuid
        } : {}
    });
}
async function $9504a0125d492264$export$6d05ed1b653c8c6c(eventId) {
    const res = await (0, $hvLQT.apiClient).POST(`api/widget/events/${eventId}/payment-method/setup-intent`, {});
    return res?.data?.client_secret ?? null;
}
async function $9504a0125d492264$export$6b20b4e7b7d8a16a(eventId, paymentMethodId) {
    return await (0, $hvLQT.apiClient).PUT(`api/widget/events/${eventId}/payment-method`, {
        payment_method_id: paymentMethodId
    });
}
async function $9504a0125d492264$export$afb9c7282f6d5543(eventId) {
    return await (0, $hvLQT.apiClient).GET(`api/events/${eventId}`);
}
async function $9504a0125d492264$export$8564f62bdc4bfd8c(eventId) {
    return await (0, $hvLQT.apiClient).GET(`api/widget/events/${eventId}/status`);
}
async function $9504a0125d492264$export$9d26de88cfb7e168(eventId, signature, expires) {
    const query = new URLSearchParams({
        signature: signature,
        expires: expires
    });
    return await (0, $hvLQT.apiClient).GET(`api/widget/events/${eventId}/resume?${query.toString()}`);
}
async function $9504a0125d492264$export$fd26b7059f7afd70(leadId, signature, expires) {
    const query = new URLSearchParams({
        signature: signature,
        expires: expires
    });
    return await (0, $hvLQT.apiClient).GET(`api/widget/leads/${leadId}/resume-token?${query.toString()}`);
}
async function $9504a0125d492264$export$7515ecefb5bac325(eventId, reason) {
    const signedParams = $9504a0125d492264$var$getSignedMiddlewareParams();
    const url = `api/events/${eventId}/action${signedParams}`;
    return await (0, $hvLQT.apiClient).PUT(url, {
        action: 'cancel',
        reason: reason
    });
}
async function $9504a0125d492264$export$e9caaaecfee38128(eventId, reason) {
    const signedParams = $9504a0125d492264$var$getSignedMiddlewareParams();
    const url = `api/events/${eventId}/cancel${signedParams}`;
    return await (0, $hvLQT.apiClient).PUT(url, {
        reason: reason
    });
}
async function $9504a0125d492264$export$83fe8b63b82504f(eventId, payload) {
    const signedParams = $9504a0125d492264$var$getSignedMiddlewareParams();
    const url = `api/events/${eventId}/action${signedParams}`;
    return await (0, $hvLQT.apiClient).PUT(url, {
        ...payload,
        action: 'confirm'
    });
}
async function $9504a0125d492264$export$d49bf8b0d6ea0efc(eventId, payload) {
    const signedParams = $9504a0125d492264$var$getSignedMiddlewareParams();
    const url = `api/events/${eventId}/reschedule${signedParams}`;
    return await (0, $hvLQT.apiClient).PUT(url, payload);
}
function $9504a0125d492264$export$fbc6c99b6a19dd32() {
    $9504a0125d492264$var$getSignedMiddlewareParams();
}
function $9504a0125d492264$var$getParamFromLocation(param, location) {
    if (!location || !location.search) return null;
    const search = (location.search || '').replace(/^\?+/, '?');
    const urlParams = new URLSearchParams(search);
    return urlParams.get(param);
}
function $9504a0125d492264$var$getSignedMiddlewareParams() {
    let signature = (0, $er9E0.params)('signature');
    let expires = (0, $er9E0.params)('expires');
    let version = (0, $er9E0.params)('v');
    if ((!signature || !expires) && window.self !== window.top) try {
        signature = signature || $9504a0125d492264$var$getParamFromLocation('signature', window.top.location);
        expires = expires || $9504a0125d492264$var$getParamFromLocation('expires', window.top.location);
        version = version || $9504a0125d492264$var$getParamFromLocation('v', window.top.location);
    } catch (_) {
    // Cross-origin: can't read top.location
    }
    if (signature && expires) $9504a0125d492264$var$cachedSignedParams = {
        signature: signature,
        expires: expires,
        version: version
    };
    else if ($9504a0125d492264$var$cachedSignedParams) {
        signature = $9504a0125d492264$var$cachedSignedParams.signature;
        expires = $9504a0125d492264$var$cachedSignedParams.expires;
        version = $9504a0125d492264$var$cachedSignedParams.version;
    }
    let queryParams = '';
    if (signature && expires) {
        // Laravel signs the URL with params in alphabetical order (ksort). Validation uses raw QUERY_STRING,
        // so we must send params in the same order: expires, signature, v.
        const parts = [
            `expires=${expires}`,
            `signature=${signature}`
        ];
        if (version != null && version !== '') parts.push(`v=${version}`);
        queryParams = '?' + parts.join('&');
    }
    return queryParams;
}

});

parcelRegister("l4e3W", function(module, exports) {

$parcel$export(module.exports, "addDays", () => $f564e1364a300ec7$export$dd412b56f1e4d8aa);
$parcel$export(module.exports, "convertUnixTimeToObjectDate", () => $f564e1364a300ec7$export$5569eceb95b4cb6e);
$parcel$export(module.exports, "CompareObjectDate", () => $f564e1364a300ec7$export$98025fe9c227f57);
$parcel$export(module.exports, "convertMonthFormat", () => $f564e1364a300ec7$export$fd508f5b3c08be44);
function $f564e1364a300ec7$export$4f0373a796cddba8(unixTime) {
    var a = new Date(unixTime * 1000);
    var months = [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
    ];
    var dayInWeek = [
        'Sun',
        'Mon',
        'Tue',
        'Wed',
        'Thu',
        'Fri',
        'Sat'
    ];
    var year = a.getFullYear();
    var month = months[a.getMonth()];
    var date = a.getDate();
    var day = dayInWeek[a.getDay()];
    return day + ', ' + month + ' ' + date;
}
function $f564e1364a300ec7$export$a76ca369783b6e62(unixTime) {
    return moment(unixTime * 1000).format('hh:mm A');
}
function $f564e1364a300ec7$export$abe538c79c7a3de7(unixTime) {
    var months = [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
    ];
    return months[new Date(unixTime).getMonth()];
}
function $f564e1364a300ec7$export$4783c0bcec402e42(schedules) {
    let schedule = {};
    for (const i of schedules){
        const day = $f564e1364a300ec7$export$4f0373a796cddba8(i.start).split(',')[0];
        schedule[day] = [];
    }
    for (const i of schedules){
        const day = $f564e1364a300ec7$export$4f0373a796cddba8(i.start).split(',')[0];
        schedule[day] = [
            ...schedule[day],
            {
                time: $f564e1364a300ec7$export$a76ca369783b6e62(i.start),
                start: i.start,
                end: i.end
            }
        ];
    }
    return schedule;
}
function $f564e1364a300ec7$export$54909074ac30785b() {
    return moment().unix();
}
function $f564e1364a300ec7$export$dd412b56f1e4d8aa(x, y) {
    return moment(moment.unix(x)).add(y, 'days').unix();
}
function $f564e1364a300ec7$export$5569eceb95b4cb6e(unixTime) {
    var a = new Date(unixTime * 1000);
    var months = [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
    ];
    var dayInWeek = [
        'Sun',
        'Mon',
        'Tue',
        'Wed',
        'Thu',
        'Fri',
        'Sat'
    ];
    var year = a.getFullYear();
    var month = months[a.getMonth()];
    var date = a.getDate();
    var day = dayInWeek[a.getDay()];
    return {
        day: day,
        month: month,
        date: date,
        year: year
    };
}
function $f564e1364a300ec7$export$98025fe9c227f57(objectDateA, ObjectDateB) {
    if (objectDateA.date === ObjectDateB.date && objectDateA.month === ObjectDateB.month && objectDateA.year === ObjectDateB.year) return true;
    return false;
}
function $f564e1364a300ec7$export$fd508f5b3c08be44(month, format) {
    let months = {
        'Jan': 'January',
        'Feb': 'February',
        'Mar': 'March',
        'Apr': 'April',
        'May': 'May',
        'Jun': 'June',
        'Jul': 'July',
        'Aug': 'August',
        'Sep': 'September',
        'Oct': 'October',
        'Nov': 'November',
        'Dec': 'December'
    };
    if (format === 'long') return months[month];
    return Object.keys(months).find((key)=>months[key] === month);
}
function $f564e1364a300ec7$export$cba94edee8999c7(year) {
    return moment([
        year
    ]).isLeapYear();
}

});

parcelRegister("2BtZD", function(module, exports) {

$parcel$export(module.exports, "loadAppoimentsSummary", () => $1e564d78f8316e05$export$f71e90aae0838775);

var $knjAn = parcelRequire("knjAn");

var $cEKee = parcelRequire("cEKee");

var $aROBf = parcelRequire("aROBf");

var $fWpof = parcelRequire("fWpof");
async function $1e564d78f8316e05$export$e35716fff80511dc() {
    if ((0, $cEKee.appointmentDuration).requires_consult) {
        const banner = document.querySelector('.appointment-summary__container .appointment__banner');
        banner.style.display = 'flex';
        banner.querySelector('.message span').innerText = (0, $cEKee.appointmentSummary).duration;
    }
    let startTime = (0, $cEKee.appointmentSummary).event.start_time;
    document.querySelector('.appointment-summary__container .appointment-time .name-title span').textContent = moment(startTime * 1000).format('hh:mm A');
    document.querySelector('.appointment-summary__container .appointment-time .detail-info').innerHTML = '';
    document.querySelector('.appointment-summary__container .appointment-time .detail-info').insertAdjacentHTML('beforeend', `<span>${moment(startTime * 1000).format('dddd')}</span><br>${moment(startTime * 1000).format('MMMM DD, YYYY')}`);
    let duration = document.querySelector('.appointment-summary__container .appointment-time .name-title .duration');
    duration.style.background = `${0, $cEKee.primaryColor}09`;
    const durationTime = moment.duration((0, $cEKee.appointmentDuration).duration, 'm');
    if (durationTime._data.hours >= 0 && durationTime._data.minutes > 0) duration.textContent = `${moment.duration((0, $cEKee.appointmentDuration).duration, 'm').format('h[h] m')}min`;
    else duration.textContent = moment.duration((0, $cEKee.appointmentDuration).duration, 'm').format('h[h]');
}
async function $1e564d78f8316e05$export$b7731a16b21af319() {
    document.querySelector('.appointment-summary__body .greeting').textContent = `${(0, $knjAn.t)('greeting_hi')} ${(0, $cEKee.leadInfo)?.first_name || ''} ${(0, $cEKee.leadInfo)?.last_name || ''}, `;
}
async function $1e564d78f8316e05$export$db684092bf26141a() {
    let selectedLocationObj = (0, $cEKee.locations).find((e)=>e.id === (0, $cEKee.appointmentSummary).event.location_id);
    let selectedStaffsObj = (0, $cEKee.providers).filter((e)=>(0, $cEKee.appointmentSummary).staffs?.map((i)=>i.participable_id)?.includes(e.id));
    const staffNames = selectedStaffsObj?.map((i)=>`${i?.first_name} ${i?.last_name}`);
    document.querySelector('.appointment-summary__container .appointment-location .name-title span').textContent = staffNames.join(', ');
    const nameSpan = document.querySelector('.appointment-summary__container .appointment-location .name-title span');
    if (nameSpan) nameSpan.classList.toggle('wrap-name', selectedStaffsObj?.length > 1);
    // Treat the visit as remote when the channel is a virtual meeting, OR when
    // every selected (or every bookable) service is delivered remotely.
    // A remote service can still carry a physical location_id — never show
    // that address or the office phone. All-virtual → "Virtual appointment".
    const selectedProcedures = (0, $cEKee.appointmentSummary).event.procedures ?? [];
    const hasVirtualVisit = (0, $fWpof.isVirtualVisit)((0, $cEKee.form), selectedProcedures);
    let locationInfo = '';
    if (hasVirtualVisit) locationInfo = `<span>${(0, $knjAn.t)((0, $fWpof.remoteVisitLabelKey)(selectedProcedures))}</span>`;
    else {
        let address = selectedLocationObj?.address1 ? `${selectedLocationObj.address1}, ` : '';
        let city = selectedLocationObj?.city ? `${selectedLocationObj.city}, ` : '';
        let state = selectedLocationObj?.state ? `${selectedLocationObj.state}, ` : '';
        let country = selectedLocationObj?.country ? `${selectedLocationObj.country}` : '';
        locationInfo = `<span>${selectedLocationObj.name}</span><span title="${(0, $knjAn.t)('click_to_copy')}">${address}${city}${state}${country}</span>`;
    }
    document.querySelector('.appointment-summary__container .appointment-location .detail-info').innerHTML = locationInfo;
}
async function $1e564d78f8316e05$export$b92721dad047892() {
    let listWrapperDOM = document.querySelector('.appointment-summary__body .appoitment-details .appoitment-details__info .procedure__list');
    let totalPriceDOM = document.querySelector('.appointment-summary__container .appointment-summary__actions .total .price');
    let totalTitleDOM = document.querySelector('.appointment-summary__container .appointment-summary__actions .total .title ');
    const showPricingForAll = (0, $cEKee.appointmentSummary).event.procedures?.every((procedure)=>procedure?.show_pricing);
    document.querySelector('.appointment-summary__body .appoitment-details .appoitment-details__info').style.background = `${0, $cEKee.primaryColor}09`;
    if ((0, $cEKee.appointmentSummary).event.procedures.length === 0) {
        listWrapperDOM.innerHTML = '';
        listWrapperDOM.insertAdjacentHTML('beforeEnd', `<div class="procedure__item--empty"><div class="message">${(0, $knjAn.t)('no_procedures_selected')}</div></div>`);
        totalPriceDOM.textContent = '';
    } else {
        let listItemHTML = '';
        (0, $cEKee.appointmentSummary).event.procedures.forEach((procedure)=>{
            listItemHTML += `
                <div class="procedure__item">
                    <div class="name-duration">
                        <div class="name">
                            ${(0, $aROBf.procedureDisplayName)(procedure) || ''}
                        </div>
                        <div class="duration">
                            ${(0, $cEKee.appointmentDuration).requires_consult ? '' : $1e564d78f8316e05$var$duration(procedure)}
                           
                        </div>
                    </div>
                    <div class='price-label ${procedure.min_cost && procedure?.show_pricing ? '' : 'bg-transparent'}'>
                        ${procedure.min_cost && procedure?.show_pricing ? `$${procedure.min_cost}` : ''}
                    </div>
                </div>
            `;
        });
        listWrapperDOM.innerHTML = '';
        listWrapperDOM.insertAdjacentHTML('beforeend', listItemHTML);
        document.querySelectorAll('.appointment-summary__body .appoitment-details .appoitment-details__info .procedure__list .procedure__item .price-label').forEach((element)=>{
            element.style.background = `${0, $cEKee.primaryColor}0f`;
            element.style.color = `${0, $cEKee.primaryColor}`;
        });
        if (showPricingForAll) {
            const totalStaffs = (0, $cEKee.appointmentSummary)?.staffs?.length;
            const pricing = totalStaffs === 1 ? (0, $cEKee.appointmentSummary).estimate.min_total : totalStaffs > 1 ? (0, $cEKee.appointmentSummary).estimate.min_cost : 0;
            totalPriceDOM.textContent = pricing ? `$${pricing}` : '';
            totalTitleDOM.textContent = (0, $knjAn.t)('total_services').replace('{count}', (0, $cEKee.appointmentSummary).event.procedures.length);
        }
    }
}
async function $1e564d78f8316e05$export$917c3672bb22f253(htmlContent) {
    let listWrapperDOM = document.querySelector('.appointment-summary__body .appoitment-details .appoitment-details__info .procedure__list');
    listWrapperDOM.innerHTML = '';
    listWrapperDOM.insertAdjacentHTML('beforeend', htmlContent);
}
async function $1e564d78f8316e05$export$f71e90aae0838775() {
    $1e564d78f8316e05$export$b92721dad047892();
    $1e564d78f8316e05$export$db684092bf26141a();
    $1e564d78f8316e05$export$e35716fff80511dc();
    $1e564d78f8316e05$export$b7731a16b21af319();
}
function $1e564d78f8316e05$var$duration(procedure) {
    if (!(0, $cEKee.staffProcedures)?.length || !procedure?.i) return '';
    const staffProcedureSelect = (0, $cEKee.staffProcedures).filter((item)=>item.staff_id === (0, $cEKee.providerId));
    if (!staffProcedureSelect.length) return '';
    const durationProcedure = staffProcedureSelect.find((item)=>item.procedure_id === procedure.i);
    if (!durationProcedure?.duration) return '';
    const durationTime = moment.duration(durationProcedure.duration, 'm');
    return `${durationTime.hours() ? `${durationTime.hours()}h` : ''} ${durationTime.minutes()}min`;
}

});
parcelRegister("fWpof", function(module, exports) {

$parcel$export(module.exports, "procedureDeliveryBucket", () => $b9aff7be021d282f$export$533855f760813cc0);
$parcel$export(module.exports, "isPhoneBooking", () => $b9aff7be021d282f$export$596e3cbbd5fd4632);
$parcel$export(module.exports, "remoteVisitLabelKey", () => $b9aff7be021d282f$export$11b5f24f2c9b39ab);
$parcel$export(module.exports, "isVirtualVisit", () => $b9aff7be021d282f$export$808fd347fcca2e0b);
/**
 * Delivery-mode buckets for the "How would you like to meet?" step.
 *
 * A channel's services sort into three buckets by service_delivery_mode:
 *   virtual   → fully_virtual (video visit)
 *   phone     → phone_consultation (the provider calls the patient)
 *   in_person → everything else
 * Inquiry tiles (online_booking_option === 'inquiry') WITHOUT a
 * service_delivery_mode belong to every bucket and never create an option on
 * their own. An inquiry tile that does carry a mode is that mode's service and
 * does create the option — selecting it routes to the inquiry end screen, which
 * is how "in person = plain enquiry, phone = scheduler" is configured.
 */ const $b9aff7be021d282f$export$4c5e5f0cf1c2e3c5 = [
    'in_person',
    'virtual',
    'phone'
];
function $b9aff7be021d282f$export$533855f760813cc0(procedure) {
    if (procedure?.service_delivery_mode === 'fully_virtual') return 'virtual';
    if (procedure?.service_delivery_mode === 'phone_consultation') return 'phone';
    return 'in_person';
}
function $b9aff7be021d282f$export$5ce75010ddcc98e(procedures) {
    return (procedures?.length ?? 0) > 0 && procedures.every((p)=>[
            'fully_virtual',
            'phone_consultation'
        ].includes(p?.service_delivery_mode));
}
function $b9aff7be021d282f$export$596e3cbbd5fd4632(procedures) {
    return (procedures?.length ?? 0) > 0 && procedures.every((p)=>p?.service_delivery_mode === 'phone_consultation');
}
function $b9aff7be021d282f$export$11b5f24f2c9b39ab(procedures) {
    return $b9aff7be021d282f$export$596e3cbbd5fd4632(procedures) ? 'phone_call' : 'virtual_appointment';
}
function $b9aff7be021d282f$export$808fd347fcca2e0b(form, procedures) {
    if (form?.appointment_channel?.is_virtual_meeting) return true;
    if ($b9aff7be021d282f$export$5ce75010ddcc98e(procedures)) return true;
    const channelProcs = (form?.appointment_channel?.procedures ?? []).filter((p)=>p?.online_booking);
    return $b9aff7be021d282f$export$5ce75010ddcc98e(channelProcs);
}

});


parcelRegister("cDpNn", function(module, exports) {

$parcel$export(module.exports, "loadAppointmentConfirmed", () => $932d22fee698e8bd$export$7c15e37cacd6ba65);
$parcel$export(module.exports, "loadAppointmentGonePage", () => $932d22fee698e8bd$export$478b5967993a42eb);

var $45fvw = parcelRequire("45fvw");

var $knjAn = parcelRequire("knjAn");

var $8Jd2Q = parcelRequire("8Jd2Q");

var $62LVp = parcelRequire("62LVp");

var $er9E0 = parcelRequire("er9E0");

var $cIxq8 = parcelRequire("cIxq8");

var $aROBf = parcelRequire("aROBf");

var $fWpof = parcelRequire("fWpof");

var $66jZq = parcelRequire("66jZq");

var $ebrDl = parcelRequire("ebrDl");

var $cEKee = parcelRequire("cEKee");

var $cNdCr = parcelRequire("cNdCr");

var $9ILu0 = parcelRequire("9ILu0");
async function $932d22fee698e8bd$export$7c15e37cacd6ba65() {
    if (!(0, $cEKee.eventPayload)) return;
    if ((0, $cEKee.eventPayload).id && !(0, $er9E0.params)((0, $cIxq8.EVENT_ID_PARAM))) (0, $er9E0.updateUrlWithEventId)((0, $cEKee.eventPayload).id, (0, $cEKee.eventPayload).resume_signature && (0, $cEKee.eventPayload).resume_expires ? {
        signature: (0, $cEKee.eventPayload).resume_signature,
        expires: (0, $cEKee.eventPayload).resume_expires
    } : null);
    $932d22fee698e8bd$var$initializeStyles();
    $932d22fee698e8bd$var$setBusinessLogo();
    $932d22fee698e8bd$var$setClientPortalSignInLink();
    $932d22fee698e8bd$var$renderAppointmentInfo();
    $932d22fee698e8bd$var$handleCalendarAndDirections();
    $932d22fee698e8bd$var$handleConfirmCancelButtons();
}
/** Dashboard base URL (telehealth + client portal live here). From API config widgets.dashboard.url. */ function $932d22fee698e8bd$var$getDashboardBaseUrl() {
    return (0, $cEKee.form)?.data?.dashboard_base_url || (0, $cEKee.form)?.project?.client_portal_base_url || (0, $cEKee.form)?.project?.dashboard_base_url || window.location.origin;
}
/** Sign-in URL for client portal: prefer backend-provided client_portal_url, else build from dashboard base + project uuid. */ function $932d22fee698e8bd$var$getClientPortalUrl() {
    const fromBackend = (0, $cEKee.form)?.data?.client_portal_url;
    if (fromBackend) return fromBackend;
    const baseClean = String($932d22fee698e8bd$var$getDashboardBaseUrl()).replace(/\/$/, '');
    const projectUuid = (0, $cEKee.form)?.project?.uuid;
    return projectUuid ? `${baseClean}/client/portal/${projectUuid}` : `${baseClean}/client/portal`;
}
/** Default dashboard host when API does not send dashboard_base_url (telehealth must never use assistant or embed origin). */ const $932d22fee698e8bd$var$DEFAULT_DASHBOARD_BASE = 'https://dashboard.pilotpractice.com';
/** Join URL for video appointments: use dashboard host + /telehealth/{text_id} so users authenticate. Never use window.location.origin (could be assistant or embed). Fallback to room_url if no text_id. */ function $932d22fee698e8bd$var$getTelehealthJoinUrl() {
    if (!(0, $cEKee.eventRoom)) return null;
    const textId = (0, $cEKee.eventRoom).text_id;
    if (textId) {
        const base = (0, $cEKee.form)?.data?.dashboard_base_url || (0, $cEKee.form)?.project?.dashboard_base_url || $932d22fee698e8bd$var$DEFAULT_DASHBOARD_BASE;
        const baseClean = String(base).replace(/\/$/, '');
        return `${baseClean}/telehealth/${textId}`;
    }
    return (0, $cEKee.eventRoom).room_url || null;
}
function $932d22fee698e8bd$var$setClientPortalSignInLink() {
    const link = document.getElementById('header-sign-in-client-portal');
    if (!link) return;
    link.setAttribute('href', $932d22fee698e8bd$var$getClientPortalUrl());
    link.setAttribute('target', '_blank');
    link.setAttribute('rel', 'noopener noreferrer');
}
function $932d22fee698e8bd$var$initializeStyles() {
    const container = document.querySelector((0, $9ILu0.SELECTORS).container);
    if (!container) return;
    const informationCard = document.querySelector((0, $9ILu0.SELECTORS).informationCard);
    if (informationCard) informationCard.style.backgroundColor = 'transparent';
}
function $932d22fee698e8bd$var$setBusinessLogo() {
    if ((0, $cEKee.form).project.business_photo) document.querySelector('.appointment__logo')?.setAttribute('src', (0, $cEKee.form).project.business_photo);
}
function $932d22fee698e8bd$var$renderAppointmentInfo() {
    const startTime = parseInt((0, $cEKee.eventPayload).start_time);
    const staffName = $932d22fee698e8bd$var$getStaffName();
    const staffNameDom = document.querySelector((0, $9ILu0.SELECTORS).staffInfo);
    const timeInfoDom = document.querySelector((0, $9ILu0.SELECTORS).timeInfo);
    const dateInfoDom = document.querySelector((0, $9ILu0.SELECTORS).dateInfo);
    if (staffNameDom) staffNameDom.textContent = staffName;
    if (timeInfoDom) timeInfoDom.textContent = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(startTime * 1000).format('hh:mm A');
    /* Date is shown in the title only; hide the redundant date line to avoid showing the date twice. */ if (dateInfoDom) {
        dateInfoDom.textContent = '';
        dateInfoDom.style.display = 'none';
    }
    $932d22fee698e8bd$var$updateAppointmentTitle();
    $932d22fee698e8bd$var$renderAppointmentStatus();
    $932d22fee698e8bd$var$renderServicesRow();
}
function $932d22fee698e8bd$var$getStatusLabel(status) {
    switch(status){
        case (0, $9ILu0.APPOINTMENT_STATUS).CONFIRMED:
            return (0, $knjAn.t)('confirmed');
        case (0, $9ILu0.APPOINTMENT_STATUS).REQUEST:
            return (0, $knjAn.t)('pending');
        case (0, $9ILu0.APPOINTMENT_STATUS).COMPLETE:
            return (0, $knjAn.t)('complete');
        case (0, $9ILu0.APPOINTMENT_STATUS).CANCELLED:
            return (0, $knjAn.t)('cancelled');
        default:
            return status ? String(status) : '';
    }
}
function $932d22fee698e8bd$var$renderAppointmentStatus() {
    const statusEl = document.querySelector('.appointment-confirmed__status');
    if (!statusEl) return;
    const status = (0, $cEKee.eventPayload)?.status;
    const label = $932d22fee698e8bd$var$getStatusLabel(status);
    if (!label) {
        statusEl.textContent = '';
        statusEl.style.display = 'none';
        return;
    }
    statusEl.textContent = label;
    statusEl.style.display = 'inline-block';
    statusEl.className = 'appointment-confirmed__status appointment-confirmed__status--' + (status || '');
}
function $932d22fee698e8bd$var$renderServicesRow() {
    const procedures = (0, $cEKee.eventPayload).procedures ?? (0, $cEKee.appointmentSummary)?.event?.procedures ?? [];
    if (!procedures.length) return;
    const informationContainer = document.querySelector('.appointment-confirmed__body .information');
    if (!informationContainer) return;
    const existingRow = informationContainer.querySelector('.appointment-services__row');
    if (existingRow) existingRow.remove();
    const names = procedures.map((p)=>(0, $aROBf.procedureDisplayName)(p) || p.title).filter(Boolean);
    if (!names.length) return;
    names.push(...$932d22fee698e8bd$var$getBookedAddonNames(procedures));
    const row = document.createElement('div');
    row.className = 'appointment-services__row';
    row.innerHTML = `
        <div class="appointment-services__label">${(0, $knjAn.t)('services')}</div>
        <div class="appointment-services__list">${names.join(', ')}</div>
    `;
    informationContainer.appendChild(row);
}
/**
 * Booked add-on names for the SERVICES row. Prefer the event payload
 * (procedure_addons — loaded on resume/confirm responses); right after an
 * in-session booking the create response may omit the relation, so fall
 * back to the visitor's selection (selectedAddons holds {id, procedureId})
 * resolved against the procedures' own procedure_addons lists.
 */ function $932d22fee698e8bd$var$getBookedAddonNames(procedures) {
    const fromPayload = (0, $cEKee.eventPayload).procedure_addons ?? [];
    if (fromPayload.length) return fromPayload.map((a)=>a.title || a.name).filter(Boolean);
    return (0, $cEKee.selectedAddons).map((sel)=>{
        if (sel.title || sel.name) return sel.title || sel.name;
        const proc = procedures.find((p)=>p.id === sel.procedureId) ?? (0, $cEKee.procedures).find((p)=>p.id === sel.procedureId);
        const addon = proc?.procedure_addons?.find((a)=>a.id === sel.id);
        return addon ? addon.title || addon.name : null;
    }).filter(Boolean);
}
function $932d22fee698e8bd$var$renderAddressRow() {
    if ((0, $cEKee.eventRoom) !== null) return;
    const informationContainer = document.querySelector('.appointment-confirmed__body .information');
    if (!informationContainer) return;
    const existingRow = informationContainer.querySelector('.location-address__row');
    if (existingRow) existingRow.remove();
    // A remote service (video or phone) can still carry a physical
    // location_id, so the address must be replaced with a "Virtual" /
    // "Phone Call" indicator rather than shown. Honor the channel flag
    // too — otherwise a virtual-only channel whose procedures are still
    // NULL (treated as in-person) prints the office street address.
    const procedures = (0, $cEKee.eventPayload).procedures ?? (0, $cEKee.appointmentSummary)?.event?.procedures ?? [];
    if ((0, $fWpof.isVirtualVisit)((0, $cEKee.form), procedures)) {
        const allPhone = (0, $fWpof.isPhoneBooking)(procedures);
        const remoteRow = document.createElement('div');
        remoteRow.className = 'location-address__row';
        remoteRow.innerHTML = `
            <div class="location-address__label">
                <i data-feather="${allPhone ? 'phone' : 'video'}" class="location-address__icon"></i>
                <span class="location-address__text">${(0, $knjAn.t)((0, $fWpof.remoteVisitLabelKey)(procedures))}</span>
            </div>
        `;
        informationContainer.appendChild(remoteRow);
        if (typeof feather !== 'undefined') feather.replace();
        return;
    }
    const locationObj = (0, $cEKee.locations).find((l)=>l.id === (0, $cEKee.eventPayload).location_id);
    const address = locationObj?.full_address ?? (0, $cEKee.eventPayload).location?.full_address ?? '';
    if (!address) return;
    const row = document.createElement('div');
    row.className = 'location-address__row';
    row.innerHTML = `
        <div class="location-address__label">
            <i data-feather="map-pin" class="location-address__icon"></i>
            <span class="location-address__text">${address}</span>
        </div>
        <button type="button" class="button--no-style location-address__copy" id="copy-address-confirmed" title="${(0, $knjAn.t)('copy')}" aria-label="${(0, $knjAn.t)('copy')}">
            <i data-feather="copy"></i>
            <span>${(0, $knjAn.t)('copy')}</span>
        </button>
    `;
    informationContainer.appendChild(row);
    if (typeof feather !== 'undefined') feather.replace();
}
function $932d22fee698e8bd$export$478b5967993a42eb(status) {
    $932d22fee698e8bd$var$initializeStyles();
    $932d22fee698e8bd$var$setBusinessLogo();
    $932d22fee698e8bd$var$setClientPortalSignInLink();
    const body = document.querySelector((0, $9ILu0.SELECTORS).body);
    if (!body) return;
    Array.from(body.children).forEach((child)=>{
        child.style.display = 'none';
    });
    const existing = body.querySelector('.appointment-gone');
    if (existing) existing.remove();
    const box = document.createElement('div');
    box.className = 'appointment-gone';
    box.style.cssText = 'width:100%;display:flex;flex-direction:column;align-items:center;text-align:center;gap:12px;margin-top:32px;';
    const title = document.createElement('div');
    title.style.cssText = "font-family:'Nunito',sans-serif;font-weight:700;font-size:20px;color:#374151;";
    title.textContent = status === 'cancelled' ? (0, $knjAn.t)('appointment_cancelled_page_title') : (0, $knjAn.t)('appointment_gone_page_title');
    const sub = document.createElement('div');
    sub.style.cssText = "font-family:'Nunito',sans-serif;font-size:15px;color:#7987a1;max-width:320px;";
    sub.textContent = (0, $knjAn.t)('appointment_gone_page_subtitle');
    const rebook = document.createElement('button');
    rebook.type = 'button';
    rebook.className = 'button--no-style appointment-action-btn appointment-action-btn--paperwork';
    rebook.style.cssText = 'width:100%;max-width:320px;margin-top:8px;';
    rebook.textContent = (0, $knjAn.t)('book_new_appointment');
    rebook.addEventListener('click', ()=>{
        (0, $er9E0.openBookAppointment)();
    });
    box.appendChild(title);
    box.appendChild(sub);
    box.appendChild(rebook);
    body.appendChild(box);
}
function $932d22fee698e8bd$var$isAppointmentCancelled() {
    const hasSignature = $932d22fee698e8bd$var$hasValidSignature();
    if (!hasSignature) return false;
    if ((0, $cEKee.eventPayload).status === (0, $9ILu0.APPOINTMENT_STATUS).CANCELLED) return true;
    if ((0, $cEKee.eventPayload).status === (0, $9ILu0.APPOINTMENT_STATUS).CONFIRMED && (0, $cEKee.eventPayload).participants && (0, $cEKee.eventPayload).participants.length > 0) {
        const leadParticipant = (0, $cEKee.eventPayload).participants.find((p)=>p.participable_type === (0, $9ILu0.PARTICIPANT_TYPES).LEAD);
        if (leadParticipant && leadParticipant.manually_confirmed === false) return true;
    }
    return false;
}
function $932d22fee698e8bd$var$updateAppointmentTitle() {
    const hasSignature = $932d22fee698e8bd$var$hasValidSignature();
    const titleContainer = document.querySelector((0, $9ILu0.SELECTORS).title);
    const titleTextEl = titleContainer?.querySelector('.title-text');
    if (!titleTextEl) return;
    if (hasSignature && $932d22fee698e8bd$var$isAppointmentCancelled()) {
        titleTextEl.textContent = (0, $9ILu0.MESSAGES).ui.appointmentCancelled;
        if (titleContainer) titleContainer.style.color = (0, $9ILu0.COLORS).error;
    } else {
        const startTime = parseInt((0, $cEKee.eventPayload)?.start_time, 10);
        const appointmentDate = startTime ? (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(startTime * 1000).format('dddd, MMM D, YYYY') : '';
        titleTextEl.textContent = appointmentDate || (0, $knjAn.t)('appointment_booked');
        if (titleContainer) titleContainer.style.color = '';
    }
}
function $932d22fee698e8bd$var$getStaffName() {
    if ((0, $cEKee.eventPayload).participants && (0, $cEKee.eventPayload).participants.length > 0 && (0, $er9E0.params)('event_id')) {
        const participant = (0, $cEKee.eventPayload).participants.find((i)=>i.participable_type === 'App\\Models\\Staff');
        return participant ? `${participant.participable.first_name} ${participant.participable.last_name}` : '';
    }
    return (0, $62LVp.getProviderFullName)();
}
function $932d22fee698e8bd$var$handleCalendarAndDirections() {
    if ((0, $cEKee.eventRoom) === null) {
        (0, $8Jd2Q.handleEventRoomNullUI)();
        $932d22fee698e8bd$var$renderAddressRow();
    } else {
        (0, $8Jd2Q.handleEventRoomUI)();
        $932d22fee698e8bd$var$addJoinVideoButton();
    }
    $932d22fee698e8bd$var$addRescheduleCancelButtons();
}
function $932d22fee698e8bd$var$addJoinVideoButton() {
    if (((0, $cEKee.form)?.appointment_channel?.show_video_call_button ?? true) === false) return;
    const joinUrl = $932d22fee698e8bd$var$getTelehealthJoinUrl();
    if (!joinUrl) return;
    const actionDiv = document.querySelector((0, $9ILu0.SELECTORS).actionDiv);
    if (!actionDiv) return;
    const existing = actionDiv.querySelector('.appointment-join-video');
    if (existing) existing.remove();
    const link = document.createElement('a');
    link.id = 'join-video-call-link';
    link.className = 'appointment-join-video appointment-action-btn appointment-action-btn--video';
    link.href = joinUrl;
    link.target = '_blank';
    link.rel = 'noopener noreferrer';
    link.textContent = (0, $knjAn.t)('join_video_call');
    actionDiv.insertBefore(link, actionDiv.firstChild);
}
function $932d22fee698e8bd$var$addRescheduleCancelButtons() {
    const actionDiv = document.querySelector((0, $9ILu0.SELECTORS).actionDiv);
    if (!actionDiv) return;
    // Cancelled appointment: no reschedule/cancel — offer a rebook instead.
    if ($932d22fee698e8bd$var$isAppointmentCancelled() || (0, $cEKee.eventPayload).status === (0, $9ILu0.APPOINTMENT_STATUS).CANCELLED) {
        const stale = actionDiv.querySelector('.appointment-reschedule-cancel-buttons');
        if (stale) stale.remove();
        const rebookWrap = document.createElement('div');
        rebookWrap.className = 'appointment-reschedule-cancel-buttons';
        const rebookBtn = document.createElement('button');
        rebookBtn.type = 'button';
        rebookBtn.className = 'button--no-style appointment-action-btn appointment-action-btn--paperwork';
        rebookBtn.textContent = (0, $knjAn.t)('book_new_appointment');
        rebookBtn.addEventListener('click', ()=>{
            (0, $er9E0.openBookAppointment)();
        });
        rebookWrap.appendChild(rebookBtn);
        actionDiv.appendChild(rebookWrap);
        return;
    }
    const existing = actionDiv.querySelector('.appointment-reschedule-cancel-buttons');
    if (existing) existing.remove();
    const wrapper = document.createElement('div');
    wrapper.className = 'appointment-reschedule-cancel-buttons';
    // The only post-booking handoff: visitor taps Start Paperwork on this
    // confirmation screen. Prefer embed_url (public template + slot token,
    // no OTP) over the assigned-form portal link.
    const paperworkUrl = (0, $cEKee.eventPayload).paperwork?.embed_url || (0, $cEKee.eventPayload).paperwork?.url;
    if (paperworkUrl) {
        const paperworkBtn = document.createElement('button');
        paperworkBtn.type = 'button';
        paperworkBtn.className = 'button--no-style appointment-action-btn appointment-action-btn--paperwork';
        paperworkBtn.textContent = (0, $knjAn.t)('start_paperwork');
        paperworkBtn.addEventListener('click', ()=>{
            try {
                window.top.location = paperworkUrl;
            } catch (_) {
                window.location = paperworkUrl;
            }
        });
        wrapper.appendChild(paperworkBtn);
    }
    const rescheduleBtn = document.createElement('button');
    rescheduleBtn.type = 'button';
    rescheduleBtn.className = 'button--no-style appointment-action-btn appointment-action-btn--reschedule';
    rescheduleBtn.textContent = (0, $knjAn.t)('reschedule');
    rescheduleBtn.addEventListener('click', async ()=>{
        rescheduleBtn.disabled = true;
        try {
            await (0, $8Jd2Q.runRescheduleFlow)((0, $cEKee.eventPayload));
        } finally{
            rescheduleBtn.disabled = false;
        }
    });
    const cancelBtn = document.createElement('button');
    cancelBtn.type = 'button';
    cancelBtn.className = 'button--no-style appointment-action-btn appointment-action-btn--cancel';
    cancelBtn.textContent = (0, $knjAn.t)('cancel_appointment');
    cancelBtn.addEventListener('click', ()=>{
        (0, $66jZq.loadAppointmentCancel)();
        (0, $ebrDl.appointmentCancelListeners)();
        document.querySelector('.appointment-cancel__container')?.style?.setProperty('transition', 'none');
        (0, $er9E0.navigate)((0, $cIxq8.SCREEN).APPOINTMENT_CANCEL);
    });
    wrapper.appendChild(rescheduleBtn);
    wrapper.appendChild(cancelBtn);
    actionDiv.appendChild(wrapper);
    if (typeof feather !== 'undefined') feather.replace();
}
function $932d22fee698e8bd$var$handleConfirmCancelButtons() {
    const { shouldShow: shouldShow } = $932d22fee698e8bd$var$shouldShowConfirmButtons();
    const { shouldShowPendingBanner: shouldShowPendingBanner } = $932d22fee698e8bd$var$shouldShowPendingApprovalBanner();
    const { shouldShowCancelledBanner: showCancelledBanner } = $932d22fee698e8bd$var$shouldShowCancelledBanner();
    const actionDiv = document.querySelector((0, $9ILu0.SELECTORS).actionDiv);
    const existingButtonsContainer = document.querySelector((0, $9ILu0.SELECTORS).appointmentButtons);
    $932d22fee698e8bd$var$toggleActionButtonsVisibility(actionDiv);
    // Legacy confirm/cancel pair is never rendered anymore; hide any stale one.
    if (!shouldShow && existingButtonsContainer) existingButtonsContainer.style.display = 'none';
    if (shouldShowPendingBanner) {
        $932d22fee698e8bd$var$createPendingApprovalBanner();
        $932d22fee698e8bd$var$removeCancelledBanner();
    } else $932d22fee698e8bd$var$removePendingApprovalBanner();
    if (showCancelledBanner) {
        $932d22fee698e8bd$var$createCancelledBanner();
        $932d22fee698e8bd$var$removePendingApprovalBanner();
    } else $932d22fee698e8bd$var$removeCancelledBanner();
}
function $932d22fee698e8bd$var$shouldShowConfirmButtons() {
    // Visitors never confirm their own appointments — confirmation is a
    // backend/staff concern. The manage page only offers Reschedule/Cancel.
    return {
        shouldShow: false
    };
}
function $932d22fee698e8bd$var$shouldShowPendingApprovalBanner() {
    if ((0, $cEKee.eventPayload).status === (0, $9ILu0.APPOINTMENT_STATUS).REQUEST) return {
        shouldShowPendingBanner: true
    };
    return {
        shouldShowPendingBanner: false
    };
}
function $932d22fee698e8bd$var$shouldShowCancelledBanner() {
    const hasSignature = $932d22fee698e8bd$var$hasValidSignature();
    if (!hasSignature) return {
        shouldShowCancelledBanner: false
    };
    if ((0, $cEKee.eventPayload).status === (0, $9ILu0.APPOINTMENT_STATUS).CANCELLED) return {
        shouldShowCancelledBanner: true
    };
    if ((0, $cEKee.eventPayload).status === (0, $9ILu0.APPOINTMENT_STATUS).CONFIRMED && (0, $cEKee.eventPayload).participants && (0, $cEKee.eventPayload).participants.length > 0) {
        const leadParticipant = (0, $cEKee.eventPayload).participants.find((p)=>p.participable_type === (0, $9ILu0.PARTICIPANT_TYPES).LEAD);
        if (leadParticipant && leadParticipant.manually_confirmed === false) return {
            shouldShowCancelledBanner: true
        };
    }
    return {
        shouldShowCancelledBanner: false
    };
}
function $932d22fee698e8bd$var$hasValidSignature() {
    const signature = (0, $er9E0.params)('signature');
    return signature && signature.length > 0;
}
function $932d22fee698e8bd$var$createPendingApprovalBanner() {
    const bodyContainer = document.querySelector((0, $9ILu0.SELECTORS).body);
    const existingBanner = document.querySelector((0, $9ILu0.SELECTORS).pendingBanner);
    if (existingBanner || !bodyContainer) return;
    const banner = document.createElement('div');
    banner.className = 'pending-approval-banner';
    banner.innerHTML = `
        <div class="banner-icon">
            <i data-feather="clock"></i>
        </div>
        <div class="banner-content">
            <div class="banner-title">${(0, $9ILu0.MESSAGES).banner.pendingApproval}</div>
            <div class="banner-description">${(0, $9ILu0.MESSAGES).banner.pendingApprovalDescription}</div>
        </div>
    `;
    const cardElement = document.querySelector((0, $9ILu0.SELECTORS).card);
    if (cardElement) {
        cardElement.after(banner);
        if (typeof feather !== 'undefined') feather.replace();
    }
}
function $932d22fee698e8bd$var$removePendingApprovalBanner() {
    const existingBanner = document.querySelector((0, $9ILu0.SELECTORS).pendingBanner);
    if (existingBanner) existingBanner.remove();
}
function $932d22fee698e8bd$var$createCancelledBanner() {
    const bodyContainer = document.querySelector((0, $9ILu0.SELECTORS).body);
    const existingBanner = document.querySelector((0, $9ILu0.SELECTORS).cancelledBanner);
    if (existingBanner || !bodyContainer) return;
    const banner = document.createElement('div');
    banner.className = 'cancelled-appointment-banner';
    banner.innerHTML = `
        <div class="banner-icon">
            <i data-feather="x-circle"></i>
        </div>
        <div class="banner-content">
            <div class="banner-title">${(0, $9ILu0.MESSAGES).banner.cancelled}</div>
            <div class="banner-description">${(0, $9ILu0.MESSAGES).banner.cancelledDescription}</div>
        </div>
    `;
    const cardElement = document.querySelector((0, $9ILu0.SELECTORS).card);
    if (cardElement) {
        cardElement.after(banner);
        if (typeof feather !== 'undefined') feather.replace();
    }
}
function $932d22fee698e8bd$var$removeCancelledBanner() {
    const existingBanner = document.querySelector((0, $9ILu0.SELECTORS).cancelledBanner);
    if (existingBanner) existingBanner.remove();
}
function $932d22fee698e8bd$var$toggleActionButtonsVisibility(actionDiv) {
    if (!actionDiv) return;
    const hasSignature = $932d22fee698e8bd$var$hasValidSignature();
    if (!hasSignature) {
        // Never offer Reschedule/Cancel on an already-cancelled appointment,
        // signature or not (the post-cancel redirect lands here unsigned).
        actionDiv.style.display = (0, $cEKee.eventPayload).status === (0, $9ILu0.APPOINTMENT_STATUS).CANCELLED ? 'none' : 'flex';
        return;
    }
    const appointmentStatus = (0, $cEKee.eventPayload).status;
    const leadParticipant = $932d22fee698e8bd$var$getLeadParticipant();
    const manuallyConfirmed = leadParticipant ? leadParticipant.manually_confirmed : null;
    const shouldDisplayActions = $932d22fee698e8bd$var$shouldShowActionButtons(appointmentStatus, manuallyConfirmed);
    actionDiv.style.display = shouldDisplayActions ? 'flex' : 'none';
}
function $932d22fee698e8bd$var$getLeadParticipant() {
    if (!(0, $cEKee.eventPayload).participants || !(0, $cEKee.eventPayload).participants.length) return null;
    return (0, $cEKee.eventPayload).participants.find((p)=>p.participable_type === (0, $9ILu0.PARTICIPANT_TYPES).LEAD);
}
function $932d22fee698e8bd$var$shouldShowActionButtons(status, manuallyConfirmed) {
    if (status === (0, $9ILu0.APPOINTMENT_STATUS).REQUEST) return false;
    if (status === (0, $9ILu0.APPOINTMENT_STATUS).CONFIRMED && manuallyConfirmed === false) return false;
    if (status === (0, $9ILu0.APPOINTMENT_STATUS).CONFIRMED) return true;
    if (status === (0, $9ILu0.APPOINTMENT_STATUS).CANCELLED) return false;
    if (status === (0, $9ILu0.APPOINTMENT_STATUS).COMPLETE) return true;
    return true;
}
async function $932d22fee698e8bd$var$refreshAppointmentData(eventId) {
    // Refresh via the signature-gated resume route when the page carries a resume
    // signature (the standard "Manage appointment" / drop-off case); fall back to
    // the token-scoped endpoint only for legacy in-session links.
    const isDropoffSummary = (0, $er9E0.params)((0, $cIxq8.DROPOFF_RESUME_PARAM)) === 'summary';
    const resumeSignature = (0, $er9E0.params)('resume_signature') || (isDropoffSummary ? (0, $er9E0.params)('signature') : null);
    const resumeExpires = (0, $er9E0.params)('resume_expires') || (isDropoffSummary ? (0, $er9E0.params)('expires') : null);
    const updatedEventInfo = resumeSignature && resumeExpires ? await (0, $cNdCr.getEventResume)(eventId, resumeSignature, resumeExpires) : await (0, $cNdCr.getEvevntInfoById)(eventId);
    if (updatedEventInfo?.data) {
        (0, $cEKee.setEventPayload)(updatedEventInfo.data);
        $932d22fee698e8bd$var$updateUIAfterDataRefresh();
        return updatedEventInfo.data;
    }
    return null;
}
function $932d22fee698e8bd$var$updateUIAfterDataRefresh() {
    const { shouldShowPendingBanner: shouldShowPendingBanner } = $932d22fee698e8bd$var$shouldShowPendingApprovalBanner();
    const { shouldShowCancelledBanner: showCancelledBanner } = $932d22fee698e8bd$var$shouldShowCancelledBanner();
    if (shouldShowPendingBanner) {
        $932d22fee698e8bd$var$createPendingApprovalBanner();
        $932d22fee698e8bd$var$removeCancelledBanner();
    } else $932d22fee698e8bd$var$removePendingApprovalBanner();
    if (showCancelledBanner) {
        $932d22fee698e8bd$var$createCancelledBanner();
        $932d22fee698e8bd$var$removePendingApprovalBanner();
    } else $932d22fee698e8bd$var$removeCancelledBanner();
    $932d22fee698e8bd$var$updateAppointmentTitle();
    const actionDiv = document.querySelector((0, $9ILu0.SELECTORS).actionDiv);
    $932d22fee698e8bd$var$toggleActionButtonsVisibility(actionDiv);
    const { shouldShow: shouldShow } = $932d22fee698e8bd$var$shouldShowConfirmButtons();
    const existingButtonsContainer = document.querySelector((0, $9ILu0.SELECTORS).appointmentButtons);
    if (!shouldShow && existingButtonsContainer) existingButtonsContainer.style.display = 'none';
}

});
parcelRegister("45fvw", function(module, exports) {
//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
(function(global, factory) {
    module.exports = factory();
})(this, function() {
    'use strict';
    var hookCallback;
    function hooks() {
        return hookCallback.apply(null, arguments);
    }
    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }
    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }
    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }
    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }
    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) return Object.getOwnPropertyNames(obj).length === 0;
        else {
            var k;
            for(k in obj){
                if (hasOwnProp(obj, k)) return false;
            }
            return true;
        }
    }
    function isUndefined(input) {
        return input === void 0;
    }
    function isNumber(input) {
        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }
    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }
    function map(arr, fn) {
        var res = [], i, arrLen = arr.length;
        for(i = 0; i < arrLen; ++i)res.push(fn(arr[i], i));
        return res;
    }
    function extend(a, b) {
        for(var i in b)if (hasOwnProp(b, i)) a[i] = b[i];
        if (hasOwnProp(b, 'toString')) a.toString = b.toString;
        if (hasOwnProp(b, 'valueOf')) a.valueOf = b.valueOf;
        return a;
    }
    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }
    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false
        };
    }
    function getParsingFlags(m) {
        if (m._pf == null) m._pf = defaultParsingFlags();
        return m._pf;
    }
    var some;
    if (Array.prototype.some) some = Array.prototype.some;
    else some = function(fun) {
        var t = Object(this), len = t.length >>> 0, i;
        for(i = 0; i < len; i++){
            if (i in t && fun.call(this, t[i], i, t)) return true;
        }
        return false;
    };
    function isValid(m) {
        var flags = null, parsedParts = false, isNowValid = m._d && !isNaN(m._d.getTime());
        if (isNowValid) {
            flags = getParsingFlags(m);
            parsedParts = some.call(flags.parsedDateParts, function(i) {
                return i != null;
            });
            isNowValid = flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
            if (m._strict) isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
        }
        if (Object.isFrozen == null || !Object.isFrozen(m)) m._isValid = isNowValid;
        else return isNowValid;
        return m._isValid;
    }
    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) extend(getParsingFlags(m), flags);
        else getParsingFlags(m).userInvalidated = true;
        return m;
    }
    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [], updateInProgress = false;
    function copyConfig(to, from) {
        var i, prop, val, momentPropertiesLen = momentProperties.length;
        if (!isUndefined(from._isAMomentObject)) to._isAMomentObject = from._isAMomentObject;
        if (!isUndefined(from._i)) to._i = from._i;
        if (!isUndefined(from._f)) to._f = from._f;
        if (!isUndefined(from._l)) to._l = from._l;
        if (!isUndefined(from._strict)) to._strict = from._strict;
        if (!isUndefined(from._tzm)) to._tzm = from._tzm;
        if (!isUndefined(from._isUTC)) to._isUTC = from._isUTC;
        if (!isUndefined(from._offset)) to._offset = from._offset;
        if (!isUndefined(from._pf)) to._pf = getParsingFlags(from);
        if (!isUndefined(from._locale)) to._locale = from._locale;
        if (momentPropertiesLen > 0) for(i = 0; i < momentPropertiesLen; i++){
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) to[prop] = val;
        }
        return to;
    }
    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) this._d = new Date(NaN);
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }
    function isMoment(obj) {
        return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }
    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false && typeof console !== 'undefined' && console.warn) console.warn('Deprecation warning: ' + msg);
    }
    function deprecate(msg, fn) {
        var firstTime = true;
        return extend(function() {
            if (hooks.deprecationHandler != null) hooks.deprecationHandler(null, msg);
            if (firstTime) {
                var args = [], arg, i, key, argLen = arguments.length;
                for(i = 0; i < argLen; i++){
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for(key in arguments[0])if (hasOwnProp(arguments[0], key)) arg += key + ': ' + arguments[0][key] + ', ';
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else arg = arguments[i];
                    args.push(arg);
                }
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + new Error().stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }
    var deprecations = {};
    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) hooks.deprecationHandler(name, msg);
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }
    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;
    function isFunction(input) {
        return typeof Function !== 'undefined' && input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }
    function set(config) {
        var prop, i;
        for(i in config)if (hasOwnProp(config, i)) {
            prop = config[i];
            if (isFunction(prop)) this[i] = prop;
            else this['_' + i] = prop;
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + '|' + /\d{1,2}/.source);
    }
    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for(prop in childConfig)if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) res[prop] = childConfig[prop];
            else delete res[prop];
        }
        for(prop in parentConfig)if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) // make sure changes to properties don't modify parent config
        res[prop] = extend({}, res[prop]);
        return res;
    }
    function Locale(config) {
        if (config != null) this.set(config);
    }
    var keys;
    if (Object.keys) keys = Object.keys;
    else keys = function(obj) {
        var i, res = [];
        for(i in obj)if (hasOwnProp(obj, i)) res.push(i);
        return res;
    };
    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L'
    };
    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }
    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number), zerosToFill = targetLength - absNumber.length, sign = number >= 0;
        return (sign ? forceSign ? '+' : '' : '-') + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }
    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') func = function() {
            return this[callback]();
        };
        if (token) formatTokenFunctions[token] = func;
        if (padded) formatTokenFunctions[padded[0]] = function() {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
        if (ordinal) formatTokenFunctions[ordinal] = function() {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) return input.replace(/^\[|\]$/g, '');
        return input.replace(/\\/g, '');
    }
    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;
        for(i = 0, length = array.length; i < length; i++)if (formatTokenFunctions[array[i]]) array[i] = formatTokenFunctions[array[i]];
        else array[i] = removeFormattingTokens(array[i]);
        return function(mom) {
            var output = '', i;
            for(i = 0; i < length; i++)output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            return output;
        };
    }
    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) return m.localeData().invalidDate();
        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
        return formatFunctions[format](m);
    }
    function expandFormat(format, locale) {
        var i = 5;
        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }
        localFormattingTokens.lastIndex = 0;
        while(i >= 0 && localFormattingTokens.test(format)){
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }
        return format;
    }
    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A'
    };
    function longDateFormat(key) {
        var format = this._longDateFormat[key], formatUpper = this._longDateFormat[key.toUpperCase()];
        if (format || !formatUpper) return format;
        this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function(tok) {
            if (tok === 'MMMM' || tok === 'MM' || tok === 'DD' || tok === 'dddd') return tok.slice(1);
            return tok;
        }).join('');
        return this._longDateFormat[key];
    }
    var defaultInvalidDate = 'Invalid date';
    function invalidDate() {
        return this._invalidDate;
    }
    var defaultOrdinal = '%d', defaultDayOfMonthOrdinalParse = /\d{1,2}/;
    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }
    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years'
    };
    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
    }
    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }
    var aliases = {
        D: 'date',
        dates: 'date',
        date: 'date',
        d: 'day',
        days: 'day',
        day: 'day',
        e: 'weekday',
        weekdays: 'weekday',
        weekday: 'weekday',
        E: 'isoWeekday',
        isoweekdays: 'isoWeekday',
        isoweekday: 'isoWeekday',
        DDD: 'dayOfYear',
        dayofyears: 'dayOfYear',
        dayofyear: 'dayOfYear',
        h: 'hour',
        hours: 'hour',
        hour: 'hour',
        ms: 'millisecond',
        milliseconds: 'millisecond',
        millisecond: 'millisecond',
        m: 'minute',
        minutes: 'minute',
        minute: 'minute',
        M: 'month',
        months: 'month',
        month: 'month',
        Q: 'quarter',
        quarters: 'quarter',
        quarter: 'quarter',
        s: 'second',
        seconds: 'second',
        second: 'second',
        gg: 'weekYear',
        weekyears: 'weekYear',
        weekyear: 'weekYear',
        GG: 'isoWeekYear',
        isoweekyears: 'isoWeekYear',
        isoweekyear: 'isoWeekYear',
        w: 'week',
        weeks: 'week',
        week: 'week',
        W: 'isoWeek',
        isoweeks: 'isoWeek',
        isoweek: 'isoWeek',
        y: 'year',
        years: 'year',
        year: 'year'
    };
    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }
    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {}, normalizedProp, prop;
        for(prop in inputObject)if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) normalizedInput[normalizedProp] = inputObject[prop];
        }
        return normalizedInput;
    }
    var priorities = {
        date: 9,
        day: 11,
        weekday: 11,
        isoWeekday: 11,
        dayOfYear: 4,
        hour: 13,
        millisecond: 16,
        minute: 14,
        month: 8,
        quarter: 7,
        second: 15,
        weekYear: 1,
        isoWeekYear: 1,
        week: 5,
        isoWeek: 5,
        year: 1
    };
    function getPrioritizedUnits(unitsObj) {
        var units = [], u;
        for(u in unitsObj)if (hasOwnProp(unitsObj, u)) units.push({
            unit: u,
            priority: priorities[u]
        });
        units.sort(function(a, b) {
            return a.priority - b.priority;
        });
        return units;
    }
    var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, match1to2NoLeadingZero = /^[1-9]\d?/, match1to2HasZero = /^([1-9]\d|\d)/, regexes;
    regexes = {};
    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function(isStrict, localeData) {
            return isStrict && strictRegex ? strictRegex : regex;
        };
    }
    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) return new RegExp(unescapeFormat(token));
        return regexes[token](config._strict, config._locale);
    }
    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }
    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }
    function absFloor(number) {
        if (number < 0) // -0 -> 0
        return Math.ceil(number) || 0;
        else return Math.floor(number);
    }
    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion, value = 0;
        if (coercedNumber !== 0 && isFinite(coercedNumber)) value = absFloor(coercedNumber);
        return value;
    }
    var tokens = {};
    function addParseToken(token, callback) {
        var i, func = callback, tokenLen;
        if (typeof token === 'string') token = [
            token
        ];
        if (isNumber(callback)) func = function(input, array) {
            array[callback] = toInt(input);
        };
        tokenLen = token.length;
        for(i = 0; i < tokenLen; i++)tokens[token[i]] = func;
    }
    function addWeekParseToken(token, callback) {
        addParseToken(token, function(input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }
    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) tokens[token](input, config._a, config, token);
    }
    function isLeapYear(year) {
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }
    var YEAR = 0, MONTH = 1, DATE = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
    // FORMATTING
    addFormatToken('Y', 0, 0, function() {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });
    addFormatToken(0, [
        'YY',
        2
    ], 0, function() {
        return this.year() % 100;
    });
    addFormatToken(0, [
        'YYYY',
        4
    ], 0, 'year');
    addFormatToken(0, [
        'YYYYY',
        5
    ], 0, 'year');
    addFormatToken(0, [
        'YYYYYY',
        6,
        true
    ], 0, 'year');
    // PARSING
    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);
    addParseToken([
        'YYYYY',
        'YYYYYY'
    ], YEAR);
    addParseToken('YYYY', function(input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function(input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function(input, array) {
        array[YEAR] = parseInt(input, 10);
    });
    // HELPERS
    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }
    // HOOKS
    hooks.parseTwoDigitYear = function(input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };
    // MOMENTS
    var getSetYear = makeGetSet('FullYear', true);
    function getIsLeapYear() {
        return isLeapYear(this.year());
    }
    function makeGetSet(unit, keepTime) {
        return function(value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else return get(this, unit);
        };
    }
    function get(mom, unit) {
        if (!mom.isValid()) return NaN;
        var d = mom._d, isUTC = mom._isUTC;
        switch(unit){
            case 'Milliseconds':
                return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
            case 'Seconds':
                return isUTC ? d.getUTCSeconds() : d.getSeconds();
            case 'Minutes':
                return isUTC ? d.getUTCMinutes() : d.getMinutes();
            case 'Hours':
                return isUTC ? d.getUTCHours() : d.getHours();
            case 'Date':
                return isUTC ? d.getUTCDate() : d.getDate();
            case 'Day':
                return isUTC ? d.getUTCDay() : d.getDay();
            case 'Month':
                return isUTC ? d.getUTCMonth() : d.getMonth();
            case 'FullYear':
                return isUTC ? d.getUTCFullYear() : d.getFullYear();
            default:
                return NaN; // Just in case
        }
    }
    function set$1(mom, unit, value) {
        var d, isUTC, year, month, date;
        if (!mom.isValid() || isNaN(value)) return;
        d = mom._d;
        isUTC = mom._isUTC;
        switch(unit){
            case 'Milliseconds':
                return void (isUTC ? d.setUTCMilliseconds(value) : d.setMilliseconds(value));
            case 'Seconds':
                return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
            case 'Minutes':
                return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
            case 'Hours':
                return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
            case 'Date':
                return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
            // case 'Day': // Not real
            //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
            // case 'Month': // Not used because we need to pass two variables
            //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
            case 'FullYear':
                break; // See below ...
            default:
                return; // Just in case
        }
        year = value;
        month = mom.month();
        date = mom.date();
        date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
        isUTC ? d.setUTCFullYear(year, month, date) : d.setFullYear(year, month, date);
    }
    // MOMENTS
    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) return this[units]();
        return this;
    }
    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units), i, prioritizedLen = prioritized.length;
            for(i = 0; i < prioritizedLen; i++)this[prioritized[i].unit](units[prioritized[i].unit]);
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) return this[units](value);
        }
        return this;
    }
    function mod(n, x) {
        return (n % x + x) % x;
    }
    var indexOf;
    if (Array.prototype.indexOf) indexOf = Array.prototype.indexOf;
    else indexOf = function(o) {
        // I know
        var i;
        for(i = 0; i < this.length; ++i){
            if (this[i] === o) return i;
        }
        return -1;
    };
    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) return NaN;
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
    }
    // FORMATTING
    addFormatToken('M', [
        'MM',
        2
    ], 'Mo', function() {
        return this.month() + 1;
    });
    addFormatToken('MMM', 0, 0, function(format) {
        return this.localeData().monthsShort(this, format);
    });
    addFormatToken('MMMM', 0, 0, function(format) {
        return this.localeData().months(this, format);
    });
    // PARSING
    addRegexToken('M', match1to2, match1to2NoLeadingZero);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function(isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function(isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });
    addParseToken([
        'M',
        'MM'
    ], function(input, array) {
        array[MONTH] = toInt(input) - 1;
    });
    addParseToken([
        'MMM',
        'MMMM'
    ], function(input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) array[MONTH] = month;
        else getParsingFlags(config).invalidMonth = input;
    });
    // LOCALES
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'), defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord;
    function localeMonths(m, format) {
        if (!m) return isArray(this._months) ? this._months : this._months['standalone'];
        return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }
    function localeMonthsShort(m, format) {
        if (!m) return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort['standalone'];
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }
    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for(i = 0; i < 12; ++i){
                mom = createUTC([
                    2000,
                    i
                ]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else if (format === 'MMM') {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;
        if (this._monthsParseExact) return handleStrictParse.call(this, monthName, format, strict);
        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }
        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) return i;
            else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) return i;
            else if (!strict && this._monthsParse[i].test(monthName)) return i;
        }
    }
    // MOMENTS
    function setMonth(mom, value) {
        if (!mom.isValid()) // No op
        return mom;
        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) value = toInt(value);
            else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) return mom;
            }
        }
        var month = value, date = mom.date();
        date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
        mom._isUTC ? mom._d.setUTCMonth(month, date) : mom._d.setMonth(month, date);
        return mom;
    }
    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else return get(this, 'Month');
    }
    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }
    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) computeMonthsParse.call(this);
            if (isStrict) return this._monthsShortStrictRegex;
            else return this._monthsShortRegex;
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) this._monthsShortRegex = defaultMonthsShortRegex;
            return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }
    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) computeMonthsParse.call(this);
            if (isStrict) return this._monthsStrictRegex;
            else return this._monthsRegex;
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) this._monthsRegex = defaultMonthsRegex;
            return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
        }
    }
    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var shortPieces = [], longPieces = [], mixedPieces = [], i, mom, shortP, longP;
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            shortP = regexEscape(this.monthsShort(mom, ''));
            longP = regexEscape(this.months(mom, ''));
            shortPieces.push(shortP);
            longPieces.push(longP);
            mixedPieces.push(longP);
            mixedPieces.push(shortP);
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }
    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) date.setFullYear(y);
        } else date = new Date(y, m, d, h, M, s, ms);
        return date;
    }
    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) date.setUTCFullYear(y);
        } else date = new Date(Date.UTC.apply(null, arguments));
        return date;
    }
    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var fwd = 7 + dow - doy, // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
        return -fwdlw + fwd - 1;
    }
    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }
        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }
    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy), week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1, resWeek, resYear;
        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }
        return {
            week: resWeek,
            year: resYear
        };
    }
    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }
    // FORMATTING
    addFormatToken('w', [
        'ww',
        2
    ], 'wo', 'week');
    addFormatToken('W', [
        'WW',
        2
    ], 'Wo', 'isoWeek');
    // PARSING
    addRegexToken('w', match1to2, match1to2NoLeadingZero);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2, match1to2NoLeadingZero);
    addRegexToken('WW', match1to2, match2);
    addWeekParseToken([
        'w',
        'ww',
        'W',
        'WW'
    ], function(input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });
    // HELPERS
    // LOCALES
    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }
    var defaultLocaleWeek = {
        dow: 0,
        doy: 6
    };
    function localeFirstDayOfWeek() {
        return this._week.dow;
    }
    function localeFirstDayOfYear() {
        return this._week.doy;
    }
    // MOMENTS
    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }
    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }
    // FORMATTING
    addFormatToken('d', 0, 'do', 'day');
    addFormatToken('dd', 0, 0, function(format) {
        return this.localeData().weekdaysMin(this, format);
    });
    addFormatToken('ddd', 0, 0, function(format) {
        return this.localeData().weekdaysShort(this, format);
    });
    addFormatToken('dddd', 0, 0, function(format) {
        return this.localeData().weekdays(this, format);
    });
    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');
    // PARSING
    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function(isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function(isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function(isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });
    addWeekParseToken([
        'dd',
        'ddd',
        'dddd'
    ], function(input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) week.d = weekday;
        else getParsingFlags(config).invalidWeekday = input;
    });
    addWeekParseToken([
        'd',
        'e',
        'E'
    ], function(input, week, config, token) {
        week[token] = toInt(input);
    });
    // HELPERS
    function parseWeekday(input, locale) {
        if (typeof input !== 'string') return input;
        if (!isNaN(input)) return parseInt(input, 10);
        input = locale.weekdaysParse(input);
        if (typeof input === 'number') return input;
        return null;
    }
    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') return locale.weekdaysParse(input) % 7 || 7;
        return isNaN(input) ? null : input;
    }
    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }
    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'), defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'), defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord;
    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? 'format' : 'standalone'];
        return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
    }
    function localeWeekdaysShort(m) {
        return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }
    function localeWeekdaysMin(m) {
        return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }
    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];
            for(i = 0; i < 7; ++i){
                mom = createUTC([
                    2000,
                    1
                ]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }
    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;
        if (this._weekdaysParseExact) return handleStrictParse$1.call(this, weekdayName, format, strict);
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) return i;
            else if (!strict && this._weekdaysParse[i].test(weekdayName)) return i;
        }
    }
    // MOMENTS
    function getSetDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var day = get(this, 'Day');
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else return day;
    }
    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }
    function getSetISODayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.
        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else return this.day() || 7;
    }
    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysStrictRegex;
            else return this._weekdaysRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) this._weekdaysRegex = defaultWeekdaysRegex;
            return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }
    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysShortStrictRegex;
            else return this._weekdaysShortRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }
    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysMinStrictRegex;
            else return this._weekdaysMinRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }
    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i, mom, minp, shortp, longp;
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;
        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }
    // FORMATTING
    function hFormat() {
        return this.hours() % 12 || 12;
    }
    function kFormat() {
        return this.hours() || 24;
    }
    addFormatToken('H', [
        'HH',
        2
    ], 0, 'hour');
    addFormatToken('h', [
        'hh',
        2
    ], 0, hFormat);
    addFormatToken('k', [
        'kk',
        2
    ], 0, kFormat);
    addFormatToken('hmm', 0, 0, function() {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });
    addFormatToken('hmmss', 0, 0, function() {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    addFormatToken('Hmm', 0, 0, function() {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });
    addFormatToken('Hmmss', 0, 0, function() {
        return '' + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function() {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }
    meridiem('a', true);
    meridiem('A', false);
    // PARSING
    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }
    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2, match1to2HasZero);
    addRegexToken('h', match1to2, match1to2NoLeadingZero);
    addRegexToken('k', match1to2, match1to2NoLeadingZero);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);
    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);
    addParseToken([
        'H',
        'HH'
    ], HOUR);
    addParseToken([
        'k',
        'kk'
    ], function(input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken([
        'a',
        'A'
    ], function(input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken([
        'h',
        'hh'
    ], function(input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });
    // LOCALES
    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }
    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    getSetHour = makeGetSet('Hours', true);
    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) return isLower ? 'pm' : 'PM';
        else return isLower ? 'am' : 'AM';
    }
    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,
        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,
        week: defaultLocaleWeek,
        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,
        meridiemParse: defaultLocaleMeridiemParse
    };
    // internal storage for locale config files
    var locales = {}, localeFamilies = {}, globalLocale;
    function commonPrefix(arr1, arr2) {
        var i, minl = Math.min(arr1.length, arr2.length);
        for(i = 0; i < minl; i += 1){
            if (arr1[i] !== arr2[i]) return i;
        }
        return minl;
    }
    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }
    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;
        while(i < names.length){
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while(j > 0){
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) return locale;
                if (next && next.length >= j && commonPrefix(split, next) >= j - 1) break;
                j--;
            }
            i++;
        }
        return globalLocale;
    }
    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        // Ensure name is available and function returns boolean
        return !!(name && name.match('^[^/\\\\]*$'));
    }
    function loadLocale(name) {
        var oldLocale = null, aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (locales[name] === undefined && true && module && module.exports && isLocaleNameSane(name)) try {
            oldLocale = globalLocale._abbr;
            aliasedRequire = undefined;
            aliasedRequire('./locale/' + name);
            getSetGlobalLocale(oldLocale);
        } catch (e) {
            // mark as not found to avoid repeating expensive file require call causing high CPU
            // when trying to find en-US, en_US, en-us for every format call
            locales[name] = null; // null means not found
        }
        return locales[name];
    }
    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) data = getLocale(key);
            else data = defineLocale(key, values);
            if (data) // moment.duration._locale = moment._locale = data;
            globalLocale = data;
            else if (typeof console !== 'undefined' && console.warn) //warn user if arguments are passed but the locale could not be set
            console.warn('Locale ' + key + ' not found. Did you forget to load it?');
        }
        return globalLocale._abbr;
    }
    function defineLocale(name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride', "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info.");
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) parentConfig = locales[config.parentLocale]._config;
                else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) parentConfig = locale._config;
                    else {
                        if (!localeFamilies[config.parentLocale]) localeFamilies[config.parentLocale] = [];
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));
            if (localeFamilies[name]) localeFamilies[name].forEach(function(x) {
                defineLocale(x.name, x.config);
            });
            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);
            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }
    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            if (locales[name] != null && locales[name].parentLocale != null) // Update existing child locale in-place to avoid memory-leaks
            locales[name].set(mergeConfigs(locales[name]._config, config));
            else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) parentConfig = tmpLocale._config;
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) // updateLocale is called for creating a new locale
                // Set abbr so it will have a name (getters return
                // undefined otherwise).
                config.abbr = name;
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }
            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
                if (name === getSetGlobalLocale()) getSetGlobalLocale(name);
            } else if (locales[name] != null) delete locales[name];
        }
        return locales[name];
    }
    // returns locale data
    function getLocale(key) {
        var locale;
        if (key && key._locale && key._locale._abbr) key = key._locale._abbr;
        if (!key) return globalLocale;
        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) return locale;
            key = [
                key
            ];
        }
        return chooseLocale(key);
    }
    function listLocales() {
        return keys(locales);
    }
    function checkOverflow(m) {
        var overflow, a = m._a;
        if (a && getParsingFlags(m).overflow === -2) {
            overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) overflow = DATE;
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) overflow = WEEK;
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) overflow = WEEKDAY;
            getParsingFlags(m).overflow = overflow;
        }
        return m;
    }
    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
        [
            'YYYYYY-MM-DD',
            /[+-]\d{6}-\d\d-\d\d/
        ],
        [
            'YYYY-MM-DD',
            /\d{4}-\d\d-\d\d/
        ],
        [
            'GGGG-[W]WW-E',
            /\d{4}-W\d\d-\d/
        ],
        [
            'GGGG-[W]WW',
            /\d{4}-W\d\d/,
            false
        ],
        [
            'YYYY-DDD',
            /\d{4}-\d{3}/
        ],
        [
            'YYYY-MM',
            /\d{4}-\d\d/,
            false
        ],
        [
            'YYYYYYMMDD',
            /[+-]\d{10}/
        ],
        [
            'YYYYMMDD',
            /\d{8}/
        ],
        [
            'GGGG[W]WWE',
            /\d{4}W\d{3}/
        ],
        [
            'GGGG[W]WW',
            /\d{4}W\d{2}/,
            false
        ],
        [
            'YYYYDDD',
            /\d{7}/
        ],
        [
            'YYYYMM',
            /\d{6}/,
            false
        ],
        [
            'YYYY',
            /\d{4}/,
            false
        ]
    ], // iso time formats and regexes
    isoTimes = [
        [
            'HH:mm:ss.SSSS',
            /\d\d:\d\d:\d\d\.\d+/
        ],
        [
            'HH:mm:ss,SSSS',
            /\d\d:\d\d:\d\d,\d+/
        ],
        [
            'HH:mm:ss',
            /\d\d:\d\d:\d\d/
        ],
        [
            'HH:mm',
            /\d\d:\d\d/
        ],
        [
            'HHmmss.SSSS',
            /\d\d\d\d\d\d\.\d+/
        ],
        [
            'HHmmss,SSSS',
            /\d\d\d\d\d\d,\d+/
        ],
        [
            'HHmmss',
            /\d\d\d\d\d\d/
        ],
        [
            'HHmm',
            /\d\d\d\d/
        ],
        [
            'HH',
            /\d\d/
        ]
    ], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -240,
        EST: -300,
        CDT: -300,
        CST: -360,
        MDT: -360,
        MST: -420,
        PDT: -420,
        PST: -480
    };
    // date from iso format
    function configFromISO(config) {
        var i, l, string = config._i, match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string), allowTime, dateFormat, timeFormat, tzFormat, isoDatesLen = isoDates.length, isoTimesLen = isoTimes.length;
        if (match) {
            getParsingFlags(config).iso = true;
            for(i = 0, l = isoDatesLen; i < l; i++)if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for(i = 0, l = isoTimesLen; i < l; i++)if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
                    break;
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) tzFormat = 'Z';
                else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else config._isValid = false;
    }
    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];
        if (secondStr) result.push(parseInt(secondStr, 10));
        return result;
    }
    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) return 2000 + year;
        else if (year <= 999) return 1900 + year;
        return year;
    }
    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^()]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }
    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr), weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }
    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) return obsOffsets[obsOffset];
        else if (militaryOffset) // the only allowed military tz is Z
        return 0;
        else {
            var hm = parseInt(numOffset, 10), m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }
    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)), parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) return;
            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);
            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
            getParsingFlags(config).rfc2822 = true;
        } else config._isValid = false;
    }
    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }
        configFromISO(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        configFromRFC2822(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        if (config._strict) config._isValid = false;
        else // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }
    hooks.createFromInputFallback = deprecate("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function(config) {
        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
    });
    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) return a;
        if (b != null) return b;
        return c;
    }
    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) return [
            nowValue.getUTCFullYear(),
            nowValue.getUTCMonth(),
            nowValue.getUTCDate()
        ];
        return [
            nowValue.getFullYear(),
            nowValue.getMonth(),
            nowValue.getDate()
        ];
    }
    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
        if (config._d) return;
        currentDate = currentDateArray(config);
        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) dayOfYearFromWeekInfo(config);
        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) getParsingFlags(config)._overflowDayOfYear = true;
            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }
        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for(i = 0; i < 3 && config._a[i] == null; ++i)config._a[i] = input[i] = currentDate[i];
        // Zero out whatever was not defaulted, including time
        for(; i < 7; i++)config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }
        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        if (config._nextDay) config._a[HOUR] = 24;
        // check for mismatching day of week
        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) getParsingFlags(config).weekdayMismatch = true;
    }
    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;
            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) weekdayOverflow = true;
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;
            curWeek = weekOfYear(createLocal(), dow, doy);
            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
            // Default to current week.
            week = defaults(w.w, curWeek.week);
            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) weekdayOverflow = true;
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) weekdayOverflow = true;
            } else // default to beginning of week
            weekday = dow;
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) getParsingFlags(config)._overflowWeeks = true;
        else if (weekdayOverflow != null) getParsingFlags(config)._overflowWeekday = true;
        else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }
    // constant that refers to the ISO standard
    hooks.ISO_8601 = function() {};
    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function() {};
    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;
        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i, i, parsedInput, tokens, token, skipped, stringLength = string.length, totalParsedInputLength = 0, era, tokenLen;
        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for(i = 0; i < tokenLen; i++){
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) getParsingFlags(config).unusedInput.push(skipped);
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) getParsingFlags(config).empty = false;
                else getParsingFlags(config).unusedTokens.push(token);
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) getParsingFlags(config).unusedTokens.push(token);
        }
        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) getParsingFlags(config).unusedInput.push(string);
        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) getParsingFlags(config).bigHour = undefined;
        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        configFromArray(config);
        checkOverflow(config);
    }
    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;
        if (meridiem == null) // nothing to do
        return hour;
        if (locale.meridiemHour != null) return locale.meridiemHour(hour, meridiem);
        else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) hour += 12;
            if (!isPm && hour === 12) hour = 0;
            return hour;
        } else // this is not supposed to happen
        return hour;
    }
    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig, bestMoment, scoreToBeat, i, currentScore, validFormatFound, bestFormatIsValid = false, configfLen = config._f.length;
        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }
        for(i = 0; i < configfLen; i++){
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) tempConfig._useUTC = config._useUTC;
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);
            if (isValid(tempConfig)) validFormatFound = true;
            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;
            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
            getParsingFlags(tempConfig).score = currentScore;
            if (!bestFormatIsValid) {
                if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) bestFormatIsValid = true;
                }
            } else if (currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }
        extend(config, bestMoment || tempConfig);
    }
    function configFromObject(config) {
        if (config._d) return;
        var i = normalizeObjectUnits(config._i), dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map([
            i.year,
            i.month,
            dayOrDate,
            i.hour,
            i.minute,
            i.second,
            i.millisecond
        ], function(obj) {
            return obj && parseInt(obj, 10);
        });
        configFromArray(config);
    }
    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }
        return res;
    }
    function prepareConfig(config) {
        var input = config._i, format = config._f;
        config._locale = config._locale || getLocale(config._l);
        if (input === null || format === undefined && input === '') return createInvalid({
            nullInput: true
        });
        if (typeof input === 'string') config._i = input = config._locale.preparse(input);
        if (isMoment(input)) return new Moment(checkOverflow(input));
        else if (isDate(input)) config._d = input;
        else if (isArray(format)) configFromStringAndArray(config);
        else if (format) configFromStringAndFormat(config);
        else configFromInput(config);
        if (!isValid(config)) config._d = null;
        return config;
    }
    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) config._d = new Date(hooks.now());
        else if (isDate(input)) config._d = new Date(input.valueOf());
        else if (typeof input === 'string') configFromString(config);
        else if (isArray(input)) {
            config._a = map(input.slice(0), function(obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) configFromObject(config);
        else if (isNumber(input)) // from milliseconds
        config._d = new Date(input);
        else hooks.createFromInputFallback(config);
    }
    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};
        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }
        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }
        if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) input = undefined;
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;
        return createFromConfig(c);
    }
    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }
    var prototypeMin = deprecate('moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/', function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other < this ? this : other;
        else return createInvalid();
    }), prototypeMax = deprecate('moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/', function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other > this ? this : other;
        else return createInvalid();
    });
    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) moments = moments[0];
        if (!moments.length) return createLocal();
        res = moments[0];
        for(i = 1; i < moments.length; ++i)if (!moments[i].isValid() || moments[i][fn](res)) res = moments[i];
        return res;
    }
    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);
        return pickBy('isBefore', args);
    }
    function max() {
        var args = [].slice.call(arguments, 0);
        return pickBy('isAfter', args);
    }
    var now = function() {
        return Date.now ? Date.now() : +new Date();
    };
    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond'
    ];
    function isDurationValid(m) {
        var key, unitHasDecimal = false, i, orderLen = ordering.length;
        for(key in m){
            if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) return false;
        }
        for(i = 0; i < orderLen; ++i)if (m[ordering[i]]) {
            if (unitHasDecimal) return false; // only allow non-integers for smallest unit
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) unitHasDecimal = true;
        }
        return true;
    }
    function isValid$1() {
        return this._isValid;
    }
    function createInvalid$1() {
        return createDuration(NaN);
    }
    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration), years = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months = normalizedInput.month || 0, weeks = normalizedInput.week || normalizedInput.isoWeek || 0, days = normalizedInput.day || 0, hours = normalizedInput.hour || 0, minutes = normalizedInput.minute || 0, seconds = normalizedInput.second || 0, milliseconds = normalizedInput.millisecond || 0;
        this._isValid = isDurationValid(normalizedInput);
        // representation for dateAddRemove
        this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 3600000; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;
        this._data = {};
        this._locale = getLocale();
        this._bubble();
    }
    function isDuration(obj) {
        return obj instanceof Duration;
    }
    function absRound(number) {
        if (number < 0) return Math.round(-1 * number) * -1;
        else return Math.round(number);
    }
    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length), lengthDiff = Math.abs(array1.length - array2.length), diffs = 0, i;
        for(i = 0; i < len; i++)if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) diffs++;
        return diffs + lengthDiff;
    }
    // FORMATTING
    function offset(token, separator) {
        addFormatToken(token, 0, 0, function() {
            var offset = this.utcOffset(), sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
        });
    }
    offset('Z', ':');
    offset('ZZ', '');
    // PARSING
    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken([
        'Z',
        'ZZ'
    ], function(input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });
    // HELPERS
    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;
    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher), chunk, parts, minutes;
        if (matches === null) return null;
        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || [
            '-',
            0,
            0
        ];
        minutes = +(parts[1] * 60) + toInt(parts[2]);
        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }
    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else return createLocal(input).local();
    }
    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }
    // HOOKS
    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function() {};
    // MOMENTS
    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0, localAdjust;
        if (!this.isValid()) return input != null ? this : NaN;
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) return this;
            } else if (Math.abs(input) < 16 && !keepMinutes) input = input * 60;
            if (!this._isUTC && keepLocalTime) localAdjust = getDateOffset(this);
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) this.add(localAdjust, 'm');
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) addSubtract(this, createDuration(input - offset, 'm'), 1, false);
                else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else return this._isUTC ? offset : getDateOffset(this);
    }
    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') input = -input;
            this.utcOffset(input, keepLocalTime);
            return this;
        } else return -this.utcOffset();
    }
    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }
    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;
            if (keepLocalTime) this.subtract(getDateOffset(this), 'm');
        }
        return this;
    }
    function setOffsetToParsedOffset() {
        if (this._tzm != null) this.utcOffset(this._tzm, false, true);
        else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) this.utcOffset(tZone);
            else this.utcOffset(0, true);
        }
        return this;
    }
    function hasAlignedHourOffset(input) {
        if (!this.isValid()) return false;
        input = input ? createLocal(input).utcOffset() : 0;
        return (this.utcOffset() - input) % 60 === 0;
    }
    function isDaylightSavingTime() {
        return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }
    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) return this._isDSTShifted;
        var c = {}, other;
        copyConfig(c, this);
        c = prepareConfig(c);
        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else this._isDSTShifted = false;
        return this._isDSTShifted;
    }
    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }
    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }
    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }
    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
    function createDuration(input, key) {
        var duration = input, // matching against regexp is expensive, do it on demand
        match = null, sign, ret, diffRes;
        if (isDuration(input)) duration = {
            ms: input._milliseconds,
            d: input._days,
            M: input._months
        };
        else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) duration[key] = +input;
            else duration.milliseconds = +input;
        } else if (match = aspNetRegex.exec(input)) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign
            };
        } else if (match = isoRegex.exec(input)) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign)
            };
        } else if (duration == null) // checks for null or undefined
        duration = {};
        else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }
        ret = new Duration(duration);
        if (isDuration(input) && hasOwnProp(input, '_locale')) ret._locale = input._locale;
        if (isDuration(input) && hasOwnProp(input, '_isValid')) ret._isValid = input._isValid;
        return ret;
    }
    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;
    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }
    function positiveMomentsDifference(base, other) {
        var res = {};
        res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) --res.months;
        res.milliseconds = +other - +base.clone().add(res.months, 'M');
        return res;
    }
    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) return {
            milliseconds: 0,
            months: 0
        };
        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) res = positiveMomentsDifference(base, other);
        else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }
        return res;
    }
    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function(val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' + 'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val;
                val = period;
                period = tmp;
            }
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }
    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds, days = absRound(duration._days), months = absRound(duration._months);
        if (!mom.isValid()) // No op
        return;
        updateOffset = updateOffset == null ? true : updateOffset;
        if (months) setMonth(mom, get(mom, 'Month') + months * isAdding);
        if (days) set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        if (milliseconds) mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        if (updateOffset) hooks.updateOffset(mom, days || months);
    }
    var add = createAdder(1, 'add'), subtract = createAdder(-1, 'subtract');
    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }
    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
    }
    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            'years',
            'year',
            'y',
            'months',
            'month',
            'M',
            'days',
            'day',
            'd',
            'dates',
            'date',
            'D',
            'hours',
            'hour',
            'h',
            'minutes',
            'minute',
            'm',
            'seconds',
            'second',
            's',
            'milliseconds',
            'millisecond',
            'ms'
        ], i, property, propertyLen = properties.length;
        for(i = 0; i < propertyLen; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input), dataTypeTest = false;
        if (arrayTest) dataTypeTest = input.filter(function(item) {
            return !isNumber(item) && isString(input);
        }).length === 0;
        return arrayTest && dataTypeTest;
    }
    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            'sameDay',
            'nextDay',
            'lastDay',
            'nextWeek',
            'lastWeek',
            'sameElse'
        ], i, property;
        for(i = 0; i < properties.length; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6 ? 'sameElse' : diff < -1 ? 'lastWeek' : diff < 0 ? 'lastDay' : diff < 1 ? 'sameDay' : diff < 2 ? 'nextDay' : diff < 7 ? 'nextWeek' : 'sameElse';
    }
    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(), sod = cloneWithOffset(now, this).startOf('day'), format = hooks.calendarFormat(this, sod) || 'sameElse', output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }
    function clone() {
        return new Moment(this);
    }
    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() > localInput.valueOf();
        else return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() < localInput.valueOf();
        else return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from), localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) return false;
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }
    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input), inputMs;
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() === localInput.valueOf();
        else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }
    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }
    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }
    function diff(input, units, asFloat) {
        var that, zoneDelta, output;
        if (!this.isValid()) return NaN;
        that = cloneWithOffset(input, this);
        if (!that.isValid()) return NaN;
        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
        units = normalizeUnits(units);
        switch(units){
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }
        return asFloat ? output : absFloor(output);
    }
    function monthDiff(a, b) {
        if (a.date() < b.date()) // end-of-month calculations work correct when the start month has more
        // days than the end month.
        return -monthDiff(b, a);
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()), // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, 'months'), anchor2, adjust;
        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }
        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }
    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }
    function toISOString(keepOffset) {
        if (!this.isValid()) return null;
        var utc = keepOffset !== true, m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) return this.toDate().toISOString();
            else return new Date(this.valueOf() + this.utcOffset() * 60000).toISOString().replace('Z', formatMoment(m, 'Z'));
        }
        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }
    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */ function inspect() {
        if (!this.isValid()) return 'moment.invalid(/* ' + this._i + ' */)';
        var func = 'moment', zone = '', prefix, year, datetime, suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';
        return this.format(prefix + year + datetime + suffix);
    }
    function format(inputString) {
        if (!inputString) inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }
    function from(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            to: this,
            from: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }
    function to(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            from: this,
            to: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }
    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;
        if (key === undefined) return this._locale._abbr;
        else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) this._locale = newLocaleData;
            return this;
        }
    }
    var lang = deprecate('moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.', function(key) {
        if (key === undefined) return this.localeData();
        else return this.locale(key);
    });
    function localeData() {
        return this._locale;
    }
    var MS_PER_SECOND = 1000, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = 3506328 * MS_PER_HOUR;
    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }
    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        else return new Date(y, m, d).valueOf();
    }
    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        else return Date.UTC(y, m, d);
    }
    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }
    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }
    function toDate() {
        return new Date(this.valueOf());
    }
    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond()
        ];
    }
    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }
    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }
    function isValid$2() {
        return isValid(this);
    }
    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }
    function invalidAt() {
        return getParsingFlags(this).overflow;
    }
    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }
    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');
    addFormatToken('y', [
        'y',
        1
    ], 'yo', 'eraYear');
    addFormatToken('y', [
        'yy',
        2
    ], 0, 'eraYear');
    addFormatToken('y', [
        'yyy',
        3
    ], 0, 'eraYear');
    addFormatToken('y', [
        'yyyy',
        4
    ], 0, 'eraYear');
    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);
    addParseToken([
        'N',
        'NN',
        'NNN',
        'NNNN',
        'NNNNN'
    ], function(input, array, config, token) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) getParsingFlags(config).era = era;
        else getParsingFlags(config).invalidEra = input;
    });
    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);
    addParseToken([
        'y',
        'yy',
        'yyy',
        'yyyy'
    ], YEAR);
    addParseToken([
        'yo'
    ], function(input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) match = input.match(config._locale._eraYearOrdinalRegex);
        if (config._locale.eraYearOrdinalParse) array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        else array[YEAR] = parseInt(input, 10);
    });
    function localeEras(m, format) {
        var i, l, date, eras = this._eras || getLocale('en')._eras;
        for(i = 0, l = eras.length; i < l; ++i){
            switch(typeof eras[i].since){
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }
            switch(typeof eras[i].until){
                case 'undefined':
                    eras[i].until = Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }
    function localeErasParse(eraName, format, strict) {
        var i, l, eras = this.eras(), name, abbr, narrow;
        eraName = eraName.toUpperCase();
        for(i = 0, l = eras.length; i < l; ++i){
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();
            if (strict) switch(format){
                case 'N':
                case 'NN':
                case 'NNN':
                    if (abbr === eraName) return eras[i];
                    break;
                case 'NNNN':
                    if (name === eraName) return eras[i];
                    break;
                case 'NNNNN':
                    if (narrow === eraName) return eras[i];
                    break;
            }
            else if ([
                name,
                abbr,
                narrow
            ].indexOf(eraName) >= 0) return eras[i];
        }
    }
    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? 1 : -1;
        if (year === undefined) return hooks(era.since).year();
        else return hooks(era.since).year() + (year - era.offset) * dir;
    }
    function getEraName() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].name;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].name;
        }
        return '';
    }
    function getEraNarrow() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].narrow;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].narrow;
        }
        return '';
    }
    function getEraAbbr() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].abbr;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].abbr;
        }
        return '';
    }
    function getEraYear() {
        var i, l, dir, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            dir = eras[i].since <= eras[i].until ? 1 : -1;
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
        }
        return this.year();
    }
    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) computeErasParse.call(this);
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }
    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) computeErasParse.call(this);
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }
    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) computeErasParse.call(this);
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }
    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }
    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }
    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }
    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }
    function computeErasParse() {
        var abbrPieces = [], namePieces = [], narrowPieces = [], mixedPieces = [], i, l, erasName, erasAbbr, erasNarrow, eras = this.eras();
        for(i = 0, l = eras.length; i < l; ++i){
            erasName = regexEscape(eras[i].name);
            erasAbbr = regexEscape(eras[i].abbr);
            erasNarrow = regexEscape(eras[i].narrow);
            namePieces.push(erasName);
            abbrPieces.push(erasAbbr);
            narrowPieces.push(erasNarrow);
            mixedPieces.push(erasName);
            mixedPieces.push(erasAbbr);
            mixedPieces.push(erasNarrow);
        }
        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp('^(' + narrowPieces.join('|') + ')', 'i');
    }
    // FORMATTING
    addFormatToken(0, [
        'gg',
        2
    ], 0, function() {
        return this.weekYear() % 100;
    });
    addFormatToken(0, [
        'GG',
        2
    ], 0, function() {
        return this.isoWeekYear() % 100;
    });
    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [
            token,
            token.length
        ], 0, getter);
    }
    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
    // ALIASES
    // PARSING
    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);
    addWeekParseToken([
        'gggg',
        'ggggg',
        'GGGG',
        'GGGGG'
    ], function(input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });
    addWeekParseToken([
        'gg',
        'GG'
    ], function(input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });
    // MOMENTS
    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.week(), this.weekday() + this.localeData()._week.dow, this.localeData()._week.dow, this.localeData()._week.doy);
    }
    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }
    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }
    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }
    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }
    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }
    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) return weekOfYear(this, dow, doy).year;
        else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) week = weeksTarget;
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }
    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }
    // FORMATTING
    addFormatToken('Q', 0, 'Qo', 'quarter');
    // PARSING
    addRegexToken('Q', match1);
    addParseToken('Q', function(input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });
    // MOMENTS
    function getSetQuarter(input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }
    // FORMATTING
    addFormatToken('D', [
        'DD',
        2
    ], 'Do', 'date');
    // PARSING
    addRegexToken('D', match1to2, match1to2NoLeadingZero);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function(isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
    });
    addParseToken([
        'D',
        'DD'
    ], DATE);
    addParseToken('Do', function(input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });
    // MOMENTS
    var getSetDayOfMonth = makeGetSet('Date', true);
    // FORMATTING
    addFormatToken('DDD', [
        'DDDD',
        3
    ], 'DDDo', 'dayOfYear');
    // PARSING
    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken([
        'DDD',
        'DDDD'
    ], function(input, array, config) {
        config._dayOfYear = toInt(input);
    });
    // HELPERS
    // MOMENTS
    function getSetDayOfYear(input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }
    // FORMATTING
    addFormatToken('m', [
        'mm',
        2
    ], 0, 'minute');
    // PARSING
    addRegexToken('m', match1to2, match1to2HasZero);
    addRegexToken('mm', match1to2, match2);
    addParseToken([
        'm',
        'mm'
    ], MINUTE);
    // MOMENTS
    var getSetMinute = makeGetSet('Minutes', false);
    // FORMATTING
    addFormatToken('s', [
        'ss',
        2
    ], 0, 'second');
    // PARSING
    addRegexToken('s', match1to2, match1to2HasZero);
    addRegexToken('ss', match1to2, match2);
    addParseToken([
        's',
        'ss'
    ], SECOND);
    // MOMENTS
    var getSetSecond = makeGetSet('Seconds', false);
    // FORMATTING
    addFormatToken('S', 0, 0, function() {
        return ~~(this.millisecond() / 100);
    });
    addFormatToken(0, [
        'SS',
        2
    ], 0, function() {
        return ~~(this.millisecond() / 10);
    });
    addFormatToken(0, [
        'SSS',
        3
    ], 0, 'millisecond');
    addFormatToken(0, [
        'SSSS',
        4
    ], 0, function() {
        return this.millisecond() * 10;
    });
    addFormatToken(0, [
        'SSSSS',
        5
    ], 0, function() {
        return this.millisecond() * 100;
    });
    addFormatToken(0, [
        'SSSSSS',
        6
    ], 0, function() {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, [
        'SSSSSSS',
        7
    ], 0, function() {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, [
        'SSSSSSSS',
        8
    ], 0, function() {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, [
        'SSSSSSSSS',
        9
    ], 0, function() {
        return this.millisecond() * 1000000;
    });
    // PARSING
    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);
    var token, getSetMillisecond;
    for(token = 'SSSS'; token.length <= 9; token += 'S')addRegexToken(token, matchUnsigned);
    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }
    for(token = 'S'; token.length <= 9; token += 'S')addParseToken(token, parseMs);
    getSetMillisecond = makeGetSet('Milliseconds', false);
    // FORMATTING
    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');
    // MOMENTS
    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }
    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }
    var proto = Moment.prototype;
    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) proto[Symbol.for('nodejs.util.inspect.custom')] = function() {
        return 'Moment<' + this.format() + '>';
    };
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
    function createUnix(input) {
        return createLocal(input * 1000);
    }
    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }
    function preParsePostFormat(string) {
        return string;
    }
    var proto$1 = Locale.prototype;
    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;
    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;
    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;
    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;
    function get$1(format, index, field, setter) {
        var locale = getLocale(), utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }
    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }
        format = format || '';
        if (index != null) return get$1(format, index, field, 'month');
        var i, out = [];
        for(i = 0; i < 12; i++)out[i] = get$1(format, i, field, 'month');
        return out;
    }
    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || '';
        }
        var locale = getLocale(), shift = localeSorted ? locale._week.dow : 0, i, out = [];
        if (index != null) return get$1(format, (index + shift) % 7, field, 'day');
        for(i = 0; i < 7; i++)out[i] = get$1(format, (i + shift) % 7, field, 'day');
        return out;
    }
    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }
    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }
    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }
    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }
    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }
    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD'
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC'
            }
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function(number) {
            var b = number % 10, output = toInt(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
            return number + output;
        }
    });
    // Side effect imports
    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
    var mathAbs = Math.abs;
    function abs() {
        var data = this._data;
        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);
        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);
        return this;
    }
    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);
        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;
        return duration._bubble();
    }
    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }
    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }
    function absCeil(number) {
        if (number < 0) return Math.floor(number);
        else return Math.ceil(number);
    }
    function bubble() {
        var milliseconds = this._milliseconds, days = this._days, months = this._months, data = this._data, seconds, minutes, hours, years, monthsFromDays;
        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }
        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;
        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;
        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;
        hours = absFloor(minutes / 60);
        data.hours = hours % 24;
        days += absFloor(hours / 24);
        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        data.days = days;
        data.months = months;
        data.years = years;
        return this;
    }
    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }
    function monthsToDays(months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }
    function as(units) {
        if (!this.isValid()) return NaN;
        var days, months, milliseconds = this._milliseconds;
        units = normalizeUnits(units);
        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch(units){
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch(units){
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }
    function makeAs(alias) {
        return function() {
            return this.as(alias);
        };
    }
    var asMilliseconds = makeAs('ms'), asSeconds = makeAs('s'), asMinutes = makeAs('m'), asHours = makeAs('h'), asDays = makeAs('d'), asWeeks = makeAs('w'), asMonths = makeAs('M'), asQuarters = makeAs('Q'), asYears = makeAs('y'), valueOf$1 = asMilliseconds;
    function clone$1() {
        return createDuration(this);
    }
    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }
    function makeGetter(name) {
        return function() {
            return this.isValid() ? this._data[name] : NaN;
        };
    }
    var milliseconds = makeGetter('milliseconds'), seconds = makeGetter('seconds'), minutes = makeGetter('minutes'), hours = makeGetter('hours'), days = makeGetter('days'), months = makeGetter('months'), years = makeGetter('years');
    function weeks() {
        return absFloor(this.days() / 7);
    }
    var round = Math.round, thresholds = {
        ss: 44,
        s: 45,
        m: 45,
        h: 22,
        d: 26,
        w: null,
        M: 11
    };
    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }
    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(), seconds = round(duration.as('s')), minutes = round(duration.as('m')), hours = round(duration.as('h')), days = round(duration.as('d')), months = round(duration.as('M')), weeks = round(duration.as('w')), years = round(duration.as('y')), a = seconds <= thresholds.ss && [
            's',
            seconds
        ] || seconds < thresholds.s && [
            'ss',
            seconds
        ] || minutes <= 1 && [
            'm'
        ] || minutes < thresholds.m && [
            'mm',
            minutes
        ] || hours <= 1 && [
            'h'
        ] || hours < thresholds.h && [
            'hh',
            hours
        ] || days <= 1 && [
            'd'
        ] || days < thresholds.d && [
            'dd',
            days
        ];
        if (thresholds.w != null) a = a || weeks <= 1 && [
            'w'
        ] || weeks < thresholds.w && [
            'ww',
            weeks
        ];
        a = a || months <= 1 && [
            'M'
        ] || months < thresholds.M && [
            'MM',
            months
        ] || years <= 1 && [
            'y'
        ] || [
            'yy',
            years
        ];
        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }
    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) return round;
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }
    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) return false;
        if (limit === undefined) return thresholds[threshold];
        thresholds[threshold] = limit;
        if (threshold === 's') thresholds.ss = limit - 1;
        return true;
    }
    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) return this.localeData().invalidDate();
        var withSuffix = false, th = thresholds, locale, output;
        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') withSuffix = argWithSuffix;
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) th.ss = argThresholds.s - 1;
        }
        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);
        if (withSuffix) output = locale.pastFuture(+this, output);
        return locale.postformat(output);
    }
    var abs$1 = Math.abs;
    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }
    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) return this.localeData().invalidDate();
        var seconds = abs$1(this._milliseconds) / 1000, days = abs$1(this._days), months = abs$1(this._months), minutes, hours, years, s, total = this.asSeconds(), totalSign, ymSign, daysSign, hmsSign;
        if (!total) // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return 'P0D';
        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
        return totalSign + 'P' + (years ? ymSign + years + 'Y' : '') + (months ? ymSign + months + 'M' : '') + (days ? daysSign + days + 'D' : '') + (hours || minutes || seconds ? 'T' : '') + (hours ? hmsSign + hours + 'H' : '') + (minutes ? hmsSign + minutes + 'M' : '') + (seconds ? hmsSign + s + 'S' : '');
    }
    var proto$2 = Duration.prototype;
    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;
    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang;
    // FORMATTING
    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');
    // PARSING
    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function(input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function(input, array, config) {
        config._d = new Date(toInt(input));
    });
    //! moment.js
    hooks.version = '2.30.1';
    setHookCallback(createLocal);
    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;
    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',
        DATE: 'YYYY-MM-DD',
        TIME: 'HH:mm',
        TIME_SECONDS: 'HH:mm:ss',
        TIME_MS: 'HH:mm:ss.SSS',
        WEEK: 'GGGG-[W]WW',
        MONTH: 'YYYY-MM'
    };
    return hooks;
});

});

parcelRegister("8Jd2Q", function(module, exports) {

$parcel$export(module.exports, "runRescheduleFlow", () => $65aca521468e4916$export$4cde5d807da86c89);
$parcel$export(module.exports, "loadAppoinmentConfirmedLandingPage", () => $65aca521468e4916$export$ca2ddd5ec4ea975e);
$parcel$export(module.exports, "handleEventRoomNullUI", () => $65aca521468e4916$export$22d04c21a22e4f92);
$parcel$export(module.exports, "handleEventRoomUI", () => $65aca521468e4916$export$914d91584efe1dee);

var $knjAn = parcelRequire("knjAn");

var $cNdCr = parcelRequire("cNdCr");

var $cIxq8 = parcelRequire("cIxq8");

var $cEKee = parcelRequire("cEKee");

var $cDpNn = parcelRequire("cDpNn");

var $66jZq = parcelRequire("66jZq");

var $gZEOs = parcelRequire("gZEOs");

var $hOgIi = parcelRequire("hOgIi");

var $ebrDl = parcelRequire("ebrDl");
parcelRequire("gEfFu");

var $er9E0 = parcelRequire("er9E0");

var $e4miY = parcelRequire("e4miY");

var $1BEhs = parcelRequire("1BEhs");

var $45fvw = parcelRequire("45fvw");

var $62LVp = parcelRequire("62LVp");

var $alq6e = parcelRequire("alq6e");
async function $65aca521468e4916$export$4cde5d807da86c89(eventData) {
    // Reset to the widget token so slot/fully-booked-days APIs work (Lead tokens lack staff.slots.show)
    if ((0, $cEKee.form)?.token) (0, $cEKee.setAccessToken)((0, $cEKee.form).token);
    const leadInfo = eventData?.participants?.find((p)=>p.participable_type === 'App\\Models\\Lead')?.participable;
    const provider = eventData?.participants?.find((p)=>p.participable_type === 'App\\Models\\Staff')?.participable;
    if (provider) (0, $cEKee.setProviderId)(provider.id);
    if (leadInfo) (0, $cEKee.setLeadInfo)(leadInfo);
    (0, $cEKee.setSelectedProcedures)(eventData.procedures?.map((p)=>p.id) ?? []);
    (0, $cEKee.setSelectedAddons)(eventData.procedure_addons ?? []);
    (0, $cEKee.setSelectedLocation)(eventData.location_id);
    const appointmentChannelIdFromEvent = eventData.appointment_channel_id ?? eventData.appointment_channel?.id;
    if (appointmentChannelIdFromEvent != null) (0, $cEKee.setAppointmentChannelId)(appointmentChannelIdFromEvent);
    (0, $cEKee.setCurrentDateInUse)((0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))().unix());
    await (0, $1BEhs.loadOnlyTimeCarousel)();
    (0, $e4miY.selectOnlyTimeListeners)();
    /* Set action=reschedule in URL so that when user picks a timeslot we show reschedule-reason and call reschedule API instead of create event. */ (0, $er9E0.setActionParam)((0, $cIxq8.APPOINTMENT_ACTIONS).RESCHEDULE);
    const titleEl = document.querySelector('.selectOnlyDate__container .title__content');
    if (titleEl) titleEl.innerHTML = `${(0, $knjAn.t)('select_time_with')} ${(0, $62LVp.getProviderFullName)()}`;
    (0, $er9E0.navigate)((0, $cIxq8.SCREEN).SELECT_ONLY_DATE);
}
async function $65aca521468e4916$export$ca2ddd5ec4ea975e() {
    const eventId = (0, $er9E0.params)((0, $cIxq8.EVENT_ID_PARAM));
    const signature = (0, $er9E0.params)('signature');
    const expires = (0, $er9E0.params)('expires');
    // Load appointment details via the signature-gated resume route, never the
    // broad token-scoped GET /api/events/{id}. The "Manage appointment" link
    // carries resume_signature/resume_expires; the drop-off summary link reuses
    // the page signature/expires.
    const isDropoffSummary = (0, $er9E0.params)((0, $cIxq8.DROPOFF_RESUME_PARAM)) === 'summary';
    const resumeSignature = (0, $er9E0.params)('resume_signature') || (isDropoffSummary ? signature : null);
    const resumeExpires = (0, $er9E0.params)('resume_expires') || (isDropoffSummary ? expires : null);
    const useResumeLink = resumeSignature && resumeExpires;
    let eventInfoRes;
    try {
        eventInfoRes = useResumeLink ? await (0, $cNdCr.getEventResume)(eventId, resumeSignature, resumeExpires) : await (0, $cNdCr.getEvevntInfoById)(eventId);
    } catch (e) {
        // Expired/missing signature (the bare route 403s for widget tokens).
        // Ask the status-only endpoint what happened so the visitor sees a
        // real page — cancelled / no longer available, with a rebook — instead
        // of a generic error. Never leave the boot spinner hanging.
        try {
            const statusRes = await (0, $cNdCr.getEventStatus)(eventId);
            const status = (statusRes?.data ?? statusRes)?.status;
            if (status === 'cancelled' || status === 'deleted') {
                (0, $cDpNn.loadAppointmentGonePage)(status);
                document.querySelector((0, $er9E0.getClassScreen)((0, $cIxq8.SCREEN).APPOINTMENT_CONFIRMED)).style.transition = 'none';
                (0, $er9E0.navigate)((0, $cIxq8.SCREEN).APPOINTMENT_CONFIRMED);
                return;
            }
        } catch (_) {}
        (0, $gZEOs.toastError)((0, $knjAn.t)('error_load_appointment_summary'));
        (0, $er9E0.navigate)((0, $cIxq8.SCREEN).DASHBOARD);
        return;
    }
    const eventData = eventInfoRes?.data ?? eventInfoRes;
    // Allow dropoff so resume links (dropoff_resume=summary) can load and let the lead continue booking
    if (![
        'request',
        'confirmed',
        'complete',
        'cancelled',
        'dropoff'
    ].includes(eventData.status)) (0, $gZEOs.toastError)((0, $knjAn.t)('error_event_cancelled'));
    else {
        (0, $cEKee.setEventPayload)(eventData);
        (0, $cEKee.setEventRoom)(eventData.event_room);
        (0, $cEKee.setLocationId)(eventData.location_id);
        // Dropoff resume or event is in dropoff status: show summary so user can continue to deposit
        const isDropoffResume = (0, $er9E0.params)((0, $cIxq8.DROPOFF_RESUME_PARAM)) === 'summary' || eventData.status === 'dropoff';
        if (isDropoffResume) {
            const appointmentChannelId = eventData.appointment_channel_id || eventData.appointment_channel?.id;
            if (!appointmentChannelId) {
                (0, $gZEOs.toastError)((0, $knjAn.t)('error_load_appointment_summary'));
                return;
            }
            try {
                const confirmRes = await (0, $cNdCr.confirmEvent)(eventId, appointmentChannelId);
                const lead = eventData?.participants?.find((p)=>p.participable_type === 'App\\Models\\Lead')?.participable;
                const provider = eventData?.participants?.find((p)=>p.participable_type === 'App\\Models\\Staff')?.participable;
                (0, $cEKee.setLeadInfo)(lead || null);
                (0, $cEKee.setProviderId)(provider?.id ?? null);
                (0, $cEKee.setAppointmentSummary)(confirmRes.data);
                (0, $cEKee.setAppointmentDuration)({
                    duration: confirmRes.data.duration || 0,
                    requires_consult: confirmRes.data.requires_consult ?? false
                });
                (0, $cEKee.setEventId)(eventId);
                (0, $alq6e.loadAppointmentSummary)();
                return;
            } catch (e) {
                (0, $gZEOs.toastError)(e?.response?.data?.message || "Unable to load appointment summary.");
                return;
            }
        }
        const action = (0, $er9E0.params)((0, $cIxq8.ACTION_PARAM));
        if (action === (0, $cIxq8.APPOINTMENT_ACTIONS).CANCEL) {
            (0, $66jZq.loadAppointmentCancel)();
            (0, $ebrDl.appointmentCancelListeners)();
            document.querySelector((0, $er9E0.getClassScreen)((0, $cIxq8.SCREEN).APPOINTMENT_CANCEL)).style.transition = 'none';
            (0, $er9E0.navigate)((0, $cIxq8.SCREEN).APPOINTMENT_CANCEL);
        } else if (action === (0, $cIxq8.APPOINTMENT_ACTIONS).RESCHEDULE) await $65aca521468e4916$export$4cde5d807da86c89(eventData);
        else {
            // Cancelled events fall through to the confirmed screen, which
            // renders the "appointment cancelled" banner. The old toast-and-
            // return here left the boot loader spinning forever on the
            // post-cancel redirect URL (?form_id=…&event_id=…, no signature).
            (0, $cDpNn.loadAppointmentConfirmed)();
            (0, $hOgIi.appointmentConfirmedListeners)();
            document.querySelector((0, $er9E0.getClassScreen)((0, $cIxq8.SCREEN).APPOINTMENT_CONFIRMED)).style.transition = 'none';
            (0, $er9E0.navigate)((0, $cIxq8.SCREEN).APPOINTMENT_CONFIRMED);
        }
    }
}
function $65aca521468e4916$export$22d04c21a22e4f92() {
    const actionWrapperDom = document.querySelector('.appointment-confirmed__container .action');
    if (actionWrapperDom) actionWrapperDom.innerHTML = '';
}
function $65aca521468e4916$export$914d91584efe1dee() {
    const actionWrapperDom = document.querySelector('.appointment-confirmed__container .action');
    if (actionWrapperDom) actionWrapperDom.innerHTML = '';
}

});
parcelRegister("66jZq", function(module, exports) {

$parcel$export(module.exports, "loadAppointmentCancel", () => $4712cf268d619e62$export$e40aef2819942d8d);

var $45fvw = parcelRequire("45fvw");

var $knjAn = parcelRequire("knjAn");

var $8Jd2Q = parcelRequire("8Jd2Q");

var $62LVp = parcelRequire("62LVp");

var $er9E0 = parcelRequire("er9E0");

var $cIxq8 = parcelRequire("cIxq8");

var $cDpNn = parcelRequire("cDpNn");

var $cEKee = parcelRequire("cEKee");

var $gZEOs = parcelRequire("gZEOs");

var $cNdCr = parcelRequire("cNdCr");

var $4vKjI = parcelRequire("4vKjI");

var $ctM9Q = parcelRequire("ctM9Q");
async function $4712cf268d619e62$export$e40aef2819942d8d() {
    if (!(0, $cEKee.eventPayload)) return;
    (0, $cNdCr.primeRescheduleSignatureParams)();
    $4712cf268d619e62$var$initializeStyles();
    $4712cf268d619e62$var$setBusinessLogo();
    $4712cf268d619e62$var$renderAppointmentInfo();
    $4712cf268d619e62$var$handleCalendarAndDirections();
    $4712cf268d619e62$var$handleConfirmCancelButtons();
}
function $4712cf268d619e62$var$initializeStyles() {
    const container = document.querySelector((0, $4vKjI.SELECTORS).container);
    if (!container) return;
    document.querySelector((0, $4vKjI.SELECTORS).icon).style.backgroundColor = `${0, $cEKee.primaryColor}0f`;
    document.querySelector((0, $4vKjI.SELECTORS).informationCard).style.backgroundColor = `${0, $cEKee.primaryColor}09`;
    const checkIconWrapper = document.querySelector((0, $4vKjI.SELECTORS).checkIconWrapper);
    checkIconWrapper.style.border = `3px solid ${0, $cEKee.primaryColor}0f`;
    checkIconWrapper.style.backgroundColor = 'white';
}
function $4712cf268d619e62$var$setBusinessLogo() {
    if ((0, $cEKee.form).project.business_photo) document.querySelector((0, $4vKjI.SELECTORS).logo)?.setAttribute('src', (0, $cEKee.form).project.business_photo);
}
function $4712cf268d619e62$var$renderAppointmentInfo() {
    const startTime = parseInt((0, $cEKee.eventPayload).start_time);
    const staffName = $4712cf268d619e62$var$getStaffName();
    const staffNameDom = document.querySelector((0, $4vKjI.SELECTORS).staffInfo);
    const timeInfoDom = document.querySelector((0, $4vKjI.SELECTORS).timeInfo);
    const dateInfoDom = document.querySelector((0, $4vKjI.SELECTORS).dateInfo);
    if (staffNameDom) staffNameDom.textContent = staffName;
    if (timeInfoDom) timeInfoDom.textContent = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(startTime * 1000).format('hh:mm A');
    if (dateInfoDom) {
        const formatDuration = (durationMinutes)=>{
            const duration = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw))).duration(durationMinutes, 'minutes');
            const hours = Math.floor(duration.asHours());
            const minutes = duration.minutes();
            let result = '';
            if (hours > 0) result += `${hours}h `;
            if (minutes > 0 || hours === 0) result += `${minutes}min`;
            return result;
        };
        const appointmentDate = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(startTime * 1000).format('dddd, MMMM DD, YYYY');
        const durationFormatted = formatDuration((0, $cEKee.eventPayload).duration);
        dateInfoDom.innerHTML = `
            ${appointmentDate} - <span style="background: ${0, $cEKee.primaryColor}0f">${durationFormatted}</span>
        `;
    }
}
function $4712cf268d619e62$var$getStaffName() {
    if ((0, $cEKee.eventPayload).participants && (0, $cEKee.eventPayload).participants.length > 0 && (0, $er9E0.params)('event_id')) {
        const participant = (0, $cEKee.eventPayload).participants.find((i)=>i.participable_type === 'App\\Models\\Staff');
        return participant ? `${participant.participable.first_name} ${participant.participable.last_name}` : '';
    }
    return (0, $62LVp.getProviderFullName)((0, $cEKee.eventPayload).staff);
}
function $4712cf268d619e62$var$handleCalendarAndDirections() {
    if ((0, $cEKee.eventRoom) === null) (0, $8Jd2Q.handleEventRoomNullUI)();
    else (0, $8Jd2Q.handleEventRoomUI)();
}
function $4712cf268d619e62$var$handleConfirmCancelButtons() {
    const actionDiv = document.querySelector((0, $4vKjI.SELECTORS).actionDiv);
    if (!actionDiv) return;
    $4712cf268d619e62$var$showCancellationForm();
}
function $4712cf268d619e62$var$showCancellationForm() {
    const actionDiv = document.querySelector((0, $4vKjI.SELECTORS).actionDiv);
    if (!actionDiv) return;
    const formHtml = `
        <div class="cancellation-form">
            <div class="cancellation-form__header">
                <h3>${(0, $knjAn.t)('why_cancelling')} <span class="required">*</span></h3>
            </div>
            <div class="cancellation-form__reasons">
                <button type="button" class="reason-btn" data-reason="Emergency">${(0, $knjAn.t)('cancel_reason_emergency')}</button>
                <button type="button" class="reason-btn" data-reason="Conflict">${(0, $knjAn.t)('cancel_reason_conflict')}</button>
                <button type="button" class="reason-btn" data-reason="Not needed">${(0, $knjAn.t)('cancel_reason_not_needed')}</button>
            </div>
            <div class="cancellation-form__textarea">
                <textarea
                    id="cancellation-reason"
                    placeholder="${(0, $knjAn.t)('cancel_reason_placeholder')}"
                    maxlength="300"
                    rows="4"
                    required
                ></textarea>
                <div class="character-count">
                    <span id="char-count">0</span>/300
                </div>
            </div>
            <div class="cancellation-form__actions">
                <button type="button" id="cancel-appointment-btn" class="cancel-appointment-btn" disabled>
                    ${(0, $knjAn.t)('cancel_appointment')}
                </button>
            </div>
        </div>
    `;
    actionDiv.innerHTML = formHtml;
    if (typeof feather !== 'undefined') feather.replace();
    $4712cf268d619e62$var$setupCancellationFormListeners();
}
function $4712cf268d619e62$var$setupCancellationFormListeners() {
    const textarea = document.getElementById('cancellation-reason');
    const charCount = document.getElementById('char-count');
    const cancelBtn = document.getElementById('cancel-appointment-btn');
    const reasonBtns = document.querySelectorAll('.reason-btn');
    if (textarea && charCount) textarea.addEventListener('input', function() {
        const length = this.value.length;
        charCount.textContent = length;
        if (cancelBtn) cancelBtn.disabled = length < 2;
    });
    reasonBtns.forEach((btn)=>{
        btn.addEventListener('click', function() {
            reasonBtns.forEach((b)=>b.classList.remove('active'));
            this.classList.add('active');
            if (textarea) {
                const reason = this.getAttribute('data-reason');
                textarea.value = reason;
                charCount.textContent = reason.length;
                if (cancelBtn) cancelBtn.disabled = false;
            }
        });
    });
    if (cancelBtn) cancelBtn.addEventListener('click', $4712cf268d619e62$var$handleCancelAppointment);
}
async function $4712cf268d619e62$var$handleCancelAppointment() {
    const textarea = document.getElementById('cancellation-reason');
    const cancelBtn = document.getElementById('cancel-appointment-btn');
    if (!textarea || !textarea.value.trim()) {
        (0, $gZEOs.toastError)((0, $knjAn.t)('cancel_provide_reason'));
        return;
    }
    const isPredefinedReason = document.querySelector('.reason-btn.active') !== null;
    if (!isPredefinedReason && textarea.value.trim().length < 10) {
        (0, $gZEOs.toastError)((0, $knjAn.t)('cancel_min_chars'));
        return;
    }
    try {
        if (cancelBtn) {
            cancelBtn.disabled = true;
            cancelBtn.innerHTML = (0, $knjAn.t)('processing');
        }
        const eventId = (0, $er9E0.params)('event_id');
        if (!eventId) throw new Error('Event ID not found');
        const response = await (0, $cNdCr.cancelEvent)(eventId, textarea.value.trim());
        if (response && response.status === 200) {
            (0, $ctM9Q.toastSuccess)((0, $knjAn.t)('cancel_success'));
            // Stay in the widget: strip the action/signature params so a
            // refresh lands on the plain revisit URL, then render the
            // cancelled page in place. No page-level redirect — it reloaded
            // the host page out from under the visitor.
            try {
                const url = new URL(window.location.href);
                [
                    'action',
                    'signature',
                    'expires',
                    'resume_signature',
                    'resume_expires'
                ].forEach((p)=>url.searchParams.delete(p));
                window.history.replaceState({}, '', url.toString());
            } catch (_) {}
            (0, $cDpNn.loadAppointmentGonePage)('cancelled');
            const screenEl = document.querySelector((0, $er9E0.getClassScreen)((0, $cIxq8.SCREEN).APPOINTMENT_CONFIRMED));
            if (screenEl) screenEl.style.transition = 'none';
            (0, $er9E0.navigate)((0, $cIxq8.SCREEN).APPOINTMENT_CONFIRMED);
        } else throw new Error('Failed to cancel appointment');
    } catch (error) {
        (0, $gZEOs.toastError)((0, $knjAn.t)('cancel_failed'));
        if (cancelBtn) {
            cancelBtn.disabled = false;
            cancelBtn.innerHTML = (0, $knjAn.t)('cancel_appointment');
        }
    }
}

});
parcelRegister("62LVp", function(module, exports) {

$parcel$export(module.exports, "selectProvider", () => $46681ae4199feefb$export$ea920ba490374be6);
$parcel$export(module.exports, "removeAllSelectProvider", () => $46681ae4199feefb$export$3a7609af54b210b);
$parcel$export(module.exports, "removeHiddenClassInProvider", () => $46681ae4199feefb$export$29ebcb6cec647a88);
$parcel$export(module.exports, "getProviderFullName", () => $46681ae4199feefb$export$25fbd319da9eed4d);
$parcel$export(module.exports, "renderContinueBtn", () => $46681ae4199feefb$export$fd21a3522afa2d24);

var $knjAn = parcelRequire("knjAn");

var $cEKee = parcelRequire("cEKee");
function $46681ae4199feefb$export$ea920ba490374be6(id) {
    $46681ae4199feefb$export$3a7609af54b210b(id);
    let providerOption;
    if (id == -1) providerOption = document.querySelector(`.provider__option[data-provider-id="-1"]`);
    else providerOption = document.querySelector(`.provider__option[data-provider-id="${CSS.escape(id)}"]`);
    providerOption?.classList.add('is-selected');
    /* Unable Continue button */ document.querySelector('.providerContinue__btn')?.classList.remove('disabled');
}
function $46681ae4199feefb$export$3a7609af54b210b(id = null) {
    (0, $cEKee.setProviderId)('');
    if ((0, $cEKee.providers).length === 1) {
        const id = (0, $cEKee.providers)[0].id;
        (0, $cEKee.setProviderId)(id);
    }
    if (id && (0, $cEKee.appointmentChannelId)) (0, $cEKee.setProviderId)(id);
    document.querySelectorAll('.provider__option').forEach((i)=>i.classList.remove('is-selected'));
    document.querySelector('.providerContinue__btn')?.classList.add('disabled');
}
function $46681ae4199feefb$export$29ebcb6cec647a88() {
    document.querySelectorAll('.providers__container .provider').forEach((i)=>{
        i.classList.remove('hidden');
    });
}
function $46681ae4199feefb$export$25fbd319da9eed4d() {
    if (!(0, $cEKee.isFlowForCalendar) || (0, $cEKee.form)?.appointment_channel?.host === 'one_on_one') {
        const currentProviderId = (0, $cEKee.providerId) || (0, $cEKee.staffId);
        if (currentProviderId === -1) return (0, $knjAn.t)('soonest_available');
        const selectedProvider = (0, $cEKee.providers).find((provider)=>provider.id === currentProviderId);
        return `${selectedProvider?.first_name ?? ""} ${selectedProvider?.last_name ?? ""}`.trim() || (0, $knjAn.t)('no_preference');
    }
    const hostMessages = {
        round_robin: (0, $knjAn.t)('no_preference'),
        collective: (0, $knjAn.t)('team_members')
    };
    return hostMessages[(0, $cEKee.form)?.appointment_channel?.host] ?? (0, $knjAn.t)('no_preference');
}
function $46681ae4199feefb$export$fd21a3522afa2d24() {
    document.querySelector('.providerContinue__btn-wrapper').innerHTML = '';
    document.querySelector('.providerContinue__btn-wrapper').insertAdjacentHTML('beforeend', `<div class="providerContinue__btn disabled">${(0, $knjAn.t)('continue')} <span class="loader__icon"> <i class="ri-arrow-right-line"></i></span><div class="loading__wrapper hidden"><div class="loader"></div></div></div>`);
}

});

parcelRegister("4vKjI", function(module, exports) {

$parcel$export(module.exports, "SELECTORS", () => $348dfc489fae853c$export$6d10441bd0a505b0);

var $knjAn = parcelRequire("knjAn");
const $348dfc489fae853c$export$6d10441bd0a505b0 = {
    container: '.appointment-cancel__container',
    body: '.appointment-cancel__body',
    card: '.appointment-cancel__body .card',
    icon: '.appointment-cancel__body .icon',
    checkIconWrapper: '.appointment-cancel__container .icon .custom-check-icon-wrapper',
    informationCard: '.appointment-cancel__body .information .card',
    staffInfo: '.appointment-cancel__container .time-staff__info .staff__info',
    timeInfo: '.appointment-cancel__container .time-staff__info .time__info',
    dateInfo: '.appointment-cancel__container .date__info',
    actionDiv: '.appointment-cancel__container .card .action',
    appointmentButtons: '.appointment-cancel__container .appointment-confirm-single',
    title: '.appointment-cancel__body .title',
    confirmBtn: '#confirm-appointment-btn',
    cancelLink: '#cancel-appointment-link',
    logo: '.appointment-cancel__container .appointment__logo',
    pendingBanner: '.appointment-cancel__container .pending-approval-banner',
    cancelledBanner: '.appointment-cancel__container .cancelled-appointment-banner'
};
const $348dfc489fae853c$export$af7faffe10421f14 = {
    errors: {
        get eventIdNotFound () {
            return (0, $knjAn.t)('error_event_id_not_found');
        },
        get locationUndefined () {
            return (0, $knjAn.t)('error_location_undefined');
        },
        get cancelFailed () {
            return (0, $knjAn.t)('cancel_failed');
        },
        get copyFailed () {
            return (0, $knjAn.t)('error_copy_failed');
        },
        get invalidResponse () {
            return (0, $knjAn.t)('error_invalid_response');
        }
    },
    success: {
        get addressCopied () {
            return (0, $knjAn.t)('address_copied');
        },
        get cancelAppointment () {
            return (0, $knjAn.t)('cancel_success');
        }
    },
    ui: {
        get processing () {
            return (0, $knjAn.t)('processing');
        },
        get cancel () {
            return (0, $knjAn.t)('cancel');
        },
        get cancelled () {
            return (0, $knjAn.t)('cancelled');
        },
        get appointmentCancelled () {
            return (0, $knjAn.t)('appointment_cancelled_title');
        },
        get bookNewAppointment () {
            return (0, $knjAn.t)('book_new_appointment');
        }
    },
    banner: {
        get cancelled () {
            return (0, $knjAn.t)('cancelled_banner_title');
        },
        get cancelledDescription () {
            return (0, $knjAn.t)('cancelled_banner_desc');
        }
    }
};
const $348dfc489fae853c$export$a97e04da196adedd = {
    bookNew: {
        id: 'book-new-appointment-btn',
        className: 'button--no-style book-new-button book-new-button-large',
        get text () {
            return (0, $knjAn.t)('book_new_appointment');
        },
        get loadingText () {
            return (0, $knjAn.t)('processing');
        },
        type: 'button'
    }
};
const $348dfc489fae853c$export$991f3ee37398e50 = {
    REQUEST: 'request',
    CONFIRMED: 'confirmed',
    COMPLETE: 'complete',
    CANCELLED: 'cancelled'
};
const $348dfc489fae853c$export$41f3f4f65e8f1e85 = {
    LEAD: 'App\\Models\\Lead',
    STAFF: 'App\\Models\\Staff'
};
const $348dfc489fae853c$export$3362bec89bce10fd = {
    OK: 200,
    CREATED: 201,
    BAD_REQUEST: 400,
    UNAUTHORIZED: 401,
    NOT_FOUND: 404,
    SERVER_ERROR: 500
};
const $348dfc489fae853c$export$56d196d2844d1ca1 = {
    error: '#e74c3c',
    success: '#11b654',
    cancel: '#e74c3c'
};
const $348dfc489fae853c$export$ff8a87d64aea7482 = {
    defaultToast: 3000,
    buttonReset: 2000
};

});

parcelRegister("ctM9Q", function(module, exports) {

$parcel$export(module.exports, "toastError", () => $915d8c94839cdc75$export$2c5af35fde2282e7);
$parcel$export(module.exports, "toastSuccess", () => $915d8c94839cdc75$export$67c64e47611aa944);

var $knjAn = parcelRequire("knjAn");
let $915d8c94839cdc75$var$timeOut = null;
const $915d8c94839cdc75$var$awaitTimeout = (delay)=>new Promise((resolve)=>$915d8c94839cdc75$var$timeOut = setTimeout(resolve, delay));
function $915d8c94839cdc75$export$2c5af35fde2282e7(message) {
    message = (0, $knjAn.translateServerError)(message);
    clearTimeout($915d8c94839cdc75$var$timeOut);
    let error = document.querySelector('.toast__container.error');
    if (!error) {
        error = document.createElement('div');
        error.className = 'toast__container error';
        error.innerHTML = `
            <span class="close-error">&times;</span>
            <span class="error-msg"></span>
        `;
        document.body.appendChild(error);
        setTimeout(()=>error.classList.add('show'), 10);
    } else error.classList.add('show');
    error.querySelector('.error-msg').textContent = message;
    $915d8c94839cdc75$var$awaitTimeout(5000).then($915d8c94839cdc75$var$closeErrorToast);
    error.querySelector('.close-error').addEventListener('click', $915d8c94839cdc75$var$closeErrorToast);
}
function $915d8c94839cdc75$var$closeErrorToast() {
    const error = document.querySelector('.toast__container.error');
    if (!error) return;
    error.addEventListener('transitionend', ()=>{
        error.querySelector('.error-msg').textContent = '';
    }, {
        once: true
    });
    error.classList.remove('show');
    clearTimeout($915d8c94839cdc75$var$timeOut);
}
function $915d8c94839cdc75$export$67c64e47611aa944(message) {
    clearTimeout($915d8c94839cdc75$var$timeOut);
    let success = document.querySelector('.toast__container.success');
    if (!success) {
        success = document.createElement('div');
        success.className = 'toast__container success';
        success.innerHTML = `
            <span class="close-success">&times;</span>
            <span class="success-msg"></span>
        `;
        document.body.appendChild(success);
        setTimeout(()=>success.classList.add('show'), 10);
    } else success.classList.add('show');
    success.querySelector('.success-msg').textContent = message;
    $915d8c94839cdc75$var$awaitTimeout(5000).then($915d8c94839cdc75$var$closeSuccessToast);
    success.querySelector('.close-success').addEventListener('click', $915d8c94839cdc75$var$closeSuccessToast);
}
function $915d8c94839cdc75$var$closeSuccessToast() {
    const success = document.querySelector('.toast__container.success');
    if (!success) return;
    success.addEventListener('transitionend', ()=>{
        success.querySelector('.success-msg').textContent = '';
    }, {
        once: true
    });
    success.classList.remove('show');
    clearTimeout($915d8c94839cdc75$var$timeOut);
}

});


parcelRegister("hOgIi", function(module, exports) {

$parcel$export(module.exports, "appointmentConfirmedListeners", () => $cf7412262f112b32$export$5ce3aeca5931bad4);

var $knjAn = parcelRequire("knjAn");

var $cEKee = parcelRequire("cEKee");

var $gZEOs = parcelRequire("gZEOs");

var $ctM9Q = parcelRequire("ctM9Q");
function $cf7412262f112b32$export$5ce3aeca5931bad4() {
    $cf7412262f112b32$var$setupActionButtonListeners();
    $cf7412262f112b32$var$setupOutsideClickHandler();
    if ((0, $cEKee.eventRoom) === null) $cf7412262f112b32$var$setupLocationBasedActions();
    else $cf7412262f112b32$var$setupEventRoomActions();
}
function $cf7412262f112b32$var$setupActionButtonListeners() {
    const actionButtons = document.querySelectorAll('.appointment-confirmed__container .action .add-calendar button');
    actionButtons.forEach((element)=>{
        element.addEventListener('click', $cf7412262f112b32$var$toggleActionButtonHandler);
    });
}
function $cf7412262f112b32$var$setupOutsideClickHandler() {
    const container = document.querySelector('.appointment-confirmed__container');
    if (container) container.addEventListener('click', $cf7412262f112b32$var$onClickOutsideDropdown);
}
function $cf7412262f112b32$var$setupLocationBasedActions() {
    const copyAddressBtn = document.getElementById('copy-address-confirmed');
    if (copyAddressBtn) copyAddressBtn.addEventListener('click', $cf7412262f112b32$var$onCopyAddressHandler);
}
function $cf7412262f112b32$var$setupEventRoomActions() {
    const eventRoomBtn = document.querySelector('.event-room button');
    if (eventRoomBtn) eventRoomBtn.addEventListener('click', $cf7412262f112b32$var$handleEventRoomBtn);
}
function $cf7412262f112b32$var$toggleActionButtonHandler(event) {
    event.stopPropagation();
    const isCurrentlyActive = this.classList.contains('action-button--clicked');
    $cf7412262f112b32$var$blurAllActionButtons();
    $cf7412262f112b32$var$closeAllDropdowns();
    if (!isCurrentlyActive) {
        this.classList.add('action-button--clicked');
        const dropdown = this.parentNode.querySelector('.action-dropdown');
        if (dropdown) dropdown.classList.remove('action-dropdown--hidden');
    }
}
function $cf7412262f112b32$var$blurAllActionButtons() {
    const actionButtons = document.querySelectorAll('.appointment-confirmed__container .action .add-calendar button');
    actionButtons.forEach((element)=>{
        element.classList.remove('action-button--clicked');
    });
}
function $cf7412262f112b32$var$closeAllDropdowns() {
    const dropdowns = document.querySelectorAll('.appointment-confirmed__container .action .action-dropdown');
    dropdowns.forEach((element)=>{
        element.classList.add('action-dropdown--hidden');
    });
}
function $cf7412262f112b32$var$onClickOutsideDropdown() {
    $cf7412262f112b32$var$blurAllActionButtons();
    $cf7412262f112b32$var$closeAllDropdowns();
}
async function $cf7412262f112b32$var$onCopyAddressHandler() {
    try {
        const addressEl = document.querySelector('.appointment-confirmed__container .location-address__text');
        const address = addressEl?.textContent?.trim();
        if (!address) {
            const locationObj = (0, $cEKee.locations).find((location)=>location.id === (0, $cEKee.locationId));
            if (!locationObj?.full_address) throw new Error('Error! Location is undefined.');
            await navigator.clipboard.writeText(locationObj.full_address);
        } else await navigator.clipboard.writeText(address);
        (0, $ctM9Q.toastSuccess)((0, $knjAn.t)('address_copied'));
    } catch (error) {
        const errorMessage = error.message || 'Error! Cannot copy to clipboard.';
        (0, $gZEOs.toastError)(errorMessage);
    }
}
async function $cf7412262f112b32$var$handleEventRoomBtn() {
    try {
        const eventRoomURL = (0, $cEKee.eventRoom)?.room_url;
        if (!eventRoomURL || eventRoomURL.length === 0) throw new Error("Event room URL is not available");
        window.open(eventRoomURL, '_blank')?.focus();
    } catch (error) {
        const errorMessage = error.message || "Something wrong with url";
        (0, $gZEOs.toastError)(errorMessage);
    }
}

});

parcelRegister("ebrDl", function(module, exports) {

$parcel$export(module.exports, "appointmentCancelListeners", () => $a5378735ddec5129$export$6441c9fe128def6e);

var $cIxq8 = parcelRequire("cIxq8");

var $er9E0 = parcelRequire("er9E0");
function $a5378735ddec5129$export$6441c9fe128def6e() {
    $a5378735ddec5129$var$setupBookNewAppointmentListener();
}
function $a5378735ddec5129$var$setupBookNewAppointmentListener() {
    const bookNewButton = document.getElementById('book-new-appointment-btn');
    if (bookNewButton) bookNewButton.addEventListener('click', $a5378735ddec5129$var$handleBookNewAppointment);
}
function $a5378735ddec5129$var$handleBookNewAppointment() {
    // Navigate back to the main menu or booking flow
    (0, $er9E0.navigate)((0, $cIxq8.SCREEN).DASHBOARD);
}

});

parcelRegister("gEfFu", function(module, exports) {

$parcel$export(module.exports, "appointmentSummaryListeners", () => $c1ec891ef783b28c$export$ef207e0aecba0f75);

var $knjAn = parcelRequire("knjAn");

var $cNdCr = parcelRequire("cNdCr");

var $cIxq8 = parcelRequire("cIxq8");

var $cEKee = parcelRequire("cEKee");

var $cDpNn = parcelRequire("cDpNn");

var $gZEOs = parcelRequire("gZEOs");

var $hOgIi = parcelRequire("hOgIi");

var $avR5a = parcelRequire("avR5a");

var $er9E0 = parcelRequire("er9E0");
function $c1ec891ef783b28c$export$ef207e0aecba0f75() {
    const btn = document.querySelector('.appointment-summary__continue-btn');
    btn.querySelector('.text').innerHTML = (0, $cEKee.form)?.appointment_channel?.auto_confirmation ? (0, $knjAn.t)('confirm') : (0, $knjAn.t)('request_appointment');
    if (!(0, $cEKee.form)?.appointment_channel?.auto_confirmation) btn.style.width = '60%';
    btn.addEventListener('click', $c1ec891ef783b28c$var$onHandleAppointmentSummaryContinueBtnClickEvent);
    const addressSpan = document.querySelector('.appointment-summary__container .appointment-location .detail-info span:last-child');
    if (addressSpan) addressSpan.addEventListener('click', $c1ec891ef783b28c$var$copyAddressHandler);
}
async function $c1ec891ef783b28c$var$onHandleAppointmentSummaryContinueBtnClickEvent() {
    if ((0, $cEKee.form)?.appointment_channel?.collect_card_on_booking && (0, $cEKee.form)?.stripe_publishable_key) {
        (0, $avR5a.loadCardCollection)();
        return;
    }
    let loaderIcon = document.querySelector('.appointment-summary__continue-btn .loader__icon');
    try {
        document.querySelector('.appointment-summary__continue-btn')?.classList.add('disabled');
        document.querySelector('.appointment-summary__continue-btn .loading__wrapper')?.classList.remove('hidden');
        if (loaderIcon) {
            loaderIcon.innerHTML = '';
            loaderIcon.insertAdjacentHTML('beforeend', `<img src="${(0, $cEKee.appUrl)}/assets/icons/rolling.png" />`);
        }
        let updateEvevntStatusRes = await (0, $cNdCr.updateEvevntStatus)((0, $cEKee.eventId));
        // Slot → intake handoff (see selectTimeActions.js).
        const intakeUrl = updateEvevntStatusRes?.data?.intake_redirect_url;
        if (intakeUrl) {
            window.parent.location.href = intakeUrl;
            return;
        }
        (0, $cEKee.setEventRoom)(updateEvevntStatusRes.data.event_room || null);
        (0, $cEKee.setEventPayload)(updateEvevntStatusRes.data);
        // Always show appointment thank you / event summary (confirmed or request)
        (0, $cDpNn.loadAppointmentConfirmed)();
        (0, $hOgIi.appointmentConfirmedListeners)();
        (0, $er9E0.navigate)((0, $cIxq8.SCREEN).APPOINTMENT_CONFIRMED);
        (0, $er9E0.triggerCalendarRedirectIfConfigured)();
    } catch (error) {
        (0, $gZEOs.toastError)(error.response?.data?.message || "Something went wrong");
    } finally{
        if (loaderIcon) {
            loaderIcon.innerHTML = '';
            loaderIcon.insertAdjacentHTML('beforeend', `<i class="ri-arrow-right-line"></i>`);
        }
        document.querySelector('.appointment-summary__continue-btn .loading__wrapper')?.classList.add('hidden');
        document.querySelector('.appointment-summary__continue-btn')?.classList.remove('disabled');
    }
}
function $c1ec891ef783b28c$var$copyAddressHandler() {
    let selectedLocationObj = (0, $cEKee.locations).find((e)=>e.id === (0, $cEKee.selectedLocation));
    let address = selectedLocationObj?.address1 ? `${selectedLocationObj.address1}, ` : '';
    let city = selectedLocationObj?.city ? `${selectedLocationObj.city}, ` : '';
    let state = selectedLocationObj?.state ? `${selectedLocationObj.state}, ` : '';
    let country = selectedLocationObj?.country ? `${selectedLocationObj.country}` : '';
    navigator.clipboard.writeText(`${address}${city}${state}${country}`);
}

});
parcelRegister("avR5a", function(module, exports) {

$parcel$export(module.exports, "loadCardCollection", () => $7a75f9b0f651abe3$export$f89a0257a61917e);

var $knjAn = parcelRequire("knjAn");

var $cIxq8 = parcelRequire("cIxq8");

var $cEKee = parcelRequire("cEKee");

var $aROBf = parcelRequire("aROBf");

var $fWpof = parcelRequire("fWpof");

var $cNdCr = parcelRequire("cNdCr");

var $cDpNn = parcelRequire("cDpNn");

var $hOgIi = parcelRequire("hOgIi");

var $er9E0 = parcelRequire("er9E0");

var $gZEOs = parcelRequire("gZEOs");
let $7a75f9b0f651abe3$var$stripeInstance = null;
let $7a75f9b0f651abe3$var$elementsInstance = null;
let $7a75f9b0f651abe3$var$cardElement = null;
let $7a75f9b0f651abe3$var$walletElements = null;
let $7a75f9b0f651abe3$var$expressCheckoutElement = null;
let $7a75f9b0f651abe3$var$_cardSubmitListenerAttached = false;
function $7a75f9b0f651abe3$var$loadStripeScript() {
    return new Promise((resolve)=>{
        if (window.Stripe) {
            resolve();
            return;
        }
        const script = document.createElement('script');
        script.src = 'https://js.stripe.com/v3/';
        script.async = true;
        script.onload = ()=>resolve();
        script.onerror = ()=>resolve(); // still resolve so we can show error in UI
        document.head.appendChild(script);
    });
}
function $7a75f9b0f651abe3$var$mountCardElement(publishableKey, stripeAccountId = null) {
    if (!window.Stripe || !publishableKey) return;
    $7a75f9b0f651abe3$var$stripeInstance = stripeAccountId ? window.Stripe(publishableKey, {
        stripeAccount: stripeAccountId
    }) : window.Stripe(publishableKey);
    const elements = $7a75f9b0f651abe3$var$stripeInstance.elements();
    const style = {
        base: {
            fontSize: '16px',
            color: '#1b2e4b',
            '::placeholder': {
                color: '#aab7c4'
            }
        },
        invalid: {
            color: '#fa755a'
        }
    };
    $7a75f9b0f651abe3$var$cardElement = elements.create('card', {
        style: style
    });
    const container = document.getElementById('card-element');
    if (container && container.children.length === 0) $7a75f9b0f651abe3$var$cardElement.mount('#card-element');
    $7a75f9b0f651abe3$var$elementsInstance = elements;
    $7a75f9b0f651abe3$var$mountExpressCheckoutElement();
}
/**
 * Apple Pay / Google Pay, via the Express Checkout Element.
 *
 * Deliberately mounted on its OWN Elements group (deferred `mode: 'setup'`) rather
 * than the group holding the Card Element: confirmSetup({ elements }) confirms the
 * whole group, so sharing one group would entangle the wallet and typed-card paths.
 * This way the existing card flow is untouched — if wallets are unavailable, Stripe
 * simply reports no available payment methods and we leave the block hidden.
 *
 * The SetupIntent the backend creates already uses payment_method_types: ['card'],
 * which covers both wallets — they tokenize into ordinary card PaymentMethods, so
 * nothing changes server-side or in how the saved card is later charged.
 */ function $7a75f9b0f651abe3$var$mountExpressCheckoutElement() {
    const container = document.getElementById('express-checkout-element');
    if (!container || container.children.length > 0) return;
    let elements;
    try {
        elements = $7a75f9b0f651abe3$var$stripeInstance.elements({
            mode: 'setup',
            currency: 'usd',
            paymentMethodTypes: [
                'card'
            ],
            setupFutureUsage: 'off_session'
        });
    } catch (_) {
        // Older stripe.js without deferred-intent support: card form still works.
        return;
    }
    if (typeof elements.create !== 'function') return;
    try {
        $7a75f9b0f651abe3$var$expressCheckoutElement = elements.create('expressCheckout', {
            paymentMethods: {
                applePay: 'auto',
                googlePay: 'auto'
            },
            buttonHeight: 44
        });
    } catch (_) {
        return;
    }
    $7a75f9b0f651abe3$var$walletElements = elements;
    $7a75f9b0f651abe3$var$expressCheckoutElement.on('ready', (event)=>{
        const available = event?.availablePaymentMethods;
        const hasWallet = available && Object.values(available).some(Boolean);
        if (hasWallet) document.querySelector('.card-collection__wallets')?.classList.remove('hidden');
    });
    // A wallet failing must never block the typed-card path, so surface the error
    // in the shared error slot and leave the card form usable.
    $7a75f9b0f651abe3$var$expressCheckoutElement.on('loaderror', ()=>{
        document.querySelector('.card-collection__wallets')?.classList.add('hidden');
    });
    $7a75f9b0f651abe3$var$expressCheckoutElement.on('confirm', async ()=>{
        $7a75f9b0f651abe3$var$showCardError('');
        try {
            const clientSecret = await (0, $cNdCr.createEventPaymentMethodSetupIntent)((0, $cEKee.eventId));
            if (!clientSecret) {
                $7a75f9b0f651abe3$var$showCardError('Could not start card setup. Please try again.');
                return;
            }
            const { setupIntent: setupIntent, error: error } = await $7a75f9b0f651abe3$var$stripeInstance.confirmSetup({
                elements: $7a75f9b0f651abe3$var$walletElements,
                clientSecret: clientSecret,
                // Wallets never redirect, so we get the SetupIntent back inline and
                // can reuse the exact same save + confirm tail as the card path.
                redirect: 'if_required'
            });
            if (error) {
                $7a75f9b0f651abe3$var$showCardError(error.message || 'Payment could not be completed.');
                return;
            }
            const paymentMethodId = setupIntent?.payment_method ?? setupIntent?.paymentMethod;
            if (!paymentMethodId) {
                $7a75f9b0f651abe3$var$showCardError('Could not save payment method. Please try again.');
                return;
            }
            await (0, $cNdCr.saveEventPaymentMethod)((0, $cEKee.eventId), typeof paymentMethodId === 'string' ? paymentMethodId : paymentMethodId.id);
            await $7a75f9b0f651abe3$var$confirmAfterCardSaved();
        } catch (err) {
            $7a75f9b0f651abe3$var$showCardError(err.response?.data?.message || 'Could not complete payment. Please try again.');
        }
    });
    $7a75f9b0f651abe3$var$expressCheckoutElement.mount('#express-checkout-element');
}
function $7a75f9b0f651abe3$var$showCardError(message) {
    const el = document.getElementById('card-errors');
    if (el) {
        el.textContent = message || '';
        el.style.display = message ? 'block' : 'none';
    }
}
async function $7a75f9b0f651abe3$var$confirmAfterCardSaved() {
    const btn = document.querySelector('.card-collection__continue-btn');
    const loadingWrapper = document.querySelector('.card-collection__continue-btn .loading__wrapper');
    try {
        btn?.classList.add('disabled');
        if (loadingWrapper) {
            loadingWrapper.classList.remove('hidden');
            loadingWrapper.innerHTML = '';
            loadingWrapper.insertAdjacentHTML('beforeend', `<img class="loader-spinner" src="${(0, $cEKee.appUrl)}/assets/icons/rolling.png" alt="" />`);
        }
        const updateRes = await (0, $cNdCr.updateEvevntStatus)((0, $cEKee.eventId));
        // Slot → intake handoff (see selectTimeActions.js) — card path included,
        // so a deposit widget with an intake configured hands off the same way.
        const intakeUrl = updateRes?.data?.intake_redirect_url;
        if (intakeUrl) {
            window.parent.location.href = intakeUrl;
            return;
        }
        (0, $cEKee.setEventRoom)(updateRes.data.event_room || null);
        (0, $cEKee.setEventPayload)(updateRes.data);
        // Always show appointment thank you / event summary (confirmed or request)
        (0, $cDpNn.loadAppointmentConfirmed)();
        (0, $hOgIi.appointmentConfirmedListeners)();
        (0, $er9E0.navigate)((0, $cIxq8.SCREEN).APPOINTMENT_CONFIRMED);
        (0, $er9E0.triggerCalendarRedirectIfConfigured)();
    } catch (err) {
        (0, $gZEOs.toastError)(err.response?.data?.message || 'Something went wrong');
    } finally{
        document.querySelector('.card-collection__continue-btn .loading__wrapper')?.classList.add('hidden');
        document.querySelector('.card-collection__continue-btn')?.classList.remove('disabled');
    }
}
/**
 * Compact appointment recap shown above the card form. The card screen is now
 * the step right after slot selection (no separate summary screen in the
 * booking flow), so the patient needs to see what they're confirming here.
 */ function $7a75f9b0f651abe3$var$renderCardCollectionRecap() {
    const recapEl = document.querySelector('.card-collection__recap');
    if (!recapEl) return;
    const event = (0, $cEKee.appointmentSummary)?.event;
    if (!event?.start_time) {
        recapEl.style.display = 'none';
        return;
    }
    const startTime = moment(event.start_time * 1000);
    const staffIds = (0, $cEKee.appointmentSummary).staffs?.map((i)=>i.participable_id) ?? [];
    const staffNames = (0, $cEKee.providers).filter((p)=>staffIds.includes(p.id)).map((p)=>`${p.first_name} ${p.last_name}`).join(', ');
    const selectedProcedures = event.procedures ?? [];
    const isRemote = (0, $fWpof.isVirtualVisit)((0, $cEKee.form), selectedProcedures);
    const locationObj = (0, $cEKee.locations).find((l)=>l.id === event.location_id);
    // Location name only — the street address belongs on the confirmation
    // screen, not the payment step.
    const locationLine = isRemote ? (0, $knjAn.t)((0, $fWpof.remoteVisitLabelKey)(selectedProcedures)) : locationObj?.name || '';
    const serviceNames = selectedProcedures.map((p)=>(0, $aROBf.procedureDisplayName)(p)).filter(Boolean).join(', ');
    const durationMinutes = (0, $cEKee.appointmentDuration)?.duration;
    let durationLabel = '';
    if (durationMinutes) {
        const dur = moment.duration(durationMinutes, 'm');
        durationLabel = dur.minutes() > 0 ? `${dur.format('h[h] m')}min` : dur.format('h[h]');
    }
    const detailRow = (icon, text)=>`
        <div class="recap__row">
            <i class="${icon}"></i>
            <span class="recap__detail">${text}</span>
        </div>`;
    recapEl.style.display = '';
    recapEl.innerHTML = `
        <div class="recap__row recap__row--lead">
            <i class="ri-time-line"></i>
            <div class="recap__col">
                <div class="recap__primary">
                    <span class="recap__time">${startTime.format('hh:mm A')}</span>
                    ${durationLabel ? `<span class="recap__duration">${durationLabel}</span>` : ''}
                </div>
                <div class="recap__detail">${startTime.format('dddd, MMMM D, YYYY')}</div>
            </div>
        </div>
        ${staffNames ? detailRow('ri-user-3-line', staffNames) : ''}
        ${locationLine ? detailRow('ri-map-pin-2-line', locationLine) : ''}
        ${serviceNames ? detailRow('ri-stethoscope-line', serviceNames) : ''}
    `;
    const durationEl = recapEl.querySelector('.recap__duration');
    if (durationEl) {
        durationEl.style.background = `${0, $cEKee.primaryColor}14`;
        durationEl.style.color = (0, $cEKee.primaryColor);
    }
}
function $7a75f9b0f651abe3$export$f89a0257a61917e() {
    $7a75f9b0f651abe3$var$renderCardCollectionRecap();
    (0, $er9E0.navigate)((0, $cIxq8.SCREEN).CARD_COLLECTION);
    $7a75f9b0f651abe3$export$72aafa0861438d55();
}
function $7a75f9b0f651abe3$var$setCardIntroMessage() {
    const introEl = document.querySelector('.card-collection__intro');
    if (!introEl) return;
    const custom = (0, $cEKee.form)?.appointment_channel?.card_collection_message?.trim();
    if (custom) {
        introEl.textContent = custom;
        return;
    }
    const mode = (0, $cEKee.form)?.appointment_channel?.card_collection_mode ?? 'on_file';
    if (mode === 'deposit') {
        const cents = (0, $cEKee.form)?.appointment_channel?.deposit_amount_cents;
        const amount = cents != null && cents >= 50 ? (cents / 100).toFixed(2) : null;
        introEl.textContent = amount != null ? `A deposit of $${amount} will be charged to your card to confirm your appointment.` : 'A deposit will be charged to your card to confirm your appointment.';
    } else introEl.textContent = "Your card will be saved securely on file. It may be charged according to the practice's cancellation policy.";
}
function $7a75f9b0f651abe3$export$72aafa0861438d55() {
    const publishableKey = (0, $cEKee.form)?.stripe_publishable_key;
    if (!publishableKey) {
        $7a75f9b0f651abe3$var$showCardError('Payment is not configured for this practice.');
        return;
    }
    $7a75f9b0f651abe3$var$setCardIntroMessage();
    $7a75f9b0f651abe3$var$loadStripeScript().then(()=>{
        requestAnimationFrame(()=>$7a75f9b0f651abe3$var$mountCardElement(publishableKey, (0, $cEKee.form)?.stripe_account ?? null));
    });
    const errorsEl = document.getElementById('card-errors');
    if (errorsEl) errorsEl.style.display = 'none';
    const submitBtn = document.querySelector('.card-collection__continue-btn');
    if (!submitBtn) return;
    if ($7a75f9b0f651abe3$var$_cardSubmitListenerAttached) return;
    $7a75f9b0f651abe3$var$_cardSubmitListenerAttached = true;
    submitBtn.addEventListener('click', async ()=>{
        if (!$7a75f9b0f651abe3$var$stripeInstance || !$7a75f9b0f651abe3$var$cardElement || !(0, $cEKee.eventId)) {
            $7a75f9b0f651abe3$var$showCardError('Please wait for the form to load.');
            return;
        }
        $7a75f9b0f651abe3$var$showCardError('');
        const loadingWrapper = submitBtn.querySelector('.loading__wrapper');
        try {
            submitBtn.classList.add('disabled');
            if (loadingWrapper) {
                loadingWrapper.classList.remove('hidden');
                loadingWrapper.innerHTML = '';
                loadingWrapper.insertAdjacentHTML('beforeend', `<img class="loader-spinner" src="${(0, $cEKee.appUrl)}/assets/icons/rolling.png" alt="" />`);
            }
            // Use SetupIntent so the PaymentMethod is created in the correct Stripe account
            // (platform or Connect) without needing the connected account's publishable key.
            const clientSecret = await (0, $cNdCr.createEventPaymentMethodSetupIntent)((0, $cEKee.eventId));
            if (!clientSecret) {
                $7a75f9b0f651abe3$var$showCardError('Could not start card setup. Please try again.');
                return;
            }
            const { setupIntent: setupIntent, error: error } = await $7a75f9b0f651abe3$var$stripeInstance.confirmCardSetup(clientSecret, {
                payment_method: {
                    card: $7a75f9b0f651abe3$var$cardElement
                }
            });
            if (error) {
                $7a75f9b0f651abe3$var$showCardError(error.message || 'Card could not be verified.');
                return;
            }
            const paymentMethodId = setupIntent?.payment_method ?? setupIntent?.paymentMethod;
            if (!paymentMethodId) {
                $7a75f9b0f651abe3$var$showCardError('Could not save card. Please try again.');
                return;
            }
            await (0, $cNdCr.saveEventPaymentMethod)((0, $cEKee.eventId), typeof paymentMethodId === 'string' ? paymentMethodId : paymentMethodId.id);
            await $7a75f9b0f651abe3$var$confirmAfterCardSaved();
        } catch (err) {
            const msg = err.response?.data?.message || 'Could not save card or process deposit. Please try again.';
            $7a75f9b0f651abe3$var$showCardError(msg);
        } finally{
            if (loadingWrapper) loadingWrapper.classList.add('hidden');
            submitBtn.classList.remove('disabled');
        }
    });
}

});


parcelRegister("e4miY", function(module, exports) {

$parcel$export(module.exports, "selectTimeListeners", () => $a3e2bdb619dec1c2$export$c5a57777a7fe862c);
$parcel$export(module.exports, "leadMonthCurrent", () => $a3e2bdb619dec1c2$export$2328543952a8aa0c);
$parcel$export(module.exports, "selectOnlyTimeListeners", () => $a3e2bdb619dec1c2$export$d745e440f9974db);

var $knjAn = parcelRequire("knjAn");

var $cIxq8 = parcelRequire("cIxq8");

var $cEKee = parcelRequire("cEKee");

var $1BEhs = parcelRequire("1BEhs");

var $hltT2 = parcelRequire("hltT2");

var $62LVp = parcelRequire("62LVp");

var $alq6e = parcelRequire("alq6e");

var $er9E0 = parcelRequire("er9E0");
function $a3e2bdb619dec1c2$export$c5a57777a7fe862c() {
    const dateLeftBtn = document.querySelector('.date__left');
    const dateRightBtn = document.querySelector('.date__right');
    const dateContainer = document.querySelectorAll('.selectTime-carousel__item');
    const selectTimeItemWidth = document.querySelector('.selectTime__carousel').offsetWidth - document.querySelector('.date__right').offsetWidth * 2;
    const selectTimeCarouselItemButtonsDom = document.querySelectorAll('.selectTime__container .selectTime__wrappers .selectTime__carousel .selectTime-carousel__list .selectTime-carousel__item button');
    document.querySelectorAll('.selectTime__container .selectTime-carousel__item').forEach((element)=>{
        element.style.flexBasis = `${selectTimeItemWidth * 0.2}px`;
    });
    (0, $1BEhs.loadAvailableMonths)();
    let allFirstDayOfMonthIndex = $a3e2bdb619dec1c2$var$findAllIndexFirstDayOfMonth();
    let anchorIndexList = [];
    anchorIndexList.push(0);
    const selectTimeMonthItems = document.querySelectorAll('.selectTime__info--available-month');
    let testIndex = 0;
    let testRs = [];
    while(testIndex < (0, $cEKee.limitRightCarousel)){
        let monthMovement = [];
        (0, $cEKee.appointmentDateRange).monthArr.forEach((monthObj)=>{
            if (monthObj.id === 0) monthMovement.push({
                monthId: monthObj.id,
                pixel: 0,
                isAddAnchor: false
            });
            else {
                let isInViewPort = Math.floor(allFirstDayOfMonthIndex[monthObj.id] / 5) === testIndex;
                let prevPixel = testRs[testIndex - 1] ? testRs[testIndex - 1][monthObj.id]?.pixel || 0 : 0;
                monthMovement.push({
                    monthId: monthObj.id,
                    pixel: !isInViewPort ? prevPixel + selectTimeItemWidth : prevPixel + selectTimeItemWidth * (allFirstDayOfMonthIndex[monthObj.id] % 5 / 5),
                    isAddAnchor: isInViewPort
                });
            }
        });
        testRs.push(monthMovement);
        testIndex++;
    }
    if (dateRightBtn) dateRightBtn.addEventListener('click', ()=>{
        (0, $cEKee.setCarouselCountLeft)((0, $cEKee.carouselCountLeft) + 1);
        if ((0, $cEKee.carouselCountLeft) >= (0, $cEKee.limitRightCarousel)) dateRightBtn.classList.add('date__left-right--disable');
        dateContainer.forEach((element)=>{
            element.style.transform = `translateX(${-selectTimeItemWidth * (0, $cEKee.carouselCountLeft)}px)`;
        });
        selectTimeMonthItems.forEach((element, index)=>{
            if (!anchorIndexList.includes(index)) element.style.transform = `translateX(${-testRs[(0, $cEKee.carouselCountLeft) - 1][index].pixel}px)`;
            if (testRs[(0, $cEKee.carouselCountLeft) - 1][index].isAddAnchor) anchorIndexList.push(index);
        });
        if ((0, $cEKee.carouselCountLeft) > 0) dateLeftBtn.classList.remove('date__left-right--disable');
    });
    if (dateLeftBtn) {
        if ((0, $cEKee.carouselCountLeft) === 0) dateLeftBtn.classList.add('date__left-right--disable');
        dateLeftBtn.addEventListener('click', ()=>{
            if ((0, $cEKee.carouselCountLeft) > 0) {
                dateLeftBtn.classList.remove('date__left-right--disable');
                (0, $cEKee.setCarouselCountLeft)((0, $cEKee.carouselCountLeft) - 1);
                dateContainer.forEach((element)=>{
                    element.style.transform = `translateX(${-selectTimeItemWidth * (0, $cEKee.carouselCountLeft)}px)`;
                });
            }
            if ((0, $cEKee.carouselCountLeft) === 0) dateLeftBtn.classList.add('date__left-right--disable');
            if ((0, $cEKee.carouselCountLeft) <= (0, $cEKee.limitRightCarousel)) dateRightBtn.classList.remove('date__left-right--disable');
            selectTimeMonthItems.forEach((element, index)=>{
                if (testRs[0, $cEKee.carouselCountLeft][index].isAddAnchor) anchorIndexList.pop();
                if (!anchorIndexList.includes(index) && testRs[(0, $cEKee.carouselCountLeft) - 1]) element.style.transform = `translateX(${-testRs[(0, $cEKee.carouselCountLeft) - 1][index].pixel}px)`;
            });
        });
    }
    // Bind click event for carousel item
    if (selectTimeCarouselItemButtonsDom?.length) {
        selectTimeCarouselItemButtonsDom.forEach((element)=>{
            $a3e2bdb619dec1c2$var$handleSelectTime.bind(element);
            element.addEventListener('click', $a3e2bdb619dec1c2$var$handleSelectTime);
            (0, $cEKee.setSelectedDatetime)(null);
        });
        if ((0, $cEKee.procedureIdSelected) && (0, $cEKee.staffId) && !(0, $cEKee.shouldCollectPatientInfoFirstForWidget)) return;
        const firstEnabled = Array.from(selectTimeCarouselItemButtonsDom).find((btn)=>!btn.closest('.selectTime-carousel__item')?.classList.contains('disabled'));
        if (firstEnabled) {
            const unixTime = parseInt(firstEnabled.dataset.datetimeValue);
            if (unixTime) (0, $alq6e.clickDateCarouselItem)(unixTime);
            else firstEnabled.click();
        }
    }
}
const $a3e2bdb619dec1c2$var$convertAbbreviatedMonth = (abbreviatedMonth)=>{
    return moment(abbreviatedMonth, 'MMM').format('MMMM');
};
const $a3e2bdb619dec1c2$export$2328543952a8aa0c = (index)=>{
    const monthTitleElement = document.querySelector('.selectOnlyDate__container .selectOnlyTime__title .selectTime__info');
    const dateContainer = document.querySelectorAll('.selectOnlyDate__container .selectTime-carousel__item-Month');
    if (monthTitleElement && dateContainer[index]) monthTitleElement.innerHTML = $a3e2bdb619dec1c2$var$convertAbbreviatedMonth(dateContainer[index].dataset.month) ?? "";
};
function $a3e2bdb619dec1c2$export$d745e440f9974db() {
    const dateLeftBtn = document.querySelector('.selectOnlyDate__container .date__left');
    const dateRightBtn = document.querySelector('.selectOnlyDate__container .date__right');
    const dateContainer = document.querySelectorAll('.selectOnlyDate__container .selectTime-carousel__item-Month');
    const dateList = document.querySelector('.selectOnlyDate__container .selectOnlyTime-carousel__list');
    const selectTimeItemWidth = document.querySelector('.selectOnlyDate__container .selectTime__carousel')?.offsetWidth || 0;
    const selectTimeCarouselItemButtonsDom = document.querySelectorAll('.selectOnlyDate__container .selectTime-carousel__item button');
    let currentWidth = 0;
    const maxWidth = (dateContainer.length - 1) * selectTimeItemWidth;
    $a3e2bdb619dec1c2$export$2328543952a8aa0c(Math.floor(currentWidth / selectTimeItemWidth) || 0);
    document.querySelector(".selectOnlyDate__container .selectTime__wrappers").style.backgroundColor = "#fff";
    const widthItem = Math.floor((selectTimeItemWidth - 24) / 7) || 0;
    if (widthItem > 0 && widthItem < 44) {
        const dates = document.querySelectorAll(".selectOnlyDate__container .date");
        dates.forEach((date)=>{
            date?.style.setProperty("--width-item", `${widthItem}px`);
        });
    }
    if (dateRightBtn) dateRightBtn.addEventListener('click', ()=>{
        currentWidth = currentWidth + selectTimeItemWidth;
        if (currentWidth >= maxWidth) dateRightBtn.classList.add('date__left-right--disable');
        $a3e2bdb619dec1c2$export$2328543952a8aa0c(Math.floor(currentWidth / selectTimeItemWidth));
        dateList.style.transform = `translateX(-${currentWidth}px)`;
        if (currentWidth > 0) dateLeftBtn.classList.remove('date__left-right--disable');
    });
    if (dateLeftBtn) {
        if (currentWidth === 0) dateLeftBtn.classList.add('date__left-right--disable');
        dateLeftBtn.addEventListener('click', ()=>{
            currentWidth = currentWidth - selectTimeItemWidth;
            if (currentWidth <= 0) dateLeftBtn.classList.add('date__left-right--disable');
            $a3e2bdb619dec1c2$export$2328543952a8aa0c(Math.floor(currentWidth / selectTimeItemWidth));
            dateList.style.transform = `translateX(-${currentWidth}px)`;
            if (currentWidth < maxWidth) dateRightBtn.classList.remove('date__left-right--disable');
        });
    }
    // Bind click event for carousel item
    selectTimeCarouselItemButtonsDom.forEach((element)=>{
        $a3e2bdb619dec1c2$var$handleSelectTime.bind(element);
        element.addEventListener('click', $a3e2bdb619dec1c2$var$handleSelectTime);
        (0, $cEKee.setSelectedDatetime)(null);
    });
    const firstEnabled = Array.from(selectTimeCarouselItemButtonsDom).find((btn)=>{
        const item = btn.closest('.selectTime-carousel__item');
        return item && !item.classList.contains('disabled') && item.style.visibility !== 'hidden' && btn.dataset.datetimeValue;
    });
    if (firstEnabled) {
        // Scroll to the month containing the first available day
        const monthContainer = firstEnabled.closest('.selectTime-carousel__item-Month');
        const monthIndex = Array.from(dateContainer).indexOf(monthContainer);
        if (monthIndex > 0) {
            currentWidth = monthIndex * selectTimeItemWidth;
            dateList.style.transform = `translateX(-${currentWidth}px)`;
            $a3e2bdb619dec1c2$export$2328543952a8aa0c(monthIndex);
            if (currentWidth > 0) dateLeftBtn?.classList.remove('date__left-right--disable');
            if (currentWidth >= maxWidth) dateRightBtn?.classList.add('date__left-right--disable');
        }
        const unixTime = parseInt(firstEnabled.dataset.datetimeValue);
        if (unixTime) {
            // Pre-select the first available date WITHOUT navigating: the caller
            // (renderSelecTime) is about to navigate(SELECT_ONLY_DATE), and letting
            // this programmatic click also navigate(SELECT_ONLY_TIME) makes the two
            // screens race for the top z-index (calendar bleed-through incident,
            // innerbalanceaz.com, 2026-08). The click still loads the slot list so
            // the times screen is pre-populated when the visitor taps the date.
            $a3e2bdb619dec1c2$var$isAutoSelectingDate = true;
            try {
                (0, $alq6e.clickOnlyDateCarouselItem)(unixTime);
            } finally{
                $a3e2bdb619dec1c2$var$isAutoSelectingDate = false;
            }
        }
    }
}
let $a3e2bdb619dec1c2$var$isAutoSelectingDate = false;
function $a3e2bdb619dec1c2$var$handleSelectTime() {
    const item = this.closest('.selectTime-carousel__item');
    if (item?.classList.contains('disabled')) return;
    const isBookAppointmentFlow = (0, $cEKee.appointmentChannelId) || ((0, $cEKee.staffId) && (0, $cEKee.procedureIdSelected) || (0, $cEKee.appointmentChannelId) && (0, $cEKee.form)?.appointment_channel?.procedures?.length > 1 && (0, $cEKee.selectedProcedures)) && !(0, $cEKee.shouldCollectPatientInfoFirstForWidget);
    const className = isBookAppointmentFlow ? '.selectOnlyDate__container .selectTime-carousel__item' : '.selectTime__wrappers .selectTime__carousel .selectTime-carousel__list .selectTime-carousel__item';
    const clickedDatetime = parseInt(this.dataset.datetimeValue);
    if ((0, $cEKee.selectedDatetime) !== clickedDatetime) {
        if (0, $cEKee.selectedDateElement) (0, $cEKee.selectedDateElement)?.classList.remove('date--selected');
        (0, $cEKee.setSelectedDatetime)(clickedDatetime);
    }
    const dateElement = document.querySelector(`${className}  button[data-datetime-value="${this.dataset.datetimeValue}"] .date`);
    dateElement?.classList.add('date--selected');
    (0, $cEKee.setSelectedDateElement)(dateElement);
    (0, $cEKee.setSelectedDatetime)(clickedDatetime);
    (0, $1BEhs.loadAppoimentsList)(clickedDatetime, false);
    if (isBookAppointmentFlow) {
        if (this.dataset.datetimeValue) {
            const formattedDate = moment.unix(this.dataset.datetimeValue).format('dddd, MMMM D');
            document.querySelector('.selectOnlyTime__container .selectOnlyTime__date_selected').innerHTML = `${formattedDate}`;
        } else document.querySelector('.selectOnlyTime__container .selectOnlyTime__date_selected').innerHTML = ``;
        const foundStaff = (0, $cEKee.form)?.staff?.find((staff)=>staff.id === +(0, $cEKee.staffId));
        const foundProcedure = (0, $cEKee.procedures).find((p)=>p?.id === +(0, $cEKee.procedureIdSelected));
        (0, $hltT2.renderStaffInfoHeader)(foundStaff, foundProcedure, 'selectOnlyTime__container');
        document.querySelector('.selectOnlyTime__container .title__content').innerHTML = `${(0, $knjAn.t)('select_time_with')} ${(0, $62LVp.getProviderFullName)()}`;
        if ((0, $cEKee.isDesktopVer) || !(0, $cEKee.isDesktopVer) && (0, $cEKee.initUI) === 'embedded') {
            document?.querySelector('.selectOnlyTime__container .screen__content')?.style.setProperty('--header-height', '0px');
            document.querySelector('.selectOnlyTime__container .title__wrapper').classList.add("hidden");
        }
        if (!(0, $cEKee.isDesktopVer) && (0, $cEKee.initUI) === 'embedded') document?.querySelector('.selectOnlyTime__container .infoStaff')?.style.setProperty('display', 'none');
        if (!$a3e2bdb619dec1c2$var$isAutoSelectingDate) (0, $er9E0.navigate)((0, $cIxq8.SCREEN).SELECT_ONLY_TIME);
        document.querySelector(".selectOnlyTime__list .selectTime__list").innerHTML = "";
        (0, $1BEhs.loadAppoimentsList)(clickedDatetime, true);
    }
}
function $a3e2bdb619dec1c2$var$findAllIndexFirstDayOfMonth() {
    let i = 0;
    let len = (0, $cEKee.appointmentDateRange).dateArr.length;
    let rs = {};
    while(i < len){
        if ((0, $cEKee.appointmentDateRange).dateArr[i].date === 1) rs[(0, $cEKee.appointmentDateRange).dateArr[i].monthId] = i;
        i++;
    }
    return rs;
}

});
parcelRegister("1BEhs", function(module, exports) {

$parcel$export(module.exports, "loadTimeCarousel", () => $12b87e080530aee7$export$8e986bf893a0db45);
$parcel$export(module.exports, "handleEditPhone", () => $12b87e080530aee7$export$1f40bd8510b61ec7);
$parcel$export(module.exports, "loadAppoimentsList", () => $12b87e080530aee7$export$f684622dfc606a61);
$parcel$export(module.exports, "loadAvailableMonths", () => $12b87e080530aee7$export$60f58e618ece9ebc);
$parcel$export(module.exports, "loadOnlyTimeCarousel", () => $12b87e080530aee7$export$15b73f7700533b43);

var $knjAn = parcelRequire("knjAn");

var $cEKee = parcelRequire("cEKee");

var $alq6e = parcelRequire("alq6e");

var $l4e3W = parcelRequire("l4e3W");

var $62LVp = parcelRequire("62LVp");

var $7FCXf = parcelRequire("7FCXf");

var $gsdGr = parcelRequire("gsdGr");

var $er9E0 = parcelRequire("er9E0");

var $cIxq8 = parcelRequire("cIxq8");

var $29QSo = parcelRequire("29QSo");

var $iDiGD = parcelRequire("iDiGD");

var $k3ko8 = parcelRequire("k3ko8");

var $577MR = parcelRequire("577MR");

var $jmDLz = parcelRequire("jmDLz");
/** The clinic's booking timezone (per-location, then channel-level fallback). */ function $12b87e080530aee7$var$clinicTimezone() {
    return (0, $cEKee.form)?.appointment_channel?.location_availabilities?.find((a)=>a.location_id === (0, $cEKee.selectedLocation))?.availability?.timezone || (0, $cEKee.form)?.appointment_channel?.availability_timezone || null;
}
/**
 * Whether a day cell is bookable, honoring the per-location `in_person_dates`
 * allow-list. Mirrors NativeScheduler::locationHoursForDay(): an in-person
 * request is bookable ONLY on allow-listed dates (which may fall outside the
 * weekly template, e.g. a visiting-provider Thursday); remote requests
 * (virtual/phone) keep the weekly template; without mode context, accept the
 * union of both — the server still validates the actual slots.
 * @param {number} unixTime - the cell's timestamp (viewer-local midnight)
 * @param {object|null} locationAvailability - the location_availabilities entry's `availability` JSON
 * @param {object|null} fallbackWeeklyHours - channel-level `availability_hours` fallback
 */ function $12b87e080530aee7$var$dayCellIsAvailable(unixTime, locationAvailability, fallbackWeeklyHours) {
    const daysOfWeekNames = [
        'sunday',
        'monday',
        'tuesday',
        'wednesday',
        'thursday',
        'friday',
        'saturday'
    ];
    const weekly = locationAvailability?.hours ?? fallbackWeeklyHours;
    const dayOfWeek = daysOfWeekNames[new Date(unixTime * 1000).getDay()];
    const weeklyOpen = !weekly || !!(weekly[dayOfWeek] && weekly[dayOfWeek].length > 0);
    const allowlist = locationAvailability?.in_person_dates;
    if (!allowlist || typeof allowlist !== 'object' || Array.isArray(allowlist) || Object.keys(allowlist).length === 0) return weeklyOpen;
    // Match the cell to the allow-list's clinic-local date the same way
    // markDaysWithNoSlotsDisabled does: anchor at midday so viewers far from
    // the clinic don't land on the previous clinic day.
    const tz = locationAvailability?.timezone || (0, $cEKee.form)?.appointment_channel?.availability_timezone || null;
    const middayMs = (unixTime + 43200) * 1000;
    let dateStr;
    try {
        dateStr = tz ? new Date(middayMs).toLocaleDateString('en-CA', {
            timeZone: tz
        }) : moment(middayMs).format('YYYY-MM-DD');
    } catch (_) {
        dateStr = moment(middayMs).format('YYYY-MM-DD');
    }
    const ranges = allowlist[dateStr];
    const dateOpen = Array.isArray(ranges) ? ranges.length > 0 : !!ranges;
    if ((0, $cEKee.selectedDeliveryMode) === 'in_person') return dateOpen;
    if ((0, $cEKee.selectedDeliveryMode) === 'virtual' || (0, $cEKee.selectedDeliveryMode) === 'phone') return weeklyOpen;
    return weeklyOpen || dateOpen;
}
/** Offset (ms) between UTC and `tz` at the given instant. */ function $12b87e080530aee7$var$tzOffsetMs(unixMs, tz) {
    const dtf = new Intl.DateTimeFormat('en-US', {
        timeZone: tz,
        hour12: false,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
    });
    const p = {};
    for (const part of dtf.formatToParts(new Date(unixMs)))p[part.type] = part.value;
    const hour = p.hour === '24' ? 0 : Number(p.hour);
    const asUTC = Date.UTC(Number(p.year), Number(p.month) - 1, Number(p.day), hour, Number(p.minute), Number(p.second));
    return asUTC - unixMs;
}
/**
 * [startUnix, endUnix] for the CLINIC calendar day a carousel cell falls in.
 *
 * A cell's unixTime is the VIEWER's local midnight, so a viewer far from the
 * clinic would otherwise query the wrong clinic day (and could clip late slots).
 * Anchor at midday so the clinic date matches the cell's label, then return that
 * clinic day's UTC bounds. No-op for same-timezone viewers; falls back to the
 * viewer-local day if no clinic timezone is configured.
 */ function $12b87e080530aee7$var$clinicDayBounds(unixTime) {
    const tz = $12b87e080530aee7$var$clinicTimezone();
    const middayMs = (unixTime + 43200) * 1000;
    if (!tz) return [
        moment(middayMs).startOf('day').unix(),
        moment(middayMs).endOf('day').unix()
    ];
    try {
        const dateStr = new Date(middayMs).toLocaleDateString('en-CA', {
            timeZone: tz
        });
        const naive = Date.parse(`${dateStr}T00:00:00Z`);
        let off = $12b87e080530aee7$var$tzOffsetMs(naive, tz);
        let startMs = naive - off;
        off = $12b87e080530aee7$var$tzOffsetMs(startMs, tz); // re-resolve at the corrected instant (DST safety)
        startMs = naive - off;
        const endMs = startMs + 86400000 - 1000;
        return [
            Math.floor(startMs / 1000),
            Math.floor(endMs / 1000)
        ];
    } catch (_) {
        return [
            moment(middayMs).startOf('day').unix(),
            moment(middayMs).endOf('day').unix()
        ];
    }
}
async function $12b87e080530aee7$export$8e986bf893a0db45() {
    (0, $cEKee.setAppointmentDateRange)((0, $alq6e.getAppoitmentsDatetime)());
    (0, $cEKee.appointmentDateRange).dateArr.forEach((item)=>{
        let temp = (0, $cEKee.appointmentDateRange).monthArr.find((month)=>{
            return month.month === item.month && month.year === item.year;
        });
        item.monthId = temp.id;
    });
    (0, $cEKee.setLimitRightCarousel)(Math.floor((0, $cEKee.appointmentDateRange).dateArr.length / 5));
    const carouselWrapper = document.querySelector('.selectTime-carousel__list');
    carouselWrapper.innerHTML = '';
    const locationAvails = (0, $cEKee.form)?.appointment_channel?.location_availabilities;
    const locationAvailability = locationAvails?.find((a)=>a.location_id === (0, $cEKee.selectedLocation))?.availability ?? null;
    let i = 0;
    let len = (0, $cEKee.appointmentDateRange).dateArr.length;
    let innerHTMLContentArr = [];
    while(i < len){
        const disabledClass = $12b87e080530aee7$var$dayCellIsAvailable((0, $cEKee.appointmentDateRange).dateArr[i].unixTime, locationAvailability, (0, $cEKee.form)?.appointment_channel?.availability_hours) ? '' : 'disabled';
        innerHTMLContentArr.push(`
            <div class="selectTime-carousel__item ${disabledClass}">
                <button class="button--no-style" data-datetime-value="${(0, $cEKee.appointmentDateRange).dateArr[i].unixTime}">
                    <div class="date" style="background-color: ${(0, $cEKee.primaryColor)}0f;"><span>${(0, $cEKee.appointmentDateRange).dateArr[i].date}</span></div>
                    <div class="day"><span>${(0, $cEKee.appointmentDateRange).dateArr[i].day}</span></div>
                </button>
            </div>
        `);
        i++;
    }
    carouselWrapper.insertAdjacentHTML('beforeend', innerHTMLContentArr.join(''));
    await $12b87e080530aee7$var$markDaysWithNoSlotsDisabled('.selectTime__container');
}
/**
 * Generation counter for the fully-booked sweep. Bumped on every render so a
 * background month chunk from a previous provider/service selection can't
 * disable days on the current carousel (`getFullyBookedDays` is the one slots
 * call with no axios cancel token).
 */ let $12b87e080530aee7$var$fullyBookedRunId = 0;
/** Split the carousel's day cells into calendar-month chunks. */ function $12b87e080530aee7$var$chunkDaysByMonth(days) {
    const chunks = [];
    let current = null;
    days.forEach((day)=>{
        if (!current || current.month !== day.month || current.year !== day.year) {
            current = {
                month: day.month,
                year: day.year,
                days: []
            };
            chunks.push(current);
        }
        current.days.push(day);
    });
    return chunks;
}
/**
 * Mark day circles as disabled when they have no slots (fully-booked-days API).
 *
 * The server computes this day-by-day with no cache, so asking for the whole
 * carousel at once cost ~0.09s/day (16s+ on a 150-day horizon) and blocked the
 * calendar render. Fetch one calendar month at a time instead: await only the
 * first month so the grid paints immediately, then fill in the later months in
 * the background as their responses land.
 * @param {string} containerSelector - e.g. '.selectTime__container' or '.selectOnlyDate__container'
 */ async function $12b87e080530aee7$var$markDaysWithNoSlotsDisabled(containerSelector) {
    if (!(0, $cEKee.form)?.appointment_channel?.id) return;
    const daysToCheck = (0, $cEKee.appointmentDateRange).dateArr;
    if (daysToCheck.length === 0) return;
    const runId = ++$12b87e080530aee7$var$fullyBookedRunId;
    const listAddons = (0, $cEKee.selectedAddons).map((addon)=>`procedure_addon_ids[]=${addon.id}`);
    const procedureIds = $12b87e080530aee7$var$resolveProcedureIdsForNextSlot();
    const listProcedure = procedureIds.map((id)=>`procedure_ids[]=${id}`);
    const baseParams = {
        procedure_ids: listProcedure?.join('&') || [],
        location_id: (0, $cEKee.selectedLocation),
        ...(0, $cEKee.selectedAddons).length > 0 && {
            procedure_addon_ids: listAddons.join('&')
        },
        staff_id: $12b87e080530aee7$var$getStaffIdForHostType()
    };
    const chunks = $12b87e080530aee7$var$chunkDaysByMonth(daysToCheck);
    async function fetchAndMarkChunk(chunk) {
        // Clinic-day bounds so the range fully covers every clinic day in the
        // chunk, regardless of the viewer's timezone.
        const startTime = $12b87e080530aee7$var$clinicDayBounds(chunk.days[0].unixTime)[0];
        const endTime = $12b87e080530aee7$var$clinicDayBounds(chunk.days[chunk.days.length - 1].unixTime)[1];
        let data;
        try {
            data = await (0, $7FCXf.getFullyBookedDays)((0, $cEKee.form).appointment_channel.id, {
                ...baseParams,
                start_time: startTime,
                end_time: endTime
            });
        } catch (_) {
            return;
        }
        if (runId !== $12b87e080530aee7$var$fullyBookedRunId) return; // superseded by a newer render
        $12b87e080530aee7$var$applyFullyBookedMarks(containerSelector, data?.fully_booked_days || [], data?.timezone || null);
    }
    // First month blocks the render; the rest stream in without holding the UI.
    await fetchAndMarkChunk(chunks[0]);
    (async ()=>{
        for(let i = 1; i < chunks.length; i++){
            if (runId !== $12b87e080530aee7$var$fullyBookedRunId) return;
            await fetchAndMarkChunk(chunks[i]);
        }
    })();
}
/** Disable the day cells whose clinic-tz date is in `fullyBookedDates`. */ function $12b87e080530aee7$var$applyFullyBookedMarks(containerSelector, fullyBookedDates, apiTimezone) {
    if (!fullyBookedDates.length) return;
    const root = document.querySelector(containerSelector);
    if (!root) return;
    // Use the same timezone the API used so our date strings match exactly
    const tzForMatch = apiTimezone || (0, $cEKee.form)?.appointment_channel?.location_availabilities?.find((a)=>a.location_id === (0, $cEKee.selectedLocation))?.availability?.timezone || (0, $cEKee.form)?.appointment_channel?.availability_timezone || null;
    function dateStrForUnix(unixTime) {
        // Carousel cells are built at the VIEWER's local midnight. Converting
        // midnight to the clinic timezone lands on the PREVIOUS clinic day for
        // viewers far east of the clinic (e.g. Europe), which shifted the
        // fully-booked-day marking by one day vs the cell's displayed date.
        // Anchor at midday (+12h) so the clinic-tz date always matches the
        // cell's label regardless of the viewer's timezone.
        const middayMs = (unixTime + 43200) * 1000;
        if (tzForMatch) try {
            return new Date(middayMs).toLocaleDateString('en-CA', {
                timeZone: tzForMatch
            });
        } catch (_) {
            return moment(middayMs).format('YYYY-MM-DD');
        }
        return moment(middayMs).format('YYYY-MM-DD');
    }
    const fullyBookedSet = new Set(fullyBookedDates);
    // Find every day button in the container and disable if its date (in API TZ) is fully booked
    root.querySelectorAll('.selectTime-carousel__item button[data-datetime-value]').forEach((btn)=>{
        const raw = btn.getAttribute('data-datetime-value');
        const unixTime = raw === null || raw === '' ? null : parseInt(raw, 10);
        if (Number.isNaN(unixTime)) return;
        const dateStr = dateStrForUnix(unixTime);
        if (!fullyBookedSet.has(dateStr)) return;
        const item = btn.closest('.selectTime-carousel__item');
        if (item) item.classList.add('disabled');
    });
}
function $12b87e080530aee7$var$clearOTPState() {
    (0, $577MR.clearOTPTimer)();
    const otpInputs = document.querySelectorAll('.validateDigits__wrapper--input-field');
    otpInputs.forEach((input)=>{
        input.value = '';
    });
}
async function $12b87e080530aee7$export$1f40bd8510b61ec7() {
    $12b87e080530aee7$var$clearOTPState();
    const { is_phone_otp_enabled: is_phone_otp_enabled } = (0, $cEKee.form) || {};
    if (is_phone_otp_enabled && (0, $cEKee.isBookAppointment)) {
        (0, $er9E0.navigate)((0, $cIxq8.SCREEN).REQUEST_CONSULT);
        return;
    }
    (0, $gsdGr.newPhoneUI)();
    await (0, $er9E0.navigate)((0, $cIxq8.SCREEN).PHONE);
    (0, $29QSo.phoneListeners)();
    if ((0, $er9E0.params)('mobile')) (0, $er9E0.doFoCus)(document.querySelector('.phone__container .phone--input'));
    else setTimeout(()=>{
        document.querySelector('.phone__container .phone--input').focus();
    }, 400);
}
function $12b87e080530aee7$var$getStaffIdForHostType() {
    const hostType = (0, $cEKee.form)?.appointment_channel?.host;
    if (hostType === 'round_robin' || hostType === 'collective') return null;
    // "Any Provider" mode: fetch merged slots across all providers
    if ((0, $cEKee.providerId) === -1) return null;
    const selectedProviderId = (0, $cEKee.providerId) || (0, $cEKee.staffId);
    const staff = (0, $cEKee.providers).find((provider)=>provider.id === selectedProviderId);
    return staff?.id;
}
/**
 * Resolve procedure IDs for the next-available-slot API when the channel has a single or preselected procedure.
 * API requires procedures; use selectedProcedures, then procedureIdSelected, then channel procedures.
 */ function $12b87e080530aee7$var$resolveProcedureIdsForNextSlot() {
    if ((0, $cEKee.selectedProcedures)?.length > 0) return 0, $cEKee.selectedProcedures;
    if (0, $cEKee.procedureIdSelected) return [
        (0, $cEKee.procedureIdSelected)
    ];
    const channelProcedures = (0, $cEKee.form)?.appointment_channel?.procedures;
    if (channelProcedures?.length === 1) return [
        channelProcedures[0].id
    ];
    if ((0, $cEKee.proceduresOfAppointmentChannel)?.length > 0) return (0, $cEKee.proceduresOfAppointmentChannel).map((p)=>p.id);
    if (channelProcedures?.length > 0) return channelProcedures.map((p)=>p.id);
    return [];
}
async function $12b87e080530aee7$export$f684622dfc606a61(selectedUnixDatetime, isSpitPage = false) {
    document.querySelector(`${isSpitPage ? ".selectOnlyTime__container" : ''} .appointment-list-loading-screen`)?.classList.remove('hidden');
    let listAddons = (0, $cEKee.selectedAddons).map((addon)=>{
        return `procedure_addon_ids[]=${addon.id}`;
    });
    const listProcedure = ((0, $cEKee.selectedProcedures) || [])?.map((procedure)=>`procedure_ids[]=${procedure}`);
    try {
        let availableAppointments = [];
        $12b87e080530aee7$var$cancelRequest();
        const provider = (0, $cEKee.providers).find((i)=>i.id === (0, $cEKee.providerId));
        // Query the CLINIC's calendar day for this cell, not the viewer's local
        // day — so far-away viewers fetch the correct day's full slot range.
        const [slotWindowStart, slotWindowEnd] = $12b87e080530aee7$var$clinicDayBounds(selectedUnixDatetime);
        let res = await (0, $7FCXf.getTimeSlots)({
            id: (0, $cEKee.form).appointment_channel.id,
            start_time: slotWindowStart,
            end_time: slotWindowEnd,
            procedure_ids: listProcedure?.join('&') || [],
            location_id: (0, $cEKee.selectedLocation),
            ...(0, $cEKee.selectedAddons).length > 0 && {
                procedure_addon_ids: listAddons.join('&')
            },
            staff_id: $12b87e080530aee7$var$getStaffIdForHostType()
        });
        (0, $cEKee.setDataSlot)(res);
        availableAppointments = res.data.slots;
        let innerHTMLContentArr = [];
        let innerHTMLContentStr = '';
        let selectTimeContainer = document.querySelector(`${isSpitPage ? ".selectOnlyTime__container" : '.selectTime__container'} .selectTime__list`);
        selectTimeContainer.innerHTML = '';
        if (!availableAppointments || availableAppointments.length === 0) {
            let nextAvailableAppointmentRes = [];
            try {
                const procedureIdsForNext = $12b87e080530aee7$var$resolveProcedureIdsForNextSlot();
                const proceduresParam = procedureIdsForNext.length ? procedureIdsForNext.map((id)=>`procedures[]=${id}`).join('&') : '';
                nextAvailableAppointmentRes = await (0, $7FCXf.getNextAvailableSlot)((0, $cEKee.form).appointment_channel.id, {
                    procedures: proceduresParam,
                    ...(0, $cEKee.selectedAddons).length > 0 && {
                        procedure_addon_ids: listAddons.join('&')
                    },
                    location_id: (0, $cEKee.selectedLocation),
                    staff_id: $12b87e080530aee7$var$getStaffIdForHostType()
                });
            } catch (error) {
            //
            }
            let nextAvailableAppointmentData = nextAvailableAppointmentRes?.data;
            if (!nextAvailableAppointmentData) {
                innerHTMLContentStr = `
                <div class="selectTime__item--empty">
                    <div class="selectTime__calender-icon" style="background-color: ${0, $cEKee.primaryColor}0f;">
                        <i data-feather="calendar"></i>
                    </div>
                    <div class="selectTime__content--empty">
                        <div class="selectTime__title--empty">
                            <span>${(0, $62LVp.getProviderFullName)()}</span> ${(0, $knjAn.t)('all_booked').replace('{provider}', '')}
                        </div>
                    </div>
                    </div>
                `;
                if (selectTimeContainer) selectTimeContainer.style.background = "#fff";
                selectTimeContainer.insertAdjacentHTML('beforeend', innerHTMLContentStr);
                feather.replace();
                document.querySelector(`${isSpitPage ? ".selectOnlyTime__container" : ''}` + ' .appointment-list-loading-screen')?.classList.add('hidden');
                return;
            }
            innerHTMLContentStr = `
                <div class="selectTime__item--empty">
                    <div class="selectTime__calender-icon" style="background-color: ${0, $cEKee.primaryColor}0f;">
                        <i data-feather="calendar"></i>
                    </div>
                    <div class="selectTime__content--empty">
                        <div class="selectTime__title--empty">
                            <span>${(0, $62LVp.getProviderFullName)()}</span> ${(0, $knjAn.t)('all_booked').replace('{provider}', '')}
                        </div>
                        <div class="selectTime__subtitle--empty">
                            ${(0, $knjAn.t)('choose_another_day')}
                        </div>
                    </div>
                    <button class="selectTime__button-next-appointment button--no-style">
                        ${(0, $knjAn.t)('next_available').replace('{date}', moment(nextAvailableAppointmentData.start * 1000).format('MMMM Do'))}
                    </button>
                </div>
            `;
            if (selectTimeContainer) selectTimeContainer.style.background = "#fff";
            selectTimeContainer.insertAdjacentHTML('beforeend', innerHTMLContentStr);
            document.querySelector(`${isSpitPage ? ".selectOnlyTime__container" : ''}` + ' .selectTime__button-next-appointment').addEventListener('click', ()=>{
                if (0, $cEKee.appointmentChannelId) (0, $alq6e.clickOnlyDateCarouselItem)(nextAvailableAppointmentData.start);
                else (0, $alq6e.clickDateCarouselItem)(nextAvailableAppointmentData.start);
            }, {
                once: true
            });
            document.querySelector(`${isSpitPage ? ".selectOnlyTime__container" : ''}` + ' .appointment-list-loading-screen')?.classList.add('hidden');
        } else {
            let i = 0, len = availableAppointments.length;
            while(i < len){
                innerHTMLContentArr.push(`
                    <div class="selectTime__item w-100 d-flex" data-time-value="${availableAppointments[i].start}/${availableAppointments[i].end}" data-staff-id="${availableAppointments[i]?.assigned_staff_id}">
                        <div class="selectTime__icon-time-wrapper d-flex">
                            <div class="selectTime__clock-icon" style="background-color:${(0, $cEKee.primaryColor)}0f;">
                                <i data-feather="clock"></i>
                            </div>
                            <div class="selectTime__time">
                            ${(()=>{
                    try {
                        return moment(availableAppointments[i].start * 1000).format('hh:mm A');
                    } catch (error) {
                        return (0, $knjAn.t)('time_unavailable');
                    }
                })()}
                            </div>
                        </div>
                        <div class="selectTime__right-arrow" data-selected-time="${availableAppointments[i].start}">
                            <i data-feather="arrow-right"></i>
                        </div>
                        <div class="selectTime__spinner hidden">
                            <svg width="24" height="24" stroke="${(0, $cEKee.primaryColor)}" data-loading="lazy" data-src="assets/icons/loading-spinner.svg"></svg>
                        </div>
                    </div>
                `);
                i++;
            }
            innerHTMLContentStr = innerHTMLContentArr.join('');
            selectTimeContainer.insertAdjacentHTML('beforeend', innerHTMLContentStr);
            if (selectTimeContainer) // The split times screen must stay opaque: screens are stacked, never
            // hidden, so a transparent list here lets the calendar screen's date
            // grid show through the gaps between slot rows if z-order ever slips.
            // #f4f4f4 matches the wrappers' background, so it looks identical.
            selectTimeContainer.style.background = isSpitPage ? "#f4f4f4" : "unset";
            // Bind click event to items
            document.querySelectorAll(`${isSpitPage ? ".selectOnlyTime__container" : '.selectTime__list'} .selectTime__item`).forEach((element)=>{
                element.addEventListener('click', async ()=>{
                    if (0, $cEKee.visitorId) (0, $iDiGD.updateVisitorAction)((0, $cEKee.visitorId), 'selected-timeslot', {
                        timeslot: element.dataset.timeValue,
                        ...(0, $cEKee.locationId) && {
                            location_id: (0, $cEKee.locationId)
                        }
                    }).catch((error)=>{
                        console.error('Failed to track timeslot selection:', error);
                    });
                    if (0, $cEKee.isBookAppointment) {
                        (0, $cEKee.setSelectedAppointmentUnixTime)(element.dataset.timeValue);
                        (0, $cEKee.setAssignedStaffId)(element?.dataset?.staffId || null);
                        (0, $cEKee.setLocationId)((0, $cEKee.locationId));
                        const collect_patient_information_first_before_scheduling = (0, $cEKee.form)?.appointment_channel?.collect_patient_information_first_before_scheduling;
                        const shouldCollectPatientInfoFirstForWidget = (0, $cEKee.leadInfo) && (0, $cEKee.leadInfo).phone && collect_patient_information_first_before_scheduling && (0, $cEKee.appointmentChannelId);
                        if (shouldCollectPatientInfoFirstForWidget) {
                            const { is_phone_otp_enabled: is_phone_otp_enabled } = (0, $cEKee.form) || {};
                            if (!is_phone_otp_enabled && (0, $cEKee.form)?.appointment_channel?.id) {
                                (0, $alq6e.loadSpinnerIcon)();
                                try {
                                    const validPhone = (0, $k3ko8.parsePhoneNumberFromString)((0, $cEKee.leadInfo).phone, (0, $cEKee.leadInfo)?.country || 'US');
                                    const bookingTokenResponse = await (0, $jmDLz.createBookingToken)((0, $cEKee.form).appointment_channel.id, {
                                        phone: validPhone.number,
                                        ...(0, $cEKee.visitorId) && {
                                            visitor_id: (0, $cEKee.visitorId)
                                        }
                                    });
                                    if (bookingTokenResponse?.data?.access_token) (0, $cEKee.setAccessToken)(bookingTokenResponse.data.access_token);
                                    const lead = bookingTokenResponse?.data?.lead;
                                    if (lead) {
                                        (0, $cEKee.setLeadInfo)(lead);
                                        if (lead?.text_id) (0, $cEKee.setLeadTextId)(lead.text_id);
                                    }
                                } catch (error) {
                                    console.error('Failed to create booking token:', error);
                                } finally{
                                    (0, $alq6e.loadSpinnerIcon)(false);
                                }
                                await (0, $alq6e.appointmentItemsClickEventHandler)(element.dataset.timeValue, null);
                                return;
                            }
                            if (0, $cEKee.otpAccessToken) {
                                (0, $cEKee.setAccessToken)((0, $cEKee.otpAccessToken));
                                await (0, $alq6e.appointmentItemsClickEventHandler)(element.dataset.timeValue, null);
                                return;
                            }
                            (0, $cEKee.setPhone)((0, $cEKee.leadInfo).phone);
                            (0, $cEKee.setSelectedCountry)((0, $cEKee.leadInfo)?.country || 'US');
                            (0, $alq6e.loadSpinnerIcon)();
                            const validPhone = (0, $k3ko8.parsePhoneNumberFromString)((0, $cEKee.leadInfo).phone, (0, $cEKee.leadInfo)?.country || 'US');
                            if (0, $cEKee.visitorId) (0, $iDiGD.updateVisitorAction)((0, $cEKee.visitorId), '2fa-number-input', {
                                phone: validPhone.number
                            }).catch((error)=>{
                                console.error('Failed to track phone input:', error);
                            });
                            if (0, $cEKee.isOTPTimeOut) {
                                (0, $alq6e.loadSpinnerIcon)();
                                await (0, $577MR.sendOTPCodeWithTimer)();
                            }
                            document.getElementById('validateDigits0').focus();
                            (0, $er9E0.navigate)((0, $cIxq8.SCREEN).VALIDATE_DIGITS);
                            const phoneNumObj = (0, $k3ko8.parsePhoneNumberFromString)((0, $cEKee.leadInfo).phone, 'US');
                            (0, $alq6e.loadSpinnerIcon)(false);
                            if (document.querySelector('.validateDigits--sub-title strong')) document.querySelector('.validateDigits--sub-title strong').innerHTML = phoneNumObj.number;
                            if (0, $cEKee.isFlowForCalendar) {
                                const editPhoneBtn = document.querySelector('.edit-phone-btn');
                                if (editPhoneBtn) {
                                    editPhoneBtn.style.display = 'inline';
                                    editPhoneBtn.addEventListener('click', $12b87e080530aee7$export$1f40bd8510b61ec7);
                                }
                            }
                            (0, $alq6e.loadSpinnerIcon)(false);
                            return;
                        }
                        (0, $gsdGr.newPhoneUI)();
                        await (0, $er9E0.navigate)((0, $cIxq8.SCREEN).PHONE);
                        if ((0, $er9E0.params)('mobile')) (0, $er9E0.doFoCus)(document.querySelector('.phone__container .phone--input'));
                        else setTimeout(()=>{
                            document.querySelector('.phone__container .phone--input').focus();
                        }, 400);
                    } else await (0, $alq6e.appointmentItemsClickEventHandler)(element.dataset.timeValue, null);
                });
            });
            document.querySelector(`${isSpitPage ? ".selectOnlyTime__container" : ''}` + ' .appointment-list-loading-screen')?.classList.add('hidden');
        }
        // eslint-disable-next-line no-undef
        feather.replace();
    } catch (error) {
        const isMissingProcedureIds = error?.response?.data?.message?.includes('procedure ids');
        const isLoading = document.querySelector(`${isSpitPage ? ".selectOnlyTime__container" : ''}` + ' .appointment-list-loading-screen')?.classList.contains('hidden');
        if (!isLoading && !isMissingProcedureIds) return;
        let innerHTMLContentStr = `
                <div class="selectTime__item--empty">
                    <div class="selectTime__calender-icon" style="background-color: ${(0, $cEKee.primaryColor)}0f;">
                        <i data-feather="calendar"></i>
                    </div>
                    <div class="selectTime__content--empty">
                        <div class="selectTime__title--empty">
                            <span>${(0, $62LVp.getProviderFullName)()}</span> ${(0, $knjAn.t)('all_booked').replace('{provider}', '')}
                        </div>
                        <div class="selectTime__subtitle--empty">
                            ${(0, $knjAn.t)('choose_another_day')}
                        </div>
                    </div>
                </div>
            `;
        let selectTimeContainer = document.querySelector(`${isSpitPage ? ".selectOnlyTime__container" : '.selectTime__container'} .selectTime__list`);
        selectTimeContainer.innerHTML = '';
        if (selectTimeContainer) selectTimeContainer.style.background = "#fff";
        selectTimeContainer.insertAdjacentHTML('beforeend', innerHTMLContentStr);
        feather.replace();
        document.querySelector(`${isSpitPage ? ".selectOnlyTime__container" : ''}` + ' .appointment-list-loading-screen')?.classList.add('hidden');
    }
}
async function $12b87e080530aee7$export$60f58e618ece9ebc() {
    let availableMonthItemsDom = document.querySelector('.selectTime__info');
    availableMonthItemsDom.innerHTML = '';
    let i = 0;
    let len = (0, $cEKee.appointmentDateRange).monthArr.length;
    let htmlContentArr = [];
    let selectTimeCarouselItemWidth = document.querySelector('.selectTime-carousel__item').getBoundingClientRect().width;
    // Check which carousel items are disabled so we can hide month labels
    // for months where every day is disabled
    const allCarouselItems = document.querySelectorAll('.selectTime__container .selectTime-carousel__list .selectTime-carousel__item');
    let dateIndex = 0;
    while(i < len){
        const monthDateCount = (0, $cEKee.appointmentDateRange).monthArr[i].dateCount;
        // Check if all days in this month are disabled
        let allDisabled = true;
        for(let j = dateIndex; j < dateIndex + monthDateCount && j < allCarouselItems.length; j++)if (!allCarouselItems[j].classList.contains('disabled')) {
            allDisabled = false;
            break;
        }
        const monthLabel = allDisabled ? '' : (0, $l4e3W.convertMonthFormat)((0, $cEKee.appointmentDateRange).monthArr[i].month, 'long');
        htmlContentArr.push(`<div class="selectTime__info--available-month" style="flex-basis: ${selectTimeCarouselItemWidth * monthDateCount}px">
                ${monthLabel}
            </div>`);
        dateIndex += monthDateCount;
        i++;
    }
    availableMonthItemsDom.insertAdjacentHTML('beforeend', htmlContentArr.join(''));
}
async function $12b87e080530aee7$export$f7b6b8e934ed9719(selectedUnixDatetime) {
    $12b87e080530aee7$export$f684622dfc606a61(selectedUnixDatetime);
    $12b87e080530aee7$export$8e986bf893a0db45();
}
function $12b87e080530aee7$var$cancelRequest() {
    try {
        if ((0, $cEKee.requestsGetSlotsTime)?.length > 0) {
            (0, $cEKee.requestsGetSlotsTime).forEach((item)=>{
                item.cancel && item.cancel();
            });
            (0, $cEKee.setRequestsGetSlotsTime)([]);
        }
        if ((0, $cEKee.nextRequestsGetSlotsTime)?.length > 0) {
            (0, $cEKee.nextRequestsGetSlotsTime).forEach((item)=>{
                item.cancel && item.cancel();
            });
            (0, $cEKee.setNextRequestsGetSlotsTime)([]);
        }
    } catch (error) {
        console.error('Error cancelling requests:', error);
    }
}
const $12b87e080530aee7$var$renderTitleDayOfWeek = ()=>{
    const arrDayOfWeek = [
        'Mon',
        'Tue',
        'Wed',
        'Thu',
        'Fri',
        'Sat',
        'Sun'
    ];
    const innerHTMLContentArr = arrDayOfWeek.map((week)=>{
        return `
        <div class="selectTime-carousel__item">
           <span>${week}</span>
        </div>
        `;
    });
    return innerHTMLContentArr.join('');
};
async function $12b87e080530aee7$export$15b73f7700533b43() {
    (0, $cEKee.setAppointmentDateRange)((0, $alq6e.getAppoitmentsDatetime)());
    (0, $cEKee.appointmentDateRange).dateArr.forEach((item)=>{
        let temp = (0, $cEKee.appointmentDateRange).monthArr.find((month)=>{
            return month.month === item.month && month.year === item.year;
        });
        item.monthId = temp.id;
    });
    (0, $cEKee.setLimitRightCarousel)(Math.floor((0, $cEKee.appointmentDateRange).dateArr.length / 7));
    const carouselWrapper = document.querySelector('.selectOnlyDate__container  .selectOnlyTime-carousel__list');
    carouselWrapper.innerHTML = '';
    const weekTitle = document.querySelector('.selectOnlyDate__container  .selectTime__list-title');
    let indexMonth = 0;
    let lenMonth = (0, $cEKee.appointmentDateRange).monthArr.length;
    let innerHTMLContentArrMonth = [];
    if (weekTitle) weekTitle.innerHTML = "";
    weekTitle.insertAdjacentHTML('beforeend', `
        <div class="selectTime-carousel__item-week">
            <div class="list-title-header">
            ${$12b87e080530aee7$var$renderTitleDayOfWeek()}
            </div>
        </div>
        `);
    while(indexMonth < lenMonth){
        innerHTMLContentArrMonth.push(`
            <div class="selectTime-carousel__item-Month" data-month=${(0, $cEKee.appointmentDateRange).monthArr[indexMonth].month}>
                <div class="selectTime__info--available-month">
                ${$12b87e080530aee7$var$renderDayOfMonth((0, $cEKee.appointmentDateRange).monthArr[indexMonth])}
                </div>
            </div>
        `);
        indexMonth++;
    }
    carouselWrapper.insertAdjacentHTML('beforeend', innerHTMLContentArrMonth.join(''));
    await $12b87e080530aee7$var$markDaysWithNoSlotsDisabled('.selectOnlyDate__container');
}
const $12b87e080530aee7$var$renderDayOfMonth = (monthCurrent)=>{
    // Filter appointment dates for the current month and year
    const filteredDates = (0, $cEKee.appointmentDateRange).dateArr.filter((item)=>item.month === monthCurrent.month && item.year === monthCurrent.year);
    // Split filtered dates into weeks
    const weeks = [];
    let currentWeek = [];
    filteredDates.forEach((date)=>{
        if (date.day === "Mon" && currentWeek.length > 0) {
            weeks.push(currentWeek);
            currentWeek = [];
        }
        currentWeek.push(date);
    });
    if (currentWeek.length > 0) weeks.push(currentWeek);
    const currentUnixTime = moment().startOf('day').unix();
    const location_availabilities = (0, $cEKee.form)?.appointment_channel?.location_availabilities;
    const location_availability = location_availabilities?.find((a)=>a.location_id === (0, $cEKee.selectedLocation))?.availability ?? null;
    // Generate HTML content for each week
    const innerHTMLContentArr = weeks.map((week)=>{
        const temp = [];
        week.forEach((day)=>{
            const isLessThanCurrent = day.unixTime < currentUnixTime;
            const availabilityClass = $12b87e080530aee7$var$dayCellIsAvailable(day.unixTime, location_availability, (0, $cEKee.form)?.appointment_channel?.availability_hours) ? '' : 'disabled';
            if (week[0].day !== "Mon" && week.length !== 7 && week[week.length - 1].day === "Sun" && temp.length === 0) temp.push(...Array(7 - week.length).fill(`
                    <div class="selectTime-carousel__item" style="visibility: hidden;">
                        <button class="button--no-style">
                            <div class="date" ><span></span></div>
                            <div class="day"><span></span></div>
                        </button>
                    </div>
                    `));
            temp.push(`
                <div class="selectTime-carousel__item ${isLessThanCurrent ? "disabled" : ""} ${availabilityClass}">
                    <button class="button--no-style" data-datetime-value="${day.unixTime}">
                        <div class="date" style="background-color: ${(0, $cEKee.primaryColor)}0f;"><span>${day.date}</span></div>
                    </button>
                </div>
            `);
        });
        if (temp?.length !== 7) temp.push(...Array(7 - week.length).fill(`
                    <div class="selectTime-carousel__item" style="visibility: hidden;">
                        <button class="button--no-style">
                            <div class="date" ><span></span></div>
                            <div class="day"><span></span></div>
                        </button>
                    </div>
                    `));
        return `
            <div class="selectTime-carousel__item-week ${temp?.length !== 7 ? "notFullWeek" : ""}">
                ${temp.join('')}
            </div>
        `;
    });
    return innerHTMLContentArr.join('');
};
function $12b87e080530aee7$var$formatUnixTime(unixTime, timezone) {
    const date = new Date(unixTime * 1000);
    const options = {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
        timeZone: timezone
    };
    try {
        return new Intl.DateTimeFormat('en-US', options).format(date);
    } catch (error) {
        return new Intl.DateTimeFormat('en-US', {
            ...options,
            timeZone: 'UTC'
        }).format(date) + ' UTC';
    }
}

});
parcelRegister("7FCXf", function(module, exports) {

$parcel$export(module.exports, "getTimeSlots", () => $595a94551dd882e9$export$12f5f7f868dca4f8);
$parcel$export(module.exports, "getFullyBookedDays", () => $595a94551dd882e9$export$322975dbdee544a7);
$parcel$export(module.exports, "getNextAvailableSlot", () => $595a94551dd882e9$export$16918f25e7f92ad8);

var $fmRoT = parcelRequire("fmRoT");

var $hvLQT = parcelRequire("hvLQT");

var $cEKee = parcelRequire("cEKee");
async function $595a94551dd882e9$export$12f5f7f868dca4f8(data) {
    const CancelToken = (0, (/*@__PURE__*/$parcel$interopDefault($fmRoT))).CancelToken;
    const source = CancelToken.source();
    (0, $cEKee.setRequestsGetSlotsTime)([
        ...(0, $cEKee.requestsGetSlotsTime),
        source
    ]);
    if (!data.procedure_addon_ids) return await (0, (/*@__PURE__*/$parcel$interopDefault($fmRoT))).request({
        headers: {
            ...(0, $hvLQT.apiClient).config().headers
        },
        cancelToken: source.token,
        method: 'GET',
        url: `${(0, $hvLQT.apiClient).apiUrl(`api/events/appointment-channel/${data.id}/slots?start_time=${data.start_time}&end_time=${data.end_time}&${data.procedure_ids}${data?.staff_id ? `&staff_id=${data?.staff_id}` : ""}${data?.location_id ? `&location_id=${data?.location_id}` : ""}`)}`
    });
    return await (0, (/*@__PURE__*/$parcel$interopDefault($fmRoT))).request({
        headers: {
            ...(0, $hvLQT.apiClient).config().headers
        },
        cancelToken: source.token,
        method: 'GET',
        url: `${(0, $hvLQT.apiClient).apiUrl(`api/events/appointment-channel/${data.id}/slots?start_time=${data.start_time}&end_time=${data.end_time}&${data.procedure_ids}&${data.procedure_addon_ids}${data?.staff_id ? `&staff_id=${data?.staff_id}` : ""}${data?.location_id ? `&location_id=${data?.location_id}` : ""}`)}`
    });
}
async function $595a94551dd882e9$export$322975dbdee544a7(appointmentChannelId, data) {
    const base = `api/events/appointment-channel/${appointmentChannelId}/fully-booked-days`;
    const q = [
        `start_time=${data.start_time}`,
        `end_time=${data.end_time}`,
        data.procedure_ids || '',
        data.procedure_addon_ids ? `&${data.procedure_addon_ids}` : '',
        data.staff_id ? `&staff_id=${data.staff_id}` : '',
        data.location_id ? `&location_id=${data.location_id}` : ''
    ].filter(Boolean).join('&');
    const url = (0, $hvLQT.apiClient).apiUrl(`${base}?${q}`);
    const res = await (0, (/*@__PURE__*/$parcel$interopDefault($fmRoT))).request({
        headers: {
            ...(0, $hvLQT.apiClient).config().headers
        },
        method: 'GET',
        url: url
    });
    return res.data;
}
async function $595a94551dd882e9$export$16918f25e7f92ad8(appointmentChannelId, data) {
    const CancelTokenNext = (0, (/*@__PURE__*/$parcel$interopDefault($fmRoT))).CancelToken;
    const sourceNext = CancelTokenNext.source();
    (0, $cEKee.setNextRequestsGetSlotsTime)([
        ...(0, $cEKee.nextRequestsGetSlotsTime),
        sourceNext
    ]);
    return await (0, (/*@__PURE__*/$parcel$interopDefault($fmRoT))).request({
        method: 'GET',
        headers: {
            ...(0, $hvLQT.apiClient).config().headers
        },
        cancelToken: sourceNext.token,
        url: `${(0, $hvLQT.apiClient).apiUrl(`api/events/appointment-channel/${appointmentChannelId}/slots/next?${data?.procedures ? data.procedures : ""}${data?.procedure_addon_ids ? `&${data?.procedure_addon_ids}` : ""}${data?.staff_id ? `&staff_id=${data?.staff_id}` : ""}${data?.location_id ? `&location_id=${data?.location_id}` : ""}`)}`
    });
}

});

parcelRegister("gsdGr", function(module, exports) {

$parcel$export(module.exports, "removePhone", () => $bfa9e0200796640d$export$de26a4f913fdad1d);
$parcel$export(module.exports, "newPhoneUI", () => $bfa9e0200796640d$export$d45f4d42bc3b3050);
$parcel$export(module.exports, "oldPhoneUI", () => $bfa9e0200796640d$export$19697143a32cea70);

var $knjAn = parcelRequire("knjAn");

var $cEKee = parcelRequire("cEKee");

var $fQMeL = parcelRequire("fQMeL");

var $ifWoM = parcelRequire("ifWoM");

var $29QSo = parcelRequire("29QSo");
function $bfa9e0200796640d$export$de26a4f913fdad1d() {
    (0, $cEKee.setPhone)('');
    const phone = document.querySelector('#phone');
    if (phone) {
        phone.value = '';
        document.querySelector('.phoneContinue__btn').classList.add('disabled');
    }
}
function $bfa9e0200796640d$export$d45f4d42bc3b3050() {
    let tempUIStr = `
                    <div class="card">
                        <div class="icon">
                            <div class="icon__background" style="background: ${(0, $cEKee.primaryColor)}0f;">
                                <i data-feather="calendar"></i>
                            </div>
                        </div>
                        <div class="phone--title-wrapper">
                            <div class="phone--title">${(0, $knjAn.t)('book_appointment')}</div>
                            <div class="phone--sub-title">
                               ${(0, $knjAn.t)('phone_entry_subtitle')}
                            </div>
                        </div>
                        <div class="phone__input-wrapper">
                            <div class="phone__input-label">${(0, $knjAn.t)('phone')}</div>
                        </div>
                        <div class="phone--element">
                            <span class="phone__valid hidden">
                                <i class="ri-check-line"></i>
                            </span>
                            <span class="phone__invalid hidden">
                                <i class="ri-close-line"></i>
                            </span>
                            <div class="phone__wrapper--input">
                                <span class="phone__countryCode phone" id="phone__countryCode">
                                    <div class="phone__selected-code phone">
                                        <img class="flag-icon selected-flag">
                                        <span class="selected-country-code"></span>
                                    </div>
                                    <div class="phone__countryCode--dropdown phone hidden">
                                        <ul class="phone__countryCode--select"></ul>
                                    </div>
                                </span>
                                <input tabindex="-1" id="phone" class="phone--input" type="tel" autocomplete="tel"
                                    placeholder="${(0, $knjAn.t)('phone_placeholder')}" inputmode="tel">
                            </div>
                        </div>
                    </div>
                    <span class="form__notice">
                        By continuing, you agree to our <u class="link" style="color: gray; cursor: pointer;">Terms</u> & <u class="link" style="color: gray; cursor: pointer;">Privacy Policy</u> and consent to receive texts. Msg & data rates may apply. Message frequency varies.
                    </span>
  `;
    let tempDom = document.querySelector('.phone__container .phone__wrappers');
    if (tempDom) {
        tempDom.innerHTML = tempUIStr;
        (0, $fQMeL.loadPhoneComponent)();
        (0, $ifWoM.countryCodeListeners)();
        (0, $29QSo.phoneListeners)();
        feather.replace();
    }
    const isWL = (0, $cEKee.form)?.project?.whitelabel ?? false;
    const projectWebsite = (0, $cEKee.form)?.project?.website;
    document.querySelectorAll('.form__notice .link').forEach((i)=>{
        if (isWL) {
            if (projectWebsite) i.onclick = (e)=>{
                e.stopPropagation();
                window.parent.parent.location.href = projectWebsite;
            };
            else {
                i.style.cursor = 'default';
                i.style.textDecoration = 'none';
            }
        } else i.onclick = (e)=>{
            e.stopPropagation();
            window.parent.parent.location.href = i.textContent === 'Terms' ? 'https://pilotpractice.com/terms-and-conditions/' : 'https://pilotpractice.com/privacy-policy/';
        };
    });
}
function $bfa9e0200796640d$export$19697143a32cea70() {
    let tempUIStr = `
                    <div class="phone--title-wrapper">
                        <div class="phone--title">${(0, $knjAn.t)('your_phone_number')}</div>
                    </div>
                    <div class="phone--element old-phone">
                        <span class="phone__valid hidden">
                            <i class="ri-check-line"></i>
                        </span>
                        <span class="phone__invalid hidden">
                            <i class="ri-close-line"></i>
                        </span>
                        <div class="phone__wrapper--input">
                            <span class="phone__countryCode phone" id="phone__countryCode">
                                <div class="phone__selected-code phone">
                                    <img class="flag-icon selected-flag">
                                    <span class="selected-country-code"></span>
                                </div>
                                <div class="phone__countryCode--dropdown phone hidden">
                                    <ul class="phone__countryCode--select"></ul>
                                </div>
                            </span>
                            <input tabindex="-1" id="phone" class="phone--input old-phone-input" type="tel" autocomplete="tel"
                                placeholder="${(0, $knjAn.t)('phone_placeholder')}" inputmode="tel">
                        </div>
                    </div>
                    <span class="form__notice">
                        By continuing, you agree to our <u class="link" style="color: gray; cursor: pointer;">Terms</u> & <u class="link" style="color: gray; cursor: pointer;">Privacy Policy</u> and consent to receive texts. Msg & data rates may apply. Message frequency varies.
                    </span>
  `;
    let tempDom = document.querySelector('.phone__container .phone__wrappers');
    if (tempDom) {
        tempDom.innerHTML = tempUIStr;
        (0, $fQMeL.loadPhoneComponent)();
        (0, $ifWoM.countryCodeListeners)();
        (0, $29QSo.phoneListeners)();
    }
    const isWL = (0, $cEKee.form)?.project?.whitelabel ?? false;
    const projectWebsite = (0, $cEKee.form)?.project?.website;
    document.querySelectorAll('.form__notice .link').forEach((i)=>{
        if (isWL) {
            if (projectWebsite) i.onclick = (e)=>{
                e.stopPropagation();
                window.parent.parent.location.href = projectWebsite;
            };
            else {
                i.style.cursor = 'default';
                i.style.textDecoration = 'none';
            }
        } else i.onclick = (e)=>{
            e.stopPropagation();
            window.parent.parent.location.href = i.textContent === 'Terms' ? 'https://pilotpractice.com/terms-and-conditions/' : 'https://pilotpractice.com/privacy-policy/';
        };
    });
}

});
parcelRegister("fQMeL", function(module, exports) {

$parcel$export(module.exports, "loadInstantQuotes", () => $b8a1213a54d2aeb1$export$9e863964f9a17e3);
$parcel$export(module.exports, "loadPhoneComponent", () => $b8a1213a54d2aeb1$export$f57cfc9a4232fcdc);

var $cIxq8 = parcelRequire("cIxq8");

var $fJdVD = parcelRequire("fJdVD");

var $5Idx5 = parcelRequire("5Idx5");

var $cEKee = parcelRequire("cEKee");
function $b8a1213a54d2aeb1$export$9e863964f9a17e3() {
    (0, $fJdVD.loadLocationList)();
}
function $b8a1213a54d2aeb1$export$f57cfc9a4232fcdc() {
    document.querySelector('.phone__container .phone__selected-code img').setAttribute('src', `${(0, $cEKee.appUrl)}/assets/images/svg/${(0, $cEKee.selectedCountry).toLowerCase()}.svg`);
    document.querySelector('.phone__container .selected-country-code').innerHTML = '+' + (0, $cEKee.selectedCodeNumber);
    document.querySelector('.phone__container .phone__countryCode--select').innerHTML = (0, $5Idx5.loadCountriesCodeDropdown)((0, $cIxq8.SCREEN).PHONE);
}

});
parcelRegister("fJdVD", function(module, exports) {

$parcel$export(module.exports, "loadLocationList", () => $b735dce60d5c1f57$export$5c1ab25c4a657cba);

var $cEKee = parcelRequire("cEKee");
function $b735dce60d5c1f57$export$5c1ab25c4a657cba(el = null, isCall = false) {
    let list = el ? el : document.querySelector('.locations__container .locations__list');
    let locationsList = ``;
    for (const location of (0, $cEKee.locations))locationsList = locationsList.concat(`
        ${isCall ? `
                <a class="call-location location" href="tel:${location?.phone || (0, $cEKee.phoneToCall)}" ${isCall ? `data-id="${location?.id || ""}"` : `data-location-id="${location.id}"`} target="_blank">
                    ${$b735dce60d5c1f57$var$renderLocationItem(location)}
                </a>
            ` : `
                <div class="call-location location" ${isCall ? `data-id="${location?.id || ""}"` : `data-location-id="${location.id}"`}>
                    ${$b735dce60d5c1f57$var$renderLocationItem(location)}
                </div>
            `}
        `);
    list.innerHTML = locationsList;
    const listContainer = list.closest('.callus_container, .locations__container');
    if (listContainer && (0, $cEKee.locations).length > 4) listContainer.classList.add('has-many-locations');
    feather.replace();
}
const $b735dce60d5c1f57$var$renderLocationItem = (location)=>{
    return `
            <span class="location-icon">
                <i data-feather="map-pin"></i>
            </span>
            <div class="location-info">
                <span class="title">${location?.name || ""}</span>
            </div>
    `;
};

});

parcelRegister("5Idx5", function(module, exports) {

$parcel$export(module.exports, "loadCountriesCodeDropdown", () => $428b8f18330c76bc$export$180736b43b8b0199);

var $ib9ar = parcelRequire("ib9ar");
var $e8gL5 = parcelRequire("e8gL5");

var $cIxq8 = parcelRequire("cIxq8");

var $cEKee = parcelRequire("cEKee");
function $428b8f18330c76bc$export$180736b43b8b0199(screen) {
    let codes = [];
    const countries = (0, $ib9ar.getCountries)();
    countries.forEach((country)=>{
        if (!(0, $cIxq8.countriesNotSupported).includes(country)) {
            let code = `
            <li class="phone__countryCode--option" data-country="${country}" data-country-code="${(0, $e8gL5.getCountryCallingCode)(country)}" data-screen="${screen}">
                <img src="${(0, $cEKee.appUrl)}/assets/images/svg/${country.toLowerCase()}.svg" class="flag-icon">
                <span style="margin-left: 6px">+${(0, $e8gL5.getCountryCallingCode)(country)}</span>
            </li>
            `;
            if ((0, $cIxq8.countriesPrioritized).includes(country)) codes.unshift(code);
            else codes.push(code);
        }
    });
    return codes.join(' ');
}

});
parcelRegister("ib9ar", function(module, exports) {

$parcel$export(module.exports, "getCountries", () => $d3c05d8665fa3dee$export$44f7508c6c352cc6);

var $1c9lJ = parcelRequire("1c9lJ");

var $4wSUA = parcelRequire("4wSUA");
function $d3c05d8665fa3dee$export$44f7508c6c352cc6() {
    return (0, $1c9lJ.withMetadata)((0, $4wSUA.default), arguments);
}

});
parcelRegister("4wSUA", function(module, exports) {

$parcel$export(module.exports, "default", () => $34c4bee83c07f6dd$export$2e2bcd8739ae039);

var $lijQr = parcelRequire("lijQr");
function $34c4bee83c07f6dd$export$2e2bcd8739ae039(metadata) {
    return new (0, $lijQr.default)(metadata).getCountries();
}

});


parcelRegister("e8gL5", function(module, exports) {

$parcel$export(module.exports, "getCountryCallingCode", () => $a49ecfeae7c8d661$export$32876ca2f1919cf0);

var $1c9lJ = parcelRequire("1c9lJ");

var $lijQr = parcelRequire("lijQr");
function $a49ecfeae7c8d661$export$32876ca2f1919cf0() {
    return (0, $1c9lJ.withMetadata)((0, $lijQr.getCountryCallingCode), arguments);
}

});



parcelRegister("ifWoM", function(module, exports) {

$parcel$export(module.exports, "countryCodeListeners", () => $d4a6ed7773c4ef2c$export$ebd2fa98fbc10e70);
$parcel$export(module.exports, "handleClickOutsidePagePhone", () => $d4a6ed7773c4ef2c$export$d6b0b3a046705e2a);

var $cIxq8 = parcelRequire("cIxq8");

var $cEKee = parcelRequire("cEKee");

var $eq8l3 = parcelRequire("eq8l3");
function $d4a6ed7773c4ef2c$export$ebd2fa98fbc10e70() {
    /* on click code number in dropdown */ const codes = document.querySelectorAll('.phone__countryCode--option');
    codes.forEach((i)=>{
        i.onclick = ()=>{
            (0, $cEKee.setSelectedCountry)(i.getAttribute('data-country'));
            (0, $cEKee.setSelectedCodeNumber)(i.getAttribute('data-country-code'));
            const screen = i.getAttribute('data-screen');
            /* Change selected flag icon */ document.querySelectorAll('.selected-flag').forEach((j)=>{
                j.setAttribute('src', `${(0, $cEKee.appUrl)}/assets/images/svg/${i.getAttribute('data-country').toLowerCase()}.svg`);
            });
            /* Change selected country code */ document.querySelectorAll('.selected-country-code').forEach((j)=>{
                j.textContent = `+${i.getAttribute('data-country-code')}`;
            });
            if (screen === (0, $cIxq8.SCREEN).REQUEST_CONSULT) {
                const phone = document.querySelector('#phoneConsult');
                const phoneWrapper = document.querySelector('.requestConsult__container div[data-form="phoneConsult"]');
                phone.value = (0, $eq8l3.formatPhoneNumber)(phone.value, (0, $cEKee.selectedCountry));
                (0, $eq8l3.validatePhoneNumber)(phoneWrapper, phone.value);
            } else if (screen === (0, $cIxq8.SCREEN).ASK_QUESTION) {
                const phone = document.querySelector('#phoneAskQuestion');
                const phoneWrapper = document.querySelector('.askQuestion__container div[data-form="phoneAskQuestion"]');
                phone.value = (0, $eq8l3.formatPhoneNumber)(phone.value, (0, $cEKee.selectedCountry));
                (0, $eq8l3.validatePhoneNumber)(phoneWrapper, phone.value);
            }
            (0, $eq8l3.toggleCountriesAskQs)((0, $cIxq8.CLOSE));
            (0, $eq8l3.toggleCountriesPhone)((0, $cIxq8.CLOSE));
            (0, $eq8l3.toggleCountriesConsult)((0, $cIxq8.CLOSE));
        };
    });
    /* Click outside to close code number country dropdown ASK QUESTION screen*/ document.addEventListener('click', $d4a6ed7773c4ef2c$var$handleClickOutsidePageAskQuestion);
    /* Click outside to close code number country dropdown REQUEST CONSULTATION screen*/ document.addEventListener('click', $d4a6ed7773c4ef2c$var$handleClickOutsidePageRequestConsultation);
    /* Click outside to close code number country dropdown PHONE screen*/ document.addEventListener('click', $d4a6ed7773c4ef2c$export$d6b0b3a046705e2a);
}
async function $d4a6ed7773c4ef2c$var$handleClickOutsidePageAskQuestion(evt) {
    const element = document.querySelector(`.phone__countryCode.${(0, $cIxq8.SCREEN).ASK_QUESTION}`);
    let targetElement = evt.target;
    do {
        if (targetElement == element) return;
        targetElement = targetElement.parentNode;
    }while (targetElement);
    (0, $eq8l3.toggleCountriesConsult)((0, $cIxq8.CLOSE));
}
async function $d4a6ed7773c4ef2c$var$handleClickOutsidePageRequestConsultation(evt) {
    const element = document.querySelector(`.phone__countryCode.${(0, $cIxq8.SCREEN).REQUEST_CONSULT}`);
    let targetElement = evt.target;
    do {
        if (targetElement == element) return;
        targetElement = targetElement.parentNode;
    }while (targetElement);
    (0, $eq8l3.toggleCountriesConsult)((0, $cIxq8.CLOSE));
}
async function $d4a6ed7773c4ef2c$export$d6b0b3a046705e2a(evt) {
    const element = document.querySelector(`.phone__countryCode.${(0, $cIxq8.SCREEN).PHONE}`);
    let targetElement = evt.target;
    do {
        if (targetElement == element) return;
        targetElement = targetElement.parentNode;
    }while (targetElement);
    (0, $eq8l3.toggleCountriesPhone)((0, $cIxq8.CLOSE));
}

});
parcelRegister("eq8l3", function(module, exports) {

$parcel$export(module.exports, "toggleCountriesAskQs", () => $a7f9f64252e82533$export$23210f9dd3de56ad);
$parcel$export(module.exports, "toggleCountriesConsult", () => $a7f9f64252e82533$export$20c7c34581e69132);
$parcel$export(module.exports, "toggleCountriesPhone", () => $a7f9f64252e82533$export$d7416979a9c8239e);
$parcel$export(module.exports, "formatPhoneNumber", () => $a7f9f64252e82533$export$842dcfa371c6bb83);
$parcel$export(module.exports, "validatePhoneNumber", () => $a7f9f64252e82533$export$30dc0b291f505e34);

var $jY7rD = parcelRequire("jY7rD");
var $1Yh2H = parcelRequire("1Yh2H");

var $cIxq8 = parcelRequire("cIxq8");

var $cEKee = parcelRequire("cEKee");
function $a7f9f64252e82533$export$23210f9dd3de56ad(state) {
    let open = (0, $cIxq8.CLOSE);
    open = (0, $cEKee.countriesAskQs);
    if (state !== (0, $cIxq8.CLOSE) && state !== (0, $cIxq8.OPEN)) {
        if (open === (0, $cIxq8.CLOSE)) open = (0, $cIxq8.OPEN);
        else open = (0, $cIxq8.CLOSE);
    } else open = state;
    (0, $cEKee.setCountriesAskQs)(open);
    const dropdown = document.querySelector(`.phone__countryCode--dropdown.${(0, $cIxq8.SCREEN).ASK_QUESTION}`);
    const code = document.querySelector(`.phone__countryCode.${(0, $cIxq8.SCREEN).ASK_QUESTION}`);
    if (open === (0, $cIxq8.OPEN)) {
        dropdown.classList.remove('hidden');
        code.classList.add('open');
    } else {
        dropdown.classList.add('hidden');
        code.classList.remove('open');
    }
}
function $a7f9f64252e82533$export$20c7c34581e69132(state) {
    let open = (0, $cIxq8.CLOSE);
    open = (0, $cEKee.countriesConsult);
    if (state !== (0, $cIxq8.CLOSE) && state !== (0, $cIxq8.OPEN)) {
        if (open === (0, $cIxq8.CLOSE)) open = (0, $cIxq8.OPEN);
        else open = (0, $cIxq8.CLOSE);
    } else open = state;
    (0, $cEKee.setCountriesConsult)(open);
    const dropdown = document.querySelector(`.phone__countryCode--dropdown.${(0, $cIxq8.SCREEN).REQUEST_CONSULT}`);
    const code = document.querySelector(`.phone__countryCode.${(0, $cIxq8.SCREEN).REQUEST_CONSULT}`);
    if (open === (0, $cIxq8.OPEN)) {
        dropdown.classList.remove('hidden');
        code.classList.add('open');
    } else {
        dropdown.classList.add('hidden');
        code.classList.remove('open');
    }
}
function $a7f9f64252e82533$export$d7416979a9c8239e(state) {
    let open = (0, $cIxq8.CLOSE);
    open = (0, $cEKee.countriesPhone);
    if (state !== (0, $cIxq8.CLOSE) && state !== (0, $cIxq8.OPEN)) {
        if (open === (0, $cIxq8.CLOSE)) open = (0, $cIxq8.OPEN);
        else open = (0, $cIxq8.CLOSE);
    } else open = state;
    (0, $cEKee.setCountriesPhone)(open);
    const dropdown = document.querySelector(`.phone__countryCode--dropdown.${(0, $cIxq8.SCREEN).PHONE}`);
    const code = document.querySelector(`.phone__countryCode.${(0, $cIxq8.SCREEN).PHONE}`);
    if (!dropdown) return;
    if (open === (0, $cIxq8.OPEN)) {
        dropdown.classList.remove('hidden');
        code.classList.add('open');
    } else {
        dropdown.classList.add('hidden');
        code.classList.remove('open');
    }
}
function $a7f9f64252e82533$export$842dcfa371c6bb83(value, country) {
    if (!value) return '';
    value = value.toString();
    if (value.includes('(') && !value.includes(')')) return value.replace('(', '');
    var newValue = new (0, $jY7rD.AsYouType)(country).input(value);
    return newValue;
}
function $a7f9f64252e82533$export$30dc0b291f505e34(phone, number) {
    if ((0, $1Yh2H.isValidPhoneNumber)(number, (0, $cEKee.selectedCountry))) {
        phone.classList.add('valid');
        phone.classList.remove('invalid');
    } else {
        phone.classList.remove('valid');
        phone.classList.add('invalid');
    }
}

});
parcelRegister("jY7rD", function(module, exports) {

$parcel$export(module.exports, "AsYouType", () => $e8996547604d497c$export$80d8c6912928a4eb);

var $1c9lJ = parcelRequire("1c9lJ");

var $iPkor = parcelRequire("iPkor");
function $e8996547604d497c$export$80d8c6912928a4eb(country) {
    return (0, $iPkor.default).call(this, country, (0, $1c9lJ.default));
}
$e8996547604d497c$export$80d8c6912928a4eb.prototype = Object.create((0, $iPkor.default).prototype, {});
$e8996547604d497c$export$80d8c6912928a4eb.prototype.constructor = $e8996547604d497c$export$80d8c6912928a4eb;

});
parcelRegister("iPkor", function(module, exports) {

$parcel$export(module.exports, "default", () => $db4ccf0f77fcc72f$export$2e2bcd8739ae039);

var $lijQr = parcelRequire("lijQr");

var $3bOc3 = parcelRequire("3bOc3");

var $l8K4T = parcelRequire("l8K4T");

var $ahynH = parcelRequire("ahynH");
var $lQt3h = parcelRequire("lQt3h");

var $fD8Ui = parcelRequire("fD8Ui");

var $3wXuM = parcelRequire("3wXuM");
function $db4ccf0f77fcc72f$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $db4ccf0f77fcc72f$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $db4ccf0f77fcc72f$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $db4ccf0f77fcc72f$var$_typeof(obj);
}
function $db4ccf0f77fcc72f$var$_slicedToArray(arr, i) {
    return $db4ccf0f77fcc72f$var$_arrayWithHoles(arr) || $db4ccf0f77fcc72f$var$_iterableToArrayLimit(arr, i) || $db4ccf0f77fcc72f$var$_nonIterableRest();
}
function $db4ccf0f77fcc72f$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
function $db4ccf0f77fcc72f$var$_iterableToArrayLimit(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $db4ccf0f77fcc72f$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $db4ccf0f77fcc72f$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $db4ccf0f77fcc72f$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $db4ccf0f77fcc72f$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $db4ccf0f77fcc72f$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $db4ccf0f77fcc72f$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
var $db4ccf0f77fcc72f$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE = false;
var $db4ccf0f77fcc72f$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * @param {(string|object)?} [optionsOrDefaultCountry] - The default country used for parsing non-international phone numbers. Can also be an `options` object.
   * @param {Object} metadata
   */ function AsYouType(optionsOrDefaultCountry, metadata) {
        $db4ccf0f77fcc72f$var$_classCallCheck(this, AsYouType);
        this.metadata = new (0, $lijQr.default)(metadata);
        var _this$getCountryAndCa = this.getCountryAndCallingCode(optionsOrDefaultCountry), _this$getCountryAndCa2 = $db4ccf0f77fcc72f$var$_slicedToArray(_this$getCountryAndCa, 2), defaultCountry = _this$getCountryAndCa2[0], defaultCallingCode = _this$getCountryAndCa2[1];
        this.defaultCountry = defaultCountry;
        this.defaultCallingCode = defaultCallingCode;
        this.reset();
    }
    $db4ccf0f77fcc72f$var$_createClass(AsYouType, [
        {
            key: "getCountryAndCallingCode",
            value: function getCountryAndCallingCode(optionsOrDefaultCountry) {
                // Set `defaultCountry` and `defaultCallingCode` options.
                var defaultCountry;
                var defaultCallingCode; // Turns out `null` also has type "object". Weird.
                if (optionsOrDefaultCountry) {
                    if ($db4ccf0f77fcc72f$var$_typeof(optionsOrDefaultCountry) === 'object') {
                        defaultCountry = optionsOrDefaultCountry.defaultCountry;
                        defaultCallingCode = optionsOrDefaultCountry.defaultCallingCode;
                    } else defaultCountry = optionsOrDefaultCountry;
                }
                if (defaultCountry && !this.metadata.hasCountry(defaultCountry)) defaultCountry = undefined;
                if (defaultCallingCode) {
                    /* istanbul ignore if */ if ($db4ccf0f77fcc72f$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
                        if (this.metadata.isNonGeographicCallingCode(defaultCallingCode)) defaultCountry = '001';
                    }
                }
                return [
                    defaultCountry,
                    defaultCallingCode
                ];
            }
        },
        {
            key: "input",
            value: function input(text) {
                var _this$parser$input = this.parser.input(text, this.state), digits = _this$parser$input.digits, justLeadingPlus = _this$parser$input.justLeadingPlus;
                if (justLeadingPlus) this.formattedOutput = '+';
                else if (digits) {
                    this.determineTheCountryIfNeeded(); // Match the available formats by the currently available leading digits.
                    if (this.state.nationalSignificantNumber) this.formatter.narrowDownMatchingFormats(this.state);
                    var formattedNationalNumber;
                    if (this.metadata.hasSelectedNumberingPlan()) formattedNationalNumber = this.formatter.format(digits, this.state);
                    if (formattedNationalNumber === undefined) // See if another national (significant) number could be re-extracted.
                    {
                        if (this.parser.reExtractNationalSignificantNumber(this.state)) {
                            this.determineTheCountryIfNeeded(); // If it could, then re-try formatting the new national (significant) number.
                            var nationalDigits = this.state.getNationalDigits();
                            if (nationalDigits) formattedNationalNumber = this.formatter.format(nationalDigits, this.state);
                        }
                    }
                    this.formattedOutput = formattedNationalNumber ? this.getFullNumber(formattedNationalNumber) : this.getNonFormattedNumber();
                }
                return this.formattedOutput;
            }
        },
        {
            key: "reset",
            value: function reset() {
                var _this = this;
                this.state = new (0, $l8K4T.default)({
                    onCountryChange: function onCountryChange(country) {
                        // Before version `1.6.0`, the official `AsYouType` formatter API
                        // included the `.country` property of an `AsYouType` instance.
                        // Since that property (along with the others) have been moved to
                        // `this.state`, `this.country` property is emulated for compatibility
                        // with the old versions.
                        _this.country = country;
                    },
                    onCallingCodeChange: function onCallingCodeChange(country, callingCode) {
                        _this.metadata.selectNumberingPlan(country, callingCode);
                        _this.formatter.reset(_this.metadata.numberingPlan, _this.state);
                        _this.parser.reset(_this.metadata.numberingPlan);
                    }
                });
                this.formatter = new (0, $ahynH.default)({
                    state: this.state,
                    metadata: this.metadata
                });
                this.parser = new (0, $fD8Ui.default)({
                    defaultCountry: this.defaultCountry,
                    defaultCallingCode: this.defaultCallingCode,
                    metadata: this.metadata,
                    state: this.state,
                    onNationalSignificantNumberChange: function onNationalSignificantNumberChange() {
                        _this.determineTheCountryIfNeeded();
                        _this.formatter.reset(_this.metadata.numberingPlan, _this.state);
                    }
                });
                this.state.reset(this.defaultCountry, this.defaultCallingCode);
                this.formattedOutput = '';
                return this;
            }
        },
        {
            key: "isInternational",
            value: function isInternational() {
                return this.state.international;
            }
        },
        {
            key: "getCallingCode",
            value: function getCallingCode() {
                return this.state.callingCode;
            } // A legacy alias.
        },
        {
            key: "getCountryCallingCode",
            value: function getCountryCallingCode() {
                return this.getCallingCode();
            }
        },
        {
            key: "getCountry",
            value: function getCountry() {
                var _this$state = this.state, digits = _this$state.digits, country = _this$state.country; // If no digits have been input yet,
                // then `this.country` is the `defaultCountry`.
                // Won't return the `defaultCountry` in such case.
                if (!digits) return;
                var countryCode = country;
                /* istanbul ignore if */ if ($db4ccf0f77fcc72f$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE) // `AsYouType.getCountry()` returns `undefined`
                // for "non-geographic" phone numbering plans.
                {
                    if (countryCode === '001') countryCode = undefined;
                }
                return countryCode;
            }
        },
        {
            key: "determineTheCountryIfNeeded",
            value: function determineTheCountryIfNeeded() {
                // Suppose a user enters a phone number in international format,
                // and there're several countries corresponding to that country calling code,
                // and a country has been derived from the number, and then
                // a user enters one more digit and the number is no longer
                // valid for the derived country, so the country should be re-derived
                // on every new digit in those cases.
                //
                // If the phone number is being input in national format,
                // then it could be a case when `defaultCountry` wasn't specified
                // when creating `AsYouType` instance, and just `defaultCallingCode` was specified,
                // and that "calling code" could correspond to a "non-geographic entity",
                // or there could be several countries corresponding to that country calling code.
                // In those cases, `this.country` is `undefined` and should be derived
                // from the number. Again, if country calling code is ambiguous, then
                // `this.country` should be re-derived with each new digit.
                //
                if (!this.state.country || this.isCountryCallingCodeAmbiguous()) this.determineTheCountry();
            } // Prepends `+CountryCode ` in case of an international phone number
        },
        {
            key: "getFullNumber",
            value: function getFullNumber(formattedNationalNumber) {
                var _this2 = this;
                if (this.isInternational()) {
                    var prefix = function prefix(text) {
                        return _this2.formatter.getInternationalPrefixBeforeCountryCallingCode(_this2.state, {
                            spacing: text ? true : false
                        }) + text;
                    };
                    var callingCode = this.state.callingCode;
                    if (!callingCode) return prefix("".concat(this.state.getDigitsWithoutInternationalPrefix()));
                    if (!formattedNationalNumber) return prefix(callingCode);
                    return prefix("".concat(callingCode, " ").concat(formattedNationalNumber));
                }
                return formattedNationalNumber;
            }
        },
        {
            key: "getNonFormattedNationalNumberWithPrefix",
            value: function getNonFormattedNationalNumberWithPrefix() {
                var _this$state2 = this.state, nationalSignificantNumber = _this$state2.nationalSignificantNumber, complexPrefixBeforeNationalSignificantNumber = _this$state2.complexPrefixBeforeNationalSignificantNumber, nationalPrefix = _this$state2.nationalPrefix;
                var number = nationalSignificantNumber;
                var prefix = complexPrefixBeforeNationalSignificantNumber || nationalPrefix;
                if (prefix) number = prefix + number;
                return number;
            }
        },
        {
            key: "getNonFormattedNumber",
            value: function getNonFormattedNumber() {
                var nationalSignificantNumberMatchesInput = this.state.nationalSignificantNumberMatchesInput;
                return this.getFullNumber(nationalSignificantNumberMatchesInput ? this.getNonFormattedNationalNumberWithPrefix() : this.state.getNationalDigits());
            }
        },
        {
            key: "getNonFormattedTemplate",
            value: function getNonFormattedTemplate() {
                var number = this.getNonFormattedNumber();
                if (number) return number.replace(/[\+\d]/g, (0, $lQt3h.DIGIT_PLACEHOLDER));
            }
        },
        {
            key: "isCountryCallingCodeAmbiguous",
            value: function isCountryCallingCodeAmbiguous() {
                var callingCode = this.state.callingCode;
                var countryCodes = this.metadata.getCountryCodesForCallingCode(callingCode);
                return countryCodes && countryCodes.length > 1;
            } // Determines the country of the phone number
        },
        {
            key: "determineTheCountry",
            value: function determineTheCountry() {
                this.state.setCountry((0, $3wXuM.default)(this.isInternational() ? this.state.callingCode : this.defaultCallingCode, this.state.nationalSignificantNumber, this.metadata));
            }
        },
        {
            key: "getNumber",
            value: function getNumber() {
                var _this$state3 = this.state, nationalSignificantNumber = _this$state3.nationalSignificantNumber, carrierCode = _this$state3.carrierCode;
                if (this.isInternational()) {
                    if (!this.state.callingCode) return;
                } else {
                    if (!this.state.country && !this.defaultCallingCode) return;
                }
                if (!nationalSignificantNumber) return;
                var countryCode = this.getCountry();
                var callingCode = this.getCountryCallingCode() || this.defaultCallingCode;
                var phoneNumber = new (0, $3bOc3.default)(countryCode || callingCode, nationalSignificantNumber, this.metadata.metadata);
                if (carrierCode) phoneNumber.carrierCode = carrierCode;
                 // Phone number extensions are not supported by "As You Type" formatter.
                return phoneNumber;
            }
        },
        {
            key: "isPossible",
            value: function isPossible() {
                var phoneNumber = this.getNumber();
                if (!phoneNumber) return false;
                return phoneNumber.isPossible();
            }
        },
        {
            key: "isValid",
            value: function isValid() {
                var phoneNumber = this.getNumber();
                if (!phoneNumber) return false;
                return phoneNumber.isValid();
            }
        },
        {
            key: "getNationalNumber",
            value: function getNationalNumber() {
                return this.state.nationalSignificantNumber;
            }
        },
        {
            key: "getChars",
            value: function getChars() {
                return (this.state.international ? '+' : '') + this.state.digits;
            }
        },
        {
            key: "getTemplate",
            value: function getTemplate() {
                return this.formatter.getTemplate(this.state) || this.getNonFormattedTemplate() || '';
            }
        }
    ]);
    return AsYouType;
}();

});
parcelRegister("l8K4T", function(module, exports) {

$parcel$export(module.exports, "default", () => $f63e1671b767c734$export$2e2bcd8739ae039);
function $f63e1671b767c734$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $f63e1671b767c734$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $f63e1671b767c734$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $f63e1671b767c734$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $f63e1671b767c734$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $f63e1671b767c734$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $f63e1671b767c734$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AsYouTypeState(_ref) {
        var _this = this;
        var onCountryChange = _ref.onCountryChange, onCallingCodeChange = _ref.onCallingCodeChange;
        $f63e1671b767c734$var$_classCallCheck(this, AsYouTypeState);
        $f63e1671b767c734$var$_defineProperty(this, "update", function(properties) {
            for(var _i = 0, _Object$keys = Object.keys(properties); _i < _Object$keys.length; _i++){
                var key = _Object$keys[_i];
                _this[key] = properties[key];
            }
        });
        this.onCountryChange = onCountryChange;
        this.onCallingCodeChange = onCallingCodeChange;
    }
    $f63e1671b767c734$var$_createClass(AsYouTypeState, [
        {
            key: "reset",
            value: function reset(defaultCountry, defaultCallingCode) {
                this.international = false;
                this.IDDPrefix = undefined;
                this.missingPlus = undefined;
                this.callingCode = undefined;
                this.digits = '';
                this.resetNationalSignificantNumber();
                this.initCountryAndCallingCode(defaultCountry, defaultCallingCode);
            }
        },
        {
            key: "resetNationalSignificantNumber",
            value: function resetNationalSignificantNumber() {
                this.nationalSignificantNumber = this.getNationalDigits();
                this.nationalSignificantNumberMatchesInput = true;
                this.nationalPrefix = undefined;
                this.carrierCode = undefined;
                this.complexPrefixBeforeNationalSignificantNumber = undefined;
            }
        },
        {
            key: "initCountryAndCallingCode",
            value: function initCountryAndCallingCode(country, callingCode) {
                this.setCountry(country);
                this.setCallingCode(callingCode);
            }
        },
        {
            key: "setCountry",
            value: function setCountry(country) {
                this.country = country;
                this.onCountryChange(country);
            }
        },
        {
            key: "setCallingCode",
            value: function setCallingCode(callingCode) {
                this.callingCode = callingCode;
                return this.onCallingCodeChange(this.country, callingCode);
            }
        },
        {
            key: "startInternationalNumber",
            value: function startInternationalNumber() {
                // Prepend the `+` to parsed input.
                this.international = true; // If a default country was set then reset it
                // because an explicitly international phone
                // number is being entered.
                this.initCountryAndCallingCode();
            }
        },
        {
            key: "appendDigits",
            value: function appendDigits(nextDigits) {
                this.digits += nextDigits;
            }
        },
        {
            key: "appendNationalSignificantNumberDigits",
            value: function appendNationalSignificantNumberDigits(nextDigits) {
                this.nationalSignificantNumber += nextDigits;
            }
        },
        {
            key: "getNationalDigits",
            value: function getNationalDigits() {
                if (this.international) return this.digits.slice((this.IDDPrefix ? this.IDDPrefix.length : 0) + (this.callingCode ? this.callingCode.length : 0));
                return this.digits;
            }
        },
        {
            key: "getDigitsWithoutInternationalPrefix",
            value: function getDigitsWithoutInternationalPrefix() {
                if (this.international) {
                    if (this.IDDPrefix) return this.digits.slice(this.IDDPrefix.length);
                }
                return this.digits;
            }
        }
    ]);
    return AsYouTypeState;
}();

});

parcelRegister("ahynH", function(module, exports) {

$parcel$export(module.exports, "default", () => $77c6294fe142cf3c$export$2e2bcd8739ae039);
$parcel$export(module.exports, "DIGIT_PLACEHOLDER", () => (parcelRequire("lQt3h")).DIGIT_PLACEHOLDER);

var $lQt3h = parcelRequire("lQt3h");

var $41ESN = parcelRequire("41ESN");

var $fkobN = parcelRequire("fkobN");

var $cQ2v2 = parcelRequire("cQ2v2");

var $hoHfs = parcelRequire("hoHfs");

var $1o9N5 = parcelRequire("1o9N5");
function $77c6294fe142cf3c$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $77c6294fe142cf3c$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $77c6294fe142cf3c$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $77c6294fe142cf3c$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $77c6294fe142cf3c$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $77c6294fe142cf3c$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
// Could be any digit, I guess.
var $77c6294fe142cf3c$var$DUMMY_DIGIT = '9'; // I don't know why is it exactly `15`
var $77c6294fe142cf3c$var$LONGEST_NATIONAL_PHONE_NUMBER_LENGTH = 15; // Create a phone number consisting only of the digit 9 that matches the
// `number_pattern` by applying the pattern to the "longest phone number" string.
var $77c6294fe142cf3c$var$LONGEST_DUMMY_PHONE_NUMBER = (0, $lQt3h.repeat)($77c6294fe142cf3c$var$DUMMY_DIGIT, $77c6294fe142cf3c$var$LONGEST_NATIONAL_PHONE_NUMBER_LENGTH); // A set of characters that, if found in a national prefix formatting rules, are an indicator to
// us that we should separate the national prefix from the number when formatting.
var $77c6294fe142cf3c$var$NATIONAL_PREFIX_SEPARATORS_PATTERN = /[- ]/; // Deprecated: Google has removed some formatting pattern related code from their repo.
// https://github.com/googlei18n/libphonenumber/commit/a395b4fef3caf57c4bc5f082e1152a4d2bd0ba4c
// "We no longer have numbers in formatting matching patterns, only \d."
// Because this library supports generating custom metadata
// some users may still be using old metadata so the relevant
// code seems to stay until some next major version update.
var $77c6294fe142cf3c$var$SUPPORT_LEGACY_FORMATTING_PATTERNS = true; // A pattern that is used to match character classes in regular expressions.
// An example of a character class is "[1-4]".
var $77c6294fe142cf3c$var$CREATE_CHARACTER_CLASS_PATTERN = $77c6294fe142cf3c$var$SUPPORT_LEGACY_FORMATTING_PATTERNS && function() {
    return /\[([^\[\]])*\]/g;
}; // Any digit in a regular expression that actually denotes a digit. For
// example, in the regular expression "80[0-2]\d{6,10}", the first 2 digits
// (8 and 0) are standalone digits, but the rest are not.
// Two look-aheads are needed because the number following \\d could be a
// two-digit number, since the phone number can be as long as 15 digits.
var $77c6294fe142cf3c$var$CREATE_STANDALONE_DIGIT_PATTERN = $77c6294fe142cf3c$var$SUPPORT_LEGACY_FORMATTING_PATTERNS && function() {
    return /\d(?=[^,}][^,}])/g;
}; // A regular expression that is used to determine if a `format` is
// suitable to be used in the "as you type formatter".
// A `format` is suitable when the resulting formatted number has
// the same digits as the user has entered.
//
// In the simplest case, that would mean that the format
// doesn't add any additional digits when formatting a number.
// Google says that it also shouldn't add "star" (`*`) characters,
// like it does in some Israeli formats.
// Such basic format would only contain "valid punctuation"
// and "captured group" identifiers ($1, $2, etc).
//
// An example of a format that adds additional digits:
//
// Country: `AR` (Argentina).
// Format:
// {
//    "pattern": "(\\d)(\\d{2})(\\d{4})(\\d{4})",
//    "leading_digits_patterns": ["91"],
//    "national_prefix_formatting_rule": "0$1",
//    "format": "$2 15-$3-$4",
//    "international_format": "$1 $2 $3-$4"
// }
//
// In the format above, the `format` adds `15` to the digits when formatting a number.
// A sidenote: this format actually is suitable because `national_prefix_for_parsing`
// has previously removed `15` from a national number, so re-adding `15` in `format`
// doesn't actually result in any extra digits added to user's input.
// But verifying that would be a complex procedure, so the code chooses a simpler path:
// it simply filters out all `format`s that contain anything but "captured group" ids.
//
// This regular expression is called `ELIGIBLE_FORMAT_PATTERN` in Google's
// `libphonenumber` code.
//
var $77c6294fe142cf3c$var$NON_ALTERING_FORMAT_REG_EXP = new RegExp("^[" + (0, $hoHfs.VALID_PUNCTUATION) + ']*' + '(\\$\\d[' + (0, $hoHfs.VALID_PUNCTUATION) + ']*)+' + '$'); // This is the minimum length of the leading digits of a phone number
// to guarantee the first "leading digits pattern" for a phone number format
// to be preemptive.
var $77c6294fe142cf3c$var$MIN_LEADING_DIGITS_LENGTH = 3;
var $77c6294fe142cf3c$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AsYouTypeFormatter(_ref) {
        var _this = this;
        var state = _ref.state, metadata = _ref.metadata;
        $77c6294fe142cf3c$var$_classCallCheck(this, AsYouTypeFormatter);
        $77c6294fe142cf3c$var$_defineProperty(this, "getSeparatorAfterNationalPrefix", function(format) {
            // `US` metadata doesn't have a `national_prefix_formatting_rule`,
            // so the `if` condition below doesn't apply to `US`,
            // but in reality there shoudl be a separator
            // between a national prefix and a national (significant) number.
            // So `US` national prefix separator is a "special" "hardcoded" case.
            if (_this.isNANP) return ' ';
             // If a `format` has a `national_prefix_formatting_rule`
            // and that rule has a separator after a national prefix,
            // then it means that there should be a separator
            // between a national prefix and a national (significant) number.
            if (format && format.nationalPrefixFormattingRule() && $77c6294fe142cf3c$var$NATIONAL_PREFIX_SEPARATORS_PATTERN.test(format.nationalPrefixFormattingRule())) return ' ';
             // At this point, there seems to be no clear evidence that
            // there should be a separator between a national prefix
            // and a national (significant) number. So don't insert one.
            return '';
        });
        $77c6294fe142cf3c$var$_defineProperty(this, "shouldTryNationalPrefixFormattingRule", function(format, _ref2) {
            var international = _ref2.international, nationalPrefix = _ref2.nationalPrefix;
            if (format.nationalPrefixFormattingRule()) {
                // In some countries, `national_prefix_formatting_rule` is `($1)`,
                // so it applies even if the user hasn't input a national prefix.
                // `format.usesNationalPrefix()` detects such cases.
                var usesNationalPrefix = format.usesNationalPrefix();
                if (usesNationalPrefix && nationalPrefix || !usesNationalPrefix && !international) return true;
            }
        });
        this.metadata = metadata;
        this.resetFormat();
    }
    $77c6294fe142cf3c$var$_createClass(AsYouTypeFormatter, [
        {
            key: "resetFormat",
            value: function resetFormat() {
                this.chosenFormat = undefined;
                this.template = undefined;
                this.nationalNumberTemplate = undefined;
                this.populatedNationalNumberTemplate = undefined;
                this.populatedNationalNumberTemplatePosition = -1;
            }
        },
        {
            key: "reset",
            value: function reset(numberingPlan, state) {
                this.resetFormat();
                if (numberingPlan) {
                    this.isNANP = numberingPlan.callingCode() === '1';
                    this.matchingFormats = numberingPlan.formats();
                    if (state.nationalSignificantNumber) this.narrowDownMatchingFormats(state);
                } else {
                    this.isNANP = undefined;
                    this.matchingFormats = [];
                }
            }
        },
        {
            key: "format",
            value: function format(nextDigits, state) {
                var _this2 = this;
                // See if the phone number digits can be formatted as a complete phone number.
                // If not, use the results from `formatNationalNumberWithNextDigits()`,
                // which formats based on the chosen formatting pattern.
                //
                // Attempting to format complete phone number first is how it's done
                // in Google's `libphonenumber`, so this library just follows it.
                // Google's `libphonenumber` code doesn't explain in detail why does it
                // attempt to format digits as a complete phone number
                // instead of just going with a previoulsy (or newly) chosen `format`:
                //
                // "Checks to see if there is an exact pattern match for these digits.
                //  If so, we should use this instead of any other formatting template
                //  whose leadingDigitsPattern also matches the input."
                //
                if ((0, $41ESN.canFormatCompleteNumber)(state.nationalSignificantNumber, this.metadata)) for(var _iterator = this.matchingFormats, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;){
                    var _ref3;
                    if (_isArray) {
                        if (_i >= _iterator.length) break;
                        _ref3 = _iterator[_i++];
                    } else {
                        _i = _iterator.next();
                        if (_i.done) break;
                        _ref3 = _i.value;
                    }
                    var format = _ref3;
                    var formattedCompleteNumber = (0, $41ESN.default)(state, format, {
                        metadata: this.metadata,
                        shouldTryNationalPrefixFormattingRule: function shouldTryNationalPrefixFormattingRule(format) {
                            return _this2.shouldTryNationalPrefixFormattingRule(format, {
                                international: state.international,
                                nationalPrefix: state.nationalPrefix
                            });
                        },
                        getSeparatorAfterNationalPrefix: this.getSeparatorAfterNationalPrefix
                    });
                    if (formattedCompleteNumber) {
                        this.resetFormat();
                        this.chosenFormat = format;
                        this.setNationalNumberTemplate(formattedCompleteNumber.replace(/\d/g, (0, $lQt3h.DIGIT_PLACEHOLDER)), state);
                        this.populatedNationalNumberTemplate = formattedCompleteNumber; // With a new formatting template, the matched position
                        // using the old template needs to be reset.
                        this.populatedNationalNumberTemplatePosition = this.template.lastIndexOf((0, $lQt3h.DIGIT_PLACEHOLDER));
                        return formattedCompleteNumber;
                    }
                }
                 // Format the digits as a partial (incomplete) phone number
                // using the previously chosen formatting pattern (or a newly chosen one).
                return this.formatNationalNumberWithNextDigits(nextDigits, state);
            } // Formats the next phone number digits.
        },
        {
            key: "formatNationalNumberWithNextDigits",
            value: function formatNationalNumberWithNextDigits(nextDigits, state) {
                var previouslyChosenFormat = this.chosenFormat; // Choose a format from the list of matching ones.
                var newlyChosenFormat = this.chooseFormat(state);
                if (newlyChosenFormat) {
                    if (newlyChosenFormat === previouslyChosenFormat) // If it can format the next (current) digits
                    // using the previously chosen phone number format
                    // then return the updated formatted number.
                    return this.formatNextNationalNumberDigits(nextDigits);
                    else // If a more appropriate phone number format
                    // has been chosen for these "leading digits",
                    // then re-format the national phone number part
                    // using the newly selected format.
                    return this.formatNextNationalNumberDigits(state.getNationalDigits());
                }
            }
        },
        {
            key: "narrowDownMatchingFormats",
            value: function narrowDownMatchingFormats(_ref4) {
                var _this3 = this;
                var nationalSignificantNumber = _ref4.nationalSignificantNumber, nationalPrefix = _ref4.nationalPrefix, international = _ref4.international;
                var leadingDigits = nationalSignificantNumber; // "leading digits" pattern list starts with a
                // "leading digits" pattern fitting a maximum of 3 leading digits.
                // So, after a user inputs 3 digits of a national (significant) phone number
                // this national (significant) number can already be formatted.
                // The next "leading digits" pattern is for 4 leading digits max,
                // and the "leading digits" pattern after it is for 5 leading digits max, etc.
                // This implementation is different from Google's
                // in that it searches for a fitting format
                // even if the user has entered less than
                // `MIN_LEADING_DIGITS_LENGTH` digits of a national number.
                // Because some leading digit patterns already match for a single first digit.
                var leadingDigitsPatternIndex = leadingDigits.length - $77c6294fe142cf3c$var$MIN_LEADING_DIGITS_LENGTH;
                if (leadingDigitsPatternIndex < 0) leadingDigitsPatternIndex = 0;
                this.matchingFormats = this.matchingFormats.filter(function(format) {
                    return _this3.formatSuits(format, international, nationalPrefix) && _this3.formatMatches(format, leadingDigits, leadingDigitsPatternIndex);
                }); // If there was a phone number format chosen
                // and it no longer holds given the new leading digits then reset it.
                // The test for this `if` condition is marked as:
                // "Reset a chosen format when it no longer holds given the new leading digits".
                // To construct a valid test case for this one can find a country
                // in `PhoneNumberMetadata.xml` yielding one format for 3 `<leadingDigits>`
                // and yielding another format for 4 `<leadingDigits>` (Australia in this case).
                if (this.chosenFormat && this.matchingFormats.indexOf(this.chosenFormat) === -1) this.resetFormat();
            }
        },
        {
            key: "formatSuits",
            value: function formatSuits(format, international, nationalPrefix) {
                // When a prefix before a national (significant) number is
                // simply a national prefix, then it's parsed as `this.nationalPrefix`.
                // In more complex cases, a prefix before national (significant) number
                // could include a national prefix as well as some "capturing groups",
                // and in that case there's no info whether a national prefix has been parsed.
                // If national prefix is not used when formatting a phone number
                // using this format, but a national prefix has been entered by the user,
                // and was extracted, then discard such phone number format.
                // In Google's "AsYouType" formatter code, the equivalent would be this part:
                // https://github.com/google/libphonenumber/blob/0a45cfd96e71cad8edb0e162a70fcc8bd9728933/java/libphonenumber/src/com/google/i18n/phonenumbers/AsYouTypeFormatter.java#L175-L184
                if (nationalPrefix && !format.usesNationalPrefix() && // !format.domesticCarrierCodeFormattingRule() &&
                !format.nationalPrefixIsOptionalWhenFormattingInNationalFormat()) return false;
                 // If national prefix is mandatory for this phone number format
                // and there're no guarantees that a national prefix is present in user input
                // then discard this phone number format as not suitable.
                // In Google's "AsYouType" formatter code, the equivalent would be this part:
                // https://github.com/google/libphonenumber/blob/0a45cfd96e71cad8edb0e162a70fcc8bd9728933/java/libphonenumber/src/com/google/i18n/phonenumbers/AsYouTypeFormatter.java#L185-L193
                if (!international && !nationalPrefix && format.nationalPrefixIsMandatoryWhenFormattingInNationalFormat()) return false;
                return true;
            }
        },
        {
            key: "formatMatches",
            value: function formatMatches(format, leadingDigits, leadingDigitsPatternIndex) {
                var leadingDigitsPatternsCount = format.leadingDigitsPatterns().length; // If this format is not restricted to a certain
                // leading digits pattern then it fits.
                if (leadingDigitsPatternsCount === 0) return true;
                 // Start excluding any non-matching formats only when the
                // national number entered so far is at least 3 digits long,
                // otherwise format matching would give false negatives.
                // For example, when the digits entered so far are `2`
                // and the leading digits pattern is `21` –
                // it's quite obvious in this case that the format could be the one
                // but due to the absence of further digits it would give false negative.
                if (leadingDigits.length < $77c6294fe142cf3c$var$MIN_LEADING_DIGITS_LENGTH) return true;
                 // If at least `MIN_LEADING_DIGITS_LENGTH` digits of a national number are available
                // then format matching starts narrowing down the list of possible formats
                // (only previously matched formats are considered for next digits).
                leadingDigitsPatternIndex = Math.min(leadingDigitsPatternIndex, leadingDigitsPatternsCount - 1);
                var leadingDigitsPattern = format.leadingDigitsPatterns()[leadingDigitsPatternIndex]; // Brackets are required for `^` to be applied to
                // all or-ed (`|`) parts, not just the first one.
                return new RegExp("^(".concat(leadingDigitsPattern, ")")).test(leadingDigits);
            }
        },
        {
            key: "getFormatFormat",
            value: function getFormatFormat(format, international) {
                return international ? format.internationalFormat() : format.format();
            }
        },
        {
            key: "chooseFormat",
            value: function chooseFormat(state) {
                var _this4 = this;
                var _loop2 = function _loop2() {
                    if (_isArray2) {
                        if (_i2 >= _iterator2.length) return "break";
                        _ref5 = _iterator2[_i2++];
                    } else {
                        _i2 = _iterator2.next();
                        if (_i2.done) return "break";
                        _ref5 = _i2.value;
                    }
                    var format = _ref5;
                    // If this format is currently being used
                    // and is still suitable, then stick to it.
                    if (_this4.chosenFormat === format) return "break";
                     // Sometimes, a formatting rule inserts additional digits in a phone number,
                    // and "as you type" formatter can't do that: it should only use the digits
                    // that the user has input.
                    //
                    // For example, in Argentina, there's a format for mobile phone numbers:
                    //
                    // {
                    //    "pattern": "(\\d)(\\d{2})(\\d{4})(\\d{4})",
                    //    "leading_digits_patterns": ["91"],
                    //    "national_prefix_formatting_rule": "0$1",
                    //    "format": "$2 15-$3-$4",
                    //    "international_format": "$1 $2 $3-$4"
                    // }
                    //
                    // In that format, `international_format` is used instead of `format`
                    // because `format` inserts `15` in the formatted number,
                    // and `AsYouType` formatter should only use the digits
                    // the user has actually input, without adding any extra digits.
                    // In this case, it wouldn't make a difference, because the `15`
                    // is first stripped when applying `national_prefix_for_parsing`
                    // and then re-added when using `format`, so in reality it doesn't
                    // add any new digits to the number, but to detect that, the code
                    // would have to be more complex: it would have to try formatting
                    // the digits using the format and then see if any digits have
                    // actually been added or removed, and then, every time a new digit
                    // is input, it should re-check whether the chosen format doesn't
                    // alter the digits.
                    //
                    // Google's code doesn't go that far, and so does this library:
                    // it simply requires that a `format` doesn't add any additonal
                    // digits to user's input.
                    //
                    // Also, people in general should move from inputting phone numbers
                    // in national format (possibly with national prefixes)
                    // and use international phone number format instead:
                    // it's a logical thing in the modern age of mobile phones,
                    // globalization and the internet.
                    //
                    /* istanbul ignore if */ if (!$77c6294fe142cf3c$var$NON_ALTERING_FORMAT_REG_EXP.test(_this4.getFormatFormat(format, state.international))) return "continue";
                    if (!_this4.createTemplateForFormat(format, state)) {
                        // Remove the format if it can't generate a template.
                        _this4.matchingFormats = _this4.matchingFormats.filter(function(_) {
                            return _ !== format;
                        });
                        return "continue";
                    }
                    _this4.chosenFormat = format;
                    return "break";
                };
                // When there are multiple available formats, the formatter uses the first
                // format where a formatting template could be created.
                _loop: for(var _iterator2 = this.matchingFormats.slice(), _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;){
                    var _ref5;
                    var _ret = _loop2();
                    switch(_ret){
                        case "break":
                            break _loop;
                        case "continue":
                            continue;
                    }
                }
                if (!this.chosenFormat) // No format matches the national (significant) phone number.
                this.resetFormat();
                return this.chosenFormat;
            }
        },
        {
            key: "createTemplateForFormat",
            value: function createTemplateForFormat(format, state) {
                // The formatter doesn't format numbers when numberPattern contains '|', e.g.
                // (20|3)\d{4}. In those cases we quickly return.
                // (Though there's no such format in current metadata)
                /* istanbul ignore if */ if ($77c6294fe142cf3c$var$SUPPORT_LEGACY_FORMATTING_PATTERNS && format.pattern().indexOf('|') >= 0) return;
                 // Get formatting template for this phone number format
                var template = this.getTemplateForFormat(format, state); // If the national number entered is too long
                // for any phone number format, then abort.
                if (template) {
                    this.setNationalNumberTemplate(template, state);
                    return true;
                }
            }
        },
        {
            key: "getInternationalPrefixBeforeCountryCallingCode",
            value: function getInternationalPrefixBeforeCountryCallingCode(_ref6, options) {
                var IDDPrefix = _ref6.IDDPrefix, missingPlus = _ref6.missingPlus;
                if (IDDPrefix) return options && options.spacing === false ? IDDPrefix : IDDPrefix + ' ';
                if (missingPlus) return '';
                return '+';
            }
        },
        {
            key: "getTemplate",
            value: function getTemplate(state) {
                if (!this.template) return;
                 // `this.template` holds the template for a "complete" phone number.
                // The currently entered phone number is most likely not "complete",
                // so trim all non-populated digits.
                var index = -1;
                var i = 0;
                var internationalPrefix = state.international ? this.getInternationalPrefixBeforeCountryCallingCode(state, {
                    spacing: false
                }) : '';
                while(i < internationalPrefix.length + state.getDigitsWithoutInternationalPrefix().length){
                    index = this.template.indexOf((0, $lQt3h.DIGIT_PLACEHOLDER), index + 1);
                    i++;
                }
                return (0, $lQt3h.cutAndStripNonPairedParens)(this.template, index + 1);
            }
        },
        {
            key: "setNationalNumberTemplate",
            value: function setNationalNumberTemplate(template, state) {
                this.nationalNumberTemplate = template;
                this.populatedNationalNumberTemplate = template; // With a new formatting template, the matched position
                // using the old template needs to be reset.
                this.populatedNationalNumberTemplatePosition = -1; // For convenience, the public `.template` property
                // contains the whole international number
                // if the phone number being input is international:
                // 'x' for the '+' sign, 'x'es for the country phone code,
                // a spacebar and then the template for the formatted national number.
                if (state.international) this.template = this.getInternationalPrefixBeforeCountryCallingCode(state).replace(/[\d\+]/g, (0, $lQt3h.DIGIT_PLACEHOLDER)) + (0, $lQt3h.repeat)((0, $lQt3h.DIGIT_PLACEHOLDER), state.callingCode.length) + ' ' + template;
                else this.template = template;
            }
        },
        {
            key: "getTemplateForFormat",
            value: function getTemplateForFormat(format, _ref7) {
                var nationalSignificantNumber = _ref7.nationalSignificantNumber, international = _ref7.international, nationalPrefix = _ref7.nationalPrefix, complexPrefixBeforeNationalSignificantNumber = _ref7.complexPrefixBeforeNationalSignificantNumber;
                var pattern = format.pattern();
                /* istanbul ignore else */ if ($77c6294fe142cf3c$var$SUPPORT_LEGACY_FORMATTING_PATTERNS) pattern = pattern // Replace anything in the form of [..] with \d
                .replace($77c6294fe142cf3c$var$CREATE_CHARACTER_CLASS_PATTERN(), '\\d') // Replace any standalone digit (not the one in `{}`) with \d
                .replace($77c6294fe142cf3c$var$CREATE_STANDALONE_DIGIT_PATTERN(), '\\d');
                 // Generate a dummy national number (consisting of `9`s)
                // that fits this format's `pattern`.
                //
                // This match will always succeed,
                // because the "longest dummy phone number"
                // has enough length to accomodate any possible
                // national phone number format pattern.
                //
                var digits = $77c6294fe142cf3c$var$LONGEST_DUMMY_PHONE_NUMBER.match(pattern)[0]; // If the national number entered is too long
                // for any phone number format, then abort.
                if (nationalSignificantNumber.length > digits.length) return;
                 // Get a formatting template which can be used to efficiently format
                // a partial number where digits are added one by one.
                // Below `strictPattern` is used for the
                // regular expression (with `^` and `$`).
                // This wasn't originally in Google's `libphonenumber`
                // and I guess they don't really need it
                // because they're not using "templates" to format phone numbers
                // but I added `strictPattern` after encountering
                // South Korean phone number formatting bug.
                //
                // Non-strict regular expression bug demonstration:
                //
                // this.nationalSignificantNumber : `111111111` (9 digits)
                //
                // pattern : (\d{2})(\d{3,4})(\d{4})
                // format : `$1 $2 $3`
                // digits : `9999999999` (10 digits)
                //
                // '9999999999'.replace(new RegExp(/(\d{2})(\d{3,4})(\d{4})/g), '$1 $2 $3') = "99 9999 9999"
                //
                // template : xx xxxx xxxx
                //
                // But the correct template in this case is `xx xxx xxxx`.
                // The template was generated incorrectly because of the
                // `{3,4}` variability in the `pattern`.
                //
                // The fix is, if `this.nationalSignificantNumber` has already sufficient length
                // to satisfy the `pattern` completely then `this.nationalSignificantNumber`
                // is used instead of `digits`.
                var strictPattern = new RegExp('^' + pattern + '$');
                var nationalNumberDummyDigits = nationalSignificantNumber.replace(/\d/g, $77c6294fe142cf3c$var$DUMMY_DIGIT); // If `this.nationalSignificantNumber` has already sufficient length
                // to satisfy the `pattern` completely then use it
                // instead of `digits`.
                if (strictPattern.test(nationalNumberDummyDigits)) digits = nationalNumberDummyDigits;
                var numberFormat = this.getFormatFormat(format, international);
                var nationalPrefixIncludedInTemplate; // If a user did input a national prefix (and that's guaranteed),
                // and if a `format` does have a national prefix formatting rule,
                // then see if that national prefix formatting rule
                // prepends exactly the same national prefix the user has input.
                // If that's the case, then use the `format` with the national prefix formatting rule.
                // Otherwise, use  the `format` without the national prefix formatting rule,
                // and prepend a national prefix manually to it.
                if (this.shouldTryNationalPrefixFormattingRule(format, {
                    international: international,
                    nationalPrefix: nationalPrefix
                })) {
                    var numberFormatWithNationalPrefix = numberFormat.replace((0, $cQ2v2.FIRST_GROUP_PATTERN), format.nationalPrefixFormattingRule()); // If `national_prefix_formatting_rule` of a `format` simply prepends
                    // national prefix at the start of a national (significant) number,
                    // then such formatting can be used with `AsYouType` formatter.
                    // There seems to be no `else` case: everywhere in metadata,
                    // national prefix formatting rule is national prefix + $1,
                    // or `($1)`, in which case such format isn't even considered
                    // when the user has input a national prefix.
                    /* istanbul ignore else */ if ((0, $fkobN.default)(format.nationalPrefixFormattingRule()) === (nationalPrefix || '') + (0, $fkobN.default)('$1')) {
                        numberFormat = numberFormatWithNationalPrefix;
                        nationalPrefixIncludedInTemplate = true; // Replace all digits of the national prefix in the formatting template
                        // with `DIGIT_PLACEHOLDER`s.
                        if (nationalPrefix) {
                            var i = nationalPrefix.length;
                            while(i > 0){
                                numberFormat = numberFormat.replace(/\d/, (0, $lQt3h.DIGIT_PLACEHOLDER));
                                i--;
                            }
                        }
                    }
                } // Generate formatting template for this phone number format.
                var template = digits // Format the dummy phone number according to the format.
                .replace(new RegExp(pattern), numberFormat) // Replace each dummy digit with a DIGIT_PLACEHOLDER.
                .replace(new RegExp($77c6294fe142cf3c$var$DUMMY_DIGIT, 'g'), (0, $lQt3h.DIGIT_PLACEHOLDER)); // If a prefix of a national (significant) number is not as simple
                // as just a basic national prefix, then just prepend such prefix
                // before the national (significant) number, optionally spacing
                // the two with a whitespace.
                if (!nationalPrefixIncludedInTemplate) {
                    if (complexPrefixBeforeNationalSignificantNumber) // Prepend the prefix to the template manually.
                    template = (0, $lQt3h.repeat)((0, $lQt3h.DIGIT_PLACEHOLDER), complexPrefixBeforeNationalSignificantNumber.length) + ' ' + template;
                    else if (nationalPrefix) // Prepend national prefix to the template manually.
                    template = (0, $lQt3h.repeat)((0, $lQt3h.DIGIT_PLACEHOLDER), nationalPrefix.length) + this.getSeparatorAfterNationalPrefix(format) + template;
                }
                if (international) template = (0, $1o9N5.default)(template);
                return template;
            }
        },
        {
            key: "formatNextNationalNumberDigits",
            value: function formatNextNationalNumberDigits(digits) {
                var result = (0, $lQt3h.populateTemplateWithDigits)(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition, digits);
                if (!result) {
                    // Reset the format.
                    this.resetFormat();
                    return;
                }
                this.populatedNationalNumberTemplate = result[0];
                this.populatedNationalNumberTemplatePosition = result[1]; // Return the formatted phone number so far.
                return (0, $lQt3h.cutAndStripNonPairedParens)(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition + 1); // The old way which was good for `input-format` but is not so good
            // for `react-phone-number-input`'s default input (`InputBasic`).
            // return closeNonPairedParens(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition + 1)
            // 	.replace(new RegExp(DIGIT_PLACEHOLDER, 'g'), ' ')
            }
        }
    ]);
    return AsYouTypeFormatter;
}();

});
parcelRegister("lQt3h", function(module, exports) {

$parcel$export(module.exports, "DIGIT_PLACEHOLDER", () => $fe74fd6609d199cf$export$2a0174a7c311f338);
$parcel$export(module.exports, "repeat", () => $fe74fd6609d199cf$export$76d90c956114f2c2);
$parcel$export(module.exports, "cutAndStripNonPairedParens", () => $fe74fd6609d199cf$export$ac095dcff0205861);
$parcel$export(module.exports, "populateTemplateWithDigits", () => $fe74fd6609d199cf$export$a15547494b55ca4e);
// Should be the same as `DIGIT_PLACEHOLDER` in `libphonenumber-metadata-generator`.
var $fe74fd6609d199cf$export$2a0174a7c311f338 = 'x'; // '\u2008' (punctuation space)
var $fe74fd6609d199cf$var$DIGIT_PLACEHOLDER_MATCHER = new RegExp($fe74fd6609d199cf$export$2a0174a7c311f338); // Counts all occurences of a symbol in a string.
function $fe74fd6609d199cf$export$af0de81b5898251d(symbol, string) {
    var count = 0; // Using `.split('')` to iterate through a string here
    // to avoid requiring `Symbol.iterator` polyfill.
    // `.split('')` is generally not safe for Unicode,
    // but in this particular case for counting brackets it is safe.
    // for (const character of string)
    for(var _iterator = string.split(''), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;){
        var _ref;
        if (_isArray) {
            if (_i >= _iterator.length) break;
            _ref = _iterator[_i++];
        } else {
            _i = _iterator.next();
            if (_i.done) break;
            _ref = _i.value;
        }
        var character = _ref;
        if (character === symbol) count++;
    }
    return count;
} // Repeats a string (or a symbol) N times.
function $fe74fd6609d199cf$export$76d90c956114f2c2(string, times) {
    if (times < 1) return '';
    var result = '';
    while(times > 1){
        if (times & 1) result += string;
        times >>= 1;
        string += string;
    }
    return result + string;
}
function $fe74fd6609d199cf$export$ac095dcff0205861(string, cutBeforeIndex) {
    if (string[cutBeforeIndex] === ')') cutBeforeIndex++;
    return $fe74fd6609d199cf$export$a464e056bc212edb(string.slice(0, cutBeforeIndex));
}
function $fe74fd6609d199cf$export$54ba366c9ffed8f9(template, cut_before) {
    var retained_template = template.slice(0, cut_before);
    var opening_braces = $fe74fd6609d199cf$export$af0de81b5898251d('(', retained_template);
    var closing_braces = $fe74fd6609d199cf$export$af0de81b5898251d(')', retained_template);
    var dangling_braces = opening_braces - closing_braces;
    while(dangling_braces > 0 && cut_before < template.length){
        if (template[cut_before] === ')') dangling_braces--;
        cut_before++;
    }
    return template.slice(0, cut_before);
}
function $fe74fd6609d199cf$export$a464e056bc212edb(string) {
    var dangling_braces = [];
    var i = 0;
    while(i < string.length){
        if (string[i] === '(') dangling_braces.push(i);
        else if (string[i] === ')') dangling_braces.pop();
        i++;
    }
    var start = 0;
    var cleared_string = '';
    dangling_braces.push(string.length);
    for(var _i2 = 0, _dangling_braces = dangling_braces; _i2 < _dangling_braces.length; _i2++){
        var index = _dangling_braces[_i2];
        cleared_string += string.slice(start, index);
        start = index + 1;
    }
    return cleared_string;
}
function $fe74fd6609d199cf$export$a15547494b55ca4e(template, position, digits) {
    // Using `.split('')` to iterate through a string here
    // to avoid requiring `Symbol.iterator` polyfill.
    // `.split('')` is generally not safe for Unicode,
    // but in this particular case for `digits` it is safe.
    // for (const digit of digits)
    for(var _iterator2 = digits.split(''), _isArray2 = Array.isArray(_iterator2), _i3 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;){
        var _ref2;
        if (_isArray2) {
            if (_i3 >= _iterator2.length) break;
            _ref2 = _iterator2[_i3++];
        } else {
            _i3 = _iterator2.next();
            if (_i3.done) break;
            _ref2 = _i3.value;
        }
        var digit = _ref2;
        // If there is room for more digits in current `template`,
        // then set the next digit in the `template`,
        // and return the formatted digits so far.
        // If more digits are entered than the current format could handle.
        if (template.slice(position + 1).search($fe74fd6609d199cf$var$DIGIT_PLACEHOLDER_MATCHER) < 0) return;
        position = template.search($fe74fd6609d199cf$var$DIGIT_PLACEHOLDER_MATCHER);
        template = template.replace($fe74fd6609d199cf$var$DIGIT_PLACEHOLDER_MATCHER, digit);
    }
    return [
        template,
        position
    ];
}

});

parcelRegister("41ESN", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ee6f7e5d3aef803$export$2e2bcd8739ae039);
$parcel$export(module.exports, "canFormatCompleteNumber", () => $2ee6f7e5d3aef803$export$9e33d25ea5d3e526);

var $jllIH = parcelRequire("jllIH");

var $fkobN = parcelRequire("fkobN");

var $cQ2v2 = parcelRequire("cQ2v2");
function $2ee6f7e5d3aef803$export$2e2bcd8739ae039(state, format, _ref) {
    var metadata = _ref.metadata, shouldTryNationalPrefixFormattingRule = _ref.shouldTryNationalPrefixFormattingRule, getSeparatorAfterNationalPrefix = _ref.getSeparatorAfterNationalPrefix;
    var matcher = new RegExp("^(?:".concat(format.pattern(), ")$"));
    if (matcher.test(state.nationalSignificantNumber)) return $2ee6f7e5d3aef803$var$formatNationalNumberWithAndWithoutNationalPrefixFormattingRule(state, format, {
        metadata: metadata,
        shouldTryNationalPrefixFormattingRule: shouldTryNationalPrefixFormattingRule,
        getSeparatorAfterNationalPrefix: getSeparatorAfterNationalPrefix
    });
}
function $2ee6f7e5d3aef803$export$9e33d25ea5d3e526(nationalSignificantNumber, metadata) {
    return (0, $jllIH.default)(nationalSignificantNumber, metadata) === 'IS_POSSIBLE';
}
function $2ee6f7e5d3aef803$var$formatNationalNumberWithAndWithoutNationalPrefixFormattingRule(state, format, _ref2) {
    var metadata = _ref2.metadata, shouldTryNationalPrefixFormattingRule = _ref2.shouldTryNationalPrefixFormattingRule, getSeparatorAfterNationalPrefix = _ref2.getSeparatorAfterNationalPrefix;
    // `format` has already been checked for `nationalPrefix` requirement.
    var nationalSignificantNumber = state.nationalSignificantNumber, international = state.international, nationalPrefix = state.nationalPrefix, carrierCode = state.carrierCode; // Format the number with using `national_prefix_formatting_rule`.
    // If the resulting formatted number is a valid formatted number, then return it.
    //
    // Google's AsYouType formatter is different in a way that it doesn't try
    // to format using the "national prefix formatting rule", and instead it
    // simply prepends a national prefix followed by a " " character.
    // This code does that too, but as a fallback.
    // The reason is that "national prefix formatting rule" may use parentheses,
    // which wouldn't be included has it used the simpler Google's way.
    //
    if (shouldTryNationalPrefixFormattingRule(format)) {
        var formattedNumber = $2ee6f7e5d3aef803$var$formatNationalNumber(state, format, {
            useNationalPrefixFormattingRule: true,
            getSeparatorAfterNationalPrefix: getSeparatorAfterNationalPrefix,
            metadata: metadata
        });
        if (formattedNumber) return formattedNumber;
    } // Format the number without using `national_prefix_formatting_rule`.
    return $2ee6f7e5d3aef803$var$formatNationalNumber(state, format, {
        useNationalPrefixFormattingRule: false,
        getSeparatorAfterNationalPrefix: getSeparatorAfterNationalPrefix,
        metadata: metadata
    });
}
function $2ee6f7e5d3aef803$var$formatNationalNumber(state, format, _ref3) {
    var metadata = _ref3.metadata, useNationalPrefixFormattingRule = _ref3.useNationalPrefixFormattingRule, getSeparatorAfterNationalPrefix = _ref3.getSeparatorAfterNationalPrefix;
    var formattedNationalNumber = (0, $cQ2v2.default)(state.nationalSignificantNumber, format, {
        carrierCode: state.carrierCode,
        useInternationalFormat: state.international,
        withNationalPrefix: useNationalPrefixFormattingRule,
        metadata: metadata
    });
    if (!useNationalPrefixFormattingRule) {
        if (state.nationalPrefix) // If a national prefix was extracted, then just prepend it,
        // followed by a " " character.
        formattedNationalNumber = state.nationalPrefix + getSeparatorAfterNationalPrefix(format) + formattedNationalNumber;
        else if (state.complexPrefixBeforeNationalSignificantNumber) formattedNationalNumber = state.complexPrefixBeforeNationalSignificantNumber + ' ' + formattedNationalNumber;
    }
    if ($2ee6f7e5d3aef803$var$isValidFormattedNationalNumber(formattedNationalNumber, state)) return formattedNationalNumber;
} // Check that the formatted phone number contains exactly
// the same digits that have been input by the user.
// For example, when "0111523456789" is input for `AR` country,
// the extracted `this.nationalSignificantNumber` is "91123456789",
// which means that the national part of `this.digits` isn't simply equal to
// `this.nationalPrefix` + `this.nationalSignificantNumber`.
//
// Also, a `format` can add extra digits to the `this.nationalSignificantNumber`
// being formatted via `metadata[country].national_prefix_transform_rule`.
// For example, for `VI` country, it prepends `340` to the national number,
// and if this check hasn't been implemented, then there would be a bug
// when `340` "area coude" is "duplicated" during input for `VI` country:
// https://github.com/catamphetamine/libphonenumber-js/issues/318
//
// So, all these "gotchas" are filtered out.
//
// In the original Google's code, the comments say:
// "Check that we didn't remove nor add any extra digits when we matched
// this formatting pattern. This usually happens after we entered the last
// digit during AYTF. Eg: In case of MX, we swallow mobile token (1) when
// formatted but AYTF should retain all the number entered and not change
// in order to match a format (of same leading digits and length) display
// in that way."
// "If it's the same (i.e entered number and format is same), then it's
// safe to return this in formatted number as nothing is lost / added."
// Otherwise, don't use this format.
// https://github.com/google/libphonenumber/commit/3e7c1f04f5e7200f87fb131e6f85c6e99d60f510#diff-9149457fa9f5d608a11bb975c6ef4bc5
// https://github.com/google/libphonenumber/commit/3ac88c7106e7dcb553bcc794b15f19185928a1c6#diff-2dcb77e833422ee304da348b905cde0b
//
function $2ee6f7e5d3aef803$var$isValidFormattedNationalNumber(formattedNationalNumber, state) {
    return (0, $fkobN.default)(formattedNationalNumber) === state.getNationalDigits();
}

});


parcelRegister("fD8Ui", function(module, exports) {

$parcel$export(module.exports, "default", () => $b611684da4cccb02$export$2e2bcd8739ae039);

var $l3IVT = parcelRequire("l3IVT");

var $6yPcr = parcelRequire("6yPcr");

var $7H2OH = parcelRequire("7H2OH");

var $lQq7N = parcelRequire("lQq7N");

var $fkobN = parcelRequire("fkobN");

var $hoHfs = parcelRequire("hoHfs");
function $b611684da4cccb02$var$_slicedToArray(arr, i) {
    return $b611684da4cccb02$var$_arrayWithHoles(arr) || $b611684da4cccb02$var$_iterableToArrayLimit(arr, i) || $b611684da4cccb02$var$_nonIterableRest();
}
function $b611684da4cccb02$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
function $b611684da4cccb02$var$_iterableToArrayLimit(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $b611684da4cccb02$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $b611684da4cccb02$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $b611684da4cccb02$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $b611684da4cccb02$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $b611684da4cccb02$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $b611684da4cccb02$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
var $b611684da4cccb02$var$VALID_FORMATTED_PHONE_NUMBER_DIGITS_PART = '[' + (0, $hoHfs.VALID_PUNCTUATION) + (0, $hoHfs.VALID_DIGITS) + ']+';
var $b611684da4cccb02$var$VALID_FORMATTED_PHONE_NUMBER_DIGITS_PART_PATTERN = new RegExp('^' + $b611684da4cccb02$var$VALID_FORMATTED_PHONE_NUMBER_DIGITS_PART + '$', 'i');
var $b611684da4cccb02$var$VALID_FORMATTED_PHONE_NUMBER_PART = "(?:[" + (0, $hoHfs.PLUS_CHARS) + ']' + '[' + (0, $hoHfs.VALID_PUNCTUATION) + (0, $hoHfs.VALID_DIGITS) + ']*' + '|' + '[' + (0, $hoHfs.VALID_PUNCTUATION) + (0, $hoHfs.VALID_DIGITS) + ']+' + ')';
var $b611684da4cccb02$var$AFTER_PHONE_NUMBER_DIGITS_END_PATTERN = new RegExp('[^' + (0, $hoHfs.VALID_PUNCTUATION) + (0, $hoHfs.VALID_DIGITS) + ']+' + '.*' + '$'); // Tests whether `national_prefix_for_parsing` could match
// different national prefixes.
// Matches anything that's not a digit or a square bracket.
var $b611684da4cccb02$var$COMPLEX_NATIONAL_PREFIX = /[^\d\[\]]/;
var $b611684da4cccb02$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AsYouTypeParser(_ref) {
        var defaultCountry = _ref.defaultCountry, defaultCallingCode = _ref.defaultCallingCode, metadata = _ref.metadata, onNationalSignificantNumberChange = _ref.onNationalSignificantNumberChange;
        $b611684da4cccb02$var$_classCallCheck(this, AsYouTypeParser);
        this.defaultCountry = defaultCountry;
        this.defaultCallingCode = defaultCallingCode;
        this.metadata = metadata;
        this.onNationalSignificantNumberChange = onNationalSignificantNumberChange;
    }
    $b611684da4cccb02$var$_createClass(AsYouTypeParser, [
        {
            key: "input",
            value: function input(text, state) {
                var _extractFormattedDigi = $b611684da4cccb02$export$84f1aacb72e7dba5(text), _extractFormattedDigi2 = $b611684da4cccb02$var$_slicedToArray(_extractFormattedDigi, 2), formattedDigits = _extractFormattedDigi2[0], hasPlus = _extractFormattedDigi2[1];
                var digits = (0, $fkobN.default)(formattedDigits); // Checks for a special case: just a leading `+` has been entered.
                var justLeadingPlus;
                if (hasPlus) {
                    if (!state.digits) {
                        state.startInternationalNumber();
                        if (!digits) justLeadingPlus = true;
                    }
                }
                if (digits) this.inputDigits(digits, state);
                return {
                    digits: digits,
                    justLeadingPlus: justLeadingPlus
                };
            }
        },
        {
            key: "inputDigits",
            value: function inputDigits(nextDigits, state) {
                var digits = state.digits;
                var hasReceivedThreeLeadingDigits = digits.length < 3 && digits.length + nextDigits.length >= 3; // Append phone number digits.
                state.appendDigits(nextDigits); // Attempt to extract IDD prefix:
                // Some users input their phone number in international format,
                // but in an "out-of-country" dialing format instead of using the leading `+`.
                // https://github.com/catamphetamine/libphonenumber-js/issues/185
                // Detect such numbers as soon as there're at least 3 digits.
                // Google's library attempts to extract IDD prefix at 3 digits,
                // so this library just copies that behavior.
                // I guess that's because the most commot IDD prefixes are
                // `00` (Europe) and `011` (US).
                // There exist really long IDD prefixes too:
                // for example, in Australia the default IDD prefix is `0011`,
                // and it could even be as long as `14880011`.
                // An IDD prefix is extracted here, and then every time when
                // there's a new digit and the number couldn't be formatted.
                if (hasReceivedThreeLeadingDigits) this.extractIddPrefix(state);
                if (this.isWaitingForCountryCallingCode(state)) {
                    if (!this.extractCountryCallingCode(state)) return;
                } else state.appendNationalSignificantNumberDigits(nextDigits);
                 // If a phone number is being input in international format,
                // then it's not valid for it to have a national prefix.
                // Still, some people incorrectly input such numbers with a national prefix.
                // In such cases, only attempt to strip a national prefix if the number becomes too long.
                // (but that is done later, not here)
                if (!state.international) {
                    if (!this.hasExtractedNationalSignificantNumber) this.extractNationalSignificantNumber(state.getNationalDigits(), state.update);
                }
            }
        },
        {
            key: "isWaitingForCountryCallingCode",
            value: function isWaitingForCountryCallingCode(_ref2) {
                var international = _ref2.international, callingCode = _ref2.callingCode;
                return international && !callingCode;
            } // Extracts a country calling code from a number
        },
        {
            key: "extractCountryCallingCode",
            value: function extractCountryCallingCode(state) {
                var _extractCountryCallin = (0, $l3IVT.default)('+' + state.getDigitsWithoutInternationalPrefix(), this.defaultCountry, this.defaultCallingCode, this.metadata.metadata), countryCallingCode = _extractCountryCallin.countryCallingCode, number = _extractCountryCallin.number;
                if (countryCallingCode) {
                    state.setCallingCode(countryCallingCode);
                    state.update({
                        nationalSignificantNumber: number
                    });
                    return true;
                }
            }
        },
        {
            key: "reset",
            value: function reset(numberingPlan) {
                if (numberingPlan) {
                    this.hasSelectedNumberingPlan = true;
                    var nationalPrefixForParsing = numberingPlan._nationalPrefixForParsing();
                    this.couldPossiblyExtractAnotherNationalSignificantNumber = nationalPrefixForParsing && $b611684da4cccb02$var$COMPLEX_NATIONAL_PREFIX.test(nationalPrefixForParsing);
                } else {
                    this.hasSelectedNumberingPlan = undefined;
                    this.couldPossiblyExtractAnotherNationalSignificantNumber = undefined;
                }
            }
        },
        {
            key: "extractNationalSignificantNumber",
            value: function extractNationalSignificantNumber(nationalDigits, setState) {
                if (!this.hasSelectedNumberingPlan) return;
                var _extractNationalNumbe = (0, $7H2OH.default)(nationalDigits, this.metadata), nationalPrefix = _extractNationalNumbe.nationalPrefix, nationalNumber = _extractNationalNumbe.nationalNumber, carrierCode = _extractNationalNumbe.carrierCode;
                if (nationalNumber === nationalDigits) return;
                this.onExtractedNationalNumber(nationalPrefix, carrierCode, nationalNumber, nationalDigits, setState);
                return true;
            }
        },
        {
            key: "extractAnotherNationalSignificantNumber",
            value: function extractAnotherNationalSignificantNumber(nationalDigits, prevNationalSignificantNumber, setState) {
                if (!this.hasExtractedNationalSignificantNumber) return this.extractNationalSignificantNumber(nationalDigits, setState);
                if (!this.couldPossiblyExtractAnotherNationalSignificantNumber) return;
                var _extractNationalNumbe2 = (0, $7H2OH.default)(nationalDigits, this.metadata), nationalPrefix = _extractNationalNumbe2.nationalPrefix, nationalNumber = _extractNationalNumbe2.nationalNumber, carrierCode = _extractNationalNumbe2.carrierCode; // If a national prefix has been extracted previously,
                // then it's always extracted as additional digits are added.
                // That's assuming `extractNationalNumberFromPossiblyIncompleteNumber()`
                // doesn't do anything different from what it currently does.
                // So, just in case, here's this check, though it doesn't occur.
                /* istanbul ignore if */ if (nationalNumber === prevNationalSignificantNumber) return;
                this.onExtractedNationalNumber(nationalPrefix, carrierCode, nationalNumber, nationalDigits, setState);
                return true;
            }
        },
        {
            key: "onExtractedNationalNumber",
            value: function onExtractedNationalNumber(nationalPrefix, carrierCode, nationalSignificantNumber, nationalDigits, setState) {
                var complexPrefixBeforeNationalSignificantNumber;
                var nationalSignificantNumberMatchesInput; // This check also works with empty `this.nationalSignificantNumber`.
                var nationalSignificantNumberIndex = nationalDigits.lastIndexOf(nationalSignificantNumber); // If the extracted national (significant) number is the
                // last substring of the `digits`, then it means that it hasn't been altered:
                // no digits have been removed from the national (significant) number
                // while applying `national_prefix_transform_rule`.
                // https://gitlab.com/catamphetamine/libphonenumber-js/-/blob/master/METADATA.md#national_prefix_for_parsing--national_prefix_transform_rule
                if (nationalSignificantNumberIndex >= 0 && nationalSignificantNumberIndex === nationalDigits.length - nationalSignificantNumber.length) {
                    nationalSignificantNumberMatchesInput = true; // If a prefix of a national (significant) number is not as simple
                    // as just a basic national prefix, then such prefix is stored in
                    // `this.complexPrefixBeforeNationalSignificantNumber` property and will be
                    // prepended "as is" to the national (significant) number to produce
                    // a formatted result.
                    var prefixBeforeNationalNumber = nationalDigits.slice(0, nationalSignificantNumberIndex); // `prefixBeforeNationalNumber` is always non-empty,
                    // because `onExtractedNationalNumber()` isn't called
                    // when a national (significant) number hasn't been actually "extracted":
                    // when a national (significant) number is equal to the national part of `digits`,
                    // then `onExtractedNationalNumber()` doesn't get called.
                    if (prefixBeforeNationalNumber !== nationalPrefix) complexPrefixBeforeNationalSignificantNumber = prefixBeforeNationalNumber;
                }
                setState({
                    nationalPrefix: nationalPrefix,
                    carrierCode: carrierCode,
                    nationalSignificantNumber: nationalSignificantNumber,
                    nationalSignificantNumberMatchesInput: nationalSignificantNumberMatchesInput,
                    complexPrefixBeforeNationalSignificantNumber: complexPrefixBeforeNationalSignificantNumber
                }); // `onExtractedNationalNumber()` is only called when
                // the national (significant) number actually did change.
                this.hasExtractedNationalSignificantNumber = true;
                this.onNationalSignificantNumberChange();
            }
        },
        {
            key: "reExtractNationalSignificantNumber",
            value: function reExtractNationalSignificantNumber(state) {
                // Attempt to extract a national prefix.
                //
                // Some people incorrectly input national prefix
                // in an international phone number.
                // For example, some people write British phone numbers as `+44(0)...`.
                //
                // Also, in some rare cases, it is valid for a national prefix
                // to be a part of an international phone number.
                // For example, mobile phone numbers in Mexico are supposed to be
                // dialled internationally using a `1` national prefix,
                // so the national prefix will be part of an international number.
                //
                // Quote from:
                // https://www.mexperience.com/dialing-cell-phones-in-mexico/
                //
                // "Dialing a Mexican cell phone from abroad
                // When you are calling a cell phone number in Mexico from outside Mexico,
                // it’s necessary to dial an additional “1” after Mexico’s country code
                // (which is “52”) and before the area code.
                // You also ignore the 045, and simply dial the area code and the
                // cell phone’s number.
                //
                // If you don’t add the “1”, you’ll receive a recorded announcement
                // asking you to redial using it.
                //
                // For example, if you are calling from the USA to a cell phone
                // in Mexico City, you would dial +52 – 1 – 55 – 1234 5678.
                // (Note that this is different to calling a land line in Mexico City
                // from abroad, where the number dialed would be +52 – 55 – 1234 5678)".
                //
                // Google's demo output:
                // https://libphonenumber.appspot.com/phonenumberparser?number=%2b5215512345678&country=MX
                //
                if (this.extractAnotherNationalSignificantNumber(state.getNationalDigits(), state.nationalSignificantNumber, state.update)) return true;
                 // If no format matches the phone number, then it could be
                // "a really long IDD" (quote from a comment in Google's library).
                // An IDD prefix is first extracted when the user has entered at least 3 digits,
                // and then here — every time when there's a new digit and the number
                // couldn't be formatted.
                // For example, in Australia the default IDD prefix is `0011`,
                // and it could even be as long as `14880011`.
                //
                // Could also check `!hasReceivedThreeLeadingDigits` here
                // to filter out the case when this check duplicates the one
                // already performed when there're 3 leading digits,
                // but it's not a big deal, and in most cases there
                // will be a suitable `format` when there're 3 leading digits.
                //
                if (this.extractIddPrefix(state)) {
                    this.extractCallingCodeAndNationalSignificantNumber(state);
                    return true;
                } // Google's AsYouType formatter supports sort of an "autocorrection" feature
                // when it "autocorrects" numbers that have been input for a country
                // with that country's calling code.
                // Such "autocorrection" feature looks weird, but different people have been requesting it:
                // https://github.com/catamphetamine/libphonenumber-js/issues/376
                // https://github.com/catamphetamine/libphonenumber-js/issues/375
                // https://github.com/catamphetamine/libphonenumber-js/issues/316
                if (this.fixMissingPlus(state)) {
                    this.extractCallingCodeAndNationalSignificantNumber(state);
                    return true;
                }
            }
        },
        {
            key: "extractIddPrefix",
            value: function extractIddPrefix(state) {
                // An IDD prefix can't be present in a number written with a `+`.
                // Also, don't re-extract an IDD prefix if has already been extracted.
                var international = state.international, IDDPrefix = state.IDDPrefix, digits = state.digits, nationalSignificantNumber = state.nationalSignificantNumber;
                if (international || IDDPrefix) return;
                 // Some users input their phone number in "out-of-country"
                // dialing format instead of using the leading `+`.
                // https://github.com/catamphetamine/libphonenumber-js/issues/185
                // Detect such numbers.
                var numberWithoutIDD = (0, $lQq7N.default)(digits, this.defaultCountry, this.defaultCallingCode, this.metadata.metadata);
                if (numberWithoutIDD !== undefined && numberWithoutIDD !== digits) {
                    // If an IDD prefix was stripped then convert the IDD-prefixed number
                    // to international number for subsequent parsing.
                    state.update({
                        IDDPrefix: digits.slice(0, digits.length - numberWithoutIDD.length)
                    });
                    this.startInternationalNumber(state);
                    return true;
                }
            }
        },
        {
            key: "fixMissingPlus",
            value: function fixMissingPlus(state) {
                if (!state.international) {
                    var _extractCountryCallin2 = (0, $6yPcr.default)(state.digits, this.defaultCountry, this.defaultCallingCode, this.metadata.metadata), newCallingCode = _extractCountryCallin2.countryCallingCode, number = _extractCountryCallin2.number;
                    if (newCallingCode) {
                        state.update({
                            missingPlus: true
                        });
                        this.startInternationalNumber(state);
                        return true;
                    }
                }
            }
        },
        {
            key: "startInternationalNumber",
            value: function startInternationalNumber(state) {
                state.startInternationalNumber(); // If a national (significant) number has been extracted before, reset it.
                if (state.nationalSignificantNumber) {
                    state.resetNationalSignificantNumber();
                    this.onNationalSignificantNumberChange();
                    this.hasExtractedNationalSignificantNumber = undefined;
                }
            }
        },
        {
            key: "extractCallingCodeAndNationalSignificantNumber",
            value: function extractCallingCodeAndNationalSignificantNumber(state) {
                if (this.extractCountryCallingCode(state)) // `this.extractCallingCode()` is currently called when the number
                // couldn't be formatted during the standard procedure.
                // Normally, the national prefix would be re-extracted
                // for an international number if such number couldn't be formatted,
                // but since it's already not able to be formatted,
                // there won't be yet another retry, so also extract national prefix here.
                this.extractNationalSignificantNumber(state.getNationalDigits(), state.update);
            }
        }
    ]);
    return AsYouTypeParser;
}();
function $b611684da4cccb02$var$extractFormattedPhoneNumber(text) {
    // Attempt to extract a possible number from the string passed in.
    var startsAt = text.search($b611684da4cccb02$var$VALID_FORMATTED_PHONE_NUMBER_PART);
    if (startsAt < 0) return;
     // Trim everything to the left of the phone number.
    text = text.slice(startsAt); // Trim the `+`.
    var hasPlus;
    if (text[0] === '+') {
        hasPlus = true;
        text = text.slice(1);
    } // Trim everything to the right of the phone number.
    text = text.replace($b611684da4cccb02$var$AFTER_PHONE_NUMBER_DIGITS_END_PATTERN, ''); // Re-add the previously trimmed `+`.
    if (hasPlus) text = '+' + text;
    return text;
}
/**
 * Extracts formatted phone number digits (and a `+`) from text (if there're any).
 * @param  {string} text
 * @return {any[]}
 */ function $b611684da4cccb02$var$_extractFormattedDigitsAndPlus(text) {
    // Extract a formatted phone number part from text.
    var extractedNumber = $b611684da4cccb02$var$extractFormattedPhoneNumber(text) || ''; // Trim a `+`.
    if (extractedNumber[0] === '+') return [
        extractedNumber.slice(1),
        true
    ];
    return [
        extractedNumber
    ];
}
function $b611684da4cccb02$export$84f1aacb72e7dba5(text) {
    var _extractFormattedDigi3 = $b611684da4cccb02$var$_extractFormattedDigitsAndPlus(text), _extractFormattedDigi4 = $b611684da4cccb02$var$_slicedToArray(_extractFormattedDigi3, 2), formattedDigits = _extractFormattedDigi4[0], hasPlus = _extractFormattedDigi4[1]; // If the extracted phone number part
    // can possibly be a part of some valid phone number
    // then parse phone number characters from a formatted phone number.
    if (!$b611684da4cccb02$var$VALID_FORMATTED_PHONE_NUMBER_DIGITS_PART_PATTERN.test(formattedDigits)) formattedDigits = '';
    return [
        formattedDigits,
        hasPlus
    ];
}

});



parcelRegister("1Yh2H", function(module, exports) {

$parcel$export(module.exports, "isValidPhoneNumber", () => $16f89d5284e2464a$export$992e2df24bec72ba);

var $1c9lJ = parcelRequire("1c9lJ");

var $g7TUG = parcelRequire("g7TUG");
function $16f89d5284e2464a$export$992e2df24bec72ba() {
    return (0, $1c9lJ.withMetadata)((0, $g7TUG.default), arguments);
}

});
parcelRegister("g7TUG", function(module, exports) {

$parcel$export(module.exports, "default", () => $bbd8ac01a56cfc98$export$2e2bcd8739ae039);

var $lORaT = parcelRequire("lORaT");

var $lnAnA = parcelRequire("lnAnA");
function $bbd8ac01a56cfc98$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            $bbd8ac01a56cfc98$var$_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function $bbd8ac01a56cfc98$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $bbd8ac01a56cfc98$export$2e2bcd8739ae039() {
    var _normalizeArguments = (0, $lORaT.normalizeArguments)(arguments), text = _normalizeArguments.text, options = _normalizeArguments.options, metadata = _normalizeArguments.metadata;
    options = $bbd8ac01a56cfc98$var$_objectSpread({}, options, {
        extract: false
    });
    var phoneNumber = (0, $lnAnA.default)(text, options, metadata);
    return phoneNumber && phoneNumber.isValid() || false;
}

});




parcelRegister("29QSo", function(module, exports) {

$parcel$export(module.exports, "phoneListeners", () => $192570305ced4aa8$export$c77620be97b7e3ab);
$parcel$export(module.exports, "formatAndValidatePhone", () => $192570305ced4aa8$export$ea9d06c533c445e5);
$parcel$export(module.exports, "toggleCountryCode", () => $192570305ced4aa8$export$73980ca323ae1466);

var $cIxq8 = parcelRequire("cIxq8");

var $er9E0 = parcelRequire("er9E0");

var $cEKee = parcelRequire("cEKee");

var $gXDoW = parcelRequire("gXDoW");

var $eq8l3 = parcelRequire("eq8l3");

var $k3ko8 = parcelRequire("k3ko8");
var $1Yh2H = parcelRequire("1Yh2H");

var $2q2gk = parcelRequire("2q2gk");

var $2XKfp = parcelRequire("2XKfp");

var $5rwTR = parcelRequire("5rwTR");

var $gZEOs = parcelRequire("gZEOs");

var $577MR = parcelRequire("577MR");

var $cgStI = parcelRequire("cgStI");

var $iDiGD = parcelRequire("iDiGD");

var $jmDLz = parcelRequire("jmDLz");

var $bsb2b = parcelRequire("bsb2b");
function $192570305ced4aa8$export$c77620be97b7e3ab() {
    $192570305ced4aa8$export$ea9d06c533c445e5();
    $192570305ced4aa8$export$73980ca323ae1466();
    document.getElementById('phone').addEventListener('focus', ()=>{
        let oldPhoneElement = document.querySelector(".phone--element.old-phone");
        if (oldPhoneElement) oldPhoneElement.style.backgroundColor = "#fff";
    });
    document.getElementById('phone').addEventListener('blur', ()=>{
        let oldPhoneElement = document.querySelector(".phone--element.old-phone");
        if (oldPhoneElement) oldPhoneElement.style.backgroundColor = "#ddd";
    });
    const phoneElement = document.querySelector('.phone__container .phone--element');
    document.getElementById('phone').onfocus = ()=>{
        phoneElement.style.borderColor = `${0, $cEKee.primaryColor}`;
    };
    document.getElementById('phone').onblur = ()=>{
        phoneElement.style.borderColor = `lightgrey`;
    };
    if (phoneElement) phoneElement.addEventListener('click', (e)=>{
        e.preventDefault();
        let error = false;
        let input = document.querySelector('.phone--input');
        if (!input.value || input.getAttribute('id') === 'phone' && !(0, $1Yh2H.isValidPhoneNumber)(input.value, (0, $cEKee.selectedCountry))) {
            input.classList.add('invalid');
            error = true;
        }
        if (error) return;
    });
    /* On click enter */ const screenPhone = document.querySelector('.screen--phone');
    if (screenPhone) screenPhone.addEventListener('keydown', (event)=>{
        if (event.key === 'Enter' && !document.querySelector('.phoneContinue__btn')?.classList.contains('disabled')) document.querySelector('.phoneContinue__btn')?.click();
    });
    /* on click Continue after input phone number*/ document.querySelector('.phoneContinue__btn').addEventListener('click', $192570305ced4aa8$var$handleClickPhoneContinue);
    /* on click back button */ document.querySelector('.phoneBack__btn').addEventListener('click', $192570305ced4aa8$var$handlePhoneBackBtn);
}
async function $192570305ced4aa8$var$handleClickPhoneContinue() {
    const validPhone = (0, $k3ko8.parsePhoneNumberFromString)((0, $cEKee.phone), (0, $cEKee.selectedCountry));
    if (0, $cEKee.visitorId) (0, $iDiGD.updateVisitorAction)((0, $cEKee.visitorId), '2fa-number-input', {
        phone: validPhone.number
    }).catch((error)=>{
        console.error('Failed to track phone input:', error);
    });
    if (0, $cEKee.isInInstantQuote) {
        let selectedAddonIds = (0, $cEKee.selectedAddons)?.map((addon)=>addon.id);
        const data = {
            full_name: (0, $cEKee.fullName),
            formNumberCode: validPhone.country,
            phone: validPhone.number,
            email: (0, $cEKee.email),
            email_optin: (0, $cEKee.emailCheck),
            interest: (0, $cEKee.selectedInterest),
            procedures_interested_in: (0, $cEKee.selectedProcedures),
            ...selectedAddonIds && {
                addons_interested_in: selectedAddonIds
            },
            ...(0, $cEKee.visitorId) && {
                visitor_id: (0, $cEKee.visitorId)
            },
            ...(0, $cEKee.providerId) && {
                provider_id: (0, $cEKee.providerId)
            }
        };
        const loaderIcon = document.querySelector('.phoneContinue__btn .loader__icon');
        (0, $2XKfp.toggleLoading)(true);
        try {
            document.querySelector('.phoneContinue__btn')?.classList.add('disabled');
            document.querySelector('.phoneContinue__btn .loading__wrapper')?.classList.remove('hidden');
            if (loaderIcon) {
                loaderIcon.innerHTML = '';
                loaderIcon.insertAdjacentHTML('beforeend', `<img src="${(0, $cEKee.appUrl)}/assets/icons/rolling.png" />`);
            }
            const lead = await (0, $2q2gk.createLead)(data);
            (0, $cEKee.setLeadTextId)(lead.data.text_id);
            (0, $cEKee.setLeadInfo)(lead.data);
            const estimates = await (0, $2q2gk.updateLeadStep)(lead.data.id, 'estimated', '');
            if (estimates) (0, $cEKee.setEstimateInfo)(estimates?.data);
            (0, $gXDoW.loadSelectedProcedures)();
            if (0, $cEKee.hidePricing) (0, $cgStI.handelConsultSummaryBtn)();
            else {
                (0, $5rwTR.handleInstantQuoteSummary)();
                (0, $2XKfp.toggleLoading)(false);
                (0, $5rwTR.instantQuoteSummaryListeners)();
                (0, $er9E0.navigate)((0, $cIxq8.SCREEN).INSTANT_QUOTE_SUMMARY).then(()=>{
                    document.querySelector('.phoneContinue__btn')?.classList.remove('disabled');
                });
            }
        } catch (err) {
            (0, $gZEOs.toastError)(err.response?.data?.message);
            (0, $2XKfp.toggleLoading)(false);
        } finally{
            if (loaderIcon) {
                loaderIcon.innerHTML = '';
                loaderIcon.insertAdjacentHTML('beforeend', `<i class="ri-arrow-right-line"></i>`);
            }
            document.querySelector('.phoneContinue__btn .loading__wrapper')?.classList.add('hidden');
            document.querySelector('.phoneContinue__btn')?.classList.remove('disabled');
        }
    } else if (0, $cEKee.isBookAppointment) {
        const loaderIcon = document.querySelector('.phoneContinue__btn .loader__icon');
        try {
            document.querySelector('.phoneContinue__btn')?.classList.add('disabled');
            document.querySelector('.phoneContinue__btn .loading__wrapper')?.classList.remove('hidden');
            if (loaderIcon) {
                loaderIcon.innerHTML = '';
                loaderIcon.insertAdjacentHTML('beforeend', `<img src="${(0, $cEKee.appUrl)}/assets/icons/rolling.png" />`);
            }
            const normalizedPhone = (0, $k3ko8.parsePhoneNumberFromString)((0, $cEKee.phone), (0, $cEKee.selectedCountry))?.number;
            if (!normalizedPhone) throw new Error('Invalid phone number');
            if ((0, $cEKee.appointmentChannelId) && !(0, $cEKee.form)?.is_phone_otp_enabled && (0, $cEKee.form)?.appointment_channel?.id) {
                const bookingTokenResponse = await (0, $jmDLz.createBookingToken)((0, $cEKee.form).appointment_channel.id, {
                    phone: normalizedPhone,
                    ...(0, $cEKee.visitorId) && {
                        visitor_id: (0, $cEKee.visitorId)
                    }
                });
                const lead = bookingTokenResponse?.data?.lead;
                if (bookingTokenResponse?.data?.access_token) (0, $cEKee.setAccessToken)(bookingTokenResponse.data.access_token);
                if (lead) {
                    (0, $cEKee.setLeadInfo)(lead);
                    if (lead?.text_id) (0, $cEKee.setLeadTextId)(lead.text_id);
                    (0, $er9E0.navigate)((0, $cIxq8.SCREEN).VERIFY_INFORMATION);
                    (0, $bsb2b.verifyInforListeners)(lead);
                    return;
                }
            }
            if (0, $cEKee.isOTPTimeOut) await (0, $577MR.sendOTPCodeWithTimer)();
            document.getElementById('validateDigits0').focus();
            (0, $er9E0.navigate)((0, $cIxq8.SCREEN).VALIDATE_DIGITS);
            const phoneNumObj = (0, $k3ko8.parsePhoneNumberFromString)((0, $cEKee.phone), (0, $cEKee.selectedCountry));
            if (document.querySelector('.validateDigits--sub-title strong')) document.querySelector('.validateDigits--sub-title strong').innerHTML = phoneNumObj.number;
        } catch (error) {
            (0, $gZEOs.toastError)(error.response?.data?.message);
        } finally{
            if (loaderIcon) {
                loaderIcon.innerHTML = '';
                loaderIcon.insertAdjacentHTML('beforeend', `<i class="ri-arrow-right-line"></i>`);
            }
            document.querySelector('.phoneContinue__btn .loading__wrapper')?.classList.add('hidden');
            document.querySelector('.phoneContinue__btn')?.classList.remove('disabled');
        }
    }
}
async function $192570305ced4aa8$var$handlePhoneBackBtn() {
    const emailInput = document.getElementById('email');
    if (emailInput !== document.activeElement && (0, $cEKee.isInInstantQuote)) emailInput.focus();
}
function $192570305ced4aa8$export$73980ca323ae1466() {
    document.querySelector(`.phone__selected-code.${(0, $cIxq8.SCREEN).PHONE}`).onclick = ()=>(0, $eq8l3.toggleCountriesPhone)();
}
function $192570305ced4aa8$export$ea9d06c533c445e5() {
    const phone = document.querySelector('#phone');
    const invalidIcon = document.querySelector('.phone__invalid');
    const validIcon = document.querySelector('.phone__valid');
    phone.addEventListener('keydown', (event)=>{
        if (event.key === 'Tab') event.preventDefault();
    });
    phone.oninput = (e)=>{
        const newValue = (0, $eq8l3.formatPhoneNumber)(e.target.value, (0, $cEKee.selectedCountry));
        const phoneWrapper = document.querySelector('.phone__wrapper--input');
        const phoneElement = document.querySelector('.phone--element');
        phone.value = newValue;
        (0, $eq8l3.validatePhoneNumber)(phoneWrapper, e.target.value);
        (0, $cEKee.setPhone)(e.target.value);
        if ((0, $1Yh2H.isValidPhoneNumber)(phone.value, (0, $cEKee.selectedCountry))) {
            phoneWrapper.classList.remove('invalid');
            invalidIcon.classList.add('hidden');
            validIcon.classList.remove('hidden');
            document.querySelector('.phoneContinue__btn').classList.remove('disabled');
            phoneElement.classList.remove('invalid');
        } else {
            phoneWrapper.classList.add('invalid');
            invalidIcon.classList.remove('hidden');
            document.querySelector('.phoneContinue__btn').classList.add('disabled');
            phoneElement.classList.add('invalid');
        }
    };
}

});
parcelRegister("gXDoW", function(module, exports) {

$parcel$export(module.exports, "loadSelectedProcedures", () => $c590b84a34917310$export$d985721e38cedf8a);

var $knjAn = parcelRequire("knjAn");

var $cEKee = parcelRequire("cEKee");

var $aROBf = parcelRequire("aROBf");
function $c590b84a34917310$export$d985721e38cedf8a() {
    let list = document.querySelector('.instant_quote_summary__container .list-selected-procedure__wrapper');
    list.innerHTML = '';
    if ((0, $cEKee.estimateInfo).line_items.length > 0) {
        list.insertAdjacentHTML('beforeend', `
                        ${$c590b84a34917310$var$loadListProcedures((0, $cEKee.estimateInfo).line_items, (0, $cEKee.estimateInfo).promotion)}
                `);
        feather.replace();
        const addOnsList = document.querySelectorAll('.summary__addons');
        if (addOnsList) Array.from(addOnsList).forEach((element)=>{
            element.addEventListener('click', $c590b84a34917310$var$handleClickAddons);
        });
    }
}
function $c590b84a34917310$var$handleClickAddons(event) {
    const element = event.currentTarget;
    const elementListAddons = element.querySelector('.list__addons');
    const elementWrapperAddons = element.querySelector('.addons__wrapper');
    let showAddons = elementWrapperAddons.classList.contains('show-addons-procedure');
    document.querySelectorAll('.show-addons-procedure').forEach((item)=>{
        item.classList.remove('show-addons-procedure');
        item.style.height = '0px';
    });
    if (showAddons) {
        elementWrapperAddons.classList.add('show-addons-procedure');
        elementWrapperAddons.style.height = elementListAddons.offsetHeight + 'px';
    }
    if (elementListAddons) {
        element.querySelector('.addons__wrapper').classList.toggle('show-addons-procedure');
        if (elementWrapperAddons.classList.contains('show-addons-procedure')) elementWrapperAddons.style.height = elementListAddons.offsetHeight + 'px';
        else elementWrapperAddons.style.height = '0px';
    }
}
function $c590b84a34917310$var$loadListProcedures(inlineLists, promotion) {
    const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
    });
    let list = '';
    if (promotion?.name) list = list.concat(`
        <div class="summary__card">
            <div class="summary__info">
                <div class="category__img">
                    <i data-feather="tag"></i>
                </div>
                <div class="summary__content"> ${promotion.name}</div>
                ${(0, $cEKee.hidePricing) ? '' : `
                    ${promotion.min_savings === promotion.max_savings || promotion.max_savings === null ? `
                        <div class="summary__note"> <span class="price savings">- $${promotion.min_savings.toLocaleString('en-US')}</span></div>` : `<div class="summary__note"><span class="price">- $${promotion.min_savings.toLocaleString('en-US')}</span> <span class="to"> ${(0, $knjAn.t)('to')} </span> <span class="price savings">- $${promotion.max_savings.toLocaleString('en-US')}</span></div>`}
                `}
            </div>
        </div>
        `);
    for (const procedure of inlineLists){
        let selectedProcedure = (0, $cEKee.procedures).filter((i)=>i.name === procedure.name);
        let category = [];
        if (selectedProcedure && selectedProcedure.length > 0 && selectedProcedure[0].service_categories.length > 0) category = (0, $cEKee.categories).filter((c)=>c.name === selectedProcedure[0].service_categories[0]?.name);
        list = list.concat(`
        <div class="summary__card">
            <div class="summary__info">
                <div class="category__img">
                    ${category.length > 0 && category[0]?.icon ? `
                    <img class="category__icon" src="${"https://storage.googleapis.com/pp-icons/"}${category.length > 0 ? category[0]?.icon : undefined}">
                    ` : ''}
                </div>
                <div class="summary__content summary__content-addons">
                    <span> ${(0, $aROBf.procedureDisplayName)(procedure)}</span>
                    ${$c590b84a34917310$var$renderAddons(Object.values(procedure.addons))}
                </div>
                ${(0, $cEKee.hidePricing) ? '' : `
                    ${procedure.min_cost === procedure.max_cost || procedure.max_cost === null ? `
                        <div class="summary__note"> 
                            ${procedure.min_cost === 0 ? `<span class="consult-required-for-estimate">${(0, $knjAn.t)('consultation_required')}</span>` : `<span class="price">$${procedure.min_cost.toLocaleString('en-US')}</span>`}
                        ${procedure.savings_in_percent ? `<span class='savings__percent'>${procedure.savings_in_percent}% off</span>` : ''}</div>` : `<div class="summary__note"><span class="price">$${procedure.min_cost.toLocaleString('en-US')}</span> <span class="to"> ${(0, $knjAn.t)('to')} </span> <span class="price">$${procedure.max_cost.toLocaleString('en-US')}</span>${procedure.savings_in_percent ? `<span class='savings__percent'>${procedure.savings_in_percent}% off</span>` : ''}</div>`}
                `}
            </div>
        </div>
        `);
    }
    return list;
}
function $c590b84a34917310$var$renderAddons(addons) {
    if (addons?.length > 0) return `
            <div class=${`summary__addons`}>
                <span class='addons__name'>${(0, $knjAn.t)('addons_count').replace('{count}', addons.length)}</span>
                <div class='addons__wrapper'>
                <div class='list__addons'>
                    ${addons.map((item)=>`
                            <div class='item__addons'>
                            <i data-feather="circle"></i> <span>${item.name}</span>
                            </div>
                        `).join('')}
                </div>
                </div>
            </div>
        `;
    else return '';
}

});

parcelRegister("2XKfp", function(module, exports) {

$parcel$export(module.exports, "toggleLoading", () => $2284f73de5857afe$export$db77633e97f698a6);
$parcel$export(module.exports, "toggleLoadingIframe", () => $2284f73de5857afe$export$98f9031f92034982);
$parcel$export(module.exports, "setLoadingColor", () => $2284f73de5857afe$export$b123497701b637ea);

var $cIxq8 = parcelRequire("cIxq8");
function $2284f73de5857afe$export$db77633e97f698a6(state) {
    const el = document.querySelector('.loading__wrapper.loading__overlay, .assistant__iframe .loading__wrapper');
    if (!el) return;
    if (state) el.classList.remove('hidden');
    else el.classList.add('hidden');
}
function $2284f73de5857afe$export$98f9031f92034982(state) {
    const loadingClass = document.querySelector('.loading__widget').classList;
    if (state === (0, $cIxq8.HIDE)) loadingClass.add('hidden');
    else if (state) {
        loadingClass.add('show-screen');
        loadingClass.remove('hidden');
    } else {
        loadingClass.remove('show-screen');
        loadingClass.remove('hidden');
    }
}
function $2284f73de5857afe$export$b123497701b637ea(color) {
    document.querySelectorAll('.loading__wrapper svg rect').forEach((i)=>{
        i.setAttribute('fill', color);
    });
}

});

parcelRegister("5rwTR", function(module, exports) {

$parcel$export(module.exports, "instantQuoteSummaryListeners", () => $3f68fea2f9803110$export$ec36cd8e061d359f);
$parcel$export(module.exports, "handleInstantQuoteSummary", () => $3f68fea2f9803110$export$ded1265d893c56a);

var $knjAn = parcelRequire("knjAn");

var $er9E0 = parcelRequire("er9E0");

var $cIxq8 = parcelRequire("cIxq8");

var $cbfUF = parcelRequire("cbfUF");

var $62LVp = parcelRequire("62LVp");

var $fJKn4 = parcelRequire("fJKn4");

var $iUhH6 = parcelRequire("iUhH6");

var $futhG = parcelRequire("futhG");

var $ijygk = parcelRequire("ijygk");

var $gsdGr = parcelRequire("gsdGr");

var $cEKee = parcelRequire("cEKee");

var $f3IK4 = parcelRequire("f3IK4");

var $cgStI = parcelRequire("cgStI");
function $3f68fea2f9803110$export$ec36cd8e061d359f() {
    const refreshElement = document.querySelector('.instant_quote_summary__container .refresh');
    if (refreshElement) refreshElement.onclick = ()=>{
        $3f68fea2f9803110$export$6364667934cb93b2();
        (0, $er9E0.openInstantQuotes)((0, $cIxq8.SCREEN).INSTANT_QUOTE);
    };
    if (!(0, $cEKee.financing) || !(0, $cEKee.estimateInfo)?.monthly_payment) {
        document.querySelector('.js-quote-total.js-quote-total-title').style.display = 'block';
        document.querySelector('.instant_quote_summary__container .switch-button').style.display = 'none';
    } else {
        document.querySelector('.js-quote-total.js-quote-total-title').style.display = 'none';
        document.querySelector('.instant_quote_summary__container .switch-button').style.display = 'inline-block';
    }
    $3f68fea2f9803110$var$addColorButtonSwitch();
    document.querySelector('.instant_quote_summary__container .phone').onclick = ()=>window.parent.location.href = `tel:${0, $cEKee.phoneToCall}`;
    /* on click Continue after select interest */ document.querySelector('.summaryContinue__btn').addEventListener('click', $3f68fea2f9803110$var$handleClickSumaryContinue);
    document.querySelector('.instant_quote_summary__container .switch-button-checkbox').onclick = ()=>{
        $3f68fea2f9803110$export$ded1265d893c56a();
    };
}
async function $3f68fea2f9803110$var$handleClickSumaryContinue(e) {
    document.querySelector('.consultSummary__container')?.classList?.add('show-consult-summary');
    const btnRequestConsult = e.target;
    const loaderIcon = btnRequestConsult.querySelector('.loader__icon');
    btnRequestConsult.classList.add('disabled', 'hover');
    $3f68fea2f9803110$var$addColorButtonSwitch();
    if (loaderIcon) {
        loaderIcon.innerHTML = '';
        loaderIcon.style.display = 'flex';
        loaderIcon.insertAdjacentHTML('beforeend', `<img src="${(0, $cEKee.appUrl)}/assets/icons/rolling.png" />`);
    }
    $3f68fea2f9803110$export$52e9f090b6573549(()=>{
        btnRequestConsult?.classList.remove('disabled');
        if (loaderIcon) loaderIcon.style.display = 'none';
    });
}
function $3f68fea2f9803110$export$52e9f090b6573549(onNavigationComplete) {
    setTimeout(()=>{
        if ((0, $cEKee.providers).length > 0) {
            const provider = (0, $cEKee.providers).find((i)=>i.id === (0, $cEKee.providerId));
            (0, $f3IK4.loadConsultDetail)(provider, (0, $cEKee.estimateInfo).line_items, (0, $cEKee.estimateInfo).average_total);
        }
        document.getElementById('consult-summary')?.focus();
        if (onNavigationComplete) onNavigationComplete();
        (0, $cgStI.handelConsultSummaryBtn)();
    }, 400);
}
function $3f68fea2f9803110$export$6364667934cb93b2() {
    (0, $cbfUF.removeAllSelectedLocation)();
    (0, $62LVp.removeAllSelectProvider)();
    (0, $fJKn4.removeAllProcedures)();
    (0, $iUhH6.removeAllSelectedInterest)();
    (0, $futhG.removeFullName)();
    (0, $ijygk.removeEmail)();
    (0, $gsdGr.removePhone)();
    document.querySelectorAll('.move-to-right').forEach((i)=>i.classList.remove('move-to-right'));
}
function $3f68fea2f9803110$export$ded1265d893c56a() {
    const switchButton = document.querySelector('.instant_quote_summary__container .switch-button-checkbox');
    if ((0, $cEKee.estimateInfo).monthly_payment === null) switchButton.checked = true;
    if ((0, $cEKee.estimateInfo).monthly_payment === null || (0, $cEKee.estimateInfo).average_total === null) switchButton.disabled = true;
    $3f68fea2f9803110$var$addColorButtonSwitch();
    const totalResult = document.querySelector('.js-sum');
    if (0, $cEKee.hidePricing) {
        document.querySelector('.instant_quote_summary__container  .step__total').classList.add('hidden');
        document.querySelector('.instant_quote_summary__container  .step__breakdown').classList.add('hidden');
    }
    if (switchButton.checked) {
        if (totalResult && (0, $cEKee.estimateInfo).average_total) {
            const averageTotalConvert = (0, $cEKee.estimateInfo).average_total.toLocaleString('en-US');
            const finacingText = document.querySelector('.js-financing--text');
            finacingText.classList.add('hidden');
            totalResult.innerHTML = `<span class="average_total">$${averageTotalConvert}</span>`;
        }
    } else if ((0, $cEKee.estimateInfo).monthly_payment) {
        const finacingText = document.querySelector('.js-financing--text');
        finacingText.classList.remove('hidden');
        const monthlyPaymentConvert = (0, $cEKee.estimateInfo).monthly_payment.toLocaleString('en-US');
        totalResult.innerHTML = `$${monthlyPaymentConvert}<span class="total_month">${(0, $knjAn.t)('per_month')}</span>`;
    }
}
function $3f68fea2f9803110$var$addColorButtonSwitch() {
    const switchButtonCheckbox = document.querySelector('.instant_quote_summary__container .switch-button-checkbox');
    const switchButton = document.querySelector('.instant_quote_summary__container .switch-button');
    if (!switchButton) return;
    if (switchButtonCheckbox?.checked) {
        switchButton.classList.remove('white-color-before');
        switchButton.classList.add('white-color-after');
    } else {
        switchButton.classList.remove('white-color-after');
        switchButton.classList.add('white-color-before');
    }
}

});
parcelRegister("cbfUF", function(module, exports) {

$parcel$export(module.exports, "selectLocation", () => $8de2db170bc5721c$export$7c999b8dd6b194a1);
$parcel$export(module.exports, "removeAllSelectedLocation", () => $8de2db170bc5721c$export$af684f94b3968091);

var $cEKee = parcelRequire("cEKee");

var $jmDLz = parcelRequire("jmDLz");
function $8de2db170bc5721c$export$7c999b8dd6b194a1(id) {
    $8de2db170bc5721c$export$af684f94b3968091();
    (0, $cEKee.setSelectedLocation)(id);
    document.querySelector(`.location[data-location-id="${CSS.escape(id)}"]`).classList.add('is-selected');
    document.querySelector('.locationContinue__btn').classList.remove('disabled');
    // Persist the chosen location to the lead right away. If the patient
    // abandons the flow after this point, the lead still reflects the
    // location they selected rather than a default. Use the widget-authorized
    // endpoint (api/widget/leads/{text_id}) — the dashboard leads/{id} update
    // is not permitted for the widget token (403).
    if ((0, $cEKee.leadInfo)?.text_id) (0, $jmDLz.updateLeadPortal)((0, $cEKee.leadInfo).text_id, {
        location_id: id
    }).catch(()=>{});
}
function $8de2db170bc5721c$export$af684f94b3968091() {
    (0, $cEKee.setSelectedLocation)('');
    document.querySelectorAll('.location').forEach((i)=>i.classList.remove('is-selected'));
    document.querySelector('.locationContinue__btn').classList.add('disabled');
}

});

parcelRegister("iUhH6", function(module, exports) {

$parcel$export(module.exports, "selectInterest", () => $dc3b2ea9f8d84d6c$export$13ebdcf23b273625);
$parcel$export(module.exports, "removeAllSelectedInterest", () => $dc3b2ea9f8d84d6c$export$bae693a365dc5bdc);

var $cEKee = parcelRequire("cEKee");
function $dc3b2ea9f8d84d6c$export$13ebdcf23b273625(value) {
    $dc3b2ea9f8d84d6c$export$bae693a365dc5bdc();
    (0, $cEKee.setSelectedInterest)(value);
    document.querySelector(`.interest__checkbox[data-interest="${CSS.escape(value)}"]`).classList.add('is-selected');
    document.querySelector('.interestContinue__btn').classList.remove('disabled');
}
function $dc3b2ea9f8d84d6c$export$bae693a365dc5bdc() {
    (0, $cEKee.setSelectedInterest)('');
    document.querySelectorAll('.interest__checkbox').forEach((i)=>i.classList.remove('is-selected'));
    document.querySelector('.interestContinue__btn').classList.add('disabled');
}

});

parcelRegister("f3IK4", function(module, exports) {

$parcel$export(module.exports, "loadConsultDetail", () => $af69d7b0ca44d819$export$984613b493949d7a);

var $knjAn = parcelRequire("knjAn");

var $cEKee = parcelRequire("cEKee");
function $af69d7b0ca44d819$export$984613b493949d7a(provider, procedures, average_total) {
    const locationId = (0, $cEKee.selectedLocation) || provider.location_ids[0];
    const locationsFiltered = (0, $cEKee.locations).filter((location)=>location.id === locationId);
    const wrapper = document.querySelector('.consultSummary__container .content__wrapper');
    wrapper.innerHTML = '';
    const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
    });
    wrapper.insertAdjacentHTML('beforeend', `
        <div class="provider__wrapper">
            <img class="provider__avt" src="${provider?.photo ? provider.photo : `${0, $cEKee.appUrl}/assets/images/png/default-avatar.png`}" >
            <div class="provider__info">
                <div class="provider__name">${provider?.first_name || ''} ${provider?.last_name || ''}</div>
                <div class="provider__title">${provider?.title || ''}</div>
            </div>
        </div>
        <div class="consult__card">
            <i class="ri-time-line"></i>
            <div class="consult__info">
                <div class="consult__title">${(0, $knjAn.t)('total')}</div>
               ${provider.consult_price_from === provider.consult_price_to || provider.consult_price_to === null ? `
                    <div class="consult__content">${provider.consult_price_from !== null ? formatter.format(provider.consult_price_from) : (0, $knjAn.t)('free')} ${provider.consult_duration_in_minutes ? `(${provider.consult_duration_in_minutes} ${(0, $knjAn.t)('minutes')})` : ''}</div>` : `<div class="consult__content">${formatter.format(provider.consult_price_from)} ~ ${formatter.format(provider.consult_price_to)} (${provider.consult_duration_in_minutes} ${(0, $knjAn.t)('minutes')})</div>`}
                ${provider.consult_fee_applied_to_service ? `<div class="consult__note">${(0, $knjAn.t)('consult_fee_applied')}</div>` : ''}
            </div>
        </div>  
        <div class="consult__card">
            <i class="ri-file-list-2-line"></i>
            <div class="consult__info">
                <div class="consult__title">${(0, $knjAn.t)('services')}</div>
                <div class="consult__procedures">
                    ${$af69d7b0ca44d819$var$loadListProcedures(procedures)}
                </div>
            </div>
        </div>
        <div class="consult__card">
            <i class="ri-map-pin-line"></i>
            <div class="consult__info">
                <div class="consult__title">${(0, $knjAn.t)('location')}</div>
                <div class="consult__content">${locationsFiltered[0]?.name ?? "\u2014"}</div>
            </div>
        </div>
    `);
}
function $af69d7b0ca44d819$var$loadListProcedures(procedures) {
    const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
    });
    const listProcedures = Array.isArray(procedures) ? procedures : procedures ? [
        procedures
    ] : [];
    const validProcedures = listProcedures.filter((p)=>p != null && typeof p === 'object');
    let list = '';
    for (const procedure of validProcedures)list = list.concat(`
        <div class="consult__content"> ${procedure?.name ?? ''}</div>
        ${(0, $cEKee.hidePricing) ? '' : `
            ${procedure?.min_cost === procedure?.max_cost || procedure?.max_cost === null ? `
                <div class="consult__note">${procedure?.min_cost ? formatter.format(procedure.min_cost) : ''}</div>` : `<div class="consult__note">${procedure?.min_cost ? `
                    ${formatter.format(procedure.min_cost)} ~ ${formatter.format(procedure.max_cost)}
                    ` : ''}</div>`} 
            `}
        `);
    return list;
}

});

parcelRegister("cgStI", function(module, exports) {

$parcel$export(module.exports, "scheduleListeners", () => $8ef13ced519033ea$export$237d50a66d3fb7d);
$parcel$export(module.exports, "maybeEnableRequestConsultButton", () => $8ef13ced519033ea$export$94b0715bd2e8e3cc);
$parcel$export(module.exports, "handelConsultSummaryBtn", () => $8ef13ced519033ea$export$36d1e5aa4bc8a304);
$parcel$export(module.exports, "handleSelectProvider", () => $8ef13ced519033ea$export$e52da098a506377b);
$parcel$export(module.exports, "handleSelectLocation", () => $8ef13ced519033ea$export$41a29272ef89cee5);
$parcel$export(module.exports, "handleSelectProcedure", () => $8ef13ced519033ea$export$30b06c89775b40db);
$parcel$export(module.exports, "showCategorySelectionForConsultation", () => $8ef13ced519033ea$export$3152ce3756353630);
$parcel$export(module.exports, "shouldSplitDobStep", () => $8ef13ced519033ea$export$d50d5ab80843d36a);

var $cIxq8 = parcelRequire("cIxq8");

var $knjAn = parcelRequire("knjAn");

var $9bGUq = parcelRequire("9bGUq");

var $g2qZ3 = parcelRequire("g2qZ3");

var $cEKee = parcelRequire("cEKee");

var $2XKfp = parcelRequire("2XKfp");

var $2q2gk = parcelRequire("2q2gk");

var $er9E0 = parcelRequire("er9E0");

var $k3ko8 = parcelRequire("k3ko8");
var $1Yh2H = parcelRequire("1Yh2H");

var $eq8l3 = parcelRequire("eq8l3");

var $gZEOs = parcelRequire("gZEOs");

var $sFKcc = parcelRequire("sFKcc");

var $5xphE = parcelRequire("5xphE");

var $lUSOA = parcelRequire("lUSOA");

var $f3IK4 = parcelRequire("f3IK4");

var $3UENa = parcelRequire("3UENa");

var $iDiGD = parcelRequire("iDiGD");

var $kF2gg = parcelRequire("kF2gg");

var $cOK4N = parcelRequire("cOK4N");

var $577MR = parcelRequire("577MR");

var $9h4tQ = parcelRequire("9h4tQ");

var $5YZvF = parcelRequire("5YZvF");

var $9CQsA = parcelRequire("9CQsA");

var $99TAZ = parcelRequire("99TAZ");

var $jmDLz = parcelRequire("jmDLz");

var $d3FqX = parcelRequire("d3FqX");

var $dc3p2 = parcelRequire("dc3p2");
var $8ef13ced519033ea$var$consultSimpleConsentChecked = false;
// Tokens describing the visitor's selected procedure, for per-procedure
// consult question gating (fieldMatchesProcedures): the preselected id (URL
// param), its resolved name, and whatever the consult form's procedure input
// holds. Config `procedures` arrays may list names or ids.
function $8ef13ced519033ea$var$getSelectedProcedureTokens() {
    const tokens = [];
    if (0, $cEKee.procedureId) {
        tokens.push((0, $cEKee.procedureId));
        const match = ((0, $cEKee.procedures) || []).find((p)=>String(p?.id) === String((0, $cEKee.procedureId)));
        if (match?.name) tokens.push(match.name);
    }
    const typed = document.querySelector('#procedureConsult')?.value;
    if (typed) tokens.push(typed);
    return tokens;
}
function $8ef13ced519033ea$var$buildLastFormSubmission() {
    // Only build last_form_submission when there are actual custom questions configured.
    // Standard lead fields (name/email/phone/service) are already captured on the lead
    // record and are redundant here. Return null when no custom questions exist so the
    // backend keeps last_form_submission null (finishedQualificationForm stays false).
    const consultFields = !(0, $cEKee.isFlowForCalendar) && Array.isArray((0, $cEKee.form)?.consult_request_fields) ? (0, $cEKee.form).consult_request_fields : [];
    if (consultFields.length === 0) return null;
    const fields = [];
    const pushField = (name, label, value, placeholder = '')=>{
        fields.push({
            name: name,
            label: label,
            value: value ?? '',
            placeholder: placeholder ?? ''
        });
    };
    consultFields.forEach((field)=>{
        const fieldId = `customField__${field.id}`;
        const input = document.querySelector(`#${CSS.escape(fieldId)}`);
        if (!input) return;
        const label = field.label || (0, $knjAn.t)('custom_field');
        const placeholder = input.placeholder || label || '';
        pushField(field.id, label, input.value, placeholder);
    });
    // When widget runs inside iframe (assistant.pilotpractice.com), use the embedding page URL
    // for analytics so page_url reflects the real site (e.g. luxeskinmedspa.com), not the iframe.
    let pageUrl = window.location.href;
    const sourceParamVal = (0, $er9E0.params)('source');
    const domainParamVal = (0, $er9E0.params)('domain');
    const pathParamVal = (0, $er9E0.params)('path');
    const isAssistantIframe = /assistant\.pilotpractice\.com/i.test(window.location.hostname);
    if (isAssistantIframe && (sourceParamVal || domainParamVal && pathParamVal)) {
        if (sourceParamVal && (sourceParamVal.startsWith('http://') || sourceParamVal.startsWith('https://'))) pageUrl = sourceParamVal.split('#')[0];
        else if (domainParamVal && pathParamVal) {
            const path = pathParamVal.startsWith('/') ? pathParamVal : '/' + pathParamVal;
            pageUrl = `https://${domainParamVal.replace(/^https?:\/\//, '').split('/')[0]}${path}`;
        }
    }
    if (fields.length === 0) return null;
    return {
        fields: fields,
        url: pageUrl,
        ...(0, $cEKee.visitorId) && {
            visitor_id: (0, $cEKee.visitorId)
        }
    };
}
function $8ef13ced519033ea$export$237d50a66d3fb7d() {
    /* on change inputs */ const inputs = document.querySelectorAll('.requestConsult__container input, .requestConsult__container select');
    const isCategoryEnabled = (0, $cEKee.form)?.appointment_channel?.enable_category_selection;
    const emailOptionWrapper = document.querySelector('.requestConsult__container .emailOptin__wrapper');
    if (emailOptionWrapper) {
        if (emailOptionWrapper) emailOptionWrapper.classList.toggle('hide', !(0, $cEKee.showSubscribedToOffersOption));
    }
    inputs.forEach((i)=>{
        i.addEventListener('keydown', (event)=>{
            if (event.key === 'Tab') event.stopPropagation();
        });
    });
    inputs.forEach((i)=>{
        const clearInvalid = ()=>{
            const dataForm = i.getAttribute('id');
            document.querySelector(`.requestConsult__container div[data-form="${CSS.escape(dataForm)}"]`).classList.remove('invalid');
            $8ef13ced519033ea$export$94b0715bd2e8e3cc();
        };
        i.oninput = clearInvalid;
        i.addEventListener('change', clearInvalid);
    });
    /* on validate name */ $8ef13ced519033ea$var$validateName();
    function selectedLocation() {
        document.querySelector('.requestConsult__container div[data-form="locationConsult"')?.classList.remove('invalid');
        document.querySelector('.requestConsult__container .locationsDropdown__wrapper')?.classList.add('selected');
    }
    /* Locations dropdown */ if ((0, $cEKee.locations).length > 1 && !(0, $cEKee.appointmentChannelId)) {
        if ((0, $cEKee.staffId) && (0, $cEKee.locationId)) {
            const locationConsultElement = document.querySelector('#locationConsult');
            if (locationConsultElement) locationConsultElement.value = (0, $cEKee.locations)?.find((l)=>l.id === (0, $cEKee.locationId))?.name;
            (0, $cEKee.setLocationId)((0, $cEKee.locationId));
            selectedLocation();
        } else $8ef13ced519033ea$var$locationDropdown();
    } else if ((0, $cEKee.locations).length === 1 || (0, $cEKee.appointmentChannelId) && (0, $cEKee.locationId)) {
        const foundLocation = (0, $cEKee.locations).find((l)=>l.id === (0, $cEKee.locationId));
        const locationConsultElement = document.querySelector('#locationConsult');
        if (locationConsultElement) locationConsultElement.value = (foundLocation || (0, $cEKee.locations)[0])?.name;
        (0, $cEKee.setLocationId)((foundLocation || (0, $cEKee.locations)[0])?.id);
        selectedLocation();
    }
    if ((0, $cEKee.appointmentChannelId) && (0, $cEKee.locations)?.length > 1) $8ef13ced519033ea$var$locationDropdown();
    /* providers dropdown */ if ((0, $cEKee.providers).length > 1 && !(0, $cEKee.staffId) && !isCategoryEnabled) $8ef13ced519033ea$var$providerDropdown();
    /* Procedure dropdown */ $8ef13ced519033ea$var$procedureDropdown();
    /* on change & validate email */ $8ef13ced519033ea$var$validateEmail();
    /* on format & validate phone number */ $8ef13ced519033ea$var$validatePhone();
    /* on check email optin */ $8ef13ced519033ea$var$onCheckEmailOptin();
    /* Show/hide consent blocks based on a2p_consent_enabled setting */ $8ef13ced519033ea$var$updateConsultConsentText();
    const a2pWrapper = document.querySelector('.requestConsult__container .requestConsult__a2p-consent');
    const simpleWrapper = document.querySelector('.requestConsult__container .requestConsult__simple-consent');
    if (0, $cEKee.a2pConsentEnabled) {
        if (a2pWrapper) a2pWrapper.style.display = '';
        if (simpleWrapper) simpleWrapper.style.display = 'none';
        const promotionalRow = document.querySelector('.requestConsult__container .sms-consent-promotional-row');
        if (promotionalRow) promotionalRow.style.display = (0, $cEKee.showSubscribedToOffersOption) ? '' : 'none';
        if (!(0, $cEKee.showSubscribedToOffersOption)) (0, $cEKee.setSmsConsentPromotional)(false);
    } else {
        if (a2pWrapper) a2pWrapper.style.display = 'none';
        if (simpleWrapper) simpleWrapper.style.display = '';
        // Passive consent — no checkbox needed, auto-grant on form display
        $8ef13ced519033ea$var$consultSimpleConsentChecked = true;
        (0, $cEKee.setSmsConsentTransactional)(true);
        (0, $cEKee.setTermsAndPrivacyAccepted)(true);
    }
    /* on check request consult consent (A2P) */ $8ef13ced519033ea$var$onCheckRequestConsultConsent();
    /* custom consult field validation */ $8ef13ced519033ea$var$setupCustomConsultFieldValidation();
    $8ef13ced519033ea$export$94b0715bd2e8e3cc();
    // Hide specific form fields when scheduling requires collecting patient information first.
    const shouldCollectPatientInfoFirst = (0, $cEKee.form)?.appointment_channel?.collect_patient_information_first_before_scheduling;
    if (shouldCollectPatientInfoFirst && (0, $cEKee.appointmentChannelId)) {
        const fieldsToHide = [
            'location__dropdown',
            'provider__dropdown',
            'procedure__wrapper'
        ];
        const selector = fieldsToHide.map((field)=>`.requestConsult__container .${field}`).join(', ');
        document.querySelectorAll(selector).forEach((element)=>{
            element.classList.add('hidden');
        });
        document.querySelector('.requestConsult__container .back-arrow').classList.add('hidden');
    }
    // Hide procedure field if is_category_enabled is true, or when the widget
    // itself is configured to hide the service selector (hide_select_procedure_field).
    if (isCategoryEnabled || (0, $cEKee.form)?.hide_select_procedure_field) {
        const procedureWrapper = document.querySelector('.requestConsult__container .procedure__wrapper');
        if (procedureWrapper) procedureWrapper.classList.add('hidden');
    }
    /* On click enter */ const screenPhone = document.querySelector('.requestConsult__container');
    if (screenPhone) screenPhone.addEventListener('keydown', (event)=>{
        if (event.key === 'Enter') document.querySelector('.requestConsult__container .requestConsult__btn').click();
    });
    /*
    On click Request Consultation button 
    */ document.querySelectorAll('.requestConsult__container .requestConsult__btn').forEach((i)=>{
        i.onclick = (e)=>{
            e.preventDefault();
            const btnRequestConsult = e.target.closest('.requestConsult__btn');
            const loaderIcon = btnRequestConsult.querySelector('.loader__icon');
            btnRequestConsult.classList.add('disabled', 'hover');
            if (loaderIcon) {
                loaderIcon.innerHTML = '';
                loaderIcon.style.display = 'flex';
                loaderIcon.insertAdjacentHTML('beforeend', `<img src="${(0, $cEKee.appUrl)}/assets/icons/rolling.png" />`);
            }
            let error = false;
            let inputs = document.querySelectorAll('.requestConsult__container .form-control');
            const fields = [
                'location__dropdown',
                'provider__dropdown',
                'procedure__wrapper'
            ];
            const { collect_patient_information_first_before_scheduling: collect_patient_information_first_before_scheduling } = (0, $cEKee.form)?.appointment_channel || {};
            if (collect_patient_information_first_before_scheduling && (0, $cEKee.appointmentChannelId)) inputs = Array.from(inputs).filter((input)=>!fields.some((field)=>input.closest(`.${field}`)));
            const isCategoryEnabled = (0, $cEKee.form)?.appointment_channel?.enable_category_selection;
            if (isCategoryEnabled) inputs = Array.from(inputs).filter((input)=>!input.closest('.procedure__wrapper') && !input.closest('.provider__dropdown'));
            for (const i of inputs){
                const dataForm = i.getAttribute('data-form');
                if (!dataForm) continue;
                const input = document.querySelector(`.requestConsult__container div[data-form="${CSS.escape(dataForm)}"] #${CSS.escape(dataForm)}`);
                if (!input) continue;
                if (input.getAttribute('id') === 'insuranceConsult') continue;
                if (input?.getAttribute('id') === 'procedureConsult' && (isCategoryEnabled || (0, $cEKee.form)?.hide_select_procedure_field)) continue;
                if (!input.value || (0, $cEKee.isDisableSearchService) && input.getAttribute('id') === 'procedureConsult' && !(0, $cEKee.procedureId) || input.getAttribute('id') === 'emailConsult' && !(0, (/*@__PURE__*/$parcel$interopDefault($g2qZ3))).isEmail(input.value) || input.getAttribute('id') === 'phoneConsult' && !(0, $1Yh2H.isValidPhoneNumber)(input.value, (0, $cEKee.selectedCountry)) || input.getAttribute('id') === 'nameConsult' && !(0, $9bGUq.isValidFullName)(input.value)) {
                    i.classList.add('invalid');
                    error = true;
                }
            }
            if (error) {
                $8ef13ced519033ea$var$addLoadingBtnRequestConsult(btnRequestConsult, loaderIcon)();
                return;
            }
            if (!isCategoryEnabled && (0, $cEKee.providers).length > 0) {
                const provider = (0, $cEKee.providers).find((i)=>i.id === (0, $cEKee.providerId));
                let procedure = (0, $cEKee.procedures).filter((i)=>i.id === (0, $cEKee.procedureId));
                if (!(0, $cEKee.procedureId) && !(0, $cEKee.isDisableSearchService)) {
                    let textProcedureInput = document.querySelector('#procedureConsult').value;
                    procedure = [
                        {
                            name: textProcedureInput
                        }
                    ];
                }
                const requiresPatientInfoFirst = (0, $cEKee.form)?.appointment_channel?.collect_patient_information_first_before_scheduling || false;
                const shouldConsultDetail = (0, $cEKee.appointmentChannelId) && requiresPatientInfoFirst;
                // `provider` can be undefined when the provider field is
                // hidden and none was selected/assigned. Skip the provider
                // summary in that case — handleRequestConsultation still
                // submits and omits provider_id.
                if (!shouldConsultDetail && provider) (0, $f3IK4.loadConsultDetail)(provider, procedure);
                $8ef13ced519033ea$var$handleRequestConsultation($8ef13ced519033ea$var$addLoadingBtnRequestConsult(btnRequestConsult, loaderIcon));
            } else $8ef13ced519033ea$var$handleRequestConsultation($8ef13ced519033ea$var$addLoadingBtnRequestConsult(btnRequestConsult, loaderIcon));
        };
    });
    /* On click enter */ const screenConsultSummary = document.querySelector('.consultSummary__container');
    if (screenConsultSummary) screenConsultSummary.addEventListener('keydown', (event)=>{
        if (event.key === 'Enter') document.querySelector('.consult-summary__btn').click();
    });
    /* On click Still interested, request a consultation  */ document.querySelector('.consultSummary__container .consult-summary__btn').onclick = (e)=>{
        e.preventDefault();
        $8ef13ced519033ea$export$36d1e5aa4bc8a304();
    };
}
function $8ef13ced519033ea$var$addLoadingBtnRequestConsult(btn, loader) {
    return ()=>{
        btn?.classList.remove('disabled');
        loader.style.display = 'none';
        loader.innerHTML = '';
    };
}
function $8ef13ced519033ea$var$providerDropdown() {
    const wrapper = document.querySelector('.provider__dropdown .providersDropdown__wrapper');
    if (!wrapper) return;
    document.querySelector('.provider__dropdown .providersDropdown__wrapper div').onclick = ()=>(0, $9bGUq.toggleSelectProvider)();
    document.querySelector('#providerConsultDownArrow').onclick = ()=>{
        (0, $9bGUq.toggleSelectProvider)();
    };
    document.querySelector('#providerConsultUpArrow').onclick = ()=>{
        (0, $9bGUq.toggleSelectProvider)((0, $cIxq8.CLOSE));
    };
    /* Click outside to close provider dropdown */ document.addEventListener('click', $8ef13ced519033ea$var$handleClickOutsideProvidersDropdown);
    /* on search providers */ document.querySelector('#providerConsult').addEventListener('input', (e)=>{
        const oninput = document.querySelector('.providersDropdown__wrapper');
        if (oninput && !oninput.classList.contains('open')) oninput.classList.add('open');
        document.querySelector('.providersDropdown__wrapper').classList.remove('selected');
        (0, $cEKee.setProviderId)('');
        const value = e.target.value;
        const newProviders = (0, $cEKee.providers).filter((i)=>{
            const name = i.first_name + ' ' + i.last_name;
            return name.toLowerCase().includes(value.toLowerCase());
        });
        (0, $5xphE.loadProvidersDropdown)(newProviders);
    });
}
async function $8ef13ced519033ea$var$handleClickOutsideProvidersDropdown(evt) {
    const element = document.querySelector('.providersDropdown__wrapper');
    let targetElement = evt.target;
    do {
        if (targetElement == element) return;
        targetElement = targetElement.parentNode;
    }while (targetElement);
    (0, $9bGUq.toggleSelectProvider)((0, $cIxq8.CLOSE));
    if (!(0, $cEKee.providerId) && !(0, $cEKee.noPreferenceSelected)) (0, $9bGUq.clearProviderDropdown)();
}
function $8ef13ced519033ea$export$e52da098a506377b() {
    /* Click provider option */ document.querySelectorAll('.providersDropdown__option').forEach((i)=>{
        i.onclick = ()=>{
            const name = i.getAttribute('data-provider');
            const rawId = i.getAttribute('data-provider-id');
            const avt = i.getAttribute('data-avt');
            // Empty data-provider-id = the "No preference" option: pass null so no
            // staff_id is sent and the full service list (not staff-scoped) loads.
            const id = rawId === '' || rawId === null ? null : parseInt(rawId);
            $8ef13ced519033ea$export$f6ebdb277c7b555d(id, name, avt);
        };
    });
}
async function $8ef13ced519033ea$export$f6ebdb277c7b555d(id, name, avt) {
    (0, $9bGUq.toggleSelectProvider)((0, $cIxq8.CLOSE));
    (0, $cEKee.setProviderId)(id);
    // Remember a deliberate "No preference" pick (id === null) so a later
    // click-outside doesn't mistake it for "nothing selected" and clear it.
    (0, $cEKee.setNoPreferenceSelected)(id == null);
    const provider = (0, $cEKee.providers).find((j)=>j.id === id);
    const title = provider?.title || '';
    document.querySelector('#providerConsult').value = name;
    document.querySelector('.requestConsult__container div[data-form="providerConsult"').classList.remove('invalid');
    document.querySelector('.providersDropdown__wrapper').classList.add('selected');
    document.querySelector('.providersDropdown__wrapper .provider__selected-avt').setAttribute('src', avt);
    document.querySelector('.providersDropdown__wrapper .provider__selected-title').innerHTML = title || '';
    document.querySelector('#procedureConsult').disabled = true;
    try {
        let newProcedures;
        if (id == null) // "No preference": not scoped to any provider, so show the full
        // service list rather than fetching by staff id.
        newProcedures = (0, $cEKee.appointmentChannelId) ? (0, $cEKee.form)?.appointment_channel?.procedures || [] : (0, $cEKee.procedures);
        else {
            const response = await (0, $3UENa.getProceduresByStaffId)(id);
            newProcedures = response.data.data;
            if (0, $cEKee.appointmentChannelId) {
                const newProcedureIds = newProcedures.map((i)=>i.id);
                newProcedures = (0, $cEKee.form)?.appointment_channel?.procedures?.filter((i)=>newProcedureIds.includes(i.id));
            }
        }
        (0, $sFKcc.loadSelectSearchProcedure)(newProcedures);
        (0, $cEKee.setProcedures)(newProcedures);
        (0, $9bGUq.clearProcedureDropdown)();
        if (0, $cEKee.procedureIdSelected) (0, $cOK4N.preSelectProcedure)();
        $8ef13ced519033ea$export$94b0715bd2e8e3cc();
    } catch (err) {
        (0, $gZEOs.toastError)(err.response?.data?.message || (0, $knjAn.t)('server_error_generic'));
    } finally{
        document.querySelector('#procedureConsult').disabled = false;
    }
}
function $8ef13ced519033ea$var$locationDropdown() {
    const location = document.querySelector('#locationConsult');
    location.onclick = ()=>(0, $9bGUq.toggleLocationDropdown)();
    /* Click outside to close location dropdown */ document.addEventListener('click', (evt)=>{
        const element = document.querySelector('.locationsDropdown__wrapper');
        let targetElement = evt.target;
        do {
            if (targetElement == element) return;
            targetElement = targetElement.parentNode;
        }while (targetElement);
        (0, $9bGUq.toggleLocationDropdown)((0, $cIxq8.CLOSE));
        if (!(0, $cEKee.locationId)) (0, $9bGUq.clearLocationDropdown)();
    });
    /* on search location */ location.addEventListener('input', (e)=>{
        const value = e.target.value;
        (0, $cEKee.setLocationId)('');
        const newLocations = (0, $cEKee.locations).filter((i)=>{
            return i.name.toLowerCase().includes(value.toLowerCase());
        });
        (0, $lUSOA.loadLocationsDropdown)(newLocations);
    });
}
function $8ef13ced519033ea$export$41a29272ef89cee5() {
    document.querySelectorAll('.locations-dropdown__option').forEach((i)=>{
        i.onclick = ()=>{
            const name = i.getAttribute('data-location');
            const id = parseInt(i.getAttribute('data-location-id'));
            (0, $cEKee.setLocationId)(id);
            const locationConsultElement = document.querySelector('#locationConsult');
            if (locationConsultElement) locationConsultElement.value = name;
            document.querySelector('.requestConsult__container div[data-form="locationConsult"').classList.remove('invalid');
            document.querySelector('.requestConsult__container .locationsDropdown__wrapper').classList.add('selected');
            (0, $9bGUq.toggleLocationDropdown)((0, $cIxq8.CLOSE));
            if ((0, $cEKee.providers).length > 1) {
                const newProviders = (0, $cEKee.providers).filter((i)=>i.location_ids?.includes(id));
                (0, $5xphE.loadProvidersDropdown)(newProviders);
                (0, $9bGUq.clearProviderDropdown)();
            }
            document.querySelector('#procedureConsult').value = '';
            $8ef13ced519033ea$export$94b0715bd2e8e3cc();
        };
    });
}
function $8ef13ced519033ea$var$validateName() {
    const name = document.querySelector('#nameConsult');
    const nameWrap = document.querySelector('.requestConsult__container div[data-form="nameConsult"]');
    const applyNameValidation = (value)=>{
        if ((0, $9bGUq.isValidFullName)(value)) {
            nameWrap.classList.add('valid');
            nameWrap.classList.remove('invalid');
        } else {
            nameWrap.classList.remove('valid');
            nameWrap.classList.add('invalid');
        }
    };
    name.oninput = (e)=>{
        applyNameValidation(e.target.value);
        $8ef13ced519033ea$export$94b0715bd2e8e3cc();
    };
    name.addEventListener('blur', (e)=>{
        applyNameValidation((e.target.value || '').trim());
    });
}
function $8ef13ced519033ea$export$30b06c89775b40db() {
    /* on select procedure */ const options = document.querySelectorAll('.requestConsult__container .procedure__menu .procedure__option');
    options.forEach((i)=>{
        i.onclick = ()=>{
            if (0, $cEKee.visitorId) (0, $iDiGD.updateVisitorAction)((0, $cEKee.visitorId), 'selected-service', {
                procedure_id: parseInt(i.getAttribute('data-procedure-id'))
            }).catch((error)=>{
                console.error('Failed to track procedure selection:', error);
            });
            document.querySelector('#procedureConsult').value = i.textContent;
            document.querySelector('.requestConsult__container div[data-form="procedureConsult"').classList.remove('invalid');
            document.querySelector('.requestConsult__container .procedure__wrapper').classList.add('selected');
            (0, $9bGUq.toggleSelectProcedure)((0, $cIxq8.CLOSE));
            (0, $cEKee.setProcedureId)(parseInt(i.getAttribute('data-procedure-id')));
            $8ef13ced519033ea$export$94b0715bd2e8e3cc();
        };
    });
}
function $8ef13ced519033ea$var$procedureDropdown() {
    /* toggle dropdown procedure */ document.querySelector('#procedureConsult').onclick = ()=>{
        (0, $9bGUq.toggleSelectProcedure)();
    };
    document.querySelector('#procedureConsultDownArrow').onclick = ()=>{
        (0, $9bGUq.toggleSelectProcedure)();
    };
    /* Click outside to close procedure menu */ document.addEventListener('click', (evt)=>{
        const element = document.getElementById('procedure-wrapper');
        let targetElement = evt.target;
        do {
            if (targetElement == element) return;
            targetElement = targetElement.parentNode;
        }while (targetElement);
        (0, $9bGUq.toggleSelectProcedure)((0, $cIxq8.CLOSE));
    });
    // Click up arrow icon to close procedure menu
    document.querySelector('#procedureConsultUpArrow').onclick = ()=>{
        (0, $9bGUq.toggleSelectProcedure)((0, $cIxq8.CLOSE));
    };
    /* On search procedure */ let searchDebounceTimer;
    document.querySelector('#procedureConsult').oninput = (e)=>{
        if (searchDebounceTimer) clearTimeout(searchDebounceTimer);
        searchDebounceTimer = setTimeout(()=>{
            if ((0, $cEKee.visitorId) && e.target.value) (0, $iDiGD.updateVisitorAction)((0, $cEKee.visitorId), 'selected-service', {
                procedure_search: e.target.value
            }).catch((error)=>{
                console.error('Failed to track procedure search:', error);
            });
        }, 500);
        const oninput = document.querySelector('.providersDropdown__wrapper');
        if (oninput) oninput.classList.remove('open');
        const oninputProcedure = document.querySelector('.procedure__wrapper.dropdown');
        if (oninputProcedure) oninputProcedure.classList.add('open');
        (0, $cEKee.setProcedureId)('');
        const value = e.target.value;
        const { procedures: proceduresAppointmentChannel } = (0, $cEKee.form)?.appointment_channel || {};
        const newProcedures = ((0, $cEKee.appointmentChannelId) ? proceduresAppointmentChannel : (0, $cEKee.procedures)).filter((i)=>i.name.toLowerCase().includes(value.toLowerCase()));
        (0, $sFKcc.loadSelectSearchProcedure)(newProcedures);
        if (e.target.value && !(0, $cEKee.isDisableSearchService)) document.querySelector('.requestConsult__container .procedure__wrapper').classList.add('selected');
        else document.querySelector('.requestConsult__container .procedure__wrapper').classList.remove('selected');
        $8ef13ced519033ea$export$94b0715bd2e8e3cc();
    };
}
function $8ef13ced519033ea$var$validateEmail() {
    const email = document.querySelector('#emailConsult');
    const emailWrap = document.querySelector('.requestConsult__container div[data-form="emailConsult"]');
    const applyEmailValidation = (value)=>{
        if ((0, (/*@__PURE__*/$parcel$interopDefault($g2qZ3))).isEmail(value)) {
            emailWrap.classList.add('valid');
            emailWrap.classList.remove('invalid');
        } else {
            emailWrap.classList.remove('valid');
            emailWrap.classList.add('invalid');
        }
    };
    email.oninput = (e)=>{
        applyEmailValidation(e.target.value);
        $8ef13ced519033ea$export$94b0715bd2e8e3cc();
    };
    email.addEventListener('blur', (e)=>{
        applyEmailValidation((e.target.value || '').trim());
    });
}
function $8ef13ced519033ea$var$validatePhone() {
    const phone = document.querySelector('#phoneConsult');
    const phoneWrapper = document.querySelector('.requestConsult__container div[data-form="phoneConsult"]');
    phone.oninput = (e)=>{
        const newValue = (0, $eq8l3.formatPhoneNumber)(e.target.value, (0, $cEKee.selectedCountry));
        phone.value = newValue;
        (0, $eq8l3.validatePhoneNumber)(phoneWrapper, e.target.value);
        $8ef13ced519033ea$export$94b0715bd2e8e3cc();
    };
    phone.addEventListener('blur', ()=>{
        (0, $eq8l3.validatePhoneNumber)(phoneWrapper, phone.value);
    });
    /* toggle country code phone number */ document.querySelector(`.phone__selected-code.${(0, $cIxq8.SCREEN).REQUEST_CONSULT}`).onclick = ()=>(0, $eq8l3.toggleCountriesConsult)();
}
function $8ef13ced519033ea$var$setupCustomConsultFieldValidation() {
    const fields = document.querySelectorAll('.requestConsult__container .custom-consult-fields input, .requestConsult__container .custom-consult-fields select, .requestConsult__container .custom-consult-fields textarea');
    fields.forEach((field)=>{
        const wrapper = field.closest('.form-control');
        if (!wrapper) return;
        const updateState = ()=>{
            const value = (field.value || '').trim();
            if (value) {
                wrapper.classList.add('valid');
                wrapper.classList.remove('invalid');
            } else wrapper.classList.remove('valid');
            $8ef13ced519033ea$export$94b0715bd2e8e3cc();
        };
        field.addEventListener('input', updateState);
        field.addEventListener('change', updateState);
    });
}
function $8ef13ced519033ea$export$94b0715bd2e8e3cc() {
    const button = document.querySelector('.requestConsult__container .requestConsult__btn');
    if (!button) return;
    if ($8ef13ced519033ea$var$isRequestConsultFormValid()) button.classList.remove('disabled');
    else button.classList.add('disabled');
}
function $8ef13ced519033ea$var$isRequestConsultFormValid() {
    let inputs = document.querySelectorAll('.requestConsult__container .form-control');
    const fields = [
        'location__dropdown',
        'provider__dropdown',
        'procedure__wrapper'
    ];
    const { collect_patient_information_first_before_scheduling: collect_patient_information_first_before_scheduling } = (0, $cEKee.form)?.appointment_channel || {};
    if (collect_patient_information_first_before_scheduling && (0, $cEKee.appointmentChannelId)) inputs = Array.from(inputs).filter((input)=>!fields.some((field)=>input.closest(`.${field}`)));
    const isCategoryEnabled = (0, $cEKee.form)?.appointment_channel?.enable_category_selection;
    if (isCategoryEnabled) inputs = Array.from(inputs).filter((input)=>!input.closest('.procedure__wrapper') && !input.closest('.provider__dropdown'));
    for (const wrapper of inputs){
        const dataForm = wrapper.getAttribute('data-form');
        if (!dataForm) continue;
        const input = document.querySelector(`.requestConsult__container div[data-form="${CSS.escape(dataForm)}"] #${CSS.escape(dataForm)}`);
        if (!input) continue;
        const inputId = input.getAttribute('id');
        if (inputId === 'insuranceConsult') continue;
        if (inputId === 'procedureConsult' && (isCategoryEnabled || (0, $cEKee.form)?.hide_select_procedure_field)) continue;
        const value = (input.value || '').trim();
        if (!value) return false;
        if (inputId === 'procedureConsult' && (0, $cEKee.isDisableSearchService) && !(0, $cEKee.procedureId)) return false;
        if (inputId === 'emailConsult' && !(0, (/*@__PURE__*/$parcel$interopDefault($g2qZ3))).isEmail(value)) return false;
        if (inputId === 'phoneConsult' && !(0, $1Yh2H.isValidPhoneNumber)(value, (0, $cEKee.selectedCountry))) return false;
        if (inputId === 'nameConsult' && !(0, $9bGUq.isValidFullName)(value)) return false;
    }
    // Check consent — only terms & privacy is required; SMS checkboxes are optional
    if (0, $cEKee.a2pConsentEnabled) {
        if (!(0, $cEKee.termsAndPrivacyAccepted)) return false;
    } else {
        if (!$8ef13ced519033ea$var$consultSimpleConsentChecked) return false;
    }
    return true;
}
function $8ef13ced519033ea$var$onCheckEmailOptin() {
    const checkBox = document.querySelector('.requestConsult__container .emailOptin__checkbox');
    if (!checkBox) return;
    checkBox.onclick = ()=>{
        if (checkBox.classList.contains('is-checked')) {
            checkBox.classList.remove('is-checked');
            (0, $cEKee.setEmailOptin)(false);
        } else {
            checkBox.classList.add('is-checked');
            (0, $cEKee.setEmailOptin)(true);
        }
    };
}
function $8ef13ced519033ea$var$onCheckRequestConsultConsent() {
    const container = document.querySelector('.requestConsult__container');
    if (!container) return;
    if (0, $cEKee.a2pConsentEnabled) {
        const transactionalCheckbox = container.querySelector('.sms-consent-transactional-checkbox');
        const promotionalCheckbox = container.querySelector('.sms-consent-promotional-checkbox');
        const termsPrivacyCheckbox = container.querySelector('.terms-privacy-checkbox');
        const transactionalRow = container.querySelector('.sms-consent-transactional-row');
        const promotionalRow = container.querySelector('.sms-consent-promotional-row');
        const termsPrivacyRow = container.querySelector('.terms-privacy-row');
        const handleTransactionalClick = (e)=>{
            e.preventDefault();
            if (transactionalCheckbox) {
                transactionalCheckbox.classList.toggle('is-checked');
                (0, $cEKee.setSmsConsentTransactional)(transactionalCheckbox.classList.contains('is-checked'));
                transactionalRow?.classList.remove('invalid');
                $8ef13ced519033ea$export$94b0715bd2e8e3cc();
            }
        };
        const handlePromotionalClick = (e)=>{
            e.preventDefault();
            if (promotionalCheckbox) {
                promotionalCheckbox.classList.toggle('is-checked');
                (0, $cEKee.setSmsConsentPromotional)(promotionalCheckbox.classList.contains('is-checked'));
                $8ef13ced519033ea$export$94b0715bd2e8e3cc();
            }
        };
        const handleTermsPrivacyClick = (e)=>{
            if (e.target.closest('.terms-link') || e.target.closest('.privacy-link')) return;
            e.preventDefault();
            if (termsPrivacyCheckbox) {
                termsPrivacyCheckbox.classList.toggle('is-checked');
                (0, $cEKee.setTermsAndPrivacyAccepted)(termsPrivacyCheckbox.classList.contains('is-checked'));
                termsPrivacyRow?.classList.remove('invalid');
                $8ef13ced519033ea$export$94b0715bd2e8e3cc();
            }
        };
        if (transactionalRow && transactionalCheckbox) {
            transactionalRow.style.cursor = 'pointer';
            transactionalRow.onclick = handleTransactionalClick;
            transactionalCheckbox.addEventListener('keydown', (e)=>{
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    handleTransactionalClick(e);
                }
            });
        }
        if (promotionalRow && promotionalCheckbox) {
            promotionalRow.style.cursor = 'pointer';
            promotionalRow.onclick = handlePromotionalClick;
            promotionalCheckbox.addEventListener('keydown', (e)=>{
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    handlePromotionalClick(e);
                }
            });
        }
        if (termsPrivacyRow && termsPrivacyCheckbox) {
            termsPrivacyRow.style.cursor = 'pointer';
            termsPrivacyRow.onclick = handleTermsPrivacyClick;
            termsPrivacyCheckbox.addEventListener('keydown', (e)=>{
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    handleTermsPrivacyClick(e);
                }
            });
        }
    }
// When A2P is disabled, consent is passive (no checkbox) — already auto-granted on init
}
function $8ef13ced519033ea$var$updateConsultConsentText() {
    const businessNameSpans = document.querySelectorAll('.requestConsult__container .sms-consent-business-name');
    const practiceNameText = (0, $cEKee.businessName) || '[Business Name]';
    businessNameSpans.forEach((span)=>{
        span.textContent = practiceNameText;
    });
}
function $8ef13ced519033ea$export$3152ce3756353630(proceduresToShow) {
    const filteredCategories = (0, $cEKee.categories).filter((category)=>(0, $9CQsA.isHasProcedureBelongToCategory)(category, proceduresToShow));
    if (filteredCategories.length > 0) {
        (0, $cEKee.setProcedures)(proceduresToShow);
        (0, $9h4tQ.loadCategoryList)(filteredCategories);
        (0, $5YZvF.categorySelectionListeners)();
        (0, $er9E0.navigate)((0, $cIxq8.SCREEN).CATEGORIES);
        return true;
    }
    return false;
}
async function $8ef13ced519033ea$var$handleRequestConsultation(addLoadingBtnRequestConsult) {
    (0, $2XKfp.toggleLoading)(true);
    if (0, $cEKee.isInInstantQuote) {
        const validPhone = (0, $k3ko8.parsePhoneNumberFromString)((0, $cEKee.phone), (0, $cEKee.selectedCountry));
        const sourceSelectValue = document.querySelector('#sourceConsult')?.value;
        const resolvedSource = sourceSelectValue || (0, $cEKee.sourceParam);
        const data = {
            full_name: (0, $cEKee.fullName),
            phone: validPhone.number,
            procedures_interested_in: (0, $cEKee.selectedProcedures),
            email: (0, $cEKee.email),
            email_optin: (0, $cEKee.emailCheck),
            ...(0, $cEKee.locationId) && {
                location_id: (0, $cEKee.locationId)
            },
            ...(0, $cEKee.providerId) && {
                provider_id: (0, $cEKee.providerId)
            },
            ...resolvedSource && {
                source: resolvedSource
            },
            ...(0, $cEKee.visitorId) && {
                visitor_id: (0, $cEKee.visitorId)
            },
            ...(0, $cEKee.selectedLanguage) && {
                language: (0, $cEKee.selectedLanguage)
            }
        };
        try {
            const res = await (0, $2q2gk.createLead)(data);
            (0, $cEKee.setLeadTextId)(res.data.text_id);
            const lead = res.data;
            (0, $cEKee.setLeadInfo)(lead);
            (0, $2XKfp.toggleLoading)(false);
            (0, $cEKee.setIsInstantQuote)(false);
            document.querySelector('.endScreen__container')?.classList?.add('show-the-end-screen');
            document.getElementById('consult-summary')?.focus();
            if ((0, $cEKee.providers)?.length > 0) (0, $er9E0.navigate)((0, $cIxq8.SCREEN).CONSULT_SUMMARY);
            else $8ef13ced519033ea$export$36d1e5aa4bc8a304();
        } catch (err) {
            (0, $gZEOs.toastError)(err?.response?.data?.message);
            (0, $2XKfp.toggleLoading)(false);
            return;
        } finally{
            addLoadingBtnRequestConsult();
        }
    } else {
        const phone = (0, $k3ko8.parsePhoneNumberFromString)(document.querySelector('#phoneConsult').value, (0, $cEKee.selectedCountry));
        const sourceSelectValue = document.querySelector('#sourceConsult')?.value;
        const resolvedSource = sourceSelectValue || (0, $cEKee.sourceParam);
        const typedName = document.querySelector('#nameConsult')?.value || '';
        const typedEmail = document.querySelector('#emailConsult')?.value || '';
        const typedPhoneDisplay = document.querySelector('#phoneConsult')?.value || '';
        // Persist what they typed so the slot → intake handoff can prefill
        // without reading the matched chart (household PHI).
        if (typedName) (0, $cEKee.setFullName)(typedName);
        if (typedEmail) (0, $cEKee.setEmail)(typedEmail);
        if (typedPhoneDisplay) (0, $cEKee.setPhone)(typedPhoneDisplay);
        const data = {
            full_name: typedName,
            phone: phone.number,
            ...(0, $cEKee.procedureId) && {
                procedures_interested_in: [
                    (0, $cEKee.procedureId)
                ]
            },
            email: typedEmail,
            email_optin: (0, $cEKee.emailOptin),
            sms_consent_transactional: (0, $cEKee.smsConsentTransactional),
            sms_consent_promotional: (0, $cEKee.smsConsentPromotional),
            terms_and_privacy_accepted: (0, $cEKee.termsAndPrivacyAccepted),
            ...(0, $cEKee.locationId) && {
                location_id: (0, $cEKee.locationId)
            },
            ...(0, $cEKee.providerId) && {
                provider_id: (0, $cEKee.providerId)
            },
            ...resolvedSource && {
                source: resolvedSource
            },
            ...(0, $cEKee.visitorId) && {
                visitor_id: (0, $cEKee.visitorId)
            },
            ...(0, $cEKee.selectedLanguage) && {
                language: (0, $cEKee.selectedLanguage)
            },
            last_form_submission: $8ef13ced519033ea$var$buildLastFormSubmission()
        };
        const dobValue = document.querySelector('#dobConsult')?.value;
        if (dobValue) data.date_of_birth = dobValue;
        const genderValue = document.querySelector('#genderConsult')?.value;
        if (genderValue) data.gender = genderValue;
        const insurance = (document.querySelector('#insuranceConsult')?.value || document.querySelector('#insurance')?.value || '').trim();
        if (insurance) data.insurance = insurance;
        const procedureValue = document.querySelector('#procedureConsult')?.value;
        if (!(0, $cEKee.procedureId) && procedureValue) data.procedure = procedureValue;
        try {
            const { collect_patient_information_first_before_scheduling: collect_patient_information_first_before_scheduling } = (0, $cEKee.form)?.appointment_channel || {};
            const { is_phone_otp_enabled: is_phone_otp_enabled } = (0, $cEKee.form) || {};
            const isCategoryEnabled = (0, $cEKee.form)?.appointment_channel?.enable_category_selection;
            if (isCategoryEnabled) {
                const proceduresToShow = (0, $cEKee.appointmentChannelId) ? (0, $cEKee.form)?.appointment_channel?.procedures || (0, $cEKee.procedures) : (0, $cEKee.procedures);
                if (is_phone_otp_enabled && data.phone) {
                    (0, $2XKfp.toggleLoading)(false);
                    (0, $cEKee.setIsInstantQuote)(false);
                    (0, $cEKee.setTempLeadInfo)(data);
                    await $8ef13ced519033ea$var$navigateToValidateDigits(data.phone);
                    return;
                } else {
                    (0, $2XKfp.toggleLoading)(false);
                    (0, $cEKee.setIsInstantQuote)(false);
                    (0, $cEKee.setTempLeadInfo)(data);
                    if ($8ef13ced519033ea$export$3152ce3756353630(proceduresToShow)) {
                        addLoadingBtnRequestConsult();
                        return;
                    }
                }
            } else if (is_phone_otp_enabled && data.phone) {
                (0, $2XKfp.toggleLoading)(false);
                (0, $cEKee.setIsInstantQuote)(false);
                (0, $cEKee.setTempLeadInfo)(data);
                await $8ef13ced519033ea$var$navigateToValidateDigits(data.phone);
                return;
            } else {
                const res = await (0, $2q2gk.createLead)(data);
                (0, $cEKee.setLeadTextId)(res.data.text_id);
                const lead = res.data;
                (0, $cEKee.setLeadInfo)(lead);
                (0, $2XKfp.toggleLoading)(false);
                (0, $cEKee.setIsInstantQuote)(false);
                document.getElementById('consult-summary')?.focus();
                const isCalendarAppointmentFlow = (0, $cEKee.appointmentChannelId) && (0, $cEKee.form)?.appointment_request_type === 'calendar';
                // Calendar appointment-channel flow: choose slot first, then questionnaire.
                if (isCalendarAppointmentFlow) {
                    // Set on_page immediately so EndWidgetSessions cron can catch
                    // drop-offs during calendar/time selection screens.
                    (0, $2q2gk.updateLeadStep)(lead.id, 'login', '');
                    // Show questionnaire before calendar if setting is enabled
                    const showQuestionnaireBefore = (0, $cEKee.form)?.appointment_channel?.show_questionnaire_before_scheduling;
                    if (showQuestionnaireBefore) {
                        const qualificationFields = Array.isArray((0, $cEKee.form)?.appointment_channel?.qualification_form?.custom_fields) ? (0, $cEKee.form).appointment_channel.qualification_form.custom_fields : [];
                        if (qualificationFields.length > 0) {
                            // upload_before (card photo → skip to type policy/member ID)
                            // only runs on the one-per-page path, not all-questions.
                            if (qualificationFields.some((f)=>f?.upload_before)) {
                                (0, $cEKee.setListDataQuestion)({});
                                (0, $cEKee.setListNamePageQuestion)([]);
                                (0, $cEKee.setQuestionnaireFields)(qualificationFields);
                                (0, $cEKee.setQuestionnaireFormId)((0, $cEKee.form)?.appointment_channel?.qualification_form?.id);
                                (0, $cEKee.setProgressQuestion)({
                                    currentQuestion: 1,
                                    total: qualificationFields.length,
                                    progress: 1 / qualificationFields.length * 100
                                });
                                (0, $cEKee.setCustomField)(qualificationFields[0]);
                                (0, $cEKee.setFirstQuestion)(true);
                                (0, $9bGUq.loadCustomFields)(qualificationFields[0]);
                                return;
                            }
                            if ((0, $99TAZ.shouldShowAllQuestions)()) {
                                (0, $cEKee.setCustomFields)(qualificationFields);
                                (0, $99TAZ.loadAllQuestionsFlow)();
                                return;
                            }
                        }
                    }
                    (0, $er9E0.openBookAppointment)();
                    return;
                }
                // Photos-first flow: collect photo uploads BEFORE the questionnaire,
                // then hand off to handelConsultSummaryBtn to start it.
                if ((0, $cEKee.fileUploadChannel)?.channelable?.before_questionnaire && !(0, $cEKee.preQuestionnairePhotosDone)) {
                    (0, $kF2gg.uploadPhotosListeners)(()=>{
                        (0, $cEKee.setPreQuestionnairePhotosDone)(true);
                        $8ef13ced519033ea$export$36d1e5aa4bc8a304();
                    });
                    (0, $er9E0.navigate)((0, $cIxq8.SCREEN).UPLOAD_PHOTOS);
                    return;
                }
                const consultRequestFields = !(0, $cEKee.isFlowForCalendar) && Array.isArray((0, $cEKee.form)?.consult_request_fields) ? (0, $cEKee.form).consult_request_fields : [];
                if ((0, $dc3p2.shouldStepConsultFields)(consultRequestFields)) {
                    const forProcedure = (0, $dc3p2.filterFieldsForProcedures)(consultRequestFields, $8ef13ced519033ea$var$getSelectedProcedureTokens());
                    if (forProcedure.length > 0) {
                        (0, $cEKee.setListDataQuestion)({});
                        (0, $cEKee.setListNamePageQuestion)([]);
                        const normalized = forProcedure.map((f)=>({
                                ...f,
                                title: f.title || f.label || (0, $knjAn.t)('custom_field')
                            }));
                        (0, $cEKee.setQuestionnaireFields)(normalized);
                        (0, $cEKee.setQuestionnaireFormId)((0, $cEKee.form)?.consult_request_form_id ?? null);
                        (0, $cEKee.setProgressQuestion)({
                            currentQuestion: 1,
                            total: normalized.length,
                            progress: 1 / normalized.length * 100
                        });
                        await (0, $2q2gk.updateLeadStep)(lead.id, 'consult', '');
                        (0, $cEKee.setCustomField)(normalized[0]);
                        (0, $cEKee.setFirstQuestion)(true);
                        (0, $9bGUq.loadCustomFields)(normalized[0]);
                        return;
                    }
                }
                // qualification_form custom_fields only apply to calendar flow
                const isFormFlow = (0, $cEKee.form)?.appointment_request_type === 'form';
                const qualificationFields = !isFormFlow && Array.isArray((0, $cEKee.form)?.appointment_channel?.qualification_form?.custom_fields) ? (0, $cEKee.form).appointment_channel.qualification_form.custom_fields : [];
                if (qualificationFields.length > 0) {
                    (0, $cEKee.setQuestionnaireFields)(qualificationFields);
                    (0, $cEKee.setQuestionnaireFormId)((0, $cEKee.form)?.appointment_channel?.qualification_form?.id);
                    (0, $cEKee.setProgressQuestion)({
                        currentQuestion: 1,
                        total: qualificationFields.length,
                        progress: 1 / qualificationFields.length * 100
                    });
                    await (0, $2q2gk.updateLeadStep)(lead.id, 'consult', '');
                    (0, $cEKee.setCustomField)(qualificationFields[0]);
                    (0, $cEKee.setFirstQuestion)(true);
                    (0, $9bGUq.loadCustomFields)(qualificationFields[0]);
                    return;
                }
                if (collect_patient_information_first_before_scheduling && (0, $cEKee.appointmentChannelId)) {
                    if (0, $cEKee.isFlowForCalendar) (0, $2q2gk.updateLeadStep)((0, $cEKee.leadInfo).id, 'login', 'true');
                    (0, $er9E0.openBookAppointment)();
                    return;
                }
                $8ef13ced519033ea$export$36d1e5aa4bc8a304();
            }
        } catch (err) {
            console.log(err);
            (0, $gZEOs.toastError)(err?.response?.data?.message);
            (0, $2XKfp.toggleLoading)(false);
            return;
        } finally{
            addLoadingBtnRequestConsult();
        }
    }
}
async function $8ef13ced519033ea$export$36d1e5aa4bc8a304() {
    const isCalendarAppointmentFlow = (0, $cEKee.appointmentChannelId) && (0, $cEKee.form)?.appointment_request_type === 'calendar';
    if (isCalendarAppointmentFlow) {
        (0, $er9E0.openBookAppointment)();
        return;
    }
    // Photos-first flow: collect photo uploads BEFORE the questionnaire,
    // then re-enter this function to start the questionnaire.
    if ((0, $cEKee.fileUploadChannel)?.channelable?.before_questionnaire && !(0, $cEKee.preQuestionnairePhotosDone)) {
        (0, $kF2gg.uploadPhotosListeners)(()=>{
            (0, $cEKee.setPreQuestionnairePhotosDone)(true);
            $8ef13ced519033ea$export$36d1e5aa4bc8a304();
        });
        (0, $er9E0.navigate)((0, $cIxq8.SCREEN).UPLOAD_PHOTOS);
        return;
    }
    // Priority 1: consult_request_fields (consult request form flow only, not calendar)
    const consultRequestFields = !(0, $cEKee.isFlowForCalendar) && Array.isArray((0, $cEKee.form)?.consult_request_fields) ? (0, $cEKee.form).consult_request_fields : [];
    if ((0, $dc3p2.shouldStepConsultFields)(consultRequestFields)) {
        const forProcedure = (0, $dc3p2.filterFieldsForProcedures)(consultRequestFields, $8ef13ced519033ea$var$getSelectedProcedureTokens());
        if (forProcedure.length > 0) {
            (0, $cEKee.setListDataQuestion)({});
            (0, $cEKee.setListNamePageQuestion)([]);
            const normalized = forProcedure.map((f)=>({
                    ...f,
                    title: f.title || f.label || (0, $knjAn.t)('custom_field')
                }));
            (0, $cEKee.setQuestionnaireFields)(normalized);
            (0, $cEKee.setQuestionnaireFormId)((0, $cEKee.form)?.consult_request_form_id ?? null);
            (0, $cEKee.setProgressQuestion)({
                currentQuestion: 1,
                total: normalized.length,
                progress: 1 / normalized.length * 100
            });
            await (0, $2q2gk.updateLeadStep)((0, $cEKee.leadInfo).id, 'consult', '');
            (0, $cEKee.setCustomField)(normalized[0]);
            (0, $cEKee.setFirstQuestion)(true);
            (0, $9bGUq.loadCustomFields)(normalized[0]);
            return;
        }
    }
    // Priority 2: qualification_form custom_fields (calendar flow only)
    const isFormFlow = (0, $cEKee.form)?.appointment_request_type === 'form';
    const qualificationFields = !isFormFlow && Array.isArray((0, $cEKee.form)?.appointment_channel?.qualification_form?.custom_fields) ? (0, $cEKee.form).appointment_channel.qualification_form.custom_fields : [];
    if (qualificationFields.length > 0) {
        (0, $cEKee.setQuestionnaireFields)(qualificationFields);
        (0, $cEKee.setQuestionnaireFormId)((0, $cEKee.form)?.appointment_channel?.qualification_form?.id);
        (0, $cEKee.setProgressQuestion)({
            currentQuestion: 1,
            total: qualificationFields.length,
            progress: 1 / qualificationFields.length * 100
        });
        await (0, $2q2gk.updateLeadStep)((0, $cEKee.leadInfo).id, 'consult', '');
        (0, $cEKee.setCustomField)(qualificationFields[0]);
        (0, $cEKee.setFirstQuestion)(true);
        (0, $9bGUq.loadCustomFields)(qualificationFields[0]);
        return;
    }
    // Single-pager DOB split: the consult request form was the whole flow and
    // DOB is required — collect it on its own step before the end screen. The
    // lead already exists, so a drop-off here still leaves a complete contact.
    if ($8ef13ced519033ea$export$d50d5ab80843d36a() && !(0, $cEKee.consultDobStepDone) && !(0, $cEKee.leadInfo)?.date_of_birth) {
        $8ef13ced519033ea$var$showConsultDobStep();
        return;
    }
    if ((0, $cEKee.fileUploadChannel) && !(0, $cEKee.preQuestionnairePhotosDone)) {
        (0, $kF2gg.uploadPhotosListeners)();
        (0, $er9E0.navigate)((0, $cIxq8.SCREEN).UPLOAD_PHOTOS);
    } else (0, $er9E0.navigate)((0, $cIxq8.SCREEN).THE_END);
}
function $8ef13ced519033ea$export$d50d5ab80843d36a() {
    const isFormOnlyFlow = !(0, $cEKee.isFlowForCalendar) && (0, $cEKee.form)?.appointment_request_type !== 'calendar';
    const isPrebookPatientInfo = (0, $cEKee.appointmentChannelId) && (0, $cEKee.form)?.appointment_channel?.collect_patient_information_first_before_scheduling;
    const consultRequestFields = Array.isArray((0, $cEKee.form)?.consult_request_fields) ? (0, $cEKee.form).consult_request_fields : [];
    const hasPhotoUpload = Boolean((0, $cEKee.fileUploadChannel)) && !(Array.isArray((0, $cEKee.fileUploadChannel)) && (0, $cEKee.fileUploadChannel).length === 0);
    return Boolean((0, $cEKee.form)?.show_dob_field && isFormOnlyFlow && !(0, $cEKee.isInInstantQuote) && !isPrebookPatientInfo && !(0, $cEKee.form)?.appointment_channel?.enable_category_selection && !(0, $dc3p2.shouldStepConsultFields)(consultRequestFields) && !hasPhotoUpload);
}
let $8ef13ced519033ea$var$consultDobSaving = false;
function $8ef13ced519033ea$var$showConsultDobStep() {
    const container = document.querySelector('.consultDob__container');
    if (!container) {
        (0, $er9E0.navigate)((0, $cIxq8.SCREEN).THE_END);
        return;
    }
    container.querySelector('.consultDob__title').textContent = (0, $knjAn.t)('dob_step_title');
    container.querySelector('.consultDob__subtitle').textContent = (0, $knjAn.t)('dob_step_subtitle');
    const btn = container.querySelector('.consultDob__btn');
    btn.querySelector('.text').textContent = (0, $knjAn.t)('continue');
    if (!container.querySelector('#dobStepInput')) {
        (0, $d3FqX.renderDobDropdowns)(container.querySelector('.dob__consult'), {
            inputId: 'dobStepInput',
            idPrefix: 'dobStep',
            onChange: (value)=>btn.classList.toggle('disabled', !value)
        });
        btn.addEventListener('click', $8ef13ced519033ea$var$handleConsultDobContinue);
    }
    (0, $er9E0.navigate)((0, $cIxq8.SCREEN).CONSULT_DOB);
}
async function $8ef13ced519033ea$var$handleConsultDobContinue() {
    const btn = document.querySelector('.consultDob__btn');
    const dob = document.getElementById('dobStepInput')?.value;
    if (!dob || $8ef13ced519033ea$var$consultDobSaving || btn?.classList.contains('disabled')) return;
    $8ef13ced519033ea$var$consultDobSaving = true;
    btn.classList.add('disabled');
    const loaderIcon = btn.querySelector('.loader__icon');
    if (loaderIcon) loaderIcon.innerHTML = `<img src="${0, $cEKee.appUrl}/assets/icons/rolling.png" />`;
    try {
        const targetTextId = (0, $cEKee.leadInfo)?.text_id || (0, $cEKee.leadTextId);
        await (0, $jmDLz.updateLeadPortal)(targetTextId, {
            date_of_birth: dob
        });
        // WidgetLeadResource doesn't echo date_of_birth — merge it locally so
        // re-entry into handelConsultSummaryBtn sees it as collected.
        (0, $cEKee.setLeadInfo)({
            ...(0, $cEKee.leadInfo) || {},
            date_of_birth: dob
        });
        (0, $cEKee.setConsultDobStepDone)(true);
        $8ef13ced519033ea$export$36d1e5aa4bc8a304();
    } catch (err) {
        console.log(err);
        (0, $gZEOs.toastError)(err?.response?.data?.message);
        btn.classList.remove('disabled');
    } finally{
        $8ef13ced519033ea$var$consultDobSaving = false;
        if (loaderIcon) loaderIcon.innerHTML = '';
    }
}
async function $8ef13ced519033ea$var$navigateToValidateDigits(phone) {
    (0, $cEKee.setPhone)(phone);
    if (0, $cEKee.isOTPTimeOut) await (0, $577MR.sendOTPCodeWithTimer)();
    document.getElementById('validateDigits0').focus();
    (0, $er9E0.navigate)((0, $cIxq8.SCREEN).VALIDATE_DIGITS);
    const phoneNumObj = (0, $k3ko8.parsePhoneNumberFromString)(phone, 'US');
    if (document.querySelector('.validateDigits--sub-title strong')) document.querySelector('.validateDigits--sub-title strong').innerHTML = phoneNumObj.number;
}

});
parcelRegister("sFKcc", function(module, exports) {

$parcel$export(module.exports, "loadSelectSearchProcedure", () => $0562ff25ac92c9b5$export$13bcad29955ca415);

var $cgStI = parcelRequire("cgStI");

var $cEKee = parcelRequire("cEKee");
function $0562ff25ac92c9b5$export$13bcad29955ca415(procedures) {
    const list = document.querySelector('.requestConsult__container .procedure__menu .procedure__select');
    list.innerHTML = '';
    let result = ``;
    const filteredProcedures = procedures ? procedures.filter((i)=>{
        if ((0, $cEKee.surgicalOption) === null) return i.online_booking;
        if (!(0, $cEKee.surgicalOption)) return i.surgical === 0 && i.online_booking;
        else return i.surgical === 1 && i.online_booking;
    }) : [];
    if (filteredProcedures.length > 0) for (const i of filteredProcedures)result = result.concat(`
            <li class="procedure__option" data-procedure-id="${i.id}">${i.name}</li>
            `);
    let menuDropdownProcedures = document.querySelector('.requestConsult__container .procedure__menu');
    if (result) menuDropdownProcedures.classList.remove('non-boxShadow');
    else menuDropdownProcedures.classList.add('non-boxShadow');
    list.insertAdjacentHTML('beforeend', result);
    (0, $cgStI.handleSelectProcedure)();
}

});

parcelRegister("5xphE", function(module, exports) {

$parcel$export(module.exports, "loadProvidersDropdown", () => $4083a59ee93a2963$export$59954ee02a354bcc);

var $cgStI = parcelRequire("cgStI");

var $cEKee = parcelRequire("cEKee");

var $knjAn = parcelRequire("knjAn");
function $4083a59ee93a2963$export$59954ee02a354bcc(providers) {
    const wrapper = document.querySelector('.requestConsult__container .providersDropdown__wrapper');
    if (!wrapper) return;
    if (0, $cEKee.staffId) return;
    let list = document.querySelector('.requestConsult__container .providersDropdown__wrapper .providers__select');
    list.innerHTML = '';
    // "No preference" option (consult_allow_no_preference): rendered FIRST so the
    // visitor can submit without choosing a provider. An empty data-provider-id
    // is the sentinel — handleSelectProvider treats it as "no provider", so no
    // staff_id is sent and the consult comes in unassigned.
    if ((0, $cEKee.form)?.consult_allow_no_preference) {
        const defaultAvatar = `${(0, $cEKee.appUrl)}/assets/images/png/default-avatar.png`;
        list.insertAdjacentHTML('beforeend', `
        <li class="providersDropdown__option providersDropdown__option--no-preference"
            data-provider-id=""
            data-provider="${(0, $knjAn.t)('no_preference')}"
            data-avt="${defaultAvatar}">

            <img src="${defaultAvatar}" />

            <div class="provider__info">
                <div>${(0, $knjAn.t)('no_preference')}</div>
            </div>
        </li>
        `);
    }
    if (providers.length <= 0) list.insertAdjacentHTML('beforeend', `
            <li>${(0, $knjAn.t)('no_providers_found')}</li>
        `);
    for (const i of providers)list.insertAdjacentHTML('beforeend', `
        <li class="providersDropdown__option" 
            data-provider-id="${i.id}" 
            data-provider="${i.first_name + ' ' + i.last_name}"
            data-avt="${i?.photo ? i.photo : `${0, $cEKee.appUrl}/assets/images/png/default-avatar.png`}">
            
            <img src="${i?.photo ? i.photo : `${0, $cEKee.appUrl}/assets/images/png/default-avatar.png`}" />
            
            <div class="provider__info">
                <div>${i.first_name + ' ' + i.last_name}</div>
                ${i.title ? `<div class="providerDropdown__title">${i.title}</div>` : ''}
            </div>
        </li>
        `);
    (0, $cgStI.handleSelectProvider)();
}

});

parcelRegister("lUSOA", function(module, exports) {

$parcel$export(module.exports, "loadLocationsDropdown", () => $ff4959058fc7f10e$export$32ee3dc9a76fc36b);

var $cgStI = parcelRequire("cgStI");

var $cEKee = parcelRequire("cEKee");

var $knjAn = parcelRequire("knjAn");
function $ff4959058fc7f10e$export$32ee3dc9a76fc36b(locations) {
    let tempLocations = locations;
    if ((0, $cEKee.staffId) && (0, $cEKee.locationId)) tempLocations = locations?.filter((l)=>l.id === (0, $cEKee.locationId));
    let list = document.querySelector('.locationsDropdown__wrapper .locationsDropdown__select');
    if (list) {
        list.innerHTML = '';
        if (tempLocations.length <= 0) list.insertAdjacentHTML('beforeend', `
                <li>${(0, $knjAn.t)('no_locations_found')}</li>
            `);
        for (const lo of tempLocations)list.insertAdjacentHTML('beforeend', `
            <li class="locations-dropdown__option"
                data-location-id="${lo.id}"
                data-location="${lo.name}"
            >
            ${lo.name}
            </li>
            `);
        (0, $cgStI.handleSelectLocation)();
    }
}

});

parcelRegister("3UENa", function(module, exports) {

$parcel$export(module.exports, "getProceduresByStaffId", () => $2d963e7c80b9b9d4$export$f2fa67988aaf41e);
$parcel$export(module.exports, "getProcedureStaffByStaffId", () => $2d963e7c80b9b9d4$export$1ff5aa668dd91594);
$parcel$export(module.exports, "getProceduresStaffByProcedureIds", () => $2d963e7c80b9b9d4$export$94f1dd33e315e305);

var $hvLQT = parcelRequire("hvLQT");
async function $2d963e7c80b9b9d4$export$7b5f868846c04008() {
    try {
        return await (0, $hvLQT.apiClient).GET(`api/procedures`);
    } catch (err) {}
}
async function $2d963e7c80b9b9d4$export$f2fa67988aaf41e(staffId) {
    return await (0, $hvLQT.apiClient).GET(`api/procedures?staff_id=${staffId}`);
}
async function $2d963e7c80b9b9d4$export$1ff5aa668dd91594(staffId) {
    return await (0, $hvLQT.apiClient).GET(`api/procedure/staff?staff_id=${staffId}`);
}
async function $2d963e7c80b9b9d4$export$94f1dd33e315e305(procedureIds) {
    try {
        return await (0, $hvLQT.apiClient).GET(`api/procedure/staff?in[procedure_id]=${procedureIds.join(',')}`);
    } catch (err) {}
}

});

parcelRegister("cOK4N", function(module, exports) {

$parcel$export(module.exports, "surgicalListeners", () => $954de55861952f82$export$2808e01d156638c3);
$parcel$export(module.exports, "handleSurgicalButtonClick", () => $954de55861952f82$export$cdb7ab9d8b245374);
$parcel$export(module.exports, "handleNonSurgicalButtonClick", () => $954de55861952f82$export$dfd0a704b75e0d10);
$parcel$export(module.exports, "removeStyleSurgicalOptionSelected", () => $954de55861952f82$export$4622e76a1d86d873);
$parcel$export(module.exports, "preSelectProcedure", () => $954de55861952f82$export$38cdb65c5a858af7);
$parcel$export(module.exports, "handleBothSurgicalOptionsClick", () => $954de55861952f82$export$3d6a1e0749845b9e);

var $cIxq8 = parcelRequire("cIxq8");

var $er9E0 = parcelRequire("er9E0");

var $cEKee = parcelRequire("cEKee");

var $sFKcc = parcelRequire("sFKcc");
parcelRequire("gsdGr");

var $a5XF8 = parcelRequire("a5XF8");

var $lmlIJ = parcelRequire("lmlIJ");

var $1kc6e = parcelRequire("1kc6e");

var $ig8jH = parcelRequire("ig8jH");
function $954de55861952f82$export$2808e01d156638c3() {
    /* on select surgical*/ $954de55861952f82$var$clickSurgicalOptionListener();
    /* on click back button */ document.querySelectorAll('.procedure__price-duration').forEach((j)=>j.classList.remove('procedure__price-duration--show'));
}
function $954de55861952f82$var$clickSurgicalOptionListener() {
    document.getElementById('button--surgical').addEventListener('click', $954de55861952f82$export$cdb7ab9d8b245374);
    document.getElementById('button--non-surgical').addEventListener('click', $954de55861952f82$export$dfd0a704b75e0d10);
    document.querySelector('.surgical-option__btn')?.addEventListener('click', $954de55861952f82$var$onClickSurgicalOptionAction);
}
async function $954de55861952f82$var$onClickSurgicalOptionAction() {
    (0, $cEKee.setLocationId)((0, $cEKee.locations)[0]?.id);
    if (0, $cEKee.surgicalOption) {
        if ((0, $cEKee.form).appointment_request_type === (0, $cIxq8.APPOINTMENT_REQUEST_CALENDAR)) {
            if (0, $cEKee.isBookAppointment) {
                if ((0, $ig8jH.isPageHidden)('patient_page', (0, $cEKee.hiddenPages))) (0, $lmlIJ.patientContinueBtnHandler)();
                else {
                    (0, $lmlIJ.patientListeners)();
                    (0, $er9E0.navigate)((0, $cIxq8.SCREEN).PATIENTS);
                }
            }
        } else {
            if (0, $cEKee.staffId) await (0, $a5XF8.fetchProcedureByStaff)(+(0, $cEKee.staffId));
            (0, $sFKcc.loadSelectSearchProcedure)((0, $cEKee.procedures));
            (0, $er9E0.navigate)((0, $cIxq8.SCREEN).REQUEST_CONSULT);
        }
    } else if (0, $cEKee.consultationNonSurgicalPath) window.open((0, $cEKee.consultationNonSurgicalPath), '_blank');
    else {
        if ((0, $cEKee.form).appointment_request_type === (0, $cIxq8.APPOINTMENT_REQUEST_CALENDAR)) {
            if (0, $cEKee.isBookAppointment) {
                if ((0, $ig8jH.isPageHidden)('patient_page', (0, $cEKee.hiddenPages))) (0, $lmlIJ.patientContinueBtnHandler)();
                else {
                    (0, $lmlIJ.patientListeners)();
                    (0, $er9E0.navigate)((0, $cIxq8.SCREEN).PATIENTS);
                }
            }
        } else {
            if (0, $cEKee.staffId) await (0, $a5XF8.fetchProcedureByStaff)(+(0, $cEKee.staffId));
            (0, $sFKcc.loadSelectSearchProcedure)((0, $cEKee.procedures));
            (0, $er9E0.navigate)((0, $cIxq8.SCREEN).REQUEST_CONSULT);
        }
    }
    $954de55861952f82$var$checkStaffExist();
}
function $954de55861952f82$export$4622e76a1d86d873(isSurgical) {
    let btnIdName = isSurgical ? 'button--surgical' : 'button--non-surgical';
    document.getElementById(btnIdName).classList.remove('surgical-option--selected');
    document.querySelectorAll(`#${btnIdName} .title-wrapper span`).forEach((e)=>{
        e.classList.remove('surgical-option__title--selected');
    });
    document.querySelector(`#${btnIdName} .icon__background`)?.classList.remove('surgical-option__icon-wrapper--selected');
    document.querySelector(`#${btnIdName} .icon__background .icon--svg path`)?.classList.remove('surgical-option__icon--selected');
}
function $954de55861952f82$var$addStyleSurgicalOptionSelected(isSurgical) {
    let btnIdName = isSurgical ? 'button--surgical' : 'button--non-surgical';
    document.getElementById(btnIdName).classList.add('surgical-option--selected');
    document.querySelectorAll(`#${btnIdName} .title-wrapper span`).forEach((e)=>{
        e.classList.add('surgical-option__title--selected');
    });
    document.querySelector(`#${btnIdName} .icon__background`).classList.add('surgical-option__icon-wrapper--selected');
    document.querySelector(`#${btnIdName} .icon__background .icon--svg path`)?.classList.add('surgical-option__icon--selected');
}
async function $954de55861952f82$export$cdb7ab9d8b245374() {
    (0, $cEKee.setLocationId)((0, $cEKee.locations)[0]?.id);
    if ((0, $cEKee.surgicalOption) === null || (0, $cEKee.surgicalOption) === false) {
        $954de55861952f82$var$addStyleSurgicalOptionSelected(true);
        $954de55861952f82$export$4622e76a1d86d873(false);
        (0, $cEKee.setSurgicalOption)(true);
        (0, $cEKee.setIsBookAppointment)(true);
        const checkStaffId = (0, $cEKee.form)?.staff?.findIndex((staff)=>staff.id === +(0, $cEKee.staffId));
        if ((0, $cEKee.staffId) && checkStaffId < 0) return;
        if (checkStaffId >= 0 && (0, $cEKee.staffId)) {
            const id = (0, $cEKee.appointmentChannelId) && (0, $cEKee.form)?.appointment_channel?.procedures?.length > 1 ? (0, $cEKee.providerId) : (0, $cEKee.staffId);
            if (!(0, $cEKee.appointmentChannelId)) await (0, $a5XF8.fetchProcedureByStaff)(id ?? +(0, $cEKee.staffId));
        }
        if ((0, $cEKee.form).appointment_request_type === (0, $cIxq8.APPOINTMENT_REQUEST_CALENDAR) || (0, $cEKee.appointmentChannelId)) {
            if ((0, $cEKee.isBookAppointment) || (0, $cEKee.appointmentChannelId)) {
                if (0, $cEKee.appointmentChannelId) {
                    const hostType = (0, $cEKee.form)?.appointment_channel?.host || (0, $cIxq8.HOST_TYPE_ONE_ON_ONE);
                    const staffsOfAppointmentChannel = (0, $cEKee.form)?.appointment_channel?.staffs?.filter((staff)=>staff?.online_booking);
                    const staffCount = staffsOfAppointmentChannel?.length || 0;
                    const isProviderFirst = (0, $cEKee.form)?.appointment_channel?.is_select_provider_first;
                    if (hostType === (0, $cIxq8.HOST_TYPE_ONE_ON_ONE) && staffCount > 1) {
                        if (isProviderFirst) (0, $er9E0.goToProviderScheduleLink)();
                        else (0, $1kc6e.goToServices)();
                    } else (0, $1kc6e.goToServices)();
                } else if ((0, $ig8jH.isPageHidden)('patient_page', (0, $cEKee.hiddenPages))) (0, $lmlIJ.patientContinueBtnHandler)();
                else {
                    (0, $lmlIJ.patientListeners)();
                    (0, $er9E0.navigate)((0, $cIxq8.SCREEN).PATIENTS);
                }
            }
        } else {
            $954de55861952f82$export$38cdb65c5a858af7();
            if (0, $cEKee.staffId) {
                if (checkStaffId >= 0) {
                    (0, $sFKcc.loadSelectSearchProcedure)((0, $cEKee.procedures));
                    (0, $er9E0.navigate)((0, $cIxq8.SCREEN).REQUEST_CONSULT);
                }
            } else {
                (0, $sFKcc.loadSelectSearchProcedure)((0, $cEKee.procedures));
                (0, $er9E0.navigate)((0, $cIxq8.SCREEN).REQUEST_CONSULT);
            }
        }
    } else if (0, $cEKee.surgicalOption) {
        $954de55861952f82$export$4622e76a1d86d873(true);
        $954de55861952f82$export$4622e76a1d86d873(false);
        (0, $cEKee.setSurgicalOption)(null);
    }
    $954de55861952f82$var$checkStaffExist();
}
async function $954de55861952f82$export$dfd0a704b75e0d10() {
    (0, $cEKee.setLocationId)((0, $cEKee.locations)[0]?.id);
    if ((0, $cEKee.surgicalOption) === null || (0, $cEKee.surgicalOption) === true) {
        $954de55861952f82$var$addStyleSurgicalOptionSelected(false);
        $954de55861952f82$export$4622e76a1d86d873(true);
        (0, $cEKee.setSurgicalOption)(false);
        (0, $cEKee.setIsBookAppointment)(true);
        const checkStaffId = (0, $cEKee.form)?.staff?.findIndex((staff)=>staff.id === +(0, $cEKee.staffId));
        if ((0, $cEKee.staffId) && checkStaffId < 0) return;
        if (checkStaffId >= 0 && (0, $cEKee.staffId)) {
            const id = (0, $cEKee.appointmentChannelId) && (0, $cEKee.form)?.appointment_channel?.procedures?.length > 1 ? (0, $cEKee.providerId) : (0, $cEKee.staffId);
            if (!(0, $cEKee.appointmentChannelId)) await (0, $a5XF8.fetchProcedureByStaff)(id ?? +(0, $cEKee.staffId));
        }
        if (0, $cEKee.consultationNonSurgicalPath) window.open((0, $cEKee.consultationNonSurgicalPath), '_blank');
        else if ((0, $cEKee.form).appointment_request_type === (0, $cIxq8.APPOINTMENT_REQUEST_CALENDAR) || (0, $cEKee.appointmentChannelId)) {
            if (0, $cEKee.appointmentChannelId) {
                const hostType = (0, $cEKee.form)?.appointment_channel?.host || (0, $cIxq8.HOST_TYPE_ONE_ON_ONE);
                const staffsOfAppointmentChannel = (0, $cEKee.form)?.appointment_channel?.staffs?.filter((staff)=>staff?.online_booking);
                const staffCount = staffsOfAppointmentChannel?.length || 0;
                const isProviderFirst = (0, $cEKee.form)?.appointment_channel?.is_select_provider_first;
                if (hostType === (0, $cIxq8.HOST_TYPE_ONE_ON_ONE) && staffCount > 1) {
                    if (isProviderFirst) (0, $er9E0.goToProviderScheduleLink)();
                    else (0, $1kc6e.goToServices)();
                } else (0, $1kc6e.goToServices)();
            } else if ((0, $ig8jH.isPageHidden)('patient_page', (0, $cEKee.hiddenPages))) (0, $lmlIJ.patientContinueBtnHandler)();
            else {
                (0, $lmlIJ.patientListeners)();
                (0, $er9E0.navigate)((0, $cIxq8.SCREEN).PATIENTS);
            }
        } else {
            $954de55861952f82$export$38cdb65c5a858af7();
            if (0, $cEKee.staffId) {
                if (checkStaffId >= 0) {
                    (0, $sFKcc.loadSelectSearchProcedure)((0, $cEKee.procedures));
                    (0, $er9E0.navigate)((0, $cIxq8.SCREEN).REQUEST_CONSULT);
                }
            } else {
                (0, $sFKcc.loadSelectSearchProcedure)((0, $cEKee.procedures));
                (0, $er9E0.navigate)((0, $cIxq8.SCREEN).REQUEST_CONSULT);
            }
        }
    } else {
        $954de55861952f82$export$4622e76a1d86d873(true);
        $954de55861952f82$export$4622e76a1d86d873(false);
        (0, $cEKee.setSurgicalOption)(null);
    }
    $954de55861952f82$var$checkStaffExist();
}
async function $954de55861952f82$export$3d6a1e0749845b9e() {
    (0, $cEKee.setLocationId)((0, $cEKee.locations)[0]?.id);
    $954de55861952f82$export$4622e76a1d86d873(true);
    $954de55861952f82$export$4622e76a1d86d873(false);
    (0, $cEKee.setSurgicalOption)(null);
    (0, $cEKee.setIsBookAppointment)(true);
    const checkStaffId = (0, $cEKee.form)?.staff?.findIndex((staff)=>staff.id === +(0, $cEKee.staffId));
    if ((0, $cEKee.staffId) && checkStaffId < 0) return;
    if (checkStaffId >= 0 && (0, $cEKee.staffId)) {
        const id = (0, $cEKee.appointmentChannelId) && (0, $cEKee.form)?.appointment_channel?.procedures?.length > 1 ? (0, $cEKee.providerId) : (0, $cEKee.staffId);
        if (!(0, $cEKee.appointmentChannelId)) await (0, $a5XF8.fetchProcedureByStaff)(id ?? +(0, $cEKee.staffId));
    }
    if ((0, $cEKee.form).appointment_request_type === (0, $cIxq8.APPOINTMENT_REQUEST_CALENDAR) || (0, $cEKee.appointmentChannelId)) {
        if ((0, $cEKee.isBookAppointment) || (0, $cEKee.appointmentChannelId)) {
            if (0, $cEKee.appointmentChannelId) {
                const hostType = (0, $cEKee.form)?.appointment_channel?.host || (0, $cIxq8.HOST_TYPE_ONE_ON_ONE);
                const staffsOfAppointmentChannel = (0, $cEKee.form)?.appointment_channel?.staffs?.filter((staff)=>staff?.online_booking);
                const staffCount = staffsOfAppointmentChannel?.length || 0;
                const isProviderFirst = (0, $cEKee.form)?.appointment_channel?.is_select_provider_first;
                if (hostType === (0, $cIxq8.HOST_TYPE_ONE_ON_ONE) && staffCount > 1) {
                    if (isProviderFirst) (0, $er9E0.goToProviderScheduleLink)();
                    else (0, $1kc6e.goToServices)();
                } else (0, $1kc6e.goToServices)();
            } else if ((0, $ig8jH.isPageHidden)('patient_page', (0, $cEKee.hiddenPages))) (0, $lmlIJ.patientContinueBtnHandler)();
            else {
                (0, $lmlIJ.patientListeners)();
                (0, $er9E0.navigate)((0, $cIxq8.SCREEN).PATIENTS);
            }
        }
    } else {
        $954de55861952f82$export$38cdb65c5a858af7();
        if (0, $cEKee.staffId) {
            if (checkStaffId >= 0) {
                (0, $sFKcc.loadSelectSearchProcedure)((0, $cEKee.procedures));
                (0, $er9E0.navigate)((0, $cIxq8.SCREEN).REQUEST_CONSULT);
            }
        } else {
            (0, $sFKcc.loadSelectSearchProcedure)((0, $cEKee.procedures));
            (0, $er9E0.navigate)((0, $cIxq8.SCREEN).REQUEST_CONSULT);
        }
    }
    $954de55861952f82$var$checkStaffExist();
}
function $954de55861952f82$var$checkStaffExist() {
    if (0, $cEKee.staffId) {
        const btnContinue = document.querySelector(".surgical__container  .surgical-option__btn");
        const provider = (0, $cEKee.providers)?.find((p)=>p.id === +(0, $cEKee.staffId));
        btnContinue?.classList.toggle("disabled", !provider);
    }
}
const $954de55861952f82$export$38cdb65c5a858af7 = ()=>{
    if (0, $cEKee.procedureIdSelected) {
        const foundProcedure = (0, $cEKee.procedures)?.find((i)=>i?.id === +(0, $cEKee.procedureIdSelected));
        if (foundProcedure) {
            (0, $cEKee.setProcedureId)((0, $cEKee.procedureIdSelected));
            if (!foundProcedure?.name) return;
            document.querySelector('#procedureConsult').value = foundProcedure?.name || "";
            document?.querySelector(".requestConsult__container .procedure__wrapper")?.classList?.add("isSelectedByIdParams");
        } else document?.querySelector(".requestConsult__container .procedure__wrapper")?.classList?.remove("isSelectedByIdParams");
    } else document?.querySelector(".requestConsult__container .procedure__wrapper")?.classList?.remove("isSelectedByIdParams");
};

});
parcelRegister("a5XF8", function(module, exports) {

$parcel$export(module.exports, "providerListeners", () => $7598a6baeb03ba77$export$2ea9ea73f5285832);
$parcel$export(module.exports, "handleSelectProvider", () => $7598a6baeb03ba77$export$e52da098a506377b);
$parcel$export(module.exports, "handleProviderContinueBtn", () => $7598a6baeb03ba77$export$6393ef1a0c499c9);
$parcel$export(module.exports, "filterProcedures", () => $7598a6baeb03ba77$export$bf5875e000e62d6d);
$parcel$export(module.exports, "fetchProcedureByStaff", () => $7598a6baeb03ba77$export$2d2087c1cee2836d);

var $knjAn = parcelRequire("knjAn");

var $gZEOs = parcelRequire("gZEOs");

var $3UENa = parcelRequire("3UENa");

var $cIxq8 = parcelRequire("cIxq8");

var $cEKee = parcelRequire("cEKee");

var $62LVp = parcelRequire("62LVp");

var $er9E0 = parcelRequire("er9E0");

var $2XKfp = parcelRequire("2XKfp");

var $8QS3m = parcelRequire("8QS3m");

var $d0tLC = parcelRequire("d0tLC");

var $1BEhs = parcelRequire("1BEhs");

var $e4miY = parcelRequire("e4miY");
parcelRequire("sFKcc");

var $hltT2 = parcelRequire("hltT2");

var $1kc6e = parcelRequire("1kc6e");

var $cgStI = parcelRequire("cgStI");

var $2q2gk = parcelRequire("2q2gk");
function $7598a6baeb03ba77$var$canUserChooseStaff(hostType, staffCount) {
    // Auto-select soonest provider overrides all host-type rules: the visitor
    // never picks a provider.
    if ((0, $cEKee.isAutoSelectSoonestProviderEnabled)()) return false;
    switch(hostType){
        case 0, $cIxq8.HOST_TYPE_ONE_ON_ONE:
            {
                const isProviderFirst = (0, $cEKee.form)?.appointment_channel?.is_select_provider_first;
                return staffCount > 1 && isProviderFirst;
            }
        case 0, $cIxq8.HOST_TYPE_ROUND_ROBIN:
        case 0, $cIxq8.HOST_TYPE_COLLECTIVE:
            return false;
        default:
            return (0, $cEKee.form)?.appointment_channel?.visitor_can_choose_the_staff;
    }
}
function $7598a6baeb03ba77$var$getHostType() {
    return (0, $cEKee.form)?.appointment_channel?.host || (0, $cIxq8.HOST_TYPE_ONE_ON_ONE);
}
function $7598a6baeb03ba77$export$2ea9ea73f5285832() {
    /* On select provider */ document.querySelectorAll('.providers__list .provider').forEach((i)=>{
        i.addEventListener('click', $7598a6baeb03ba77$export$e52da098a506377b);
    });
    if (0, $cEKee.isBookAppointment) {
        const titleContent = document.querySelector('.providers__container .title__content');
        if (titleContent) titleContent.innerHTML = (0, $knjAn.t)('select_provider');
    }
    /* On click enter */ const screenProviders = document.querySelector('.screen--providers');
    if (screenProviders) screenProviders.addEventListener('keydown', $7598a6baeb03ba77$var$handleScreenProvidersKeyDown);
    /* On click Continue after selected provider */ document.querySelector('.providerContinue__btn').addEventListener('click', $7598a6baeb03ba77$export$6393ef1a0c499c9);
}
async function $7598a6baeb03ba77$export$6393ef1a0c499c9() {
    const isConsultationRequest = (0, $cEKee.form).appointment_request_type === (0, $cIxq8.APPOINTMENT_REQUEST_FORM);
    const isCategoryEnabled = (0, $cEKee.form)?.appointment_channel?.enable_category_selection;
    if (0, $cEKee.isInInstantQuote) {
        (0, $8QS3m.loadCategories)($7598a6baeb03ba77$export$bf5875e000e62d6d((0, $cEKee.procedures)));
        (0, $d0tLC.loadProcedures)($7598a6baeb03ba77$export$bf5875e000e62d6d((0, $cEKee.procedures)));
        (0, $er9E0.navigate)((0, $cIxq8.SCREEN).SEE_ALL_SERVICES);
    } else if (isConsultationRequest && isCategoryEnabled) {
        if ((0, $cEKee.tempLeadInfo) && !(0, $cEKee.leadInfo)) {
            const res = await (0, $2q2gk.createLead)({
                ...(0, $cEKee.tempLeadInfo),
                ...(0, $cEKee.providerId) && {
                    provider_id: (0, $cEKee.providerId)
                }
            });
            (0, $cEKee.setLeadTextId)(res.data.text_id);
            (0, $cEKee.setLeadInfo)(res.data);
            (0, $cEKee.setTempLeadInfo)(null);
        }
        (0, $cgStI.handelConsultSummaryBtn)();
    } else if (0, $cEKee.isBookAppointment) {
        const { staffs: staffs, procedures: proceduresOfAppointment } = (0, $cEKee.form).appointment_channel;
        if ((0, $cEKee.appointmentChannelId) && proceduresOfAppointment?.length > 1 && !(0, $cEKee.isFlowForCalendar)) {
            const proceduresIds = proceduresOfAppointment?.map((i)=>i.id);
            const providersOfServices = (0, $cEKee.selectedProcedures)?.every((i)=>proceduresIds?.includes(i));
            if (!providersOfServices) {
                const div = document.querySelector('.notfound__container .screen__content');
                if (div) div.textContent = (0, $knjAn.t)('provider_no_service');
                (0, $er9E0.navigate)((0, $cIxq8.SCREEN).NOTFOUND_APPOINTMENT);
                return;
            }
        }
        // `!form.appointment_request_type === X` compares a boolean to a string, so
        // it is always false and BOTH blocks below always fell through to
        // renderSelecTime() — running it twice, concurrently, whenever
        // requires_consult === false. The two runs rebuilt the date carousel while
        // the other was binding its click listeners (dead date taps) and raced four
        // navigate() calls (calendar rendered over the times screen). Keep the
        // effective behavior, but run it exactly once.
        $7598a6baeb03ba77$export$271d94f9a1110068();
    }
}
async function $7598a6baeb03ba77$export$271d94f9a1110068() {
    if (0, $cEKee.appointmentChannelId) {
        // Always use month calendar grid for appointment channel widget flow
        document.querySelector('.selectOnlyDate__container .title__content').innerHTML = `${(0, $knjAn.t)('select_time_with')} ${(0, $62LVp.getProviderFullName)()}`;
        if ((0, $cEKee.isDesktopVer) || !(0, $cEKee.isDesktopVer) && (0, $cEKee.initUI) === 'embedded') {
            document?.querySelector('.selectOnlyDate__container .screen__content')?.style.setProperty('--header-height', '0px');
            document.querySelector('.selectOnlyDate__container .title__wrapper').classList.add("hidden");
        }
        if (!(0, $cEKee.isDesktopVer) && (0, $cEKee.initUI) === 'embedded') {
            document?.querySelector('.selectOnlyDate__container .infoStaff')?.style.setProperty('display', 'none');
            document?.querySelector('.selectOnlyDate__container .selectOnlyTime__title')?.style.setProperty('padding-top', '1rem');
        }
        (0, $2XKfp.toggleLoading)(true);
        await (0, $1BEhs.loadOnlyTimeCarousel)();
        (0, $e4miY.selectOnlyTimeListeners)();
        const foundStaff = (0, $cEKee.form)?.staff?.find((staff)=>staff.id === +(0, $cEKee.staffId) || (0, $cEKee.providerId));
        const foundProcedure = (0, $cEKee.procedures).find((p)=>p?.id === +(0, $cEKee.procedureIdSelected));
        (0, $hltT2.renderStaffInfoHeader)(foundStaff, foundProcedure, 'selectOnlyDate__container');
        (0, $er9E0.navigate)((0, $cIxq8.SCREEN).SELECT_ONLY_DATE);
        (0, $2XKfp.toggleLoading)(false);
        return;
    }
    // Legacy non-appointmentChannel flows — keep existing behavior
    if (0, $cEKee.shouldCollectPatientInfoFirstForWidget) {
        (0, $cEKee.setCurrentDateInUse)(moment().unix());
        (0, $2XKfp.toggleLoading)(true);
        await (0, $1BEhs.loadTimeCarousel)();
        (0, $e4miY.selectTimeListeners)();
        document.querySelector('.selectTime__container .title__content').innerHTML = `${(0, $knjAn.t)('select_time_with')} ${(0, $62LVp.getProviderFullName)()}`;
        (0, $er9E0.navigate)((0, $cIxq8.SCREEN).SELECT_TIME);
        (0, $2XKfp.toggleLoading)(false);
    } else if ((0, $cEKee.staffId) && (0, $cEKee.procedureIdSelected) || (0, $cEKee.appointmentChannelId) && (0, $cEKee.form)?.appointment_channel?.procedures?.length > 1) {
        document.querySelector('.selectOnlyDate__container .title__content').innerHTML = `${(0, $knjAn.t)('select_time_with')} ${(0, $62LVp.getProviderFullName)()}`;
        if ((0, $cEKee.isDesktopVer) || !(0, $cEKee.isDesktopVer) && (0, $cEKee.initUI) === 'embedded') {
            document?.querySelector('.selectOnlyDate__container .screen__content')?.style.setProperty('--header-height', '0px');
            document.querySelector('.selectOnlyDate__container .title__wrapper').classList.add("hidden");
        }
        if (!(0, $cEKee.isDesktopVer) && (0, $cEKee.initUI) === 'embedded') {
            document?.querySelector('.selectOnlyDate__container .infoStaff')?.style.setProperty('display', 'none');
            document?.querySelector('.selectOnlyDate__container .selectOnlyTime__title')?.style.setProperty('padding-top', '1rem');
        }
        (0, $2XKfp.toggleLoading)(true);
        await (0, $1BEhs.loadOnlyTimeCarousel)();
        (0, $e4miY.selectOnlyTimeListeners)();
        const foundStaff = (0, $cEKee.form)?.staff?.find((staff)=>staff.id === +(0, $cEKee.staffId) || (0, $cEKee.providerId));
        const foundProcedure = (0, $cEKee.procedures).find((p)=>p?.id === +(0, $cEKee.procedureIdSelected));
        (0, $hltT2.renderStaffInfoHeader)(foundStaff, foundProcedure, 'selectOnlyDate__container');
        (0, $er9E0.navigate)((0, $cIxq8.SCREEN).SELECT_ONLY_DATE);
        (0, $2XKfp.toggleLoading)(false);
    } else {
        document.querySelector('.selectTime__container .title__content').innerHTML = `${(0, $knjAn.t)('select_time_with')} ${(0, $62LVp.getProviderFullName)()}`;
        (0, $er9E0.navigate)((0, $cIxq8.SCREEN).SELECT_TIME);
    }
}
async function $7598a6baeb03ba77$var$handleScreenProvidersKeyDown(event) {
    if (event.key === 'Enter' && !document.querySelector('.providerContinue__btn').classList.contains('disabled--noneOpacity')) document.querySelector('.providerContinue__btn').click();
}
async function $7598a6baeb03ba77$export$2d2087c1cee2836d(providerId) {
    let selectedProcedures = [];
    try {
        const res = await (0, $3UENa.getProcedureStaffByStaffId)(providerId);
        res.data.data.forEach((procedureStaff)=>{
            if (procedureStaff.procedure) selectedProcedures.push(procedureStaff.procedure);
        });
        selectedProcedures.forEach((proce)=>{
            const addOns = res.data.data.find((item)=>item?.procedure?.id === proce?.id)?.procedure_addons;
            proce.procedure_addons = addOns;
        });
        if ((0, $cEKee.appointmentChannelId) && (0, $cEKee.form)?.appointment_channel?.procedures?.length > 0) {
            const proceduresOfAppointmentChannelIds = (0, $cEKee.form)?.appointment_channel?.procedures?.map((i)=>i.id);
            const proceduresOfAppointmentChannelSelected = selectedProcedures.filter((i)=>proceduresOfAppointmentChannelIds.includes(i.id));
            selectedProcedures = proceduresOfAppointmentChannelSelected;
            if (proceduresOfAppointmentChannelSelected.length === 1) (0, $cEKee.setSelectedProcedures)([
                proceduresOfAppointmentChannelSelected[0].id
            ]);
            else if (proceduresOfAppointmentChannelSelected.length === 0) {
                // A 0-match intersection (staff→procedure mapping doesn't list
                // the channel's services, or a partial API response) must NOT
                // clobber a selection that is already valid for this channel —
                // wiping it here made single-selection bookings submit the
                // whole menu and 422 ("Please select a service to book.").
                const stillValid = ((0, $cEKee.selectedProcedures) || []).filter((id)=>proceduresOfAppointmentChannelIds.includes(+id));
                if (!stillValid.length) (0, $cEKee.setSelectedProcedures)([]);
            }
        }
    } catch (err) {
        (0, $gZEOs.toastError)(err.response?.data?.message || (0, $knjAn.t)('server_error_generic'));
    }
    (0, $cEKee.setProcedures)(selectedProcedures);
    (0, $d0tLC.loadProcedures)(selectedProcedures);
    (0, $8QS3m.loadCategories)(selectedProcedures);
}
async function $7598a6baeb03ba77$export$e52da098a506377b(e = null, selectedProvider = null) {
    let className = e && !e.currentTarget?.classList.contains('provider') ? e.currentTarget.className : 'providerContinue__btn';
    let isLoading = document.querySelector(`.${className}`)?.classList?.contains('disabled--noneOpacity');
    if (isLoading && !(0, $cEKee.appointmentChannelId)) return;
    const hostType = $7598a6baeb03ba77$var$getHostType();
    const staffsOfAppointmentChannel = (0, $cEKee.form)?.appointment_channel?.staffs?.filter((staff)=>staff?.online_booking);
    const staffCount = staffsOfAppointmentChannel?.length || 0;
    const canChooseStaff = $7598a6baeb03ba77$var$canUserChooseStaff(hostType, staffCount);
    const isProviderFirst = (0, $cEKee.form)?.appointment_channel?.is_select_provider_first;
    let providerIdCurrent = (0, $cEKee.appointmentChannelId) && canChooseStaff && isProviderFirst ? (0, $cEKee.providerId) ?? parseInt(this.getAttribute('data-provider-id')) : (0, $cEKee.staffId) || selectedProvider || parseInt(this.getAttribute('data-provider-id'));
    !(((0, $cEKee.staffId) || selectedProvider) && !canChooseStaff) && (0, $62LVp.selectProvider)(providerIdCurrent);
    (0, $cEKee.setProviderId)(providerIdCurrent);
    if ((0, $cEKee.appointmentChannelId) && (canChooseStaff || !isProviderFirst)) {
        if (typeof this?.getAttribute === 'function') {
            const id = parseInt(this.getAttribute('data-provider-id'));
            if (id !== providerIdCurrent) {
                providerIdCurrent = id;
                (0, $cEKee.setProviderId)(id);
                (0, $62LVp.selectProvider)(id);
            }
        }
        (0, $cEKee.setSelectedStaffAppointmentChannel)(providerIdCurrent);
    }
    let loaderIcon = null;
    document.querySelector(`.${className}`)?.classList.add('disabled--noneOpacity');
    document.querySelector(`.${className} .loading__wrapper`)?.classList.remove('hidden');
    loaderIcon = document.querySelector(`.${className} .loader__icon`);
    if (loaderIcon) {
        loaderIcon.innerHTML = '';
        loaderIcon.insertAdjacentHTML('beforeend', `<img src="${(0, $cEKee.appUrl)}/assets/icons/rolling.png" />`);
        document.querySelector('.providerBack__btn').classList.add('disabled');
    }
    const isConsultationRequest = (0, $cEKee.form).appointment_request_type === (0, $cIxq8.APPOINTMENT_REQUEST_FORM);
    const isCategoryEnabled = (0, $cEKee.form)?.appointment_channel?.enable_category_selection;
    if (isConsultationRequest && isCategoryEnabled) {
        if ((0, $cEKee.tempLeadInfo) && !(0, $cEKee.leadInfo)) {
            const res = await (0, $2q2gk.createLead)({
                ...(0, $cEKee.tempLeadInfo),
                ...providerIdCurrent && {
                    provider_id: providerIdCurrent
                }
            });
            (0, $cEKee.setLeadTextId)(res.data.text_id);
            (0, $cEKee.setLeadInfo)(res.data);
            (0, $cEKee.setTempLeadInfo)(null);
        }
        (0, $cgStI.handelConsultSummaryBtn)();
    } else if (0, $cEKee.isInInstantQuote) {
        await $7598a6baeb03ba77$export$2d2087c1cee2836d(providerIdCurrent);
        const foundProcedure = (0, $cEKee.procedures)?.find((i)=>i?.id === +(0, $cEKee.procedureIdSelected));
        if ((0, $cEKee.procedureIdSelected) && foundProcedure) {
            let proceduresArr = [
                ...(0, $cEKee.selectedProcedures),
                foundProcedure.id
            ];
            (0, $cEKee.setSelectedProcedures)(proceduresArr);
            if (0, $cEKee.skipInterestPage) {
                (0, $er9E0.navigate)((0, $cIxq8.SCREEN).FULL_NAME);
                setTimeout(()=>{
                    const fullNameInput = document.getElementById('fullName');
                    if (fullNameInput !== document.activeElement) fullNameInput.focus();
                }, 500);
            } else (0, $er9E0.navigate)((0, $cIxq8.SCREEN).INTERESTS);
        } else {
            (0, $8QS3m.loadCategories)($7598a6baeb03ba77$export$bf5875e000e62d6d((0, $cEKee.procedures)));
            (0, $d0tLC.loadProcedures)($7598a6baeb03ba77$export$bf5875e000e62d6d((0, $cEKee.procedures)));
            // skip Continue screen when send staff_id in params
            (0, $cEKee.staffId) && (0, $er9E0.navigate)((0, $cIxq8.SCREEN).SEE_ALL_SERVICES);
        }
    } else if ((0, $cEKee.isBookAppointment) || (0, $cEKee.appointmentChannelId)) {
        if ((0, $cEKee.staffId) && !canChooseStaff) (0, $cEKee.setProviderId)(+(0, $cEKee.staffId));
        if ((0, $cEKee.appointmentChannelId) && canChooseStaff) {
            if (typeof this?.getAttribute === 'function') {
                const id = parseInt(this.getAttribute('data-provider-id'));
                if (id !== providerIdCurrent) {
                    providerIdCurrent = id;
                    (0, $cEKee.setProviderId)(id);
                    (0, $62LVp.selectProvider)(id);
                }
            }
        }
        if (!isProviderFirst) {
            if (typeof this?.getAttribute === 'function') {
                const id = parseInt(this.getAttribute('data-provider-id'));
                providerIdCurrent = id;
                (0, $cEKee.setProviderId)(id);
                (0, $62LVp.selectProvider)(id);
            }
        }
        if ((0, $cEKee.appointmentChannelId) && isProviderFirst && providerIdCurrent !== -1) await $7598a6baeb03ba77$export$2d2087c1cee2836d(providerIdCurrent);
        if (canChooseStaff && (0, $cEKee.form)?.appointment_channel?.procedures?.length > 1 && (0, $cEKee.appointmentChannelId)) {
            document.querySelector(`.${className}`)?.classList.remove('disabled--noneOpacity');
            if (loaderIcon) {
                loaderIcon.innerHTML = '';
                loaderIcon.insertAdjacentHTML('beforeend', `<i class="ri-arrow-right-line"></i>`);
                document.querySelector('.providerBack__btn').classList.remove('disabled');
            }
            document.querySelector(`.${className} .loading__wrapper`)?.classList.add('hidden');
            (0, $1kc6e.goToServices)();
            return;
        }
        if (0, $cEKee.appointmentChannelId) {
            await $7598a6baeb03ba77$export$271d94f9a1110068();
            // Remove loading state (same as end of function)
            document.querySelector(`.${className}`)?.classList.remove('disabled--noneOpacity');
            if (loaderIcon) {
                loaderIcon.innerHTML = '';
                loaderIcon.insertAdjacentHTML('beforeend', `<i class="ri-arrow-right-line"></i>`);
                document.querySelector('.providerBack__btn').classList.remove('disabled');
            }
            document.querySelector(`.${className} .loading__wrapper`)?.classList.add('hidden');
            return;
        }
        (0, $cEKee.setCurrentDateInUse)(moment().unix());
        await (0, $1BEhs.loadTimeCarousel)();
        (0, $e4miY.selectTimeListeners)();
    }
    document.querySelector(`.${className}`)?.classList.remove('disabled--noneOpacity');
    if (loaderIcon) {
        loaderIcon.innerHTML = '';
        loaderIcon.insertAdjacentHTML('beforeend', `<i class="ri-arrow-right-line"></i>`);
        document.querySelector('.providerBack__btn').classList.remove('disabled');
    }
    document.querySelector(`.${className} .loading__wrapper`)?.classList.add('hidden');
}
function $7598a6baeb03ba77$export$bf5875e000e62d6d(proce) {
    let currentProcedures = proce;
    if ((0, $cEKee.showBodyAreaSelection) && (0, $cEKee.bodyAreaSelected)?.length > 0) currentProcedures = proce?.filter((item)=>$7598a6baeb03ba77$var$checkCategoryOfProcedure(item.service_categories.map((category)=>category.name)));
    if (!(0, $cEKee.selectedGender)) return currentProcedures.filter((procedure)=>{
        return procedure.online_booking;
    });
    let newProcedures = currentProcedures.filter((procedure)=>{
        return (procedure.gender === (0, $cEKee.selectedGender) || procedure.gender === 'both') && procedure.online_booking;
    });
    return newProcedures;
}
const $7598a6baeb03ba77$var$checkCategoryOfProcedure = (categories)=>{
    const listCategory = (0, $cEKee.bodyAreaSelected)?.map((item)=>item.name);
    return listCategory.some((item)=>categories.includes(item));
};

});
parcelRegister("hltT2", function(module, exports) {

$parcel$export(module.exports, "renderStaffInfoHeader", () => $ca0b94bb55176be6$export$59040d21ee84d3a9);

var $knjAn = parcelRequire("knjAn");

var $cEKee = parcelRequire("cEKee");
parcelRequire("er9E0");

var $cIxq8 = parcelRequire("cIxq8");

var $k3ko8 = parcelRequire("k3ko8");

var $eq8l3 = parcelRequire("eq8l3");

var $fWpof = parcelRequire("fWpof");
const $ca0b94bb55176be6$var$DAY_ORDER = [
    'monday',
    'tuesday',
    'wednesday',
    'thursday',
    'friday',
    'saturday',
    'sunday'
];
const $ca0b94bb55176be6$var$DAY_KEYS = {
    monday: 'day_mon',
    tuesday: 'day_tue',
    wednesday: 'day_wed',
    thursday: 'day_thu',
    friday: 'day_fri',
    saturday: 'day_sat',
    sunday: 'day_sun'
};
function $ca0b94bb55176be6$var$esc(value) {
    if (value === null || value === undefined) return '';
    return String(value).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}
function $ca0b94bb55176be6$var$formatMinutes(mins) {
    const total = Math.max(0, Math.round(Number(mins) || 0));
    if (!total) return '';
    const hours = Math.floor(total / 60);
    const minutes = total % 60;
    if (hours && minutes) return `${hours}h ${minutes}min`;
    if (hours) return `${hours}h`;
    return `${minutes} min`;
}
function $ca0b94bb55176be6$var$formatClock(value) {
    // Hours come from config as "HH:mm" strings.
    const parsed = moment(value, 'HH:mm', true);
    return parsed.isValid() ? parsed.format('h:mm A') : String(value ?? '');
}
function $ca0b94bb55176be6$var$timezoneAbbreviation(timezone) {
    if (!timezone) return '';
    try {
        const parts = new Intl.DateTimeFormat('en-US', {
            timeZone: timezone,
            timeZoneName: 'short'
        }).formatToParts(new Date());
        const abbr = parts.find((p)=>p.type === 'timeZoneName')?.value || '';
        const localParts = new Intl.DateTimeFormat('en-US', {
            timeZoneName: 'short'
        }).formatToParts(new Date());
        const localAbbr = localParts.find((p)=>p.type === 'timeZoneName')?.value || '';
        // Only worth showing when the practice is in a different zone than the visitor.
        return abbr && abbr !== localAbbr ? abbr : '';
    } catch (error) {
        return '';
    }
}
/**
 * Collapse an hours map into human lines, merging consecutive days that share
 * the same ranges: { monday..friday 09:00-17:00 } -> "Mon – Fri  9:00 AM – 5:00 PM".
 */ function $ca0b94bb55176be6$var$buildHoursLines(hours) {
    if (!hours || typeof hours !== 'object') return [];
    const groups = [];
    for (const day of $ca0b94bb55176be6$var$DAY_ORDER){
        const ranges = (Array.isArray(hours[day]) ? hours[day] : []).filter((r)=>r?.from && r?.to);
        const key = ranges.map((r)=>`${r.from}-${r.to}`).join(',');
        const last = groups[groups.length - 1];
        if (last && last.key === key) last.days.push(day);
        else groups.push({
            key: key,
            days: [
                day
            ],
            ranges: ranges
        });
    }
    return groups.filter((group)=>group.ranges.length).map((group)=>{
        const first = (0, $knjAn.t)($ca0b94bb55176be6$var$DAY_KEYS[group.days[0]]);
        const last = (0, $knjAn.t)($ca0b94bb55176be6$var$DAY_KEYS[group.days[group.days.length - 1]]);
        return {
            days: group.days.length > 1 ? `${first} \u{2013} ${last}` : first,
            times: group.ranges.map((r)=>`${$ca0b94bb55176be6$var$formatClock(r.from)} \u{2013} ${$ca0b94bb55176be6$var$formatClock(r.to)}`).join(', ')
        };
    });
}
function $ca0b94bb55176be6$var$formatLocationPhone(phoneNumber, country) {
    if (!phoneNumber) return '';
    try {
        const parsed = (0, $k3ko8.parsePhoneNumberFromString)(phoneNumber, country || 'US');
        if (parsed && parsed.isValid()) return parsed.formatNational();
        return (0, $eq8l3.formatPhoneNumber)(phoneNumber, country || 'US');
    } catch (error) {
        return phoneNumber;
    }
}
function $ca0b94bb55176be6$var$telHref(phoneNumber, country) {
    if (!phoneNumber) return '';
    try {
        const parsed = (0, $k3ko8.parsePhoneNumberFromString)(phoneNumber, country || 'US');
        if (parsed && parsed.isValid()) return parsed.getURI();
    } catch (error) {}
    const digits = String(phoneNumber).replace(/[^\d+]/g, '');
    return digits ? `tel:${digits}` : '';
}
function $ca0b94bb55176be6$var$directionsUrl(location) {
    if (!location) return '';
    if (location.google_profile_url) return location.google_profile_url;
    const destination = location.lat && location.long ? `${location.lat},${location.long}` : [
        location.address1,
        location.address2,
        location.city,
        location.state,
        location.postal_code
    ].filter(Boolean).join(', ');
    if (!destination) return '';
    return `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(destination)}`;
}
function $ca0b94bb55176be6$var$addressLines(location) {
    if (!location) return [];
    const street = [
        location.address1,
        location.address2
    ].filter(Boolean).join(', ');
    const cityLine = [
        [
            location.city,
            location.state
        ].filter(Boolean).join(', '),
        location.postal_code
    ].filter(Boolean).join(' ');
    const lines = [
        street,
        cityLine
    ].filter(Boolean);
    if (lines.length) return lines;
    return location.full_address ? [
        location.full_address
    ] : [];
}
function $ca0b94bb55176be6$var$staffFullName(staff) {
    return [
        staff?.first_name,
        staff?.last_name
    ].filter(Boolean).join(' ').trim();
}
function $ca0b94bb55176be6$var$canUserChooseStaff(hostType, staffCount) {
    switch(hostType){
        case 0, $cIxq8.HOST_TYPE_ONE_ON_ONE:
            return staffCount > 1;
        case 0, $cIxq8.HOST_TYPE_ROUND_ROBIN:
        case 0, $cIxq8.HOST_TYPE_COLLECTIVE:
            return false;
        default:
            return (0, $cEKee.form)?.appointment_channel?.visitor_can_choose_the_staff;
    }
}
function $ca0b94bb55176be6$var$getHostType() {
    return (0, $cEKee.form)?.appointment_channel?.host || (0, $cIxq8.HOST_TYPE_ONE_ON_ONE);
}
const $ca0b94bb55176be6$var$DIVIDER = `<div class="divider"><hr /></div>`;
function $ca0b94bb55176be6$var$row(icon, title, valueHtml, { extra: extra = false, className: className = '' } = {}) {
    if (!valueHtml) return '';
    return `
        <div class="staffInfo__description ${extra ? 'staffInfo__extra' : ''} ${className}">
            <span class="staffInfo__description-icon"><i data-feather="${icon}"></i></span>
            <div class="staffInfo__description-left">
                <span class="staffInfo__description-title">${title}</span>
                ${valueHtml}
            </div>
        </div>
    `;
}
function $ca0b94bb55176be6$export$59040d21ee84d3a9(staff, procedure, container, isAppend = false) {
    const staffsOfAppointmentChannel = (0, $cEKee.form)?.appointment_channel?.staffs?.filter((staff)=>staff?.online_booking);
    const foundStaff = staff ?? (0, $cEKee.form)?.staff?.find((staff)=>staff.id === +(0, $cEKee.staffId));
    /**
     * The service this panel describes. Callers resolve it out of the
     * project-level `procedures` list only (providersListeners/selectTime
     * listeners both do `procedures.find(...)`), and that list does NOT hold a
     * channel's own services — so on a scheduling link the visitor's pick
     * arrived here as undefined and the panel kept reading "18 services
     * available" with no duration all the way to the date/time screens.
     * Resolve it from the same selection state the services screen writes,
     * looked up across both procedure sources. Read-only: no flow state is
     * touched, and with several services still selected nothing is claimed.
     */ const procedurePool = [
        ...(0, $cEKee.proceduresOfAppointmentChannel) || [],
        ...(0, $cEKee.procedures) || [],
        ...(0, $cEKee.originProcedures) || []
    ].filter(Boolean);
    const pickedProcedureId = +(0, $cEKee.procedureIdSelected) || ((0, $cEKee.selectedProcedures)?.length === 1 ? +(0, $cEKee.selectedProcedures)[0] : 0);
    const foundProcedure = procedure ?? (pickedProcedureId ? procedurePool.find((p)=>p?.id === pickedProcedureId) : null) ?? null;
    const infoStaffContainer = document.querySelector(`${container ? '.' + container : ''} .infoStaff`);
    const isMultipleStaff = staffsOfAppointmentChannel?.length > 1;
    const { duration: duration, location: location } = (0, $cEKee.form).appointment_channel;
    const selectedLocation = (0, $cEKee.locationId) ? (0, $cEKee.locations)?.find((l)=>l?.id === +(0, $cEKee.locationId)) : null;
    const currentLocation = location ? location : selectedLocation ? selectedLocation : (0, $cEKee.locations)?.length === 1 ? (0, $cEKee.locations)[0] : null;
    const descriptionAppointmentChannel = (0, $cEKee.form)?.appointment_channel?.description ?? '';
    const appointment_channel_name = (0, $cEKee.form)?.appointment_channel?.appointment_channel_name ?? '';
    const businessName = (0, $cEKee.form)?.project?.business_name ?? '';
    const businessPhoto = (0, $cEKee.form)?.project?.business_photo ?? '';
    const hostType = $ca0b94bb55176be6$var$getHostType();
    const staffCount = staffsOfAppointmentChannel?.length || 0;
    const canChooseStaff = $ca0b94bb55176be6$var$canUserChooseStaff(hostType, staffCount);
    let providerSelected = null;
    if ((0, $cEKee.appointmentChannelId) && canChooseStaff) providerSelected = staffsOfAppointmentChannel?.find((staff)=>staff?.id == (0, $cEKee.selectedStaffAppointmentChannel));
    // The one provider this panel represents: the explicitly selected one, the
    // staff carried in from the flow, or the channel's only bookable provider.
    const singleStaff = providerSelected ?? ((0, $cEKee.appointmentChannelId) ? staffCount === 1 ? staffsOfAppointmentChannel[0] : null : foundStaff);
    const MAX_STAFF_DISPLAY = 4;
    // Providers this panel represents: the one the visitor picked, otherwise all
    // bookable ones on the channel.
    const listedStaffs = ((0, $cEKee.appointmentChannelId) ? canChooseStaff && providerSelected ? [
        providerSelected
    ] : staffsOfAppointmentChannel : [
        foundStaff
    ])?.filter(Boolean) || [];
    /**
     * Initials, so a provider without a photo doesn't borrow the practice logo.
     * Four copies of a wide wordmark cropped into overlapping circles reads as
     * a rendering bug, which is exactly what multi-provider channels showed.
     */ const initialsOf = (i)=>{
        const parts = $ca0b94bb55176be6$var$staffFullName(i).split(/\s+/).filter(Boolean);
        if (!parts.length) return '';
        return (parts[0][0] + (parts.length > 1 ? parts[parts.length - 1][0] : '')).toUpperCase();
    };
    const renderListStaff = ()=>{
        if (!listedStaffs.length) return ``;
        const displayStaffs = listedStaffs.slice(0, MAX_STAFF_DISPLAY);
        const remainingCount = listedStaffs.length - MAX_STAFF_DISPLAY;
        let iconStaffs = ``;
        for (const i of displayStaffs){
            const initials = initialsOf(i);
            const face = i?.photo ? `<img src="${encodeURI(i.photo)}" alt="">` : initials ? `<span class="staff-item__initials">${$ca0b94bb55176be6$var$esc(initials)}</span>` : `<img src="${0, $cEKee.appUrl}/assets/images/png/default-avatar.png" alt="">`;
            iconStaffs = iconStaffs.concat(`
                <div class="staff-item">
                    <div class="img">
                    ${face}
                    </div>
                    <span class="name">${$ca0b94bb55176be6$var$esc($ca0b94bb55176be6$var$staffFullName(i))}</span>
                </div>
            `);
        }
        if (remainingCount > 0) iconStaffs = iconStaffs.concat(`
                <div class="staff-item staff-item-more">
                    <div class="img">
                        <span class="staff-more-count">+${remainingCount}</span>
                    </div>
                </div>
            `);
        return iconStaffs;
    };
    /**
     * Identity image: the photo of the provider this appointment is actually
     * with, otherwise the practice logo. With several bookable providers and
     * none chosen yet there is no such provider, so we must NOT borrow the
     * first one's face — that presents an arbitrary provider as the one the
     * visitor is booking. The generic silhouette is the last resort only.
     */ const renderIdentityImage = ()=>{
        const photo = singleStaff?.photo || ((0, $cEKee.appointmentChannelId) ? '' : foundStaff?.photo);
        if (photo) return `<div class="img"><img src="${encodeURI(photo)}" alt="avatar"></div>`;
        if (businessPhoto) return `<div class="img img--logo"><img src="${encodeURI(businessPhoto)}" alt="${$ca0b94bb55176be6$var$esc(businessName)}"></div>`;
        return `<div class="img"><img src="${0, $cEKee.appUrl}/assets/images/png/default-avatar.png" alt="avatar"></div>`;
    };
    const renderStaffInfo = ()=>{
        const heading = appointment_channel_name || businessName;
        // Channel names often already carry the practice name ("Acme — Book an Appointment"),
        // so only add the practice line when it isn't already in the heading.
        const subtitle = businessName && !heading.toLowerCase().includes(businessName.toLowerCase()) ? businessName : '';
        return `
            ${renderIdentityImage()}
            <div class="staffInfo__identity">
                <h3>${$ca0b94bb55176be6$var$esc(heading)}</h3>
                ${subtitle ? `<span class="staffInfo__practice">${$ca0b94bb55176be6$var$esc(subtitle)}</span>` : ''}
            </div>
        `;
    };
    const channelProcedures = ((0, $cEKee.appointmentChannelId) ? (0, $cEKee.proceduresOfAppointmentChannel) : [
        foundProcedure
    ]) || [];
    const procedureList = channelProcedures.filter(Boolean);
    const selectedProcedure = foundProcedure ?? (procedureList.length === 1 ? procedureList[0] : null);
    const renderProviderRow = ()=>{
        // One provider (or one chosen out of many): just name them.
        if (!isMultipleStaff || providerSelected) {
            const name = $ca0b94bb55176be6$var$staffFullName(singleStaff);
            if (!name) return '';
            return $ca0b94bb55176be6$var$row('user', (0, $knjAn.t)('provider'), `<span class="staffInfo__description-name">${$ca0b94bb55176be6$var$esc(name)}</span>`);
        }
        // Several bookable providers: avatars plus their names in writing, since
        // the avatar tooltip only exists on hover (and never on touch).
        const names = listedStaffs.map($ca0b94bb55176be6$var$staffFullName).filter(Boolean);
        if (!names.length) return '';
        const shown = names.slice(0, MAX_STAFF_DISPLAY).map($ca0b94bb55176be6$var$esc).join(', ');
        const remaining = names.length - MAX_STAFF_DISPLAY;
        const value = `
            <div class="list-staff">${renderListStaff()}</div>
            <span class="staffInfo__providers-names">${shown}${remaining > 0 ? ` +${remaining} ${(0, $knjAn.t)('more')}` : ''}</span>
        `;
        return $ca0b94bb55176be6$var$row('users', (0, $knjAn.t)('providers'), value, {
            className: 'staffInfo__providers'
        });
    };
    /**
     * Duration is only shown once it is actually DECIDED: a channel-level fixed
     * duration, or the one service on the channel, or the service the visitor
     * picked. When several services are still on the table, any number here —
     * including a "30–60 min" range — is a guess the booking won't honour, so
     * the row is omitted and appears later in the flow once a service is chosen.
     */ const renderDurationRow = ()=>{
        const minutes = duration > 0 ? duration : selectedProcedure?.duration || 0;
        if (!(minutes > 0)) return '';
        const text = $ca0b94bb55176be6$var$formatMinutes(minutes);
        if (!text) return '';
        return $ca0b94bb55176be6$var$row('clock', (0, $knjAn.t)('duration_label'), `<span class="staffInfo__description-name">${$ca0b94bb55176be6$var$esc(text)}</span>`);
    };
    const renderTypeRow = ()=>{
        if (!procedureList.length) return `<div class="staffInfo__description"><div class="staffInfo__description-left">${(0, $knjAn.t)('no_services')}</div></div>`;
        const text = selectedProcedure?.name ? selectedProcedure.name : `${procedureList.length} ${(0, $knjAn.t)('services_available')}`;
        return $ca0b94bb55176be6$var$row('activity', (0, $knjAn.t)('appointment_type'), `<span class="staffInfo__description-name">${$ca0b94bb55176be6$var$esc(text)}</span>`);
    };
    const renderLocationRow = ()=>{
        if (!currentLocation) return '';
        const remoteProcs = procedureList.length ? procedureList : (0, $cEKee.form)?.appointment_channel?.procedures ?? [];
        const hasVirtualVisit = (0, $fWpof.isVirtualVisit)((0, $cEKee.form), remoteProcs);
        if (hasVirtualVisit) {
            const icon = (0, $fWpof.isPhoneBooking)(remoteProcs) ? 'phone' : 'video';
            return $ca0b94bb55176be6$var$row(icon, (0, $knjAn.t)('location'), `<span class="staffInfo__description-name">${(0, $knjAn.t)((0, $fWpof.remoteVisitLabelKey)(remoteProcs))}</span>`);
        }
        const name = currentLocation?.name || '';
        const lines = $ca0b94bb55176be6$var$addressLines(currentLocation);
        const directions = $ca0b94bb55176be6$var$directionsUrl(currentLocation);
        const primary = name || lines.shift() || '';
        if (!primary) return '';
        return $ca0b94bb55176be6$var$row('map-pin', (0, $knjAn.t)('location'), `
            <span class="staffInfo__description-name">${$ca0b94bb55176be6$var$esc(primary)}</span>
            ${lines.length ? `<span class="staffInfo__address staffInfo__extra">${lines.map($ca0b94bb55176be6$var$esc).join('<br />')}</span>` : ''}
            ${directions ? `<a class="staffInfo__link staffInfo__extra" href="${$ca0b94bb55176be6$var$esc(directions)}" target="_blank" rel="noopener noreferrer">${(0, $knjAn.t)('get_directions')}</a>` : ''}
        `);
    };
    const renderPhoneRow = ()=>{
        const remoteProcs = procedureList.length ? procedureList : (0, $cEKee.form)?.appointment_channel?.procedures ?? [];
        if ((0, $fWpof.isVirtualVisit)((0, $cEKee.form), remoteProcs)) return '';
        const phone = currentLocation?.phone || (0, $cEKee.form)?.project?.business_phone || '';
        if (!phone) return '';
        const country = currentLocation?.country || 'US';
        const formatted = $ca0b94bb55176be6$var$formatLocationPhone(phone, country) || phone;
        const href = $ca0b94bb55176be6$var$telHref(phone, country);
        const value = href ? `<a class="staffInfo__description-name staffInfo__link" href="${$ca0b94bb55176be6$var$esc(href)}">${$ca0b94bb55176be6$var$esc(formatted)}</a>` : `<span class="staffInfo__description-name">${$ca0b94bb55176be6$var$esc(formatted)}</span>`;
        return $ca0b94bb55176be6$var$row('phone', (0, $knjAn.t)('phone_label'), value, {
            extra: true
        });
    };
    const renderHoursRow = ()=>{
        const availabilities = (0, $cEKee.form)?.appointment_channel?.location_availabilities || [];
        const matched = currentLocation ? availabilities.find((a)=>a?.location_id === currentLocation.id) : null;
        const hours = matched?.availability?.hours || (0, $cEKee.form)?.appointment_channel?.availability_hours || currentLocation?.hours;
        const timezone = matched?.availability?.timezone || (0, $cEKee.form)?.appointment_channel?.availability_timezone || currentLocation?.timezone;
        const lines = $ca0b94bb55176be6$var$buildHoursLines(hours);
        if (!lines.length) return '';
        const abbr = $ca0b94bb55176be6$var$timezoneAbbreviation(timezone);
        const title = abbr ? `${(0, $knjAn.t)('office_hours')} (${$ca0b94bb55176be6$var$esc(abbr)})` : (0, $knjAn.t)('office_hours');
        return $ca0b94bb55176be6$var$row('calendar', title, `
            <span class="staffInfo__hours">
                ${lines.map((line)=>`
                    <span class="staffInfo__hours-line">
                        <span class="staffInfo__hours-days">${$ca0b94bb55176be6$var$esc(line.days)}</span>
                        <span class="staffInfo__hours-times">${$ca0b94bb55176be6$var$esc(line.times)}</span>
                    </span>
                `).join('')}
            </span>
        `, {
            extra: true
        });
    };
    const renderDescriptionInfo = ()=>{
        if (!descriptionAppointmentChannel) return '';
        return $ca0b94bb55176be6$var$row('file-text', (0, $knjAn.t)('description'), `<span class="staffInfo__description-name">${$ca0b94bb55176be6$var$esc(descriptionAppointmentChannel)}</span>`, {
            extra: true
        });
    };
    if (infoStaffContainer) {
        const rows = [
            renderProviderRow(),
            renderDurationRow(),
            renderTypeRow(),
            renderLocationRow(),
            renderPhoneRow(),
            renderHoursRow(),
            renderDescriptionInfo()
        ].filter(Boolean);
        const infoStaffHeaderHTML = `
            <div class="staffInfo__wrapper">
                ${renderStaffInfo()}
                ${rows.length ? `<div class="staffInfo__rows">${rows.join($ca0b94bb55176be6$var$DIVIDER)}</div>` : ''}
            </div>
        `;
        if (isAppend) {
            infoStaffContainer.innerHTML = '';
            infoStaffContainer.insertAdjacentHTML('afterbegin', `${infoStaffHeaderHTML}`);
        } else infoStaffContainer.innerHTML = infoStaffHeaderHTML;
    }
    feather.replace();
}

});

parcelRegister("1kc6e", function(module, exports) {

$parcel$export(module.exports, "validateDigitsListeners", () => $0f710b6912540e15$export$a61bd95ef2ddae90);
$parcel$export(module.exports, "goToServices", () => $0f710b6912540e15$export$3525a34679af5919);

var $knjAn = parcelRequire("knjAn");

var $cIxq8 = parcelRequire("cIxq8");

var $fWpof = parcelRequire("fWpof");

var $er9E0 = parcelRequire("er9E0");

var $cEKee = parcelRequire("cEKee");

var $fJKn4 = parcelRequire("fJKn4");

var $jmDLz = parcelRequire("jmDLz");

var $k3ko8 = parcelRequire("k3ko8");

var $577MR = parcelRequire("577MR");

var $d0tLC = parcelRequire("d0tLC");

var $8QS3m = parcelRequire("8QS3m");

var $bsb2b = parcelRequire("bsb2b");

var $hSkqV = parcelRequire("hSkqV");

var $gZEOs = parcelRequire("gZEOs");

var $1BEhs = parcelRequire("1BEhs");
parcelRequire("alq6e");

var $99TAZ = parcelRequire("99TAZ");

var $9h4tQ = parcelRequire("9h4tQ");

var $5YZvF = parcelRequire("5YZvF");

var $9CQsA = parcelRequire("9CQsA");

var $2q2gk = parcelRequire("2q2gk");

var $cgStI = parcelRequire("cgStI");
function $0f710b6912540e15$export$a61bd95ef2ddae90() {
    const allowedKeys = [
        "Backspace",
        "Enter",
        "Tab",
        "ArrowLeft",
        "ArrowRight"
    ];
    /* On click enter */ const screenPhone = document.querySelector('.screen--validateDigits');
    if (screenPhone) screenPhone.addEventListener('keydown', (event)=>{
        if (event.key === 'Enter' && !document.querySelector('.validateDigitsContinue__btn').classList.contains('disabled')) document.querySelector('.validateDigitsContinue__btn').click();
    });
    /* OTP input fields */ const validateDigitsDoms = [
        document.getElementById('validateDigits0'),
        document.getElementById('validateDigits1'),
        document.getElementById('validateDigits2'),
        document.getElementById('validateDigits3')
    ];
    const resendOTPBtnDom = document.querySelector('.validateDigits--resend-otp');
    /* on click Continue after input phone number*/ document.querySelector('.validateDigitsContinue__btn').addEventListener('click', async ()=>{
        const loaderIcon = document.querySelector('.validateDigitsContinue__btn .loader__icon');
        try {
            document.querySelector('.validateDigitsContinue__btn')?.classList.add('disabled');
            document.querySelector('.validateDigitsContinue__btn .loading__wrapper')?.classList.remove('hidden');
            if (loaderIcon) {
                loaderIcon.innerHTML = '';
                loaderIcon.insertAdjacentHTML('beforeend', `<img src="${(0, $cEKee.appUrl)}/assets/icons/rolling.png" />`);
            }
            if ((0, $cEKee.locations).length > 1 && !(0, $cEKee.isBookAppointment)) (0, $er9E0.navigate)((0, $cIxq8.SCREEN).LOCATIONS);
            else if ((0, $cEKee.locations).length <= 0 && !(0, $cEKee.isBookAppointment)) {
                (0, $er9E0.navigate)((0, $cIxq8.SCREEN).LOCATIONS);
                document.querySelector('.locations__container .title__wrapper--instant .title__content').textContent = (0, $knjAn.t)('no_location_found');
            } else {
                let otpCode = '';
                validateDigitsDoms.forEach((element)=>{
                    otpCode += element.value;
                });
                const tempLeadInfo = await (0, $jmDLz.loginPortal)((0, $k3ko8.parsePhoneNumberFromString)((0, $cEKee.phone), (0, $cEKee.selectedCountry)).number, otpCode, (0, $cEKee.projectId), (0, $cEKee.visitorId));
                (0, $cEKee.setAccessToken)(tempLeadInfo.data.access_token);
                (0, $cEKee.setOtpAccessToken)(tempLeadInfo.data.access_token);
                /**
                     * Appointment booking flow after OTP verification.
                     */ if (0, $cEKee.appointmentChannelId) {
                    const collectPatientInfoFirst = (0, $cEKee.form)?.appointment_channel?.collect_patient_information_first_before_scheduling;
                    // "Collect patient info first" flow: patient already entered info before OTP.
                    // Create the lead from the saved form data, then check questionnaire, then calendar.
                    if (collectPatientInfoFirst && (0, $cEKee.tempLeadInfo)) {
                        const res = await (0, $2q2gk.createLead)((0, $cEKee.tempLeadInfo));
                        const lead = res.data;
                        (0, $cEKee.setLeadInfo)(lead);
                        (0, $cEKee.setLeadTextId)(lead.text_id);
                        (0, $cEKee.setTempLeadInfo)(null);
                        if (lead?.id) await (0, $2q2gk.updateLeadStep)(lead.id, 'login', 'true');
                        // Show questionnaire before calendar if setting is enabled
                        const showQuestionnaireBefore = (0, $cEKee.form)?.appointment_channel?.show_questionnaire_before_scheduling;
                        if (showQuestionnaireBefore) {
                            const qualificationFields = Array.isArray((0, $cEKee.form)?.appointment_channel?.qualification_form?.custom_fields) ? (0, $cEKee.form).appointment_channel.qualification_form.custom_fields : [];
                            if (qualificationFields.length > 0 && (0, $99TAZ.shouldShowAllQuestions)()) {
                                (0, $cEKee.setCustomFields)(qualificationFields);
                                (0, $99TAZ.loadAllQuestionsFlow)();
                                return;
                            }
                        }
                        (0, $er9E0.openBookAppointment)();
                        return;
                    }
                    // Normal calendar-first flow: go to Verify Information after OTP.
                    const otpLead = tempLeadInfo?.data?.lead || (0, $cEKee.leadInfo);
                    if (otpLead) {
                        const data = {
                            ...otpLead,
                            phone: (0, $k3ko8.parsePhoneNumberFromString)((0, $cEKee.phone), (0, $cEKee.selectedCountry)).number
                        };
                        (0, $cEKee.setLeadInfo)(data);
                        if (data?.text_id) (0, $cEKee.setLeadTextId)(data.text_id);
                        if (!(0, $cEKee.customFields)?.length) (0, $cEKee.setCustomFields)((0, $cEKee.form)?.appointment_channel?.qualification_form?.custom_fields || []);
                        if (data?.id) await (0, $2q2gk.updateLeadStep)(data.id, 'login', 'true');
                        (0, $er9E0.navigate)((0, $cIxq8.SCREEN).VERIFY_INFORMATION);
                        (0, $bsb2b.verifyInforListeners)(data);
                        return;
                    }
                }
                const { is_phone_otp_enabled: is_phone_otp_enabled } = (0, $cEKee.form) || {};
                const isCategoryEnabled = (0, $cEKee.form)?.appointment_channel?.enable_category_selection;
                if (is_phone_otp_enabled) {
                    (0, $cEKee.setLeadInfo)(tempLeadInfo?.data?.lead);
                    (0, $cEKee.setLeadTextId)(tempLeadInfo?.data?.lead?.text_id);
                    if (isCategoryEnabled && (0, $cEKee.tempLeadInfo)) {
                        const proceduresToShow = (0, $cEKee.appointmentChannelId) ? (0, $cEKee.form)?.appointment_channel?.procedures || (0, $cEKee.procedures) : (0, $cEKee.procedures);
                        if ((0, $cgStI.showCategorySelectionForConsultation)(proceduresToShow)) return;
                        if (proceduresToShow.length > 0) {
                            (0, $cEKee.setProcedures)(proceduresToShow);
                            (0, $8QS3m.loadCategories)(proceduresToShow);
                            (0, $d0tLC.loadProcedures)(proceduresToShow);
                            (0, $er9E0.navigate)((0, $cIxq8.SCREEN).SEE_ALL_SERVICES);
                            return;
                        }
                    }
                    if (0, $cEKee.tempLeadInfo) {
                        const created = await (0, $2q2gk.createLead)((0, $cEKee.tempLeadInfo));
                        // Capture the created lead so downstream steps
                        // (e.g. the standalone DOB step) can patch it.
                        if (created?.data) {
                            (0, $cEKee.setLeadInfo)(created.data);
                            (0, $cEKee.setLeadTextId)(created.data.text_id);
                        }
                        (0, $cEKee.setTempLeadInfo)(null);
                    }
                    (0, $cgStI.handelConsultSummaryBtn)();
                    return;
                }
                const data = tempLeadInfo?.data?.lead;
                if (data) {
                    (0, $cEKee.setLeadInfo)(data);
                    (0, $cEKee.setSelectedLocation)((0, $cEKee.selectedLocation) || (0, $cEKee.locations)[0].id);
                    (0, $cEKee.setLeadTextId)(data.text_id);
                    if ((0, $99TAZ.shouldTriggerAllQuestionsAfterValidation)()) (0, $99TAZ.loadAllQuestionsFlow)();
                    else {
                        (0, $er9E0.navigate)((0, $cIxq8.SCREEN).VERIFY_INFORMATION);
                        (0, $bsb2b.verifyInforListeners)(data);
                    }
                } else {
                    (0, $cEKee.setHasLead)(true);
                    (0, $hSkqV.registerNewPatientInputFieldListeners)();
                    (0, $hSkqV.registerNewPatientContinueBtnListeners)();
                    (0, $er9E0.navigate)((0, $cIxq8.SCREEN).REGISTER_NEW_PATIENT);
                }
                validateDigitsDoms.forEach((element)=>{
                    element.value = '';
                });
                validateDigitsDoms[0].focus();
            }
        } catch (error) {
            validateDigitsDoms.forEach((element)=>{
                element.value = '';
            });
            validateDigitsDoms[0].focus();
            if ((error.response?.data?.message || error) && error.response?.status === 500) {
                (0, $cEKee.setHasLead)(true);
                (0, $cEKee.setAccessToken)((0, $cEKee.form).token);
                if ((0, $99TAZ.shouldTriggerAllQuestionsAfterValidation)()) (0, $99TAZ.loadAllQuestionsFlow)();
                else {
                    (0, $hSkqV.registerNewPatientInputFieldListeners)();
                    (0, $hSkqV.registerNewPatientContinueBtnListeners)();
                    (0, $er9E0.navigate)((0, $cIxq8.SCREEN).REGISTER_NEW_PATIENT);
                }
            } else (0, $gZEOs.toastError)(error.response?.data?.message);
        } finally{
            document.querySelector('.validateDigitsContinue__btn')?.classList.remove('disabled--noneOpacity');
            if (loaderIcon) {
                loaderIcon.innerHTML = '';
                loaderIcon.insertAdjacentHTML('beforeend', `<i class="ri-arrow-right-line"></i>`);
            }
            document.querySelector('.validateDigitsContinue__btn .loading__wrapper')?.classList.add('hidden');
            if (validateDigitsDoms[0].value && validateDigitsDoms[1].value && validateDigitsDoms[2].value && validateDigitsDoms[3].value) document.querySelector('.validateDigitsContinue__btn')?.classList.remove('disabled');
        }
    });
    let pageOTPInputContinueBtn = document.querySelector('.validateDigitsContinue__btn');
    /* OTP input field validation - Only accept number */ validateDigitsDoms.forEach((element, index)=>{
        element.addEventListener('input', (event)=>{
            if (validateDigitsDoms[0].value && validateDigitsDoms[1].value && validateDigitsDoms[2].value && validateDigitsDoms[3].value) pageOTPInputContinueBtn?.classList.remove('disabled');
            else if (!pageOTPInputContinueBtn?.classList.contains('disabled')) pageOTPInputContinueBtn?.classList.add('disabled');
            if (event.data?.length === 1 && validateDigitsDoms[index + 1]) {
                validateDigitsDoms[index + 1].focus();
                return;
            }
            if (element.id === 'validateDigits0' && element.value.length > 1) {
                for(let i = 0; i < validateDigitsDoms.length; i++)if (!validateDigitsDoms[i].value) {
                    validateDigitsDoms[i].value = event.target.value.split('')[event.target.value.length - 1];
                    element.value = event.target.value.split('')[0];
                    break;
                }
                if (validateDigitsDoms[0].value && validateDigitsDoms[1].value && validateDigitsDoms[2].value && validateDigitsDoms[3].value) pageOTPInputContinueBtn?.classList.remove('disabled');
                else if (!pageOTPInputContinueBtn?.classList.contains('disabled')) pageOTPInputContinueBtn?.classList.add('disabled');
                return;
            }
        });
        element.addEventListener('keydown', (event)=>{
            if (event.key === 'Tab') event.stopPropagation();
            if ((isNaN(event.key) || event.key === " ") && !event.ctrlKey && !allowedKeys.includes(event.key)) {
                event.preventDefault();
                return;
            }
            if (event.key === "Backspace") {
                event.preventDefault();
                if (!validateDigitsDoms[index].value && validateDigitsDoms[index - 1]) validateDigitsDoms[index - 1].focus();
                validateDigitsDoms[index].value = "";
                if (!pageOTPInputContinueBtn?.classList.contains('disabled')) pageOTPInputContinueBtn?.classList.add('disabled');
                return;
            } else if (element.id === 'validateDigits3' && event.key === "Tab") event.preventDefault();
        });
        element.addEventListener('beforeinput', (event)=>{
            if (event.data?.length > 1) {
                event.preventDefault();
                let eventDataArr = event.data.split('').filter((value)=>{
                    return !isNaN(value) && value !== " ";
                });
                if (eventDataArr.length > 4) eventDataArr = eventDataArr.slice(0, 4);
                eventDataArr.forEach((val, pos)=>{
                    validateDigitsDoms[pos].value = val;
                    if (validateDigitsDoms[pos + 1]) validateDigitsDoms[pos + 1].focus();
                });
            } else if (element.value && event.data) {
                event.preventDefault();
                element.value = event.data;
                if (validateDigitsDoms[index + 1]) validateDigitsDoms[index + 1].focus();
            }
            if (validateDigitsDoms[0].value && validateDigitsDoms[1].value && validateDigitsDoms[2].value && validateDigitsDoms[3].value) pageOTPInputContinueBtn?.classList.remove('disabled');
            else if (!pageOTPInputContinueBtn?.classList.contains('disabled')) pageOTPInputContinueBtn?.classList.add('disabled');
        });
        element.addEventListener('paste', (event)=>{
            const paste = (event.clipboardData || window.clipboardData).getData('text').replaceAll(' ', '').split("");
            event.preventDefault();
            validateDigitsDoms.forEach((element, index)=>{
                if (paste[index] && !isNaN(paste[index])) element.value = paste[index];
            });
            if (validateDigitsDoms[0].value && validateDigitsDoms[1].value && validateDigitsDoms[2].value && validateDigitsDoms[3].value) {
                pageOTPInputContinueBtn?.classList.remove('disabled');
                validateDigitsDoms[3].focus();
            } else if (!pageOTPInputContinueBtn?.classList.contains('disabled')) pageOTPInputContinueBtn?.classList.add('disabled');
        });
    });
    resendOTPBtnDom.addEventListener('click', async ()=>{
        (0, $577MR.sendOTPCodeWithTimer)();
    });
    const { is_phone_otp_enabled: is_phone_otp_enabled } = (0, $cEKee.form) || {};
    if ((0, $cEKee.isFlowForCalendar) || is_phone_otp_enabled) {
        const editPhoneBtn = document.querySelector('.edit-phone-btn');
        if (editPhoneBtn) {
            editPhoneBtn.style.display = 'inline';
            editPhoneBtn.addEventListener('click', (0, $1BEhs.handleEditPhone));
        }
    }
}
const $0f710b6912540e15$export$3525a34679af5919 = ()=>{
    document.querySelector('.seeServices__container')?.classList.add('procedure-in-booking');
    (0, $cEKee.setIsBookAppointment)(true);
    let filterProcedures = ((0, $cEKee.staffId) ? (0, $cEKee.procedures) : (0, $cEKee.originProcedures)).filter((i)=>{
        if ((0, $cEKee.surgicalOption) === null) return i?.online_booking;
        return !!i?.surgical === (0, $cEKee.surgicalOption) && i?.online_booking;
    });
    if ((0, $cEKee.appointmentChannelId) && (0, $cEKee.form)?.appointment_channel?.procedures?.length > 1) {
        filterProcedures = (0, $cEKee.form)?.appointment_channel?.procedures.filter((i)=>{
            if ((0, $cEKee.surgicalOption) === null) return i?.online_booking;
            return !!i?.surgical === (0, $cEKee.surgicalOption) && i?.online_booking;
        });
        const hostType = (0, $cEKee.form)?.appointment_channel?.host || 'one_on_one';
        const staffsOfAppointmentChannel = (0, $cEKee.form)?.appointment_channel?.staffs?.filter((staff)=>staff?.online_booking);
        const staffCount = staffsOfAppointmentChannel?.length || 0;
        const canChooseStaff = hostType === 'one_on_one' && staffCount > 1 || hostType !== 'one_on_one' && (0, $cEKee.form)?.appointment_channel?.visitor_can_choose_the_staff;
        if (canChooseStaff && (0, $cEKee.providerId) > 0) {
            const proceduresStaffIds = (0, $cEKee.procedures)?.map((i)=>i.id);
            filterProcedures = filterProcedures.filter((f)=>proceduresStaffIds.includes(f.id));
        }
    }
    if (0, $cEKee.patientSelected) filterProcedures = filterProcedures.filter((f)=>{
        if ((0, $cEKee.patientSelected) === 'all') return [
            'returning_patient',
            "new_patient",
            "new_and_returning_patient"
        ].includes(f.type);
        return [
            (0, $cEKee.patientSelected),
            "new_and_returning_patient"
        ].includes(f.type);
    });
    // Filter the service list by the chosen delivery mode when the channel has
    // delivery_mode_selection on. Virtual → fully_virtual services; Phone →
    // phone_consultation services; In-Person → everything else.
    if (0, $cEKee.selectedDeliveryMode) {
        // MODE-LESS inquiry tiles (online_booking_option === 'inquiry' with no
        // service_delivery_mode, e.g. an "Others" option) belong to every
        // delivery mode. An inquiry tile that DOES carry a mode is that mode's
        // service only — it must not leak into the other modes' menus
        // (Executive Plastic 692: the in-person inquiry tile appeared on the
        // Phone menu).
        filterProcedures = filterProcedures.filter((f)=>f?.online_booking_option === 'inquiry' && !f?.service_delivery_mode || (0, $fWpof.procedureDeliveryBucket)(f) === (0, $cEKee.selectedDeliveryMode));
        // The chosen mode has no bookable services at the selected location
        // (e.g. in-person consults pivot-scoped to another location). Don't
        // render an empty menu — or a menu of only inquiry tiles — thank the
        // visitor instead; THE_END's updateStep() files the lead for
        // front-desk follow-up.
        const bookable = (0, $cEKee.scopeProceduresToSelectedLocation)(filterProcedures).filter((f)=>f?.online_booking_option !== 'inquiry');
        if (bookable.length === 0) {
            const notifyText = document.querySelector('.endScreen__container .notify-text');
            if (notifyText) notifyText.textContent = (0, $knjAn.t)('inquiry_fallback_message');
            (0, $er9E0.navigate)((0, $cIxq8.SCREEN).THE_END);
            return;
        }
    }
    (0, $d0tLC.loadProcedures)(filterProcedures);
    (0, $8QS3m.loadCategories)(filterProcedures);
    document.querySelectorAll('.procedure__price-duration')?.forEach((j)=>j.classList.add('procedure__price-duration--show'));
    const enableCategorySelection = (0, $cEKee.form)?.appointment_channel?.enable_category_selection;
    if (enableCategorySelection && filterProcedures.length > 1) {
        const filteredCategories = (0, $cEKee.categories).filter((category)=>(0, $9CQsA.isHasProcedureBelongToCategory)(category, filterProcedures));
        if (filteredCategories.length > 0) {
            (0, $9h4tQ.loadCategoryList)(filteredCategories);
            (0, $5YZvF.categorySelectionListeners)();
            (0, $er9E0.navigate)((0, $cIxq8.SCREEN).CATEGORIES);
            return;
        }
    }
    // Exactly one service survived the filters above (patient type / delivery
    // mode / provider) — don't make the visitor tick a one-item list. Select it
    // and run the same Continue path the button would. We deliberately DON'T
    // navigate to SEE_ALL_SERVICES, so Back from the next screen returns to the
    // previous real question instead of a pointless single-option picker.
    // Skipped for tiles whose click handler does something other than select
    // (inquiry / custom_booking_url) or that need a second choice (add-ons).
    const onlyProcedure = filterProcedures.length === 1 ? filterProcedures[0] : null;
    const hasAddons = onlyProcedure?.procedure_addons?.some((a)=>!a.deleted_at);
    if (onlyProcedure && onlyProcedure.online_booking_option !== 'inquiry' && !onlyProcedure.custom_booking_url && !hasAddons) {
        // navigate(SEE_ALL_SERVICES) normally does these two in showScreen().
        (0, $cEKee.setProcedureSelectionType)((0, $cEKee.form)?.appointment_channel?.selection_type || (0, $cEKee.form).selection_type);
        (0, $fJKn4.removeAllProcedures)();
        (0, $fJKn4.addProcedure)(onlyProcedure.id);
        document.querySelector('.procedureContinue__btn')?.click();
        return;
    }
    (0, $er9E0.navigate)((0, $cIxq8.SCREEN).SEE_ALL_SERVICES);
};

});
parcelRegister("577MR", function(module, exports) {

$parcel$export(module.exports, "OTPTimer", () => $3b93a586207740c6$export$5cff5546720663bd);
$parcel$export(module.exports, "clearOTPTimer", () => $3b93a586207740c6$export$52c3cdc177e0ee17);
$parcel$export(module.exports, "sendOTPCodeWithTimer", () => $3b93a586207740c6$export$8138bec1d081c053);

var $k3ko8 = parcelRequire("k3ko8");

var $jmDLz = parcelRequire("jmDLz");

var $cEKee = parcelRequire("cEKee");
let $3b93a586207740c6$var$otpTimerId = null;
async function $3b93a586207740c6$export$5cff5546720663bd() {
    if ($3b93a586207740c6$var$otpTimerId) {
        clearInterval($3b93a586207740c6$var$otpTimerId);
        $3b93a586207740c6$var$otpTimerId = null;
    }
    document.querySelector('.validateDigits--resend-otp')?.classList.add('validateDigits--resend-otp--disabled');
    let timeleft = 30;
    let blockTimer = document.querySelector('.validateDigits__resend-timer');
    if (!blockTimer) return;
    blockTimer.textContent = `00:${timeleft}`;
    $3b93a586207740c6$var$otpTimerId = setInterval(function() {
        if (timeleft >= 0) {
            blockTimer.textContent = `00:${('0' + timeleft).slice(-2)}`;
            if (timeleft === 0) {
                if (document.querySelector('.validateDigits__resend-timer')) document.querySelector('.validateDigits__resend-timer').style.display = 'none';
                document.querySelector('.validateDigits--resend-otp')?.classList.remove('validateDigits--resend-otp--disabled');
            }
        } else if (timeleft < 0) {
            clearInterval($3b93a586207740c6$var$otpTimerId);
            $3b93a586207740c6$var$otpTimerId = null;
            (0, $cEKee.setIsOTPTimeOut)(true);
        }
        timeleft -= 1;
    }, 1000);
    (0, $cEKee.setIsOTPTimeOut)(false);
    document.querySelector('.validateDigits__resend-timer').style.display = 'block';
}
function $3b93a586207740c6$export$52c3cdc177e0ee17() {
    if ($3b93a586207740c6$var$otpTimerId) {
        clearInterval($3b93a586207740c6$var$otpTimerId);
        $3b93a586207740c6$var$otpTimerId = null;
    }
    const resendTimer = document.querySelector('.validateDigits__resend-timer');
    if (resendTimer) {
        resendTimer.style.display = 'none';
        resendTimer.textContent = '';
    }
    const resendBtn = document.querySelector('.validateDigits--resend-otp');
    if (resendBtn) resendBtn.classList.remove('validateDigits--resend-otp--disabled');
    (0, $cEKee.setIsOTPTimeOut)(true);
}
async function $3b93a586207740c6$export$8138bec1d081c053() {
    $3b93a586207740c6$export$5cff5546720663bd();
    await (0, $jmDLz.sendOTPCode)((0, $k3ko8.parsePhoneNumberFromString)((0, $cEKee.phone), (0, $cEKee.selectedCountry)).number);
}

});

parcelRegister("hSkqV", function(module, exports) {

$parcel$export(module.exports, "registerNewPatientInputFieldListeners", () => $d0375475fd21325e$export$f40e0fe5e9e6c14);
$parcel$export(module.exports, "registerNewPatientContinueBtnListeners", () => $d0375475fd21325e$export$98b22c1d8b23a365);

var $cEKee = parcelRequire("cEKee");

var $5q2KL = parcelRequire("5q2KL");

var $gZEOs = parcelRequire("gZEOs");

var $k3ko8 = parcelRequire("k3ko8");

var $2q2gk = parcelRequire("2q2gk");

var $alq6e = parcelRequire("alq6e");
parcelRequire("1kc6e");
async function $d0375475fd21325e$export$f40e0fe5e9e6c14() {
    document.querySelectorAll('.register-new-patient__input input').forEach((element)=>{
        element.addEventListener('input', $d0375475fd21325e$var$checkContinueBtnState, false);
        element.addEventListener('keydown', $d0375475fd21325e$var$onKeyDownInputRegisterNewPatient, false);
    });
    let datepicker = flatpickr("#dobDatepicker", {
        maxDate: 'today',
        dateFormat: "M d, Y",
        altInput: true,
        altFormat: "F j, Y"
    });
}
async function $d0375475fd21325e$export$98b22c1d8b23a365() {
    let dobContinueBtnDom = document.querySelector('.register-new-patient-continue__btn');
    dobContinueBtnDom.addEventListener('click', $d0375475fd21325e$var$onClickDobContinueBtn, false);
}
async function $d0375475fd21325e$var$onClickDobContinueBtn() {
    let loaderIcon = document.querySelector('.register-new-patient-continue__btn .loader__icon');
    try {
        document.querySelector('.register-new-patient-continue__btn')?.classList.add('disabled');
        document.querySelector('.register-new-patient-continue__btn .loading__wrapper')?.classList.remove('hidden');
        if (loaderIcon) loaderIcon.innerHTML = `<img src="${0, $cEKee.appUrl}/assets/icons/rolling.png" />`;
        let nameInputDoms = document.querySelectorAll('.register-new-patient__input input');
        let dobInputDom = document.getElementById('dobDatepicker');
        let data = {
            first_name: nameInputDoms[0].value,
            last_name: nameInputDoms[1].value,
            date_of_birth: dobInputDom.value,
            phone: (0, $k3ko8.parsePhoneNumberFromString)((0, $cEKee.phone), (0, $cEKee.selectedCountry)).number,
            ...(0, $cEKee.visitorId) && {
                visitor_id: (0, $cEKee.visitorId)
            }
        };
        let res = await (0, $2q2gk.createLead)(data);
        (0, $cEKee.setLeadTextId)(res.data.text_id);
        (0, $cEKee.setLeadInfo)(res.data);
        await (0, $alq6e.appointmentItemsClickEventHandler)((0, $cEKee.selectedAppointmentUnixTime));
    } catch (error) {
        (0, $gZEOs.toastError)(error.response?.data?.message);
    } finally{
        if (loaderIcon) loaderIcon.innerHTML = '<i class="ri-arrow-right-line"></i>';
        document.querySelector('.register-new-patient-continue__btn .loading__wrapper')?.classList.add('hidden');
        document.querySelector('.register-new-patient-continue__btn')?.classList.remove('disabled');
    }
}
function $d0375475fd21325e$var$checkContinueBtnState() {
    let continueBtnDom = document.querySelector('.register-new-patient-continue__btn');
    if ((0, $5q2KL.checkPageRegisterNewPatientsFormData)()) continueBtnDom?.classList.remove('disabled');
    else continueBtnDom?.classList.add('disabled');
}
function $d0375475fd21325e$var$onKeyDownInputRegisterNewPatient(event) {
    if (event.key === 'Tab') event.stopPropagation();
}

});
parcelRegister("5q2KL", function(module, exports) {

$parcel$export(module.exports, "resetPageRegisterNewPatientsFormData", () => $3f21842e7f0d95c0$export$d3d5c1e3a6eab89b);
$parcel$export(module.exports, "checkPageRegisterNewPatientsFormData", () => $3f21842e7f0d95c0$export$3f4bdc4b0f7095c3);
function $3f21842e7f0d95c0$export$d3d5c1e3a6eab89b() {
    document.querySelectorAll('.register-new-patient__input input').forEach((element)=>{
        element.value = '';
    });
}
function $3f21842e7f0d95c0$export$3f4bdc4b0f7095c3() {
    let firstNameDom = document.querySelectorAll('.register-new-patient__input input')[0];
    let lastNameDom = document.querySelectorAll('.register-new-patient__input input')[1];
    let dobDom = document.getElementById('dobDatepicker');
    if (!firstNameDom.value || firstNameDom.value.length === 0) return false;
    if (!lastNameDom.value || lastNameDom.value.length === 0) return false;
    if (!dobDom || dobDom.value.length === 0) return false;
    return true;
}

});


parcelRegister("99TAZ", function(module, exports) {

$parcel$export(module.exports, "shouldShowAllQuestions", () => $6ab01473d330ef47$export$183dbda18d60f8a7);
$parcel$export(module.exports, "loadAllQuestionsFlow", () => $6ab01473d330ef47$export$eb53d48a70ffcf4f);
$parcel$export(module.exports, "shouldTriggerAllQuestionsAfterValidation", () => $6ab01473d330ef47$export$a350975c436c4ba4);

var $cEKee = parcelRequire("cEKee");

var $dc3p2 = parcelRequire("dc3p2");

var $22TpL = parcelRequire("22TpL");

var $er9E0 = parcelRequire("er9E0");

var $cIxq8 = parcelRequire("cIxq8");
function $6ab01473d330ef47$export$183dbda18d60f8a7() {
    // When widget uses consult_request_fields (inline or one-per-page), do not also show the all-questions screen
    // so users are not asked the same or another set of questions twice (individually then all together).
    if (!(0, $cEKee.appointmentChannelId) && Array.isArray((0, $cEKee.form)?.consult_request_fields) && (0, $cEKee.form).consult_request_fields.length > 0) return false;
    const questionnaire = (0, $cEKee.customFields)?.length ? (0, $cEKee.customFields) : (0, $cEKee.appointmentChannelId) ? (0, $cEKee.form)?.appointment_channel?.qualification_form?.custom_fields : (0, $cEKee.form)?.consult_request_fields || (0, $cEKee.form)?.form?.custom_fields;
    // Fields gated to another patient type don't count — a questionnaire whose
    // every field targets e.g. new patients is skipped for returning patients.
    // Likewise fields gated to another procedure (per-field `procedures` key).
    const visible = (0, $dc3p2.filterFieldsForProcedures)((0, $dc3p2.filterFieldsForPatientType)(questionnaire ?? [], (0, $cEKee.patientSelected)), $6ab01473d330ef47$var$getBookingProcedureTokens());
    if (visible.length > 0) return true;
    return false;
}
// Tokens describing the booking flow's selected service, mirroring
// getSelectedProcedureTokens in consultListeners: the selected id plus its
// resolved name (channel procedures first, then the project list). Config
// `procedures` arrays may list names or ids.
function $6ab01473d330ef47$var$getBookingProcedureTokens() {
    // Booking channels with a service list record the choice in
    // selectedProcedures (array of ids); single-service / URL-preselected
    // flows use procedureIdSelected. Accept either.
    const ids = [];
    if (0, $cEKee.procedureIdSelected) ids.push((0, $cEKee.procedureIdSelected));
    if (Array.isArray((0, $cEKee.selectedProcedures))) ids.push(...(0, $cEKee.selectedProcedures));
    if (ids.length === 0) return [];
    const pool = [
        ...Array.isArray((0, $cEKee.proceduresOfAppointmentChannel)) ? (0, $cEKee.proceduresOfAppointmentChannel) : [],
        ...Array.isArray((0, $cEKee.procedures)) ? (0, $cEKee.procedures) : []
    ];
    const tokens = [
        ...ids
    ];
    for (const id of ids){
        const match = pool.find((p)=>String(p?.id) === String(id));
        if (match?.name) tokens.push(match.name);
    }
    return tokens;
}
function $6ab01473d330ef47$export$eb53d48a70ffcf4f() {
    // Prefer consult_request_fields when no appointment channel so we show one consistent set of questions
    const questionnaire = (0, $cEKee.customFields)?.length ? (0, $cEKee.customFields) : (0, $cEKee.appointmentChannelId) ? (0, $cEKee.form)?.appointment_channel?.qualification_form?.custom_fields : (0, $cEKee.form)?.consult_request_fields || (0, $cEKee.form)?.form?.custom_fields;
    const visibleQuestionnaire = (0, $dc3p2.filterFieldsForProcedures)((0, $dc3p2.filterFieldsForPatientType)(questionnaire ?? [], (0, $cEKee.patientSelected)), $6ab01473d330ef47$var$getBookingProcedureTokens());
    if (visibleQuestionnaire.length === 0) return false;
    (0, $cEKee.setCustomFields)(visibleQuestionnaire);
    (0, $er9E0.navigate)((0, $cIxq8.SCREEN).ALL_QUESTIONS);
    (0, $22TpL.loadAllQuestionsPage)();
    return true;
}
function $6ab01473d330ef47$export$a350975c436c4ba4() {
    // Book-first flows run the questionnaire BEFORE the verify-info screen; once
    // it's completed, verify's Continue must not send the visitor back into it
    // (questions → verify → questions forever).
    if ((0, $cEKee.appointmentChannelId) && (0, $cEKee.appointmentQuestionsCompleted)) return false;
    return $6ab01473d330ef47$export$183dbda18d60f8a7();
}

});
parcelRegister("dc3p2", function(module, exports) {

$parcel$export(module.exports, "fieldMatchesPatientType", () => $99af09196953b0f8$export$9b93aa9dcf44d162);
$parcel$export(module.exports, "filterFieldsForPatientType", () => $99af09196953b0f8$export$83ade54661363a59);
$parcel$export(module.exports, "filterFieldsForProcedures", () => $99af09196953b0f8$export$a2d319786306b87f);
$parcel$export(module.exports, "shouldStepConsultFields", () => $99af09196953b0f8$export$b3e9f2b330705fcd);
$parcel$export(module.exports, "conditionSatisfied", () => $99af09196953b0f8$export$3a6f868b8d527b24);
/**
 * Visibility rules for qualification fields. Both keys are optional extras on the
 * qualification_fields JSON — fields without them behave exactly as before.
 *
 *   patient_types: ['new_patient']            → only shown to that patient type
 *   visible_if: { field_id, values: [...] }   → only shown once the referenced
 *                                               field's answer matches one of values
 */ function $99af09196953b0f8$export$9b93aa9dcf44d162(field, patientSelected) {
    const types = field?.patient_types;
    if (!Array.isArray(types) || types.length === 0) return true;
    if (!patientSelected || patientSelected === 'all' || patientSelected === 'new_and_returning_patient') return true;
    return types.includes(patientSelected);
}
function $99af09196953b0f8$export$83ade54661363a59(fields, patientSelected) {
    if (!Array.isArray(fields)) return fields;
    return fields.filter((f)=>$99af09196953b0f8$export$9b93aa9dcf44d162(f, patientSelected));
}
function $99af09196953b0f8$export$f746a7d0e827aa47(field, selectedTokens) {
    const wanted = field?.procedures;
    if (!Array.isArray(wanted) || wanted.length === 0) return true;
    if (!Array.isArray(selectedTokens) || selectedTokens.length === 0) return false;
    const norm = (v)=>String(v).trim().toLowerCase();
    const selected = selectedTokens.filter((v)=>v !== null && v !== undefined && String(v).trim() !== '').map(norm);
    if (selected.length === 0) return false;
    return wanted.some((w)=>selected.includes(norm(w)));
}
function $99af09196953b0f8$export$a2d319786306b87f(fields, selectedTokens) {
    if (!Array.isArray(fields)) return fields;
    return fields.filter((f)=>$99af09196953b0f8$export$f746a7d0e827aa47(f, selectedTokens));
}
function $99af09196953b0f8$export$b3e9f2b330705fcd(fields) {
    if (!Array.isArray(fields) || fields.length === 0) return false;
    return fields.length > 2 || fields.some((f)=>f && f.disqualifier);
}
function $99af09196953b0f8$export$3a6f868b8d527b24(field, answers) {
    const cond = field?.visible_if;
    if (!cond || cond.field_id == null || !Array.isArray(cond.values) || cond.values.length === 0) return true;
    const answer = answers?.[cond.field_id] ?? answers?.[String(cond.field_id)];
    if (answer === undefined || answer === null) return false;
    const wanted = cond.values.map((v)=>String(v).trim().toLowerCase());
    // multi_select answers are stored as a JSON array string — match on any overlap
    if (typeof answer === 'string' && answer.startsWith('[') && answer.endsWith(']')) try {
        const arr = JSON.parse(answer);
        if (Array.isArray(arr)) return arr.some((v)=>wanted.includes(String(v).trim().toLowerCase()));
    } catch (_) {}
    // checkbox answers are stored as 1/0 — normalize to yes/no
    let norm;
    if (answer === 1 || answer === '1') norm = 'yes';
    else if (answer === 0 || answer === '0') norm = 'no';
    else norm = String(answer).trim().toLowerCase();
    return wanted.includes(norm);
}

});

parcelRegister("22TpL", function(module, exports) {

$parcel$export(module.exports, "loadAllQuestionsPage", () => $17d6c0d9f14a3f2f$export$d7de33b5e8336231);
$parcel$export(module.exports, "hideAllQuestionsPage", () => $17d6c0d9f14a3f2f$export$39452b194046f87a);

var $hltT2 = parcelRequire("hltT2");

var $lr6EI = parcelRequire("lr6EI");

var $cEKee = parcelRequire("cEKee");
function $17d6c0d9f14a3f2f$export$d7de33b5e8336231() {
    const container = document.querySelector('.allQuestions__container');
    if (!container) return;
    container.classList.remove('hidden');
    $17d6c0d9f14a3f2f$var$handleLayoutClasses();
    $17d6c0d9f14a3f2f$var$renderStaffInfo();
    if ((0, $cEKee.customFields) && (0, $cEKee.customFields).length > 0) (0, $lr6EI.loadAllQuestions)((0, $cEKee.customFields));
// Listeners are initialized inside loadAllQuestions()
}
function $17d6c0d9f14a3f2f$var$handleLayoutClasses() {
    const container = document.querySelector('.allQuestions__container');
    if (!container) return;
    if (0, $cEKee.isFlowForCalendar) container.classList.remove('split-page');
    else container.classList.add('split-page');
}
function $17d6c0d9f14a3f2f$var$renderStaffInfo() {
    const infoStaffContainer = document.querySelector('.allQuestions__container .infoStaff');
    if (!infoStaffContainer) return;
    if (!(0, $cEKee.isFlowForCalendar) || $17d6c0d9f14a3f2f$var$shouldShowStaffInfo()) (0, $hltT2.renderStaffInfoHeader)(null, null, 'allQuestions__container');
    else infoStaffContainer.style.display = 'none';
}
function $17d6c0d9f14a3f2f$var$shouldShowStaffInfo() {
    return !(0, $cEKee.isFlowForCalendar) || $17d6c0d9f14a3f2f$var$needsSplitPage();
}
function $17d6c0d9f14a3f2f$var$needsSplitPage() {
    return !(0, $cEKee.isFlowForCalendar);
}
function $17d6c0d9f14a3f2f$export$39452b194046f87a() {
    const container = document.querySelector('.allQuestions__container');
    if (container) container.classList.add('hidden');
}

});
parcelRegister("lr6EI", function(module, exports) {

$parcel$export(module.exports, "loadAllQuestions", () => $f9b1484572fafaf6$export$99b39b260502158d);

var $cEKee = parcelRequire("cEKee");

var $dc3p2 = parcelRequire("dc3p2");

var $knjAn = parcelRequire("knjAn");

var $hWSV7 = parcelRequire("hWSV7");

var $gZEOs = parcelRequire("gZEOs");

var $87Cn1 = parcelRequire("87Cn1");

var $22TpL = parcelRequire("22TpL");

var $9bGUq = parcelRequire("9bGUq");

var $gMDh6 = parcelRequire("gMDh6");

var $2q2gk = parcelRequire("2q2gk");

var $er9E0 = parcelRequire("er9E0");

var $cIxq8 = parcelRequire("cIxq8");
const $f9b1484572fafaf6$var$QUESTIONS_PAGE_SIZE = 6;
let $f9b1484572fafaf6$var$currentPageIndex = 0;
function $f9b1484572fafaf6$export$99b39b260502158d(custom_fields) {
    if (!custom_fields || custom_fields.length === 0) return;
    (0, $cEKee.customFields).splice(0, (0, $cEKee.customFields).length, ...(0, $dc3p2.filterFieldsForPatientType)(custom_fields, (0, $cEKee.patientSelected)));
    if ((0, $cEKee.customFields).length === 0) return;
    $f9b1484572fafaf6$var$currentPageIndex = 0;
    $f9b1484572fafaf6$var$initializeContinueButtonListener();
    $f9b1484572fafaf6$var$initializeBackButtonListener();
    $f9b1484572fafaf6$var$renderQuestionsPage($f9b1484572fafaf6$var$currentPageIndex);
}
function $f9b1484572fafaf6$var$getTotalPages() {
    return Math.max(1, Math.ceil((0, $cEKee.customFields).length / $f9b1484572fafaf6$var$QUESTIONS_PAGE_SIZE));
}
function $f9b1484572fafaf6$var$getPageFields(pageIndex) {
    return (0, $cEKee.customFields).slice(pageIndex * $f9b1484572fafaf6$var$QUESTIONS_PAGE_SIZE, (pageIndex + 1) * $f9b1484572fafaf6$var$QUESTIONS_PAGE_SIZE);
}
function $f9b1484572fafaf6$var$renderQuestionsPage(pageIndex) {
    const contentContainer = document.querySelector('.allQuestions__content');
    if (!contentContainer) return;
    contentContainer.innerHTML = '';
    const pageFields = $f9b1484572fafaf6$var$getPageFields(pageIndex);
    pageFields.forEach((field)=>{
        const questionHtml = $f9b1484572fafaf6$var$generateQuestionHtmlByType(field);
        contentContainer.insertAdjacentHTML('beforeend', questionHtml);
    });
    feather.replace();
    $f9b1484572fafaf6$var$initializeAllQuestionListeners(pageFields);
    $f9b1484572fafaf6$var$applyConditionalVisibility();
    const continueBtn = document.querySelector('.allQuestions__container .allQuestionsContinue__btn');
    if (continueBtn) continueBtn.classList.add('disabled');
    $f9b1484572fafaf6$var$validateAllQuestions();
}
function $f9b1484572fafaf6$var$generateQuestionHtmlByType(field) {
    const { id: id, type: type, title: title, required: required } = field;
    const requiredMark = required ? '<span class="required">*</span>' : '';
    switch(type){
        case 'height':
            return `
                <div class="heightQuestion__container heightQuestion__container--${id} question-item" data-question-id="${id}" data-question-type="${type}">
                    <div class="question-header">
                        <h3 class="question-title">${title} ${requiredMark}</h3>
                    </div>
                    <div class="question-body">
                        <div class="heightboxQuestion__container">
                            <div class="heightQuestion" data-name=''>
                                <input id="height_feet_${id}" type="number" min="3" max="8" class="height_feet" />
                                <h3>${(0, $knjAn.t)('feet')}</h3>
                                <input id="height_inch_${id}" type="number" min="0" max="11" class="height_inch" />
                                <h3>${(0, $knjAn.t)('inches')}</h3>
                                <span class="heightQuestion__valid hidden">
                                    <i class="ri-check-line"></i>
                                </span>
                                <span class="heightQuestion__invalid hidden">
                                    <i class="ri-close-line"></i>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            `;
        case 'checkbox':
            return `
                <div class="checkboxQuestion__container checkboxQuestion__container--${id} question-item" data-question-id="${id}" data-question-type="${type}">
                    <div class="question-header">
                        <h3 class="question-title">${title} ${requiredMark}</h3>
                    </div>
                    <div class="question-body">
                        <div class="content__wrapper">
                            <form name="form-checkbox-${id}">
                <div class="selectCheckboxContainer">
                    <div class="select__boolean">
                        <div class="step__list">
                            <ul class="list-basic"> 
                                <li class="select__radio__row">
                                    <div>
                                        <label class="checkbox-lg-container checkbox-round">
                                                            <input id="checkbox_${id}_yes" type="radio" name="custom_fields_${id}" value="yes">
                                            <span class="checkmark"></span>
                                        </label>
                                        <h3>${(0, $knjAn.t)('yes')}</h3>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="select__boolean">
                        <div class="step__list">
                            <ul class="list-basic"> 
                                <li class="select__radio__row">
                                    <div>
                                        <label class="checkbox-lg-container checkbox-round">
                                                            <input id="checkbox_${id}_no" type="radio" name="custom_fields_${id}" value="no">
                                            <span class="checkmark"></span>
                                        </label>
                                        <h3>${(0, $knjAn.t)('no')}</h3>
                                    </div>
                                </li>
                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            `;
        case 'textarea':
            return `
                <div class="textareaQuestion__container textareaQuestion__container--${id} question-item" data-question-id="${id}" data-question-type="${type}">
                    <div class="question-header">
                        <h3 class="question-title">${title} ${requiredMark}</h3>
                    </div>
                    <div class="question-body">
                        <div class="content__wrapper">
                            <form>
                                <div data-form="textareaQuestion" class="form-control">
                                    <textarea class="textareaQuestion" id="textareaQuestion_${id}" placeholder=""></textarea>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            `;
        case 'text':
            return `
                <div class="textQuestion__container textQuestion__container--${id} question-item" data-question-id="${id}" data-question-type="${type}">
                    <div class="question-header">
                        <h3 class="question-title">${title} ${requiredMark}</h3>
                    </div>
                    <div class="question-body">
                        <div class="textboxQuestion__container">
                            <div class="textQuestion" data-name=''>
                                <span class="textQuestion__valid hidden">
                            <i class="ri-check-line"></i>
                        </span>
                                <span class="textQuestion__invalid hidden">
                            <i class="ri-close-line"></i>
                        </span>
                                <input placeholder="" id="textQuestion_${id}" class="textQuestion--input" type="text" autocomplete="off">
                            </div>
                        </div>
                    </div>
                </div>
            `;
        case 'select':
            return `
                <div class="selectQuestion__container selectQuestion__container--${id} question-item" data-question-id="${id}" data-question-type="${type}">
                    <div class="question-header">
                        <h3 class="question-title">${title} ${requiredMark}</h3>
                    </div>
                    <div class="question-body">
                        <div class="content__wrapper">
                            <div class="list-question" id="list-question_${id}">
                            </div>
                        </div>
                    </div>
                </div>
            `;
        case 'date':
            return `
                <div class="dateQuestion__container dateQuestion__container--${id} question-item" data-question-id="${id}" data-question-type="${type}">
                    <div class="question-header">
                        <h3 class="question-title">${title} ${requiredMark}</h3>
                    </div>
                    <div class="question-body">
                        <div class="dateboxQuestion__container">
                            <div class="dateQuestion">
                                <i data-feather="calendar"></i>
                                <input id="questionDatepicker--dateQuestion__container--${id}" class="dateQuestion--input" type="text" placeholder="MM/DD/YYYY" readonly>
                            </div>
                        </div>
                    </div>
                </div>
            `;
        case 'number':
            return `
                <div class="numberQuestion__container numberQuestion__container--${id} question-item" data-question-id="${id}" data-question-type="${type}">
                    <div class="question-header">
                        <h3 class="question-title">${title} ${requiredMark}</h3>
                    </div>
                    <div class="question-body">
                        <div class="numberboxQuestion__container">
                    <div class="numberQuestion" data-name=''>
                        <span class="numberQuestion__valid hidden">
                            <i class="ri-check-line"></i>
                        </span>
                        <span class="numberQuestion__invalid hidden">
                            <i class="ri-close-line"></i>
                        </span>
                                <input min="0" placeholder="" id="numberQuestion_${id}" class="numberQuestion--input" type="number" autocomplete="off">
                            </div>
                        </div>
                    </div>
                </div>
            `;
        case 'multi_select':
            return `
                <div class="selectQuestion__container multi_selectQuestion__container--${id} question-item" data-question-id="${id}" data-question-type="${type}">
                    <div class="question-header">
                        <h3 class="question-title">${title} ${requiredMark}</h3>
                    </div>
                    <div class="question-body">
                        <div class="content__wrapper">
                            <div class="list-question" id="list-question_${id}">
                            </div>
                        </div>
                    </div>
                </div>
            `;
        default:
            return `<div class="unsupported-question">${(0, $knjAn.t)('unsupported_question_type')} ${type}</div>`;
    }
}
function $f9b1484572fafaf6$var$initializeAllQuestionListeners(custom_fields) {
    custom_fields.forEach((field)=>{
        $f9b1484572fafaf6$var$initializeQuestionType(field);
    });
    custom_fields.forEach((field)=>{
        if (field.type === 'select' || field.type === 'multi_select') $f9b1484572fafaf6$var$loadSelectOptions(field);
    });
    custom_fields.forEach((field)=>{
        if (field.type === 'date') $f9b1484572fafaf6$var$initializeDatePicker(field);
    });
}
function $f9b1484572fafaf6$var$initializeQuestionType(field) {
    const { id: id, type: type } = field;
    switch(type){
        case 'text':
            $f9b1484572fafaf6$var$initializeTextQuestion(id);
            break;
        case 'textarea':
            $f9b1484572fafaf6$var$initializeTextareaQuestion(id);
            break;
        case 'number':
            $f9b1484572fafaf6$var$initializeNumberQuestion(id);
            break;
        case 'date':
            break;
        case 'checkbox':
            $f9b1484572fafaf6$var$initializeCheckboxQuestion(id);
            break;
        case 'select':
        case 'multi_select':
            break;
        case 'height':
            $f9b1484572fafaf6$var$initializeHeightQuestion(id);
            break;
    }
}
function $f9b1484572fafaf6$var$initializeTextQuestion(questionId) {
    const input = document.getElementById(`textQuestion_${questionId}`);
    const container = document.querySelector(`.allQuestions__container .textQuestion__container--${questionId}`);
    const textQuestionElement = container?.querySelector('.textQuestion');
    const validIcon = container?.querySelector('.textQuestion__valid');
    const invalidIcon = container?.querySelector('.textQuestion__invalid');
    if (input) {
        input.addEventListener('input', (e)=>{
            const value = e.target.value.trim();
            if (value) {
                textQuestionElement?.classList.add('valid');
                textQuestionElement?.classList.remove('invalid');
                validIcon?.classList.remove('hidden');
                invalidIcon?.classList.add('hidden');
                (0, $cEKee.listDataQuestion)[questionId] = value;
            } else {
                textQuestionElement?.classList.remove('valid');
                textQuestionElement?.classList.add('invalid');
                validIcon?.classList.add('hidden');
                invalidIcon?.classList.remove('hidden');
                delete (0, $cEKee.listDataQuestion)[questionId];
            }
            $f9b1484572fafaf6$var$validateAllQuestions();
        });
        if ((0, $cEKee.listDataQuestion)[questionId]) {
            input.value = (0, $cEKee.listDataQuestion)[questionId];
            textQuestionElement?.classList.add('valid');
            validIcon?.classList.remove('hidden');
            invalidIcon?.classList.add('hidden');
        }
    }
}
function $f9b1484572fafaf6$var$initializeTextareaQuestion(questionId) {
    const textarea = document.getElementById(`textareaQuestion_${questionId}`);
    if (textarea) {
        textarea.addEventListener('input', (e)=>{
            const value = e.target.value.trim();
            if (value) (0, $cEKee.listDataQuestion)[questionId] = value;
            else delete (0, $cEKee.listDataQuestion)[questionId];
            $f9b1484572fafaf6$var$validateAllQuestions();
        });
        if ((0, $cEKee.listDataQuestion)[questionId]) textarea.value = (0, $cEKee.listDataQuestion)[questionId];
    }
}
function $f9b1484572fafaf6$var$initializeNumberQuestion(questionId) {
    const input = document.getElementById(`numberQuestion_${questionId}`);
    const container = document.querySelector(`.allQuestions__container .numberQuestion__container--${questionId}`);
    const numberQuestionElement = container?.querySelector('.numberQuestion');
    const validIcon = container?.querySelector('.numberQuestion__valid');
    const invalidIcon = container?.querySelector('.numberQuestion__invalid');
    if (input) {
        input.addEventListener('input', (e)=>{
            const value = e.target.value;
            if (value && !isNaN(value) && value > 0) {
                numberQuestionElement?.classList.add('valid');
                numberQuestionElement?.classList.remove('invalid');
                validIcon?.classList.remove('hidden');
                invalidIcon?.classList.add('hidden');
                (0, $cEKee.listDataQuestion)[questionId] = value;
            } else {
                numberQuestionElement?.classList.remove('valid');
                numberQuestionElement?.classList.add('invalid');
                validIcon?.classList.add('hidden');
                invalidIcon?.classList.remove('hidden');
                delete (0, $cEKee.listDataQuestion)[questionId];
            }
            $f9b1484572fafaf6$var$validateAllQuestions();
        });
        if ((0, $cEKee.listDataQuestion)[questionId]) {
            input.value = (0, $cEKee.listDataQuestion)[questionId];
            numberQuestionElement?.classList.add('valid');
            validIcon?.classList.remove('hidden');
            invalidIcon?.classList.add('hidden');
        }
    }
}
function $f9b1484572fafaf6$var$initializeCheckboxQuestion(questionId) {
    const radios = document.querySelectorAll(`.allQuestions__container input[name="custom_fields_${questionId}"]`);
    radios.forEach((radio)=>{
        radio.addEventListener('change', ()=>{
            if (radio.checked) {
                (0, $cEKee.listDataQuestion)[questionId] = radio.value === 'yes' ? 1 : 0;
                $f9b1484572fafaf6$var$validateAllQuestions();
            }
        });
    });
    if ((0, $cEKee.listDataQuestion)[questionId] !== undefined) {
        const savedValue = (0, $cEKee.listDataQuestion)[questionId];
        const radioToSelect = savedValue === 1 ? document.getElementById(`checkbox_${questionId}_yes`) : document.getElementById(`checkbox_${questionId}_no`);
        if (radioToSelect) radioToSelect.checked = true;
    }
}
function $f9b1484572fafaf6$var$initializeHeightQuestion(questionId) {
    const feetInput = document.getElementById(`height_feet_${questionId}`);
    const inchesInput = document.getElementById(`height_inch_${questionId}`);
    const container = document.querySelector(`.allQuestions__container .heightQuestion__container--${questionId}`);
    const heightQuestionElement = container?.querySelector('.heightQuestion');
    const validIcon = container?.querySelector('.heightQuestion__valid');
    const invalidIcon = container?.querySelector('.heightQuestion__invalid');
    const updateHeight = ()=>{
        const feet = feetInput?.value || '0';
        const inches = inchesInput?.value || '0';
        if (feet && inches) {
            heightQuestionElement?.classList.add('valid');
            heightQuestionElement?.classList.remove('invalid');
            validIcon?.classList.remove('hidden');
            invalidIcon?.classList.add('hidden');
            (0, $cEKee.listDataQuestion)[questionId] = `${feet}'${inches}"`;
        } else {
            heightQuestionElement?.classList.remove('valid');
            heightQuestionElement?.classList.add('invalid');
            validIcon?.classList.add('hidden');
            invalidIcon?.classList.remove('hidden');
            delete (0, $cEKee.listDataQuestion)[questionId];
        }
        $f9b1484572fafaf6$var$validateAllQuestions();
    };
    if (feetInput) feetInput.addEventListener('input', updateHeight);
    if (inchesInput) inchesInput.addEventListener('input', updateHeight);
    if ((0, $cEKee.listDataQuestion)[questionId]) {
        const heightValue = (0, $cEKee.listDataQuestion)[questionId];
        const match = heightValue.match(/(\d+)'(\d+)"/);
        if (match) {
            feetInput.value = match[1];
            inchesInput.value = match[2];
            heightQuestionElement?.classList.add('valid');
            validIcon?.classList.remove('hidden');
            invalidIcon?.classList.add('hidden');
        }
    }
}
function $f9b1484572fafaf6$var$loadSelectOptions(field) {
    const { id: id, type: type, answers: answers } = field;
    const container = document.getElementById(`list-question_${id}`);
    if (!container || !answers) return;
    const isMultiSelect = type === 'multi_select';
    if (isMultiSelect) {
        let optionsHtml = '';
        answers.forEach((answer)=>{
            optionsHtml += `
                <div class="option" data-option="${answer}">
                    <span class="option__name">${answer}</span>
                    <span class="option__checkbox" data-option="${answer}">
                        <i class="option__icon-check ri-check-line"></i>
                    </span>
                </div>
            `;
        });
        container.innerHTML = optionsHtml;
        container.querySelectorAll('.option').forEach((option)=>{
            option.addEventListener('click', ()=>{
                const value = option.getAttribute('data-option');
                $f9b1484572fafaf6$var$selectOption(value, isMultiSelect, id);
            });
        });
        if ((0, $cEKee.listDataQuestion)[id]) try {
            const selectedValues = JSON.parse((0, $cEKee.listDataQuestion)[id]);
            selectedValues.forEach((value)=>$f9b1484572fafaf6$var$selectOption(value, true, id));
        } catch (e) {
        // Error parsing multi-select values
        }
    } else {
        let selectHtml = '<select class="select-dropdown" id="select-dropdown_' + id + '">';
        selectHtml += `<option value="">${(0, $knjAn.t)('select_an_option')}</option>`;
        answers.forEach((answer)=>{
            selectHtml += '<option value="' + answer + '">' + answer + '</option>';
        });
        selectHtml += '</select>';
        container.innerHTML = selectHtml;
        const selectElement = document.getElementById(`select-dropdown_${id}`);
        if (selectElement) {
            selectElement.addEventListener('change', (e)=>{
                const value = e.target.value;
                if (value) (0, $cEKee.listDataQuestion)[id] = value;
                else delete (0, $cEKee.listDataQuestion)[id];
                $f9b1484572fafaf6$var$validateAllQuestions();
            });
            if ((0, $cEKee.listDataQuestion)[id]) selectElement.value = (0, $cEKee.listDataQuestion)[id];
        }
    }
}
function $f9b1484572fafaf6$var$selectOption(value, isMultiSelect, questionId) {
    const container = document.getElementById(`list-question_${questionId}`);
    if (!container) return;
    if (isMultiSelect) {
        // Use DOM traversal instead of CSS.escape which can break attribute selectors for values with spaces
        const checkboxes = container.querySelectorAll('.option__checkbox');
        let checkbox = null;
        for (const cb of checkboxes)if (cb.getAttribute('data-option') === value) {
            checkbox = cb;
            break;
        }
        if (checkbox) {
            checkbox.classList.toggle('is-selected');
            const selectedValues = Array.from(container.querySelectorAll('.option__checkbox.is-selected')).map((el)=>el.getAttribute('data-option'));
            if (selectedValues.length > 0) (0, $cEKee.listDataQuestion)[questionId] = JSON.stringify(selectedValues);
            else delete (0, $cEKee.listDataQuestion)[questionId];
        }
    }
    $f9b1484572fafaf6$var$validateAllQuestions();
}
function $f9b1484572fafaf6$var$initializeDatePicker(field) {
    const { id: id } = field;
    const input = document.getElementById(`questionDatepicker--dateQuestion__container--${id}`);
    if (input && typeof window.flatpickr !== 'undefined') {
        window.flatpickr(input, {
            dateFormat: "Y-m-d",
            altInput: true,
            altFormat: "m/d/Y",
            onChange: function(selectedDates, dateStr) {
                if (dateStr) (0, $cEKee.listDataQuestion)[id] = dateStr;
                else delete (0, $cEKee.listDataQuestion)[id];
                $f9b1484572fafaf6$var$validateAllQuestions();
            }
        });
        if ((0, $cEKee.listDataQuestion)[id]) input.value = (0, $cEKee.listDataQuestion)[id];
    }
}
function $f9b1484572fafaf6$var$initializeContinueButtonListener() {
    const continueBtn = document.querySelector('.allQuestions__container .allQuestionsContinue__btn');
    const backBtn = document.querySelector('.allQuestions__container .allQuestionsBack__btn');
    if (continueBtn) continueBtn.addEventListener('click', async ()=>{
        if (continueBtn.classList.contains('disabled')) return;
        // Let the visitor answer every page first — do not evaluate
        // disqualifiers until the last page's answers are in, so a
        // disqualifying pick on page 1 no longer cuts the questionnaire short.
        if ($f9b1484572fafaf6$var$currentPageIndex < $f9b1484572fafaf6$var$getTotalPages() - 1) {
            $f9b1484572fafaf6$var$currentPageIndex += 1;
            $f9b1484572fafaf6$var$renderQuestionsPage($f9b1484572fafaf6$var$currentPageIndex);
            return;
        }
        continueBtn.classList.add('disabled');
        const loadingWrapper = continueBtn.querySelector('.loading__wrapper');
        const loaderIcon = continueBtn.querySelector('.loader__icon');
        if (loadingWrapper) loadingWrapper.classList.remove('hidden');
        if (loaderIcon) loaderIcon.innerHTML = `<img src="${0, $cEKee.appUrl}/assets/icons/rolling.png" />`;
        try {
            const formId = (0, $cEKee.form)?.appointment_channel?.qualification_form?.id;
            if (Object.keys((0, $cEKee.listDataQuestion)).length > 0) {
                if (typeof formId === 'string' && formId.startsWith('ac-')) {
                    const acId = parseInt(formId.replace(/^ac-/, ''), 10);
                    const fieldLabels = ((0, $cEKee.customFields) || []).reduce((acc, f)=>{
                        if (f && f.id) acc[f.id] = f.label || f.title || 'Custom field';
                        return acc;
                    }, {});
                    await (0, $hWSV7.updateQualificationResponses)((0, $cEKee.leadTextId), acId, (0, $cEKee.listDataQuestion), fieldLabels, (0, $cEKee.eventId) || undefined);
                } else {
                    const fieldLabels = ((0, $cEKee.customFields) || []).reduce((acc, f)=>{
                        if (f && f.id) acc[f.id] = f.label || f.title || 'Custom field';
                        return acc;
                    }, {});
                    await (0, $hWSV7.updateConsultRequestFields)((0, $cEKee.leadTextId), (0, $cEKee.listDataQuestion), fieldLabels);
                }
            }
            // Now that every page's answers are saved, decide whether the
            // full set of answers disqualifies the visitor.
            const fields = ((0, $cEKee.customFields)?.length ? (0, $cEKee.customFields) : (0, $cEKee.form)?.appointment_channel?.qualification_form?.custom_fields ?? []).filter((f)=>(0, $dc3p2.fieldMatchesPatientType)(f, (0, $cEKee.patientSelected)) && (0, $dc3p2.conditionSatisfied)(f, (0, $cEKee.listDataQuestion)));
            const minDisqualifiers = (0, $cEKee.form)?.appointment_channel?.min_disqualifier_matches ?? 1;
            if ((0, $cEKee.appointmentChannelId) && fields.length > 0 && (0, $gMDh6.shouldDisqualifyNow)(fields, (0, $cEKee.listDataQuestion), minDisqualifiers) && (0, $cEKee.leadInfo)?.id) {
                await (0, $2q2gk.updateLeadStep)((0, $cEKee.leadInfo).id, 'disqualified', 'true');
                (0, $er9E0.setSessionEndStepSentForLeadId)((0, $cEKee.leadInfo).id);
                (0, $22TpL.hideAllQuestionsPage)();
                $f9b1484572fafaf6$export$7a69b9654b1e26dd();
                (0, $9bGUq.clearCustomFields)();
                (0, $er9E0.setIsDisqualified)(true);
                (0, $er9E0.navigate)((0, $cIxq8.SCREEN).THE_END);
                return;
            }
            if (0, $cEKee.appointmentChannelId) (0, $cEKee.setAppointmentQuestionsCompleted)(true);
            await (0, $87Cn1.navigateToNextPageWithClearFields)();
            (0, $22TpL.hideAllQuestionsPage)();
            $f9b1484572fafaf6$export$7a69b9654b1e26dd();
            (0, $9bGUq.clearCustomFields)();
        } catch (error) {
            (0, $gZEOs.toastError)(error.response?.data?.message);
        } finally{
            continueBtn.classList.remove('disabled');
            if (loadingWrapper) loadingWrapper.classList.add('hidden');
            if (loaderIcon) loaderIcon.innerHTML = '<i class="ri-arrow-right-line"></i>';
        }
    });
    if (backBtn) backBtn.addEventListener('click', ()=>{
        $f9b1484572fafaf6$export$7a69b9654b1e26dd();
    });
}
function $f9b1484572fafaf6$var$initializeBackButtonListener() {
    const backBtn = document.querySelector('.allQuestions__actions .backOneStep__btn');
    if (!backBtn) return;
    // Capture phase so this runs before movePages.js's own onclick handler on the
    // same element, letting us swallow the click and go to the previous question
    // page instead of leaving the screen — only while there's a previous page.
    backBtn.addEventListener('click', (event)=>{
        if ($f9b1484572fafaf6$var$currentPageIndex > 0) {
            event.stopImmediatePropagation();
            event.preventDefault();
            $f9b1484572fafaf6$var$currentPageIndex -= 1;
            $f9b1484572fafaf6$var$renderQuestionsPage($f9b1484572fafaf6$var$currentPageIndex);
        }
    }, true);
}
/**
 * Show/hide the current page's visible_if fields based on the answers so far.
 * When a field hides, its answer AND its rendered input state are cleared so a
 * stale visible answer can't diverge from listDataQuestion.
 */ function $f9b1484572fafaf6$var$applyConditionalVisibility() {
    $f9b1484572fafaf6$var$getPageFields($f9b1484572fafaf6$var$currentPageIndex).forEach((field)=>{
        if (!field?.visible_if) return;
        const container = document.querySelector(`.allQuestions__content .question-item[data-question-id="${field.id}"]`);
        if (!container) return;
        if ((0, $dc3p2.conditionSatisfied)(field, (0, $cEKee.listDataQuestion))) container.classList.remove('hidden');
        else {
            container.classList.add('hidden');
            if ((0, $cEKee.listDataQuestion)[field.id] !== undefined) delete (0, $cEKee.listDataQuestion)[field.id];
            container.querySelectorAll('input[type="radio"], input[type="checkbox"]').forEach((i)=>{
                i.checked = false;
            });
            container.querySelectorAll('input[type="text"], input[type="number"], textarea, select').forEach((i)=>{
                i.value = '';
            });
            container.querySelectorAll('.option__checkbox.is-selected').forEach((el)=>el.classList.remove('is-selected'));
        }
    });
}
/**
 */ function $f9b1484572fafaf6$var$validateAllQuestions() {
    $f9b1484572fafaf6$var$applyConditionalVisibility();
    const continueBtn = document.querySelector('.allQuestions__container .allQuestionsContinue__btn');
    if (!continueBtn) return;
    const requiredQuestions = $f9b1484572fafaf6$var$getPageFields($f9b1484572fafaf6$var$currentPageIndex).filter((field)=>field.required && (0, $dc3p2.conditionSatisfied)(field, (0, $cEKee.listDataQuestion)));
    const allRequiredAnswered = requiredQuestions.every((field)=>{
        const answer = (0, $cEKee.listDataQuestion)[field.id];
        if (answer === undefined || answer === null) return false;
        if (typeof answer === 'string') {
            if (answer.startsWith('[') && answer.endsWith(']')) try {
                const parsed = JSON.parse(answer);
                return Array.isArray(parsed) && parsed.length > 0;
            } catch  {
                return false;
            }
            return answer.trim() !== '';
        }
        if (typeof answer === 'number') return true;
        return Boolean(answer);
    });
    if (allRequiredAnswered && requiredQuestions.length > 0 || requiredQuestions.length === 0) continueBtn.classList.remove('disabled');
    else continueBtn.classList.add('disabled');
}
function $f9b1484572fafaf6$export$1b70ed5211768260() {
    return {
        ...(0, $cEKee.listDataQuestion)
    };
}
function $f9b1484572fafaf6$export$7a69b9654b1e26dd() {
    const contentContainer = document.querySelector('.allQuestions__content');
    if (contentContainer) contentContainer.innerHTML = '';
    Object.keys((0, $cEKee.listDataQuestion)).forEach((key)=>{
        delete (0, $cEKee.listDataQuestion)[key];
    });
    (0, $cEKee.customFields).splice(0, (0, $cEKee.customFields).length);
    $f9b1484572fafaf6$var$currentPageIndex = 0;
}

});
parcelRegister("gMDh6", function(module, exports) {

$parcel$export(module.exports, "evaluateDisqualifier", () => $c37f98362f37e572$export$8c45e6cbb3dc9023);
$parcel$export(module.exports, "shouldDisqualifyNow", () => $c37f98362f37e572$export$5812665b6cfab9f);
/**
 * Evaluates whether an answer matches a field's disqualifier config.
 * When true, the visitor should be sent to the dead-end screen (no appointment booking).
 * Comparisons are case-insensitive for string values; types/operators normalized to avoid casing issues.
 *
 * @param {Object} field - Qualification field with optional disqualifier: { type, disqualifier?: { type, values?, value?, operator? } }
 * @param {string|number|*} value - The answer value (as stored: string for select/text, number for number, 1|0 for checkbox, JSON string for multi_select)
 * @returns {boolean} true if the answer matches the disqualifier (visitor should be disqualified)
 */ function $c37f98362f37e572$export$8c45e6cbb3dc9023(field, value) {
    if (!field || !field.disqualifier) return false;
    const d = field.disqualifier;
    const type = String(field.type || '').toLowerCase();
    if (type === 'select') {
        const dType = String(d.type || '').toLowerCase();
        if (dType !== 'options' || !Array.isArray(d.values) || d.values.length === 0) return false;
        const strVal = (value != null ? String(value).trim() : '').toLowerCase();
        return d.values.some((v)=>String(v).trim().toLowerCase() === strVal);
    }
    if (type === 'multi_select') {
        const dType = String(d.type || '').toLowerCase();
        if (dType !== 'options' || !Array.isArray(d.values) || d.values.length === 0) return false;
        let selected = [];
        try {
            selected = typeof value === 'string' ? JSON.parse(value) : Array.isArray(value) ? value : [];
        } catch (_) {
            return false;
        }
        if (!Array.isArray(selected)) return false;
        const dValuesLower = d.values.map((v)=>String(v).trim().toLowerCase());
        return selected.some((v)=>dValuesLower.includes(String(v).trim().toLowerCase()));
    }
    if (type === 'number') {
        const dType = String(d.type || '').toLowerCase();
        if (dType !== 'threshold' || d.operator == null) return false;
        const num = typeof value === 'number' ? value : parseFloat(value);
        if (Number.isNaN(num)) return false;
        const threshold = typeof d.value === 'number' ? d.value : parseFloat(d.value);
        if (Number.isNaN(threshold)) return false;
        const op = String(d.operator).toLowerCase();
        switch(op){
            case 'gt':
                return num > threshold;
            case 'gte':
                return num >= threshold;
            case 'lt':
                return num < threshold;
            case 'lte':
                return num <= threshold;
            case 'eq':
                return num === threshold;
            default:
                return false;
        }
    }
    if (type === 'text' || type === 'textarea') {
        const strVal = (value != null ? String(value).trim() : '').toLowerCase();
        const matchVal = (d.value != null ? String(d.value).trim() : '').toLowerCase();
        const dType = String(d.type || '').toLowerCase();
        if (dType === 'contains') return matchVal.length > 0 && strVal.includes(matchVal);
        if (dType === 'equals') return matchVal.length > 0 && strVal === matchVal;
        return false;
    }
    if (type === 'checkbox') {
        const dType = String(d.type || '').toLowerCase();
        if (dType !== 'equals') return false;
        const configVal = $c37f98362f37e572$var$normalizeCheckboxValue(d.value);
        if (configVal !== 'yes' && configVal !== 'no') return false;
        const answer = $c37f98362f37e572$var$normalizeCheckboxValue(value);
        return answer !== null && answer === configVal;
    }
    return false;
}
function $c37f98362f37e572$var$normalizeCheckboxValue(v) {
    if (v === true || v === 1 || v === '1') return 'yes';
    if (v === false || v === 0 || v === '0') return 'no';
    const s = (v != null ? String(v).trim() : '').toLowerCase();
    if (s === 'yes' || s === 'true') return 'yes';
    if (s === 'no' || s === 'false') return 'no';
    return null;
}
function $c37f98362f37e572$export$6cd6ebd55421d210(fields, listDataQuestion) {
    if (!Array.isArray(fields) || !listDataQuestion || typeof listDataQuestion !== 'object') return 0;
    let count = 0;
    for (const field of fields){
        if (!field || !field.disqualifier) continue;
        const id = field.id;
        const value = listDataQuestion[id] ?? listDataQuestion[String(id)];
        if (value === undefined) continue;
        if ($c37f98362f37e572$export$8c45e6cbb3dc9023(field, value)) count++;
    }
    return count;
}
function $c37f98362f37e572$export$5812665b6cfab9f(fields, listDataQuestion, minMatches = 1) {
    const n = Math.max(1, parseInt(minMatches, 10) || 1);
    return $c37f98362f37e572$export$6cd6ebd55421d210(fields, listDataQuestion) >= n;
}

});




parcelRegister("9h4tQ", function(module, exports) {

$parcel$export(module.exports, "loadCategoryList", () => $6c092d4bb8d2c380$export$18de84c2bfd0fa18);

var $knjAn = parcelRequire("knjAn");
function $6c092d4bb8d2c380$export$18de84c2bfd0fa18(categories) {
    const list = document.querySelector('.categories__container .categories__list');
    list.innerHTML = '';
    if (categories.length <= 0) list.insertAdjacentHTML('beforeend', `
        <div class="noProcedures">${(0, $knjAn.t)('no_categories_found')}</div>
        `);
    if (categories.length > 0) list.insertAdjacentHTML('beforeend', `
        <div class="categories__list--title">${(0, $knjAn.t)('select_category')}</div>
        `);
    if (categories.length > 0) for (const category of categories){
        const iconHtml = category.icon ? `<img src="${"https://storage.googleapis.com/pp-icons/"}${category.icon}"/>` : '';
        list.insertAdjacentHTML('beforeend', `
            <div class="category-item" data-category-id="${category.id}" data-category="${category.name}">
                ${iconHtml}
                <div class="category-item__info-wrapper">
                    <span class="category-item__name">${category.name}</span>
                </div>
                <span class="category-item__option" data-category-id="${category.id}">
                    <i class="category-item__icon-check ri-check-line"></i>
                </span>
            </div>
            `);
    }
}

});

parcelRegister("5YZvF", function(module, exports) {

$parcel$export(module.exports, "categorySelectionListeners", () => $45b244e2d5901a20$export$b3d9d518e7c225a8);

var $cIxq8 = parcelRequire("cIxq8");

var $cEKee = parcelRequire("cEKee");

var $9aDEm = parcelRequire("9aDEm");

var $er9E0 = parcelRequire("er9E0");

var $8QS3m = parcelRequire("8QS3m");

var $d0tLC = parcelRequire("d0tLC");
function $45b244e2d5901a20$export$b3d9d518e7c225a8() {
    document.querySelectorAll('.categories__list .category-item').forEach((i)=>{
        i.addEventListener('click', $45b244e2d5901a20$export$43ff1acc236ecf9d);
    });
}
function $45b244e2d5901a20$export$43ff1acc236ecf9d(selectedCategory = null) {
    let categoryId;
    if (selectedCategory && typeof selectedCategory === 'number') categoryId = selectedCategory;
    else categoryId = parseInt(this.getAttribute('data-category-id'));
    (0, $9aDEm.selectCategory)(categoryId);
    (0, $cEKee.setSelectedCategoryId)(categoryId);
    const selectedCategoryObj = (0, $cEKee.categories).find((c)=>c.id == categoryId);
    if (!selectedCategoryObj) return;
    const filteredProcedures = (0, $cEKee.procedures).filter((procedure)=>{
        return procedure.service_categories?.map((cat)=>cat.id).includes(categoryId);
    });
    (0, $8QS3m.loadCategories)(filteredProcedures);
    (0, $d0tLC.loadProcedures)(filteredProcedures);
    (0, $er9E0.navigate)((0, $cIxq8.SCREEN).SEE_ALL_SERVICES);
}

});
parcelRegister("9aDEm", function(module, exports) {

$parcel$export(module.exports, "selectCategory", () => $6ad3cde810ea3c41$export$9d13104b8c445928);

var $cEKee = parcelRequire("cEKee");
function $6ad3cde810ea3c41$export$9d13104b8c445928(id) {
    $6ad3cde810ea3c41$export$a0a89bc8b4bcfd91();
    (0, $cEKee.setSelectedCategoryId)(id);
    const categoryOption = document.querySelector(`.category-item__option[data-category-id="${CSS.escape(id)}"]`);
    categoryOption?.classList.add('is-selected');
}
function $6ad3cde810ea3c41$export$a0a89bc8b4bcfd91() {
    (0, $cEKee.setSelectedCategoryId)('');
    document.querySelectorAll('.category-item__option').forEach((i)=>i.classList.remove('is-selected'));
}

});




parcelRegister("lmlIJ", function(module, exports) {

$parcel$export(module.exports, "patientListeners", () => $f8cc804bba9a53cd$export$b08fca6371820164);
$parcel$export(module.exports, "patientContinueBtnHandler", () => $f8cc804bba9a53cd$export$aefc9af040eecf53);

var $ig8jH = parcelRequire("ig8jH");

var $cIxq8 = parcelRequire("cIxq8");

var $cEKee = parcelRequire("cEKee");

var $26PlJ = parcelRequire("26PlJ");

var $er9E0 = parcelRequire("er9E0");

var $cOK4N = parcelRequire("cOK4N");

var $1kc6e = parcelRequire("1kc6e");
const $f8cc804bba9a53cd$export$b08fca6371820164 = ()=>{
    (0, $26PlJ.loadPatients)();
    const lengthServiceType = Object.keys((0, $cEKee.form)?.service_types).length;
    if (lengthServiceType < 2 && !(0, $cEKee.appointmentChannelId)) document.querySelector(".patient__actions .backOneStep__btn")?.classList?.add("hide");
    if (0, $cEKee.patientSelected) {
        const idPatient = (0, $26PlJ.getPatients)()?.find((i)=>i.value === (0, $cEKee.patientSelected))?.id;
        idPatient && $f8cc804bba9a53cd$export$f249c1aef8ed4ea1(idPatient);
    }
    /* on select patient*/ document.querySelectorAll('.patients__container .patient').forEach((i)=>{
        i.addEventListener('click', ()=>{
            const id = parseInt(i.getAttribute('data-patient-id'));
            $f8cc804bba9a53cd$export$f249c1aef8ed4ea1(id);
        });
    });
    document.querySelector('.patientContinue__btn').addEventListener('click', $f8cc804bba9a53cd$export$aefc9af040eecf53);
    /* On click enter */ const screenPhone = document.querySelector('.patients__container');
    if (screenPhone) screenPhone.addEventListener('keydown', $f8cc804bba9a53cd$var$handlePressEnter);
    if ((0, $cEKee.appointmentChannelId) && (0, $cEKee.locations)?.length < 2) document.querySelector('.patients__container .backOneStep__btn').classList.add("hide");
};
function $f8cc804bba9a53cd$export$aefc9af040eecf53() {
    // skip patient selection page
    if (!(0, $cEKee.patientSelected) && (0, $ig8jH.isPageHidden)('patient_page', (0, $cEKee.hiddenPages))) (0, $cEKee.setPatientSelected)("all");
    if (0, $cEKee.appointmentChannelId) {
        const lengthServiceType = Object.keys((0, $cEKee.form).service_types).length;
        if ((0, $ig8jH.isPageHidden)('surgical', (0, $cEKee.hiddenPages))) {
            (0, $cOK4N.handleBothSurgicalOptionsClick)();
            return;
        }
        if (lengthServiceType > 1) (0, $er9E0.navigate)((0, $cIxq8.SCREEN).SURGICAL);
        else {
            let service = Object.values((0, $cEKee.form).service_types)[0];
            if (service === "surgical") (0, $cOK4N.handleSurgicalButtonClick)();
            else (0, $cOK4N.handleNonSurgicalButtonClick)();
        }
    } else (0, $1kc6e.goToServices)();
}
function $f8cc804bba9a53cd$export$f249c1aef8ed4ea1(id) {
    const select = (0, $26PlJ.getPatients)()?.find((i)=>i.id === +id)?.value || '';
    $f8cc804bba9a53cd$var$removeAllSelectedPatient();
    (0, $cEKee.setPatientSelected)(select);
    document.querySelector(`.patient__checkbox[data-patient-id="${CSS.escape(id)}"]`).classList.add('is-selected');
    document.querySelector('.patientContinue__btn').classList.remove('disabled');
}
const $f8cc804bba9a53cd$var$removeAllSelectedPatient = ()=>{
    (0, $cEKee.setPatientSelected)('');
    document.querySelectorAll('.patient__checkbox').forEach((i)=>i.classList.remove('is-selected'));
    document.querySelector('.patientContinue__btn').classList.add('disabled');
};
function $f8cc804bba9a53cd$var$handlePressEnter(event) {
    event.stopPropagation();
    if (event.key === 'Enter' && !document.querySelector(`.patients__container .patientContinue__btn`).classList.contains('disabled')) document.querySelector('.patientContinue__btn').click();
}

});
parcelRegister("ig8jH", function(module, exports) {

$parcel$export(module.exports, "isPageHidden", () => $d4b02c297a0c560d$export$d43fb2fa01ff166f);
const $d4b02c297a0c560d$export$d43fb2fa01ff166f = (pageKey, hiddenPages = [])=>{
    return hiddenPages.includes(pageKey);
};

});

parcelRegister("26PlJ", function(module, exports) {

$parcel$export(module.exports, "getPatients", () => $1893f9465738cf52$export$21cdaf643f3db8a6);
$parcel$export(module.exports, "loadPatients", () => $1893f9465738cf52$export$a77b59c18abdb225);

var $knjAn = parcelRequire("knjAn");
const $1893f9465738cf52$export$21cdaf643f3db8a6 = ()=>[
        {
            id: 1,
            name: (0, $knjAn.t)('new_patient'),
            value: "new_patient"
        },
        {
            id: 2,
            name: (0, $knjAn.t)('returning_patient'),
            value: "returning_patient"
        }
    ];
function $1893f9465738cf52$export$a77b59c18abdb225() {
    let list = document.querySelector('.patients__container .patients__list');
    let partientList = ``;
    for (const i of $1893f9465738cf52$export$21cdaf643f3db8a6())partientList = partientList.concat(`
        <button class="patient" data-patient-id="${i.id}">
            <span class="patient__name">${i.name}</span>
            <span class="patient__checkbox" data-patient-id="${i.id}">
                <i class="patient__icon-check ri-check-line"></i>
            </span>
        </button>
        `);
    list.innerHTML = partientList;
}

});



parcelRegister("d3FqX", function(module, exports) {

$parcel$export(module.exports, "renderDobDropdowns", () => $981bb216f802563d$export$d0abee0c84674db7);

var $knjAn = parcelRequire("knjAn");
function $981bb216f802563d$export$d0abee0c84674db7(host, { inputId: inputId, idPrefix: idPrefix, onChange: onChange } = {}) {
    // Build month options using moment locale for localized names
    const months = moment.months();
    const monthOpts = months.map((m, i)=>`<option value="${i + 1}">${m}</option>`).join('');
    // Build day options (1-31, refined on month/year change)
    let dayOpts = '';
    for(let d = 1; d <= 31; d++)dayOpts += `<option value="${d}">${d}</option>`;
    // Build year options (current year down to 1920)
    const currentYear = new Date().getFullYear();
    let yearOpts = '';
    for(let y = currentYear; y >= 1920; y--)yearOpts += `<option value="${y}">${y}</option>`;
    host.innerHTML = `
        <input id="${inputId}" type="hidden">
        <label class="dob-dropdowns-label">${(0, $knjAn.t)('dob')}</label>
        <div class="dob-dropdowns">
            <select id="${idPrefix}Month" aria-label="${(0, $knjAn.t)('month')}">
                <option value="" disabled selected>${(0, $knjAn.t)('month')}</option>
                ${monthOpts}
            </select>
            <select id="${idPrefix}Day" aria-label="${(0, $knjAn.t)('day')}">
                <option value="" disabled selected>${(0, $knjAn.t)('day')}</option>
                ${dayOpts}
            </select>
            <select id="${idPrefix}Year" aria-label="${(0, $knjAn.t)('year')}">
                <option value="" disabled selected>${(0, $knjAn.t)('year')}</option>
                ${yearOpts}
            </select>
        </div>
    `;
    const monthEl = host.querySelector(`#${idPrefix}Month`);
    const dayEl = host.querySelector(`#${idPrefix}Day`);
    const yearEl = host.querySelector(`#${idPrefix}Year`);
    const hiddenInput = host.querySelector(`#${inputId}`);
    function updateDobValue() {
        const m = monthEl.value;
        const d = dayEl.value;
        const y = yearEl.value;
        if (m && d && y) // YYYY-MM-DD format for Laravel date validation
        hiddenInput.value = `${y}-${m.padStart(2, '0')}-${d.padStart(2, '0')}`;
        else hiddenInput.value = '';
        if (typeof onChange === 'function') onChange(hiddenInput.value);
    }
    // Adjust day options when month or year changes
    function adjustDays() {
        const m = parseInt(monthEl.value, 10);
        const y = parseInt(yearEl.value, 10) || currentYear;
        const maxDay = m ? new Date(y, m, 0).getDate() : 31;
        const prevDay = dayEl.value;
        let opts = '<option value="" disabled>Day</option>';
        for(let d = 1; d <= maxDay; d++)opts += `<option value="${d}"${d === parseInt(prevDay, 10) ? ' selected' : ''}>${d}</option>`;
        dayEl.innerHTML = opts;
        // If previously selected day exceeds new max, clear it
        if (parseInt(prevDay, 10) > maxDay) dayEl.value = '';
    }
    monthEl.addEventListener('change', ()=>{
        adjustDays();
        updateDobValue();
    });
    dayEl.addEventListener('change', updateDobValue);
    yearEl.addEventListener('change', ()=>{
        adjustDays();
        updateDobValue();
    });
}

});








parcelRegister("9ILu0", function(module, exports) {

$parcel$export(module.exports, "SELECTORS", () => $713d0e41dc085b5b$export$6d10441bd0a505b0);
$parcel$export(module.exports, "MESSAGES", () => $713d0e41dc085b5b$export$af7faffe10421f14);
$parcel$export(module.exports, "APPOINTMENT_STATUS", () => $713d0e41dc085b5b$export$991f3ee37398e50);
$parcel$export(module.exports, "PARTICIPANT_TYPES", () => $713d0e41dc085b5b$export$41f3f4f65e8f1e85);
$parcel$export(module.exports, "COLORS", () => $713d0e41dc085b5b$export$56d196d2844d1ca1);

var $knjAn = parcelRequire("knjAn");
const $713d0e41dc085b5b$export$6d10441bd0a505b0 = {
    container: '.appointment-confirmed__container',
    body: '.appointment-confirmed__body',
    card: '.appointment-confirmed__body .card',
    icon: '.appointment-confirmed__body .icon',
    checkIconWrapper: '.icon .custom-check-icon-wrapper',
    informationCard: '.appointment-confirmed__body .information .card',
    staffInfo: '.time-staff__info .staff__info',
    timeInfo: '.time-staff__info .time__info',
    dateInfo: '.date__info',
    actionDiv: '.card .action',
    appointmentButtons: '.appointment-confirm-single',
    title: '.appointment-confirmed__body .title',
    confirmBtn: '#confirm-appointment-btn',
    cancelLink: '#cancel-appointment-link',
    logo: '.appointment__logo',
    pendingBanner: '.pending-approval-banner',
    cancelledBanner: '.cancelled-appointment-banner'
};
const $713d0e41dc085b5b$export$af7faffe10421f14 = {
    errors: {
        get eventIdNotFound () {
            return (0, $knjAn.t)('error_event_id_not_found');
        },
        get locationUndefined () {
            return (0, $knjAn.t)('error_location_undefined');
        },
        get confirmFailed () {
            return (0, $knjAn.t)('confirm_appointment_failed');
        },
        get cancelFailed () {
            return (0, $knjAn.t)('cancel_failed');
        },
        get copyFailed () {
            return (0, $knjAn.t)('error_copy_failed');
        },
        get eventRoomUrlUnavailable () {
            return (0, $knjAn.t)('error_room_url_unavailable');
        },
        get invalidResponse () {
            return (0, $knjAn.t)('error_invalid_response');
        }
    },
    success: {
        get addressCopied () {
            return (0, $knjAn.t)('address_copied');
        },
        get confirmAppointment () {
            return (0, $knjAn.t)('confirm_appointment_success');
        },
        get cancelAppointment () {
            return (0, $knjAn.t)('cancel_success');
        }
    },
    confirmations: {
        get cancelAppointment () {
            return (0, $knjAn.t)('confirm_cancel_dialog');
        }
    },
    ui: {
        get processing () {
            return (0, $knjAn.t)('processing');
        },
        get confirm () {
            return (0, $knjAn.t)('confirmed');
        },
        get cancel () {
            return (0, $knjAn.t)('cancel');
        },
        get cancelled () {
            return (0, $knjAn.t)('cancelled');
        },
        get appointmentCancelled () {
            return (0, $knjAn.t)('appointment_cancelled_title');
        },
        get confirmAppointment () {
            return (0, $knjAn.t)('confirm_appointment_btn');
        }
    },
    banner: {
        get pendingApproval () {
            return (0, $knjAn.t)('pending_approval_title');
        },
        get pendingApprovalDescription () {
            return (0, $knjAn.t)('pending_approval_desc');
        },
        get cancelled () {
            return (0, $knjAn.t)('cancelled_banner_title');
        },
        get cancelledDescription () {
            return (0, $knjAn.t)('cancelled_banner_desc');
        }
    }
};
const $713d0e41dc085b5b$export$a97e04da196adedd = {
    confirm: {
        id: 'confirm-appointment-btn',
        className: 'button--no-style confirm-button confirm-button-large',
        get text () {
            return (0, $knjAn.t)('confirm_appointment_btn');
        },
        get loadingText () {
            return (0, $knjAn.t)('processing');
        },
        type: 'button'
    },
    cancel: {
        id: 'cancel-appointment-link',
        className: 'cancel-link',
        get text () {
            return (0, $knjAn.t)('cancel_appointment');
        },
        get loadingText () {
            return (0, $knjAn.t)('processing');
        },
        type: 'link'
    }
};
const $713d0e41dc085b5b$export$991f3ee37398e50 = {
    REQUEST: 'request',
    CONFIRMED: 'confirmed',
    COMPLETE: 'complete',
    CANCELLED: 'cancelled'
};
const $713d0e41dc085b5b$export$41f3f4f65e8f1e85 = {
    LEAD: 'App\\Models\\Lead',
    STAFF: 'App\\Models\\Staff'
};
const $713d0e41dc085b5b$export$3362bec89bce10fd = {
    OK: 200,
    CREATED: 201,
    BAD_REQUEST: 400,
    UNAUTHORIZED: 401,
    NOT_FOUND: 404,
    SERVER_ERROR: 500
};
const $713d0e41dc085b5b$export$56d196d2844d1ca1 = {
    error: '#e74c3c',
    success: '#11b654'
};
const $713d0e41dc085b5b$export$ff8a87d64aea7482 = {
    defaultToast: 3000,
    buttonReset: 2000
};

});


parcelRegister("5oy7H", function(module, exports) {

$parcel$export(module.exports, "addressCollectionListeners", () => $3ed9a9ce46309d25$export$b37f06f367b59db6);

var $knjAn = parcelRequire("knjAn");

var $jmDLz = parcelRequire("jmDLz");

var $alq6e = parcelRequire("alq6e");

var $cEKee = parcelRequire("cEKee");
function $3ed9a9ce46309d25$export$b37f06f367b59db6() {
    const container = document.querySelector('.address-collection__container');
    if (!container) return;
    const line1 = container.querySelector('#addressLine1');
    const city = container.querySelector('#addressCity');
    const state = container.querySelector('#addressState');
    const zip = container.querySelector('#addressZip');
    const btn = container.querySelector('.address-collection__btn');
    function validate() {
        const valid = line1.value.trim() && city.value.trim() && state.value.trim() && zip.value.trim();
        btn.classList.toggle('disabled', !valid);
    }
    [
        line1,
        city,
        state,
        zip,
        container.querySelector('#addressLine2')
    ].forEach((el)=>{
        if (el) el.addEventListener('input', validate);
    });
    btn.addEventListener('click', async ()=>{
        if (btn.classList.contains('disabled')) return;
        btn.classList.add('disabled');
        btn.textContent = (0, $knjAn.t)('saving');
        const addressData = {
            address1: line1.value.trim(),
            address2: (container.querySelector('#addressLine2')?.value || '').trim(),
            city: city.value.trim(),
            state: state.value.trim(),
            zip: zip.value.trim()
        };
        try {
            await (0, $jmDLz.updateLeadPortal)((0, $cEKee.leadInfo).text_id, addressData);
            // Create + book the appointment only now that address is captured, so the
            // booking cannot be completed without it. appointmentItemsClickEventHandler
            // handles the create → deposit/confirm flow (see selectTimeActions.js).
            await (0, $alq6e.appointmentItemsClickEventHandler)((0, $cEKee.selectedAppointmentUnixTime), addressData);
        } catch (e) {
            btn.classList.remove('disabled');
            btn.textContent = (0, $knjAn.t)('continue');
        }
    });
}

});

parcelRegister("bUtOS", function(module, exports) {

$parcel$export(module.exports, "loadAppointmentRescheduleReason", () => $8abc0e36f67425a2$export$b583f82473a7139);

var $45fvw = parcelRequire("45fvw");

var $knjAn = parcelRequire("knjAn");

var $er9E0 = parcelRequire("er9E0");

var $cEKee = parcelRequire("cEKee");

var $cNdCr = parcelRequire("cNdCr");

var $ctM9Q = parcelRequire("ctM9Q");

var $62LVp = parcelRequire("62LVp");
let $8abc0e36f67425a2$var$newStartTime = null;
let $8abc0e36f67425a2$var$newEndTime = null;
async function $8abc0e36f67425a2$export$b583f82473a7139(startTime, endTime) {
    if (!(0, $cEKee.eventPayload)) return;
    $8abc0e36f67425a2$var$newStartTime = startTime;
    $8abc0e36f67425a2$var$newEndTime = endTime;
    (0, $cNdCr.primeRescheduleSignatureParams)();
    $8abc0e36f67425a2$var$initializeStyles();
    $8abc0e36f67425a2$var$setBusinessLogo();
    $8abc0e36f67425a2$var$setClientPortalSignInLink();
    $8abc0e36f67425a2$var$renderAppointmentInfo();
    $8abc0e36f67425a2$var$showRescheduleReasonForm();
}
function $8abc0e36f67425a2$var$initializeStyles() {
    const informationCard = document.querySelector('.appointment-reschedule-reason__container .appointment-reschedule-reason__datetime-section .card');
    if (informationCard) informationCard.style.backgroundColor = 'transparent';
}
function $8abc0e36f67425a2$var$getClientPortalUrl() {
    const fromBackend = (0, $cEKee.form)?.data?.client_portal_url;
    if (fromBackend) return fromBackend;
    const base = (0, $cEKee.form)?.data?.dashboard_base_url || (0, $cEKee.form)?.project?.client_portal_base_url || (0, $cEKee.form)?.project?.dashboard_base_url || window.location.origin;
    const baseClean = String(base).replace(/\/$/, '');
    const projectUuid = (0, $cEKee.form)?.project?.uuid;
    return projectUuid ? `${baseClean}/client/portal/${projectUuid}` : `${baseClean}/client/portal`;
}
function $8abc0e36f67425a2$var$setClientPortalSignInLink() {
    const link = document.getElementById('header-sign-in-client-portal-reschedule');
    if (!link) return;
    link.setAttribute('href', $8abc0e36f67425a2$var$getClientPortalUrl());
    link.setAttribute('target', '_blank');
    link.setAttribute('rel', 'noopener noreferrer');
}
function $8abc0e36f67425a2$var$setBusinessLogo() {
    if ((0, $cEKee.form)?.project?.business_photo) document.querySelector('.appointment-reschedule-reason__container .appointment__logo')?.setAttribute('src', (0, $cEKee.form).project.business_photo);
}
function $8abc0e36f67425a2$var$renderAppointmentInfo() {
    const currentStartTime = parseInt((0, $cEKee.eventPayload).start_time);
    const staffName = $8abc0e36f67425a2$var$getStaffName();
    const currentDetailsElement = document.querySelector('.appointment-reschedule-reason__container .current-details');
    if (currentDetailsElement) {
        const currentDate = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(currentStartTime * 1000).format('dddd, MMMM DD, YYYY');
        const currentTime = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(currentStartTime * 1000).format('h:mm A');
        currentDetailsElement.innerHTML = `
            ${currentDate} at ${currentTime}<br>
            with ${staffName}
        `;
    }
    const newDetailsElement = document.querySelector('.appointment-reschedule-reason__container .new-details');
    if (newDetailsElement && $8abc0e36f67425a2$var$newStartTime) {
        const newDate = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))($8abc0e36f67425a2$var$newStartTime * 1000).format('dddd, MMMM DD, YYYY');
        const newTime = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))($8abc0e36f67425a2$var$newStartTime * 1000).format('h:mm A');
        newDetailsElement.innerHTML = `
            ${newDate} at ${newTime}<br>
            with ${staffName}
        `;
    }
}
function $8abc0e36f67425a2$var$getStaffName() {
    if ((0, $cEKee.eventPayload).participants && (0, $cEKee.eventPayload).participants.length > 0 && (0, $er9E0.params)('event_id')) {
        const participant = (0, $cEKee.eventPayload).participants.find((i)=>i.participable_type === 'App\\Models\\Staff');
        return participant ? `${participant.participable.first_name} ${participant.participable.last_name}` : '';
    }
    return (0, $62LVp.getProviderFullName)((0, $cEKee.eventPayload).staff);
}
function $8abc0e36f67425a2$var$showRescheduleReasonForm() {
    const actionDiv = document.querySelector('.appointment-reschedule-reason__container .action');
    if (!actionDiv) return;
    const formHtml = `
        <div class="reschedule-reason-form">
            <div class="reschedule-reason-form__header">
                <h3>${(0, $knjAn.t)('why_rescheduling')} <span class="required">*</span></h3>
            </div>
            <div class="reschedule-reason-form__reasons">
                <button type="button" class="reason-btn" data-reason="Schedule conflict">${(0, $knjAn.t)('reschedule_reason_conflict')}</button>
                <button type="button" class="reason-btn" data-reason="Emergency">${(0, $knjAn.t)('reschedule_reason_emergency')}</button>
                <button type="button" class="reason-btn" data-reason="Personal reasons">${(0, $knjAn.t)('reschedule_reason_personal')}</button>
            </div>
            <div class="reschedule-reason-form__textarea">
                <textarea
                    id="reschedule-reason-textarea"
                    placeholder="${(0, $knjAn.t)('reschedule_reason_placeholder')}"
                    maxlength="500"
                    rows="4"
                    required
                ></textarea>
            </div>
            <div class="reschedule-reason-form__actions">
                <button type="button" id="confirm-reschedule-btn" class="confirm-reschedule-btn" disabled>
                    ${(0, $knjAn.t)('confirm_reschedule')}
                </button>
            </div>
        </div>
    `;
    actionDiv.innerHTML = formHtml;
    if (typeof feather !== 'undefined') feather.replace();
    $8abc0e36f67425a2$var$setupRescheduleReasonFormListeners();
}
function $8abc0e36f67425a2$var$setupRescheduleReasonFormListeners() {
    const textarea = document.getElementById('reschedule-reason-textarea');
    const confirmBtn = document.getElementById('confirm-reschedule-btn');
    const reasonBtns = document.querySelectorAll('.reason-btn');
    if (textarea) textarea.addEventListener('input', function() {
        const length = this.value.length;
        if (confirmBtn) confirmBtn.disabled = length < 10;
    });
    reasonBtns.forEach((btn)=>{
        btn.addEventListener('click', function() {
            reasonBtns.forEach((b)=>b.classList.remove('active'));
            this.classList.add('active');
            if (textarea) {
                const reason = this.getAttribute('data-reason');
                textarea.value = reason;
                if (confirmBtn) confirmBtn.disabled = false;
            }
        });
    });
    if (confirmBtn) confirmBtn.addEventListener('click', $8abc0e36f67425a2$var$handleConfirmReschedule);
}
async function $8abc0e36f67425a2$var$handleConfirmReschedule() {
    const textarea = document.getElementById('reschedule-reason-textarea');
    const confirmBtn = document.getElementById('confirm-reschedule-btn');
    if (!textarea || !textarea.value.trim()) {
        (0, $ctM9Q.toastError)((0, $knjAn.t)('reschedule_provide_reason'));
        return;
    }
    const isPredefinedReason = document.querySelector('.reason-btn.active') !== null;
    if (!isPredefinedReason && textarea.value.trim().length < 10) {
        (0, $ctM9Q.toastError)((0, $knjAn.t)('reschedule_min_chars'));
        return;
    }
    try {
        if (confirmBtn) {
            confirmBtn.disabled = true;
            confirmBtn.innerHTML = (0, $knjAn.t)('processing');
        }
        const eventId = (0, $er9E0.params)('event_id');
        if (!eventId) throw new Error('Event ID not found');
        const response = await (0, $cNdCr.rescheduleAppointment)(eventId, {
            start_time: $8abc0e36f67425a2$var$newStartTime,
            end_time: $8abc0e36f67425a2$var$newEndTime,
            reason: textarea.value.trim()
        });
        if (response && response.status === 200) {
            (0, $ctM9Q.toastSuccess)((0, $knjAn.t)('reschedule_success'));
            setTimeout(()=>{
                const cleanUrl = `${response.data.navigation.frontend_url}?form_id=${response.data.navigation.url_params.form_id}&event_id=${response.data.navigation.url_params.event_id}`;
                try {
                    if (new URL(cleanUrl).origin === window.location.origin) window.history.replaceState({}, '', cleanUrl);
                } catch (_) {
                // replaceState only allowed for same-origin URL; skip if frontend_url is different origin (e.g. widget vs assistant iframe)
                }
                window.location.replace(cleanUrl);
                if (window.parent !== window.self) window.parent.location.replace(cleanUrl);
            }, 1500);
        } else throw new Error('Failed to reschedule appointment');
    } catch (error) {
        (0, $ctM9Q.toastError)((0, $knjAn.t)('reschedule_failed'));
        if (confirmBtn) {
            confirmBtn.disabled = false;
            confirmBtn.innerHTML = (0, $knjAn.t)('confirm_reschedule');
        }
    }
}

});

parcelRegister("6oS6b", function(module, exports) {

$parcel$export(module.exports, "appointmentRescheduleReasonListeners", () => $4a8ef2dc28c4c626$export$1b43310b0a44b327);
function $4a8ef2dc28c4c626$export$1b43310b0a44b327() {}

});


parcelRegister("6jZoE", function(module, exports) {

$parcel$export(module.exports, "loadLanguageDropdown", () => $49a424808dcee569$export$6279be5798877ea);
$parcel$export(module.exports, "loadLanguageDropdownVerify", () => $49a424808dcee569$export$2660dee1bbb63dd3);
$parcel$export(module.exports, "getLanguageId", () => $49a424808dcee569$export$6adf9b057a2a1827);

var $cEKee = parcelRequire("cEKee");

var $knjAn = parcelRequire("knjAn");
const $49a424808dcee569$var$LANGUAGES = [
    {
        id: 'en',
        get name () {
            return (0, $knjAn.t)('language_english');
        }
    },
    {
        id: 'es',
        get name () {
            return (0, $knjAn.t)('language_spanish');
        }
    }
];
class $49a424808dcee569$export$f397a346e9b493ee {
    constructor(config){
        this.config = {
            containerSelector: config.containerSelector,
            inputId: config.inputId,
            dataForm: config.dataForm,
            wrapperId: config.wrapperId,
            downArrowId: config.downArrowId,
            upArrowId: config.upArrowId,
            onSelectionChange: config.onSelectionChange || null,
            initialValue: config.initialValue || null
        };
        this.hasUserInteracted = false;
        this.selectedLanguage = null;
        this.init();
    }
    init() {
        this.createHTML();
        this.setupEventListeners();
        this.populateOptions();
        this.setInitialValue();
        this.resetValidationState();
    }
    createHTML() {
        const container = document.querySelector(this.config.containerSelector);
        if (!container) return;
        container.innerHTML = this.getHTMLTemplate();
    }
    getHTMLTemplate() {
        return `
            <div data-form="${this.config.dataForm}" class="languageDropdown__wrapper dropdown form-control" id="${this.config.wrapperId}">
                <input id="${this.config.inputId}" autocomplete="off" placeholder="${(0, $knjAn.t)('select_language')}" readonly>
                <span class="down-arrow arrow" id="${this.config.downArrowId}">
                    <i class="ri-arrow-down-s-line"></i>
                </span>
                <span class="up-arrow arrow" id="${this.config.upArrowId}">
                    <i class="ri-arrow-up-s-line"></i>
                </span>
                <div class="languageDropdown__select">
                    <ul class="languages__select">
                    </ul>
                </div>
            </div>
        `;
    }
    populateOptions() {
        const list = this.getOptionsList();
        if (!list) return;
        list.innerHTML = '';
        $49a424808dcee569$var$LANGUAGES.forEach((lang)=>{
            const option = document.createElement('li');
            option.className = 'languageDropdown__option';
            option.setAttribute('data-language-id', lang.id);
            option.setAttribute('data-language', lang.name);
            option.textContent = lang.name;
            option.addEventListener('click', ()=>this.selectLanguage(lang.id, lang.name));
            list.appendChild(option);
        });
    }
    setupEventListeners() {
        const input = this.getInput();
        const downArrow = this.getDownArrow();
        const upArrow = this.getUpArrow();
        if (input) {
            input.addEventListener('click', ()=>this.toggle());
            input.addEventListener('keydown', (e)=>this.handleKeydown(e));
        }
        if (downArrow) downArrow.addEventListener('click', ()=>this.toggle());
        if (upArrow) upArrow.addEventListener('click', ()=>this.close());
        document.addEventListener('click', (e)=>this.handleOutsideClick(e));
    }
    handleKeydown(e) {
        switch(e.key){
            case 'Enter':
            case ' ':
                e.preventDefault();
                this.toggle();
                break;
            case 'Escape':
                this.close();
                break;
            case 'ArrowDown':
                e.preventDefault();
                this.open();
                break;
            case 'ArrowUp':
                e.preventDefault();
                this.close();
                break;
        }
    }
    handleOutsideClick(e) {
        const wrapper = this.getWrapper();
        if (wrapper && !wrapper.contains(e.target)) this.close();
    }
    open() {
        const wrapper = this.getWrapper();
        if (wrapper) wrapper.classList.add('open');
    }
    close() {
        const wrapper = this.getWrapper();
        if (wrapper) {
            wrapper.classList.remove('open');
            this.syncUIState();
        }
    }
    toggle() {
        const wrapper = this.getWrapper();
        if (wrapper) {
            if (wrapper.classList.contains('open')) this.close();
            else this.open();
        }
    }
    selectLanguage(id, name) {
        this.hasUserInteracted = true;
        this.selectedLanguage = {
            id: id,
            name: name
        };
        const input = this.getInput();
        if (input) input.value = name;
        (0, $cEKee.setSelectedLanguage)(id);
        this.updateUIState(true);
        this.close();
        if (this.config.onSelectionChange) this.config.onSelectionChange(id, name);
    }
    clearSelection() {
        this.selectedLanguage = null;
        const input = this.getInput();
        if (input) input.value = '';
        (0, $cEKee.setSelectedLanguage)('');
        this.updateUIState(false);
    }
    updateUIState(isSelected) {
        const wrapper = this.getWrapper();
        const formItem = this.getFormItem();
        if (wrapper) {
            if (isSelected) wrapper.classList.add('selected');
            else wrapper.classList.remove('selected');
        }
        if (this.hasUserInteracted) {
            if (formItem) {
                if (isSelected) formItem.classList.remove('invalid');
                else formItem.classList.add('invalid');
            }
        }
    }
    syncUIState() {
        const input = this.getInput();
        if (!input) return;
        if (this.selectedLanguage) {
            // Re-derive the display name from the current language so it stays in sync
            // after the user picks a language (lang.name getter calls t() dynamically)
            const currentName = $49a424808dcee569$var$LANGUAGES.find((l)=>l.id === this.selectedLanguage.id)?.name || '';
            input.value = currentName;
            this.updateUIState(true);
        } else if (input.value.trim() === '') {
            const wrapper = this.getWrapper();
            if (wrapper) wrapper.classList.remove('selected');
        } else this.clearSelection();
    }
    isValidLanguage(languageName) {
        return $49a424808dcee569$var$LANGUAGES.some((lang)=>lang.name === languageName);
    }
    getWrapper() {
        return document.querySelector(`${this.config.containerSelector} .languageDropdown__wrapper`);
    }
    getInput() {
        return document.getElementById(this.config.inputId);
    }
    getDownArrow() {
        return document.getElementById(this.config.downArrowId);
    }
    getUpArrow() {
        return document.getElementById(this.config.upArrowId);
    }
    getOptionsList() {
        return document.querySelector(`${this.config.containerSelector} .languages__select`);
    }
    getFormItem() {
        const wrapper = this.getWrapper();
        return wrapper ? wrapper.closest('[data-form]') : null;
    }
    setInitialValue() {
        if (this.config.initialValue) {
            const language = $49a424808dcee569$var$LANGUAGES.find((lang)=>lang.id === this.config.initialValue || lang.name === this.config.initialValue);
            if (language) this.selectLanguage(language.id, language.name);
        }
    }
    resetValidationState() {
        const formItem = this.getFormItem();
        if (formItem) formItem.classList.remove('invalid');
    }
}
function $49a424808dcee569$export$6279be5798877ea() {
    return new $49a424808dcee569$export$f397a346e9b493ee({
        containerSelector: '.requestConsult__container .language__dropdown',
        inputId: 'languageConsult',
        dataForm: 'languageConsult',
        wrapperId: 'language-wrapper',
        downArrowId: 'languageConsultDownArrow',
        upArrowId: 'languageConsultUpArrow'
    });
}
function $49a424808dcee569$export$2660dee1bbb63dd3(leadLanguage = null) {
    return new $49a424808dcee569$export$f397a346e9b493ee({
        containerSelector: '.verifyInformation__container .language__dropdown-verify',
        inputId: 'languageVerify',
        dataForm: 'languageVerify',
        wrapperId: 'language-wrapper-verify',
        downArrowId: 'languageVerifyDownArrow',
        upArrowId: 'languageVerifyUpArrow',
        initialValue: leadLanguage
    });
}
function $49a424808dcee569$export$50f85bef7146a9ac(languageValue) {
    return $49a424808dcee569$var$LANGUAGES.some((lang)=>lang.name === languageValue);
}
function $49a424808dcee569$export$6adf9b057a2a1827(languageName) {
    const language = $49a424808dcee569$var$LANGUAGES.find((lang)=>lang.name === languageName);
    return language ? language.id : null;
}

});

parcelRegister("cFczh", function(module, exports) {

$parcel$export(module.exports, "urlPrefill", () => $938310233f14963e$export$3df0d81e8e234078);
$parcel$export(module.exports, "applyLeadPrefillDefaults", () => $938310233f14963e$export$adacfdad64df5796);
/**
 * Contact prefill from URL query params — lets marketing pages (e.g.
 * kloudmd.com/get-started) hand off a visitor's name/email so they don't
 * retype them in the widget.
 *
 * Supported params: `full_name` (split on whitespace into first/last),
 * or explicit `first_name` / `last_name`, plus `email`.
 *
 * These are visitor-typed values arriving via an attacker-controllable URL,
 * so they are length-capped and stripped of HTML-significant characters here,
 * and must still only be applied via `input.value =` or escaped interpolation
 * — never raw innerHTML.
 *
 * Note: the same param names double as lead-CREATION inputs on the photo
 * upload-link flow (`&upload=` in widget.js). That flow is unaffected — this
 * module only reads.
 */ const $938310233f14963e$var$clean = (v)=>{
    v = String(v || '').replace(/[<>"'&`]/g, '').trim();
    return v.length > 120 ? '' : v;
};
const $938310233f14963e$var$search = (window.location.search || '').replace(/^\?+/, '?');
const $938310233f14963e$var$q = new URLSearchParams($938310233f14963e$var$search);
let $938310233f14963e$var$first = $938310233f14963e$var$clean($938310233f14963e$var$q.get('first_name'));
let $938310233f14963e$var$last = $938310233f14963e$var$clean($938310233f14963e$var$q.get('last_name'));
if (!$938310233f14963e$var$first && !$938310233f14963e$var$last) {
    const full = $938310233f14963e$var$clean($938310233f14963e$var$q.get('full_name')).split(/\s+/).filter(Boolean);
    $938310233f14963e$var$first = full.shift() || '';
    $938310233f14963e$var$last = full.join(' ');
}
const $938310233f14963e$var$email = $938310233f14963e$var$clean($938310233f14963e$var$q.get('email'));
const $938310233f14963e$export$3df0d81e8e234078 = {
    first_name: $938310233f14963e$var$first,
    last_name: $938310233f14963e$var$last,
    email: $938310233f14963e$var$email,
    full_name: [
        $938310233f14963e$var$first,
        $938310233f14963e$var$last
    ].filter(Boolean).join(' ')
};
function $938310233f14963e$export$adacfdad64df5796(lead) {
    const out = {
        ...lead || {}
    };
    // Name is all-or-nothing: don't graft a URL last_name onto a server first_name.
    if (!out.first_name && !out.last_name && $938310233f14963e$export$3df0d81e8e234078.first_name) {
        out.first_name = $938310233f14963e$export$3df0d81e8e234078.first_name;
        if ($938310233f14963e$export$3df0d81e8e234078.last_name) out.last_name = $938310233f14963e$export$3df0d81e8e234078.last_name;
    }
    if (!out.email && $938310233f14963e$export$3df0d81e8e234078.email) out.email = $938310233f14963e$export$3df0d81e8e234078.email;
    return out;
}

});



parcelRegister("5r2Yt", function(module, exports) {

$parcel$export(module.exports, "checkboxQuestionListener", () => $3f51c8026e477804$export$5f5ee3ed3cc51828);

var $hWSV7 = parcelRequire("hWSV7");

var $knjAn = parcelRequire("knjAn");

var $cEKee = parcelRequire("cEKee");

var $gZEOs = parcelRequire("gZEOs");

var $9bGUq = parcelRequire("9bGUq");

var $8ZTdz = parcelRequire("8ZTdz");

var $62Jhk = parcelRequire("62Jhk");

var $er9E0 = parcelRequire("er9E0");

var $1BMUZ = parcelRequire("1BMUZ");

var $l4WR9 = parcelRequire("l4WR9");

var $5fptp = parcelRequire("5fptp");

var $cXbcK = parcelRequire("cXbcK");

var $87Cn1 = parcelRequire("87Cn1");

var $gMDh6 = parcelRequire("gMDh6");

var $cIxq8 = parcelRequire("cIxq8");

var $2q2gk = parcelRequire("2q2gk");
function $3f51c8026e477804$export$5f5ee3ed3cc51828() {
    const fieldId = (0, $cEKee.nameScreenDynamic).split('--')[1];
    const previousAnswer = (0, $cEKee.listDataQuestion)[fieldId];
    var radios = document.querySelectorAll(`${(0, $cEKee.nameScreenDynamic)} #checkbox`);
    let val = '';
    // If the user previously answered this question (yes=1 or no=0), pre-check
    // the matching radio and seed `val` from the stored answer. Without this,
    // navigating Back → Forward re-renders the radios in an unselected state
    // while leaving the Continue button enabled; clicking Continue without
    // re-selecting silently overwrote the answer with 0 ("No") because `val`
    // was '' and `storedVal = val === 'yes' ? 1 : 0` defaults to 0.
    // Use `!== undefined` so a stored 0 ("No") also restores correctly.
    if (previousAnswer !== undefined) {
        const yesRadio = document.querySelector(`${(0, $cEKee.nameScreenDynamic)} #checkbox[value="yes"]`);
        const noRadio = document.querySelector(`${(0, $cEKee.nameScreenDynamic)} #checkbox[value="no"]`);
        if (previousAnswer === 1 && yesRadio) {
            yesRadio.checked = true;
            val = 'yes';
        } else if (previousAnswer === 0 && noRadio) {
            noRadio.checked = true;
            val = 'no';
        }
        if (val !== '') {
            document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .checkboxContinue__btn`)?.classList.remove('disabled');
            document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .checkboxContinue__btn .loading__wrapper`)?.classList.add('hidden');
            const loaderIcon = document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .loader__icon`);
            if (loaderIcon) {
                loaderIcon.innerHTML = '';
                loaderIcon.insertAdjacentHTML('beforeend', `<i class="ri-arrow-right-line"></i>`);
            }
        }
    }
    for(var i = 0, max = radios.length; i < max; i++)radios[i].onclick = function() {
        if (this.value) {
            val = this.value;
            document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .checkboxContinue__btn`).classList.remove('disabled');
        } else {
            val = this.value;
            document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .checkboxContinue__btn`).classList.add('disabled');
        }
    };
    /* On click Back button */ document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .checkboxQuestionBack__btn`)?.addEventListener('click', ()=>{
        const idx = (0, $cEKee.listNamePageQuestion).findIndex((l)=>l === (0, $cEKee.nameScreenDynamic));
        if (idx > 0) {
            (0, $er9E0.customFeildGoBackAnimationHandler)(`${(0, $cEKee.nameScreenDynamic)}`);
            (0, $cEKee.setProgressQuestion)({
                ...(0, $cEKee.progressQuestion),
                currentQuestion: (0, $cEKee.progressQuestion).currentQuestion - 1,
                progress: ((0, $cEKee.progressQuestion).currentQuestion - 1) / (0, $cEKee.progressQuestion).total * 100
            });
            (0, $cEKee.setNameScreenDynamic)((0, $cEKee.listNamePageQuestion)[idx - 1]);
            if ((0, $cEKee.nameScreenDynamic).includes('text') && !(0, $cEKee.nameScreenDynamic).includes('textarea')) (0, $cXbcK.textQuestionListener)();
            else if ((0, $cEKee.nameScreenDynamic).includes('checkbox')) $3f51c8026e477804$export$5f5ee3ed3cc51828();
            else if ((0, $cEKee.nameScreenDynamic).includes('select')) (0, $l4WR9.selectQuestionListener)();
            else if ((0, $cEKee.nameScreenDynamic).includes('date')) (0, $8ZTdz.dateQuestionListener)();
            else if ((0, $cEKee.nameScreenDynamic).includes('textarea')) (0, $5fptp.textAreaQuestonListener)();
            else if ((0, $cEKee.nameScreenDynamic).includes('number')) (0, $1BMUZ.numberQuestionListener)();
            else if ((0, $cEKee.nameScreenDynamic).includes('height')) (0, $62Jhk.heightQuestionListener)();
        } else (0, $er9E0.customFeildGoBackAnimationHandler)(`${(0, $cEKee.nameScreenDynamic)}`);
    });
    /* On click enter */ const screenCheckbox = document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .screen--checkbox`);
    if (screenCheckbox) screenCheckbox.addEventListener('keydown', (event)=>{
        if (event.key === 'Enter' && !document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .checkboxContinue__btn`).classList.contains('disabled')) document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .checkboxContinue__btn`).click();
    });
    // on click continue button
    const buttonCheckboxContinue = document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .checkboxContinue__btn`);
    buttonCheckboxContinue.addEventListener('click', async function() {
        if (!(0, $cEKee.listNamePageQuestion).find((list)=>list === (0, $cEKee.nameScreenDynamic))) (0, $cEKee.listNamePageQuestion).push((0, $cEKee.nameScreenDynamic));
        (0, $cEKee.setListNamePageQuestion)((0, $cEKee.listNamePageQuestion));
        document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .checkboxContinue__btn`).classList.add('disabled');
        document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .checkboxContinue__btn .loading__wrapper`)?.classList.remove('hidden');
        const loaderIcon = document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .loader__icon`);
        if (loaderIcon) {
            loaderIcon.innerHTML = '';
            loaderIcon.insertAdjacentHTML('beforeend', `<img src="${(0, $cEKee.appUrl)}/assets/icons/rolling.png" />`);
        }
        const item = (0, $cEKee.nameScreenDynamic).split('--')[1];
        const storedVal = val === 'yes' ? 1 : 0;
        const answersWithCurrent = {
            ...(0, $cEKee.listDataQuestion),
            [item]: storedVal
        };
        (0, $cEKee.listDataQuestion)[item] = storedVal;
        (0, $cEKee.setListDataQuestion)((0, $cEKee.listDataQuestion));
        const fields = (0, $cEKee.questionnaireFields)?.length ? (0, $cEKee.questionnaireFields) : (0, $cEKee.form)?.form?.custom_fields ?? [];
        const currentField = fields.find((f)=>f && f.id == item);
        const minDisqualifiers = (0, $cEKee.form)?.appointment_channel?.min_disqualifier_matches ?? (0, $cEKee.form)?.consult_min_disqualifier_matches ?? 1;
        if (currentField && (0, $gMDh6.evaluateDisqualifier)(currentField, storedVal) && (0, $gMDh6.shouldDisqualifyNow)(fields, answersWithCurrent, minDisqualifiers)) {
            try {
                const fieldLabels = {};
                const sourceFields = (0, $cEKee.questionnaireFields)?.length ? (0, $cEKee.questionnaireFields) : (0, $cEKee.form)?.form?.custom_fields ?? [];
                sourceFields.forEach((f)=>{
                    if (f && f.id) fieldLabels[f.id] = f.label || f.title || (0, $knjAn.t)('custom_field');
                });
                const formId = (0, $cEKee.questionnaireFormId) ?? (0, $cEKee.form)?.form?.id;
                if (typeof formId === 'string' && formId.startsWith('ac-')) {
                    const acId = parseInt(formId.replace(/^ac-/, ''), 10);
                    await (0, $hWSV7.updateQualificationResponses)((0, $cEKee.leadTextId), acId, (0, $cEKee.listDataQuestion), fieldLabels);
                } else await (0, $hWSV7.updateConsultRequestFields)((0, $cEKee.leadTextId), (0, $cEKee.listDataQuestion), fieldLabels);
            } catch (_) {}
            if ((0, $cEKee.leadInfo)?.id) {
                await (0, $2q2gk.updateLeadStep)((0, $cEKee.leadInfo).id, 'disqualified', 'true');
                (0, $er9E0.setSessionEndStepSentForLeadId)((0, $cEKee.leadInfo).id);
            }
            document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .checkboxContinue__btn`)?.classList.remove('disabled');
            document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .checkboxContinue__btn .loading__wrapper`)?.classList.add('hidden');
            const loaderIcon = document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .checkboxContinue__btn .loader__icon`);
            if (loaderIcon) {
                loaderIcon.innerHTML = '';
                loaderIcon.insertAdjacentHTML('beforeend', '<i class="ri-arrow-right-line"></i>');
            }
            (0, $9bGUq.clearCustomFields)();
            (0, $cEKee.clearQuestionnaireContext)();
            (0, $er9E0.setIsDisqualified)(true);
            (0, $er9E0.navigate)((0, $cIxq8.SCREEN).THE_END);
            return;
        }
        const formId = (0, $cEKee.questionnaireFormId) ?? (0, $cEKee.form)?.form?.id;
        let idx = fields.findIndex((custom)=>custom && custom.id == (0, $cEKee.nameScreenDynamic).split('--')[1]);
        if (idx == fields.length - 1) try {
            const fieldLabels = {};
            const sourceFields = (0, $cEKee.questionnaireFields)?.length ? (0, $cEKee.questionnaireFields) : (0, $cEKee.form)?.form?.custom_fields ?? [];
            sourceFields.forEach((f)=>{
                if (f && f.id) fieldLabels[f.id] = f.label || f.title || (0, $knjAn.t)('custom_field');
            });
            if (typeof formId === 'string' && formId.startsWith('ac-')) {
                const acId = parseInt(formId.replace(/^ac-/, ''), 10);
                await (0, $hWSV7.updateQualificationResponses)((0, $cEKee.leadTextId), acId, (0, $cEKee.listDataQuestion), fieldLabels);
            } else await (0, $hWSV7.updateConsultRequestFields)((0, $cEKee.leadTextId), (0, $cEKee.listDataQuestion), fieldLabels);
            if (document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .checkboxContinue__btn`)) document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .checkboxContinue__btn`)?.classList.remove('disabled');
            document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .checkboxContinue__btn .loading__wrapper`)?.classList.add('hidden');
            const loaderIcon = document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .loader__icon`);
            if (loaderIcon) {
                loaderIcon.innerHTML = '';
                loaderIcon.insertAdjacentHTML('beforeend', `<i class="ri-arrow-right-line"></i>`);
            }
            (0, $9bGUq.clearCustomFields)();
            (0, $cEKee.clearQuestionnaireContext)();
            (0, $87Cn1.navigateToNextPage)();
        } catch (error) {
            (0, $gZEOs.toastError)(error.response?.data?.message);
        }
        else {
            (0, $cEKee.setProgressQuestion)({
                ...(0, $cEKee.progressQuestion),
                currentQuestion: (0, $cEKee.progressQuestion).currentQuestion + 1,
                progress: ((0, $cEKee.progressQuestion).currentQuestion + 1) / (0, $cEKee.progressQuestion).total * 100
            });
            (0, $9bGUq.loadCustomFields)(fields[idx + 1]);
        }
    });
}

});
parcelRegister("8ZTdz", function(module, exports) {

$parcel$export(module.exports, "dateQuestionListener", () => $68ceda619868d27c$export$908d9d6226c9e96c);

var $hWSV7 = parcelRequire("hWSV7");

var $knjAn = parcelRequire("knjAn");

var $cEKee = parcelRequire("cEKee");

var $gZEOs = parcelRequire("gZEOs");

var $9bGUq = parcelRequire("9bGUq");

var $5r2Yt = parcelRequire("5r2Yt");

var $62Jhk = parcelRequire("62Jhk");

var $er9E0 = parcelRequire("er9E0");

var $1BMUZ = parcelRequire("1BMUZ");

var $l4WR9 = parcelRequire("l4WR9");

var $5fptp = parcelRequire("5fptp");

var $cXbcK = parcelRequire("cXbcK");

var $87Cn1 = parcelRequire("87Cn1");
function $68ceda619868d27c$export$908d9d6226c9e96c() {
    let datepicker = flatpickr(`${(0, $cEKee.nameScreenDynamic)} #questionDatepicker--${(0, $cEKee.nameScreenDynamic).replace('.', '')}`, {
        maxDate: 'today',
        dateFormat: 'Y-m-d',
        altInput: true,
        altFormat: 'm/d/Y'
    });
    // check has data
    if ((0, $cEKee.listNamePageQuestion).find((name)=>name === (0, $cEKee.nameScreenDynamic)) && (0, $cEKee.listDataQuestion)[(0, $cEKee.nameScreenDynamic).split('--')[1]]) {
        const value = document.querySelector(`${(0, $cEKee.nameScreenDynamic)} #questionDatepicker--${(0, $cEKee.nameScreenDynamic).replace('.', '')}`);
        if (value) value.value = (0, $cEKee.listDataQuestion)[(0, $cEKee.nameScreenDynamic).split('--')[1]];
        setTimeout(()=>{
            const dateQuestionInput = document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .dateQuestion--input.form-control.input`);
            if (dateQuestionInput !== document.activeElement) dateQuestionInput.focus();
        }, 500);
        document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .dateQuestionContinue__btn`)?.classList.remove('disabled');
        document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .dateQuestionContinue__btn .loading__wrapper`)?.classList.add('hidden');
        const loaderIcon = document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .loader__icon`);
        if (loaderIcon) {
            loaderIcon.innerHTML = '';
            loaderIcon.insertAdjacentHTML('beforeend', `<i class="ri-arrow-right-line"></i>`);
        }
        return;
    }
    document.querySelector(`${(0, $cEKee.nameScreenDynamic)} #questionDatepicker--${(0, $cEKee.nameScreenDynamic).replace('.', '')}`).addEventListener('change', function() {
        if (document.querySelector(`${(0, $cEKee.nameScreenDynamic)} #questionDatepicker--${(0, $cEKee.nameScreenDynamic).replace('.', '')}`).value) document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .dateQuestionContinue__btn`).classList.remove('disabled');
        else document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .dateQuestionContinue__btn`).classList.add('disabled');
    });
    /* On click Back button */ document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .dateQuestionBack__btn`)?.addEventListener('click', $68ceda619868d27c$var$handleClickBackDateQuestion);
    /* On click enter */ const screenDate = document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .screen--date`);
    if (screenDate) screenDate.addEventListener('keydown', (event)=>{
        if (event.key === 'Enter' && !document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .dateQuestionContinue__btn`).classList.contains('disabled')) document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .dateQuestionContinue__btn`).click();
    });
    /* on click Continue after select date */ document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .dateQuestionContinue__btn`).addEventListener('click', async ()=>{
        if (!(0, $cEKee.listNamePageQuestion).find((list)=>list === (0, $cEKee.nameScreenDynamic))) (0, $cEKee.listNamePageQuestion).push((0, $cEKee.nameScreenDynamic));
        (0, $cEKee.setListNamePageQuestion)((0, $cEKee.listNamePageQuestion));
        document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .dateQuestionContinue__btn`).classList.add('disabled');
        document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .dateQuestionContinue__btn .loading__wrapper`)?.classList.remove('hidden');
        const loaderIcon = document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .loader__icon`);
        if (loaderIcon) {
            loaderIcon.innerHTML = '';
            loaderIcon.insertAdjacentHTML('beforeend', `<img src="${(0, $cEKee.appUrl)}/assets/icons/rolling.png" />`);
        }
        const item = (0, $cEKee.nameScreenDynamic).split('--')[1];
        (0, $cEKee.listDataQuestion)[item] = document.querySelector(`${(0, $cEKee.nameScreenDynamic)} #questionDatepicker--${(0, $cEKee.nameScreenDynamic).replace('.', '')}`).value;
        (0, $cEKee.setListDataQuestion)((0, $cEKee.listDataQuestion));
        const fields = (0, $cEKee.questionnaireFields)?.length ? (0, $cEKee.questionnaireFields) : (0, $cEKee.form)?.form?.custom_fields ?? [];
        const formId = (0, $cEKee.questionnaireFormId) ?? (0, $cEKee.form)?.form?.id;
        let idx = fields.findIndex((custom)=>custom && custom.id == (0, $cEKee.nameScreenDynamic).split('--')[1]);
        if (idx == fields.length - 1) try {
            const fieldLabels = {};
            const sourceFields = (0, $cEKee.questionnaireFields)?.length ? (0, $cEKee.questionnaireFields) : (0, $cEKee.form)?.form?.custom_fields ?? [];
            sourceFields.forEach((f)=>{
                if (f && f.id) fieldLabels[f.id] = f.label || f.title || (0, $knjAn.t)('custom_field');
            });
            if (typeof formId === 'string' && formId.startsWith('ac-')) {
                const acId = parseInt(formId.replace(/^ac-/, ''), 10);
                await (0, $hWSV7.updateQualificationResponses)((0, $cEKee.leadTextId), acId, (0, $cEKee.listDataQuestion), fieldLabels);
            } else await (0, $hWSV7.updateConsultRequestFields)((0, $cEKee.leadTextId), (0, $cEKee.listDataQuestion), fieldLabels);
            document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .dateQuestionContinue__btn`)?.classList.remove('disabled');
            document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .dateQuestionContinue__btn .loading__wrapper`)?.classList.remove('hidden');
            const valueDate = document.querySelector(`${(0, $cEKee.nameScreenDynamic)} #questionDatepicker--${(0, $cEKee.nameScreenDynamic)}`);
            if (valueDate) valueDate.value = '';
            const loaderIcon = document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .loader__icon`);
            if (loaderIcon) {
                loaderIcon.innerHTML = '';
                loaderIcon.insertAdjacentHTML('beforeend', `<i class="ri-arrow-right-line"></i>`);
            }
            (0, $9bGUq.clearCustomFields)();
            (0, $cEKee.clearQuestionnaireContext)();
            (0, $87Cn1.navigateToNextPage)();
        } catch (error) {
            (0, $gZEOs.toastError)(error.response?.data?.message);
        }
        else {
            (0, $cEKee.setProgressQuestion)({
                ...(0, $cEKee.progressQuestion),
                currentQuestion: (0, $cEKee.progressQuestion).currentQuestion + 1,
                progress: ((0, $cEKee.progressQuestion).currentQuestion + 1) / (0, $cEKee.progressQuestion).total * 100
            });
            (0, $9bGUq.loadCustomFields)(fields[idx + 1]);
        }
    });
}
function $68ceda619868d27c$var$handleClickBackDateQuestion() {
    const idx = (0, $cEKee.listNamePageQuestion).findIndex((l)=>l === (0, $cEKee.nameScreenDynamic));
    if (idx > 0) {
        (0, $er9E0.customFeildGoBackAnimationHandler)(`${(0, $cEKee.nameScreenDynamic)}`);
        (0, $cEKee.setProgressQuestion)({
            ...(0, $cEKee.progressQuestion),
            currentQuestion: (0, $cEKee.progressQuestion).currentQuestion - 1,
            progress: ((0, $cEKee.progressQuestion).currentQuestion - 1) / (0, $cEKee.progressQuestion).total * 100
        });
        (0, $cEKee.setNameScreenDynamic)((0, $cEKee.listNamePageQuestion)[idx - 1]);
        if ((0, $cEKee.nameScreenDynamic).includes('text') && !(0, $cEKee.nameScreenDynamic).includes('textarea')) (0, $cXbcK.textQuestionListener)();
        else if ((0, $cEKee.nameScreenDynamic).includes('checkbox')) (0, $5r2Yt.checkboxQuestionListener)();
        else if ((0, $cEKee.nameScreenDynamic).includes('select')) (0, $l4WR9.selectQuestionListener)();
        else if ((0, $cEKee.nameScreenDynamic).includes('date')) $68ceda619868d27c$export$908d9d6226c9e96c();
        else if ((0, $cEKee.nameScreenDynamic).includes('textarea')) (0, $5fptp.textAreaQuestonListener)();
        else if ((0, $cEKee.nameScreenDynamic).includes('number')) (0, $1BMUZ.numberQuestionListener)();
        else if ((0, $cEKee.nameScreenDynamic).includes('height')) (0, $62Jhk.heightQuestionListener)();
    } else (0, $er9E0.customFeildGoBackAnimationHandler)(`${(0, $cEKee.nameScreenDynamic)}`);
}

});
parcelRegister("62Jhk", function(module, exports) {

$parcel$export(module.exports, "heightQuestionListener", () => $46660d5ba8211e25$export$7f1c724a4f138a88);

var $hWSV7 = parcelRequire("hWSV7");

var $knjAn = parcelRequire("knjAn");

var $cEKee = parcelRequire("cEKee");

var $gZEOs = parcelRequire("gZEOs");

var $9bGUq = parcelRequire("9bGUq");

var $5r2Yt = parcelRequire("5r2Yt");

var $8ZTdz = parcelRequire("8ZTdz");

var $er9E0 = parcelRequire("er9E0");

var $1BMUZ = parcelRequire("1BMUZ");

var $l4WR9 = parcelRequire("l4WR9");

var $5fptp = parcelRequire("5fptp");

var $cXbcK = parcelRequire("cXbcK");

var $87Cn1 = parcelRequire("87Cn1");
function $46660d5ba8211e25$export$7f1c724a4f138a88() {
    // check has data
    if ((0, $cEKee.listNamePageQuestion).find((name)=>name === (0, $cEKee.nameScreenDynamic)) && (0, $cEKee.listDataQuestion)[(0, $cEKee.nameScreenDynamic).split('--')[1]]) {
        let regex = /\d+/g;
        let data = (0, $cEKee.listDataQuestion)[(0, $cEKee.nameScreenDynamic).split('--')[1]];
        var matches = data.match(regex);
        const valueFeet = document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .height_feet`);
        const valueIn = document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .height_inch`);
        if (valueFeet) valueFeet.value = matches[0];
        if (valueIn) valueIn.value = matches[1];
        setTimeout(()=>{
            if (document.getElementById('height_feet')) document.getElementById('height_feet').focus();
        }, 500);
        document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .heightQuestionContinue__btn`)?.classList.remove('disabled');
        document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .heightQuestion__valid`)?.classList.remove('hidden');
        document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .heightQuestionContinue__btn .loading__wrapper`)?.classList.add('hidden');
        const loaderIcon = document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .loader__icon`);
        if (loaderIcon) {
            loaderIcon.innerHTML = '';
            loaderIcon.insertAdjacentHTML('beforeend', `<i class="ri-arrow-right-line"></i>`);
        }
        document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .heightQuestion__invalid`)?.classList.add('hidden');
        return;
    }
    $46660d5ba8211e25$var$validateHeight();
    const isValidIcon = document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .heightQuestion__valid`);
    isValidIcon?.addEventListener('click', function() {
        document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .heightQuestionContinue__btn`)?.click();
    });
    /* On click enter */ const screenHeightQuestion = document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .screen--height`);
    if (screenHeightQuestion) screenHeightQuestion.addEventListener('keydown', (event)=>{
        if (event.key === 'Enter' && !document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .heightQuestionContinue__btn`).classList.contains('disabled')) document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .heightQuestionContinue__btn`).click();
    });
    /* On click Back button */ document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .heightQuestionBack__btn`)?.addEventListener('click', ()=>{
        const idx = (0, $cEKee.listNamePageQuestion).findIndex((l)=>l === (0, $cEKee.nameScreenDynamic));
        if (idx > 0) {
            (0, $er9E0.customFeildGoBackAnimationHandler)(`${(0, $cEKee.nameScreenDynamic)}`);
            (0, $cEKee.setProgressQuestion)({
                ...(0, $cEKee.progressQuestion),
                currentQuestion: (0, $cEKee.progressQuestion).currentQuestion - 1,
                progress: ((0, $cEKee.progressQuestion).currentQuestion - 1) / (0, $cEKee.progressQuestion).total * 100
            });
            (0, $cEKee.setNameScreenDynamic)((0, $cEKee.listNamePageQuestion)[idx - 1]);
            if ((0, $cEKee.nameScreenDynamic).includes('text') && !(0, $cEKee.nameScreenDynamic).includes('textarea')) (0, $cXbcK.textQuestionListener)();
            else if ((0, $cEKee.nameScreenDynamic).includes('checkbox')) (0, $5r2Yt.checkboxQuestionListener)();
            else if ((0, $cEKee.nameScreenDynamic).includes('select')) (0, $l4WR9.selectQuestionListener)();
            else if ((0, $cEKee.nameScreenDynamic).includes('date')) (0, $8ZTdz.dateQuestionListener)();
            else if ((0, $cEKee.nameScreenDynamic).includes('textarea')) (0, $5fptp.textAreaQuestonListener)();
            else if ((0, $cEKee.nameScreenDynamic).includes('number')) (0, $1BMUZ.numberQuestionListener)();
            else if ((0, $cEKee.nameScreenDynamic).includes('height')) $46660d5ba8211e25$export$7f1c724a4f138a88();
        } else (0, $er9E0.customFeildGoBackAnimationHandler)(`${(0, $cEKee.nameScreenDynamic)}`);
    });
    /* on click Continue */ document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .heightQuestionContinue__btn`)?.addEventListener('click', async ()=>{
        if (!(0, $cEKee.listNamePageQuestion).find((list)=>list === (0, $cEKee.nameScreenDynamic))) (0, $cEKee.listNamePageQuestion).push((0, $cEKee.nameScreenDynamic));
        (0, $cEKee.setListNamePageQuestion)((0, $cEKee.listNamePageQuestion));
        document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .heightQuestionContinue__btn`).classList.add('disabled');
        document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .heightQuestionContinue__btn .loading__wrapper`)?.classList.remove('hidden');
        const loaderIcon = document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .loader__icon`);
        if (loaderIcon) {
            loaderIcon.innerHTML = '';
            loaderIcon.insertAdjacentHTML('beforeend', `<img src="${(0, $cEKee.appUrl)}/assets/icons/rolling.png" />`);
        }
        const item = (0, $cEKee.nameScreenDynamic).split('--')[1];
        const valFeet = document.getElementById('height_feet').value;
        const valIn = document.getElementById('height_inch').value;
        (0, $cEKee.listDataQuestion)[item] = `${valFeet} FT - ${valIn} IN`;
        (0, $cEKee.setListDataQuestion)((0, $cEKee.listDataQuestion));
        // find index
        const fields = (0, $cEKee.questionnaireFields)?.length ? (0, $cEKee.questionnaireFields) : (0, $cEKee.form)?.form?.custom_fields ?? [];
        const formId = (0, $cEKee.questionnaireFormId) ?? (0, $cEKee.form)?.form?.id;
        let idx = fields.findIndex((custom)=>custom && custom.id == (0, $cEKee.nameScreenDynamic).split('--')[1]);
        if (idx == fields.length - 1) try {
            const fieldLabels = {};
            const sourceFields = (0, $cEKee.questionnaireFields)?.length ? (0, $cEKee.questionnaireFields) : (0, $cEKee.form)?.form?.custom_fields ?? [];
            sourceFields.forEach((f)=>{
                if (f && f.id) fieldLabels[f.id] = f.label || f.title || (0, $knjAn.t)('custom_field');
            });
            if (typeof formId === 'string' && formId.startsWith('ac-')) {
                const acId = parseInt(formId.replace(/^ac-/, ''), 10);
                await (0, $hWSV7.updateQualificationResponses)((0, $cEKee.leadTextId), acId, (0, $cEKee.listDataQuestion), fieldLabels);
            } else await (0, $hWSV7.updateConsultRequestFields)((0, $cEKee.leadTextId), (0, $cEKee.listDataQuestion), fieldLabels);
            document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .heightQuestion__container .heightQuestionContinue__btn`)?.classList.remove('disabled');
            document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .heightQuestionContinue__btn .loading__wrapper`)?.classList.add('hidden');
            const valueFeet = document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .height_feet`);
            const valueIn = document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .height_inch`);
            if (valueFeet) valueFeet.value = '';
            if (valueIn) valueIn.value = '';
            const loaderIcon = document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .loader__icon`);
            if (loaderIcon) {
                loaderIcon.innerHTML = '';
                loaderIcon.insertAdjacentHTML('beforeend', `<i class="ri-arrow-right-line"></i>`);
            }
            document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .heightQuestion__invalid`)?.classList.add('hidden');
            document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .heightQuestion__valid`)?.classList.add('hidden');
            (0, $9bGUq.clearCustomFields)();
            (0, $cEKee.clearQuestionnaireContext)();
            (0, $87Cn1.navigateToNextPage)();
        } catch (error) {
            (0, $gZEOs.toastError)(error.response?.data?.message);
        }
        else {
            // handle
            (0, $cEKee.setProgressQuestion)({
                ...(0, $cEKee.progressQuestion),
                currentQuestion: (0, $cEKee.progressQuestion).currentQuestion + 1,
                progress: ((0, $cEKee.progressQuestion).currentQuestion + 1) / (0, $cEKee.progressQuestion).total * 100
            });
            (0, $9bGUq.loadCustomFields)(fields[idx + 1]);
        }
    });
}
function $46660d5ba8211e25$var$validateHeight() {
    const heightQuestionEle = document.querySelector('.heightQuestion');
    const ftInput = heightQuestionEle.querySelector('#height_feet');
    ftInput?.addEventListener('keyup', function() {
        if (parseInt(ftInput.value) > 8 || parseInt(ftInput.value) < 3) {
            ftInput.classList.add('error');
            heightQuestionEle.querySelector('.heightQuestion__valid').classList.add('hidden');
            heightQuestionEle.querySelector('.heightQuestion__invalid').classList.remove('hidden');
        } else if (parseInt(ftInput.value) >= 3 && parseInt(ftInput.value) <= 8) {
            ftInput.classList.remove('error');
            heightQuestionEle.querySelector('.heightQuestion__valid').classList.remove('hidden');
            heightQuestionEle.querySelector('.heightQuestion__invalid').classList.add('hidden');
        }
        $46660d5ba8211e25$var$checkContinueForTypeHeight();
    });
    ftInput.addEventListener('keydown', function(e) {
        if (e.key === 'Tab') document.getElementById('height_inch')?.focus();
    });
    const inInput = document.querySelector('#height_inch');
    inInput?.addEventListener('keyup', function() {
        if (parseInt(inInput.value) > 11 || parseInt(inInput.value) < 0) {
            inInput?.classList.add('error');
            heightQuestionEle.querySelector('.heightQuestion__valid').classList.add('hidden');
            heightQuestionEle.querySelector('.heightQuestion__invalid').classList.remove('hidden');
        } else if (parseInt(inInput.value) <= 11 && parseInt(inInput.value) >= 0) {
            inInput.classList.remove('error');
            heightQuestionEle.querySelector('.heightQuestion__valid').classList.remove('hidden');
            heightQuestionEle.querySelector('.heightQuestion__invalid').classList.add('hidden');
        }
        $46660d5ba8211e25$var$checkContinueForTypeHeight();
    });
    inInput.addEventListener('keydown', function(e) {
        if (e.key === 'Backspace' && !document.getElementById('height_inch').value) {
            e.preventDefault();
            document.getElementById('height_feet').focus();
        }
    });
}
function $46660d5ba8211e25$var$checkContinueForTypeHeight() {
    if (!document.querySelector('#height_feet')?.classList.contains('error') && !document.querySelector('#height_inch')?.classList.contains('error') && document.getElementById('height_inch')?.value && document.getElementById('height_feet')?.value) document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .heightQuestionContinue__btn`)?.classList.remove('disabled');
    else document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .heightQuestionContinue__btn`)?.classList.add('disabled');
}

});
parcelRegister("1BMUZ", function(module, exports) {

$parcel$export(module.exports, "numberQuestionListener", () => $12bf314dc377fc1a$export$4677748b811a80a);

var $hWSV7 = parcelRequire("hWSV7");

var $knjAn = parcelRequire("knjAn");

var $cEKee = parcelRequire("cEKee");

var $gZEOs = parcelRequire("gZEOs");

var $9bGUq = parcelRequire("9bGUq");

var $5r2Yt = parcelRequire("5r2Yt");

var $8ZTdz = parcelRequire("8ZTdz");

var $62Jhk = parcelRequire("62Jhk");

var $er9E0 = parcelRequire("er9E0");

var $l4WR9 = parcelRequire("l4WR9");

var $5fptp = parcelRequire("5fptp");

var $cXbcK = parcelRequire("cXbcK");

var $87Cn1 = parcelRequire("87Cn1");

var $gMDh6 = parcelRequire("gMDh6");

var $cIxq8 = parcelRequire("cIxq8");

var $2q2gk = parcelRequire("2q2gk");
function $12bf314dc377fc1a$export$4677748b811a80a() {
    // check has data
    if ((0, $cEKee.listNamePageQuestion).find((name)=>name === (0, $cEKee.nameScreenDynamic)) && (0, $cEKee.listDataQuestion)[(0, $cEKee.nameScreenDynamic).split('--')[1]]) {
        const value = document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .numberQuestion--input`);
        if (value) value.value = (0, $cEKee.listDataQuestion)[(0, $cEKee.nameScreenDynamic).split('--')[1]];
        setTimeout(()=>{
            const numberNameInput = document.querySelector(`${(0, $cEKee.nameScreenDynamic)} #numberQuestion`);
            if (numberNameInput !== document.activeElement) numberNameInput.focus();
        }, 500);
        document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .numberQuestionContinue__btn`)?.classList.remove('disabled');
        document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .numberQuestion__valid`)?.classList.remove('hidden');
        document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .numberQuestionContinue__btn .loading__wrapper`)?.classList.add('hidden');
        const loaderIcon = document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .loader__icon`);
        if (loaderIcon) {
            loaderIcon.innerHTML = '';
            loaderIcon.insertAdjacentHTML('beforeend', `<i class="ri-arrow-right-line"></i>`);
        }
        document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .numberQuestion__invalid`)?.classList.add('hidden');
        return;
    }
    $12bf314dc377fc1a$var$validateNumber();
    const isValidIcon = document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .numberQuestion__valid`);
    isValidIcon.addEventListener('click', function() {
        document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .numberQuestionContinue__btn`)?.click();
    });
    /* On click enter */ const screenNumberQuestion = document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .screen--number`);
    if (screenNumberQuestion) screenNumberQuestion.addEventListener('keydown', (event)=>{
        if (event.key === 'Enter' && !document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .numberQuestionContinue__btn`)?.classList.contains('disabled')) document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .numberQuestionContinue__btn`).click();
    });
    /* On click Back button */ document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .numberQuestionBack__btn`)?.addEventListener('click', ()=>{
        const idx = (0, $cEKee.listNamePageQuestion).findIndex((l)=>l === (0, $cEKee.nameScreenDynamic));
        if (idx > 0) {
            (0, $er9E0.customFeildGoBackAnimationHandler)(`${(0, $cEKee.nameScreenDynamic)}`);
            (0, $cEKee.setProgressQuestion)({
                ...(0, $cEKee.progressQuestion),
                currentQuestion: (0, $cEKee.progressQuestion).currentQuestion - 1,
                progress: ((0, $cEKee.progressQuestion).currentQuestion - 1) / (0, $cEKee.progressQuestion).total * 100
            });
            (0, $cEKee.setNameScreenDynamic)((0, $cEKee.listNamePageQuestion)[idx - 1]);
            if ((0, $cEKee.nameScreenDynamic).includes('text') && !(0, $cEKee.nameScreenDynamic).includes('textarea')) (0, $cXbcK.textQuestionListener)();
            else if ((0, $cEKee.nameScreenDynamic).includes('checkbox')) (0, $5r2Yt.checkboxQuestionListener)();
            else if ((0, $cEKee.nameScreenDynamic).includes('select')) (0, $l4WR9.selectQuestionListener)();
            else if ((0, $cEKee.nameScreenDynamic).includes('date')) (0, $8ZTdz.dateQuestionListener)();
            else if ((0, $cEKee.nameScreenDynamic).includes('textarea')) (0, $5fptp.textAreaQuestonListener)();
            else if ((0, $cEKee.nameScreenDynamic).includes('number')) $12bf314dc377fc1a$export$4677748b811a80a();
            else if ((0, $cEKee.nameScreenDynamic).includes('height')) (0, $62Jhk.heightQuestionListener)();
        } else (0, $er9E0.customFeildGoBackAnimationHandler)(`${(0, $cEKee.nameScreenDynamic)}`);
    });
    /* on click Continue */ document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .numberQuestionContinue__btn`)?.addEventListener('click', async ()=>{
        if (!(0, $cEKee.listNamePageQuestion).find((list)=>list === (0, $cEKee.nameScreenDynamic))) (0, $cEKee.listNamePageQuestion).push((0, $cEKee.nameScreenDynamic));
        (0, $cEKee.setListNamePageQuestion)((0, $cEKee.listNamePageQuestion));
        document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .numberQuestionContinue__btn`).classList.add('disabled');
        document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .numberQuestionContinue__btn .loading__wrapper`)?.classList.remove('hidden');
        const loaderIcon = document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .loader__icon`);
        if (loaderIcon) {
            loaderIcon.innerHTML = '';
            loaderIcon.insertAdjacentHTML('beforeend', `<img src="${(0, $cEKee.appUrl)}/assets/icons/rolling.png" />`);
        }
        const item = (0, $cEKee.nameScreenDynamic).split('--')[1];
        const numVal = Number(document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .numberQuestion--input`).value);
        const answersWithCurrent = {
            ...(0, $cEKee.listDataQuestion),
            [item]: numVal
        };
        (0, $cEKee.listDataQuestion)[item] = numVal;
        (0, $cEKee.setListDataQuestion)((0, $cEKee.listDataQuestion));
        const fields = (0, $cEKee.questionnaireFields)?.length ? (0, $cEKee.questionnaireFields) : (0, $cEKee.form)?.form?.custom_fields ?? [];
        const currentField = fields.find((f)=>f && f.id == item);
        const minDisqualifiers = (0, $cEKee.form)?.appointment_channel?.min_disqualifier_matches ?? (0, $cEKee.form)?.consult_min_disqualifier_matches ?? 1;
        if (currentField && (0, $gMDh6.evaluateDisqualifier)(currentField, numVal) && (0, $gMDh6.shouldDisqualifyNow)(fields, answersWithCurrent, minDisqualifiers)) {
            try {
                const fieldLabels = {};
                const sourceFields = (0, $cEKee.questionnaireFields)?.length ? (0, $cEKee.questionnaireFields) : (0, $cEKee.form)?.form?.custom_fields ?? [];
                sourceFields.forEach((f)=>{
                    if (f && f.id) fieldLabels[f.id] = f.label || f.title || (0, $knjAn.t)('custom_field');
                });
                const formId = (0, $cEKee.questionnaireFormId) ?? (0, $cEKee.form)?.form?.id;
                if (typeof formId === 'string' && formId.startsWith('ac-')) {
                    const acId = parseInt(formId.replace(/^ac-/, ''), 10);
                    await (0, $hWSV7.updateQualificationResponses)((0, $cEKee.leadTextId), acId, (0, $cEKee.listDataQuestion), fieldLabels);
                } else await (0, $hWSV7.updateConsultRequestFields)((0, $cEKee.leadTextId), (0, $cEKee.listDataQuestion), fieldLabels);
            } catch (_) {}
            if ((0, $cEKee.leadInfo)?.id) {
                await (0, $2q2gk.updateLeadStep)((0, $cEKee.leadInfo).id, 'disqualified', 'true');
                (0, $er9E0.setSessionEndStepSentForLeadId)((0, $cEKee.leadInfo).id);
            }
            document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .numberQuestionContinue__btn`)?.classList.remove('disabled');
            document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .numberQuestionContinue__btn .loading__wrapper`)?.classList.add('hidden');
            const loaderIcon = document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .loader__icon`);
            if (loaderIcon) {
                loaderIcon.innerHTML = '';
                loaderIcon.insertAdjacentHTML('beforeend', '<i class="ri-arrow-right-line"></i>');
            }
            (0, $9bGUq.clearCustomFields)();
            (0, $cEKee.clearQuestionnaireContext)();
            (0, $er9E0.setIsDisqualified)(true);
            (0, $er9E0.navigate)((0, $cIxq8.SCREEN).THE_END);
            return;
        }
        const formId = (0, $cEKee.questionnaireFormId) ?? (0, $cEKee.form)?.form?.id;
        let idx = fields.findIndex((custom)=>custom && custom.id == (0, $cEKee.nameScreenDynamic).split('--')[1]);
        if (idx == fields.length - 1) try {
            const fieldLabels = {};
            const sourceFields = (0, $cEKee.questionnaireFields)?.length ? (0, $cEKee.questionnaireFields) : (0, $cEKee.form)?.form?.custom_fields ?? [];
            sourceFields.forEach((f)=>{
                if (f && f.id) fieldLabels[f.id] = f.label || f.title || (0, $knjAn.t)('custom_field');
            });
            if (typeof formId === 'string' && formId.startsWith('ac-')) {
                const acId = parseInt(formId.replace(/^ac-/, ''), 10);
                await (0, $hWSV7.updateQualificationResponses)((0, $cEKee.leadTextId), acId, (0, $cEKee.listDataQuestion), fieldLabels);
            } else await (0, $hWSV7.updateConsultRequestFields)((0, $cEKee.leadTextId), (0, $cEKee.listDataQuestion), fieldLabels);
            document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .numberQuestion__container .numberQuestionContinue__btn`)?.classList.remove('disabled');
            document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .numberQuestionContinue__btn .loading__wrapper`)?.classList.add('hidden');
            const value = document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .numberQuestion--input`);
            if (value) value.value = '';
            const loaderIcon = document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .loader__icon`);
            if (loaderIcon) {
                loaderIcon.innerHTML = '';
                loaderIcon.insertAdjacentHTML('beforeend', `<i class="ri-arrow-right-line"></i>`);
            }
            document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .numberQuestion__invalid`)?.classList.add('hidden');
            document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .numberQuestion__valid`)?.classList.add('hidden');
            (0, $9bGUq.clearCustomFields)();
            (0, $cEKee.clearQuestionnaireContext)();
            (0, $87Cn1.navigateToNextPage)();
        } catch (error) {
            (0, $gZEOs.toastError)(error.response?.data?.message);
        }
        else {
            // handle
            (0, $cEKee.setProgressQuestion)({
                ...(0, $cEKee.progressQuestion),
                currentQuestion: (0, $cEKee.progressQuestion).currentQuestion + 1,
                progress: ((0, $cEKee.progressQuestion).currentQuestion + 1) / (0, $cEKee.progressQuestion).total * 100
            });
            (0, $9bGUq.loadCustomFields)(fields[idx + 1]);
        }
    });
}
function $12bf314dc377fc1a$var$validateNumber() {
    const numberInput = document.querySelector(`${(0, $cEKee.nameScreenDynamic)} #numberQuestion`);
    const numberWrap = document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .numberQuestion`);
    const invalidIcon = document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .numberQuestion__invalid`);
    const validIcon = document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .numberQuestion__valid`);
    if (numberInput) numberInput.oninput = (e)=>{
        if (!e.target.value) {
            numberWrap.classList.remove('valid');
            numberWrap.classList.add('invalid');
            invalidIcon.classList.remove('hidden');
            document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .numberQuestionContinue__btn`).classList.add('disabled');
        } else {
            numberWrap.classList.add('valid');
            invalidIcon.classList.add('hidden');
            validIcon.classList.remove('hidden');
            numberInput.classList.remove('invalid');
            document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .numberQuestionContinue__btn`).classList.remove('disabled');
        }
    };
}

});
parcelRegister("l4WR9", function(module, exports) {

$parcel$export(module.exports, "selectQuestionListener", () => $f587a0544c691d3e$export$db7f1579b1077f78);

var $lF1I4 = parcelRequire("lF1I4");

var $hWSV7 = parcelRequire("hWSV7");

var $knjAn = parcelRequire("knjAn");

var $cEKee = parcelRequire("cEKee");

var $9bGUq = parcelRequire("9bGUq");

var $er9E0 = parcelRequire("er9E0");

var $gZEOs = parcelRequire("gZEOs");

var $87Cn1 = parcelRequire("87Cn1");

var $gMDh6 = parcelRequire("gMDh6");

var $cIxq8 = parcelRequire("cIxq8");

var $2q2gk = parcelRequire("2q2gk");

var $cXbcK = parcelRequire("cXbcK");

var $5r2Yt = parcelRequire("5r2Yt");

var $8ZTdz = parcelRequire("8ZTdz");

var $5fptp = parcelRequire("5fptp");

var $1BMUZ = parcelRequire("1BMUZ");

var $62Jhk = parcelRequire("62Jhk");
function $f587a0544c691d3e$export$db7f1579b1077f78() {
    const itemId = (0, $cEKee.nameScreenDynamic).split('--')[1];
    const fields = (0, $cEKee.questionnaireFields)?.length ? (0, $cEKee.questionnaireFields) : (0, $cEKee.form)?.form?.custom_fields ?? [];
    const customField = fields.find((custom)=>custom && custom.id == itemId);
    const isMultiSelect = customField?.type === 'multi_select';
    const optionsOrAnswers = customField?.options ?? customField?.answers;
    // check has data
    if ((0, $cEKee.listNamePageQuestion).find((name)=>name === (0, $cEKee.nameScreenDynamic)) && (0, $cEKee.listDataQuestion)[itemId]) {
        const savedValue = (0, $cEKee.listDataQuestion)[itemId];
        if (isMultiSelect) {
            const selectedValues = JSON.parse(savedValue);
            selectedValues.forEach((value)=>(0, $lF1I4.selectOption)(value, true));
        } else (0, $lF1I4.selectOption)(savedValue);
        document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .selectContinue__btn`)?.classList.remove('disabled');
        document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .selectContinue__btn .loading__wrapper`)?.classList.add('hidden');
        const loaderIcon = document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .loader__icon`);
        if (loaderIcon) {
            loaderIcon.innerHTML = '';
            loaderIcon.insertAdjacentHTML('beforeend', `<i class="ri-arrow-right-line"></i>`);
        }
        return;
    } else (0, $lF1I4.loadSelectoptionList)(optionsOrAnswers);
    /* on select option*/ document.querySelectorAll(`${(0, $cEKee.nameScreenDynamic)} .option`).forEach((i)=>{
        i.addEventListener('click', ()=>{
            const value = i.getAttribute('data-option');
            (0, $lF1I4.selectOption)(value, isMultiSelect);
        });
    });
    /* On click Back button */ document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .selectQuestionBack__btn`)?.addEventListener('click', ()=>{
        const idx = (0, $cEKee.listNamePageQuestion).findIndex((l)=>l === (0, $cEKee.nameScreenDynamic));
        if (idx > 0) {
            (0, $cEKee.setProgressQuestion)({
                ...(0, $cEKee.progressQuestion),
                currentQuestion: (0, $cEKee.progressQuestion).currentQuestion - 1,
                progress: ((0, $cEKee.progressQuestion).currentQuestion - 1) / (0, $cEKee.progressQuestion).total * 100
            });
            (0, $er9E0.customFeildGoBackAnimationHandler)(`${(0, $cEKee.nameScreenDynamic)}`);
            (0, $cEKee.setNameScreenDynamic)((0, $cEKee.listNamePageQuestion)[idx - 1]);
            if ((0, $cEKee.nameScreenDynamic).includes('text') && !(0, $cEKee.nameScreenDynamic).includes('textarea')) (0, $cXbcK.textQuestionListener)();
            else if ((0, $cEKee.nameScreenDynamic).includes('checkbox')) (0, $5r2Yt.checkboxQuestionListener)();
            else if ((0, $cEKee.nameScreenDynamic).includes('select')) $f587a0544c691d3e$export$db7f1579b1077f78();
            else if ((0, $cEKee.nameScreenDynamic).includes('date')) (0, $8ZTdz.dateQuestionListener)();
            else if ((0, $cEKee.nameScreenDynamic).includes('textarea')) (0, $5fptp.textAreaQuestonListener)();
            else if ((0, $cEKee.nameScreenDynamic).includes('number')) (0, $1BMUZ.numberQuestionListener)();
            else if ((0, $cEKee.nameScreenDynamic).includes('height')) (0, $62Jhk.heightQuestionListener)();
        } else (0, $er9E0.customFeildGoBackAnimationHandler)(`${(0, $cEKee.nameScreenDynamic)}`);
    });
    /* On click enter */ const screenSelect = document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .screen--select`);
    if (screenSelect) screenSelect.addEventListener('keydown', (event)=>{
        if (event.key === 'Enter' && !document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .selectContinue__btn`).classList.contains('disabled')) document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .selectContinue__btn`).click();
    });
    /* on click Continue after select option */ const btnSelectElement = document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .selectContinue__btn`);
    btnSelectElement.addEventListener('click', async ()=>{
        if (!(0, $cEKee.listNamePageQuestion).find((list)=>list === (0, $cEKee.nameScreenDynamic))) (0, $cEKee.listNamePageQuestion).push((0, $cEKee.nameScreenDynamic));
        (0, $cEKee.setListNamePageQuestion)((0, $cEKee.listNamePageQuestion));
        document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .selectContinue__btn`).classList.add('disabled');
        document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .selectContinue__btn .loading__wrapper`)?.classList.remove('hidden');
        const loaderIcon = document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .loader__icon`);
        if (loaderIcon) {
            loaderIcon.innerHTML = '';
            loaderIcon.insertAdjacentHTML('beforeend', `<img src="${(0, $cEKee.appUrl)}/assets/icons/rolling.png" />`);
        }
        let value;
        if (isMultiSelect) {
            const selectedValues = Array.from(document.querySelectorAll(`${(0, $cEKee.nameScreenDynamic)} .option__checkbox.is-selected`)).map((el)=>el.getAttribute('data-option'));
            value = JSON.stringify(selectedValues);
        } else value = document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .option__checkbox.is-selected`).getAttribute('data-option');
        const item = (0, $cEKee.nameScreenDynamic).split('--')[1];
        const answersWithCurrent = {
            ...(0, $cEKee.listDataQuestion),
            [item]: value
        };
        (0, $cEKee.listDataQuestion)[item] = value;
        (0, $cEKee.setListDataQuestion)((0, $cEKee.listDataQuestion));
        const fields = (0, $cEKee.questionnaireFields)?.length ? (0, $cEKee.questionnaireFields) : (0, $cEKee.form)?.form?.custom_fields ?? [];
        const currentField = fields.find((f)=>f && f.id == item);
        const minDisqualifiers = (0, $cEKee.form)?.appointment_channel?.min_disqualifier_matches ?? (0, $cEKee.form)?.consult_min_disqualifier_matches ?? 1;
        if (currentField && (0, $gMDh6.evaluateDisqualifier)(currentField, value) && (0, $gMDh6.shouldDisqualifyNow)(fields, answersWithCurrent, minDisqualifiers)) {
            try {
                const fieldLabels = {};
                const sourceFields = (0, $cEKee.questionnaireFields)?.length ? (0, $cEKee.questionnaireFields) : (0, $cEKee.form)?.form?.custom_fields ?? [];
                sourceFields.forEach((f)=>{
                    if (f && f.id) fieldLabels[f.id] = f.label || f.title || (0, $knjAn.t)('custom_field');
                });
                const formId = (0, $cEKee.questionnaireFormId) ?? (0, $cEKee.form)?.form?.id;
                if (typeof formId === 'string' && formId.startsWith('ac-')) {
                    const acId = parseInt(formId.replace(/^ac-/, ''), 10);
                    await (0, $hWSV7.updateQualificationResponses)((0, $cEKee.leadTextId), acId, (0, $cEKee.listDataQuestion), fieldLabels);
                } else await (0, $hWSV7.updateConsultRequestFields)((0, $cEKee.leadTextId), (0, $cEKee.listDataQuestion), fieldLabels);
            } catch (_) {}
            if ((0, $cEKee.leadInfo)?.id) {
                await (0, $2q2gk.updateLeadStep)((0, $cEKee.leadInfo).id, 'disqualified', 'true');
                (0, $er9E0.setSessionEndStepSentForLeadId)((0, $cEKee.leadInfo).id);
            }
            document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .selectContinue__btn`)?.classList.remove('disabled');
            document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .selectContinue__btn .loading__wrapper`)?.classList.add('hidden');
            const loaderIcon = document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .loader__icon`);
            if (loaderIcon) {
                loaderIcon.innerHTML = '';
                loaderIcon.insertAdjacentHTML('beforeend', '<i class="ri-arrow-right-line"></i>');
            }
            (0, $9bGUq.clearCustomFields)();
            (0, $cEKee.clearQuestionnaireContext)();
            (0, $er9E0.setIsDisqualified)(true);
            (0, $er9E0.navigate)((0, $cIxq8.SCREEN).THE_END);
            return;
        }
        const formId = (0, $cEKee.questionnaireFormId) ?? (0, $cEKee.form)?.form?.id;
        let idx = fields.findIndex((custom)=>custom && custom.id == (0, $cEKee.nameScreenDynamic).split('--')[1]);
        if (idx == fields.length - 1) try {
            const fieldLabels = {};
            const sourceFields = (0, $cEKee.questionnaireFields)?.length ? (0, $cEKee.questionnaireFields) : (0, $cEKee.form)?.form?.custom_fields ?? [];
            sourceFields.forEach((f)=>{
                if (f && f.id) fieldLabels[f.id] = f.label || f.title || (0, $knjAn.t)('custom_field');
            });
            if (typeof formId === 'string' && formId.startsWith('ac-')) {
                const acId = parseInt(formId.replace(/^ac-/, ''), 10);
                await (0, $hWSV7.updateQualificationResponses)((0, $cEKee.leadTextId), acId, (0, $cEKee.listDataQuestion), fieldLabels);
            } else await (0, $hWSV7.updateConsultRequestFields)((0, $cEKee.leadTextId), (0, $cEKee.listDataQuestion), fieldLabels);
            document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .selectContinue__btn`)?.classList.remove('disabled');
            document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .selectContinue__btn .loading__wrapper`)?.classList.add('hidden');
            const loaderIcon = document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .loader__icon`);
            if (loaderIcon) {
                loaderIcon.innerHTML = '';
                loaderIcon.insertAdjacentHTML('beforeend', `<i class="ri-arrow-right-line"></i>`);
            }
            (0, $9bGUq.clearCustomFields)();
            (0, $cEKee.clearQuestionnaireContext)();
            (0, $87Cn1.navigateToNextPage)();
        } catch (error) {
            (0, $gZEOs.toastError)(error.response?.data?.message);
        }
        else {
            (0, $cEKee.setProgressQuestion)({
                ...(0, $cEKee.progressQuestion),
                currentQuestion: (0, $cEKee.progressQuestion).currentQuestion + 1,
                progress: ((0, $cEKee.progressQuestion).currentQuestion + 1) / (0, $cEKee.progressQuestion).total * 100
            });
            (0, $9bGUq.loadCustomFields)(fields[idx + 1]);
        }
    });
}

});
parcelRegister("lF1I4", function(module, exports) {

$parcel$export(module.exports, "loadSelectoptionList", () => $fc4ec0d7dd675532$export$c0baac1759b30f28);
$parcel$export(module.exports, "selectOption", () => $fc4ec0d7dd675532$export$f6a817e077493ad8);

var $cEKee = parcelRequire("cEKee");
/**
 * Find an .option__checkbox by its data-option value using DOM traversal
 * instead of CSS.escape (which can break attribute selectors for values with spaces).
 */ function $fc4ec0d7dd675532$var$findCheckbox(value) {
    const container = document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .list-question`);
    if (!container) return null;
    const checkboxes = container.querySelectorAll('.option__checkbox');
    for (const cb of checkboxes){
        if (cb.getAttribute('data-option') === value) return cb;
    }
    return null;
}
function $fc4ec0d7dd675532$export$c0baac1759b30f28(answers) {
    let list = document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .list-question`);
    if (!list) return;
    const options = Array.isArray(answers) ? answers : [];
    const optionValues = options.map((o)=>typeof o === 'string' ? o : o?.value ?? o?.label ?? String(o));
    let optionList = ``;
    for (const i of optionValues)optionList = optionList.concat(`
        <div class="option" data-option="${i}">
            <span class="option__name">${i}</span>
            <span class="option__checkbox" data-option="${i}">
                <i class="option__icon-check ri-check-line"></i>
            </span>
        </div>
        `);
    list.insertAdjacentHTML('beforeend', optionList);
}
function $fc4ec0d7dd675532$export$f6a817e077493ad8(value, isMultiSelect = false) {
    if (isMultiSelect) {
        const checkbox = $fc4ec0d7dd675532$var$findCheckbox(value);
        if (!checkbox) return;
        checkbox.classList.toggle('is-selected');
        const hasSelectedOptions = document.querySelectorAll(`${(0, $cEKee.nameScreenDynamic)} .option__checkbox.is-selected`).length > 0;
        const continueBtn = document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .selectContinue__btn`);
        if (hasSelectedOptions) continueBtn.classList.remove('disabled');
        else continueBtn.classList.add('disabled');
    } else {
        $fc4ec0d7dd675532$export$2447b668d1d10b37();
        const checkbox = $fc4ec0d7dd675532$var$findCheckbox(value);
        if (checkbox) checkbox.classList.add('is-selected');
        document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .selectContinue__btn`).classList.remove('disabled');
    }
}
function $fc4ec0d7dd675532$export$2447b668d1d10b37() {
    document.querySelectorAll(`${(0, $cEKee.nameScreenDynamic)} .option__checkbox`).forEach((i)=>i.classList.remove('is-selected'));
    document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .selectContinue__btn`).classList.add('disabled');
}

});

parcelRegister("cXbcK", function(module, exports) {

$parcel$export(module.exports, "textQuestionListener", () => $96e3afb9468d99d0$export$b488dad32c8016bd);

var $hWSV7 = parcelRequire("hWSV7");

var $knjAn = parcelRequire("knjAn");

var $cEKee = parcelRequire("cEKee");

var $gZEOs = parcelRequire("gZEOs");

var $9bGUq = parcelRequire("9bGUq");

var $5r2Yt = parcelRequire("5r2Yt");

var $8ZTdz = parcelRequire("8ZTdz");

var $62Jhk = parcelRequire("62Jhk");

var $er9E0 = parcelRequire("er9E0");

var $1BMUZ = parcelRequire("1BMUZ");

var $l4WR9 = parcelRequire("l4WR9");

var $5fptp = parcelRequire("5fptp");

var $87Cn1 = parcelRequire("87Cn1");

var $gMDh6 = parcelRequire("gMDh6");

var $cIxq8 = parcelRequire("cIxq8");

var $2q2gk = parcelRequire("2q2gk");
/**
 * A text question flagged `required_without_upload` is only required when the
 * visitor skipped the photo-upload step; once at least one upload succeeded
 * (an `.upload-success` element exists on the persistent UPLOAD_PHOTOS screen)
 * the question may be left blank (e.g. insurance member ID vs. card photo).
 */ function $96e3afb9468d99d0$var$currentTextField() {
    const fields = (0, $cEKee.questionnaireFields)?.length ? (0, $cEKee.questionnaireFields) : (0, $cEKee.form)?.appointment_channel?.qualification_form?.custom_fields ?? (0, $cEKee.form)?.form?.custom_fields ?? [];
    return fields.find((f)=>f && String(f.id) === String((0, $cEKee.nameScreenDynamic).split('--')[1]));
}
function $96e3afb9468d99d0$var$isOptionalNow() {
    const field = $96e3afb9468d99d0$var$currentTextField();
    if (field && field.required === false) return true;
    if (!field?.required_without_upload) return false;
    return document.querySelectorAll('.uploadPhotos__container .upload-success').length > 0;
}
function $96e3afb9468d99d0$export$b488dad32c8016bd() {
    // check has data
    if ((0, $cEKee.listNamePageQuestion).find((name)=>name === (0, $cEKee.nameScreenDynamic)) && (0, $cEKee.listDataQuestion)[(0, $cEKee.nameScreenDynamic).split('--')[1]]) {
        const value = document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .textQuestion--input`);
        if (value) value.value = (0, $cEKee.listDataQuestion)[(0, $cEKee.nameScreenDynamic).split('--')[1]];
        setTimeout(()=>{
            const textNameInput = document.querySelector(`${(0, $cEKee.nameScreenDynamic)} #textQuestion`);
            if (textNameInput !== document.activeElement) textNameInput.focus();
        }, 500);
        document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .textQuestionContinue__btn`)?.classList.remove('disabled');
        document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .textQuestion__valid`)?.classList.remove('hidden');
        document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .textQuestionContinue__btn .loading__wrapper`)?.classList.add('hidden');
        const loaderIcon = document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .loader__icon`);
        if (loaderIcon) {
            loaderIcon.innerHTML = '';
            loaderIcon.insertAdjacentHTML('beforeend', `<i class="ri-arrow-right-line"></i>`);
        }
        document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .textQuestion__invalid`)?.classList.add('hidden');
        return;
    }
    $96e3afb9468d99d0$var$validateName();
    if ($96e3afb9468d99d0$var$isOptionalNow()) document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .textQuestionContinue__btn`)?.classList.remove('disabled');
    const isValidIcon = document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .textQuestion__valid`);
    isValidIcon?.addEventListener('click', function() {
        document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .textQuestionContinue__btn`)?.click();
    });
    /* On click enter */ const screenTextQuestion = document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .screen--text`);
    if (screenTextQuestion) screenTextQuestion.addEventListener('keydown', (event)=>{
        if (event.key === 'Enter' && !document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .textQuestionContinue__btn`).classList.contains('disabled')) document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .textQuestionContinue__btn`).click();
    });
    /* On click Back button */ document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .textQuestionBack__btn`)?.addEventListener('click', ()=>{
        const idx = (0, $cEKee.listNamePageQuestion).findIndex((l)=>l === (0, $cEKee.nameScreenDynamic));
        if (idx > 0) {
            (0, $er9E0.customFeildGoBackAnimationHandler)(`${(0, $cEKee.nameScreenDynamic)}`);
            (0, $cEKee.setProgressQuestion)({
                ...(0, $cEKee.progressQuestion),
                currentQuestion: (0, $cEKee.progressQuestion).currentQuestion - 1,
                progress: ((0, $cEKee.progressQuestion).currentQuestion - 1) / (0, $cEKee.progressQuestion).total * 100
            });
            (0, $cEKee.setNameScreenDynamic)((0, $cEKee.listNamePageQuestion)[idx - 1]);
            if ((0, $cEKee.nameScreenDynamic).includes('text') && !(0, $cEKee.nameScreenDynamic).includes('textarea')) $96e3afb9468d99d0$export$b488dad32c8016bd();
            else if ((0, $cEKee.nameScreenDynamic).includes('checkbox')) (0, $5r2Yt.checkboxQuestionListener)();
            else if ((0, $cEKee.nameScreenDynamic).includes('select')) (0, $l4WR9.selectQuestionListener)();
            else if ((0, $cEKee.nameScreenDynamic).includes('date')) (0, $8ZTdz.dateQuestionListener)();
            else if ((0, $cEKee.nameScreenDynamic).includes('textarea')) (0, $5fptp.textAreaQuestonListener)();
            else if ((0, $cEKee.nameScreenDynamic).includes('number')) (0, $1BMUZ.numberQuestionListener)();
            else if ((0, $cEKee.nameScreenDynamic).includes('height')) (0, $62Jhk.heightQuestionListener)();
        } else (0, $er9E0.customFeildGoBackAnimationHandler)(`${(0, $cEKee.nameScreenDynamic)}`);
    });
    /* on click Continue */ document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .textQuestionContinue__btn`)?.addEventListener('click', async ()=>{
        if (!(0, $cEKee.listNamePageQuestion).find((list)=>list === (0, $cEKee.nameScreenDynamic))) (0, $cEKee.listNamePageQuestion).push((0, $cEKee.nameScreenDynamic));
        (0, $cEKee.setListNamePageQuestion)((0, $cEKee.listNamePageQuestion));
        document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .textQuestionContinue__btn`).classList.add('disabled');
        document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .textQuestionContinue__btn .loading__wrapper`)?.classList.remove('hidden');
        const loaderIcon = document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .loader__icon`);
        if (loaderIcon) {
            loaderIcon.innerHTML = '';
            loaderIcon.insertAdjacentHTML('beforeend', `<img src="${(0, $cEKee.appUrl)}/assets/icons/rolling.png" />`);
        }
        const item = (0, $cEKee.nameScreenDynamic).split('--')[1];
        const textVal = document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .textQuestion--input`).value;
        const answersWithCurrent = {
            ...(0, $cEKee.listDataQuestion),
            [item]: textVal
        };
        (0, $cEKee.listDataQuestion)[item] = textVal;
        (0, $cEKee.setListDataQuestion)((0, $cEKee.listDataQuestion));
        const fields = (0, $cEKee.questionnaireFields)?.length ? (0, $cEKee.questionnaireFields) : (0, $cEKee.form)?.form?.custom_fields ?? [];
        const currentField = fields.find((f)=>f && f.id == item);
        const minDisqualifiers = (0, $cEKee.form)?.appointment_channel?.min_disqualifier_matches ?? (0, $cEKee.form)?.consult_min_disqualifier_matches ?? 1;
        if (currentField && (0, $gMDh6.evaluateDisqualifier)(currentField, textVal) && (0, $gMDh6.shouldDisqualifyNow)(fields, answersWithCurrent, minDisqualifiers)) {
            try {
                const fieldLabels = {};
                const sourceFields = (0, $cEKee.questionnaireFields)?.length ? (0, $cEKee.questionnaireFields) : (0, $cEKee.form)?.form?.custom_fields ?? [];
                sourceFields.forEach((f)=>{
                    if (f && f.id) fieldLabels[f.id] = f.label || f.title || (0, $knjAn.t)('custom_field');
                });
                const formId = (0, $cEKee.questionnaireFormId) ?? (0, $cEKee.form)?.form?.id;
                if (typeof formId === 'string' && formId.startsWith('ac-')) {
                    const acId = parseInt(formId.replace(/^ac-/, ''), 10);
                    await (0, $hWSV7.updateQualificationResponses)((0, $cEKee.leadTextId), acId, (0, $cEKee.listDataQuestion), fieldLabels);
                } else await (0, $hWSV7.updateConsultRequestFields)((0, $cEKee.leadTextId), (0, $cEKee.listDataQuestion), fieldLabels);
            } catch (_) {}
            if ((0, $cEKee.leadInfo)?.id) {
                await (0, $2q2gk.updateLeadStep)((0, $cEKee.leadInfo).id, 'disqualified', 'true');
                (0, $er9E0.setSessionEndStepSentForLeadId)((0, $cEKee.leadInfo).id);
            }
            document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .textQuestionContinue__btn`)?.classList.remove('disabled');
            document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .textQuestionContinue__btn .loading__wrapper`)?.classList.add('hidden');
            const loaderIcon = document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .loader__icon`);
            if (loaderIcon) {
                loaderIcon.innerHTML = '';
                loaderIcon.insertAdjacentHTML('beforeend', '<i class="ri-arrow-right-line"></i>');
            }
            (0, $9bGUq.clearCustomFields)();
            (0, $cEKee.clearQuestionnaireContext)();
            (0, $er9E0.setIsDisqualified)(true);
            (0, $er9E0.navigate)((0, $cIxq8.SCREEN).THE_END);
            return;
        }
        const formId = (0, $cEKee.questionnaireFormId) ?? (0, $cEKee.form)?.form?.id;
        let idx = fields.findIndex((custom)=>custom && custom.id == (0, $cEKee.nameScreenDynamic).split('--')[1]);
        if (idx == fields.length - 1) try {
            const fieldLabels = {};
            const sourceFields = (0, $cEKee.questionnaireFields)?.length ? (0, $cEKee.questionnaireFields) : (0, $cEKee.form)?.form?.custom_fields ?? [];
            sourceFields.forEach((f)=>{
                if (f && f.id) fieldLabels[f.id] = f.label || f.title || (0, $knjAn.t)('custom_field');
            });
            if (typeof formId === 'string' && formId.startsWith('ac-')) {
                const acId = parseInt(formId.replace(/^ac-/, ''), 10);
                await (0, $hWSV7.updateQualificationResponses)((0, $cEKee.leadTextId), acId, (0, $cEKee.listDataQuestion), fieldLabels);
            } else await (0, $hWSV7.updateConsultRequestFields)((0, $cEKee.leadTextId), (0, $cEKee.listDataQuestion), fieldLabels);
            document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .textQuestion__container .textQuestionContinue__btn`)?.classList.remove('disabled');
            document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .textQuestionContinue__btn .loading__wrapper`)?.classList.add('hidden');
            const value = document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .textQuestion--input`);
            if (value) value.value = '';
            const loaderIcon = document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .loader__icon`);
            if (loaderIcon) {
                loaderIcon.innerHTML = '';
                loaderIcon.insertAdjacentHTML('beforeend', `<i class="ri-arrow-right-line"></i>`);
            }
            document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .textQuestion__invalid`)?.classList.add('hidden');
            document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .textQuestion__valid`)?.classList.add('hidden');
            (0, $cEKee.clearQuestionnaireContext)();
            (0, $87Cn1.navigateToNextPageWithClearFields)();
        } catch (error) {
            (0, $gZEOs.toastError)(error.response?.data?.message);
        }
        else {
            // handle
            (0, $cEKee.setProgressQuestion)({
                ...(0, $cEKee.progressQuestion),
                currentQuestion: (0, $cEKee.progressQuestion).currentQuestion + 1,
                progress: ((0, $cEKee.progressQuestion).currentQuestion + 1) / (0, $cEKee.progressQuestion).total * 100
            });
            (0, $9bGUq.loadCustomFields)(fields[idx + 1]);
        }
    });
}
function $96e3afb9468d99d0$var$validateName() {
    const name = document.querySelector(`${(0, $cEKee.nameScreenDynamic)} #textQuestion`);
    const nameWrap = document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .textQuestion`);
    const invalidIcon = document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .textQuestion__invalid`);
    const validIcon = document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .textQuestion__valid`);
    if (name) name.oninput = (e)=>{
        if (!e.target.value && $96e3afb9468d99d0$var$isOptionalNow()) {
            nameWrap.classList.remove('valid');
            nameWrap.classList.remove('invalid');
            invalidIcon.classList.add('hidden');
            validIcon.classList.add('hidden');
            document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .textQuestionContinue__btn`).classList.remove('disabled');
        } else if (!e.target.value) {
            nameWrap.classList.remove('valid');
            nameWrap.classList.add('invalid');
            invalidIcon.classList.remove('hidden');
            document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .textQuestionContinue__btn`).classList.add('disabled');
        } else {
            nameWrap.classList.add('valid');
            invalidIcon.classList.add('hidden');
            validIcon.classList.remove('hidden');
            name.classList.remove('invalid');
            document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .textQuestionContinue__btn`).classList.remove('disabled');
        }
    };
}

});
parcelRegister("5fptp", function(module, exports) {

$parcel$export(module.exports, "textAreaQuestonListener", () => $3d221cf5b5ad7af5$export$f2c8edc53519c830);

var $hWSV7 = parcelRequire("hWSV7");

var $knjAn = parcelRequire("knjAn");

var $cEKee = parcelRequire("cEKee");

var $gZEOs = parcelRequire("gZEOs");

var $9bGUq = parcelRequire("9bGUq");

var $5r2Yt = parcelRequire("5r2Yt");

var $8ZTdz = parcelRequire("8ZTdz");

var $62Jhk = parcelRequire("62Jhk");

var $er9E0 = parcelRequire("er9E0");

var $1BMUZ = parcelRequire("1BMUZ");

var $l4WR9 = parcelRequire("l4WR9");

var $cXbcK = parcelRequire("cXbcK");

var $87Cn1 = parcelRequire("87Cn1");

var $gMDh6 = parcelRequire("gMDh6");

var $cIxq8 = parcelRequire("cIxq8");

var $2q2gk = parcelRequire("2q2gk");
function $3d221cf5b5ad7af5$export$f2c8edc53519c830() {
    // check has data
    if ((0, $cEKee.listNamePageQuestion).find((name)=>name === (0, $cEKee.nameScreenDynamic)) && (0, $cEKee.listDataQuestion)[(0, $cEKee.nameScreenDynamic).split('--')[1]]) {
        const value = document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .textareaQuestion`);
        if (value) value.value = (0, $cEKee.listDataQuestion)[(0, $cEKee.nameScreenDynamic).split('--')[1]];
        setTimeout(()=>{
            const textAreaNameInput = document.querySelector(`${(0, $cEKee.nameScreenDynamic)} #textareaQuestion`);
            if (textAreaNameInput !== document.activeElement) textAreaNameInput.focus();
        }, 500);
        document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .textareaContinue__btn`)?.classList.remove('disabled');
        document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .textareaContinue__btn .loading__wrapper`)?.classList.add('hidden');
        const loaderIcon = document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .loader__icon`);
        if (loaderIcon) {
            loaderIcon.innerHTML = '';
            loaderIcon.insertAdjacentHTML('beforeend', `<i class="ri-arrow-right-line"></i>`);
        }
        return;
    }
    // edit textarea
    const textAreaElement = document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .textareaQuestion`);
    textAreaElement?.addEventListener('input', function() {
        if (document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .textareaQuestion`)?.value) document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .textareaContinue__btn`).classList.remove('disabled');
        else document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .textareaContinue__btn`).classList.add('disabled');
    });
    /* On click Back button */ document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .textareaQuestionBack__btn`)?.addEventListener('click', ()=>{
        const idx = (0, $cEKee.listNamePageQuestion).findIndex((l)=>l === (0, $cEKee.nameScreenDynamic));
        if (idx > 0) {
            (0, $er9E0.customFeildGoBackAnimationHandler)(`${(0, $cEKee.nameScreenDynamic)}`);
            (0, $cEKee.setProgressQuestion)({
                ...(0, $cEKee.progressQuestion),
                currentQuestion: (0, $cEKee.progressQuestion).currentQuestion - 1,
                progress: ((0, $cEKee.progressQuestion).currentQuestion - 1) / (0, $cEKee.progressQuestion).total * 100
            });
            (0, $cEKee.setNameScreenDynamic)((0, $cEKee.listNamePageQuestion)[idx - 1]);
            if ((0, $cEKee.nameScreenDynamic).includes('text') && !(0, $cEKee.nameScreenDynamic).includes('textarea')) (0, $cXbcK.textQuestionListener)();
            else if ((0, $cEKee.nameScreenDynamic).includes('checkbox')) (0, $5r2Yt.checkboxQuestionListener)();
            else if ((0, $cEKee.nameScreenDynamic).includes('select')) (0, $l4WR9.selectQuestionListener)();
            else if ((0, $cEKee.nameScreenDynamic).includes('date')) (0, $8ZTdz.dateQuestionListener)();
            else if ((0, $cEKee.nameScreenDynamic).includes('textarea')) $3d221cf5b5ad7af5$export$f2c8edc53519c830();
            else if ((0, $cEKee.nameScreenDynamic).includes('number')) (0, $1BMUZ.numberQuestionListener)();
            else if ((0, $cEKee.nameScreenDynamic).includes('height')) (0, $62Jhk.heightQuestionListener)();
        } else (0, $er9E0.customFeildGoBackAnimationHandler)(`${(0, $cEKee.nameScreenDynamic)}`);
    });
    // on click continue button
    const buttonTextAreaContinue = document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .textareaContinue__btn`);
    buttonTextAreaContinue.addEventListener('click', async function() {
        if (!(0, $cEKee.listNamePageQuestion).find((list)=>list === (0, $cEKee.nameScreenDynamic))) (0, $cEKee.listNamePageQuestion).push((0, $cEKee.nameScreenDynamic));
        (0, $cEKee.setListNamePageQuestion)((0, $cEKee.listNamePageQuestion));
        document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .textareaContinue__btn`)?.classList.add('disabled');
        document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .textareaContinue__btn .loading__wrapper`)?.classList.remove('hidden');
        const loaderIcon = document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .loader__icon`);
        if (loaderIcon) {
            loaderIcon.innerHTML = '';
            loaderIcon.insertAdjacentHTML('beforeend', `<img src="${(0, $cEKee.appUrl)}/assets/icons/rolling.png" />`);
        }
        const item = (0, $cEKee.nameScreenDynamic).split('--')[1];
        const textAreaVal = textAreaElement.value;
        const answersWithCurrent = {
            ...(0, $cEKee.listDataQuestion),
            [item]: textAreaVal
        };
        (0, $cEKee.listDataQuestion)[item] = textAreaVal;
        (0, $cEKee.setListDataQuestion)((0, $cEKee.listDataQuestion));
        const fields = (0, $cEKee.questionnaireFields)?.length ? (0, $cEKee.questionnaireFields) : (0, $cEKee.form)?.form?.custom_fields ?? [];
        const currentField = fields.find((f)=>f && f.id == item);
        const minDisqualifiers = (0, $cEKee.form)?.appointment_channel?.min_disqualifier_matches ?? (0, $cEKee.form)?.consult_min_disqualifier_matches ?? 1;
        if (currentField && (0, $gMDh6.evaluateDisqualifier)(currentField, textAreaVal) && (0, $gMDh6.shouldDisqualifyNow)(fields, answersWithCurrent, minDisqualifiers)) {
            try {
                const fieldLabels = {};
                const sourceFields = (0, $cEKee.questionnaireFields)?.length ? (0, $cEKee.questionnaireFields) : (0, $cEKee.form)?.form?.custom_fields ?? [];
                sourceFields.forEach((f)=>{
                    if (f && f.id) fieldLabels[f.id] = f.label || f.title || (0, $knjAn.t)('custom_field');
                });
                const formId = (0, $cEKee.questionnaireFormId) ?? (0, $cEKee.form)?.form?.id;
                if (typeof formId === 'string' && formId.startsWith('ac-')) {
                    const acId = parseInt(formId.replace(/^ac-/, ''), 10);
                    await (0, $hWSV7.updateQualificationResponses)((0, $cEKee.leadTextId), acId, (0, $cEKee.listDataQuestion), fieldLabels);
                } else await (0, $hWSV7.updateConsultRequestFields)((0, $cEKee.leadTextId), (0, $cEKee.listDataQuestion), fieldLabels);
            } catch (_) {}
            if ((0, $cEKee.leadInfo)?.id) {
                await (0, $2q2gk.updateLeadStep)((0, $cEKee.leadInfo).id, 'disqualified', 'true');
                (0, $er9E0.setSessionEndStepSentForLeadId)((0, $cEKee.leadInfo).id);
            }
            document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .textareaContinue__btn`)?.classList.remove('disabled');
            document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .textareaContinue__btn .loading__wrapper`)?.classList.add('hidden');
            const loaderIcon = document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .loader__icon`);
            if (loaderIcon) {
                loaderIcon.innerHTML = '';
                loaderIcon.insertAdjacentHTML('beforeend', '<i class="ri-arrow-right-line"></i>');
            }
            (0, $9bGUq.clearCustomFields)();
            (0, $cEKee.clearQuestionnaireContext)();
            (0, $er9E0.setIsDisqualified)(true);
            (0, $er9E0.navigate)((0, $cIxq8.SCREEN).THE_END);
            return;
        }
        const formId = (0, $cEKee.questionnaireFormId) ?? (0, $cEKee.form)?.form?.id;
        let idx = fields.findIndex((custom)=>custom && custom.id == (0, $cEKee.nameScreenDynamic).split('--')[1]);
        if (idx == fields.length - 1) try {
            const fieldLabels = {};
            const sourceFields = (0, $cEKee.questionnaireFields)?.length ? (0, $cEKee.questionnaireFields) : (0, $cEKee.form)?.form?.custom_fields ?? [];
            sourceFields.forEach((f)=>{
                if (f && f.id) fieldLabels[f.id] = f.label || f.title || (0, $knjAn.t)('custom_field');
            });
            if (typeof formId === 'string' && formId.startsWith('ac-')) {
                const acId = parseInt(formId.replace(/^ac-/, ''), 10);
                await (0, $hWSV7.updateQualificationResponses)((0, $cEKee.leadTextId), acId, (0, $cEKee.listDataQuestion), fieldLabels);
            } else await (0, $hWSV7.updateConsultRequestFields)((0, $cEKee.leadTextId), (0, $cEKee.listDataQuestion), fieldLabels);
            document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .textareaContinue__btn`)?.classList.remove('disabled');
            document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .textareaContinue__btn .loading__wrapper`)?.classList.add('hidden');
            const textAreaElement = document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .textareaQuestion`);
            const loaderIcon = document.querySelector(`${(0, $cEKee.nameScreenDynamic)} .loader__icon`);
            textAreaElement.value = '';
            if (loaderIcon) {
                loaderIcon.innerHTML = '';
                loaderIcon.insertAdjacentHTML('beforeend', `<i class="ri-arrow-right-line"></i>`);
            }
            (0, $9bGUq.clearCustomFields)();
            (0, $cEKee.clearQuestionnaireContext)();
            (0, $87Cn1.navigateToNextPage)();
        } catch (error) {
            (0, $gZEOs.toastError)(error.response?.data?.message);
        }
        else {
            (0, $cEKee.setProgressQuestion)({
                ...(0, $cEKee.progressQuestion),
                currentQuestion: (0, $cEKee.progressQuestion).currentQuestion + 1,
                progress: ((0, $cEKee.progressQuestion).currentQuestion + 1) / (0, $cEKee.progressQuestion).total * 100
            });
            (0, $9bGUq.loadCustomFields)(fields[idx + 1]);
        }
    });
}

});








parcelRegister("hlXLP", function(module, exports) {

$parcel$export(module.exports, "clearAllWidgetIframe", () => $ca22c3039bbee348$export$77cd5c801d3b1d0e);
function $ca22c3039bbee348$export$77cd5c801d3b1d0e() {
    document.querySelectorAll('.widgetScreen__container iframe').forEach((i)=>i.removeAttribute('src'));
}

});

parcelRegister("1H8Mz", function(module, exports) {

$parcel$export(module.exports, "clearInputsAskQs", () => $13c09e9d174e1ab6$export$2f1b3c7f13c63a2f);

var $9bGUq = parcelRequire("9bGUq");

var $cEKee = parcelRequire("cEKee");
function $13c09e9d174e1ab6$export$2f1b3c7f13c63a2f() {
    document.querySelectorAll('.askQuestion__container .valid').forEach((i)=>{
        i.classList.remove('valid');
    });
    document.querySelectorAll('.askQuestion__container .invalid').forEach((i)=>{
        i.classList.remove('invalid');
    });
    document.querySelectorAll('.askQuestion__container input').forEach((i)=>{
        i.value = '';
    });
    document.querySelectorAll('.askQuestion__container textarea').forEach((i)=>{
        i.value = '';
    });
    (0, $9bGUq.clearEmailOptin)();
    (0, $cEKee.setTermsAndPrivacyAccepted)(false);
    document.querySelectorAll('.askQuestion__container .terms-privacy-checkbox').forEach((el)=>el.classList.remove('is-checked'));
    const container = document.querySelector('.askQuestion__container');
    if (container) container.classList.remove('step-2');
}

});

parcelRegister("bLott", function(module, exports) {

$parcel$export(module.exports, "selectGenderListeners", () => $890711949b224043$export$335c3311ca10ac1d);

var $cIxq8 = parcelRequire("cIxq8");

var $cEKee = parcelRequire("cEKee");

var $d6VOC = parcelRequire("d6VOC");

var $4Le5k = parcelRequire("4Le5k");

var $er9E0 = parcelRequire("er9E0");

var $a5XF8 = parcelRequire("a5XF8");
function $890711949b224043$export$335c3311ca10ac1d() {
    document.querySelector('.gender__container .main_gender').style.background = `${0, $cEKee.primaryColor}09`;
    const elementsGender = document.querySelectorAll('.gender__container .main_gender .category_item');
    if (elementsGender) elementsGender.forEach((element)=>{
        element.addEventListener('click', $890711949b224043$var$handelSelectGender);
    });
    document.querySelector('.gender__container .selectGender__actions .genderContinue__btn').classList[(0, $cEKee.selectedGender) ? 'remove' : 'add']('disabled');
    document.querySelector(`.gender__container .genderContinue__btn`).addEventListener('click', $890711949b224043$var$handleClickContinue);
    document.querySelector('.category_item .select__gender')?.addEventListener('keypress', $890711949b224043$var$cancelEnterButton);
    /* On click enter */ const screenPhone = document.querySelector('.gender__container');
    if (screenPhone) screenPhone.addEventListener('keydown', $890711949b224043$var$handlePressEnter);
}
function $890711949b224043$var$cancelEnterButton(e) {
    if (e.key === 'Enter') e.preventDefault();
}
function $890711949b224043$var$handleClickContinue(e) {
    if (0, $cEKee.showBodyAreaSelection) {
        (0, $d6VOC.renderbodySelectionUI)((0, $cEKee.selectedGender) || 'non-binary');
        (0, $4Le5k.bodyAreaSelectionListeners)();
        (0, $er9E0.navigate)((0, $cIxq8.SCREEN).BODY_AREA_SELECTION);
    } else (0, $cEKee.staffId) ? (0, $a5XF8.handleSelectProvider)(e) : (0, $er9E0.handleCheckProviders)();
}
function $890711949b224043$var$handelSelectGender(event) {
    document.querySelector('.category_item .select__gender').focus();
    const elementSelected = (0, $cEKee.selectedGender) ? document.getElementById(`${(0, $cEKee.selectedGender)}`) : null;
    const currentSelectedGender = event.currentTarget;
    if (elementSelected) {
        (0, $cEKee.selectedGender) !== currentSelectedGender.id && elementSelected.classList.remove('gender--selected');
        currentSelectedGender.classList.toggle('gender--selected');
    } else currentSelectedGender.classList.toggle('gender--selected');
    const gender = currentSelectedGender.classList.contains('gender--selected');
    (0, $cEKee.setSelectedGender)(gender ? currentSelectedGender.id : null);
    document.querySelector('.gender__container .selectGender__actions .genderContinue__btn').classList[(0, $cEKee.selectedGender) ? 'remove' : 'add']('disabled');
}
function $890711949b224043$var$handlePressEnter(event) {
    event.stopPropagation();
    if (event.key === 'Enter' && !document.querySelector(`.gender__container .genderContinue__btn`).classList.contains('disabled')) document.querySelector(`.gender__container .genderContinue__btn`).click();
}

});
parcelRegister("d6VOC", function(module, exports) {

$parcel$export(module.exports, "renderbodySelectionUI", () => $98b8aed17312f18f$export$5151340e375d6969);

var $cEKee = parcelRequire("cEKee");
function $98b8aed17312f18f$export$5151340e375d6969(type = 'non-binary') {
    let tempUIMaleStr = `
    <div class="step__body ">
        <div class="step__image ">
            <img src="assets/images/webp/gender_male.webp" alt="Male">
            <div class="form__cols">
                <div class="form__col step__col--body">
                    <div class="form__row">
                        <div class="form__controls">
                            <div class="checkbox checkbox--male checkbox--male-chest">
                                <input type="checkbox" id="maleBreast" data-category="Breasts">

                                <label for="maleBreast" data-text="Breasts">
                                    Chest
                                </label>
                            </div>
                        </div>
                    </div>

                    <div class="form__row">
                        <div class="form__controls">
                            <div class="checkbox checkbox--male checkbox--male-face">
                                <input type="checkbox" id="maleFace" data-category="Face"
                                    class="js-face-checkbox">

                                <label for="maleFace" data-text="Face" class="js-face-label">
                                    Face
                                </label>
                            </div>
                        </div>
                    </div>

                    <div class="form__row">
                        <div class="form__controls">
                            <div class="checkbox checkbox--male checkbox--male-abdomen">
                                <input type="checkbox" id="maleAbdomen" data-category="Abdomen">

                                <label for="maleAbdomen" data-text="Abdomen">
                                    Abdomen
                                </label>
                            </div>
                        </div>
                    </div>

                    <div class="form__row">
                        <div class="form__controls">
                            <div class="checkbox checkbox--male checkbox--male-back">

                                <input type="checkbox" id="maleBackButt" data-category="Back & Butt">

                                <label for="maleBackButt" data-text="Back & Butt">
                                    <span class="checkbox__element"></span>

                                    Back & Butt
                                </label>
                            </div>
                        </div>
                    </div>

                    <div class="form__row">
                        <div class="form__controls">
                            <div class="checkbox checkbox--male checkbox--male-genital">
                                <input type="checkbox" id="maleGenitals" data-category="Genital">

                                <label for="maleGenitals" data-text="Genital">
                                    Genital
                                </label>
                            </div>
                        </div>
                    </div>

                    <div class="form__row">
                        <div class="form__controls">
                            <div class="checkbox checkbox--male checkbox--male-arms">
                                <input type="checkbox" id="maleArmsLegs" data-category="Arms & Legs">

                                <label for="maleArmsLegs" data-text="Arms & Legs">
                                    <span class="checkbox__element"></span>

                                    Arms & Legs
                                </label>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="form__col step__col--face display__none">
                    <div class="form__row">
                        <div class="form__controls">
                            <div class="checkbox-face checkbox-face--male checkbox-face--hair">
                                <input type="checkbox" id="maleHair" data-category="Hair">

                                <label for="maleHair" data-text="Hair">
                                    Hair
                                </label>
                            </div>
                        </div>
                    </div>

                    <div class="form__row">
                        <div class="form__controls">
                            <div class="checkbox-face checkbox-face--male checkbox-face--eyes">
                                <input type="checkbox" id="maleEyes" data-category="Eyes">

                                <label for="maleEyes" data-text="Eyes">
                                    Eyes
                                </label>
                            </div>
                        </div>
                    </div>

                    <div class="form__row">
                        <div class="form__controls">
                            <div class="checkbox-face checkbox-face--male checkbox-face--nose">
                                <input type="checkbox" id="maleNose" data-category="Nose">

                                <label for="maleNose" data-text="Nose">
                                    Nose
                                </label>
                            </div>
                        </div>
                    </div>

                    <div class="form__row">
                        <div class="form__controls">
                            <div class="checkbox-face checkbox-face--male checkbox-face--lips">
                                <input type="checkbox" id="maleLips" data-category="Lips">

                                <label for="maleLips" data-text="Lips">
                                    Lips
                                </label>
                            </div>
                        </div>
                    </div>

                    <div class="form__row">
                        <div class="form__controls">
                            <div class="checkbox-face checkbox-face--male checkbox-face--neck">
                                <input type="checkbox" id="maleNeck" data-category="Neck">

                                <label for="maleNeck" data-text="Neck">
                                    Neck
                                </label>
                            </div>
                        </div>
                    </div>

                    <div class="form__row">
                        <div class="form__controls">
                            <div class="checkbox-face checkbox-face--male checkbox-face--cheek">
                                <input type="checkbox" id="maleCheekChin"
                                    data-category="Cheek & Chin">

                                <label for="maleCheekChin" data-text="Cheek & Chin">
                                    Cheek & Chin
                                </label>
                            </div>
                        </div>
                    </div>

                    <div class="form__row">
                        <div class="form__controls">
                            <div class="checkbox-face checkbox-face--male checkbox-face--ears">
                                <input type="checkbox" id="maleEars" data-category="Ears">

                                <label for="maleEars" data-text="Ears">
                                    Ears
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    `;
    let tempUIFemaleStr = `
    <div class="step__body ">
        <div class="step__image ">
            <img src="assets/images/webp/gender_female.webp" alt="Female">
            <div class="form__cols">
                <div class="form__col step__col--body">
                    <div class="form__row">
                        <div class="form__controls">
                            <div class="checkbox checkbox--female checkbox--female-chest">
                                <input type="checkbox" id="femaleBreast" data-category="Breasts">

                                <label for="femaleBreast" data-text="Breasts">
                                    Breasts
                                </label>
                            </div>
                        </div>
                    </div>

                    <div class="form__row">
                        <div class="form__controls">
                            <div class="checkbox checkbox--female checkbox--female-face">
                                <input type="checkbox" id="femaleFace" data-category="Face"
                                    class="js-face-checkbox">

                                <label for="femaleFace" data-text="Face" class="js-face-label">
                                    Face
                                </label>
                            </div>
                        </div>
                    </div>

                    <div class="form__row">
                        <div class="form__controls">
                            <div class="checkbox checkbox--female checkbox--female-abdomen">
                                <input type="checkbox" id="femaleAbdomen" data-category="Abdomen">

                                <label for="femaleAbdomen" data-text="Abdomen">
                                    Abdomen
                                </label>
                            </div>
                        </div>
                    </div>

                    <div class="form__row">
                        <div class="form__controls">
                            <div class="checkbox checkbox--female checkbox--female-back">

                                <input type="checkbox" id="femaleBackButt"
                                    data-category="Back & Butt">

                                <label for="femaleBackButt" data-text="Back & Butt">
                                    <span class="checkbox__element"></span>

                                    Back & Butt
                                </label>
                            </div>
                        </div>
                    </div>

                    <div class="form__row">
                        <div class="form__controls">
                            <div class="checkbox checkbox--female checkbox--female-genital">
                                <input type="checkbox" id="femaleGenitals" data-category="Genital">

                                <label for="femaleGenitals" data-text="Genital">
                                    Genital
                                </label>
                            </div>
                        </div>
                    </div>

                    <div class="form__row">
                        <div class="form__controls">
                            <div class="checkbox checkbox--female checkbox--female-arms">
                                <input type="checkbox" id="femaleArmsLegs"
                                    data-category="Arms & Legs">

                                <label for="femaleArmsLegs" data-text="Arms & Legs">
                                    <span class="checkbox__element"></span>

                                    Arms & Legs
                                </label>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="form__col step__col--face display__none">
                    <div class="form__row">
                        <div class="form__controls">
                            <div class="checkbox-face checkbox-face--female checkbox-face--hair">
                                <input type="checkbox" id="femaleHair" data-category="Hair">

                                <label for="femaleHair" data-text="Hair">
                                    Hair
                                </label>
                            </div>
                        </div>
                    </div>

                    <div class="form__row">
                        <div class="form__controls">
                            <div class="checkbox-face checkbox-face--female checkbox-face--eyes">
                                <input type="checkbox" id="femaleEyes" data-category="Eyes">

                                <label for="femaleEyes" data-text="Eyes">
                                    Eyes
                                </label>
                            </div>
                        </div>
                    </div>

                    <div class="form__row">
                        <div class="form__controls">
                            <div class="checkbox-face checkbox-face--female checkbox-face--nose">
                                <input type="checkbox" id="femaleNose" data-category="Nose">

                                <label for="femaleNose" data-text="Nose">
                                    Nose
                                </label>
                            </div>
                        </div>
                    </div>

                    <div class="form__row">
                        <div class="form__controls">
                            <div class="checkbox-face checkbox-face--female checkbox-face--lips">
                                <input type="checkbox" id="femaleLips" data-category="Lips">

                                <label for="femaleLips" data-text="Lips">
                                    Lips
                                </label>
                            </div>
                        </div>
                    </div>

                    <div class="form__row">
                        <div class="form__controls">
                            <div class="checkbox-face checkbox-face--female checkbox-face--neck">
                                <input type="checkbox" id="femaleNeck" data-category="Neck">

                                <label for="femaleNeck" data-text="Neck">
                                    Neck
                                </label>
                            </div>
                        </div>
                    </div>

                    <div class="form__row">
                        <div class="form__controls">
                            <div class="checkbox-face checkbox-face--female checkbox-face--cheek">
                                <input type="checkbox" id="femaleCheekChin"
                                    data-category="Cheek & Chin">

                                <label for="femaleCheekChin" data-text="Cheek & Chin">
                                    Cheek & Chin
                                </label>
                            </div>
                        </div>
                    </div>

                    <div class="form__row">
                        <div class="form__controls">
                            <div class="checkbox-face checkbox-face--female checkbox-face--ears">
                                <input type="checkbox" id="femaleEars" data-category="Ears">

                                <label for="femaleEars" data-text="Ears">
                                    Ears
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    `;
    let tempUINonBinaryStr = `
    <div class="step__body">
        <div class="step__image">
            <img class="js-non-binary-figure" src="assets/images/webp/gender_female.webp"
                alt="Female">

            <div class="form__cols">
                <div class="form__col step__col--body">
                    <div class="form__row">
                        <div class="form__controls">
                            <div class="checkbox checkbox--female checkbox--female-chest">
                                <input type="checkbox" id="nonBinaryBreast"
                                    data-category="Breasts">

                                <label for="nonBinaryBreast" data-text="Breasts">
                                    Breasts
                                </label>
                            </div>
                        </div>
                    </div>

                    <div class="form__row">
                        <div class="form__controls">
                            <div class="checkbox checkbox--female checkbox--female-face">
                                <input type="checkbox" id="nonBinaryFace"
                                    data-category="Face" class="js-face-checkbox">

                                <label for="nonBinaryFace" data-text="Face"
                                    class="js-face-label">
                                    Face
                                </label>
                            </div>
                        </div>
                    </div>

                    <div class="form__row">
                        <div class="form__controls">
                            <div class="checkbox checkbox--female checkbox--female-abdomen">
                                <input type="checkbox" id="nonBinaryAbdomen"
                                    data-category="Abdomen">

                                <label for="nonBinaryAbdomen" data-text="Abdomen">
                                    Abdomen
                                </label>
                            </div>
                        </div>
                    </div>

                    <div class="form__row">
                        <div class="form__controls">
                            <div class="checkbox checkbox--female checkbox--female-back">

                                <input type="checkbox" id="nonBinaryBackButt"
                                    data-category="Back & Butt">

                                <label for="nonBinaryBackButt" data-text="Back & Butt">
                                    <span class="checkbox__element"></span>

                                    Back & Butt
                                </label>
                            </div>
                        </div>
                    </div>

                    <div class="form__row">
                        <div class="form__controls">
                            <div class="checkbox checkbox--female checkbox--female-genital">
                                <input type="checkbox" id="nonBinaryGenitals"
                                    data-category="Genital">

                                <label for="nonBinaryGenitals" data-text="Genital">
                                    Genital
                                </label>
                            </div>
                        </div>
                    </div>

                    <div class="form__row">
                        <div class="form__controls">
                            <div class="checkbox checkbox--female checkbox--female-arms">
                                <input type="checkbox" id="nonBinaryArmsLegs"
                                    data-category="Arms & Legs">

                                <label for="nonBinaryArmsLegs" data-text="Arms & Legs">
                                    <span class="checkbox__element"></span>

                                    Arms & Legs
                                </label>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="form__col step__col--face display__none">
                    <div class="form__row">
                        <div class="form__controls">
                            <div
                                class="checkbox-face checkbox-face--female checkbox-face--hair">
                                <input type="checkbox" id="nonBinaryHair"
                                    data-category="Hair">

                                <label for="nonBinaryHair" data-text="Hair">
                                    Hair
                                </label>
                            </div>
                        </div>
                    </div>

                    <div class="form__row">
                        <div class="form__controls">
                            <div
                                class="checkbox-face checkbox-face--female checkbox-face--eyes">
                                <input type="checkbox" id="nonBinaryEyes"
                                    data-category="Eyes">

                                <label for="nonBinaryEyes" data-text="Eyes">
                                    Eyes
                                </label>
                            </div>
                        </div>
                    </div>

                    <div class="form__row">
                        <div class="form__controls">
                            <div
                                class="checkbox-face checkbox-face--female checkbox-face--nose">
                                <input type="checkbox" id="nonBinaryNose"
                                    data-category="Nose">

                                <label for="nonBinaryNose" data-text="Nose">
                                    Nose
                                </label>
                            </div>
                        </div>
                    </div>

                    <div class="form__row">
                        <div class="form__controls">
                            <div
                                class="checkbox-face checkbox-face--female checkbox-face--lips">
                                <input type="checkbox" id="nonBinaryLips"
                                    data-category="Lips">

                                <label for="nonBinaryLips" data-text="Lips">
                                    Lips
                                </label>
                            </div>
                        </div>
                    </div>

                    <div class="form__row">
                        <div class="form__controls">
                            <div
                                class="checkbox-face checkbox-face--female checkbox-face--neck">
                                <input type="checkbox" id="nonBinaryNeck"
                                    data-category="Neck">

                                <label for="nonBinaryNeck" data-text="Neck">
                                    Neck
                                </label>
                            </div>
                        </div>
                    </div>

                    <div class="form__row">
                        <div class="form__controls">
                            <div
                                class="checkbox-face checkbox-face--female checkbox-face--cheek">
                                <input type="checkbox" id="nonBinaryCheekChin"
                                    data-category="Cheek & Chin">

                                <label for="nonBinaryCheekChin" data-text="Cheek & Chin">
                                    Cheek & Chin
                                </label>
                            </div>
                        </div>
                    </div>

                    <div class="form__row">
                        <div class="form__controls">
                            <div
                                class="checkbox-face checkbox-face--female checkbox-face--ears">
                                <input type="checkbox" id="nonBinaryEars"
                                    data-category="Ears">

                                <label for="nonBinaryEars" data-text="Ears">
                                    Ears
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div
        </div>
    </div>
    `;
    let tempDom = document.querySelector('.bodyAreaSelection__container .content__wrapper');
    if (tempDom) {
        if (type === 'male') tempDom.innerHTML = tempUIMaleStr;
        if (type === 'female') tempDom.innerHTML = tempUIFemaleStr;
        if (type === 'non-binary') tempDom.innerHTML = tempUINonBinaryStr;
    }
    $98b8aed17312f18f$var$activeForCategories();
}
function $98b8aed17312f18f$var$activeForCategories() {
    const nameOfCategories = (0, $cEKee.categories).map((item)=>item.name);
    const inputs = document.querySelectorAll('.bodyAreaSelection__container .form__row input[type=checkbox]');
    inputs.forEach((input)=>{
        const categoryOfInput = input.dataset.category;
        if (nameOfCategories.includes(categoryOfInput)) input.parentElement.querySelector('label')?.classList.add('isActive');
    });
}

});

parcelRegister("4Le5k", function(module, exports) {

$parcel$export(module.exports, "bodyAreaSelectionListeners", () => $37767a2b77df3b3a$export$5684d2baad4a8d84);

var $cEKee = parcelRequire("cEKee");

var $er9E0 = parcelRequire("er9E0");

var $a5XF8 = parcelRequire("a5XF8");
function $37767a2b77df3b3a$export$5684d2baad4a8d84() {
    // onclick input face
    const elementInputFace = document.querySelector('.bodyAreaSelection__container .js-face-checkbox');
    if (elementInputFace) elementInputFace?.addEventListener('change', $37767a2b77df3b3a$var$handleOnchangeInputFace);
    // click continue button
    const buttonContinue = document.querySelector('.bodyAreaSelection__container .bodySelectionContinue__btn');
    buttonContinue?.addEventListener('click', $37767a2b77df3b3a$var$handleOnclickContinueButton);
    // onchange input checkbox
    const inputs = document.querySelectorAll('.bodyAreaSelection__container .form__row input[type=checkbox]');
    inputs.forEach((input)=>input.addEventListener('change', $37767a2b77df3b3a$var$handleOnchangeInputFace));
}
const $37767a2b77df3b3a$var$handleOnchangeInputFace = (event)=>{
    if (event.target.classList.contains('js-face-checkbox')) {
        const bodyContainer = event.target.closest('.bodyAreaSelection__container');
        if (event.target.checked) {
            document.querySelector('.bodyAreaSelection__container .bodySelectionContinue__btn').classList.remove('disabled');
            bodyContainer.querySelector('.step__body').classList.add('zoom');
            bodyContainer.querySelector('.step__image').classList.add('zoom');
        } else Array.from(bodyContainer.querySelectorAll('.bodyAreaSelection__container .step__col--face input[type="checkbox"]'))?.forEach((item)=>{
            item.checked = false;
        });
    }
    if ($37767a2b77df3b3a$var$getLengthInputChecked() > 0) document.querySelector('.bodyAreaSelection__container .bodySelectionContinue__btn')?.classList.remove('disabled');
    else document.querySelector('.bodyAreaSelection__container .bodySelectionContinue__btn')?.classList.add('disabled');
    if (document.querySelector('.step__image').classList.contains('zoom')) document.querySelector('.bodyAreaSelection__container .bodySelectionContinue__btn')?.classList.remove('disabled');
};
const $37767a2b77df3b3a$var$getLengthInputChecked = ()=>{
    const isFace = document.querySelector('.bodyAreaSelection__container .step__image').classList.contains('zoom');
    if (isFace) {
        const inputs = document.querySelectorAll('.bodyAreaSelection__container .step__col--face input[type="checkbox"]');
        return Array.from(inputs)?.filter((input)=>input.checked)?.length;
    }
    const inputs = document.querySelectorAll('.bodyAreaSelection__container .step__col--body input[type=checkbox]');
    return Array.from(inputs)?.filter((input)=>input.checked)?.length;
};
const $37767a2b77df3b3a$var$handleOnclickContinueButton = (event)=>{
    if (event.target) {
        const bodyContainer = event.target.closest('.bodyAreaSelection__container');
        const bodyZoom = bodyContainer.querySelector('.step__body');
        const imageZoom = bodyContainer.querySelector('.step__image');
        if (bodyZoom.classList.contains('zoom') || imageZoom.classList.contains('zoom')) {
            bodyZoom.classList.remove('zoom');
            imageZoom.classList.remove('zoom');
        } else {
            const inputs = document.querySelectorAll('.bodyAreaSelection__container .form__row input[type="checkbox"]');
            let listCategorySelected = [];
            inputs.forEach((input)=>{
                if (input.checked) {
                    const getCategory = (0, $cEKee.categories).find((item)=>item.name === input.dataset.category);
                    listCategorySelected.push(getCategory);
                }
            });
            if ($37767a2b77df3b3a$var$checkIsFace(listCategorySelected)) listCategorySelected = listCategorySelected.filter((item)=>item.name !== 'Face');
            (0, $cEKee.setBodyAreaSelected)(listCategorySelected);
            $37767a2b77df3b3a$var$goToNextPage(event);
        }
    }
};
const $37767a2b77df3b3a$var$goToNextPage = (e)=>{
    (0, $cEKee.staffId) ? (0, $a5XF8.handleSelectProvider)(e) : (0, $er9E0.handleCheckProviders)();
};
const $37767a2b77df3b3a$var$checkIsFace = (cate)=>{
    const listCategory = cate.map((item)=>item.name);
    const inputs = document.querySelectorAll('.bodyAreaSelection__container .step__col--face input[type="checkbox"]');
    return Array.from(inputs).some((item)=>listCategory.includes(item.dataset.category));
};

});


parcelRegister("hprW2", function(module, exports) {

$parcel$export(module.exports, "loadProviderList", () => $caca70ce6fc02cee$export$c85464346766bbb9);

var $cEKee = parcelRequire("cEKee");

var $knjAn = parcelRequire("knjAn");
function $caca70ce6fc02cee$export$c85464346766bbb9(providers) {
    let list = document.querySelector('.providers__container .providers__list');
    list.innerHTML = '';
    if (providers.length <= 0) list.insertAdjacentHTML('beforeend', `
        <div class="noProcedures">${(0, $knjAn.t)('no_providers_found')}</div>
        `);
    if (providers.length > 0) list.insertAdjacentHTML('beforeend', `
        <div class="providers__list--title">${(0, $knjAn.t)('select_provider')}</div>
        `);
    if (providers.length > 1 && (0, $cEKee.form)?.appointment_channel?.show_any_provider_option) list.insertAdjacentHTML('beforeend', `
            <div class="provider no-preference-provider" data-provider-id="-1" data-provider="no-preference">
                <i class="ri-group-line"></i>
                <div>
                    <span class="provider__name">${(0, $knjAn.t)('any_provider')}</span>
                    <div style="margin-right: 10px;" class="provider__title">${(0, $knjAn.t)('soonest_available')}</div>
                </div>
                <span class="provider__option" data-provider-id="-1">
                    <i class="provider__icon-check ri-check-line"></i>
                </span>
            </div>
            `);
    if (providers.length > 0) for (const i of providers){
        const name = i.first_name + ' ' + i.last_name;
        list.insertAdjacentHTML('beforeend', `
            <div class="provider" data-provider-id="${i.id}" data-provider="${name}">
                <img src="${i?.photo ? i.photo : `${0, $cEKee.appUrl}/assets/images/png/default-avatar.png`}"/>
                <div class="provider__info-wrapper">
                    <span class="provider__name">${name}</span>
                    ${i.title ? `<div style="margin-right: 10px;" class="provider__title">${i.title}</div>` : ''}
                </div>
                <span class="provider__option" data-provider-id="${i.id}">
                    <i class="provider__icon-check ri-check-line"></i>
                </span>
            </div>
            `);
    }
}
function $caca70ce6fc02cee$export$774f7dd340a573fe(unSelectedProviders) {
    const providerArray = document.querySelectorAll('.providers__container .provider');
    for(let i = 0; i < unSelectedProviders.length; i++)providerArray.forEach((element)=>{
        if (element.getAttribute("data-provider-id") == unSelectedProviders[i]?.id) element.classList.add('hidden');
    });
}

});

parcelRegister("hGWxM", function(module, exports) {

$parcel$export(module.exports, "locationListeners", () => $ce13c57de76f11b6$export$5bc656f9bd3bafc5);
$parcel$export(module.exports, "handleLocationPage", () => $ce13c57de76f11b6$export$fe1df56c25474635);

var $knjAn = parcelRequire("knjAn");

var $ig8jH = parcelRequire("ig8jH");

var $cIxq8 = parcelRequire("cIxq8");

var $cEKee = parcelRequire("cEKee");

var $1f5FT = parcelRequire("1f5FT");

var $2XKfp = parcelRequire("2XKfp");

var $8QS3m = parcelRequire("8QS3m");

var $d0tLC = parcelRequire("d0tLC");

var $hprW2 = parcelRequire("hprW2");

var $cbfUF = parcelRequire("cbfUF");

var $62LVp = parcelRequire("62LVp");

var $er9E0 = parcelRequire("er9E0");

var $bK4nS = parcelRequire("bK4nS");

var $lmlIJ = parcelRequire("lmlIJ");

var $a5XF8 = parcelRequire("a5XF8");
// Multi-channel widgets (`appointment_channel_ids`) boot with only the DEFAULT
// channel's config, and each appointment channel is bound to exactly one
// location. Picking any other location must swap in that location's channel —
// otherwise the provider list filters the wrong channel's roster by the chosen
// location and always comes up empty ("No Providers Found").
const $ce13c57de76f11b6$var$channelConfigCache = {};
async function $ce13c57de76f11b6$export$2a961da5c0a299be(locationId) {
    const ids = (0, $cEKee.form)?.appointment_channel_ids;
    if (!Array.isArray(ids) || ids.length < 2 || !locationId) return;
    if ((0, $cEKee.form)?.appointment_channel?.location?.id === locationId) return;
    for (const id of ids){
        if (id === (0, $cEKee.form)?.appointment_channel?.id) continue;
        let channel = $ce13c57de76f11b6$var$channelConfigCache[id];
        if (!channel) {
            try {
                const res = await (0, $1f5FT.getFormByFormId)((0, $cEKee.formId), id);
                channel = res?.data?.appointment_channel;
            } catch (e) {
                continue;
            }
            if (channel) $ce13c57de76f11b6$var$channelConfigCache[id] = channel;
        }
        if (channel?.location?.id === locationId) {
            (0, $cEKee.form).appointment_channel = channel;
            (0, $cEKee.setAppointmentChannelId)(channel.id);
            (0, $er9E0.refreshProvidersStore)(true);
            return;
        }
    }
}
function $ce13c57de76f11b6$export$5bc656f9bd3bafc5() {
    /* on select location*/ document.querySelectorAll('.locations__container .location').forEach((i)=>{
        i.addEventListener('click', ()=>{
            const id = parseInt(i.getAttribute('data-location-id'));
            (0, $cbfUF.selectLocation)(id);
        });
    });
    /* on click Continue after select location */ document.querySelector('.locationContinue__btn').addEventListener('click', async ()=>{
        // Re-prompt the delivery-mode step on every fresh Continue from the
        // location step so the gate in handleLocationPage() shows it again.
        if ((0, $cEKee.form)?.appointment_channel?.delivery_mode_selection) (0, $cEKee.setSelectedDeliveryMode)(null);
        (0, $2XKfp.toggleLoading)(true);
        try {
            await $ce13c57de76f11b6$export$2a961da5c0a299be((0, $cEKee.selectedLocation));
        } finally{
            (0, $2XKfp.toggleLoading)(false);
        }
        $ce13c57de76f11b6$export$fe1df56c25474635();
    });
    /* on click back button */ document.querySelector('.locations__container .backOneStep__btn').addEventListener('click', ()=>{
        (0, $cEKee.setIsInstantQuote)(false);
        (0, $cEKee.setSelectedDeliveryMode)(null);
        document.querySelector('.no-preference-provider')?.classList?.add('hidden');
    });
    if (0, $cEKee.appointmentChannelId) document.querySelector('.locations__container .backOneStep__btn').classList.add("hide");
}
const $ce13c57de76f11b6$export$fe1df56c25474635 = ()=>{
    console.log('[DBG] handleLocationPage, selectedLocation=', (0, $cEKee.selectedLocation), 'providers=', JSON.stringify((0, $cEKee.providers)?.map?.((p)=>({
            id: p.id,
            loc: p.location_ids
        }))));
    if ((0, $cEKee.isBookAppointment) || (0, $cEKee.appointmentChannelId)) {
        // Gated "How would you like to meet?" step — after location, before
        // service. Only when the channel opts in and the visitor hasn't chosen
        // yet. The mode step's Continue re-enters handleLocationPage() with the
        // mode set, so it falls through to the normal provider/service routing.
        // deliveryModeListeners() returns false when the channel has a single
        // delivery bucket — the mode was auto-selected, skip the step.
        if ((0, $cEKee.form)?.appointment_channel?.delivery_mode_selection && !(0, $cEKee.selectedDeliveryMode)) {
            if ((0, $bK4nS.deliveryModeListeners)()) {
                (0, $er9E0.navigate)((0, $cIxq8.SCREEN).DELIVERY_MODE);
                return;
            }
        }
        // Auto-select soonest provider: skip the provider picker entirely and
        // engage the existing "any provider" (-1) path so the server assigns the
        // soonest-available provider for the chosen slot.
        // Only short-circuit once the service is resolved — the visitor already
        // picked one, or the channel offers a single service. With multiple
        // services and none selected, fall through to the routing below
        // (PATIENTS → services page) so the visitor picks a service first;
        // the services Continue re-enters handleLocationPage() with
        // `selectedProcedures` set and the gate then fires. Otherwise the
        // booking-payload fallback attaches the channel's ENTIRE service menu
        // to the event (see selectTimeActions.js empty-selection fallback).
        // Count DISTINCT ids: the payload serializes one entry per
        // channel-location pivot row, so a 1-service/2-location channel has 2
        // entries and a naive length check would wrongly show a 1-item menu.
        if ((0, $cEKee.isAutoSelectSoonestProviderEnabled)()) {
            const distinctProcedureIds = new Set(((0, $cEKee.form)?.appointment_channel?.procedures || []).filter((p)=>p?.online_booking).map((p)=>p?.id));
            if ((0, $cEKee.selectedProcedures)?.length || distinctProcedureIds.size <= 1) {
                (0, $cEKee.setStaffId)(-1);
                (0, $a5XF8.handleSelectProvider)(null, -1);
                (0, $a5XF8.handleProviderContinueBtn)();
                return;
            }
        }
        const hostType = (0, $cEKee.form)?.appointment_channel?.host || 'one_on_one';
        const staffsOfAppointmentChannel = (0, $cEKee.form)?.appointment_channel?.staffs?.filter((staff)=>staff?.online_booking);
        const staffCount = staffsOfAppointmentChannel?.length || 0;
        const canChooseStaff = hostType === 'one_on_one' && staffCount > 1 || hostType !== 'one_on_one' && (0, $cEKee.form)?.appointment_channel?.visitor_can_choose_the_staff;
        const isProviderFirst = (0, $cEKee.form)?.appointment_channel?.is_select_provider_first;
        if ((0, $cEKee.appointmentChannelId) && (canChooseStaff || (0, $cEKee.form)?.appointment_channel?.procedures?.length > 1)) {
            const { procedures: procedures } = (0, $cEKee.form).appointment_channel;
            const staffsOfAppointmentChannel = (0, $cEKee.form)?.appointment_channel?.staffs?.filter((staff)=>staff?.online_booking);
            const ids = staffsOfAppointmentChannel?.map((i)=>i.id);
            let listProvider = (0, $cEKee.providers).filter((provider)=>ids.includes(provider.id));
            listProvider = listProvider.filter((provider)=>provider.location_ids?.includes((0, $cEKee.selectedLocation)));
            if (!isProviderFirst && (0, $cEKee.staffProcedures)?.length) {
                const staffIds = (0, $cEKee.staffProcedures)?.map((sp)=>sp?.staff_id) ?? [];
                listProvider = listProvider.filter(({ id: id })=>staffIds.includes(id));
            }
            console.log('[DBG] big-branch listProvider=', JSON.stringify(listProvider?.map?.((p)=>p.id)), 'procs=', procedures?.length, 'selProcs=', (0, $cEKee.selectedProcedures)?.length);
            if (procedures?.length === 1 || (0, $cEKee.appointmentChannelId) && (0, $cEKee.selectedProcedures)?.length) {
                (0, $hprW2.loadProviderList)(listProvider);
                if (listProvider?.length === 1) {
                    (0, $cEKee.setStaffId)(listProvider[0]?.id);
                    (0, $a5XF8.handleSelectProvider)(null, listProvider[0]?.id);
                    (0, $a5XF8.handleProviderContinueBtn)();
                } else {
                    document.querySelector('.providers__container')?.classList?.add('provider-in-booking');
                    (0, $62LVp.renderContinueBtn)();
                    (0, $a5XF8.providerListeners)();
                    if (0, $cEKee.appointmentChannelId) document.querySelector('.providers__container .providerContinue__btn ')?.classList?.add('hide');
                    document.querySelector('.providers__container .providerBack__btn')?.classList?.add('hiden');
                    (0, $er9E0.navigate)((0, $cIxq8.SCREEN).PROVIDERS);
                }
            } else {
                if (listProvider?.length === 0) {
                    if (0, $cEKee.isFlowForCalendar) {
                        (0, $hprW2.loadProviderList)(listProvider);
                        (0, $er9E0.navigate)((0, $cIxq8.SCREEN).PROVIDERS);
                        return;
                    }
                    const div = document.querySelector('.notfound__container .screen__content');
                    if (div) div.textContent = (0, $knjAn.t)('provider_no_location');
                    (0, $er9E0.navigate)((0, $cIxq8.SCREEN).NOTFOUND_APPOINTMENT);
                    return;
                }
                if ((0, $ig8jH.isPageHidden)('patient_page', (0, $cEKee.hiddenPages))) (0, $lmlIJ.patientContinueBtnHandler)();
                else {
                    (0, $lmlIJ.patientListeners)();
                    (0, $er9E0.navigate)((0, $cIxq8.SCREEN).PATIENTS);
                }
            }
            return;
        }
        let staffIdList = (0, $cEKee.staffProcedures)?.map((item)=>item?.staff?.id);
        let filteredProviders = (0, $cEKee.providers).filter((e)=>staffIdList?.indexOf(e.id) !== -1);
        const listProvider = filteredProviders.filter((provider)=>provider.location_ids?.includes((0, $cEKee.selectedLocation)));
        (0, $hprW2.loadProviderList)(listProvider);
        if (listProvider?.length === 1 || (0, $cEKee.staffId)) {
            (0, $a5XF8.handleSelectProvider)(null, +(0, $cEKee.staffId) || listProvider[0]?.id);
            (0, $a5XF8.handleProviderContinueBtn)();
        } else {
            document.querySelector('.providers__container')?.classList?.add('provider-in-booking');
            (0, $62LVp.renderContinueBtn)();
            (0, $a5XF8.providerListeners)();
            (0, $er9E0.navigate)((0, $cIxq8.SCREEN).PROVIDERS);
        }
    } else {
        if ((0, $cEKee.providers).length > 0) {
            const selectedProviders = (0, $cEKee.providers).filter((i)=>i?.location_ids?.includes((0, $cEKee.selectedLocation)));
            const providerContainer = document.querySelector('.providers__container .list');
            if (providerContainer) providerContainer.innerHTML = '';
            (0, $hprW2.loadProviderList)(selectedProviders);
            (0, $cEKee.setIsInstantQuote)(true);
            (0, $62LVp.renderContinueBtn)();
            (0, $a5XF8.providerListeners)();
            (0, $er9E0.navigate)((0, $cIxq8.SCREEN).PROVIDERS);
        } else if (0, $cEKee.isInInstantQuote) {
            (0, $8QS3m.loadCategories)((0, $a5XF8.filterProcedures)((0, $cEKee.procedures)));
            (0, $d0tLC.loadProcedures)((0, $a5XF8.filterProcedures)((0, $cEKee.procedures)));
            (0, $er9E0.navigate)((0, $cIxq8.SCREEN).SEE_ALL_SERVICES);
        }
    }
};

});
parcelRegister("bK4nS", function(module, exports) {

$parcel$export(module.exports, "deliveryModeListeners", () => $88c7642d1e9f3e1b$export$c9f635dca1df7257);

var $knjAn = parcelRequire("knjAn");

var $cEKee = parcelRequire("cEKee");

var $fWpof = parcelRequire("fWpof");

var $hGWxM = parcelRequire("hGWxM");
const $88c7642d1e9f3e1b$export$c9f635dca1df7257 = ()=>{
    const buckets = $88c7642d1e9f3e1b$var$bucketedProcedures();
    const availableModes = Object.keys(buckets).filter((mode)=>buckets[mode].length > 0);
    if (availableModes.length === 1) {
        (0, $cEKee.setSelectedDeliveryMode)(availableModes[0]);
        return false;
    }
    // Localize static labels.
    const title = document.querySelector('.deliveryMode__container .deliveryMode--title');
    if (title) title.textContent = (0, $knjAn.t)('select_visit_type');
    document.querySelectorAll('.deliveryMode__container .deliveryMode__option').forEach((option)=>{
        const mode = option.getAttribute('data-delivery-mode');
        // Misconfigured channels (every bucket empty) keep the legacy
        // two-option step rather than rendering nothing.
        const hide = availableModes.length > 0 ? !availableModes.includes(mode) : mode === 'phone';
        option.classList.toggle('hidden', hide);
        const titleEl = option.querySelector('.deliveryMode__option-title');
        const descEl = option.querySelector('.deliveryMode__option-desc');
        if (titleEl) titleEl.textContent = $88c7642d1e9f3e1b$var$optionTitle(mode);
        if (descEl) descEl.textContent = $88c7642d1e9f3e1b$var$optionDesc(mode, buckets[mode] ?? []);
        option.onclick = ()=>$88c7642d1e9f3e1b$var$selectDeliveryMode(mode);
    });
    // Re-highlight a prior selection, otherwise start clean.
    if (0, $cEKee.selectedDeliveryMode) $88c7642d1e9f3e1b$var$selectDeliveryMode((0, $cEKee.selectedDeliveryMode));
    else $88c7642d1e9f3e1b$var$removeDeliveryModeSelection();
    document.querySelector('.deliveryModeContinue__btn').onclick = $88c7642d1e9f3e1b$var$deliveryModeContinueHandler;
    return true;
};
function $88c7642d1e9f3e1b$var$bucketedProcedures() {
    const list = (0, $cEKee.scopeProceduresToSelectedLocation)(((0, $cEKee.form)?.appointment_channel?.procedures ?? []).filter((p)=>p?.online_booking)).filter((p)=>p?.online_booking_option !== 'inquiry' || !!p?.service_delivery_mode);
    const buckets = {
        in_person: [],
        virtual: [],
        phone: []
    };
    list.forEach((p)=>buckets[(0, $fWpof.procedureDeliveryBucket)(p)].push(p));
    return buckets;
}
function $88c7642d1e9f3e1b$var$optionTitle(mode) {
    if (mode === 'virtual') return (0, $knjAn.t)('virtual');
    if (mode === 'phone') return (0, $knjAn.t)('phone_call');
    return (0, $knjAn.t)('in_person');
}
function $88c7642d1e9f3e1b$var$optionDesc(mode, procedures) {
    if (mode === 'virtual') return (0, $knjAn.t)('virtual_visit_desc');
    if (mode === 'phone') {
        // "Meet for a 20-minute phone call" when every bookable phone service
        // shares one duration; generic copy otherwise. Inquiry tiles carry no
        // meaningful duration — they never reach a calendar.
        const durations = [
            ...new Set(procedures.filter((p)=>p?.online_booking_option !== 'inquiry').map((p)=>parseInt(p?.duration, 10) || 0).filter(Boolean))
        ];
        return durations.length === 1 ? (0, $knjAn.t)('phone_visit_desc_duration').replace('{duration}', durations[0]) : (0, $knjAn.t)('phone_visit_desc');
    }
    return (0, $knjAn.t)('in_person_visit_desc');
}
function $88c7642d1e9f3e1b$var$deliveryModeContinueHandler() {
    if (!(0, $cEKee.selectedDeliveryMode)) return;
    (0, $hGWxM.handleLocationPage)();
}
function $88c7642d1e9f3e1b$var$selectDeliveryMode(mode) {
    $88c7642d1e9f3e1b$var$removeDeliveryModeSelection();
    (0, $cEKee.setSelectedDeliveryMode)(mode);
    document.querySelector(`.deliveryMode__option[data-delivery-mode="${CSS.escape(mode)}"]`)?.classList.add('is-selected');
    document.querySelector('.deliveryModeContinue__btn').classList.remove('disabled');
}
function $88c7642d1e9f3e1b$var$removeDeliveryModeSelection() {
    document.querySelectorAll('.deliveryMode__container .deliveryMode__option').forEach((i)=>i.classList.remove('is-selected'));
    document.querySelector('.deliveryModeContinue__btn').classList.add('disabled');
}

});


parcelRegister("63Hky", function(module, exports) {

$parcel$export(module.exports, "renderUILocationCall", () => $4694a270a1adb385$export$6c7a0e24c0562c3b);

var $cEKee = parcelRequire("cEKee");

var $fJdVD = parcelRequire("fJdVD");
const $4694a270a1adb385$export$6c7a0e24c0562c3b = ()=>{
    const locationElement = document.querySelector('.callus_container .callus');
    if (!locationElement) return "";
    (0, $fJdVD.loadLocationList)(locationElement, true);
    document.querySelector(".callus_container")?.style.setProperty('--background-color', `${(0, $cEKee.primaryColor)}1A`);
};

});


parcelRegister("7rUQ4", function(module, exports) {
function $56c7250b65c3574e$export$1f73f60bdb811cb1(name, value) {
    localStorage.setItem(name, JSON.stringify(value));
}
function $56c7250b65c3574e$export$d3720feff416e85b(name) {
    return JSON.parse(localStorage.getItem(name));
}
function $56c7250b65c3574e$export$720fb0373088e6ec(items) {
    for (const i of items)localStorage.removeItem(i);
}

});



parcelRegister("8ENHq", function(module, exports) {

$parcel$export(module.exports, "assistantListeners", () => $64d89c6900183fa2$export$f6aa5d92fba36497);
$parcel$export(module.exports, "toggleWidgetAssistant", () => $64d89c6900183fa2$export$61e818365ba50527);
$parcel$export(module.exports, "bindEvent", () => $64d89c6900183fa2$export$9e3f871ead679777);
$parcel$export(module.exports, "closeAssistant", () => $64d89c6900183fa2$export$f7163eec18732dd3);

var $cIxq8 = parcelRequire("cIxq8");

var $cEKee = parcelRequire("cEKee");

var $er9E0 = parcelRequire("er9E0");

var $a8vmc = parcelRequire("a8vmc");
function $64d89c6900183fa2$export$f6aa5d92fba36497() {
    /* Toggle assistant widget */ document.querySelector('.assistant__container .assistant__button').onclick = $64d89c6900183fa2$export$61e818365ba50527;
    /*Close Tooltip*/ document.querySelector('.assistant__container .tooltip__text').onclick = $64d89c6900183fa2$export$6108d95d641a81fb;
    /* Close assistant widget when click x icon */ document.querySelector('.assistant__container .close-tooltip-btn').onclick = $64d89c6900183fa2$export$a30893eaf6ea4b5;
    /* on click sub-button to close assistant when on mobile */ document.querySelectorAll('.assistant__container .subCLose__btn').forEach((i)=>i.onclick = $64d89c6900183fa2$export$61e818365ba50527);
    /* Receive message finish load iframe */ $64d89c6900183fa2$export$9e3f871ead679777(window, 'message', function(e) {
        if (e.data === (0, $cIxq8.EVENT_MESSAGE).FINISH_LOADING_IFRAME) {
            const assistantIframeTemp = document.querySelector('.assistant__container .assistant__content--iframe');
            const selector = document.querySelector('script[data-id="assistant"]');
            const book_appointment = selector.getAttribute('book_appointment');
            if ((0, $cEKee.isModalPopup) && book_appointment) {
                assistantIframeTemp.contentWindow.postMessage('navigate' + (0, $cIxq8.EVENT_MESSAGE).BOOK_APPOINTMENT, '*');
                setTimeout(function() {
                    $64d89c6900183fa2$var$hideLoadingWrapper();
                }, 300);
            } else $64d89c6900183fa2$var$hideLoadingWrapper();
            if ((0, $er9E0.params)((0, $cIxq8.IGNORE_IFRAME))) document.querySelector('.widgetContent__container .subCLose__btn').style.visibility = 'hidden';
        }
        if (e.data === (0, $cIxq8.EVENT_MESSAGE).ENABLE_SCROLL) (0, $a8vmc.default).off();
        if (e.data === (0, $cIxq8.EVENT_MESSAGE).DISABLE_SCROLL && document.querySelector('.assistant__container').classList.contains('show')) (0, $a8vmc.default).on();
    });
    /* Check query params to open assistant automatically */ if ((0, $er9E0.params)('is_open_assistant')) $64d89c6900183fa2$export$61e818365ba50527();
    /* Check query params to open assistant automatically */ if ((0, $er9E0.params)('open')) $64d89c6900183fa2$export$61e818365ba50527();
    /** Close modal when press escape */ window?.addEventListener('keydown', $64d89c6900183fa2$var$closeModalPressEscape);
}
function $64d89c6900183fa2$export$61e818365ba50527() {
    const assistantIframe = document.querySelector('.assistant__container .assistant__content--iframe');
    const isShow = document.querySelector('.assistant__container').classList.contains('show');
    if (!isShow) {
        const isOpen = (0, $er9E0.params)('staff_id') && (0, $er9E0.params)('procedure_id') || (0, $er9E0.params)((0, $cIxq8.APPOINTMENT_CHANNEL_ID));
        if (isOpen) {
            if (assistantIframe) assistantIframe.contentWindow.postMessage((0, $cIxq8.EVENT_MESSAGE).OPEN_BOOK_APPOINTMENT_FLOW, '*');
        }
        $64d89c6900183fa2$var$openAssistant();
    } else $64d89c6900183fa2$export$f7163eec18732dd3();
    if (assistantIframe) {
        assistantIframe.contentWindow.postMessage((0, $cIxq8.EVENT_MESSAGE).TOGGLE_WIDGET, '*');
        if (!isShow) assistantIframe.contentWindow.postMessage((0, $cIxq8.EVENT_MESSAGE).WIDGET_OPEN, '*');
        if (0, $cIxq8.MOBILE_SCREEN) assistantIframe.contentWindow.postMessage((0, $cIxq8.EVENT_MESSAGE).ENABLE_SCROLL, '*');
    }
}
function $64d89c6900183fa2$var$openAssistant() {
    if (0, $cIxq8.MOBILE_SCREEN) (0, $a8vmc.default).on();
    const selector = document.querySelector('script[data-id="assistant"]');
    const book_appointment = selector.getAttribute('book_appointment');
    if ((0, $cEKee.isModalPopup) && book_appointment) {
        document.querySelector('.assistant__container').classList.add('modal');
        let overlay = document?.querySelector('.overlay__popup');
        if (overlay) overlay.classList.remove('hide');
    }
    document.querySelector('.assistant__container').classList.add('show');
}
function $64d89c6900183fa2$export$f7163eec18732dd3() {
    if (0, $cIxq8.MOBILE_SCREEN) (0, $a8vmc.default).off();
    document.querySelector('.assistant__container').classList.remove('show');
    document.querySelector('.assistant__container .assistant__content--iframe').contentWindow.postMessage((0, $cIxq8.EVENT_MESSAGE).REFRESH, '*');
    window.parent.postMessage((0, $cIxq8.EVENT_MESSAGE).ENABLE_SCROLL, '*');
    const selector = document.querySelector('script[data-id="assistant"]');
    const book_appointment = selector.getAttribute('book_appointment');
    if ((0, $cEKee.isModalPopup) && book_appointment) {
        document.querySelector('.assistant__container').classList.add('modal');
        let overlay = document?.querySelector('.overlay__popup');
        if (overlay) overlay.classList.add('hide');
    }
}
function $64d89c6900183fa2$var$hideLoadingWrapper() {
    document.querySelector('.assistant__container .loading__wrapper').classList.add('hidden');
}
function $64d89c6900183fa2$export$6108d95d641a81fb(e) {
    e.stopPropagation();
    document.querySelector('.tooltip__text').classList.add('hidden');
    $64d89c6900183fa2$export$61e818365ba50527();
}
function $64d89c6900183fa2$export$a30893eaf6ea4b5(e) {
    e.stopPropagation();
    document.querySelector('.tooltip__text').classList.add('hidden');
}
function $64d89c6900183fa2$export$bc240254b7dc456() {
    document.querySelector('.close-tooltip-btn').classList.add('show');
}
function $64d89c6900183fa2$export$9e3f871ead679777(element, eventName, eventHandler) {
    if (element.addEventListener) element.addEventListener(eventName, eventHandler, false);
    else if (element.attachEvent) element.attachEvent('on' + eventName, eventHandler);
}
function $64d89c6900183fa2$var$closeModalPressEscape(e) {
    if (e.key === 'Escape' && (0, $cEKee.isModalPopup)) $64d89c6900183fa2$export$f7163eec18732dd3();
}

});
parcelRegister("a8vmc", function(module, exports) {

$parcel$export(module.exports, "default", () => $7612f9953fac2669$export$2e2bcd8739ae039);
var $7612f9953fac2669$var$__assign = undefined && undefined.__assign || function() {
    $7612f9953fac2669$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $7612f9953fac2669$var$__assign.apply(this, arguments);
};
var $7612f9953fac2669$var$canUseDOM = function() {
    return typeof window !== 'undefined' && !!window.document && !!window.document.createElement;
};
var $7612f9953fac2669$var$DisableScroll = /** @class */ function() {
    function DisableScroll() {
        var _this = this;
        this.handleWheel = function(e) {
            e.preventDefault();
        };
        this.handleScroll = function() {
            window.scrollTo.apply(window, _this.lockToScrollPos);
        };
        this.handleKeydown = function(e) {
            var keys = _this.options.keyboardKeys;
            /* istanbul ignore else */ if ([
                'INPUT',
                'TEXTAREA'
            ].includes(e.target.tagName)) keys = keys.filter(function(key) {
                return !_this.options.authorizedInInputs.includes(key);
            });
            /* istanbul ignore else */ if (keys.includes(e.keyCode)) e.preventDefault();
        };
        this.element = null;
        this.lockToScrollPos = [
            0,
            0
        ];
        this.options = {
            authorizedInInputs: [
                32,
                37,
                38,
                39,
                40
            ],
            disableKeys: true,
            disableScroll: true,
            disableWheel: true,
            keyboardKeys: [
                32,
                33,
                34,
                35,
                36,
                37,
                38,
                39,
                40
            ]
        };
        /* istanbul ignore else */ if ($7612f9953fac2669$var$canUseDOM()) this.element = document.scrollingElement;
    }
    /**
     * Disable Page Scroll
     */ DisableScroll.prototype.on = function(element, options) {
        var _a, _b, _c, _d;
        if (!$7612f9953fac2669$var$canUseDOM()) return;
        this.element = element || this.element;
        this.options = $7612f9953fac2669$var$__assign($7612f9953fac2669$var$__assign({}, this.options), options);
        var _e = this.options, disableKeys = _e.disableKeys, disableScroll = _e.disableScroll, disableWheel = _e.disableWheel;
        /* istanbul ignore else */ if (disableWheel) {
            document.addEventListener('wheel', this.handleWheel, {
                passive: false
            });
            document.addEventListener('touchmove', this.handleWheel, {
                passive: false
            });
        }
        /* istanbul ignore else */ if (disableScroll) {
            this.lockToScrollPos = [
                (_b = (_a = this.element) === null || _a === void 0 ? void 0 : _a.scrollLeft) !== null && _b !== void 0 ? _b : 0,
                (_d = (_c = this.element) === null || _c === void 0 ? void 0 : _c.scrollTop) !== null && _d !== void 0 ? _d : 0
            ];
            document.addEventListener('scroll', this.handleScroll, {
                passive: false
            });
        }
        /* istanbul ignore else */ if (disableKeys) document.addEventListener('keydown', this.handleKeydown, {
            passive: false
        });
    };
    /**
     * Re-enable page scrolls
     */ DisableScroll.prototype.off = function() {
        if (!$7612f9953fac2669$var$canUseDOM()) return;
        document.removeEventListener('wheel', this.handleWheel);
        document.removeEventListener('touchmove', this.handleWheel);
        document.removeEventListener('scroll', this.handleScroll);
        document.removeEventListener('keydown', this.handleKeydown);
    };
    return DisableScroll;
}();
var $7612f9953fac2669$export$2e2bcd8739ae039 = new $7612f9953fac2669$var$DisableScroll();

});



//# sourceMappingURL=assistant.bc7e6f76.js.map
